// Structured data for set summary pages.
// Auto-generated; card listings extracted from the original infographic HTML.

export const SET_SUMMARIES = {

  '2023-chrome': {
    setId: '2023-chrome',
    year: '2023',
    brand: 'TOPPS',
    title: 'STAR WARS CHROME',
    releaseDate: '5 / 24 / 2023',
    lede: 'Where the flagship line began — the first Star Wars Chrome pairs 100 characters with the actors who played them on chromium stock. A 14-deep rainbow from Refractor to Superfractor (with retail-only Black and Purple Waves), five insert lines from Journey of Grogu to manga-style art, and a 77-card autograph program across four tiers — every Chrome Autograph a numbered refractor, Blue /150 to Superfractor — with an autograph in every hobby box.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Characters + their actors', color: 'gold' },
      { num: '5', label: 'Insert Sets', sub: '10 to 20 cards each', color: 'cyan' },
      { num: '77', label: 'Auto Cards', sub: '4 signature tiers', color: 'green' },
      { num: '14', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '11', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '24', l: 'Packs per box' },
      { v: '4', l: 'Cards per pack' },
      { v: '8', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
    ],
    pullRates: [
      { name: 'Journey of Grogu', odds: '1 : 3', tier: 'normal' },
      { name: 'Monikers', odds: '1 : 6', tier: 'normal' },
      { name: 'Manga Madness', odds: '1 : 8', tier: 'normal' },
      { name: 'ROTJ 40th Anniversary', odds: '1 : 24', tier: 'normal' },
      { name: 'Chrome Autographs', odds: '1 : 32', tier: 'rare' },
      { name: 'First Appearances SP', odds: '1 : 255', tier: 'rare' },
      { name: 'Sketch Cards', odds: '1 : 1,677', tier: 'mythic' },
      { name: 'Dual Autographs', odds: '1 : 17,881', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'BLACK WAVE', pr: '∞', gradient: 'linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)' },
      { name: 'PURPLE WAVE', pr: '∞', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)' },
      { name: 'AQUA', pr: '/199', gradient: 'linear-gradient(135deg, #40e8e0 0%, #00a0a0 60%, #80fff0 100%)', darkText: true },
      { name: 'BLUE', pr: '/150', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'PRINTING PLATE CYAN', pr: '1/1', gradient: 'linear-gradient(135deg, #00e5ff 0%, #0090a8 100%)', darkText: true },
      { name: 'PRINTING PLATE MAGENTA', pr: '1/1', gradient: 'linear-gradient(135deg, #ff40a0 0%, #c01070 100%)' },
      { name: 'PRINTING PLATE YELLOW', pr: '1/1', gradient: 'linear-gradient(135deg, #ffee58 0%, #d0b820 100%)', darkText: true },
      { name: 'PRINTING PLATE BLACK', pr: '1/1', gradient: 'linear-gradient(135deg, #404040 0%, #101010 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Characters + the actors who played them',
          parallels: 14,
          cards: [
            { num: '1', title: 'Cassian Andor', meta: 'Diego Luna' },
            { num: '2', title: 'Mon Mothma', meta: 'Genevieve O\'Reilly' },
            { num: '3', title: 'K-2SO', meta: 'Alan Tudyk' },
            { num: '4', title: 'Saw Gerrera', meta: 'Forest Whitaker' },
            { num: '5', title: 'Luthen Rael', meta: 'Stellan Skarsgård' },
            { num: '6', title: 'Obi-Wan Kenobi', meta: 'Ewan McGregor' },
            { num: '7', title: 'Reva', meta: 'Moses Ingram' },
            { num: '8', title: 'The Grand Inquisitor', meta: 'Rupert Friend' },
            { num: '9', title: 'Fifth Brother', meta: 'Sung Kang' },
            { num: '10', title: 'Fourth Sister', meta: 'Rya Kihlstedt' },
            { num: '11', title: 'Owen Lars', meta: 'Joel Edgerton' },
            { num: '12', title: 'Beru Lars', meta: 'Bonnie Piesse' },
            { num: '13', title: 'Haja Estree', meta: 'Kumail Nanjiani' },
            { num: '14', title: 'Tala Durith', meta: 'Indira Varma' },
            { num: '15', title: 'Darth Vader', meta: 'Hayden Christensen' },
            { num: '16', title: 'Bail Organa', meta: 'Jimmy Smits' },
            { num: '17', title: 'Princess Leia Organa', meta: 'Vivien Lyra Blair' },
            { num: '18', title: 'NED-B', meta: 'Dustin Ceithamer' },
            { num: '19', title: 'Jyn Erso', meta: 'Felicity Jones' },
            { num: '20', title: 'Galen Erso', meta: 'Mads Mikkelsen' },
            { num: '21', title: 'Han Solo', meta: 'Alden Ehrenreich' },
            { num: '22', title: 'Qi\'ra', meta: 'Emilia Clarke' },
            { num: '23', title: 'Chewbacca', meta: 'Joonas Suotamo' },
            { num: '24', title: 'Maul', meta: 'Sam Witwer' },
            { num: '25', title: 'Cal Kestis', meta: 'Cameron Monaghan' },
            { num: '26', title: 'BD-1', meta: 'Ben Burtt' },
            { num: '27', title: 'Second Sister', meta: 'Elizabeth Grullon' },
            { num: '28', title: 'Cere Junda', meta: 'Debra Wilson' },
            { num: '29', title: 'Greez Dritus', meta: 'Greez Dritus' },
            { num: '30', title: 'Kanan Jarrus', meta: 'Freddie Prinze, Jr.' },
            { num: '31', title: 'Hera Syndulla', meta: 'Vanessa Marshall' },
            { num: '32', title: 'Ezra Bridger', meta: 'Taylor Gray' },
            { num: '33', title: 'Zeb Orrelios', meta: 'Steve Blum' },
            { num: '34', title: 'Sabine Wren', meta: 'Tiya Sircar' },
            { num: '35', title: 'Ketsu Onyo', meta: 'Gina Torres' },
            { num: '36', title: 'Kazuda Xiono', meta: 'Christopher Sean' },
            { num: '37', title: 'Neeku Vozo', meta: 'Josh Brener' },
            { num: '38', title: 'Tam Ryvora', meta: 'Suzie McGrath' },
            { num: '39', title: 'Jarek Yeager', meta: 'Scott Lawrence' },
            { num: '40', title: 'Synara San', meta: 'Nazneen Contractor' },
            { num: '41', title: 'Torra Doza', meta: 'Myrna Velasco' },
            { num: '42', title: 'Bucket', meta: 'Justin Ridge' },
            { num: '43', title: 'Mace Windu', meta: 'Samuel L. Jackson' },
            { num: '44', title: 'Count Dooku', meta: 'Christopher Lee' },
            { num: '45', title: 'Jabba The Hutt', meta: 'David Barclay' },
            { num: '46', title: 'Salacious B. Crumb', meta: 'Mark Dodson' },
            { num: '47', title: 'Admiral Ackbar', meta: 'Tim Rose' },
            { num: '48', title: 'Anakin Skywalker', meta: 'Hayden Christensen' },
            { num: '49', title: 'Padmé Amidala', meta: 'Natalie Portman' },
            { num: '50', title: 'Quinlan Vos', meta: 'Al Rodrigo' },
            { num: '51', title: 'Yoda', meta: 'Deep Roy' },
            { num: '52', title: 'Han Solo', meta: 'Harrison Ford' },
            { num: '53', title: 'General Hux', meta: 'Domhnall Gleeson' },
            { num: '54', title: 'BB-8', meta: 'Brian Herring' },
            { num: '55', title: 'Maz Kanata', meta: 'Lupita Nyong\'o' },
            { num: '56', title: 'General Leia Organa', meta: 'Carrie Fisher' },
            { num: '57', title: 'Supreme Leader Snoke', meta: 'Andy Serkis' },
            { num: '58', title: 'DJ', meta: 'Benicio del Toro' },
            { num: '59', title: 'Captain Phasma', meta: 'Gwendoline Christie' },
            { num: '60', title: 'Qui-Gon Jinn', meta: 'Liam Neeson' },
            { num: '61', title: 'Jar Jar Binks', meta: 'Ahmed Best' },
            { num: '62', title: 'Sebulba', meta: 'Lewis Macleod' },
            { num: '63', title: 'Shmi Skywalker', meta: 'Pernilla August' },
            { num: '64', title: 'Boss Nass', meta: 'Brian Blessed' },
            { num: '65', title: 'R2-D2', meta: 'Kenny Baker' },
            { num: '66', title: 'C-3PO', meta: 'Anthony Daniels' },
            { num: '67', title: 'Poe Dameron', meta: 'Oscar Isaac' },
            { num: '68', title: 'Finn', meta: 'John Boyega' },
            { num: '69', title: 'Rey', meta: 'Daisy Ridley' },
            { num: '70', title: 'Dark Rey', meta: 'Daisy Ridley' },
            { num: '71', title: 'Kylo Ren', meta: 'Adam Driver' },
            { num: '72', title: 'Emperor Palpatine', meta: 'Ian McDiarmid' },
            { num: '73', title: 'Zorii Bliss', meta: 'Keri Russell' },
            { num: '74', title: 'Babu Frik', meta: 'Shirley Henderson' },
            { num: '75', title: 'Klaud', meta: 'Nick Kellington' },
            { num: '76', title: 'Rose Tico', meta: 'Kelly Marie Tran' },
            { num: '77', title: 'Lando Calrissian', meta: 'Billy Dee Williams' },
            { num: '78', title: 'Jannah', meta: 'Naomi Ackie' },
            { num: '79', title: 'D-O', meta: 'Lynn Robertson Bruce' },
            { num: '80', title: 'Nien Nunb', meta: 'Mike Quinn' },
            { num: '81', title: 'Hunter', meta: 'Dee Bradley Baker' },
            { num: '82', title: 'Wrecker', meta: 'Dee Bradley Baker' },
            { num: '83', title: 'Tech', meta: 'Dee Bradley Baker' },
            { num: '84', title: 'Omega', meta: 'Michelle Ang' },
            { num: '85', title: 'Crosshair', meta: 'Dee Bradley Baker' },
            { num: '86', title: 'Echo', meta: 'Dee Bradley Baker' },
            { num: '87', title: 'Luke Skywalker', meta: 'Mark Hamill' },
            { num: '88', title: 'Krrsantan', meta: 'Carey Jones' },
            { num: '89', title: 'Boba Fett', meta: 'Temuera Morrison' },
            { num: '90', title: 'Fennec Shand', meta: 'Ming-Na Wen' },
            { num: '91', title: 'Cad Bane', meta: 'Dorian Kingi' },
            { num: '92', title: 'Cobb Vanth', meta: 'Timothy Olyphant' },
            { num: '93', title: 'Taanti', meta: 'W. Earl Brown' },
            { num: '94', title: 'Tusken Chief', meta: 'Xavier Jimenez' },
            { num: '95', title: 'Tusken Warrior', meta: 'Joanna Bennet' },
            { num: '96', title: 'Ahsoka Tano', meta: 'Rosario Dawson' },
            { num: '97', title: 'The Mandalorian', meta: 'Pedro Pascal' },
            { num: '98', title: 'Grogu', meta: 'David Acord' },
            { num: '99', title: 'Greef Karga', meta: 'Carl Weathers' },
            { num: '100', title: 'Migs Mayfeld', meta: 'Bill Burr' },
          ]
        }
      ],
      insert: [
        {
          count: 20,
          name: 'FIRST APPEARANCES SHORT PRINTS',
          meta: 'First on-screen appearances',
          odds: '1:255 packs',
          parallels: 5,
          cards: [
            { num: 'FA-1', title: 'Darth Vader' },
            { num: 'FA-2', title: 'Obi-Wan Kenobi' },
            { num: 'FA-3', title: 'Han Solo' },
            { num: 'FA-4', title: 'Princess Leia' },
            { num: 'FA-5', title: 'Luke Skywalker' },
            { num: 'FA-6', title: 'Darth Maul' },
            { num: 'FA-7', title: 'Palpatine' },
            { num: 'FA-8', title: 'The Mandalorian' },
            { num: 'FA-9', title: 'Grogu' },
            { num: 'FA-10', title: 'Ahsoka Tano' },
            { num: 'FA-11', title: 'Queen Amidala' },
            { num: 'FA-12', title: 'Rey' },
            { num: 'FA-13', title: 'Finn' },
            { num: 'FA-14', title: 'Poe Dameron' },
            { num: 'FA-15', title: 'Kylo Ren' },
            { num: 'FA-16', title: 'Ezra Bridger' },
            { num: 'FA-17', title: 'Hera Syndulla' },
            { num: 'FA-18', title: 'Kanan Jarrus' },
            { num: 'FA-19', title: 'Jyn Erso' },
            { num: 'FA-20', title: 'Cassian Andor' },
          ]
        },
        {
          count: 20,
          name: 'MONIKERS',
          meta: 'Aliases & designations',
          odds: '1:6 packs',
          parallels: 5,
          cards: [
            { num: 'M-1', title: 'Darth Vader' },
            { num: 'M-2', title: 'Luke Skywalker' },
            { num: 'M-3', title: 'Rey' },
            { num: 'M-4', title: 'Chewbacca' },
            { num: 'M-5', title: 'Han Solo' },
            { num: 'M-6', title: 'The Mandalorian' },
            { num: 'M-7', title: 'Grogu' },
            { num: 'M-8', title: 'Obi-Wan Kenobi' },
            { num: 'M-9', title: 'Obi-Wan Kenobi' },
            { num: 'M-10', title: 'R2-D2' },
            { num: 'M-11', title: 'C-3PO' },
            { num: 'M-12', title: 'Kylo Ren' },
            { num: 'M-13', title: 'Anakin Skywalker' },
            { num: 'M-14', title: 'Ahsoka Tano' },
            { num: 'M-15', title: 'Sheev Palpatine' },
            { num: 'M-16', title: 'Leia Organa' },
            { num: 'M-17', title: 'FN-2187' },
            { num: 'M-18', title: 'Jabba The Hutt' },
            { num: 'M-19', title: 'Stormtrooper' },
            { num: 'M-20', title: 'CT-7567' },
          ]
        },
        {
          count: 20,
          name: 'JOURNEY OF GROGU',
          meta: 'Grogu\'s story so far',
          odds: '1:3 packs',
          parallels: 5,
          cards: [
            { num: 'JG-1', title: 'Jedi Temple Siege' },
            { num: 'JG-2', title: 'Meeting the Mandalorian' },
            { num: 'JG-3', title: 'Slaying the Mudhorn' },
            { num: 'JG-4', title: 'Brought Before the Client' },
            { num: 'JG-5', title: 'Kidnapped by Toro Calican' },
            { num: 'JG-6', title: 'Discovered by Mercenaries!' },
            { num: 'JG-7', title: 'IG-11\'s New Programming' },
            { num: 'JG-8', title: 'A Clan of Two' },
            { num: 'JG-9', title: 'The Mysterious Mandalorian of Tatooine' },
            { num: 'JG-10', title: 'The Mandalorians of Trask' },
            { num: 'JG-11', title: 'Grogu in Class' },
            { num: 'JG-12', title: 'Ahsoka Tano Sets Grogu\'s Path' },
            { num: 'JG-13', title: 'The Seeing Stone' },
            { num: 'JG-14', title: 'The Dark Troopers Arrive!' },
            { num: 'JG-15', title: 'Encounter with Moff Gideon' },
            { num: 'JG-16', title: 'The Mandalorian & His Allies to the Rescue' },
            { num: 'JG-17', title: 'The future site of Luke Skywalker\'s Jedi Temple' },
            { num: 'JG-18', title: 'Grogu\'s Choice' },
            { num: 'JG-19', title: 'Facing the Rancor' },
            { num: 'JG-20', title: 'The Mandalorian\'s New Ship' },
          ]
        },
        {
          count: 15,
          name: 'MANGA MADNESS',
          meta: 'Manga-style original trilogy art',
          odds: '1:8 packs',
          parallels: 5,
          cards: [
            { num: 'MM-1', title: 'Leia / Luke / Han / AT-AT' },
            { num: 'MM-2', title: 'R2-D2 / C-3PO' },
            { num: 'MM-3', title: 'Darth Vader / Obi-Wan' },
            { num: 'MM-4', title: 'Darth Vader / Luke' },
            { num: 'MM-5', title: 'Darth Vader / Luke / Han / Leia' },
            { num: 'MM-6', title: 'Bounty Hunters' },
            { num: 'MM-7', title: 'Han / Chewbacca' },
            { num: 'MM-8', title: 'Cantina' },
            { num: 'MM-9', title: 'Death Star / Han / Luke / Boba / C-3PO / Jabba' },
            { num: 'MM-10', title: 'Yoda / Luke / Darth Vader' },
            { num: 'MM-11', title: 'Han in Carbonite' },
            { num: 'MM-12', title: 'TIE Fighter / Luke / Darth Vader' },
            { num: 'MM-13', title: 'Emperor / Millennium Falcon' },
            { num: 'MM-14', title: 'Princess Leia' },
            { num: 'MM-15', title: 'Luke Skywalker' },
          ]
        },
        {
          count: 10,
          name: 'RETURN OF THE JEDI 40TH ANNIVERSARY',
          meta: 'Anniversary tribute',
          odds: '1:24 packs',
          parallels: 5,
          cards: [
            { num: 'ROJ40-1', title: 'R2-D2' },
            { num: 'ROJ40-2', title: 'Boba Fett' },
            { num: 'ROJ40-3', title: 'C-3PO' },
            { num: 'ROJ40-4', title: 'Chewbacca' },
            { num: 'ROJ40-5', title: 'Han Solo' },
            { num: 'ROJ40-6', title: 'Yoda' },
            { num: 'ROJ40-7', title: 'Lando Calrissian' },
            { num: 'ROJ40-8', title: 'Princess Leia' },
            { num: 'ROJ40-9', title: 'Luke Skywalker' },
            { num: 'ROJ40-10', title: 'Darth Vader' },
          ]
        }
      ],
      auto: [
        {
          count: 55,
          name: 'CHROME AUTOGRAPHS',
          meta: 'Signed base design · every copy a numbered refractor',
          odds: '1:32 packs',
          parallels: 7,
          cards: [
            { num: 'CA-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'CA-ADK', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'CA-AE', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'CA-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'CA-BB', title: 'Brian Blessed', meta: 'Boss Nass' },
            { num: 'CA-BP', title: 'Bonnie Piesse', meta: 'Beru Lars' },
            { num: 'CA-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'CA-CF', title: 'Carrie Fisher', meta: 'General Leia Organa' },
            { num: 'CA-CS', title: 'Christopher Sean', meta: 'Kazuda Xiono' },
            { num: 'CA-CW', title: 'Carl Weathers', meta: 'Greef Karga' },
            { num: 'CA-DB', title: 'David Barclay', meta: 'Jabba The Hutt' },
            { num: 'CA-DC', title: 'Dustin Ceithamer', meta: 'NED-B' },
            { num: 'CA-DG', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'CA-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'CA-DR', title: 'Deep Roy', meta: 'Yoda' },
            { num: 'CA-DRD', title: 'Daisy Ridley', meta: 'Dark Rey' },
            { num: 'CA-DRR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'CA-DW', title: 'Debra Wilson', meta: 'Cere Junda' },
            { num: 'CA-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'CA-EG', title: 'Elizabeth Grullon', meta: 'Second Sister' },
            { num: 'CA-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'CA-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'CA-FP', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'CA-FW', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'CA-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'CA-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'CA-HCA', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'CA-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'CA-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'CA-IV', title: 'Indira Varma', meta: 'Tala Durith' },
            { num: 'CA-KB', title: 'Kenny Baker', meta: 'R2-D2' },
            { num: 'CA-KT', title: 'Kelly Marie Tran', meta: 'Rose Tico' },
            { num: 'CA-LB', title: 'Lynn Robertson Bruce', meta: 'D-O' },
            { num: 'CA-LM', title: 'Lewis Macleod', meta: 'Sebulba' },
            { num: 'CA-LN', title: 'Lupita Nyong\'o', meta: 'Maz Kanata' },
            { num: 'CA-MD', title: 'Mark Dodson', meta: 'Salacious B. Crumb' },
            { num: 'CA-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'CA-MM', title: 'Mads Mikkelsen', meta: 'Galen Erso' },
            { num: 'CA-MQ', title: 'Mike Quinn', meta: 'Nien Nunb' },
            { num: 'CA-MV', title: 'Myrna Velasco', meta: 'Torra Doza' },
            { num: 'CA-MW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'CA-NA', title: 'Naomi Ackie', meta: 'Jannah' },
            { num: 'CA-NC', title: 'Nazneen Contractor', meta: 'Synara San' },
            { num: 'CA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'CA-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'CA-RK', title: 'Rya Kihlstedt', meta: 'Fourth Sister' },
            { num: 'CA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'CA-SL', title: 'Scott Lawrence', meta: 'Jarek Yeager' },
            { num: 'CA-SM', title: 'Suzie McGrath', meta: 'Tam Ryvora' },
            { num: 'CA-SW', title: 'Sam Witwer', meta: 'Maul' },
            { num: 'CA-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'CA-TR', title: 'Tim Rose', meta: 'Admiral Ackbar' },
            { num: 'CA-VB', title: 'Vivien Lyra Blair', meta: 'Princess Leia Organa' },
            { num: 'CA-VM', title: 'Vanessa Marshall', meta: 'Hera Syndulla' },
            { num: 'CA-XJ', title: 'Xavier Jimenez', meta: 'Tusken Chief' },
          ]
        },
        {
          count: 10,
          name: 'FIRST APPEARANCES AUTOGRAPHS',
          meta: 'Autograph parallels of the SP insert',
          odds: '1:12,089 packs',
          parallels: 2,
          cards: [
            { num: 'FAA-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'FAA-CF', title: 'Carrie Fisher', meta: 'Princess Leia Organa' },
            { num: 'FAA-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'FAA-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'FAA-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'FAA-FP', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'FAA-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'FAA-IM', title: 'Ian McDiarmid', meta: 'Palpatine' },
            { num: 'FAA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'FAA-VM', title: 'Vanessa Marshall', meta: 'Hera Syndulla' },
          ]
        },
        {
          count: 8,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer · /5 + Superfractor',
          odds: '1:17,881 packs',
          parallels: 2,
          cards: [
            { num: 'DA-CE', title: 'Emilia Clarke / Alden Ehrenreich', meta: 'Qi\'ra / Han Solo' },
            { num: 'DA-CT', title: 'Hermione Corfield / Kelly Marie Tran', meta: 'Tallie Lintra / Rose Tico' },
            { num: 'DA-LW2', title: 'Diego Luna / Forest Whitaker', meta: 'Cassian Andor / Saw Gerrera' },
            { num: 'DA-MC', title: 'Hayden Christensen / Ewan McGregor', meta: 'Darth Vader / Obi-Wan Kenobi' },
            { num: 'DA-PM', title: 'Natalie Portman / Ian McDiarmid', meta: 'Padmé Amidala / Chancellor Palpatine' },
            { num: 'DA-SR', title: 'Kiran Shah / Daisy Ridley', meta: 'Nambi Ghima / Rey' },
            { num: 'DA-TL', title: 'Billie Lourd / Kelly Marie Tran', meta: 'Kaydel Ko Connix / Rose Tico' },
            { num: 'DA-WC', title: 'Sam Witwer / Emilia Clarke', meta: 'Maul / Qi\'ra' },
          ]
        },
        {
          count: 4,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer · /5 + Superfractor',
          odds: '1:71,524 packs',
          parallels: 2,
          cards: [
            { num: 'TA-BMP', title: 'Matt Berry / David Pasquesi / Temuera Morrison', meta: '8D8 / Twi\'lek Majordomo / Boba Fett' },
            { num: 'TA-EKC', title: 'Emilia Clarke / Alden Ehrenreich / Erin Kellyman', meta: 'Qi\'ra / Han Solo / Enfys Nest' },
            { num: 'TA-JML', title: 'Diego Luna / Felicity Jones / Mads Mikkelsen', meta: 'Cassian Andor / Jyn Erso / Galen Erso' },
            { num: 'TA-SFD', title: 'Adam Driver / Andy Serkis / Harrison Ford', meta: 'Kylo Ren / Supreme Leader Snoke / Han Solo' },
          ]
        }
      ],
      sketch: [
        {
          count: 2,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches + die-cut manga sketches · roster not cataloged',
          oneOfOne: true,
          noParallels: true,
          odds: '1:1,677 packs',
          cards: [
            { num: 'SK-1', title: 'Sketch Card' },
            { num: 'SK-2', title: 'Manga Sketch Card' },
          ]
        }
      ],
    },
  },

  '2026-chrome': {
    setId: '2026-chrome',
    year: '2026',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS',
    releaseDate: '9 / 30 / 2026',
    lede: 'Chrome Star Wars for 2026: a 200-card base set with 44 debut characters, full-checklist Aurebesh and printing-plate book-card versions, a 23-parallel rainbow led by the new hobby-only Star Wars LogoFractor /77 and the icy Hoth FrozenFractor /5, seventeen insert lines headlined by Andor Season 2, Visions Season 3 and The Mandalorian and Grogu, a 245-card autograph program, and a 173-artist sketch program.',
    stats: [
      { num: '200', label: 'Base Cards', sub: '44 debut characters', color: 'gold' },
      { num: '17', label: 'Insert Sets', sub: '5 to 50 cards each', color: 'cyan' },
      { num: '245', label: 'Auto Cards', sub: 'Singles, duos & triples', color: 'green' },
      { num: '23', label: 'Base Parallels', sub: 'Rainbow → 1/1', color: 'purple' },
      { num: '27', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '10', l: 'Packs per box' },
      { v: '10', l: 'Cards per pack' },
      { v: '8', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
      { v: '4', l: 'Numbered parallels / box' },
    ],
    pullRates: [
      { name: 'Autograph', odds: '1 per hobby box', tier: 'normal' },
      { name: 'Numbered Parallels', odds: '4 per hobby box', tier: 'normal' },
      { name: 'Autographs (Breaker Delight)', odds: '2 per box', tier: 'rare' },
      { name: 'Sketch Cards', odds: '2 per hobby case', tier: 'mythic' },
      { name: 'Sketch Cards (Breaker Delight)', odds: '3 per case', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'RAINBOW', pr: '∞', gradient: 'linear-gradient(135deg, #e8eef8 0%, #b8c4d8 50%, #f4f8ff 100%)', darkText: true },
      { name: 'PRISM', pr: '∞', gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'BLACK & WHITE SHIMMER', pr: '∞', gradient: 'linear-gradient(135deg, #f8f8f8 0%, #b0b0b0 50%, #e0e0e0 100%)', darkText: true },
      { name: 'RAYWAVE', pr: '∞', gradient: 'linear-gradient(135deg, #6cef4d 0%, #2fae2f 60%, #a0ff80 100%)', darkText: true },
      { name: 'SKYWALKER BLUE GEOMETRIC', pr: '∞', gradient: 'repeating-linear-gradient(60deg, #2979ff 0 6px, #7ba2ff 6px 12px)' },
      { name: 'PURPLE GEOMETRIC', pr: '∞', gradient: 'repeating-linear-gradient(60deg, #7020c0 0 6px, #cb7dff 6px 12px)' },
      { name: 'KAMINO', pr: '/199', gradient: 'linear-gradient(135deg, #bb8ce4 0%, #7a4bb0 100%)' },
      { name: 'SKYWALKER BLUE', pr: '/150', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'KASHYYYK GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'STAR WARS LOGOFRACTOR', pr: '/77', gradient: 'linear-gradient(135deg, #ffe27a 0%, #f0c040 40%, #1a1a1a 100%)', darkText: true },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'ORANGE GEOMETRIC', pr: '/25', gradient: 'repeating-linear-gradient(60deg, #e06000 0 6px, #ffb072 6px 12px)' },
      { name: 'REBEL ORANGE WAVE', pr: '/25', gradient: 'linear-gradient(135deg, #ffb072 0%, #ff8800 50%, #ffcf9f 100%)', darkText: true },
      { name: 'GALAXY', pr: '/15', gradient: 'radial-gradient(circle at 30% 30%, #7fd8e8 0%, #3a2a8a 55%, #0a0a2a 100%)' },
      { name: 'BLACK', pr: '/10', gradient: 'linear-gradient(135deg, #2a2a2a 0%, #0a0a0a 100%)' },
      { name: 'BLACK GEOMETRIC', pr: '/10', gradient: 'repeating-linear-gradient(60deg, #0a0a0a 0 6px, #4a4a5a 6px 12px)' },
      { name: 'BLACK MUSTAFAR LAVA', pr: '/10', gradient: 'linear-gradient(135deg, #1a1a1a 0%, #4a1000 60%, #ff5020 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'RED GEOMETRIC', pr: '/5', gradient: 'repeating-linear-gradient(60deg, #b00000 0 6px, #ff806b 6px 12px)' },
      { name: 'DATHOMIR WAVE', pr: '/5', gradient: 'linear-gradient(135deg, #ff9090 0%, #ff3030 50%, #ffb0b0 100%)' },
      { name: 'HOTH FROZENFRACTOR', pr: '/5', gradient: 'linear-gradient(135deg, #e8f6ff 0%, #a8d8ff 45%, #4a8ac8 100%)', darkText: true },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 200,
          name: 'BASE SET',
          meta: '44 debuts across the saga',
          parallels: 23,
          cards: [
            { num: '1', title: 'Obi-Wan Kenobi' },
            { num: '2', title: 'Lezine' },
            { num: '3', title: 'Chopper' },
            { num: '4', title: 'Devon Izara' },
            { num: '5', title: 'Wizzich Mozzer' },
            { num: '6', title: 'General Maximilian Veers' },
            { num: '7', title: 'Rune Haako' },
            { num: '8', title: 'Tusken Raider Warrior' },
            { num: '9', title: 'Baylan Skoll' },
            { num: '10', title: 'Captain Kaido' },
            { num: '11', title: 'Freck' },
            { num: '12', title: 'Clone Captain Rex' },
            { num: '13', title: 'Sy Snootles' },
            { num: '14', title: 'Chewbacca' },
            { num: '15', title: 'Rabé' },
            { num: '16', title: 'Hamato Xiono' },
            { num: '17', title: 'Ahsoka Tano' },
            { num: '18', title: 'Davo Sculdun' },
            { num: '19', title: 'At Attin frogdog' },
            { num: '20', title: 'Icarus' },
            { num: '21', title: 'Ezra Bridger' },
            { num: '22', title: 'General Hux' },
            { num: '23', title: 'Ben Quadinaros' },
            { num: '24', title: 'Bo-Katan Kryze' },
            { num: '25', title: 'Looti Vario' },
            { num: '26', title: 'Sergeant Heert' },
            { num: '27', title: 'Mace Windu' },
            { num: '28', title: 'Nooma' },
            { num: '29', title: 'General Grievous' },
            { num: '30', title: 'Maz Kanata' },
            { num: '31', title: 'Rey' },
            { num: '32', title: 'Grogu' },
            { num: '33', title: 'Grand Admiral Thrawn' },
            { num: '34', title: 'Runai Sculdun' },
            { num: '35', title: 'Hutt Sister' },
            { num: '36', title: 'Ralakili' },
            { num: '37', title: 'Mace Windu' },
            { num: '38', title: 'Poe Dameron' },
            { num: '39', title: 'Moff Gideon' },
            { num: '40', title: 'Hera Syndulla' },
            { num: '41', title: 'Senator Oran' },
            { num: '42', title: 'The Armorer' },
            { num: '43', title: 'Qi\'ra' },
            { num: '44', title: 'Yoda' },
            { num: '45', title: 'BB-8' },
            { num: '46', title: 'D-O' },
            { num: '47', title: 'The Mandalorian' },
            { num: '48', title: 'Sabine Wren' },
            { num: '49', title: 'Supervisor Lonni Jung' },
            { num: '50', title: 'Vult Skerris' },
            { num: '51', title: 'Dryden Vos' },
            { num: '52', title: 'Anakin Skywalker' },
            { num: '53', title: 'Finn' },
            { num: '54', title: 'Colonel Aftab Ackbar' },
            { num: '55', title: 'Zeb Orrelios' },
            { num: '56', title: 'Shin Hati' },
            { num: '57', title: 'Kylo Ren' },
            { num: '58', title: 'Kanan Jarrus' },
            { num: '59', title: 'Sidon Ithano' },
            { num: '60', title: 'Klatooinian Crime Boss' },
            { num: '61', title: 'Eedy Karn' },
            { num: '62', title: 'Babu Frik' },
            { num: '63', title: 'Cobb Vanth' },
            { num: '64', title: 'Morgan Elsbeth' },
            { num: '65', title: 'Ghorman Spider' },
            { num: '66', title: 'Emperor Palpatine' },
            { num: '67', title: 'Sergeant Gharial' },
            { num: '68', title: 'Colonel Ward' },
            { num: '69', title: 'Bobbajo' },
            { num: '70', title: 'Haja Estree' },
            { num: '71', title: 'Syril Karn' },
            { num: '72', title: 'Commissioner Helgait' },
            { num: '73', title: 'Erskin Semaj' },
            { num: '74', title: 'Jyn Erso' },
            { num: '75', title: 'Hype Fazon' },
            { num: '76', title: 'Rook Kast' },
            { num: '77', title: 'Scorn' },
            { num: '78', title: 'Bix Caleen' },
            { num: '79', title: 'Kuiil' },
            { num: '80', title: 'Captain Enoch' },
            { num: '81', title: 'Stekan Sculdun' },
            { num: '82', title: 'Chirrut Îmwe' },
            { num: '83', title: 'Han Solo' },
            { num: '84', title: 'Imperial Inquisitor' },
            { num: '85', title: 'Lieutenant Connix' },
            { num: '86', title: 'Rose Tico' },
            { num: '87', title: 'The Duchess of Plazir' },
            { num: '88', title: 'Great Mother Lakesis' },
            { num: '89', title: 'Drash' },
            { num: '90', title: 'Jan Dodonna' },
            { num: '91', title: 'Luke Skywalker' },
            { num: '92', title: 'Niro' },
            { num: '93', title: 'Captain Phasma' },
            { num: '94', title: 'Jedi Master Sol' },
            { num: '95', title: 'Omera' },
            { num: '96', title: 'Vel Sartha' },
            { num: '97', title: 'Kleya Marki' },
            { num: '98', title: 'Huyang' },
            { num: '99', title: 'Moff Tarkin' },
            { num: '100', title: 'Bardi' },
            { num: '101', title: 'Asajj Ventress' },
            { num: '102', title: 'Supreme Leader Snoke' },
            { num: '103', title: 'The Stranger' },
            { num: '104', title: 'Captain Gilad Pellaeon' },
            { num: '105', title: 'Cassian Andor' },
            { num: '106', title: 'Pix the Tooka' },
            { num: '107', title: 'Jace Rucklin' },
            { num: '108', title: 'Ponda Baba' },
            { num: '109', title: 'Raxshir' },
            { num: '110', title: 'Noti' },
            { num: '111', title: 'Jedi Master Indara' },
            { num: '112', title: 'Hutt Brother' },
            { num: '113', title: 'Mon Mothma' },
            { num: '114', title: 'Leida Mothma' },
            { num: '115', title: 'Dedra Meero' },
            { num: '116', title: 'Owen Lars' },
            { num: '117', title: 'Yaddle' },
            { num: '118', title: 'Lovey' },
            { num: '119', title: 'Massiff' },
            { num: '120', title: 'Elia Kane' },
            { num: '121', title: 'K-2SO' },
            { num: '122', title: 'General Draven' },
            { num: '123', title: 'Jod Na Nawood' },
            { num: '124', title: 'Count Dooku' },
            { num: '125', title: 'Bossk' },
            { num: '126', title: 'Dobbu Scay' },
            { num: '127', title: 'Imperial Remnant Snowtrooper' },
            { num: '128', title: 'Ranzar "Ran" Malk' },
            { num: '129', title: 'Luthen Rael' },
            { num: '130', title: 'Bail Organa' },
            { num: '131', title: 'Neel' },
            { num: '132', title: 'Padmé Amidala' },
            { num: '133', title: 'Zorii Bliss' },
            { num: '134', title: 'Admiral Ackbar' },
            { num: '135', title: 'Embo' },
            { num: '136', title: 'Jawa' },
            { num: '137', title: 'Saw Gerrera' },
            { num: '138', title: 'Cinta Kaz' },
            { num: '139', title: 'SM-33' },
            { num: '140', title: 'Lyco Strata' },
            { num: '141', title: 'Master Eeko-Dio Daki' },
            { num: '142', title: 'Tallie Lintra' },
            { num: '143', title: '8D8' },
            { num: '144', title: 'Greef Karga' },
            { num: '145', title: 'Jabba the Hutt' },
            { num: '146', title: 'Maul' },
            { num: '147', title: 'Beela' },
            { num: '148', title: 'Taun We' },
            { num: '149', title: 'BDX Droid' },
            { num: '150', title: 'Captain Peavey' },
            { num: '151', title: 'Jedi Padawan Jecki Lon' },
            { num: '152', title: 'Dreena' },
            { num: '153', title: 'Supervisor Lagret' },
            { num: '154', title: 'Beef' },
            { num: '155', title: 'Luminara Unduli' },
            { num: '156', title: 'Gatori' },
            { num: '157', title: 'Captain Canady' },
            { num: '158', title: 'Omega' },
            { num: '159', title: 'Samm' },
            { num: '160', title: 'Krrsantan' },
            { num: '161', title: 'Spybot' },
            { num: '162', title: 'Barriss Offee' },
            { num: '163', title: 'B-1 Mercenary Droid' },
            { num: '164', title: 'Jar Jar Binks' },
            { num: '165', title: 'Boba Fett' },
            { num: '166', title: 'Enza Rylanz' },
            { num: '167', title: 'Clem Andor' },
            { num: '168', title: 'Bubbles' },
            { num: '169', title: 'C-3PO' },
            { num: '170', title: 'Aayla Secura' },
            { num: '171', title: 'Darth Maul' },
            { num: '172', title: 'Cad Bane' },
            { num: '173', title: 'Perrin Fertha' },
            { num: '174', title: 'B2EMO' },
            { num: '175', title: 'L3-37' },
            { num: '176', title: 'Darth Vader' },
            { num: '177', title: 'Plo Koon' },
            { num: '178', title: 'Qui-Gon Jinn' },
            { num: '179', title: 'Fennec Shand' },
            { num: '180', title: 'Carro Rylanz' },
            { num: '181', title: 'Brander Lawson' },
            { num: '182', title: 'Hugo Durant' },
            { num: '183', title: 'Leia Organa' },
            { num: '184', title: 'Even Piell' },
            { num: '185', title: 'Captain Typho' },
            { num: '186', title: 'B-2 Mercenary Droid' },
            { num: '187', title: 'Oathkeeper' },
            { num: '188', title: 'Keibu' },
            { num: '189', title: 'Gerdis' },
            { num: '190', title: 'Lando Calrissian' },
            { num: '191', title: 'Eleventh Brother' },
            { num: '192', title: 'Vane' },
            { num: '193', title: 'Mrs. Ikk' },
            { num: '194', title: 'Dr. Royce Hemlock' },
            { num: '195', title: 'Lord Janu' },
            { num: '196', title: 'Droopy McCool' },
            { num: '197', title: 'R2-D2' },
            { num: '198', title: 'Oppo Rancisis' },
            { num: '199', title: 'The Grand Inquisitor' },
            { num: '200', title: 'Rotta the Hutt' },
          ]
        },
        {
          count: 200,
          name: 'AUREBESH',
          meta: 'Full 200-card Aurebesh mirror',
          parallels: 5,
          cards: [
            { num: 'AURE-1', title: 'Obi-Wan Kenobi' },
            { num: 'AURE-2', title: 'Lezine' },
            { num: 'AURE-3', title: 'Chopper' },
            { num: 'AURE-4', title: 'Devon Izara' },
            { num: 'AURE-5', title: 'Wizzich Mozzer' },
            { num: 'AURE-6', title: 'General Maximilian Veers' },
            { num: 'AURE-7', title: 'Rune Haako' },
            { num: 'AURE-8', title: 'Tusken Raider Warrior' },
            { num: 'AURE-9', title: 'Baylan Skoll' },
            { num: 'AURE-10', title: 'Captain Kaido' },
            { num: 'AURE-11', title: 'Freck' },
            { num: 'AURE-12', title: 'Clone Captain Rex' },
            { num: 'AURE-13', title: 'Sy Snootles' },
            { num: 'AURE-14', title: 'Chewbacca' },
            { num: 'AURE-15', title: 'Rabé' },
            { num: 'AURE-16', title: 'Hamato Xiono' },
            { num: 'AURE-17', title: 'Ahsoka Tano' },
            { num: 'AURE-18', title: 'Davo Sculdun' },
            { num: 'AURE-19', title: 'At Attin frogdog' },
            { num: 'AURE-20', title: 'Icarus' },
            { num: 'AURE-21', title: 'Ezra Bridger' },
            { num: 'AURE-22', title: 'General Hux' },
            { num: 'AURE-23', title: 'Ben Quadinaros' },
            { num: 'AURE-24', title: 'Bo-Katan Kryze' },
            { num: 'AURE-25', title: 'Looti Vario' },
            { num: 'AURE-26', title: 'Sergeant Heert' },
            { num: 'AURE-27', title: 'Mace Windu' },
            { num: 'AURE-28', title: 'Nooma' },
            { num: 'AURE-29', title: 'General Grievous' },
            { num: 'AURE-30', title: 'Maz Kanata' },
            { num: 'AURE-31', title: 'Rey' },
            { num: 'AURE-32', title: 'Grogu' },
            { num: 'AURE-33', title: 'Grand Admiral Thrawn' },
            { num: 'AURE-34', title: 'Runai Sculdun' },
            { num: 'AURE-35', title: 'Hutt Sister' },
            { num: 'AURE-36', title: 'Ralakili' },
            { num: 'AURE-37', title: 'Mace Windu' },
            { num: 'AURE-38', title: 'Poe Dameron' },
            { num: 'AURE-39', title: 'Moff Gideon' },
            { num: 'AURE-40', title: 'Hera Syndulla' },
            { num: 'AURE-41', title: 'Senator Oran' },
            { num: 'AURE-42', title: 'The Armorer' },
            { num: 'AURE-43', title: 'Qi\'ra' },
            { num: 'AURE-44', title: 'Yoda' },
            { num: 'AURE-45', title: 'BB-8' },
            { num: 'AURE-46', title: 'D-O' },
            { num: 'AURE-47', title: 'The Mandalorian' },
            { num: 'AURE-48', title: 'Sabine Wren' },
            { num: 'AURE-49', title: 'Supervisor Lonni Jung' },
            { num: 'AURE-50', title: 'Vult Skerris' },
            { num: 'AURE-51', title: 'Dryden Vos' },
            { num: 'AURE-52', title: 'Anakin Skywalker' },
            { num: 'AURE-53', title: 'Finn' },
            { num: 'AURE-54', title: 'Colonel Aftab Ackbar' },
            { num: 'AURE-55', title: 'Zeb Orrelios' },
            { num: 'AURE-56', title: 'Shin Hati' },
            { num: 'AURE-57', title: 'Kylo Ren' },
            { num: 'AURE-58', title: 'Kanan Jarrus' },
            { num: 'AURE-59', title: 'Sidon Ithano' },
            { num: 'AURE-60', title: 'Klatooinian Crime Boss' },
            { num: 'AURE-61', title: 'Eedy Karn' },
            { num: 'AURE-62', title: 'Babu Frik' },
            { num: 'AURE-63', title: 'Cobb Vanth' },
            { num: 'AURE-64', title: 'Morgan Elsbeth' },
            { num: 'AURE-65', title: 'Ghorman Spider' },
            { num: 'AURE-66', title: 'Emperor Palpatine' },
            { num: 'AURE-67', title: 'Sergeant Gharial' },
            { num: 'AURE-68', title: 'Colonel Ward' },
            { num: 'AURE-69', title: 'Bobbajo' },
            { num: 'AURE-70', title: 'Haja Estree' },
            { num: 'AURE-71', title: 'Syril Karn' },
            { num: 'AURE-72', title: 'Commissioner Helgait' },
            { num: 'AURE-73', title: 'Erskin Semaj' },
            { num: 'AURE-74', title: 'Jyn Erso' },
            { num: 'AURE-75', title: 'Hype Fazon' },
            { num: 'AURE-76', title: 'Rook Kast' },
            { num: 'AURE-77', title: 'Scorn' },
            { num: 'AURE-78', title: 'Bix Caleen' },
            { num: 'AURE-79', title: 'Kuiil' },
            { num: 'AURE-80', title: 'Captain Enoch' },
            { num: 'AURE-81', title: 'Stekan Sculdun' },
            { num: 'AURE-82', title: 'Chirrut Îmwe' },
            { num: 'AURE-83', title: 'Han Solo' },
            { num: 'AURE-84', title: 'Imperial Inquisitor' },
            { num: 'AURE-85', title: 'Lieutenant Connix' },
            { num: 'AURE-86', title: 'Rose Tico' },
            { num: 'AURE-87', title: 'The Duchess of Plazir' },
            { num: 'AURE-88', title: 'Great Mother Lakesis' },
            { num: 'AURE-89', title: 'Drash' },
            { num: 'AURE-90', title: 'Jan Dodonna' },
            { num: 'AURE-91', title: 'Luke Skywalker' },
            { num: 'AURE-92', title: 'Niro' },
            { num: 'AURE-93', title: 'Captain Phasma' },
            { num: 'AURE-94', title: 'Jedi Master Sol' },
            { num: 'AURE-95', title: 'Omera' },
            { num: 'AURE-96', title: 'Vel Sartha' },
            { num: 'AURE-97', title: 'Kleya Marki' },
            { num: 'AURE-98', title: 'Huyang' },
            { num: 'AURE-99', title: 'Moff Tarkin' },
            { num: 'AURE-100', title: 'Bardi' },
            { num: 'AURE-101', title: 'Asajj Ventress' },
            { num: 'AURE-102', title: 'Supreme Leader Snoke' },
            { num: 'AURE-103', title: 'The Stranger' },
            { num: 'AURE-104', title: 'Captain Gilad Pellaeon' },
            { num: 'AURE-105', title: 'Cassian Andor' },
            { num: 'AURE-106', title: 'Pix the Tooka' },
            { num: 'AURE-107', title: 'Jace Rucklin' },
            { num: 'AURE-108', title: 'Ponda Baba' },
            { num: 'AURE-109', title: 'Raxshir' },
            { num: 'AURE-110', title: 'Noti' },
            { num: 'AURE-111', title: 'Jedi Master Indara' },
            { num: 'AURE-112', title: 'Hutt Brother' },
            { num: 'AURE-113', title: 'Mon Mothma' },
            { num: 'AURE-114', title: 'Leida Mothma' },
            { num: 'AURE-115', title: 'Dedra Meero' },
            { num: 'AURE-116', title: 'Owen Lars' },
            { num: 'AURE-117', title: 'Yaddle' },
            { num: 'AURE-118', title: 'Lovey' },
            { num: 'AURE-119', title: 'Massiff' },
            { num: 'AURE-120', title: 'Elia Kane' },
            { num: 'AURE-121', title: 'K-2SO' },
            { num: 'AURE-122', title: 'General Draven' },
            { num: 'AURE-123', title: 'Jod Na Nawood' },
            { num: 'AURE-124', title: 'Count Dooku' },
            { num: 'AURE-125', title: 'Bossk' },
            { num: 'AURE-126', title: 'Dobbu Scay' },
            { num: 'AURE-127', title: 'Imperial Remnant Snowtrooper' },
            { num: 'AURE-128', title: 'Ranzar "Ran" Malk' },
            { num: 'AURE-129', title: 'Luthen Rael' },
            { num: 'AURE-130', title: 'Bail Organa' },
            { num: 'AURE-131', title: 'Neel' },
            { num: 'AURE-132', title: 'Padmé Amidala' },
            { num: 'AURE-133', title: 'Zorii Bliss' },
            { num: 'AURE-134', title: 'Admiral Ackbar' },
            { num: 'AURE-135', title: 'Embo' },
            { num: 'AURE-136', title: 'Jawa' },
            { num: 'AURE-137', title: 'Saw Gerrera' },
            { num: 'AURE-138', title: 'Cinta Kaz' },
            { num: 'AURE-139', title: 'SM-33' },
            { num: 'AURE-140', title: 'Lyco Strata' },
            { num: 'AURE-141', title: 'Master Eeko-Dio Daki' },
            { num: 'AURE-142', title: 'Tallie Lintra' },
            { num: 'AURE-143', title: '8D8' },
            { num: 'AURE-144', title: 'Greef Karga' },
            { num: 'AURE-145', title: 'Jabba the Hutt' },
            { num: 'AURE-146', title: 'Maul' },
            { num: 'AURE-147', title: 'Beela' },
            { num: 'AURE-148', title: 'Taun We' },
            { num: 'AURE-149', title: 'BDX Droid' },
            { num: 'AURE-150', title: 'Captain Peavey' },
            { num: 'AURE-151', title: 'Jedi Padawan Jecki Lon' },
            { num: 'AURE-152', title: 'Dreena' },
            { num: 'AURE-153', title: 'Supervisor Lagret' },
            { num: 'AURE-154', title: 'Beef' },
            { num: 'AURE-155', title: 'Luminara Unduli' },
            { num: 'AURE-156', title: 'Gatori' },
            { num: 'AURE-157', title: 'Captain Canady' },
            { num: 'AURE-158', title: 'Omega' },
            { num: 'AURE-159', title: 'Samm' },
            { num: 'AURE-160', title: 'Krrsantan' },
            { num: 'AURE-161', title: 'Spybot' },
            { num: 'AURE-162', title: 'Barriss Offee' },
            { num: 'AURE-163', title: 'B-1 Mercenary Droid' },
            { num: 'AURE-164', title: 'Jar Jar Binks' },
            { num: 'AURE-165', title: 'Boba Fett' },
            { num: 'AURE-166', title: 'Enza Rylanz' },
            { num: 'AURE-167', title: 'Clem Andor' },
            { num: 'AURE-168', title: 'Bubbles' },
            { num: 'AURE-169', title: 'C-3PO' },
            { num: 'AURE-170', title: 'Aayla Secura' },
            { num: 'AURE-171', title: 'Darth Maul' },
            { num: 'AURE-172', title: 'Cad Bane' },
            { num: 'AURE-173', title: 'Perrin Fertha' },
            { num: 'AURE-174', title: 'B2EMO' },
            { num: 'AURE-175', title: 'L3-37' },
            { num: 'AURE-176', title: 'Darth Vader' },
            { num: 'AURE-177', title: 'Plo Koon' },
            { num: 'AURE-178', title: 'Qui-Gon Jinn' },
            { num: 'AURE-179', title: 'Fennec Shand' },
            { num: 'AURE-180', title: 'Carro Rylanz' },
            { num: 'AURE-181', title: 'Brander Lawson' },
            { num: 'AURE-182', title: 'Hugo Durant' },
            { num: 'AURE-183', title: 'Leia Organa' },
            { num: 'AURE-184', title: 'Even Piell' },
            { num: 'AURE-185', title: 'Captain Typho' },
            { num: 'AURE-186', title: 'B-2 Mercenary Droid' },
            { num: 'AURE-187', title: 'Oathkeeper' },
            { num: 'AURE-188', title: 'Keibu' },
            { num: 'AURE-189', title: 'Gerdis' },
            { num: 'AURE-190', title: 'Lando Calrissian' },
            { num: 'AURE-191', title: 'Eleventh Brother' },
            { num: 'AURE-192', title: 'Vane' },
            { num: 'AURE-193', title: 'Mrs. Ikk' },
            { num: 'AURE-194', title: 'Dr. Royce Hemlock' },
            { num: 'AURE-195', title: 'Lord Janu' },
            { num: 'AURE-196', title: 'Droopy McCool' },
            { num: 'AURE-197', title: 'R2-D2' },
            { num: 'AURE-198', title: 'Oppo Rancisis' },
            { num: 'AURE-199', title: 'The Grand Inquisitor' },
            { num: 'AURE-200', title: 'Rotta the Hutt' },
          ]
        },
        {
          count: 200,
          name: 'PRINTING PLATE BOOK CARDS',
          meta: 'Plates bound as one-of-one book cards · Hobby & Breaker Delight',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'PLATE-1', title: 'Obi-Wan Kenobi' },
            { num: 'PLATE-2', title: 'Lezine' },
            { num: 'PLATE-3', title: 'Chopper' },
            { num: 'PLATE-4', title: 'Devon Izara' },
            { num: 'PLATE-5', title: 'Wizzich Mozzer' },
            { num: 'PLATE-6', title: 'General Maximilian Veers' },
            { num: 'PLATE-7', title: 'Rune Haako' },
            { num: 'PLATE-8', title: 'Tusken Raider Warrior' },
            { num: 'PLATE-9', title: 'Baylan Skoll' },
            { num: 'PLATE-10', title: 'Captain Kaido' },
            { num: 'PLATE-11', title: 'Freck' },
            { num: 'PLATE-12', title: 'Clone Captain Rex' },
            { num: 'PLATE-13', title: 'Sy Snootles' },
            { num: 'PLATE-14', title: 'Chewbacca' },
            { num: 'PLATE-15', title: 'Rabé' },
            { num: 'PLATE-16', title: 'Hamato Xiono' },
            { num: 'PLATE-17', title: 'Ahsoka Tano' },
            { num: 'PLATE-18', title: 'Davo Sculdun' },
            { num: 'PLATE-19', title: 'At Attin frogdog' },
            { num: 'PLATE-20', title: 'Icarus' },
            { num: 'PLATE-21', title: 'Ezra Bridger' },
            { num: 'PLATE-22', title: 'General Hux' },
            { num: 'PLATE-23', title: 'Ben Quadinaros' },
            { num: 'PLATE-24', title: 'Bo-Katan Kryze' },
            { num: 'PLATE-25', title: 'Looti Vario' },
            { num: 'PLATE-26', title: 'Sergeant Heert' },
            { num: 'PLATE-27', title: 'Mace Windu' },
            { num: 'PLATE-28', title: 'Nooma' },
            { num: 'PLATE-29', title: 'General Grievous' },
            { num: 'PLATE-30', title: 'Maz Kanata' },
            { num: 'PLATE-31', title: 'Rey' },
            { num: 'PLATE-32', title: 'Grogu' },
            { num: 'PLATE-33', title: 'Grand Admiral Thrawn' },
            { num: 'PLATE-34', title: 'Runai Sculdun' },
            { num: 'PLATE-35', title: 'Hutt Sister' },
            { num: 'PLATE-36', title: 'Ralakili' },
            { num: 'PLATE-37', title: 'Mace Windu' },
            { num: 'PLATE-38', title: 'Poe Dameron' },
            { num: 'PLATE-39', title: 'Moff Gideon' },
            { num: 'PLATE-40', title: 'Hera Syndulla' },
            { num: 'PLATE-41', title: 'Senator Oran' },
            { num: 'PLATE-42', title: 'The Armorer' },
            { num: 'PLATE-43', title: 'Qi\'ra' },
            { num: 'PLATE-44', title: 'Yoda' },
            { num: 'PLATE-45', title: 'BB-8' },
            { num: 'PLATE-46', title: 'D-O' },
            { num: 'PLATE-47', title: 'The Mandalorian' },
            { num: 'PLATE-48', title: 'Sabine Wren' },
            { num: 'PLATE-49', title: 'Supervisor Lonni Jung' },
            { num: 'PLATE-50', title: 'Vult Skerris' },
            { num: 'PLATE-51', title: 'Dryden Vos' },
            { num: 'PLATE-52', title: 'Anakin Skywalker' },
            { num: 'PLATE-53', title: 'Finn' },
            { num: 'PLATE-54', title: 'Colonel Aftab Ackbar' },
            { num: 'PLATE-55', title: 'Zeb Orrelios' },
            { num: 'PLATE-56', title: 'Shin Hati' },
            { num: 'PLATE-57', title: 'Kylo Ren' },
            { num: 'PLATE-58', title: 'Kanan Jarrus' },
            { num: 'PLATE-59', title: 'Sidon Ithano' },
            { num: 'PLATE-60', title: 'Klatooinian Crime Boss' },
            { num: 'PLATE-61', title: 'Eedy Karn' },
            { num: 'PLATE-62', title: 'Babu Frik' },
            { num: 'PLATE-63', title: 'Cobb Vanth' },
            { num: 'PLATE-64', title: 'Morgan Elsbeth' },
            { num: 'PLATE-65', title: 'Ghorman Spider' },
            { num: 'PLATE-66', title: 'Emperor Palpatine' },
            { num: 'PLATE-67', title: 'Sergeant Gharial' },
            { num: 'PLATE-68', title: 'Colonel Ward' },
            { num: 'PLATE-69', title: 'Bobbajo' },
            { num: 'PLATE-70', title: 'Haja Estree' },
            { num: 'PLATE-71', title: 'Syril Karn' },
            { num: 'PLATE-72', title: 'Commissioner Helgait' },
            { num: 'PLATE-73', title: 'Erskin Semaj' },
            { num: 'PLATE-74', title: 'Jyn Erso' },
            { num: 'PLATE-75', title: 'Hype Fazon' },
            { num: 'PLATE-76', title: 'Rook Kast' },
            { num: 'PLATE-77', title: 'Scorn' },
            { num: 'PLATE-78', title: 'Bix Caleen' },
            { num: 'PLATE-79', title: 'Kuiil' },
            { num: 'PLATE-80', title: 'Captain Enoch' },
            { num: 'PLATE-81', title: 'Stekan Sculdun' },
            { num: 'PLATE-82', title: 'Chirrut Îmwe' },
            { num: 'PLATE-83', title: 'Han Solo' },
            { num: 'PLATE-84', title: 'Imperial Inquisitor' },
            { num: 'PLATE-85', title: 'Lieutenant Connix' },
            { num: 'PLATE-86', title: 'Rose Tico' },
            { num: 'PLATE-87', title: 'The Duchess of Plazir' },
            { num: 'PLATE-88', title: 'Great Mother Lakesis' },
            { num: 'PLATE-89', title: 'Drash' },
            { num: 'PLATE-90', title: 'Jan Dodonna' },
            { num: 'PLATE-91', title: 'Luke Skywalker' },
            { num: 'PLATE-92', title: 'Niro' },
            { num: 'PLATE-93', title: 'Captain Phasma' },
            { num: 'PLATE-94', title: 'Jedi Master Sol' },
            { num: 'PLATE-95', title: 'Omera' },
            { num: 'PLATE-96', title: 'Vel Sartha' },
            { num: 'PLATE-97', title: 'Kleya Marki' },
            { num: 'PLATE-98', title: 'Huyang' },
            { num: 'PLATE-99', title: 'Moff Tarkin' },
            { num: 'PLATE-100', title: 'Bardi' },
            { num: 'PLATE-101', title: 'Asajj Ventress' },
            { num: 'PLATE-102', title: 'Supreme Leader Snoke' },
            { num: 'PLATE-103', title: 'The Stranger' },
            { num: 'PLATE-104', title: 'Captain Gilad Pellaeon' },
            { num: 'PLATE-105', title: 'Cassian Andor' },
            { num: 'PLATE-106', title: 'Pix the Tooka' },
            { num: 'PLATE-107', title: 'Jace Rucklin' },
            { num: 'PLATE-108', title: 'Ponda Baba' },
            { num: 'PLATE-109', title: 'Raxshir' },
            { num: 'PLATE-110', title: 'Noti' },
            { num: 'PLATE-111', title: 'Jedi Master Indara' },
            { num: 'PLATE-112', title: 'Hutt Brother' },
            { num: 'PLATE-113', title: 'Mon Mothma' },
            { num: 'PLATE-114', title: 'Leida Mothma' },
            { num: 'PLATE-115', title: 'Dedra Meero' },
            { num: 'PLATE-116', title: 'Owen Lars' },
            { num: 'PLATE-117', title: 'Yaddle' },
            { num: 'PLATE-118', title: 'Lovey' },
            { num: 'PLATE-119', title: 'Massiff' },
            { num: 'PLATE-120', title: 'Elia Kane' },
            { num: 'PLATE-121', title: 'K-2SO' },
            { num: 'PLATE-122', title: 'General Draven' },
            { num: 'PLATE-123', title: 'Jod Na Nawood' },
            { num: 'PLATE-124', title: 'Count Dooku' },
            { num: 'PLATE-125', title: 'Bossk' },
            { num: 'PLATE-126', title: 'Dobbu Scay' },
            { num: 'PLATE-127', title: 'Imperial Remnant Snowtrooper' },
            { num: 'PLATE-128', title: 'Ranzar "Ran" Malk' },
            { num: 'PLATE-129', title: 'Luthen Rael' },
            { num: 'PLATE-130', title: 'Bail Organa' },
            { num: 'PLATE-131', title: 'Neel' },
            { num: 'PLATE-132', title: 'Padmé Amidala' },
            { num: 'PLATE-133', title: 'Zorii Bliss' },
            { num: 'PLATE-134', title: 'Admiral Ackbar' },
            { num: 'PLATE-135', title: 'Embo' },
            { num: 'PLATE-136', title: 'Jawa' },
            { num: 'PLATE-137', title: 'Saw Gerrera' },
            { num: 'PLATE-138', title: 'Cinta Kaz' },
            { num: 'PLATE-139', title: 'SM-33' },
            { num: 'PLATE-140', title: 'Lyco Strata' },
            { num: 'PLATE-141', title: 'Master Eeko-Dio Daki' },
            { num: 'PLATE-142', title: 'Tallie Lintra' },
            { num: 'PLATE-143', title: '8D8' },
            { num: 'PLATE-144', title: 'Greef Karga' },
            { num: 'PLATE-145', title: 'Jabba the Hutt' },
            { num: 'PLATE-146', title: 'Maul' },
            { num: 'PLATE-147', title: 'Beela' },
            { num: 'PLATE-148', title: 'Taun We' },
            { num: 'PLATE-149', title: 'BDX Droid' },
            { num: 'PLATE-150', title: 'Captain Peavey' },
            { num: 'PLATE-151', title: 'Jedi Padawan Jecki Lon' },
            { num: 'PLATE-152', title: 'Dreena' },
            { num: 'PLATE-153', title: 'Supervisor Lagret' },
            { num: 'PLATE-154', title: 'Beef' },
            { num: 'PLATE-155', title: 'Luminara Unduli' },
            { num: 'PLATE-156', title: 'Gatori' },
            { num: 'PLATE-157', title: 'Captain Canady' },
            { num: 'PLATE-158', title: 'Omega' },
            { num: 'PLATE-159', title: 'Samm' },
            { num: 'PLATE-160', title: 'Krrsantan' },
            { num: 'PLATE-161', title: 'Spybot' },
            { num: 'PLATE-162', title: 'Barriss Offee' },
            { num: 'PLATE-163', title: 'B-1 Mercenary Droid' },
            { num: 'PLATE-164', title: 'Jar Jar Binks' },
            { num: 'PLATE-165', title: 'Boba Fett' },
            { num: 'PLATE-166', title: 'Enza Rylanz' },
            { num: 'PLATE-167', title: 'Clem Andor' },
            { num: 'PLATE-168', title: 'Bubbles' },
            { num: 'PLATE-169', title: 'C-3PO' },
            { num: 'PLATE-170', title: 'Aayla Secura' },
            { num: 'PLATE-171', title: 'Darth Maul' },
            { num: 'PLATE-172', title: 'Cad Bane' },
            { num: 'PLATE-173', title: 'Perrin Fertha' },
            { num: 'PLATE-174', title: 'B2EMO' },
            { num: 'PLATE-175', title: 'L3-37' },
            { num: 'PLATE-176', title: 'Darth Vader' },
            { num: 'PLATE-177', title: 'Plo Koon' },
            { num: 'PLATE-178', title: 'Qui-Gon Jinn' },
            { num: 'PLATE-179', title: 'Fennec Shand' },
            { num: 'PLATE-180', title: 'Carro Rylanz' },
            { num: 'PLATE-181', title: 'Brander Lawson' },
            { num: 'PLATE-182', title: 'Hugo Durant' },
            { num: 'PLATE-183', title: 'Leia Organa' },
            { num: 'PLATE-184', title: 'Even Piell' },
            { num: 'PLATE-185', title: 'Captain Typho' },
            { num: 'PLATE-186', title: 'B-2 Mercenary Droid' },
            { num: 'PLATE-187', title: 'Oathkeeper' },
            { num: 'PLATE-188', title: 'Keibu' },
            { num: 'PLATE-189', title: 'Gerdis' },
            { num: 'PLATE-190', title: 'Lando Calrissian' },
            { num: 'PLATE-191', title: 'Eleventh Brother' },
            { num: 'PLATE-192', title: 'Vane' },
            { num: 'PLATE-193', title: 'Mrs. Ikk' },
            { num: 'PALTE-194', title: 'Dr. Royce Hemlock' },
            { num: 'PLATE-195', title: 'Lord Janu' },
            { num: 'PLATE-196', title: 'Droopy McCool' },
            { num: 'PLATE-197', title: 'R2-D2' },
            { num: 'PLATE-198', title: 'Oppo Rancisis' },
            { num: 'PLATE-199', title: 'The Grand Inquisitor' },
            { num: 'PLATE-200', title: 'Rotta the Hutt' },
          ]
        }
      ],
      insert: [
        {
          count: 17,
          name: 'ANDOR SEASON 2 CHARACTERS',
          meta: 'The cast of the rebellion’s final chapter',
          parallels: 6,
          cards: [
            { num: 'A2-B2', title: 'B2EMO' },
            { num: 'A2-BIX', title: 'Bix Caleen' },
            { num: 'A2-BRA', title: 'Brasso' },
            { num: 'A2-CASS', title: 'Cassian Andor' },
            { num: 'A2-DEDRA', title: 'Dedra Meero' },
            { num: 'A2-DIRE', title: 'Director Krennic' },
            { num: 'A2-GORST', title: 'Dr. Gorst' },
            { num: 'A2-KARN', title: 'Syril Karn' },
            { num: 'A2-KAZ', title: 'Cinta Kaz' },
            { num: 'A2-MARK', title: 'Kleya Marki' },
            { num: 'A2-PAAK', title: 'Wilmon Paak' },
            { num: 'A2-PART', title: 'Major Partagaz' },
            { num: 'A2-RAEL', title: 'Luthen Rael' },
            { num: 'A2-SAW', title: 'Saw Gerrera' },
            { num: 'A2-TAY', title: 'Tay Kolma' },
            { num: 'AS-K2', title: 'K-2SO' },
            { num: 'AS-MON', title: 'Mon Mothma' },
          ]
        },
        {
          count: 12,
          name: 'ANDOR SEASON 2 MOMENTS',
          meta: 'Key scenes from Season 2',
          parallels: 6,
          cards: [
            { num: 'AM-1', title: 'An Uncomfortable Dinner' },
            { num: 'AM-2', title: 'Mon Mothma Dances' },
            { num: 'AM-3', title: 'Cassian Andor Saves His Friends' },
            { num: 'AM-4', title: '"We Should Have Killed Krennic"' },
            { num: 'AM-5', title: 'Bix Caleen Gets Revenge On Dr. Gorst' },
            { num: 'AM-6', title: '"Who Are You?"' },
            { num: 'AM-7', title: 'Mon Mothma Fights The Empire' },
            { num: 'AM-8', title: '"I Have Friends Everywhere"' },
            { num: 'AM-9', title: 'Dedra Meero Finally Meets Axis' },
            { num: 'AM-10', title: 'Dedra Meero\'s Interrogation' },
            { num: 'AM-11', title: 'K-2SO Provides Backup' },
            { num: 'AM-12', title: 'Consequences' },
          ]
        },
        {
          count: 14,
          name: 'VISIONS SEASON 3 CHARACTERS',
          meta: 'Heroes and villains of the anthology’s third volume',
          parallels: 6,
          cards: [
            { num: 'V3-AS', title: 'Anée-San' },
            { num: 'V3-CHIT', title: 'Chita' },
            { num: 'V3-CRA', title: 'Crane' },
            { num: 'V3-F', title: 'F' },
            { num: 'V3-FOX', title: 'Fox-Ear' },
            { num: 'V3-GRA', title: 'Grand Master' },
            { num: 'V3-KAR', title: 'Lah Kara' },
            { num: 'V3-NAKIM', title: 'Nakime' },
            { num: 'V3-RON', title: 'Ronin' },
            { num: 'V3-SHA', title: 'Shad-Rah' },
            { num: 'V3-TETO', title: 'Teto' },
            { num: 'V3-WOO', title: 'Woopas' },
            { num: 'V3-YUKO', title: 'Yuko' },
            { num: 'V3-ZIM', title: 'Lah Zhima' },
          ]
        },
        {
          count: 9,
          name: 'VISIONS SEASON 3 MOMENTS',
          meta: 'Key scenes from Season 3',
          parallels: 6,
          cards: [
            { num: 'V3-1', title: 'The Grand Master vs Ronin' },
            { num: 'V3-2', title: 'Crane Saves Woopas' },
            { num: 'V3-3', title: 'Kara Fights Off the Hunters' },
            { num: 'V3-4', title: 'Sevn And IV-A4 On The Run' },
            { num: 'V3-5', title: 'Leaving Mos Eisley' },
            { num: 'V3-6', title: 'F vs Shad-Rah' },
            { num: 'V3-7', title: 'Gleenu Reveals Her Hidden Past' },
            { num: 'V3-8', title: 'The Temptation Of The Dark Side' },
            { num: 'V3-9', title: 'Black' },
          ]
        },
        {
          count: 26,
          name: 'THE MANDALORIAN AND GROGU CHARACTERS',
          meta: 'Heroes, villains and allies of the 2026 film',
          parallels: 6,
          cards: [
            { num: 'MAGR-AT', title: 'Imperial Remnant AT-AT Driver' },
            { num: 'MAGR-BAI', title: 'Bai' },
            { num: 'MAGR-CLAN', title: 'Clang' },
            { num: 'MAGR-DEER', title: 'BDX Droid' },
            { num: 'MAGR-EMB', title: 'Embo' },
            { num: 'MAGR-GAT', title: 'Gatori' },
            { num: 'MAGR-GHH', title: 'Ghhhk' },
            { num: 'MAGR-GRO', title: 'Grogu' },
            { num: 'MAGR-HOU', title: 'Houjix' },
            { num: 'MAGR-JAN', title: 'Lord Janu' },
            { num: 'MAGR-KEET', title: 'Keeto' },
            { num: 'MAGR-KINT', title: 'Kintan Strider' },
            { num: 'MAGR-KLO', title: 'K\'lor\'slug' },
            { num: 'MAGR-MAN', title: 'The Mandalorian' },
            { num: 'MAGR-MANT', title: 'Mantellian Savrip' },
            { num: 'MAGR-MINC', title: 'Minch' },
            { num: 'MAGR-MOL', title: 'Molatar' },
            { num: 'MAGR-MON', title: 'Monnok' },
            { num: 'MAGR-NGO', title: 'Ng\'ok' },
            { num: 'MAGR-R5', title: 'R5-D4' },
            { num: 'MAGR-ROT', title: 'Rotta the Hutt' },
            { num: 'MAGR-SNOW', title: 'Imperial Remnant Snowtrooper' },
            { num: 'MAGR-ST', title: 'Stormtrooper' },
            { num: 'MAGR-TWIN', title: 'Hutt Twins' },
            { num: 'MAGR-WARD', title: 'Colonel Ward' },
            { num: 'MAGR-ZEB', title: 'Zeb Orrelios' },
          ]
        },
        {
          count: 17,
          name: 'THE MANDALORIAN AND GROGU MOMENTS',
          meta: 'Key scenes from the 2026 film',
          parallels: 6,
          cards: [
            { num: 'MAGR-1', title: 'Refitting The Mandalorian\'s Ship' },
            { num: 'MAGR-2', title: 'Miniature Mechanics' },
            { num: 'MAGR-3', title: 'Tracking Grogu' },
            { num: 'MAGR-4', title: 'A Friendly Favor' },
            { num: 'MAGR-5', title: 'Defending The Imperial Base' },
            { num: 'MAGR-6', title: 'An Unlikely Means Of Escape' },
            { num: 'MAGR-7', title: 'On The Hunt' },
            { num: 'MAGR-8', title: 'Stake Out' },
            { num: 'MAGR-9', title: 'Inhospitable Conditions' },
            { num: 'MAGR-10', title: 'Back In The Razor Crest' },
            { num: 'MAGR-11', title: 'Tiny Ride, Big Friends!' },
            { num: 'MAGR-12', title: 'The Pit Fight' },
            { num: 'MAGR-13', title: 'Grogu\'s Distraction' },
            { num: 'MAGR-14', title: 'Inside The AT-AT' },
            { num: 'MAGR-15', title: 'Cooking Up Information' },
            { num: 'MAGR-16', title: 'The Twins\' Scheme' },
            { num: 'MAGR-17', title: 'A Place Of Peace' },
          ]
        },
        {
          count: 16,
          name: 'OBLIVION',
          meta: 'Characters over fiery backdrops · new for 2026',
          parallels: 3,
          cards: [
            { num: 'O-1', title: 'Cassian Andor' },
            { num: 'O-2', title: 'K-2SO' },
            { num: 'O-3', title: 'The Mandalorian' },
            { num: 'O-4', title: 'Moff Gideon' },
            { num: 'O-5', title: 'Stormtrooper' },
            { num: 'O-6', title: 'Paz Vizsla' },
            { num: 'O-7', title: 'Chopper' },
            { num: 'O-8', title: 'Tie Fighter Pilot' },
            { num: 'O-9', title: 'Jango Fett' },
            { num: 'O-10', title: 'Luke Skywalker' },
            { num: 'O-11', title: 'Finn' },
            { num: 'O-12', title: 'Captain Phasma' },
            { num: 'O-13', title: 'Death Trooper' },
            { num: 'O-14', title: 'Boba Fett' },
            { num: 'O-15', title: 'R2-D2' },
            { num: 'O-16', title: 'BB-8' },
          ]
        },
        {
          count: 20,
          name: 'STORMTROOPER COMMAND',
          meta: 'Stormtrooper-helmet die-cuts',
          parallels: 6,
          cards: [
            { num: 'SC-1', title: 'Stormtrooper Helmet 1' },
            { num: 'SC-2', title: 'Stormtrooper Helmet 2' },
            { num: 'SC-3', title: 'Stormtrooper Helmet 3' },
            { num: 'SC-4', title: 'Stormtrooper Helmet 4' },
            { num: 'SC-5', title: 'Stormtrooper Helmet 5' },
            { num: 'SC-6', title: 'Stormtrooper Helmet 6' },
            { num: 'SC-7', title: 'Stormtrooper Helmet 7' },
            { num: 'SC-8', title: 'Stormtrooper Helmet 8' },
            { num: 'SC-9', title: 'Stormtrooper Helmet 9' },
            { num: 'SC-10', title: 'Stormtrooper Helmet 10' },
            { num: 'SC-11', title: 'Stormtrooper Helmet 11' },
            { num: 'SC-12', title: 'Stormtrooper Helmet 12' },
            { num: 'SC-13', title: 'Stormtrooper Helmet 13' },
            { num: 'SC-14', title: 'Stormtrooper Helmet 14' },
            { num: 'SC-15', title: 'Stormtrooper Helmet 15' },
            { num: 'SC-16', title: 'Stormtrooper Helmet 16' },
            { num: 'SC-17', title: 'Stormtrooper Helmet 17' },
            { num: 'SC-18', title: 'Stormtrooper Helmet 18' },
            { num: 'SC-19', title: 'Stormtrooper Helmet 19' },
            { num: 'SC-20', title: 'Stormtrooper Helmet 20' },
          ]
        },
        {
          count: 15,
          name: 'GALAXY’S CUTEST',
          meta: 'Sticker-style art of the galaxy’s cutest · new for 2026',
          parallels: 6,
          cards: [
            { num: 'QT-1', title: 'Anzellan' },
            { num: 'QT-2', title: 'Trash Crab' },
            { num: 'QT-3', title: 'Dokma' },
            { num: 'QT-4', title: 'Ewok' },
            { num: 'QT-5', title: 'Grogu' },
            { num: 'QT-6', title: 'Jawa' },
            { num: 'QT-7', title: 'Lava Meerkat' },
            { num: 'QT-8', title: 'Loth-Cat' },
            { num: 'QT-9', title: 'Noti' },
            { num: 'QT-10', title: 'Myykian' },
            { num: 'QT-11', title: 'Puffer Pig' },
            { num: 'QT-12', title: 'Porg' },
            { num: 'QT-13', title: 'Oki-Poki' },
            { num: 'QT-14', title: 'Tooka Cat' },
            { num: 'QT-15', title: 'Wookiee' },
          ]
        },
        {
          count: 10,
          name: 'GALACTIC MAXIMALISTS',
          meta: 'Bold poster-style artwork · new for 2026',
          parallels: 5,
          cards: [
            { num: 'GMAX-C3', title: 'C-3PO' },
            { num: 'GMAX-CHEWIE', title: 'Chewbacca' },
            { num: 'GMAX-FETT', title: 'Boba Fett' },
            { num: 'GMAX-JABBA', title: 'Jabba the Hutt' },
            { num: 'GMAX-OBI', title: 'Obi-Wan Kenobi' },
            { num: 'GMAX-QUEEN', title: 'Queen Amidala' },
            { num: 'GMAX-REBO', title: 'Max Rebo' },
            { num: 'GMAX-SKY', title: 'Luke Skywalker' },
            { num: 'GMAX-VADER', title: 'Darth Vader' },
            { num: 'GMAX-YODA', title: 'Yoda' },
          ]
        },
        {
          count: 10,
          name: 'FACTIONS',
          meta: 'The galaxy’s great factions',
          parallels: 3,
          cards: [
            { num: 'SQUAD-1', title: 'Bounty Hunters' },
            { num: 'SQUAD-2', title: 'First Order' },
            { num: 'SQUAD-3', title: 'Galactic Empire' },
            { num: 'SQUAD-4', title: 'Hutt Clan' },
            { num: 'SQUAD-5', title: 'Jedi Order' },
            { num: 'SQUAD-6', title: 'Phoenix Squadron' },
            { num: 'SQUAD-7', title: 'Rebel Alliance' },
            { num: 'SQUAD-8', title: 'Resistance' },
            { num: 'SQUAD-9', title: 'Sith' },
            { num: 'SQUAD-10', title: 'Inquisitorius' },
          ]
        },
        {
          count: 50,
          name: 'COSMIC CRYSTALS',
          meta: '50-card insert · Superfractor parallel only',
          parallels: 1,
          cards: [
            { num: 'COS-1', title: 'Leia Organa' },
            { num: 'COS-2', title: 'Bo-Katan Kryze' },
            { num: 'COS-3', title: 'Fennec Shand' },
            { num: 'COS-4', title: 'Rey' },
            { num: 'COS-5', title: 'Poe Dameron' },
            { num: 'COS-6', title: 'Darth Vader' },
            { num: 'COS-7', title: 'Count Dooku' },
            { num: 'COS-8', title: 'Mace Windu' },
            { num: 'COS-9', title: 'Obi-Wan Kenobi' },
            { num: 'COS-10', title: 'Luke Skywalker' },
            { num: 'COS-11', title: 'Chewbacca' },
            { num: 'COS-12', title: 'Han Solo' },
            { num: 'COS-13', title: 'Ahsoka Tano' },
            { num: 'COS-14', title: 'Sabine Wren' },
            { num: 'COS-15', title: 'Shin Hati' },
            { num: 'COS-16', title: 'Lando Calrissian' },
            { num: 'COS-17', title: 'Maz Kanata' },
            { num: 'COS-18', title: 'BB-8' },
            { num: 'COS-19', title: 'C-3PO' },
            { num: 'COS-20', title: 'Grogu' },
            { num: 'COS-21', title: 'The Mandalorian' },
            { num: 'COS-22', title: 'Kylo Ren' },
            { num: 'COS-23', title: 'Boba Fett' },
            { num: 'COS-24', title: 'Padmé Amidala' },
            { num: 'COS-25', title: 'Hera Syndulla' },
            { num: 'COS-26', title: 'Captain Phasma' },
            { num: 'COS-27', title: 'Cassian Andor' },
            { num: 'COS-28', title: 'Mon Mothma' },
            { num: 'COS-29', title: 'Jod Na Nawood' },
            { num: 'COS-30', title: 'Neel' },
            { num: 'COS-31', title: 'Finn' },
            { num: 'COS-32', title: 'Chopper' },
            { num: 'COS-33', title: 'R2-D2' },
            { num: 'COS-34', title: 'Kit Fisto' },
            { num: 'COS-35', title: 'Anakin Skywalker' },
            { num: 'COS-36', title: 'General Grievous' },
            { num: 'COS-37', title: 'Shaak Ti' },
            { num: 'COS-38', title: 'Grand Admiral Thrawn' },
            { num: 'COS-39', title: 'Porg' },
            { num: 'COS-40', title: 'Jyn Erso' },
            { num: 'COS-41', title: 'Darth Sidious' },
            { num: 'COS-42', title: 'Yoda' },
            { num: 'COS-43', title: 'Qi\'ra' },
            { num: 'COS-44', title: 'The Grand Inquisitor' },
            { num: 'COS-45', title: 'Vice Admiral Holdo' },
            { num: 'COS-46', title: 'Qui-Gon Jinn' },
            { num: 'COS-47', title: 'Max Rebo' },
            { num: 'COS-48', title: 'Clone Trooper' },
            { num: 'COS-49', title: 'Kaydel Ko Connix' },
            { num: 'COS-50', title: 'Sabé' },
          ]
        },
        {
          count: 12,
          name: 'BONUS STAGE',
          meta: 'Retro arcade art · Superfractor parallel only',
          parallels: 1,
          cards: [
            { num: 'BO-BEN', title: 'Obi-Wan Kenobi' },
            { num: 'BO-BOSS', title: 'Bossk' },
            { num: 'BO-DV', title: 'Darth Vader' },
            { num: 'BO-FET', title: 'Boba Fett' },
            { num: 'BO-GRE', title: 'Greedo' },
            { num: 'BO-JAW', title: 'Jawa' },
            { num: 'BO-LAC', title: 'Lando Calrissian' },
            { num: 'BO-LO', title: 'Leia Organa' },
            { num: 'BO-LUKE', title: 'Luke Skywalker' },
            { num: 'BO-R2', title: 'R2-D2' },
            { num: 'BO-ST', title: 'Scout Trooper' },
            { num: 'BO-YO', title: 'Yoda' },
          ]
        },
        {
          count: 10,
          name: 'KYBER LIGHT',
          meta: 'KL-21 to KL-30 · continues 2025',
          parallels: 3,
          cards: [
            { num: 'KL-21', title: 'Bo-Katan Kryze' },
            { num: 'KL-22', title: 'Grand Admiral Thrawn' },
            { num: 'KL-23', title: 'Hera Syndulla' },
            { num: 'KL-24', title: 'Kit Fisto' },
            { num: 'KL-25', title: 'Mace Windu' },
            { num: 'KL-26', title: 'Neel' },
            { num: 'KL-27', title: 'Sabine Wren' },
            { num: 'KL-28', title: 'Savage Opress' },
            { num: 'KL-29', title: 'Shaak Ti' },
            { num: 'KL-30', title: 'Zeb Orrelios' },
          ]
        },
        {
          count: 9,
          name: 'ERAS',
          meta: 'The nine films in original artwork · Superfractor parallel only',
          parallels: 1,
          cards: [
            { num: 'E-1', title: 'The First' },
            { num: 'E-2', title: 'The Second' },
            { num: 'E-3', title: 'The Third' },
            { num: 'E-4', title: 'The Fourth' },
            { num: 'E-5', title: 'The Fifth' },
            { num: 'E-6', title: 'The Sixth' },
            { num: 'E-7', title: 'The Seventh' },
            { num: 'E-8', title: 'The Eighth' },
            { num: 'E-9', title: 'The Ninth' },
          ]
        },
        {
          count: 5,
          name: 'REFLECTIONS',
          meta: 'R-16 to R-20 · continues 2025',
          parallels: 3,
          cards: [
            { num: 'R-16', title: 'Captain Phasma' },
            { num: 'R-17', title: 'Clone Commander Cody' },
            { num: 'R-18', title: 'Imperial Red Guard' },
            { num: 'R-19', title: 'Luke Skywalker' },
            { num: 'R-20', title: 'Moff Gideon' },
          ]
        },
        {
          count: 5,
          name: 'COMICFRACTOR',
          meta: 'Comic cover art · VC-16 to VC-20',
          parallels: 4,
          cards: [
            { num: 'VC-16', title: 'C-3PO' },
            { num: 'VC-17', title: 'Chewbacca' },
            { num: 'VC-18', title: 'Han Solo' },
            { num: 'VC-19', title: 'Jawa' },
            { num: 'VC-20', title: 'The Emperor' },
          ]
        }
      ],
      auto: [
        {
          count: 181,
          name: 'CHARACTER AUTOGRAPHS',
          meta: 'Single-signer · legends to first-time signers',
          parallels: 7,
          cards: [
            { num: 'A-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'A-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'A-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'A-AT', title: 'Alan Tudyk', meta: 'K-2SO' },
            { num: 'A-BB', title: 'Blair Bess', meta: 'Even Piell' },
            { num: 'A-BD', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'A-BLUM', title: 'Steve Blum', meta: 'Icarus' },
            { num: 'A-BN', title: 'Benjamin Norris', meta: 'Bardi' },
            { num: 'A-C3', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'A-CAM', title: 'Carrie-Anne Moss', meta: 'Jedi Master Indara' },
            { num: 'A-CARR', title: 'Geneva Carr', meta: 'Nooma' },
            { num: 'A-CF', title: 'Carrie Fisher', meta: 'Leia Organa' },
            { num: 'A-DB', title: 'Dominic Burgess', meta: 'Beef' },
            { num: 'A-DBB', title: 'Dee Bradley Baker', meta: 'Clone Captain Rex' },
            { num: 'A-DIL', title: 'Richard Dillane', meta: 'Davo Sculdun' },
            { num: 'A-DK', title: 'Dafne Keen', meta: 'Jedi Padawan Jecki Lon' },
            { num: 'A-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'A-DOM', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'A-DP', title: 'David Prowse', meta: 'Darth Vader' },
            { num: 'A-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'A-DTEN', title: 'David Tennant', meta: 'Huyang' },
            { num: 'A-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'A-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'A-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'A-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'A-FPJ', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'A-FW', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'A-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'A-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'A-HC', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'A-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'A-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'A-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'A-JB', title: 'John Boyega', meta: 'Finn' },
            { num: 'A-JG', title: 'Julian Glover', meta: 'General Maximilian Veers' },
            { num: 'A-JIM', title: 'Jimmi Simpson', meta: 'Royce Hemlock' },
            { num: 'A-JJB', title: 'Jacob James Beswick', meta: 'Sergeant Heert' },
            { num: 'A-JL', title: 'Jude Law', meta: 'Jod Na Nawood' },
            { num: 'A-JO', title: 'Jonjo O\'Neill', meta: 'Captain Kaido' },
            { num: 'A-KAT', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'A-KS', title: 'Karol Cristina da Silva', meta: 'Rabé' },
            { num: 'A-LB', title: 'Lynn Robertson Bruce', meta: 'D-O' },
            { num: 'A-LFA', title: 'Lane Factor', meta: 'Lyco Strata' },
            { num: 'A-LIZ', title: 'Lizzo', meta: 'The Duchess of Plazir' },
            { num: 'A-LJ', title: 'Lee Jung-jae', meta: 'Jedi Master Sol' },
            { num: 'A-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'A-LOO', title: 'Chris Diamantopoulos', meta: 'Looti Vario' },
            { num: 'A-LU', title: 'Lupita Nyong\'o', meta: 'Maz Kanata' },
            { num: 'A-MEW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'A-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'A-MMA', title: 'Marti Matulis', meta: 'Vane' },
            { num: 'A-MQ', title: 'Mike Quinn', meta: 'Sy Snootles' },
            { num: 'A-MV', title: 'Mario Vernazza', meta: 'Vult Skerris' },
            { num: 'A-MW', title: 'Matthew Wood', meta: 'General Grievous' },
            { num: 'A-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'A-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'A-OWE', title: 'Rena Owen', meta: 'Taun We' },
            { num: 'A-PB', title: 'Paul Bettany', meta: 'Dryden Vos' },
            { num: 'A-PL', title: 'Phil LaMarr', meta: 'Klatooinian Crime Boss' },
            { num: 'A-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'A-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'A-RE', title: 'Robert Emms', meta: 'Supervisor Lonni Jung' },
            { num: 'A-RH', title: 'Clint Howard', meta: 'Ralakili' },
            { num: 'A-RO', title: 'Rosalind Halstead', meta: 'Runai Sculdun' },
            { num: 'A-RRL', title: 'Raphael Roger Levy', meta: 'Senator Oran' },
            { num: 'A-SH', title: 'Shirley Henderson', meta: 'Babu Frik' },
            { num: 'A-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'A-TC', title: 'TC Carson', meta: 'Mace Windu' },
            { num: 'A-TG', title: 'Thierry Godard', meta: 'Lezine' },
            { num: 'A-ZAC', title: 'Zach Braff', meta: 'Freck' },
            { num: 'A-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'A-AC', title: 'Aidan Cook', meta: 'Bobbajo' },
            { num: 'A-AM', title: 'Alastair Mackenzie', meta: 'Perrin Fertha' },
            { num: 'A-AP', title: 'Alistair Petrie', meta: 'General Draven' },
            { num: 'A-BB-2', title: 'Benjamin Bratt', meta: 'Bail Organa' },
            { num: 'A-BDH', title: 'Bryce Dallas Howard', meta: 'Yaddle' },
            { num: 'A-BL', title: 'Billie Lourd', meta: 'Lieutenant Connix' },
            { num: 'A-BUTL', title: 'Artt Butler', meta: 'Niro' },
            { num: 'A-CL', title: 'Christopher Lloyd', meta: 'Commissioner Helgait' },
            { num: 'A-COYN', title: 'Jonny Coyne', meta: 'Lord Janu' },
            { num: 'A-DBA', title: 'David Barclay', meta: 'Jabba the Hutt' },
            { num: 'A-DGO', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'A-DI', title: 'Diana Lee Inosanto', meta: 'Morgan Elsbeth' },
            { num: 'A-DT', title: 'Dee Tails', meta: 'Sidon Ithano' },
            { num: 'A-ED', title: 'Elizabeth Dulau', meta: 'Kleya Marki' },
            { num: 'A-EE', title: 'Eman Esfandi', meta: 'Ezra Bridger' },
            { num: 'A-EW', title: 'Elijah Wood', meta: 'Jace Rucklin' },
            { num: 'A-FG', title: 'Finley Glasgow', meta: 'Stekan Sculdun' },
            { num: 'A-FM', title: 'Faye Marsay', meta: 'Vel Sartha' },
            { num: 'A-GA', title: 'Gideon Adlon', meta: 'Devon Izara' },
            { num: 'A-GAT', title: 'Stephen McKinley Henderson', meta: 'Gatori' },
            { num: 'A-GB', title: 'Gary Beadle', meta: 'Clem Andor' },
            { num: 'A-HAY', title: 'Dennis Haysbert', meta: 'Master Eeko-Dio Daki' },
            { num: 'A-HER', title: 'Hermione Corfield', meta: 'Tallie Lintra' },
            { num: 'A-IE', title: 'Ian McElhinney', meta: 'Jan Dodonna' },
            { num: 'A-JAI', title: 'Jason Isaacs', meta: 'The Grand Inquisitor' },
            { num: 'A-JJ', title: 'Julia Jones', meta: 'Omera' },
            { num: 'A-JOA', title: 'Joanna Bennett', meta: 'Tusken Raider Warrior' },
            { num: 'A-KHU', title: 'Kathryn Hunter', meta: 'Eedy Karn' },
            { num: 'A-KO', title: 'Katy O\'Brian', meta: 'Elia Kane' },
            { num: 'A-KRR', title: 'Carey Jones', meta: 'Krrsantan' },
            { num: 'A-KSO', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'A-KT', title: 'Kelly Marie Tran', meta: 'Rose Tico' },
            { num: 'A-LM-2', title: 'Bronte Carmichael', meta: 'Leida Mothma' },
            { num: 'A-LS', title: 'Leilani Shiu', meta: 'Jawa' },
            { num: 'A-MA', title: 'Michelle Ang', meta: 'Omega' },
            { num: 'A-MB', title: 'Mark Boone Jr.', meta: 'Ranzar Malk' },
            { num: 'A-MJ', title: 'Manny Jacinto', meta: 'The Stranger' },
            { num: 'A-MNW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'A-MOFF', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'A-NF', title: 'Nick Frost', meta: 'SM-33' },
            { num: 'A-NIKKA', title: 'Nikka Futterman', meta: 'Asajj Ventress' },
            { num: 'A-NKR', title: 'Nalini Krishan', meta: 'Barriss Offee' },
            { num: 'A-NL', title: 'Nelson Lee', meta: 'Hamato Xiono' },
            { num: 'A-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'A-RAY', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'A-ROY', title: 'Deep Roy', meta: 'Droopy McCool' },
            { num: 'A-RS', title: 'Richard Sammel', meta: 'Carro Rylanz' },
            { num: 'A-RUSS', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'A-SG', title: 'Sam Gilroy', meta: 'Gerdis' },
            { num: 'A-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'A-SPYB', title: 'David W. Collins', meta: 'Spybot' },
            { num: 'A-ST', title: 'Sophie Thatcher', meta: 'Drash' },
            { num: 'A-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'A-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'A-TR', title: 'Tim Rose', meta: 'Admiral Ackbar' },
            { num: 'A-VAN', title: 'Vanessa Marshall', meta: 'Rook Kast' },
            { num: 'A-VEE', title: 'Jimmy Vee', meta: 'R2-D2' },
            { num: 'A-VS', title: 'Varada Sethu', meta: 'Cinta Kaz' },
            { num: 'A-WC', title: 'Wes Chatham', meta: 'Captain Enoch' },
            { num: 'A-WIT', title: 'Sam Witwer', meta: 'Maul' },
            { num: 'A-XB', title: 'Xander Berkeley', meta: 'Captain Gilad Pellaeon' },
            { num: 'A-AE', title: 'Ashley Eckstein', meta: 'Ahsoka Tano' },
            { num: 'A-ALAW', title: 'Amanda Lawrence', meta: 'Commander D\'acy' },
            { num: 'A-ALD', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'A-AMY', title: 'Amy Sedaris', meta: 'Peli Motto' },
            { num: 'A-ANP', title: 'Angelique Perrin', meta: 'Adi Gallia' },
            { num: 'A-BAKE', title: 'Tom Baker', meta: 'Bendu' },
            { num: 'A-BDT', title: 'Benicio del Toro', meta: 'DJ' },
            { num: 'A-BRU', title: 'Bruce Spence', meta: 'Tion Medon' },
            { num: 'A-BVE', title: 'Brian Vernel', meta: 'Bala-Tik' },
            { num: 'A-CB', title: 'Clancy Brown', meta: 'Ryder Azadi' },
            { num: 'A-CBL', title: 'Claudia Black', meta: 'Klothow' },
            { num: 'A-CSO', title: 'Marton Csokas', meta: 'Poggle the Lesser' },
            { num: 'A-DD', title: 'Dawn Dininger', meta: 'Lieutenant Beyta' },
            { num: 'A-DER', title: 'Laura Dern', meta: 'Amilyn Holdo' },
            { num: 'A-DISK', title: 'Ben Diskin', meta: 'AZI-3' },
            { num: 'A-DMO', title: 'Dominic Monaghan', meta: 'Beaumont Kin' },
            { num: 'A-DOY', title: 'David Oyelowo', meta: 'Alexsandr Kallus' },
            { num: 'A-DUS', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'A-ERI', title: 'Cynthia Erivo', meta: 'Jedi Master Kratu' },
            { num: 'A-FON', title: 'Gabriel Fonseca', meta: 'Duke Kayo Organa' },
            { num: 'A-FSH', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'A-GG', title: 'Greg Grunberg', meta: 'Snap Wexley' },
            { num: 'A-GTA', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'A-GTO', title: 'Gina Torres', meta: 'Ketsu Onyo' },
            { num: 'A-HQU', title: 'Hugh Quarshie', meta: 'Captain Panaka' },
            { num: 'A-JAKEL', title: 'Jake Lloyd', meta: 'Anakin Skywalker' },
            { num: 'A-JSP', title: 'Jason Spisak', meta: 'Lux Bonteri' },
            { num: 'A-KATK', title: 'Katy Kartwheel', meta: 'Rio Durant' },
            { num: 'A-KKN', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'A-LBO', title: 'Lee Boardman', meta: 'Kravas Drezzer' },
            { num: 'A-LL', title: 'Lucy Liu', meta: 'Bandit Leader' },
            { num: 'A-MOS', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'A-PEGG', title: 'Simon Pegg', meta: 'Unkar Plutt' },
            { num: 'A-PM', title: 'Peter Mayhew', meta: 'Chewbacca' },
            { num: 'A-ROD', title: 'Al Rodrigo', meta: 'Quinlan Vos' },
            { num: 'A-RON', title: 'Ron Howard', meta: 'Solo: A Star Wars Story' },
            { num: 'A-ROP', title: 'Ron Perlman', meta: 'Gha Nachkt' },
            { num: 'A-RUP', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'A-SEB', title: 'Sebastian Armesto', meta: 'Lieutenant Mitaka' },
            { num: 'A-SMG', title: 'Sarah Michelle Gellar', meta: 'Seventh Sister' },
            { num: 'A-SPIN', title: 'Brent Spiner', meta: 'Gall Trayvis' },
            { num: 'A-TAT', title: 'Fred Tatasciore', meta: 'Captain Brutus' },
            { num: 'A-TKA', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'A-TNEW', title: 'Thandiwe Newton', meta: 'Val' },
            { num: 'A-TVAL', title: 'Tasia Valenza', meta: 'Shaak Ti' },
            { num: 'A-VR', title: 'Vinette Robinson', meta: 'Wrobie Tyce' },
            { num: 'A-WANDA', title: 'Wanda Sykes', meta: 'Phee Genoa' },
            { num: 'A-WER', title: 'Werner Herzog', meta: 'The Client' },
          ]
        },
        {
          count: 14,
          name: 'ANDOR SEASON 2 AUTOGRAPH PARALLEL',
          meta: 'The Andor cast on the Season 2 design',
          parallels: 7,
          cards: [
            { num: 'A2A-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'A2A-AL', title: 'Anton Lesser', meta: 'Major Partagaz' },
            { num: 'A2A-ALAN', title: 'Alan Tudyk', meta: 'K-2SO' },
            { num: 'A2A-BEN', title: 'Ben Miles', meta: 'Tay Kolma' },
            { num: 'A2A-DG', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'A2A-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'A2A-ED', title: 'Elizabeth Dulau', meta: 'Kleya Marki' },
            { num: 'A2A-FWT', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'A2A-GEN', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'A2A-JJ', title: 'Joshua James', meta: 'Dr. Gorst' },
            { num: 'A2A-JS', title: 'Joplin Sibtain', meta: 'Brasso' },
            { num: 'A2A-KS', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'A2A-MBH', title: 'Muhannad Bhaier', meta: 'Wilmon Paak' },
            { num: 'A2A-SKAR', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
          ]
        },
        {
          count: 4,
          name: 'THE MANDALORIAN AND GROGU AUTOGRAPH PARALLEL',
          meta: 'Signers from the 2026 film',
          parallels: 7,
          cards: [
            { num: 'MAGR-MAN', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'MAGR-ZEB', title: 'Steve Blum', meta: 'Zeb Orrelios' },
            { num: 'MAGR-GAT', title: 'Stephen McKinley Henderson', meta: 'Gatori' },
            { num: 'MAGR-JAN', title: 'Jonny Coyne', meta: 'Lord Janu' },
          ]
        },
        {
          count: 5,
          name: 'VISIONS SEASON 3 AUTOGRAPH PARALLEL',
          meta: 'The voice cast of Visions Season 3',
          parallels: 7,
          cards: [
            { num: 'V3A-KF', title: 'Karen Fukuhara', meta: 'F' },
            { num: 'V3A-LK', title: 'Liam Karlson', meta: 'Yuko' },
            { num: 'V3A-SH', title: 'Stephanie Hsu', meta: 'Crane' },
            { num: 'V3A-SL', title: 'Simu Liu', meta: 'Lah Zhima' },
            { num: 'V3A-SN', title: 'Suzy Nakamura', meta: 'Anée-San' },
          ]
        },
        {
          count: 22,
          name: 'DUO AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'DUO-66', title: 'Temuera Morrison / Ian McDiarmid', meta: 'Clone Commander Cody / Darth Sidious' },
            { num: 'DUO-AD', title: 'Diego Luna / Alan Tudyk', meta: 'Cassian Andor / K-2SO' },
            { num: 'DUO-AJ', title: 'Alden Ehrenreich / Joonas Suotamo', meta: 'Han Solo / Chewbacca' },
            { num: 'DUO-BD', title: 'Daisy Ridley / Billy Dee Williams', meta: 'Rey / Lando Calrissian' },
            { num: 'DUO-BG', title: 'Gwendoline Christie / Benicio del Toro', meta: 'Captain Phasma / DJ' },
            { num: 'DUO-DP', title: 'Peter Mayhew / David Prowse', meta: 'Chewbacca / Darth Vader' },
            { num: 'DUO-DROIDS', title: 'Anthony Daniels / Jimmy Vee', meta: 'C-3PO / R2-D2' },
            { num: 'DUO-DS', title: 'Denise Gough / Stellan Skarsgård', meta: 'Dedra Meero / Luthen Rael' },
            { num: 'DUO-FETT', title: 'Temuera Morrison / Daniel Logan', meta: 'Jango Fett / Boba Fett' },
            { num: 'DUO-FG', title: 'Felicity Jones / Genevieve O\'Reilly', meta: 'Jyn Erso / Mon Mothma' },
            { num: 'DUO-HE', title: 'Hayden Christensen / Ewan McGregor', meta: 'Darth Vader / Obi-Wan Kenobi' },
            { num: 'DUO-JAKKU', title: 'Daisy Ridley / Simon Pegg', meta: 'Rey / Unkar Plutt' },
            { num: 'DUO-JH', title: 'Jeremy Bulloch / Harrison Ford', meta: 'Boba Fett / Han Solo' },
            { num: 'DUO-JM', title: 'Jennifer Beals / Ming-Na Wen', meta: 'Garsa Fwip / Fennec Shand' },
            { num: 'DUO-JN', title: 'Jake Lloyd / Natalie Portman', meta: 'Anakin Skywalker / Padmé Amidala' },
            { num: 'DUO-KI', title: 'Keira Knightley / Ian McDiarmid', meta: 'Sabé / Senator Palpatine' },
            { num: 'DUO-LM', title: 'Lee Jung-jae / Manny Jacinto', meta: 'Jedi Master Sol / The Stranger' },
            { num: 'DUO-NA', title: 'Natalie Portman / Anthony Daniels', meta: 'Padmé Amidala / C-3PO' },
            { num: 'DUO-SE', title: 'Elizabeth Dulau / Stellan Skarsgård', meta: 'Kleya Marki / Luthen Rael' },
            { num: 'DUO-SI', title: 'Ian McDiarmid / Samuel L. Jackson', meta: 'Supreme Chancellor Palpatine / Mace Windu' },
            { num: 'DUO-SOLO', title: 'Adam Driver / Harrison Ford', meta: 'Kylo Ren / Han Solo' },
            { num: 'DUO-TG', title: 'Taika Waititi / Giancarlo Esposito', meta: 'IG-11 / Moff Gideon' },
          ]
        },
        {
          count: 19,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer',
          parallels: 2,
          cards: [
            { num: 'TRIP-DAK', title: 'Anton Lesser / Kyle Soller / Denise Gough', meta: 'Major Partagaz / Syril Karn / Dedra Meero' },
            { num: 'TRIP-DEG', title: 'Diego Luna / Elizabeth Dulau / Genevieve O\'Reilly', meta: 'Cassian Andor / Kleya Marki / Mon Mothma' },
            { num: 'TRIP-DFT', title: 'Dee Bradley Baker / Taylor Gray / Freddie Prinze Jr.', meta: 'Rex / Ezra Bridger / Kanan Jarrus' },
            { num: 'TRIP-DJJ', title: 'Daisy Ridley / Joonas Suotamo / Jimmy Vee', meta: 'Rey / Chewbacca / R2-D2' },
            { num: 'TRIP-DKK', title: 'Kyle Soller / Kathryn Hunter / Denise Gough', meta: 'Syril Karn / Eedy Karn / Dedra Meero' },
            { num: 'TRIP-EAP', title: 'Alden Ehrenreich / Emilia Clarke / Paul Bettany', meta: 'Han Solo / Qi\'ra / Dryden Vos' },
            { num: 'TRIP-GAB', title: 'Bronte Carmichael / Genevieve O\'Reilly / Alastair Mackenzie', meta: 'Leida Mothma / Mon Mothma / Perrin Fertha' },
            { num: 'TRIP-GAM', title: 'Mary Elizabeth Winstead / Genevieve O\'Reilly / Anthony Daniels', meta: 'Hera Syndulla / Mon Mothma / C-3PO' },
            { num: 'TRIP-IRN', title: 'Ian McDiarmid / Ray Park / Natalie Portman', meta: 'Darth Sidious / Darth Maul / Padmé Amidala' },
            { num: 'TRIP-KME', title: 'Mercedes Varnado / Katee Sackhoff / Emily Swallow', meta: 'Koska Reeves / Bo-Katan Kryze / The Armorer' },
            { num: 'TRIP-KNJ', title: 'Nick Frost / Jude Law / Kyriana Kratter', meta: 'SM-33 / Jod Na Nawood / KB' },
            { num: 'TRIP-OLK', title: 'Keri Russell / Oscar Isaac / Lynn Robertson Bruce', meta: 'Zorii Bliss / Poe Dameron / D-O' },
            { num: 'TRIP-RDN', title: 'Rosario Dawson / David Tennant / Natasha Liu Bordizzo', meta: 'Ahsoka Tano / Huyang / Sabine Wren' },
            { num: 'TRIP-RFF', title: 'Riz Ahmed / Forest Whitaker / Felicity Jones', meta: 'Bodhi Rook / Saw Gerrera / Jyn Erso' },
            { num: 'TRIP-SDT', title: 'Samuel L. Jackson / Temuera Morrison / Daniel Logan', meta: 'Mace Windu / Jango Fett / Boba Fett' },
            { num: 'TRIP-SKD', title: 'Shirley Henderson / Keri Russell / Dave Chapman', meta: 'Babu Frik / Zorii Bliss / BB-8' },
            { num: 'TRIP-SLD', title: 'Dave Chapman / Lynn Robertson Bruce / Shirley Henderson', meta: 'BB-8 / D-O / Babu Frik' },
            { num: 'TRIP-SMC', title: 'Sophie Thatcher / Carey Jones / Ming-Na Wen', meta: 'Drash / Krrsantan / Fennec Shand' },
            { num: 'TRIP-YAVIN', title: 'Mark Hamill / Harrison Ford / Peter Mayhew', meta: 'Luke Skywalker / Han Solo / Chewbacca' },
          ]
        }
      ],
      sketch: [
        {
          count: 173,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches · Silver, Gold & Black Foil 1/1s',
          oneOfOne: true,
          parallels: 3,
          cards: [
            { num: '1', title: 'Sketch Card', meta: 'Aaron Laurich' },
            { num: '2', title: 'Sketch Card', meta: 'Adam Beck' },
            { num: '3', title: 'Sketch Card', meta: 'Adam D. Perler' },
            { num: '4', title: 'Sketch Card', meta: 'Alexander McCormick' },
            { num: '5', title: 'Sketch Card', meta: 'Allen Geneta' },
            { num: '6', title: 'Sketch Card', meta: 'Allen Grimes' },
            { num: '7', title: 'Sketch Card', meta: 'Andrew Fry' },
            { num: '8', title: 'Sketch Card', meta: 'Andy Tiu' },
            { num: '9', title: 'Sketch Card', meta: 'Anthony Pietszak' },
            { num: '10', title: 'Sketch Card', meta: 'Anthony Richichi' },
            { num: '11', title: 'Sketch Card', meta: 'Antni Ellison' },
            { num: '12', title: 'Sketch Card', meta: 'Arlene' },
            { num: '13', title: 'Sketch Card', meta: 'Ash' },
            { num: '14', title: 'Sketch Card', meta: 'Basak Kahraman' },
            { num: '15', title: 'Sketch Card', meta: 'Ben AbuSaada' },
            { num: '16', title: 'Sketch Card', meta: 'Benjamin Lombart' },
            { num: '17', title: 'Sketch Card', meta: 'Bernardo Oliveira' },
            { num: '18', title: 'Sketch Card', meta: 'Bistek Javier' },
            { num: '19', title: 'Sketch Card', meta: 'Bnfer' },
            { num: '20', title: 'Sketch Card', meta: 'Bobby Blakey' },
            { num: '21', title: 'Sketch Card', meta: 'Brandon Klein' },
            { num: '22', title: 'Sketch Card', meta: 'Bruce Gerlach' },
            { num: '23', title: 'Sketch Card', meta: 'C. Deakes' },
            { num: '24', title: 'Sketch Card', meta: 'Candice Clemmons' },
            { num: '25', title: 'Sketch Card', meta: 'Carlo Allen Victoria' },
            { num: '26', title: 'Sketch Card', meta: 'Carrie Craggs' },
            { num: '27', title: 'Sketch Card', meta: 'Charlie Cody' },
            { num: '28', title: 'Sketch Card', meta: 'Chenduz' },
            { num: '29', title: 'Sketch Card', meta: 'Chris Colyer' },
            { num: '30', title: 'Sketch Card', meta: 'Chris Meeks' },
            { num: '31', title: 'Sketch Card', meta: 'Chris Timola' },
            { num: '32', title: 'Sketch Card', meta: 'Christoffer Allen Victoria' },
            { num: '33', title: 'Sketch Card', meta: 'Court' },
            { num: '34', title: 'Sketch Card', meta: 'Cyrus Sherkat' },
            { num: '35', title: 'Sketch Card', meta: 'Dan Bergren' },
            { num: '36', title: 'Sketch Card', meta: 'Dan Cooney' },
            { num: '37', title: 'Sketch Card', meta: 'Dan Curto' },
            { num: '38', title: 'Sketch Card', meta: 'Dan Gorman' },
            { num: '39', title: 'Sketch Card', meta: 'Dan Lawler' },
            { num: '40', title: 'Sketch Card', meta: 'Daniel Riveron' },
            { num: '41', title: 'Sketch Card', meta: 'Darrin Pepe' },
            { num: '42', title: 'Sketch Card', meta: 'David Willingham' },
            { num: '43', title: 'Sketch Card', meta: 'Dawn Murphy' },
            { num: '44', title: 'Sketch Card', meta: 'Débora Centeio' },
            { num: '45', title: 'Sketch Card', meta: 'Dwayne Carpenter' },
            { num: '46', title: 'Sketch Card', meta: 'DYJ' },
            { num: '47', title: 'Sketch Card', meta: 'Dylan Riley' },
            { num: '48', title: 'Sketch Card', meta: 'El Smetchö' },
            { num: '49', title: 'Sketch Card', meta: 'Elvin A Hernandez' },
            { num: '50', title: 'Sketch Card', meta: 'Enso Solo' },
            { num: '51', title: 'Sketch Card', meta: 'Eric Lehtonen' },
            { num: '52', title: 'Sketch Card', meta: 'Erik Maell' },
            { num: '53', title: 'Sketch Card', meta: 'Erik Muller' },
            { num: '54', title: 'Sketch Card', meta: 'Frank A. Kadar' },
            { num: '55', title: 'Sketch Card', meta: 'Gabe Rogue' },
            { num: '56', title: 'Sketch Card', meta: 'Gary Shipman' },
            { num: '57', title: 'Sketch Card', meta: 'Gawanimayk' },
            { num: '58', title: 'Sketch Card', meta: 'George Joseph' },
            { num: '59', title: 'Sketch Card', meta: 'Gerry Garcia Jr' },
            { num: '60', title: 'Sketch Card', meta: 'Getatom' },
            { num: '61', title: 'Sketch Card', meta: 'Ghoulie Julie' },
            { num: '62', title: 'Sketch Card', meta: 'Grace Riley' },
            { num: '63', title: 'Sketch Card', meta: 'Greg Treize' },
            { num: '64', title: 'Sketch Card', meta: 'Guilherme Rocha' },
            { num: '65', title: 'Sketch Card', meta: 'Henrique Pirote' },
            { num: '66', title: 'Sketch Card', meta: 'Ian McKesson' },
            { num: '67', title: 'Sketch Card', meta: 'Ian Yoshio Roberts' },
            { num: '68', title: 'Sketch Card', meta: 'Isiah Xavier Bradley' },
            { num: '69', title: 'Sketch Card', meta: 'Jaime Lopez' },
            { num: '70', title: 'Sketch Card', meta: 'James Boyd' },
            { num: '71', title: 'Sketch Card', meta: 'James Harris' },
            { num: '72', title: 'Sketch Card', meta: 'Jamie Richards' },
            { num: '73', title: 'Sketch Card', meta: 'Jane Rushton' },
            { num: '74', title: 'Sketch Card', meta: 'Jason Christner' },
            { num: '75', title: 'Sketch Card', meta: 'Jason Queen' },
            { num: '76', title: 'Sketch Card', meta: 'Jason Saldajeno' },
            { num: '77', title: 'Sketch Card', meta: 'Jason Sobol' },
            { num: '78', title: 'Sketch Card', meta: 'Jay Manchand' },
            { num: '79', title: 'Sketch Card', meta: 'Jeff Ward' },
            { num: '80', title: 'Sketch Card', meta: 'Jeffrey C. Benitez' },
            { num: '81', title: 'Sketch Card', meta: 'Jenn DePaola' },
            { num: '82', title: 'Sketch Card', meta: 'Jenny Kim' },
            { num: '83', title: 'Sketch Card', meta: 'Jessica Hickman' },
            { num: '84', title: 'Sketch Card', meta: 'Jessica Van Dusen' },
            { num: '85', title: 'Sketch Card', meta: 'Jesus' },
            { num: '86', title: 'Sketch Card', meta: 'Jiaxin "YinShan" Sun' },
            { num: '87', title: 'Sketch Card', meta: 'Jim O\'Riley' },
            { num: '88', title: 'Sketch Card', meta: 'Jodie Rae Charity' },
            { num: '89', title: 'Sketch Card', meta: 'Joey Mason' },
            { num: '90', title: 'Sketch Card', meta: 'John "JAR" Rodriguez' },
            { num: '91', title: 'Sketch Card', meta: 'John Boren' },
            { num: '92', title: 'Sketch Card', meta: 'John Pleak' },
            { num: '93', title: 'Sketch Card', meta: 'John Still' },
            { num: '94', title: 'Sketch Card', meta: 'Jojo Hilario' },
            { num: '95', title: 'Sketch Card', meta: 'Jon Mangini' },
            { num: '96', title: 'Sketch Card', meta: 'Josh Rosland' },
            { num: '97', title: 'Sketch Card', meta: 'Josh Trout' },
            { num: '98', title: 'Sketch Card', meta: 'Joshua Whitten' },
            { num: '99', title: 'Sketch Card', meta: 'Julia McKenzie' },
            { num: '100', title: 'Sketch Card', meta: 'Jun Diaz' },
            { num: '101', title: 'Sketch Card', meta: 'Jungle' },
            { num: '102', title: 'Sketch Card', meta: 'Kang Jing' },
            { num: '103', title: 'Sketch Card', meta: 'Karl Jones' },
            { num: '104', title: 'Sketch Card', meta: 'Kevin Scott Jacobs' },
            { num: '105', title: 'Sketch Card', meta: 'Khloe Delnick' },
            { num: '106', title: 'Sketch Card', meta: 'Kris Penix' },
            { num: '107', title: 'Sketch Card', meta: 'Laura Inglis' },
            { num: '108', title: 'Sketch Card', meta: 'Layton Scarbrough' },
            { num: '109', title: 'Sketch Card', meta: 'Lee Lightfoot' },
            { num: '110', title: 'Sketch Card', meta: 'Leon Braojos' },
            { num: '111', title: 'Sketch Card', meta: 'LH (Lisa Hall)' },
            { num: '112', title: 'Sketch Card', meta: 'Limuel Pinzon' },
            { num: '113', title: 'Sketch Card', meta: 'Louise Draper' },
            { num: '114', title: 'Sketch Card', meta: 'Luke Rushton LR' },
            { num: '115', title: 'Sketch Card', meta: 'Marcia Dye' },
            { num: '116', title: 'Sketch Card', meta: 'Marlo Martos' },
            { num: '117', title: 'Sketch Card', meta: 'Matt Stewart' },
            { num: '118', title: 'Sketch Card', meta: 'Matthew Maldonado' },
            { num: '119', title: 'Sketch Card', meta: 'Matthew Skillern' },
            { num: '120', title: 'Sketch Card', meta: 'Michael Mastermaker' },
            { num: '121', title: 'Sketch Card', meta: 'Michael W. Foreman II' },
            { num: '122', title: 'Sketch Card', meta: 'Michelle Rayner' },
            { num: '123', title: 'Sketch Card', meta: 'Nadz' },
            { num: '124', title: 'Sketch Card', meta: 'Neil A Brady' },
            { num: '125', title: 'Sketch Card', meta: 'Neil Camera' },
            { num: '126', title: 'Sketch Card', meta: 'Nick Gribbon' },
            { num: '127', title: 'Sketch Card', meta: 'Niño John Benitez' },
            { num: '128', title: 'Sketch Card', meta: 'Oscar Chavez' },
            { num: '129', title: 'Sketch Card', meta: 'Patricio Carrasco' },
            { num: '130', title: 'Sketch Card', meta: 'Patrick Giles' },
            { num: '131', title: 'Sketch Card', meta: 'Paul Williams' },
            { num: '132', title: 'Sketch Card', meta: 'Phil Hassewer' },
            { num: '133', title: 'Sketch Card', meta: 'Phillip Trujillo' },
            { num: '134', title: 'Sketch Card', meta: 'R. Goto' },
            { num: '135', title: 'Sketch Card', meta: 'Randy Siplon' },
            { num: '136', title: 'Sketch Card', meta: 'Rebeca Louro' },
            { num: '137', title: 'Sketch Card', meta: 'Rees Chua-Finlay' },
            { num: '138', title: 'Sketch Card', meta: 'Rich Hennemann' },
            { num: '139', title: 'Sketch Card', meta: 'Rico Dela Rosa' },
            { num: '140', title: 'Sketch Card', meta: 'Robert Hendrickson' },
            { num: '141', title: 'Sketch Card', meta: 'Ross' },
            { num: '142', title: 'Sketch Card', meta: 'Rustico Limosinero' },
            { num: '143', title: 'Sketch Card', meta: 'Rusty!' },
            { num: '144', title: 'Sketch Card', meta: 'Rutvig Vaid' },
            { num: '145', title: 'Sketch Card', meta: 'Ryan Edwards' },
            { num: '146', title: 'Sketch Card', meta: 'Ryan Finley' },
            { num: '147', title: 'Sketch Card', meta: 'Ryan Johnston' },
            { num: '148', title: 'Sketch Card', meta: 'Ryan Olsen' },
            { num: '149', title: 'Sketch Card', meta: 'Ryan Thompson' },
            { num: '150', title: 'Sketch Card', meta: 'Sammy Gomez' },
            { num: '151', title: 'Sketch Card', meta: 'Sandy Meeks' },
            { num: '152', title: 'Sketch Card', meta: 'Scott Hattox' },
            { num: '153', title: 'Sketch Card', meta: 'Scribbling Joe' },
            { num: '154', title: 'Sketch Card', meta: 'Semra Bulut' },
            { num: '155', title: 'Sketch Card', meta: 'Shane McCormack' },
            { num: '156', title: 'Sketch Card', meta: 'Shaow Siong' },
            { num: '157', title: 'Sketch Card', meta: 'Snorpixel' },
            { num: '158', title: 'Sketch Card', meta: 'Stephane Leonardi' },
            { num: '159', title: 'Sketch Card', meta: 'Steve Alce' },
            { num: '160', title: 'Sketch Card', meta: 'Steven Smith' },
            { num: '161', title: 'Sketch Card', meta: 'Ted Dastick Jr' },
            { num: '162', title: 'Sketch Card', meta: 'Tim Shinn' },
            { num: '163', title: 'Sketch Card', meta: 'Tom Amici' },
            { num: '164', title: 'Sketch Card', meta: 'TOMA' },
            { num: '165', title: 'Sketch Card', meta: 'Tomoko Taniguchi' },
            { num: '166', title: 'Sketch Card', meta: 'Tony Riley' },
            { num: '167', title: 'Sketch Card', meta: 'Trent Westbrook' },
            { num: '168', title: 'Sketch Card', meta: 'Tyler Newcomb' },
            { num: '169', title: 'Sketch Card', meta: 'Veronica Louro' },
            { num: '170', title: 'Sketch Card', meta: 'Ward Silverman' },
            { num: '171', title: 'Sketch Card', meta: 'William ROGER' },
            { num: '172', title: 'Sketch Card', meta: 'Zach Woolsey' },
            { num: '173', title: 'Sketch Card', meta: 'ジェイソン (Jason)' },
          ]
        }
      ],
    },
  },
  '2025-chrome': {
    setId: '2025-chrome',
    year: '2025',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS',
    releaseDate: '8 / 20 / 2025',
    lede: 'The third flagship Chrome Star Wars and the deepest checklist of the line: a 200-card base set — 65 of them first appearances stamped with the Debut Medallion, with The Acolyte and Skeleton Crew joining the fold — a 21-parallel rainbow, full-checklist Hothfractor and Aurebesh short prints, printing-plate book cards, twelve insert lines, a 195-card autograph program across four tiers, and a 188-artist sketch program.',
    stats: [
      { num: '200', label: 'Base Cards', sub: '65 Debut Medallions', color: 'gold' },
      { num: '12', label: 'Insert Sets', sub: '5 to 50 cards each', color: 'cyan' },
      { num: '195', label: 'Auto Cards', sub: '4 signature tiers', color: 'green' },
      { num: '21', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '21', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '10', l: 'Packs per box' },
      { v: '10', l: 'Cards per pack' },
      { v: '8', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
      { v: '4', l: 'Serial-numbered hits / box' },
    ],
    pullRates: [
      { name: 'Skeleton Crew', odds: '1 : 3', tier: 'normal' },
      { name: 'Acolyte', odds: '1 : 6', tier: 'normal' },
      { name: 'Outer World Oddities', odds: '1 : 6', tier: 'normal' },
      { name: 'Galactic Graffiti', odds: '1 : 40', tier: 'rare' },
      { name: 'Sketch Cards', odds: '1 : 84', tier: 'rare' },
      { name: '1975 Tribute', odds: '1 : 119', tier: 'rare' },
      { name: 'Reflections', odds: '1 : 400', tier: 'mythic' },
      { name: 'Comicfractor', odds: '1 : 400', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'RAINBOW', pr: '∞', gradient: 'linear-gradient(135deg, #ffb3ba 0%, #ffdfba 25%, #baffc9 50%, #bae1ff 75%, #e3baff 100%)', darkText: true },
      { name: 'PRISM', pr: '∞', gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'BLACK & WHITE SHIMMER', pr: '∞', gradient: 'linear-gradient(135deg, #f8f8f8 0%, #b0b0b0 50%, #e0e0e0 100%)', darkText: true },
      { name: 'RAYWAVE', pr: '∞', gradient: 'linear-gradient(135deg, #6cef4d 0%, #2fae2f 60%, #a0ff80 100%)', darkText: true },
      { name: 'BLUE PULSAR', pr: '∞', gradient: 'radial-gradient(circle at 50% 50%, #80b0ff 0%, #2050d0 70%)' },
      { name: 'PURPLE PULSAR', pr: '∞', gradient: 'radial-gradient(circle at 50% 50%, #d0a0ff 0%, #7020c0 70%)' },
      { name: 'KAMINO PURPLE', pr: '/199', gradient: 'linear-gradient(135deg, #bb8ce4 0%, #7a4bb0 100%)' },
      { name: 'SKYWALKER BLUE', pr: '/150', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'KASHYYYK GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'GOLD MINI DIAMONDS', pr: '/50', gradient: 'repeating-linear-gradient(45deg, #f0c040 0 4px, #ffe080 4px 8px)', darkText: true },
      { name: 'ORANGE PULSAR', pr: '/25', gradient: 'radial-gradient(circle at 50% 50%, #ffc080 0%, #e06000 70%)' },
      { name: 'REBEL ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'REBEL ORANGE WAVE', pr: '/25', gradient: 'linear-gradient(135deg, #ffb072 0%, #ff8800 50%, #ffcf9f 100%)', darkText: true },
      { name: 'BLACK PULSAR', pr: '/10', gradient: 'radial-gradient(circle at 50% 50%, #4a4a5a 0%, #0a0a12 70%)' },
      { name: 'MUSTAFAR BLACK', pr: '/10', gradient: 'linear-gradient(135deg, #2a2a2a 0%, #0a0a0a 100%)' },
      { name: 'MUSTAFAR BLACK LAVA', pr: '/10', gradient: 'linear-gradient(135deg, #1a1a1a 0%, #4a1000 60%, #ff5020 100%)' },
      { name: 'RED PULSAR', pr: '/5', gradient: 'radial-gradient(circle at 50% 50%, #ff9080 0%, #c01000 70%)' },
      { name: 'DATHOMIR RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'DATHOMIR RED WAVE', pr: '/5', gradient: 'linear-gradient(135deg, #ff9090 0%, #ff3030 50%, #ffb0b0 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 200,
          name: 'BASE SET',
          meta: '65 debuts with Debut Medallions',
          parallels: 21,
          cards: [
            { num: '1', title: 'Admiral Ackbar' },
            { num: '2', title: 'Ahsoka Tano' },
            { num: '3', title: 'Anakin Skywalker' },
            { num: '4', title: 'Arvel Skeen' },
            { num: '5', title: 'Baylan Skoll' },
            { num: '6', title: 'Bazil' },
            { num: '7', title: 'Beru Lars' },
            { num: '8', title: 'Birnok' },
            { num: '9', title: 'Bix Caleen' },
            { num: '10', title: 'Bo-Katan Kryze' },
            { num: '11', title: 'Boba Fett' },
            { num: '12', title: 'Bodhi Rook' },
            { num: '13', title: 'C-3PO' },
            { num: '14', title: 'C1-D1' },
            { num: '15', title: 'Captain Blex' },
            { num: '16', title: 'Captain Elk' },
            { num: '17', title: 'Captain Girard' },
            { num: '18', title: 'Captain Hayle' },
            { num: '19', title: 'Captain Phasma' },
            { num: '20', title: 'Captain Porter' },
            { num: '21', title: 'Captain Silvo' },
            { num: '22', title: 'Cassian Andor' },
            { num: '23', title: 'Chewbacca' },
            { num: '24', title: 'Chirrut Îmwe' },
            { num: '25', title: 'Chopper' },
            { num: '26', title: 'Clone Captain Rex' },
            { num: '27', title: 'Count Dooku' },
            { num: '28', title: 'Darth Maul' },
            { num: '29', title: 'Darth Vader' },
            { num: '30', title: 'Dedra Meero' },
            { num: '31', title: 'Dengar' },
            { num: '32', title: 'Dinghy Driver' },
            { num: '33', title: 'DJ' },
            { num: '34', title: 'Dr. Gorst' },
            { num: '35', title: 'Dryden Vos' },
            { num: '36', title: 'Eedy Karn' },
            { num: '37', title: 'Elder Naasa' },
            { num: '38', title: 'Emperor Palpatine' },
            { num: '39', title: 'Ezra Bridger' },
            { num: '40', title: 'Fara' },
            { num: '41', title: 'Fennec Shand' },
            { num: '42', title: 'Fern' },
            { num: '43', title: 'Fifth Brother Inquisitor' },
            { num: '44', title: 'Fillik' },
            { num: '45', title: 'Finn' },
            { num: '46', title: 'First Officer Jensen Corbyt' },
            { num: '47', title: 'Galen Erso' },
            { num: '48', title: 'Garsa Fwip' },
            { num: '49', title: 'General Grievous' },
            { num: '50', title: 'General Hux' },
            { num: '51', title: 'General Pryde' },
            { num: '52', title: 'Grand Admiral Thrawn' },
            { num: '53', title: 'Grand Moff Tarkin' },
            { num: '54', title: 'Greedo' },
            { num: '55', title: 'Greef Karga' },
            { num: '56', title: 'Grogu' },
            { num: '57', title: 'Gunter' },
            { num: '58', title: 'Han Solo' },
            { num: '59', title: 'Hera Syndulla' },
            { num: '60', title: 'IG-11' },
            { num: '61', title: 'Indara' },
            { num: '62', title: 'Jabba The Hutt' },
            { num: '63', title: 'Jar Jar Binks' },
            { num: '64', title: 'Jecki Lon' },
            { num: '65', title: 'Jod Na Nawood' },
            { num: '66', title: 'Jyn Erso' },
            { num: '67', title: 'K-2SO' },
            { num: '68', title: 'Karis Nemik' },
            { num: '69', title: 'Kassa' },
            { num: '70', title: 'Kawlan Roken' },
            { num: '71', title: 'Kaydel Connix' },
            { num: '72', title: 'Kelleran Beq' },
            { num: '73', title: 'Kelnacca' },
            { num: '74', title: 'Kh\'ymm' },
            { num: '75', title: 'Klothow' },
            { num: '76', title: 'Koska Reeves' },
            { num: '77', title: 'L3-37' },
            { num: '78', title: 'Lando Calrissian' },
            { num: '79', title: 'Lando Calrissian' },
            { num: '80', title: 'Leia Organa' },
            { num: '81', title: 'Logray' },
            { num: '82', title: 'Lor San Tekka' },
            { num: '83', title: 'Luke Skywalker' },
            { num: '84', title: 'Luthen Rael' },
            { num: '85', title: 'Mace Windu' },
            { num: '86', title: 'Mae Aniseya' },
            { num: '87', title: 'Maree' },
            { num: '88', title: 'Master Codebreaker' },
            { num: '89', title: 'Max Rebo' },
            { num: '90', title: 'Maz Kanata' },
            { num: '91', title: 'Moff Gideon' },
            { num: '92', title: 'Mog Adana' },
            { num: '93', title: 'Mon Mothma' },
            { num: '94', title: 'Mother Aniseya' },
            { num: '95', title: 'Mother Koril' },
            { num: '96', title: 'Nol' },
            { num: '97', title: 'Pokkit' },
            { num: '98', title: 'Skull Ridge Mountain Hotelier' },
            { num: '99', title: 'SM-33' },
            { num: '100', title: 'Trash crab' },
            { num: '101', title: '2-1B Droid' },
            { num: '102', title: 'Adi Gallia' },
            { num: '103', title: 'Aemon Gremm' },
            { num: '104', title: 'Bazine Netal' },
            { num: '105', title: 'BB-9E' },
            { num: '106', title: 'Beaumont Kin' },
            { num: '107', title: 'Benjar Pranic' },
            { num: '108', title: 'Bossk' },
            { num: '109', title: 'Brasso' },
            { num: '110', title: 'Cabuck' },
            { num: '111', title: 'Chancellor Drellik' },
            { num: '112', title: 'Chief Chirpa' },
            { num: '113', title: 'Darth Bane' },
            { num: '114', title: 'Dokk Strassi' },
            { num: '115', title: 'Enfys Nest' },
            { num: '116', title: 'Figrin D\'an' },
            { num: '117', title: 'Fuzzball' },
            { num: '118', title: 'Fyrnock' },
            { num: '119', title: 'General Pong Krell' },
            { num: '120', title: 'General Strix' },
            { num: '121', title: 'Glerb' },
            { num: '122', title: 'Hayna' },
            { num: '123', title: 'Hondo Ohnaka' },
            { num: '124', title: 'IG-88' },
            { num: '125', title: 'Jawa' },
            { num: '126', title: 'Jess Pava' },
            { num: '127', title: 'Kayo Organa' },
            { num: '128', title: 'KB' },
            { num: '129', title: 'Kona' },
            { num: '130', title: 'Kragan Gorr' },
            { num: '131', title: 'Lobot' },
            { num: '132', title: 'Lortha Peel' },
            { num: '133', title: 'Mas Amedda' },
            { num: '134', title: 'Mayor Mok Shaiz' },
            { num: '135', title: 'Melna' },
            { num: '136', title: 'Mother Talzin' },
            { num: '137', title: 'Neel' },
            { num: '138', title: 'Obi-Wan Kenobi' },
            { num: '139', title: 'Obi-Wan Kenobi' },
            { num: '140', title: 'Osha Aniseya' },
            { num: '141', title: 'Padmé Amidala' },
            { num: '142', title: 'Pegla' },
            { num: '143', title: 'Pip' },
            { num: '144', title: 'Pirate Captain Brutus' },
            { num: '145', title: 'Poe Dameron' },
            { num: '146', title: 'Poggle the Lesser' },
            { num: '147', title: 'Porg' },
            { num: '148', title: 'Professor Huyang' },
            { num: '149', title: 'Pyke Boss' },
            { num: '150', title: 'Qi\'ra' },
            { num: '151', title: 'Queen Apailana' },
            { num: '152', title: 'Qui-Gon Jinn' },
            { num: '153', title: 'R2-D2' },
            { num: '154', title: 'Ragnar Vizsla' },
            { num: '155', title: 'Rey' },
            { num: '156', title: 'Rio Durant' },
            { num: '157', title: 'Roona' },
            { num: '158', title: 'Rose Tico' },
            { num: '159', title: 'Sabé' },
            { num: '160', title: 'Sabine Wren' },
            { num: '161', title: 'Safety Droid' },
            { num: '162', title: 'Savage Opress' },
            { num: '163', title: 'Senator Rayencourt' },
            { num: '164', title: 'Sergeant Linus Mosk' },
            { num: '165', title: 'Shaak Ti' },
            { num: '166', title: 'Shin Hati' },
            { num: '167', title: 'Skura' },
            { num: '168', title: 'Slowen Lo' },
            { num: '169', title: 'Sly Moore' },
            { num: '170', title: 'Snowball' },
            { num: '171', title: 'Sol' },
            { num: '172', title: 'Sully Stark' },
            { num: '173', title: 'Supreme Leader Kylo Ren' },
            { num: '174', title: 'Supreme Leader Snoke' },
            { num: '175', title: 'Tasi Lowa' },
            { num: '176', title: 'Teacher Droid' },
            { num: '177', title: 'Tera Sinube' },
            { num: '178', title: 'The Armorer' },
            { num: '179', title: 'The Client' },
            { num: '180', title: 'The Grand Inquisitor' },
            { num: '181', title: 'The Mandalorian' },
            { num: '182', title: 'The Stranger' },
            { num: '183', title: 'Tion Medon' },
            { num: '184', title: 'Tobias Beckett' },
            { num: '185', title: 'Torbin' },
            { num: '186', title: 'Unkar Plutt' },
            { num: '187', title: 'Val' },
            { num: '188', title: 'Vernestra Rwoh' },
            { num: '189', title: 'Vetch' },
            { num: '190', title: 'Watto' },
            { num: '191', title: 'Wendle' },
            { num: '192', title: 'Wilmon Paak' },
            { num: '193', title: 'Wim' },
            { num: '194', title: 'Wullf Yularen' },
            { num: '195', title: 'Xanwan' },
            { num: '196', title: 'Yarael Poof' },
            { num: '197', title: 'Yoda' },
            { num: '198', title: 'Yord Fandar' },
            { num: '199', title: 'Zam Wesell' },
            { num: '200', title: 'Zorii Bliss' },
          ]
        },
        {
          count: 200,
          name: 'HOTHFRACTOR SHORT PRINTS',
          meta: 'Full 200-card icy short-print mirror',
          parallels: 1,
          cards: [
            { num: 'HF-1', title: 'Admiral Ackbar' },
            { num: 'HF-2', title: 'Ahsoka Tano' },
            { num: 'HF-3', title: 'Anakin Skywalker' },
            { num: 'HF-4', title: 'Arvel Skeen' },
            { num: 'HF-5', title: 'Baylan Skoll' },
            { num: 'HF-6', title: 'Bazil' },
            { num: 'HF-7', title: 'Beru Lars' },
            { num: 'HF-8', title: 'Birnok' },
            { num: 'HF-9', title: 'Bix Caleen' },
            { num: 'HF-10', title: 'Bo-Katan Kryze' },
            { num: 'HF-11', title: 'Boba Fett' },
            { num: 'HF-12', title: 'Bodhi Rook' },
            { num: 'HF-13', title: 'C-3PO' },
            { num: 'HF-14', title: 'C1-D1' },
            { num: 'HF-15', title: 'Captain Blex' },
            { num: 'HF-16', title: 'Captain Elk' },
            { num: 'HF-17', title: 'Captain Girard' },
            { num: 'HF-18', title: 'Captain Hayle' },
            { num: 'HF-19', title: 'Captain Phasma' },
            { num: 'HF-20', title: 'Captain Porter' },
            { num: 'HF-21', title: 'Captain Silvo' },
            { num: 'HF-22', title: 'Cassian Andor' },
            { num: 'HF-23', title: 'Chewbacca' },
            { num: 'HF-24', title: 'Chirrut Îmwe' },
            { num: 'HF-25', title: 'Chopper' },
            { num: 'HF-26', title: 'Clone Captain Rex' },
            { num: 'HF-27', title: 'Count Dooku' },
            { num: 'HF-28', title: 'Darth Maul' },
            { num: 'HF-29', title: 'Darth Vader' },
            { num: 'HF-30', title: 'Dedra Meero' },
            { num: 'HF-31', title: 'Dengar' },
            { num: 'HF-32', title: 'Dinghy Driver' },
            { num: 'HF-33', title: 'DJ' },
            { num: 'HF-34', title: 'Dr. Gorst' },
            { num: 'HF-35', title: 'Dryden Vos' },
            { num: 'HF-36', title: 'Eedy Karn' },
            { num: 'HF-37', title: 'Elder Naasa' },
            { num: 'HF-38', title: 'Emperor Palpatine' },
            { num: 'HF-39', title: 'Ezra Bridger' },
            { num: 'HF-40', title: 'Fara' },
            { num: 'HF-41', title: 'Fennec Shand' },
            { num: 'HF-42', title: 'Fern' },
            { num: 'HF-43', title: 'Fifth Brother Inquisitor' },
            { num: 'HF-44', title: 'Fillik' },
            { num: 'HF-45', title: 'Finn' },
            { num: 'HF-46', title: 'First Officer Jensen Corbyt' },
            { num: 'HF-47', title: 'Galen Erso' },
            { num: 'HF-48', title: 'Garsa Fwip' },
            { num: 'HF-49', title: 'General Grievous' },
            { num: 'HF-50', title: 'General Hux' },
            { num: 'HF-51', title: 'General Pryde' },
            { num: 'HF-52', title: 'Grand Admiral Thrawn' },
            { num: 'HF-53', title: 'Grand Moff Tarkin' },
            { num: 'HF-54', title: 'Greedo' },
            { num: 'HF-55', title: 'Greef Karga' },
            { num: 'HF-56', title: 'Grogu' },
            { num: 'HF-57', title: 'Gunter' },
            { num: 'HF-58', title: 'Han Solo' },
            { num: 'HF-59', title: 'Hera Syndulla' },
            { num: 'HF-60', title: 'IG-11' },
            { num: 'HF-61', title: 'Indara' },
            { num: 'HF-62', title: 'Jabba The Hutt' },
            { num: 'HF-63', title: 'Jar Jar Binks' },
            { num: 'HF-64', title: 'Jecki Lon' },
            { num: 'HF-65', title: 'Jod Na Nawood' },
            { num: 'HF-66', title: 'Jyn Erso' },
            { num: 'HF-67', title: 'K-2SO' },
            { num: 'HF-68', title: 'Karis Nemik' },
            { num: 'HF-69', title: 'Kassa' },
            { num: 'HF-70', title: 'Kawlan Roken' },
            { num: 'HF-71', title: 'Kaydel Connix' },
            { num: 'HF-72', title: 'Kelleran Beq' },
            { num: 'HF-73', title: 'Kelnacca' },
            { num: 'HF-74', title: 'Kh\'ymm' },
            { num: 'HF-75', title: 'Klothow' },
            { num: 'HF-76', title: 'Koska Reeves' },
            { num: 'HF-77', title: 'L3-37' },
            { num: 'HF-78', title: 'Lando Calrissian' },
            { num: 'HF-79', title: 'Lando Calrissian' },
            { num: 'HF-80', title: 'Leia Organa' },
            { num: 'HF-81', title: 'Logray' },
            { num: 'HF-82', title: 'Lor San Tekka' },
            { num: 'HF-83', title: 'Luke Skywalker' },
            { num: 'HF-84', title: 'Luthen Rael' },
            { num: 'HF-85', title: 'Mace Windu' },
            { num: 'HF-86', title: 'Mae Aniseya' },
            { num: 'HF-87', title: 'Maree' },
            { num: 'HF-88', title: 'Master Codebreaker' },
            { num: 'HF-89', title: 'Max Rebo' },
            { num: 'HF-90', title: 'Maz Kanata' },
            { num: 'HF-91', title: 'Moff Gideon' },
            { num: 'HF-92', title: 'Mog Adana' },
            { num: 'HF-93', title: 'Mon Mothma' },
            { num: 'HF-94', title: 'Mother Aniseya' },
            { num: 'HF-95', title: 'Mother Koril' },
            { num: 'HF-96', title: 'Nol' },
            { num: 'HF-97', title: 'Pokkit' },
            { num: 'HF-98', title: 'Skull Ridge Mountain Hotelier' },
            { num: 'HF-99', title: 'SM-33' },
            { num: 'HF-100', title: 'Trash crab' },
            { num: 'HF-101', title: '2-1B Droid' },
            { num: 'HF-102', title: 'Adi Gallia' },
            { num: 'HF-103', title: 'Aemon Gremm' },
            { num: 'HF-104', title: 'Bazine Netal' },
            { num: 'HF-105', title: 'BB-9E' },
            { num: 'HF-106', title: 'Beaumont Kin' },
            { num: 'HF-107', title: 'Benjar Pranic' },
            { num: 'HF-108', title: 'Bossk' },
            { num: 'HF-109', title: 'Brasso' },
            { num: 'HF-110', title: 'Cabuck' },
            { num: 'HF-111', title: 'Chancellor Drellik' },
            { num: 'HF-112', title: 'Chief Chirpa' },
            { num: 'HF-113', title: 'Darth Bane' },
            { num: 'HF-114', title: 'Dokk Strassi' },
            { num: 'HF-115', title: 'Enfys Nest' },
            { num: 'HF-116', title: 'Figrin D\'an' },
            { num: 'HF-117', title: 'Fuzzball' },
            { num: 'HF-118', title: 'Fyrnock' },
            { num: 'HF-119', title: 'General Pong Krell' },
            { num: 'HF-120', title: 'General Strix' },
            { num: 'HF-121', title: 'Glerb' },
            { num: 'HF-122', title: 'Hayna' },
            { num: 'HF-123', title: 'Hondo Ohnaka' },
            { num: 'HF-124', title: 'IG-88' },
            { num: 'HF-125', title: 'Jawa' },
            { num: 'HF-126', title: 'Jess Pava' },
            { num: 'HF-127', title: 'Kayo Organa' },
            { num: 'HF-128', title: 'KB' },
            { num: 'HF-129', title: 'Kona' },
            { num: 'HF-130', title: 'Kragan Gorr' },
            { num: 'HF-131', title: 'Lobot' },
            { num: 'HF-132', title: 'Lortha Peel' },
            { num: 'HF-133', title: 'Mas Amedda' },
            { num: 'HF-134', title: 'Mayor Mok Shaiz' },
            { num: 'HF-135', title: 'Melna' },
            { num: 'HF-136', title: 'Mother Talzin' },
            { num: 'HF-137', title: 'Neel' },
            { num: 'HF-138', title: 'Obi-Wan Kenobi' },
            { num: 'HF-139', title: 'Obi-Wan Kenobi' },
            { num: 'HF-140', title: 'Osha Aniseya' },
            { num: 'HF-141', title: 'Padmé Amidala' },
            { num: 'HF-142', title: 'Pegla' },
            { num: 'HF-143', title: 'Pip' },
            { num: 'HF-144', title: 'Pirate Captain Brutus' },
            { num: 'HF-145', title: 'Poe Dameron' },
            { num: 'HF-146', title: 'Poggle the Lesser' },
            { num: 'HF-147', title: 'Porg' },
            { num: 'HF-148', title: 'Professor Huyang' },
            { num: 'HF-149', title: 'Pyke Boss' },
            { num: 'HF-150', title: 'Qi\'ra' },
            { num: 'HF-151', title: 'Queen Apailana' },
            { num: 'HF-152', title: 'Qui-Gon Jinn' },
            { num: 'HF-153', title: 'R2-D2' },
            { num: 'HF-154', title: 'Ragnar Vizsla' },
            { num: 'HF-155', title: 'Rey' },
            { num: 'HF-156', title: 'Rio Durant' },
            { num: 'HF-157', title: 'Roona' },
            { num: 'HF-158', title: 'Rose Tico' },
            { num: 'HF-159', title: 'Sabé' },
            { num: 'HF-160', title: 'Sabine Wren' },
            { num: 'HF-161', title: 'Safety Droid' },
            { num: 'HF-162', title: 'Savage Opress' },
            { num: 'HF-163', title: 'Senator Rayencourt' },
            { num: 'HF-164', title: 'Sergeant Linus Mosk' },
            { num: 'HF-165', title: 'Shaak Ti' },
            { num: 'HF-166', title: 'Shin Hati' },
            { num: 'HF-167', title: 'Skura' },
            { num: 'HF-168', title: 'Slowen Lo' },
            { num: 'HF-169', title: 'Sly Moore' },
            { num: 'HF-170', title: 'Snowball' },
            { num: 'HF-171', title: 'Sol' },
            { num: 'HF-172', title: 'Sully Stark' },
            { num: 'HF-173', title: 'Supreme Leader Kylo Ren' },
            { num: 'HF-174', title: 'Supreme Leader Snoke' },
            { num: 'HF-175', title: 'Tasi Lowa' },
            { num: 'HF-176', title: 'Teacher Droid' },
            { num: 'HF-177', title: 'Tera Sinube' },
            { num: 'HF-178', title: 'The Armorer' },
            { num: 'HF-179', title: 'The Client' },
            { num: 'HF-180', title: 'The Grand Inquisitor' },
            { num: 'HF-181', title: 'The Mandalorian' },
            { num: 'HF-182', title: 'The Stranger' },
            { num: 'HF-183', title: 'Tion Medon' },
            { num: 'HF-184', title: 'Tobias Beckett' },
            { num: 'HF-185', title: 'Torbin' },
            { num: 'HF-186', title: 'Unkar Plutt' },
            { num: 'HF-187', title: 'Val' },
            { num: 'HF-188', title: 'Vernestra Rwoh' },
            { num: 'HF-189', title: 'Vetch' },
            { num: 'HF-190', title: 'Watto' },
            { num: 'HF-191', title: 'Wendle' },
            { num: 'HF-192', title: 'Wilmon Paak' },
            { num: 'HF-193', title: 'Wim' },
            { num: 'HF-194', title: 'Wullf Yularen' },
            { num: 'HF-195', title: 'Xanwan' },
            { num: 'HF-196', title: 'Yarael Poof' },
            { num: 'HF-197', title: 'Yoda' },
            { num: 'HF-198', title: 'Yord Fandar' },
            { num: 'HF-199', title: 'Zam Wesell' },
            { num: 'HF-200', title: 'Zorii Bliss' },
          ]
        },
        {
          count: 200,
          name: 'AUREBESH SHORT PRINTS',
          meta: 'Full 200-card Aurebesh short-print mirror',
          parallels: 4,
          cards: [
            { num: 'AV-1', title: 'Admiral Ackbar' },
            { num: 'AV-2', title: 'Ahsoka Tano' },
            { num: 'AV-3', title: 'Anakin Skywalker' },
            { num: 'AV-4', title: 'Arvel Skeen' },
            { num: 'AV-5', title: 'Baylan Skoll' },
            { num: 'AV-6', title: 'Bazil' },
            { num: 'AV-7', title: 'Beru Lars' },
            { num: 'AV-8', title: 'Birnok' },
            { num: 'AV-9', title: 'Bix Caleen' },
            { num: 'AV-10', title: 'Bo-Katan Kryze' },
            { num: 'AV-11', title: 'Boba Fett' },
            { num: 'AV-12', title: 'Bodhi Rook' },
            { num: 'AV-13', title: 'C-3PO' },
            { num: 'AV-14', title: 'C1-D1' },
            { num: 'AV-15', title: 'Captain Blex' },
            { num: 'AV-16', title: 'Captain Elk' },
            { num: 'AV-17', title: 'Captain Girard' },
            { num: 'AV-18', title: 'Captain Hayle' },
            { num: 'AV-19', title: 'Captain Phasma' },
            { num: 'AV-20', title: 'Captain Porter' },
            { num: 'AV-21', title: 'Captain Silvo' },
            { num: 'AV-22', title: 'Cassian Andor' },
            { num: 'AV-23', title: 'Chewbacca' },
            { num: 'AV-24', title: 'Chirrut Imwe' },
            { num: 'AV-25', title: 'Chopper' },
            { num: 'AV-26', title: 'Clone Captain Rex' },
            { num: 'AV-27', title: 'Count Dooku' },
            { num: 'AV-28', title: 'Darth Maul' },
            { num: 'AV-29', title: 'Darth Vader' },
            { num: 'AV-30', title: 'Dedra Meero' },
            { num: 'AV-31', title: 'Dengar' },
            { num: 'AV-32', title: 'Dinghy Driver' },
            { num: 'AV-33', title: 'DJ' },
            { num: 'AV-34', title: 'Dr. Gorst' },
            { num: 'AV-35', title: 'Dryden Vos' },
            { num: 'AV-36', title: 'Eedy Karn' },
            { num: 'AV-37', title: 'Elder Naasa' },
            { num: 'AV-38', title: 'Emperor Palpatine' },
            { num: 'AV-39', title: 'Ezra Bridger' },
            { num: 'AV-40', title: 'Fara' },
            { num: 'AV-41', title: 'Fennec Shand' },
            { num: 'AV-42', title: 'Fern' },
            { num: 'AV-43', title: 'Fifth Brother Inquisitor' },
            { num: 'AV-44', title: 'Fillik' },
            { num: 'AV-45', title: 'Finn' },
            { num: 'AV-46', title: 'First Officer Jensen Corbyt' },
            { num: 'AV-47', title: 'Galen Erso' },
            { num: 'AV-48', title: 'Garsa Fwip' },
            { num: 'AV-49', title: 'General Grievous' },
            { num: 'AV-50', title: 'General Hux' },
            { num: 'AV-51', title: 'General Pryde' },
            { num: 'AV-52', title: 'Grand Admiral Thrawn' },
            { num: 'AV-53', title: 'Grand Moff Tarkin' },
            { num: 'AV-54', title: 'Greedo' },
            { num: 'AV-55', title: 'Greef Karga' },
            { num: 'AV-56', title: 'Grogu' },
            { num: 'AV-57', title: 'Gunter' },
            { num: 'AV-58', title: 'Han Solo' },
            { num: 'AV-59', title: 'Hera Syndulla' },
            { num: 'AV-60', title: 'IG-11' },
            { num: 'AV-61', title: 'Indara' },
            { num: 'AV-62', title: 'Jabba The Hutt' },
            { num: 'AV-63', title: 'Jar Jar Binks' },
            { num: 'AV-64', title: 'Jecki Lon' },
            { num: 'AV-65', title: 'Jod Na Nawood' },
            { num: 'AV-66', title: 'Jyn Erso' },
            { num: 'AV-67', title: 'K-2SO' },
            { num: 'AV-68', title: 'Karis Nemik' },
            { num: 'AV-69', title: 'Kassa' },
            { num: 'AV-70', title: 'Kawlan Roken' },
            { num: 'AV-71', title: 'Kaydel Connix' },
            { num: 'AV-72', title: 'Kelleran Beq' },
            { num: 'AV-73', title: 'Kelnacca' },
            { num: 'AV-74', title: 'Kh\'ymm' },
            { num: 'AV-75', title: 'Klothow' },
            { num: 'AV-76', title: 'Koska Reeves' },
            { num: 'AV-77', title: 'L3-37' },
            { num: 'AV-78', title: 'Lando Calrissian' },
            { num: 'AV-79', title: 'Lando Calrissian' },
            { num: 'AV-80', title: 'Leia Organa' },
            { num: 'AV-81', title: 'Logray' },
            { num: 'AV-82', title: 'Lor San Tekka' },
            { num: 'AV-83', title: 'Luke Skywalker' },
            { num: 'AV-84', title: 'Luthen Rael' },
            { num: 'AV-85', title: 'Mace Windu' },
            { num: 'AV-86', title: 'Mae Aniseya' },
            { num: 'AV-87', title: 'Maree' },
            { num: 'AV-88', title: 'Master Codebreaker' },
            { num: 'AV-89', title: 'Max Rebo' },
            { num: 'AV-90', title: 'Maz Kanata' },
            { num: 'AV-91', title: 'Moff Gideon' },
            { num: 'AV-92', title: 'Mog Adana' },
            { num: 'AV-93', title: 'Mon Mothma' },
            { num: 'AV-94', title: 'Mother Aniseya' },
            { num: 'AV-95', title: 'Mother Koril' },
            { num: 'AV-96', title: 'Nol' },
            { num: 'AV-97', title: 'Pokkit' },
            { num: 'AV-98', title: 'Skull Ridge Mountain Hotelier' },
            { num: 'AV-99', title: 'SM-33' },
            { num: 'AV-100', title: 'Trash crab' },
            { num: 'AV-101', title: '2-1B Droid' },
            { num: 'AV-102', title: 'Adi Gallia' },
            { num: 'AV-103', title: 'Aemon Gremm' },
            { num: 'AV-104', title: 'Bazine Netal' },
            { num: 'AV-105', title: 'BB-9E' },
            { num: 'AV-106', title: 'Beaumont Kin' },
            { num: 'AV-107', title: 'Benjar Pranic' },
            { num: 'AV-108', title: 'Bossk' },
            { num: 'AV-109', title: 'Brasso' },
            { num: 'AV-110', title: 'Cabuck' },
            { num: 'AV-111', title: 'Chancellor Drellik' },
            { num: 'AV-112', title: 'Chief Chirpa' },
            { num: 'AV-113', title: 'Darth Bane' },
            { num: 'AV-114', title: 'Dokk Strassi' },
            { num: 'AV-115', title: 'Enfys Nest' },
            { num: 'AV-116', title: 'Figrin D\'an' },
            { num: 'AV-117', title: 'Fuzzball' },
            { num: 'AV-118', title: 'Fyrnock' },
            { num: 'AV-119', title: 'General Pong Krell' },
            { num: 'AV-120', title: 'General Strix' },
            { num: 'AV-121', title: 'Glerb' },
            { num: 'AV-122', title: 'Hayna' },
            { num: 'AV-123', title: 'Hondo Ohnaka' },
            { num: 'AV-124', title: 'IG-88' },
            { num: 'AV-125', title: 'Jawa' },
            { num: 'AV-126', title: 'Jess Pava' },
            { num: 'AV-127', title: 'Kayo Organa' },
            { num: 'AV-128', title: 'KB' },
            { num: 'AV-129', title: 'Kona' },
            { num: 'AV-130', title: 'Kragan Gorr' },
            { num: 'AV-131', title: 'Lobot' },
            { num: 'AV-132', title: 'Lortha Peel' },
            { num: 'AV-133', title: 'Mas Amedda' },
            { num: 'AV-134', title: 'Mayor Mok Shaiz' },
            { num: 'AV-135', title: 'Melna' },
            { num: 'AV-136', title: 'Mother Talzin' },
            { num: 'AV-137', title: 'Neel' },
            { num: 'AV-138', title: 'Obi-Wan Kenobi' },
            { num: 'AV-139', title: 'Obi-Wan Kenobi' },
            { num: 'AV-140', title: 'Osha Aniseya' },
            { num: 'AV-141', title: 'Padmé Amidala' },
            { num: 'AV-142', title: 'Pegla' },
            { num: 'AV-143', title: 'Pip' },
            { num: 'AV-144', title: 'Pirate Captain Brutus' },
            { num: 'AV-145', title: 'Poe Dameron' },
            { num: 'AV-146', title: 'Poggle the Lesser' },
            { num: 'AV-147', title: 'Porg' },
            { num: 'AV-148', title: 'Professor Huyang' },
            { num: 'AV-149', title: 'Pyke Boss' },
            { num: 'AV-150', title: 'Qi\'ra' },
            { num: 'AV-151', title: 'Queen Apailana' },
            { num: 'AV-152', title: 'Qui-Gon Jinn' },
            { num: 'AV-153', title: 'R2-D2' },
            { num: 'AV-154', title: 'Ragnar Vizsla' },
            { num: 'AV-155', title: 'Rey' },
            { num: 'AV-156', title: 'Rio Durant' },
            { num: 'AV-157', title: 'Roona' },
            { num: 'AV-158', title: 'Rose Tico' },
            { num: 'AV-159', title: 'Sabé' },
            { num: 'AV-160', title: 'Sabine Wren' },
            { num: 'AV-161', title: 'Safety Droid' },
            { num: 'AV-162', title: 'Savage Opress' },
            { num: 'AV-163', title: 'Senator Rayencourt' },
            { num: 'AV-164', title: 'Sergeant Linus Mosk' },
            { num: 'AV-165', title: 'Shaak Ti' },
            { num: 'AV-166', title: 'Shin Hati' },
            { num: 'AV-167', title: 'Skura' },
            { num: 'AV-168', title: 'Slowen Lo' },
            { num: 'AV-169', title: 'Sly Moore' },
            { num: 'AV-170', title: 'Snowball' },
            { num: 'AV-171', title: 'Sol' },
            { num: 'AV-172', title: 'Sully Stark' },
            { num: 'AV-173', title: 'Supreme Leader Kylo Ren' },
            { num: 'AV-174', title: 'Supreme Leader Snoke' },
            { num: 'AV-175', title: 'Tasi Lowa' },
            { num: 'AV-176', title: 'Teacher Droid' },
            { num: 'AV-177', title: 'Tera Sinube' },
            { num: 'AV-178', title: 'The Armorer' },
            { num: 'AV-179', title: 'The Client' },
            { num: 'AV-180', title: 'The Grand Inquisitor' },
            { num: 'AV-181', title: 'The Mandalorian' },
            { num: 'AV-182', title: 'The Stranger' },
            { num: 'AV-183', title: 'Tion Medon' },
            { num: 'AV-184', title: 'Tobias Beckett' },
            { num: 'AV-185', title: 'Torbin' },
            { num: 'AV-186', title: 'Unkar Plutt' },
            { num: 'AV-187', title: 'Val' },
            { num: 'AV-188', title: 'Vernestra Rwoh' },
            { num: 'AV-189', title: 'Vetch' },
            { num: 'AV-190', title: 'Watto' },
            { num: 'AV-191', title: 'Wendle' },
            { num: 'AV-192', title: 'Wilmon Paak' },
            { num: 'AV-193', title: 'Wim' },
            { num: 'AV-194', title: 'Wullf Yularen' },
            { num: 'AV-195', title: 'Xanwan' },
            { num: 'AV-196', title: 'Yarael Poof' },
            { num: 'AV-197', title: 'Yoda' },
            { num: 'AV-198', title: 'Yord Fandar' },
            { num: 'AV-199', title: 'Zam Wesell' },
            { num: 'AV-200', title: 'Zorii Bliss' },
          ]
        },
        {
          count: 200,
          name: 'PRINTING PLATE BOOK CARDS',
          meta: 'CMYK plates bound as one-of-one book cards',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'BC-1', title: 'Admiral Ackbar' },
            { num: 'BC-2', title: 'Ahsoka Tano' },
            { num: 'BC-3', title: 'Anakin Skywalker' },
            { num: 'BC-4', title: 'Arvel Skeen' },
            { num: 'BC-5', title: 'Baylan Skoll' },
            { num: 'BC-6', title: 'Bazil' },
            { num: 'BC-7', title: 'Beru Lars' },
            { num: 'BC-8', title: 'Birnok' },
            { num: 'BC-9', title: 'Bix Caleen' },
            { num: 'BC-10', title: 'Bo-Katan Kryze' },
            { num: 'BC-11', title: 'Boba Fett' },
            { num: 'BC-12', title: 'Bodhi Rook' },
            { num: 'BC-13', title: 'C-3PO' },
            { num: 'BC-14', title: 'C1-D1' },
            { num: 'BC-15', title: 'Captain Blex' },
            { num: 'BC-16', title: 'Captain Elk' },
            { num: 'BC-17', title: 'Captain Girard' },
            { num: 'BC-18', title: 'Captain Hayle' },
            { num: 'BC-19', title: 'Captain Phasma' },
            { num: 'BC-20', title: 'Captain Porter' },
            { num: 'BC-21', title: 'Captain Silvo' },
            { num: 'BC-22', title: 'Cassian Andor' },
            { num: 'BC-23', title: 'Chewbacca' },
            { num: 'BC-24', title: 'Chirrut Îmwe' },
            { num: 'BC-25', title: 'Chopper' },
            { num: 'BC-26', title: 'Clone Captain Rex' },
            { num: 'BC-27', title: 'Count Dooku' },
            { num: 'BC-28', title: 'Darth Maul' },
            { num: 'BC-29', title: 'Darth Vader' },
            { num: 'BC-30', title: 'Dedra Meero' },
            { num: 'BC-31', title: 'Dengar' },
            { num: 'BC-32', title: 'Dinghy Driver' },
            { num: 'BC-33', title: 'DJ' },
            { num: 'BC-34', title: 'Dr. Gorst' },
            { num: 'BC-35', title: 'Dryden Vos' },
            { num: 'BC-36', title: 'Eedy Karn' },
            { num: 'BC-37', title: 'Elder Naasa' },
            { num: 'BC-38', title: 'Emperor Palpatine' },
            { num: 'BC-39', title: 'Ezra Bridger' },
            { num: 'BC-40', title: 'Fara' },
            { num: 'BC-41', title: 'Fennec Shand' },
            { num: 'BC-42', title: 'Fern' },
            { num: 'BC-43', title: 'Fifth Brother Inquisitor' },
            { num: 'BC-44', title: 'Fillik' },
            { num: 'BC-45', title: 'Finn' },
            { num: 'BC-46', title: 'First Officer Jensen Corbyt' },
            { num: 'BC-47', title: 'Galen Erso' },
            { num: 'BC-48', title: 'Garsa Fwip' },
            { num: 'BC-49', title: 'General Grievous' },
            { num: 'BC-50', title: 'General Hux' },
            { num: 'BC-51', title: 'General Pryde' },
            { num: 'BC-52', title: 'Grand Admiral Thrawn' },
            { num: 'BC-53', title: 'Grand Moff Tarkin' },
            { num: 'BC-54', title: 'Greedo' },
            { num: 'BC-55', title: 'Greef Karga' },
            { num: 'BC-56', title: 'Grogu' },
            { num: 'BC-57', title: 'Gunter' },
            { num: 'BC-58', title: 'Han Solo' },
            { num: 'BC-59', title: 'Hera Syndulla' },
            { num: 'BC-60', title: 'IG-11' },
            { num: 'BC-61', title: 'Indara' },
            { num: 'BC-62', title: 'Jabba The Hutt' },
            { num: 'BC-63', title: 'Jar Jar Binks' },
            { num: 'BC-64', title: 'Jecki Lon' },
            { num: 'BC-65', title: 'Jod Na Nawood' },
            { num: 'BC-66', title: 'Jyn Erso' },
            { num: 'BC-67', title: 'K-2SO' },
            { num: 'BC-68', title: 'Karis Nemik' },
            { num: 'BC-69', title: 'Kassa' },
            { num: 'BC-70', title: 'Kawlan Roken' },
            { num: 'BC-71', title: 'Kaydel Connix' },
            { num: 'BC-72', title: 'Kelleran Beq' },
            { num: 'BC-73', title: 'Kelnacca' },
            { num: 'BC-74', title: 'Kh\'ymm' },
            { num: 'BC-75', title: 'Klothow' },
            { num: 'BC-76', title: 'Koska Reeves' },
            { num: 'BC-77', title: 'L3-37' },
            { num: 'BC-78', title: 'Lando Calrissian' },
            { num: 'BC-79', title: 'Lando Calrissian' },
            { num: 'BC-80', title: 'Leia Organa' },
            { num: 'BC-81', title: 'Logray' },
            { num: 'BC-82', title: 'Lor San Tekka' },
            { num: 'BC-83', title: 'Luke Skywalker' },
            { num: 'BC-84', title: 'Luthen Rael' },
            { num: 'BC-85', title: 'Mace Windu' },
            { num: 'BC-86', title: 'Mae Aniseya' },
            { num: 'BC-87', title: 'Maree' },
            { num: 'BC-88', title: 'Master Codebreaker' },
            { num: 'BC-89', title: 'Max Rebo' },
            { num: 'BC-90', title: 'Maz Kanata' },
            { num: 'BC-91', title: 'Moff Gideon' },
            { num: 'BC-92', title: 'Mog Adana' },
            { num: 'BC-93', title: 'Mon Mothma' },
            { num: 'BC-94', title: 'Mother Aniseya' },
            { num: 'BC-95', title: 'Mother Koril' },
            { num: 'BC-96', title: 'Nol' },
            { num: 'BC-97', title: 'Pokkit' },
            { num: 'BC-98', title: 'Skull Ridge Mountain Hotelier' },
            { num: 'BC-99', title: 'SM-33' },
            { num: 'BC-100', title: 'Trash crab' },
            { num: 'BC-101', title: '2-1B Droid' },
            { num: 'BC-102', title: 'Adi Gallia' },
            { num: 'BC-103', title: 'Aemon Gremm' },
            { num: 'BC-104', title: 'Bazine Netal' },
            { num: 'BC-105', title: 'BB-9E' },
            { num: 'BC-106', title: 'Beaumont Kin' },
            { num: 'BC-107', title: 'Benjar Pranic' },
            { num: 'BC-108', title: 'Bossk' },
            { num: 'BC-109', title: 'Brasso' },
            { num: 'BC-110', title: 'Cabuck' },
            { num: 'BC-111', title: 'Chancellor Drellik' },
            { num: 'BC-112', title: 'Chief Chirpa' },
            { num: 'BC-113', title: 'Darth Bane' },
            { num: 'BC-114', title: 'Dokk Strassi' },
            { num: 'BC-115', title: 'Enfys Nest' },
            { num: 'BC-116', title: 'Figrin D\'an' },
            { num: 'BC-117', title: 'Fuzzball' },
            { num: 'BC-118', title: 'Fyrnock' },
            { num: 'BC-119', title: 'General Pong Krell' },
            { num: 'BC-120', title: 'General Strix' },
            { num: 'BC-121', title: 'Glerb' },
            { num: 'BC-122', title: 'Hayna' },
            { num: 'BC-123', title: 'Hondo Ohnaka' },
            { num: 'BC-124', title: 'IG-88' },
            { num: 'BC-125', title: 'Jawa' },
            { num: 'BC-126', title: 'Jess Pava' },
            { num: 'BC-127', title: 'Kayo Organa' },
            { num: 'BC-128', title: 'KB' },
            { num: 'BC-129', title: 'Kona' },
            { num: 'BC-130', title: 'Kragan Gorr' },
            { num: 'BC-131', title: 'Lobot' },
            { num: 'BC-132', title: 'Lortha Peel' },
            { num: 'BC-133', title: 'Mas Amedda' },
            { num: 'BC-134', title: 'Mayor Mok Shaiz' },
            { num: 'BC-135', title: 'Melna' },
            { num: 'BC-136', title: 'Mother Talzin' },
            { num: 'BC-137', title: 'Neel' },
            { num: 'BC-138', title: 'Obi-Wan Kenobi' },
            { num: 'BC-139', title: 'Obi-Wan Kenobi' },
            { num: 'BC-140', title: 'Osha Aniseya' },
            { num: 'BC-141', title: 'Padmé Amidala' },
            { num: 'BC-142', title: 'Pegla' },
            { num: 'BC-143', title: 'Pip' },
            { num: 'BC-144', title: 'Pirate Captain Brutus' },
            { num: 'BC-145', title: 'Poe Dameron' },
            { num: 'BC-146', title: 'Poggle the Lesser' },
            { num: 'BC-147', title: 'Porg' },
            { num: 'BC-148', title: 'Professor Huyang' },
            { num: 'BC-149', title: 'Pyke Boss' },
            { num: 'BC-150', title: 'Qi\'ra' },
            { num: 'BC-151', title: 'Queen Apailana' },
            { num: 'BC-152', title: 'Qui-Gon Jinn' },
            { num: 'BC-153', title: 'R2-D2' },
            { num: 'BC-154', title: 'Ragnar Vizsla' },
            { num: 'BC-155', title: 'Rey' },
            { num: 'BC-156', title: 'Rio Durant' },
            { num: 'BC-157', title: 'Roona' },
            { num: 'BC-158', title: 'Rose Tico' },
            { num: 'BC-159', title: 'Sabé' },
            { num: 'BC-160', title: 'Sabine Wren' },
            { num: 'BC-161', title: 'Safety Droid' },
            { num: 'BC-162', title: 'Savage Opress' },
            { num: 'BC-163', title: 'Senator Rayencourt' },
            { num: 'BC-164', title: 'Sergeant Linus Mosk' },
            { num: 'BC-165', title: 'Shaak Ti' },
            { num: 'BC-166', title: 'Shin Hati' },
            { num: 'BC-167', title: 'Skura' },
            { num: 'BC-168', title: 'Slowen Lo' },
            { num: 'BC-169', title: 'Sly Moore' },
            { num: 'BC-170', title: 'Snowball' },
            { num: 'BC-171', title: 'Sol' },
            { num: 'BC-172', title: 'Sully Stark' },
            { num: 'BC-173', title: 'Supreme Leader Kylo Ren' },
            { num: 'BC-174', title: 'Supreme Leader Snoke' },
            { num: 'BC-175', title: 'Tasi Lowa' },
            { num: 'BC-176', title: 'Teacher Droid' },
            { num: 'BC-177', title: 'Tera Sinube' },
            { num: 'BC-178', title: 'The Armorer' },
            { num: 'BC-179', title: 'The Client' },
            { num: 'BC-180', title: 'The Grand Inquisitor' },
            { num: 'BC-181', title: 'The Mandalorian' },
            { num: 'BC-182', title: 'The Stranger' },
            { num: 'BC-183', title: 'Tion Medon' },
            { num: 'BC-184', title: 'Tobias Beckett' },
            { num: 'BC-185', title: 'Torbin' },
            { num: 'BC-186', title: 'Unkar Plutt' },
            { num: 'BC-187', title: 'Val' },
            { num: 'BC-188', title: 'Vernestra Rwoh' },
            { num: 'BC-189', title: 'Vetch' },
            { num: 'BC-190', title: 'Watto' },
            { num: 'BC-191', title: 'Wendle' },
            { num: 'BC-192', title: 'Wilmon Paak' },
            { num: 'BC-193', title: 'Wim' },
            { num: 'BC-194', title: 'Wullf Yularen' },
            { num: 'BC-195', title: 'Xanwan' },
            { num: 'BC-196', title: 'Yarael Poof' },
            { num: 'BC-197', title: 'Yoda' },
            { num: 'BC-198', title: 'Yord Fandar' },
            { num: 'BC-199', title: 'Zam Wesell' },
            { num: 'BC-200', title: 'Zorii Bliss' },
          ]
        }
      ],
      insert: [
        {
          count: 50,
          name: '1975 TRIBUTE',
          meta: 'Original 1975 Topps design tribute',
          odds: '1:119 packs',
          parallels: 1,
          cards: [
            { num: 'TB-1', title: 'Admiral Ackbar' },
            { num: 'TB-2', title: 'Ahsoka Tano' },
            { num: 'TB-3', title: 'Anakin Skywalker' },
            { num: 'TB-4', title: 'Bail Organa' },
            { num: 'TB-5', title: 'Baylan Skoll' },
            { num: 'TB-6', title: 'Bo-Katan Kryze' },
            { num: 'TB-7', title: 'Boba Fett' },
            { num: 'TB-8', title: 'C-3PO' },
            { num: 'TB-9', title: 'Captain Phasma' },
            { num: 'TB-10', title: 'Cassian Andor' },
            { num: 'TB-11', title: 'Chewbacca' },
            { num: 'TB-12', title: 'Chirrut Îmwe' },
            { num: 'TB-13', title: 'Count Dooku' },
            { num: 'TB-14', title: 'Darth Maul' },
            { num: 'TB-15', title: 'Darth Vader' },
            { num: 'TB-16', title: 'Emperor Palpatine' },
            { num: 'TB-17', title: 'General Grievous' },
            { num: 'TB-18', title: 'General Hux' },
            { num: 'TB-19', title: 'Grand Admiral Thrawn' },
            { num: 'TB-20', title: 'Grand Moff Tarkin' },
            { num: 'TB-21', title: 'Greedo' },
            { num: 'TB-22', title: 'Greef Karga' },
            { num: 'TB-23', title: 'Grogu' },
            { num: 'TB-24', title: 'Han Solo' },
            { num: 'TB-25', title: 'Hera Syndulla' },
            { num: 'TB-26', title: 'IG-11' },
            { num: 'TB-27', title: 'Jabba The Hutt' },
            { num: 'TB-28', title: 'Jar Jar Binks' },
            { num: 'TB-29', title: 'Jod Na Nawood' },
            { num: 'TB-30', title: 'Jyn Erso' },
            { num: 'TB-31', title: 'Lando Calrissian' },
            { num: 'TB-32', title: 'Lando Calrissian' },
            { num: 'TB-33', title: 'Leia Organa' },
            { num: 'TB-34', title: 'Luke Skywalker' },
            { num: 'TB-35', title: 'Mace Windu' },
            { num: 'TB-36', title: 'Moff Gideon' },
            { num: 'TB-37', title: 'Mon Mothma' },
            { num: 'TB-38', title: 'Nien Nunb' },
            { num: 'TB-39', title: 'Obi-Wan Kenobi' },
            { num: 'TB-40', title: 'Obi-Wan Kenobi' },
            { num: 'TB-41', title: 'Padmé Amidala' },
            { num: 'TB-42', title: 'Qui-Gon Jinn' },
            { num: 'TB-43', title: 'R2-D2' },
            { num: 'TB-44', title: 'Sabine Wren' },
            { num: 'TB-45', title: 'Shin Hati' },
            { num: 'TB-46', title: 'Supreme Leader Kylo Ren' },
            { num: 'TB-47', title: 'The Armorer' },
            { num: 'TB-48', title: 'The Mandalorian' },
            { num: 'TB-49', title: 'Wicket W. Warrick' },
            { num: 'TB-50', title: 'Yoda' },
          ]
        },
        {
          count: 25,
          name: 'SKELETON CREW',
          meta: 'The series hits chromium',
          odds: '1:3 packs',
          parallels: 6,
          cards: [
            { num: 'SC-1', title: 'Captain Silvo' },
            { num: 'SC-2', title: 'Wim and Neel Shuttle To Class' },
            { num: 'SC-3', title: 'Fern and KB Speed To Class' },
            { num: 'SC-4', title: 'Preparing For Career Day' },
            { num: 'SC-5', title: '"What Are You In For?"' },
            { num: 'SC-6', title: 'Discovering The Onyx Cinder' },
            { num: 'SC-7', title: 'SM-33 and Snowball' },
            { num: 'SC-8', title: 'Jumping Into Hyperdrive' },
            { num: 'SC-9', title: 'Docking At Port Borgo' },
            { num: 'SC-10', title: 'Jod Na Nawood' },
            { num: 'SC-11', title: 'Kh\'ymm Helps The Children' },
            { num: 'SC-12', title: 'Neel And Hayna' },
            { num: 'SC-13', title: 'The Crew Gets Enlisted' },
            { num: 'SC-14', title: 'The Wise Elders' },
            { num: 'SC-15', title: 'Tak Rennod\'s Lair' },
            { num: 'SC-16', title: 'Jod Captured' },
            { num: 'SC-17', title: 'Equal Time' },
            { num: 'SC-18', title: 'Jod Rallies The Pirates' },
            { num: 'SC-19', title: 'The Crew Reunites' },
            { num: 'SC-20', title: 'The Crew Finds At Attin' },
            { num: 'SC-21', title: 'Jod Threatens The Crew' },
            { num: 'SC-22', title: 'Jod Finds His Treasure' },
            { num: 'SC-23', title: 'Racing To Save At Attin' },
            { num: 'SC-24', title: 'The Supervisor Revealed' },
            { num: 'SC-25', title: 'The Real Good Guys Save At Attin' },
          ]
        },
        {
          count: 25,
          name: 'ACOLYTE',
          meta: 'The series hits chromium',
          odds: '1:6 packs',
          parallels: 6,
          cards: [
            { num: 'AC-1', title: 'Mae Aniseya Defeats Jedi Master Indara' },
            { num: 'AC-2', title: 'A Crash On Carlac' },
            { num: 'AC-3', title: 'Jedi Master Sol Saves Osha Aniseya' },
            { num: 'AC-4', title: 'Mae Aniseya\'s Next Assignment' },
            { num: 'AC-5', title: 'Bottled Absolution' },
            { num: 'AC-6', title: 'Tracking Down Mae Aniseya' },
            { num: 'AC-7', title: 'The Power Of Many' },
            { num: 'AC-8', title: 'The Twins Are Tested' },
            { num: 'AC-9', title: 'A Deadly Fire' },
            { num: 'AC-10', title: 'Mae Aniseya Changes Course' },
            { num: 'AC-11', title: 'The Stranger Vs The Jedi' },
            { num: 'AC-12', title: 'The Stranger, Unmasked' },
            { num: 'AC-13', title: 'Mae Aniseya Assumes Osha\'s Identity' },
            { num: 'AC-14', title: 'Osha Aniseya Threatens Qimir' },
            { num: 'AC-15', title: 'Osha Aniseya Wears The Cortosis Helmet' },
            { num: 'AC-16', title: 'Vernestra Rwoh' },
            { num: 'AC-17', title: 'Master Sol Finds The Twins' },
            { num: 'AC-18', title: 'The Jedi Search For A Vergence' },
            { num: 'AC-19', title: 'Kelnacca Unleashed' },
            { num: 'AC-20', title: 'The Witches Perish' },
            { num: 'AC-21', title: 'A Sith Lord Observes' },
            { num: 'AC-22', title: 'Sol Vs Qimir' },
            { num: 'AC-23', title: 'Without A Weapon' },
            { num: 'AC-24', title: 'The Bleeding Of A Kyber Crystal' },
            { num: 'AC-25', title: 'Memory Loss' },
          ]
        },
        {
          count: 25,
          name: 'OUTER WORLD ODDITIES',
          meta: 'Creatures & curiosities of the galaxy',
          odds: '1:6 packs',
          parallels: 6,
          cards: [
            { num: 'UO-1', title: 'Acklay' },
            { num: 'UO-2', title: 'Brain Worm' },
            { num: 'UO-3', title: 'Colo Claw Fish' },
            { num: 'UO-4', title: 'Fyrnock' },
            { num: 'UO-5', title: 'Gundark' },
            { num: 'UO-6', title: 'Ice Spider' },
            { num: 'UO-7', title: 'Irling' },
            { num: 'UO-8', title: 'Kouhun' },
            { num: 'UO-9', title: 'Krayt Dragon' },
            { num: 'UO-10', title: 'Krykna' },
            { num: 'UO-11', title: 'Blurrg' },
            { num: 'UO-12', title: 'Nexu' },
            { num: 'UO-13', title: 'Rancor' },
            { num: 'UO-14', title: 'Rathtar' },
            { num: 'UO-15', title: 'Ravinak' },
            { num: 'UO-16', title: 'Rokkna' },
            { num: 'UO-17', title: 'Tatooine sand beast' },
            { num: 'UO-18', title: 'Sando Aqua Monster' },
            { num: 'UO-19', title: 'Sarlacc' },
            { num: 'UO-20', title: 'Space Slug' },
            { num: 'UO-21', title: 'Summa-Verminoth' },
            { num: 'UO-22', title: 'Vexis' },
            { num: 'UO-23', title: 'Vixus' },
            { num: 'UO-24', title: 'Wampa' },
            { num: 'UO-25', title: 'Zillo Beast' },
          ]
        },
        {
          count: 24,
          name: 'STAR WARS BY THE NUMBER',
          meta: 'The numbers that made the saga',
          noParallels: true,
          cards: [
            { num: 'CP-1', title: 'R2-D2' },
            { num: 'CP-2', title: 'Boba Fett' },
            { num: 'CP-3', title: 'Han Solo, Leia Organa and Luke Skywalker' },
            { num: 'CP-4', title: 'Jabba the Hutt, Bib Fortuna and Salacious B. Crumb' },
            { num: 'CP-5', title: 'Max Rebo' },
            { num: 'CP-6', title: 'Imperial Royal Guard' },
            { num: 'CP-7', title: 'Darth Vader' },
            { num: 'CP-8', title: 'Yoda' },
            { num: 'CP-9', title: 'Han Solo in Carbonite and Boushh' },
            { num: 'CP-10', title: 'Darth Vader, Luke Skywalker and Emperor Palpatine' },
            { num: 'CP-11', title: 'Darth Vader and Emperor Palpatine' },
            { num: 'CP-12', title: 'Jawas' },
            { num: 'CP-13', title: 'Star Destroyer' },
            { num: 'CP-14', title: 'Stormtrooper' },
            { num: 'CP-15', title: 'Starfighters' },
            { num: 'CP-16', title: 'Chewbacca' },
            { num: 'CP-17', title: 'Millennium Falcon' },
            { num: 'CP-18', title: 'Lando Calrissian' },
            { num: 'CP-19', title: 'Darth Vader vs Luke Skywalker' },
            { num: 'CP-20', title: 'May the Force Be With You' },
            { num: 'CP-21', title: 'C-3PO & R2-D2' },
            { num: 'CP-22', title: 'Stormtrooper' },
            { num: 'CP-23', title: 'Luke Skywalker & Yoda' },
            { num: 'CP-24', title: 'Yoda' },
          ]
        },
        {
          count: 21,
          name: 'GALACTIC GRAFFITI',
          meta: 'Street-art treatments',
          odds: '1:40 packs',
          parallels: 5,
          cards: [
            { num: 'GG-1', title: 'Ahsoka Tano' },
            { num: 'GG-2', title: 'Baylan Skoll' },
            { num: 'GG-3', title: 'BB-8' },
            { num: 'GG-4', title: 'Boba Fett' },
            { num: 'GG-5', title: 'C-3P0 & R2-D2' },
            { num: 'GG-6', title: 'Captain Phasma' },
            { num: 'GG-7', title: 'Cassian Andor' },
            { num: 'GG-8', title: 'Chewbacca' },
            { num: 'GG-9', title: 'Darth Maul' },
            { num: 'GG-10', title: 'Ezra Bridger' },
            { num: 'GG-11', title: 'Grand Admiral Thrawn' },
            { num: 'GG-12', title: 'Jecki Lon' },
            { num: 'GG-13', title: 'Mace Windu' },
            { num: 'GG-14', title: 'Mae Aniseya' },
            { num: 'GG-15', title: 'Obi-Wan Kenobi' },
            { num: 'GG-16', title: 'Padmé Amidala' },
            { num: 'GG-17', title: 'Sabine Wren' },
            { num: 'GG-18', title: 'Stormtooper' },
            { num: 'GG-19', title: 'The Mandalorian' },
            { num: 'GG-20', title: 'The Stranger' },
            { num: 'GG-21', title: 'Yoda' },
          ]
        },
        {
          count: 10,
          name: 'BONUS STAGE',
          meta: 'Retro arcade art · Superfractor parallel only',
          odds: '1:160 packs',
          parallels: 1,
          cards: [
            { num: 'BS-AV', title: 'Asajj Ventress' },
            { num: 'BS-BK', title: 'Bo-Katan Kryze' },
            { num: 'BS-CB', title: 'Cad Bane' },
            { num: 'BS-F', title: 'Fives' },
            { num: 'BS-HO', title: 'Hondo Ohnaka' },
            { num: 'BS-HS', title: 'Hera Syndulla' },
            { num: 'BS-M', title: 'Darth Maul' },
            { num: 'BS-SG', title: 'Saw Gerrera' },
            { num: 'BS-SO', title: 'Savage Opress' },
            { num: 'BS-T', title: 'Grand Admiral Thrawn' },
          ]
        },
        {
          count: 20,
          name: 'KYBER LIGHT',
          meta: '20-card chase insert',
          odds: '1:240 packs',
          parallels: 3,
          cards: [
            { num: 'KL-1', title: 'Admiral Ackbar' },
            { num: 'KL-2', title: 'Ahsoka Tano' },
            { num: 'KL-3', title: 'Baylan Skoll' },
            { num: 'KL-4', title: 'BB-8' },
            { num: 'KL-5', title: 'C-3PO' },
            { num: 'KL-6', title: 'Chewbacca' },
            { num: 'KL-7', title: 'Darth Maul' },
            { num: 'KL-8', title: 'Figrin D\'an' },
            { num: 'KL-9', title: 'Greedo' },
            { num: 'KL-10', title: 'Han Solo' },
            { num: 'KL-11', title: 'IG-88' },
            { num: 'KL-12', title: 'Jabba the Hutt' },
            { num: 'KL-13', title: 'Jar Jar Binks' },
            { num: 'KL-14', title: 'Luke Skywalker' },
            { num: 'KL-15', title: 'Max Rebo' },
            { num: 'KL-16', title: 'Maz Kanata' },
            { num: 'KL-17', title: 'Padmé Amidala' },
            { num: 'KL-18', title: 'Stormtrooper' },
            { num: 'KL-19', title: 'The Mandalorian And Grogu' },
            { num: 'KL-20', title: 'Yoda' },
          ]
        },
        {
          count: 5,
          name: 'REFLECTIONS',
          meta: 'R-11 to R-15 · Superfractor parallel only',
          odds: '1:400 packs',
          parallels: 1,
          cards: [
            { num: 'R-11', title: 'C-3PO' },
            { num: 'R-12', title: 'Crossing Paths' },
            { num: 'R-13', title: 'Showdown on Scarif' },
            { num: 'R-14', title: 'Want Some Soup' },
            { num: 'R-15', title: 'Geonosis Reflections' },
          ]
        },
        {
          count: 5,
          name: 'COMICFRACTOR',
          meta: 'Comic cover art · VC-6 to VC-10',
          odds: '1:400 packs',
          parallels: 4,
          cards: [
            { num: 'VC-6', title: 'Anakin Skywalker' },
            { num: 'VC-7', title: 'Boba Fett' },
            { num: 'VC-8', title: 'Queen Padmé Amidala' },
            { num: 'VC-9', title: 'Artoo-Detoo' },
            { num: 'VC-10', title: 'Yoda' },
          ]
        },
        {
          count: 5,
          name: 'ONE WITH THE FORCE',
          meta: 'OF-6 to OF-10',
          noParallels: true,
          cards: [
            { num: 'OF-6', title: 'Ben Solo' },
            { num: 'OF-7', title: 'Chirrut Îmwe' },
            { num: 'OF-8', title: 'Leia Organa' },
            { num: 'OF-9', title: 'Luke Skywalker' },
            { num: 'OF-10', title: 'Mace Windu' },
          ]
        },
        {
          count: 25,
          name: 'DOUBLE VISION',
          meta: 'Dual-image design',
          noParallels: true,
          cards: [
            { num: 'DV-1', title: 'Ahsoka Tano' },
            { num: 'DV-2', title: 'Anakin Skywalker' },
            { num: 'DV-3', title: 'Aurra Sing' },
            { num: 'DV-4', title: 'Bo-Katan Kryze' },
            { num: 'DV-5', title: 'Cad Bane' },
            { num: 'DV-6', title: 'Chewbacca' },
            { num: 'DV-7', title: 'Clone Captain Rex' },
            { num: 'DV-8', title: 'Count Dooku' },
            { num: 'DV-9', title: 'Darth Sidious' },
            { num: 'DV-10', title: 'Ezra Bridger' },
            { num: 'DV-11', title: 'Garazeb "Zeb" Orrelios' },
            { num: 'DV-12', title: 'General Grievous' },
            { num: 'DV-13', title: 'Grand Admiral Thrawn' },
            { num: 'DV-14', title: 'Hera Syndulla' },
            { num: 'DV-15', title: 'Kit Fisto' },
            { num: 'DV-16', title: 'Mace Windu' },
            { num: 'DV-17', title: 'Darth Maul' },
            { num: 'DV-18', title: 'Obi-Wan Kenobi' },
            { num: 'DV-19', title: 'Padmé Amidala' },
            { num: 'DV-20', title: 'Plo Koon' },
            { num: 'DV-21', title: 'Professor Huyang' },
            { num: 'DV-22', title: 'Sabine Wren' },
            { num: 'DV-23', title: 'Saw Gerrera' },
            { num: 'DV-24', title: 'The Grand Inquisitor' },
            { num: 'DV-25', title: 'Yoda' },
          ]
        }
      ],
      auto: [
        {
          count: 122,
          name: 'AUTOGRAPH CARDS',
          meta: 'Single-signer · legends to first-time signers',
          parallels: 8,
          cards: [
            { num: 'A-SLKR', title: 'Supreme Leader Kylo Ren' },
            { num: 'A-AA', title: 'Bix Caleen' },
            { num: 'A-AW', title: 'Mortis Daughter' },
            { num: 'A-AB', title: 'Kelleran Beq' },
            { num: 'A-ABE', title: 'Jar Jar Binks' },
            { num: 'A-AF', title: 'Sergeant Linus Mosk' },
            { num: 'A-AL', title: 'Karis Nemik' },
            { num: 'A-AP', title: 'General Draven' },
            { num: 'A-AM', title: 'Aayla Secura' },
            { num: 'A-SE', title: 'Peli Motto' },
            { num: 'A-ASE', title: 'Kino Loy' },
            { num: 'A-SLS', title: 'Supreme Leader Snoke' },
            { num: 'A-AN', title: 'Bazine Netal' },
            { num: 'A-AD', title: 'C-3PO' },
            { num: 'A-LE', title: 'Major Partagaz' },
            { num: 'A-AV', title: 'Kassa' },
            { num: 'A-BL', title: 'Kaydel Connix' },
            { num: 'A-BDW', title: 'Lando Calrissian' },
            { num: 'A-BLA', title: 'Beru Lars' },
            { num: 'A-CJ', title: 'Gorian Shard' },
            { num: 'A-CAM', title: 'Indara' },
            { num: 'A-CH', title: 'Yord Fandar' },
            { num: 'A-CBA', title: 'C1-D1' },
            { num: 'A-CB', title: 'Klothow' },
            { num: 'A-DK', title: 'Jecki Lon' },
            { num: 'A-DR', title: 'Rey' },
            { num: 'A-DCA', title: 'B2EMO' },
            { num: 'A-DB', title: 'Jabba The Hutt' },
            { num: 'A-DCC', title: 'Torbin' },
            { num: 'A-DER', title: 'Droopy McCool' },
            { num: 'A-DGO', title: 'Dedra Meero' },
            { num: 'A-DLR', title: 'Morgan Elsbeth' },
            { num: 'A-DL', title: 'Cassian Andor' },
            { num: 'A-DGR', title: 'General Hux' },
            { num: 'A-EE', title: 'Ezra Bridger' },
            { num: 'A-ES', title: 'The Armorer' },
            { num: 'A-EK', title: 'Enfys Nest' },
            { num: 'A-EM', title: 'Obi-Wan Kenobi' },
            { num: 'A-FM', title: 'Vel Sartha' },
            { num: 'A-FJ', title: 'Jyn Erso' },
            { num: 'A-FS', title: 'Maarva Andor' },
            { num: 'A-FW', title: 'Saw Gerrera' },
            { num: 'A-FT', title: 'Captain Brutus' },
            { num: 'A-GB', title: 'Clem Andor' },
            { num: 'A-GOR', title: 'Mon Mothma' },
            { num: 'A-GE', title: 'Moff Gideon' },
            { num: 'A-GH', title: 'Grand Moff Tarkin' },
            { num: 'A-GC', title: 'Captain Phasma' },
            { num: 'A-HF', title: 'Han Solo' },
            { num: 'A-HC', title: 'Anakin Skywalker' },
            { num: 'A-IM', title: 'Emperor Palpatine' },
            { num: 'A-IW', title: 'Vetch' },
            { num: 'A-IS', title: 'Shin Hati' },
            { num: 'A-JC', title: 'Toro Calican' },
            { num: 'A-JAL', title: 'Gunter' },
            { num: 'A-JE', title: 'Owen Lars' },
            { num: 'A-JR', title: 'Major Bren Derlin' },
            { num: 'A-JS', title: 'Kelnacca' },
            { num: 'A-LAW', title: 'Jod Na Nawood' },
            { num: 'A-KCS', title: 'Rabé' },
            { num: 'A-KS', title: 'Bo-Katan Kryze' },
            { num: 'A-KCH', title: 'Queen Apailana' },
            { num: 'A-K', title: 'Pokkit' },
            { num: 'A-KMT', title: 'Rose Tico' },
            { num: 'A-KC', title: 'Admiral Piett' },
            { num: 'A-KR', title: 'Zorii Bliss' },
            { num: 'A-KOB', title: 'Pegla' },
            { num: 'A-LM', title: 'Grand Admiral Thrawn' },
            { num: 'A-LD', title: 'Vice Admiral Holdo' },
            { num: 'A-LJJ', title: 'Sol' },
            { num: 'A-LL', title: 'Major Vonreg' },
            { num: 'A-LN', title: 'Maz Kanata' },
            { num: 'A-MJ', title: 'The Stranger' },
            { num: 'A-MVE', title: 'Vult Skerris' },
            { num: 'A-MH', title: 'Luke Skywalker' },
            { num: 'A-MR', title: 'Captain Hayle' },
            { num: 'A-M', title: 'Poggle the Lesser' },
            { num: 'A-MEW', title: 'Hera Syndulla' },
            { num: 'A-MO', title: 'Luminara Unduli' },
            { num: 'A-MW', title: 'General Grievous' },
            { num: 'A-MA', title: 'Sully Stark' },
            { num: 'A-MSA', title: 'Barriss Offee' },
            { num: 'A-MC', title: 'Even Piell' },
            { num: 'A-MAG', title: 'Omega' },
            { num: 'A-MQ', title: 'Nien Nunb' },
            { num: 'A-MNW', title: 'Fennec Shand' },
            { num: 'A-MI', title: 'Reva' },
            { num: 'A-MB', title: 'Wilmon Paak' },
            { num: 'A-NP', title: 'Padmé Amidala' },
            { num: 'A-NLB', title: 'Sabine Wren' },
            { num: 'A-FRO', title: 'SM-33' },
            { num: 'A-AJ', title: 'Asajj Ventress' },
            { num: 'A-OSJ', title: 'Kawlan Roken' },
            { num: 'A-OS', title: 'Shaak Ti' },
            { num: 'A-OI', title: 'Poe Dameron' },
            { num: 'A-PB', title: 'Greedo' },
            { num: 'A-PD', title: 'Marrok' },
            { num: 'A-PP', title: 'The Mandalorian' },
            { num: 'A-MWE', title: 'Myn Weaver' },
            { num: 'A-PL', title: 'Kit Fisto' },
            { num: 'A-RAB', title: 'Queen Miraj Scintel' },
            { num: 'A-RCC', title: 'Wim' },
            { num: 'A-RP', title: 'Darth Maul' },
            { num: 'A-RH', title: 'Vernestra Rwoh' },
            { num: 'A-RA', title: 'Bodhi Rook' },
            { num: 'A-RTS', title: 'Neel' },
            { num: 'A-RD', title: 'Ahsoka Tano' },
            { num: 'A-RF', title: 'The Grand Inquisitor' },
            { num: 'A-RK', title: 'Fourth Sister Inquisitor' },
            { num: 'A-SWIT', title: 'Dinghy Driver' },
            { num: 'A-SLJ', title: 'Mace Windu' },
            { num: 'A-SP', title: 'Unkar Plutt' },
            { num: 'A-SW', title: 'Max Rebo' },
            { num: 'A-SI', title: 'Breha Organa' },
            { num: 'A-SS', title: 'Luthen Rael' },
            { num: 'A-TW', title: 'IG-11' },
            { num: 'A-TM', title: 'Boba Fett' },
            { num: 'A-TO', title: 'Cobb Vanth' },
            { num: 'A-TAD', title: 'Wendle' },
            { num: 'A-WD', title: 'Wicket W. Warrick' },
            { num: 'A-WE', title: 'The Client' },
            { num: 'A-ZV', title: 'Xanwan' },
          ]
        },
        {
          count: 15,
          name: 'DUO AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'DA-AD', title: 'General Hux & Supreme Leader Snoke' },
            { num: 'DA-BD', title: 'Kaydel Connix & Beaumont Kin' },
            { num: 'DA-CB', title: 'Jecki Lon & Yord Fandar' },
            { num: 'DA-CL', title: 'Indara & Sol' },
            { num: 'DA-DSK', title: 'Luthen Rael & Cassian Andor' },
            { num: 'DA-EP', title: 'The Mandalorian & The Armorer' },
            { num: 'DA-FM', title: 'Saw Gerrera & Galen Erso' },
            { num: 'DA-ID', title: 'Shin Hati & Morgan Elsbeth' },
            { num: 'DA-JA', title: 'Peli Motto & Toro Calican' },
            { num: 'DA-KB', title: 'Rose Tico & DJ' },
            { num: 'DA-MJj', title: 'Sol & The Stranger' },
            { num: 'DA-NJ', title: 'SM-33 & Jod Na Nawood' },
            { num: 'DA-RM', title: 'The Stranger & Vernestra Rwoh' },
            { num: 'DA-SD', title: 'Unkar Plutt & Rey' },
            { num: 'DA-WG', title: 'Moff Gideon & The Client' },
          ]
        },
        {
          count: 11,
          name: 'TRIO AUTOGRAPHS',
          meta: 'Three-signer',
          parallels: 2,
          cards: [
            { num: 'TA-CJD', title: 'Krrsantan, Garsa Fwip & Twi\'lek Majordomo' },
            { num: 'TA-EMR', title: 'Obi-Wan Kenobi, Reva & The Grand Inquisitor' },
            { num: 'TA-ENM', title: 'Hera Syndulla, Ezra Bridger & Sabine Wren' },
            { num: 'TA-FVG', title: 'Mon Mothma, Vel Sartha & Cinta Kaz' },
            { num: 'TA-FZI', title: 'Vetch, Xanwan & Maarva Andor' },
            { num: 'TA-HES', title: 'Anakin Skywalker, Mace Windu & Obi-Wan Kenobi' },
            { num: 'TA-JRN', title: 'Neel, Jod Na Nawood & SM-33' },
            { num: 'TA-JSM', title: 'The Modifier, Fennec Shand & Skad' },
            { num: 'TA-KDA', title: 'Sergeant Linus Mosk, Syril Karn & Dedra Meero' },
            { num: 'TA-MDN', title: 'Asajj Ventress, Omega & Hunter' },
            { num: 'TA-WTN', title: 'Kuill, IG-11 & The Client' },
          ]
        },
        {
          count: 47,
          name: '1975 TRIBUTE AUTO VARIATIONS',
          meta: 'Autographs on the tribute design',
          parallels: 1,
          cards: [
            { num: 'TV-AB', title: 'Jar Jar Binks' },
            { num: 'TV-AD', title: 'C-3PO' },
            { num: 'TV-ADR', title: 'Supreme Leader Kylo Ren' },
            { num: 'TV-BW', title: 'Lando Calrissian' },
            { num: 'TV-CF', title: 'Leia Organa' },
            { num: 'TV-DB', title: 'Jabba The Hutt' },
            { num: 'TV-DG', title: 'Dedra Meero' },
            { num: 'TV-DGL', title: 'General Hux' },
            { num: 'TV-DL', title: 'Cassian Andor' },
            { num: 'TV-DP', title: 'Darth Vader' },
            { num: 'TV-DY', title: 'Chirrut Îmwe' },
            { num: 'TV-EE', title: 'Ezra Bridger' },
            { num: 'TV-EM', title: 'Obi-Wan Kenobi' },
            { num: 'TV-ES', title: 'The Armorer' },
            { num: 'TV-FJ', title: 'Jyn Erso' },
            { num: 'TV-GC', title: 'Captain Phasma' },
            { num: 'TV-GE', title: 'Moff Gideon' },
            { num: 'TV-GH', title: 'Grand Moff Tarkin' },
            { num: 'TV-GR', title: 'Mon Mothma' },
            { num: 'TV-HC', title: 'Anakin Skywalker' },
            { num: 'TV-HF', title: 'Han Solo' },
            { num: 'TV-IM', title: 'Emperor Palpatine' },
            { num: 'TV-IS', title: 'Shin Hati' },
            { num: 'TV-JOS', title: 'Chewbacca' },
            { num: 'TV-KS', title: 'Bo-Katan Kryze' },
            { num: 'TV-LAW', title: 'Jod Na Nawood' },
            { num: 'TV-LJ', title: 'Sol' },
            { num: 'TV-LM', title: 'Grand Admiral Thrawn' },
            { num: 'TV-MEW', title: 'Hera Syndulla' },
            { num: 'TV-MH', title: 'Luke Skywalker' },
            { num: 'TV-MJ', title: 'The Stranger' },
            { num: 'TV-MQ', title: 'Nien Nunb' },
            { num: 'TV-MW', title: 'General Grievous' },
            { num: 'TV-NB', title: 'Sabine Wren' },
            { num: 'TV-NP', title: 'Padmé Amidala' },
            { num: 'TV-PB', title: 'Greedo' },
            { num: 'TV-PP', title: 'The Mandalorian' },
            { num: 'TV-RD', title: 'Ahsoka Tano' },
            { num: 'TV-RP', title: 'Darth Maul' },
            { num: 'TV-SJ', title: 'Mace Windu' },
            { num: 'TV-SP', title: 'Unkar Plutt' },
            { num: 'TV-SS', title: 'Luthen Rael' },
            { num: 'TV-TM', title: 'Boba Fett' },
            { num: 'TV-TR', title: 'Admiral Ackbar' },
            { num: 'TV-TW', title: 'IG-11' },
            { num: 'TV-WD', title: 'Wicket W. Warrick' },
            { num: 'TV-WILL', title: 'Max Rebo' },
          ]
        }
      ],
      sketch: [
        {
          count: 188,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches · Silver, Gold & Black Foil 1/1s',
          oneOfOne: true,
          odds: '1:84 packs',
          parallels: 3,
          cards: [
            { num: '1', title: 'Sketch Card', meta: 'Adam Beck' },
            { num: '2', title: 'Sketch Card', meta: 'Aleksandr Gigov' },
            { num: '3', title: 'Sketch Card', meta: 'Alex Mines' },
            { num: '4', title: 'Sketch Card', meta: 'Alexander Diab' },
            { num: '5', title: 'Sketch Card', meta: 'Allen Grimes' },
            { num: '6', title: 'Sketch Card', meta: 'Andrew Fry' },
            { num: '7', title: 'Sketch Card', meta: 'Andy Hanks' },
            { num: '8', title: 'Sketch Card', meta: 'Angel Aviles' },
            { num: '9', title: 'Sketch Card', meta: 'Angelina Benedetti' },
            { num: '10', title: 'Sketch Card', meta: 'Anthony Pietszak' },
            { num: '11', title: 'Sketch Card', meta: 'Antni Ellison' },
            { num: '12', title: 'Sketch Card', meta: 'Ari Arnaldsson' },
            { num: '13', title: 'Sketch Card', meta: 'Ashley Marsh' },
            { num: '14', title: 'Sketch Card', meta: 'Basak Kahraman' },
            { num: '15', title: 'Sketch Card', meta: 'Ben Jones' },
            { num: '16', title: 'Sketch Card', meta: 'Bistek Javier' },
            { num: '17', title: 'Sketch Card', meta: 'Bobby Blakey' },
            { num: '18', title: 'Sketch Card', meta: 'Brandon "B.Done" Blevins' },
            { num: '19', title: 'Sketch Card', meta: 'Brandon Klein' },
            { num: '20', title: 'Sketch Card', meta: 'Brent Ragland' },
            { num: '21', title: 'Sketch Card', meta: 'C DUB' },
            { num: '22', title: 'Sketch Card', meta: 'Candice Clemmons' },
            { num: '23', title: 'Sketch Card', meta: 'Charlie Cody' },
            { num: '24', title: 'Sketch Card', meta: 'Chris Meeks' },
            { num: '25', title: 'Sketch Card', meta: 'Chris Thorne' },
            { num: '26', title: 'Sketch Card', meta: 'Cisco Rivera' },
            { num: '27', title: 'Sketch Card', meta: 'Cyrus Sherkat' },
            { num: '28', title: 'Sketch Card', meta: 'Dan Bergren' },
            { num: '29', title: 'Sketch Card', meta: 'Dan Cooney' },
            { num: '30', title: 'Sketch Card', meta: 'Dan Curto' },
            { num: '31', title: 'Sketch Card', meta: 'Dan Gorman' },
            { num: '32', title: 'Sketch Card', meta: 'Dan Lawler' },
            { num: '33', title: 'Sketch Card', meta: 'Dan Tearle' },
            { num: '34', title: 'Sketch Card', meta: 'Daniel Chavez' },
            { num: '35', title: 'Sketch Card', meta: 'Daniel Riveron' },
            { num: '36', title: 'Sketch Card', meta: 'Darrin Pepe' },
            { num: '37', title: 'Sketch Card', meta: 'Dave Fowler' },
            { num: '38', title: 'Sketch Card', meta: 'Dave Gaskin' },
            { num: '39', title: 'Sketch Card', meta: 'David "Dove" McHargue' },
            { num: '40', title: 'Sketch Card', meta: 'David Willingham' },
            { num: '41', title: 'Sketch Card', meta: 'Dawn Murphy' },
            { num: '42', title: 'Sketch Card', meta: 'Don Pedicini Jr' },
            { num: '43', title: 'Sketch Card', meta: 'Douglas Stromenger' },
            { num: '44', title: 'Sketch Card', meta: 'Dwayne Carpenter' },
            { num: '45', title: 'Sketch Card', meta: 'Dylan Riley' },
            { num: '46', title: 'Sketch Card', meta: 'El Smetchö' },
            { num: '47', title: 'Sketch Card', meta: 'Elvin A Hernandez' },
            { num: '48', title: 'Sketch Card', meta: 'Emma Douglas' },
            { num: '49', title: 'Sketch Card', meta: 'Emrah Cildir' },
            { num: '50', title: 'Sketch Card', meta: 'Emre Varlıbaş' },
            { num: '51', title: 'Sketch Card', meta: 'Eric Lehtonen' },
            { num: '52', title: 'Sketch Card', meta: 'Eric Medina' },
            { num: '53', title: 'Sketch Card', meta: 'Erik Muller' },
            { num: '54', title: 'Sketch Card', meta: 'Evgheni Batu' },
            { num: '55', title: 'Sketch Card', meta: 'Frank A. Kadar' },
            { num: '56', title: 'Sketch Card', meta: 'Frank Sansone' },
            { num: '57', title: 'Sketch Card', meta: 'Franklim Teixeira' },
            { num: '58', title: 'Sketch Card', meta: 'Gabe Farber' },
            { num: '59', title: 'Sketch Card', meta: 'Gerry Garcia Jr' },
            { num: '60', title: 'Sketch Card', meta: 'Greg Treize' },
            { num: '61', title: 'Sketch Card', meta: 'Guilherme Rocha' },
            { num: '62', title: 'Sketch Card', meta: 'Ian McKesson' },
            { num: '63', title: 'Sketch Card', meta: 'Isiah Xavier Bradley' },
            { num: '64', title: 'Sketch Card', meta: 'J. Hammond' },
            { num: '65', title: 'Sketch Card', meta: 'Jaime Lopez' },
            { num: '66', title: 'Sketch Card', meta: 'Jake Minor' },
            { num: '67', title: 'Sketch Card', meta: 'James Boyd' },
            { num: '68', title: 'Sketch Card', meta: 'James Harris' },
            { num: '69', title: 'Sketch Card', meta: 'Jamie Richards' },
            { num: '70', title: 'Sketch Card', meta: 'Jamison Murdock' },
            { num: '71', title: 'Sketch Card', meta: 'Jason Adams' },
            { num: '72', title: 'Sketch Card', meta: 'Jason Christner' },
            { num: '73', title: 'Sketch Card', meta: 'Jason Davies' },
            { num: '74', title: 'Sketch Card', meta: 'Jason Montoya' },
            { num: '75', title: 'Sketch Card', meta: 'Jason Queen' },
            { num: '76', title: 'Sketch Card', meta: 'Jason Saldajeno' },
            { num: '77', title: 'Sketch Card', meta: 'Jason Sobol' },
            { num: '78', title: 'Sketch Card', meta: 'Jay Manchand' },
            { num: '79', title: 'Sketch Card', meta: 'Jeffrey C. Benitez' },
            { num: '80', title: 'Sketch Card', meta: 'Jenna McGrath' },
            { num: '81', title: 'Sketch Card', meta: 'Jessica Hickman' },
            { num: '82', title: 'Sketch Card', meta: 'Jessica Van Dusen' },
            { num: '83', title: 'Sketch Card', meta: 'Jim O\'Riley' },
            { num: '84', title: 'Sketch Card', meta: 'Joe Ortiz' },
            { num: '85', title: 'Sketch Card', meta: 'Joey Mason' },
            { num: '86', title: 'Sketch Card', meta: 'John "JAR" Rodriguez' },
            { num: '87', title: 'Sketch Card', meta: 'John Bruce' },
            { num: '88', title: 'Sketch Card', meta: 'John Pleak' },
            { num: '89', title: 'Sketch Card', meta: 'John Still' },
            { num: '90', title: 'Sketch Card', meta: 'Jonathan Beistline' },
            { num: '91', title: 'Sketch Card', meta: 'Josh Trout' },
            { num: '92', title: 'Sketch Card', meta: 'Jude Gallagher' },
            { num: '93', title: 'Sketch Card', meta: 'Julia McKenzie' },
            { num: '94', title: 'Sketch Card', meta: 'Julie-Anne' },
            { num: '95', title: 'Sketch Card', meta: 'Justin Bruce Lee' },
            { num: '96', title: 'Sketch Card', meta: 'Kang Jing' },
            { num: '97', title: 'Sketch Card', meta: 'Karl Jones' },
            { num: '98', title: 'Sketch Card', meta: 'Kevin Cleveland' },
            { num: '99', title: 'Sketch Card', meta: 'Kevin Graham' },
            { num: '100', title: 'Sketch Card', meta: 'Kevin P. West' },
            { num: '101', title: 'Sketch Card', meta: 'Kevin Scott Jacobs' },
            { num: '102', title: 'Sketch Card', meta: 'Khloe Delnick' },
            { num: '103', title: 'Sketch Card', meta: 'Khushi Mahajan' },
            { num: '104', title: 'Sketch Card', meta: 'Kirk Chavarria' },
            { num: '105', title: 'Sketch Card', meta: 'Kris Penix' },
            { num: '106', title: 'Sketch Card', meta: 'Krishna Sharma' },
            { num: '107', title: 'Sketch Card', meta: 'Kyle Babbitt' },
            { num: '108', title: 'Sketch Card', meta: 'Lee Lightfoot' },
            { num: '109', title: 'Sketch Card', meta: 'Limuel Pinzon' },
            { num: '110', title: 'Sketch Card', meta: 'Lindsey Greyling' },
            { num: '111', title: 'Sketch Card', meta: 'Loc Nguyen' },
            { num: '112', title: 'Sketch Card', meta: 'Lukas Maurer' },
            { num: '113', title: 'Sketch Card', meta: 'Luke Seavers' },
            { num: '114', title: 'Sketch Card', meta: 'Madison Emerick' },
            { num: '115', title: 'Sketch Card', meta: 'Marcia Dye' },
            { num: '116', title: 'Sketch Card', meta: 'Mark Stroud' },
            { num: '117', title: 'Sketch Card', meta: 'Marlo Agunos' },
            { num: '118', title: 'Sketch Card', meta: 'Mathilde Machuel' },
            { num: '119', title: 'Sketch Card', meta: 'Matt Maldonado' },
            { num: '120', title: 'Sketch Card', meta: 'Matt Steffens' },
            { num: '121', title: 'Sketch Card', meta: 'Matt Stewart' },
            { num: '122', title: 'Sketch Card', meta: 'Matthew Skillern' },
            { num: '123', title: 'Sketch Card', meta: 'Matthew Sutton' },
            { num: '124', title: 'Sketch Card', meta: 'Mayumi Seto' },
            { num: '125', title: 'Sketch Card', meta: 'Michael Mastermaker' },
            { num: '126', title: 'Sketch Card', meta: 'Michael Munshaw' },
            { num: '127', title: 'Sketch Card', meta: 'Michael W. Foreman II' },
            { num: '128', title: 'Sketch Card', meta: 'Mike Dalzell' },
            { num: '129', title: 'Sketch Card', meta: 'Mike Davidson' },
            { num: '130', title: 'Sketch Card', meta: 'Mike J Sealie' },
            { num: '131', title: 'Sketch Card', meta: 'Mike LaPeruta' },
            { num: '132', title: 'Sketch Card', meta: 'Mike Stephens' },
            { num: '133', title: 'Sketch Card', meta: 'Nathaniel Howard' },
            { num: '134', title: 'Sketch Card', meta: 'Neil A Brady' },
            { num: '135', title: 'Sketch Card', meta: 'Neil Camera' },
            { num: '136', title: 'Sketch Card', meta: 'Nick Gribbon' },
            { num: '137', title: 'Sketch Card', meta: 'Oscar Chavez' },
            { num: '138', title: 'Sketch Card', meta: 'Patricio Carrasco' },
            { num: '139', title: 'Sketch Card', meta: 'Phillip Trujillo' },
            { num: '140', title: 'Sketch Card', meta: 'Quinton Baker' },
            { num: '141', title: 'Sketch Card', meta: 'Rachel Jane Hetherington' },
            { num: '142', title: 'Sketch Card', meta: 'Rebeca Louro' },
            { num: '143', title: 'Sketch Card', meta: 'Rees Chua-Finlay' },
            { num: '144', title: 'Sketch Card', meta: 'Rich "RAM" Molinelli' },
            { num: '145', title: 'Sketch Card', meta: 'Rich Hennemann' },
            { num: '146', title: 'Sketch Card', meta: 'Rico Dela Rosa' },
            { num: '147', title: 'Sketch Card', meta: 'Rob Demers' },
            { num: '148', title: 'Sketch Card', meta: 'Robert Hendrickson' },
            { num: '149', title: 'Sketch Card', meta: 'Rugved Bhuskute' },
            { num: '150', title: 'Sketch Card', meta: 'Rustico Limosinero' },
            { num: '151', title: 'Sketch Card', meta: 'Rusty Gilligan' },
            { num: '152', title: 'Sketch Card', meta: 'Rutvig Vaid' },
            { num: '153', title: 'Sketch Card', meta: 'Ryan Crosby' },
            { num: '154', title: 'Sketch Card', meta: 'Ryan Edwards' },
            { num: '155', title: 'Sketch Card', meta: 'Ryan Finley' },
            { num: '156', title: 'Sketch Card', meta: 'Ryan Johnston' },
            { num: '157', title: 'Sketch Card', meta: 'Ryan Olsen' },
            { num: '158', title: 'Sketch Card', meta: 'Ryan Thompson' },
            { num: '159', title: 'Sketch Card', meta: 'Sammy Gomez' },
            { num: '160', title: 'Sketch Card', meta: 'Scott Anthony' },
            { num: '161', title: 'Sketch Card', meta: 'Scott Houseman' },
            { num: '162', title: 'Sketch Card', meta: 'Scott West' },
            { num: '163', title: 'Sketch Card', meta: 'Scott Zenteno' },
            { num: '164', title: 'Sketch Card', meta: 'Sean Earey' },
            { num: '165', title: 'Sketch Card', meta: 'Sean Mathews' },
            { num: '166', title: 'Sketch Card', meta: 'Semra Bulut' },
            { num: '167', title: 'Sketch Card', meta: 'Shaow Siong' },
            { num: '168', title: 'Sketch Card', meta: 'Shyla Lee' },
            { num: '169', title: 'Sketch Card', meta: 'Sir Edmund Duke' },
            { num: '170', title: 'Sketch Card', meta: 'Stax' },
            { num: '171', title: 'Sketch Card', meta: 'Stephane Leonardi' },
            { num: '172', title: 'Sketch Card', meta: 'Stephanie Swanger' },
            { num: '173', title: 'Sketch Card', meta: 'Steve Alce' },
            { num: '174', title: 'Sketch Card', meta: 'Taylor Chojecki' },
            { num: '175', title: 'Sketch Card', meta: 'Ted Dastick Jr' },
            { num: '176', title: 'Sketch Card', meta: 'Todd Aaron Smith' },
            { num: '177', title: 'Sketch Card', meta: 'Tom Amici' },
            { num: '178', title: 'Sketch Card', meta: 'Tomoko Taniguchi' },
            { num: '179', title: 'Sketch Card', meta: 'Tony Riley' },
            { num: '180', title: 'Sketch Card', meta: 'Traci Easterday' },
            { num: '181', title: 'Sketch Card', meta: 'Trent Westbrook' },
            { num: '182', title: 'Sketch Card', meta: 'Veronica Louro' },
            { num: '183', title: 'Sketch Card', meta: 'Veronica Smith' },
            { num: '184', title: 'Sketch Card', meta: 'Vincenzo "Chenduz" D\'Ippolito' },
            { num: '185', title: 'Sketch Card', meta: 'Vini Pirani' },
            { num: '186', title: 'Sketch Card', meta: 'Ward Silverman' },
            { num: '187', title: 'Sketch Card', meta: 'Will Pleydon' },
            { num: '188', title: 'Sketch Card', meta: 'Zach Woolsey' },
          ]
        }
      ],
    },
  },

  '2024-topps-chrome-sw': {
    setId: '2024-topps-chrome-sw',
    year: '2024',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS',
    releaseDate: '8 / 14 / 2024',
    lede: 'The second flagship Chrome Star Wars — and the debut of the Debut Medallion stamp for first-time cards. A 150-card chromium base set spanning the films and the Disney+ era, Aurebesh and Hoth FrozenFractor short-print mirrors, nine insert lines from Galactic Gear to Starship Blueprints, a 115-card autograph program in three tiers with an autograph in every hobby box, and an 82-artist sketch roster.',
    stats: [
      { num: '150', label: 'Base Cards', sub: 'Films + Disney+ era', color: 'gold' },
      { num: '9', label: 'Insert Sets', sub: '5 to 25 cards each', color: 'cyan' },
      { num: '115', label: 'Auto Cards', sub: '3 signature tiers', color: 'green' },
      { num: '15', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '16', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '10', l: 'Packs per box' },
      { v: '10', l: 'Cards per pack' },
      { v: '8', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
    ],
    pullRates: [
      { name: 'The Rise of Palpatine', odds: '1 : 5', tier: 'normal' },
      { name: 'The Heiress', odds: '1 : 6', tier: 'normal' },
      { name: 'Galactic Civil War', odds: '1 : 8', tier: 'normal' },
      { name: 'Galactic Gear', odds: '1 : 10', tier: 'normal' },
      { name: 'Starship Blueprints', odds: '1 : 192', tier: 'rare' },
      { name: 'Bonus Stage', odds: 'Super limited', tier: 'mythic' },
      { name: 'Reflections', odds: 'Extremely limited', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'RAINBOW', pr: '∞', gradient: 'linear-gradient(135deg, #ffb3ba 0%, #ffdfba 25%, #baffc9 50%, #bae1ff 75%, #e3baff 100%)', darkText: true },
      { name: 'BLUE BLASTER PULSAR', pr: '∞', gradient: 'radial-gradient(circle at 50% 50%, #80b0ff 0%, #2050d0 70%)' },
      { name: 'RED BLASTER RAYWAVE', pr: '∞', gradient: 'linear-gradient(135deg, #ff6b6b 0%, #c01010 60%, #ff9090 100%)' },
      { name: 'KAMINO AQUA', pr: '/199', gradient: 'linear-gradient(135deg, #40e8e0 0%, #00a0a0 60%, #80fff0 100%)', darkText: true },
      { name: 'SKYWALKER BLUE', pr: '/150', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'KASHYYYK GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'REBEL ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'MUSTAFAR LAVA', pr: '/10', gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'DATHOMIR RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'PRINTING PLATE CYAN', pr: '1/1', gradient: 'linear-gradient(135deg, #00e5ff 0%, #0090a8 100%)', darkText: true },
      { name: 'PRINTING PLATE MAGENTA', pr: '1/1', gradient: 'linear-gradient(135deg, #ff40a0 0%, #c01070 100%)' },
      { name: 'PRINTING PLATE YELLOW', pr: '1/1', gradient: 'linear-gradient(135deg, #ffee58 0%, #d0b820 100%)', darkText: true },
      { name: 'PRINTING PLATE BLACK', pr: '1/1', gradient: 'linear-gradient(135deg, #404040 0%, #101010 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 150,
          name: 'BASE SET',
          meta: 'Characters across the full Star Wars universe',
          parallels: 15,
          cards: [
            { num: '1', title: 'Ahsoka Tano' },
            { num: '2', title: 'Hera Syndulla' },
            { num: '3', title: 'Sabine Wren' },
            { num: '4', title: 'Grand Admiral Thrawn' },
            { num: '5', title: 'Baylan Skoll' },
            { num: '6', title: 'Shin Hati' },
            { num: '7', title: 'Cassian Andor' },
            { num: '8', title: 'Mon Mothma' },
            { num: '9', title: 'Luthen Rael' },
            { num: '10', title: 'Bix Caleen' },
            { num: '11', title: 'Kino Loy' },
            { num: '12', title: 'Syril Karn' },
            { num: '13', title: 'Maarva Andor' },
            { num: '14', title: 'Dedra Meero' },
            { num: '15', title: 'Vel Sartha' },
            { num: '16', title: 'Cinta Kaz' },
            { num: '17', title: 'Saw Gerrera' },
            { num: '18', title: 'B2EMO' },
            { num: '19', title: 'Boba Fett' },
            { num: '20', title: 'Fennec Shand' },
            { num: '21', title: 'The Mandalorian' },
            { num: '22', title: 'Grogu' },
            { num: '23', title: '8D8' },
            { num: '24', title: 'Twi\'lek Majordomo' },
            { num: '25', title: 'Garsa Fwip' },
            { num: '26', title: 'Krrsantan' },
            { num: '27', title: 'The Twins' },
            { num: '28', title: 'Drash' },
            { num: '29', title: 'Skad' },
            { num: '30', title: 'The Modifier' },
            { num: '31', title: 'Peli Motto' },
            { num: '32', title: 'Cobb Vanth' },
            { num: '33', title: 'Cad Bane' },
            { num: '34', title: 'Camie' },
            { num: '35', title: 'Fixer' },
            { num: '36', title: 'Carson Teva' },
            { num: '37', title: 'Moff Gideon' },
            { num: '38', title: 'Bo-Katan Kryze' },
            { num: '39', title: 'The Armorer' },
            { num: '40', title: 'IG-12' },
            { num: '41', title: 'IG-11' },
            { num: '42', title: 'Mayfeld' },
            { num: '43', title: 'Greef Karga' },
            { num: '44', title: 'The Client' },
            { num: '45', title: 'Kuiil' },
            { num: '46', title: 'Koska Reeves' },
            { num: '47', title: 'Elia Kane' },
            { num: '48', title: 'Axe Woves' },
            { num: '49', title: 'Paz Vizsla' },
            { num: '50', title: 'Toro Calican' },
            { num: '51', title: 'Ranzar Malk' },
            { num: '52', title: 'Commissioner Helgait' },
            { num: '53', title: 'The Duchess' },
            { num: '54', title: 'Captain Bombardier' },
            { num: '55', title: 'Colonel Tuttle' },
            { num: '56', title: 'Kelleran Beq' },
            { num: '57', title: 'Morgan Elsbeth' },
            { num: '58', title: 'Qin' },
            { num: '59', title: 'Xi\'an' },
            { num: '60', title: 'Burg' },
            { num: '61', title: 'Q9-0' },
            { num: '62', title: 'Gorian Shard' },
            { num: '63', title: 'Boba Fett\'s Rancor' },
            { num: '64', title: 'Rancor Keeper' },
            { num: '65', title: 'Tatooine Sand Beast' },
            { num: '66', title: 'Darth Vader' },
            { num: '67', title: 'Obi-Wan Kenobi' },
            { num: '68', title: 'Reva' },
            { num: '69', title: 'Princess Leia' },
            { num: '70', title: 'Luke Skywalker' },
            { num: '71', title: 'Uncle Owen' },
            { num: '72', title: 'Aunt Beru' },
            { num: '73', title: 'Breha Organa' },
            { num: '74', title: 'Bail Organa' },
            { num: '75', title: 'Vect Nokru' },
            { num: '76', title: 'L0LA' },
            { num: '77', title: 'Fifth Brother' },
            { num: '78', title: 'The Grand Inquisitor' },
            { num: '79', title: 'Haja Estree' },
            { num: '80', title: 'Fourth Sister' },
            { num: '81', title: 'Freck' },
            { num: '82', title: 'Purge Trooper' },
            { num: '83', title: 'Tala Durith' },
            { num: '84', title: 'NED-B' },
            { num: '85', title: 'Vane' },
            { num: '86', title: 'Praetorian Guard' },
            { num: '87', title: 'Pit Droid' },
            { num: '88', title: 'R5-D4' },
            { num: '89', title: 'Mudhorn' },
            { num: '90', title: 'Freedi Pamular' },
            { num: '91', title: 'Doctor Quadpaw' },
            { num: '92', title: 'Nurchi' },
            { num: '93', title: 'Salman Paak' },
            { num: '94', title: 'Steelpecker' },
            { num: '95', title: 'Corellian Hound' },
            { num: '96', title: 'Leida Mothma' },
            { num: '97', title: 'Perrin Fertha' },
            { num: '98', title: 'Melshi' },
            { num: '99', title: 'Captain Enoch' },
            { num: '100', title: 'Jacen Syndulla' },
            { num: '101', title: 'K-2SO' },
            { num: '102', title: 'Han Solo' },
            { num: '103', title: 'Leia Organa' },
            { num: '104', title: 'Luke Skywalker' },
            { num: '105', title: 'Wedge Antilles' },
            { num: '106', title: 'Lando Calrissian' },
            { num: '107', title: 'Chewbacca' },
            { num: '108', title: 'R2-D2' },
            { num: '109', title: 'C-3PO' },
            { num: '110', title: 'BB-8' },
            { num: '111', title: 'D-0' },
            { num: '112', title: 'Rey' },
            { num: '113', title: 'Finn' },
            { num: '114', title: 'Poe Dameron' },
            { num: '115', title: 'Kylo Ren' },
            { num: '116', title: 'General Hux' },
            { num: '117', title: 'Supreme Leader Snoke' },
            { num: '118', title: 'Jabba The Hutt' },
            { num: '119', title: 'Jyn Erso' },
            { num: '120', title: 'Director Krennic' },
            { num: '121', title: 'Admiral Ackbar' },
            { num: '122', title: 'Nien Nunb' },
            { num: '123', title: 'Wicket W. Warrick' },
            { num: '124', title: 'Kanan Jarrus' },
            { num: '125', title: 'Ezra Bridger' },
            { num: '126', title: 'Zeb Orrelios' },
            { num: '127', title: 'Jar Jar Binks' },
            { num: '128', title: 'Qui-Gon Jinn' },
            { num: '129', title: 'Count Dooku' },
            { num: '130', title: 'Padmé Amidala' },
            { num: '131', title: 'Emperor Palpatine' },
            { num: '132', title: 'Sebulba' },
            { num: '133', title: 'Captain Phasma' },
            { num: '134', title: 'Maz Kanata' },
            { num: '135', title: 'General Grievous' },
            { num: '136', title: 'Asajj Ventress' },
            { num: '137', title: 'Captain Rex' },
            { num: '138', title: 'Mace Windu' },
            { num: '139', title: 'Jango Fett' },
            { num: '140', title: 'Yoda' },
            { num: '141', title: 'Kit Fisto' },
            { num: '142', title: 'Dexter Jettster' },
            { num: '143', title: 'Aayla Secura' },
            { num: '144', title: 'Barriss Offee' },
            { num: '145', title: 'Luminara Unduli' },
            { num: '146', title: 'Saesee Tiin' },
            { num: '147', title: 'Plo Koon' },
            { num: '148', title: 'Aurra Sing' },
            { num: '149', title: 'Dryden Vos' },
            { num: '150', title: 'Qi\'ra' },
          ]
        },
        {
          count: 150,
          name: 'AUREBESH SP VARIATIONS',
          meta: 'All 150 base cards in Aurebesh script',
          parallels: 5,
          cards: [
            { num: 'AV-1', title: 'Ahsoka Tano' },
            { num: 'AV-2', title: 'Hera Syndulla' },
            { num: 'AV-3', title: 'Sabine Wren' },
            { num: 'AV-4', title: 'Grand Admiral Thrawn' },
            { num: 'AV-5', title: 'Baylan Skoll' },
            { num: 'AV-6', title: 'Shin Hati' },
            { num: 'AV-7', title: 'Cassian Andor' },
            { num: 'AV-8', title: 'Mon Mothma' },
            { num: 'AV-9', title: 'Luthen Rael' },
            { num: 'AV-10', title: 'Bix Caleen' },
            { num: 'AV-11', title: 'Kino Loy' },
            { num: 'AV-12', title: 'Syril Karn' },
            { num: 'AV-13', title: 'Maarva Andor' },
            { num: 'AV-14', title: 'Dedra Meero' },
            { num: 'AV-15', title: 'Vel Sartha' },
            { num: 'AV-16', title: 'Cinta Kaz' },
            { num: 'AV-17', title: 'Saw Gerrera' },
            { num: 'AV-18', title: 'B2EMO' },
            { num: 'AV-19', title: 'Boba Fett' },
            { num: 'AV-20', title: 'Fennec Shand' },
            { num: 'AV-21', title: 'The Mandalorian' },
            { num: 'AV-22', title: 'Grogu' },
            { num: 'AV-23', title: '8D8' },
            { num: 'AV-24', title: 'Twi\'lek Majordomo' },
            { num: 'AV-25', title: 'Garsa Fwip' },
            { num: 'AV-26', title: 'Krrsantan' },
            { num: 'AV-27', title: 'The Twins' },
            { num: 'AV-28', title: 'Drash' },
            { num: 'AV-29', title: 'Skad' },
            { num: 'AV-30', title: 'The Modifier' },
            { num: 'AV-31', title: 'Peli Motto' },
            { num: 'AV-32', title: 'Cobb Vanth' },
            { num: 'AV-33', title: 'Cad Bane' },
            { num: 'AV-34', title: 'Camie' },
            { num: 'AV-35', title: 'Fixer' },
            { num: 'AV-36', title: 'Carson Teva' },
            { num: 'AV-37', title: 'Moff Gideon' },
            { num: 'AV-38', title: 'Bo-Katan Kryze' },
            { num: 'AV-39', title: 'The Armorer' },
            { num: 'AV-40', title: 'IG-12' },
            { num: 'AV-41', title: 'IG-11' },
            { num: 'AV-42', title: 'Mayfeld' },
            { num: 'AV-43', title: 'Greef Karga' },
            { num: 'AV-44', title: 'The Client' },
            { num: 'AV-45', title: 'Kuiil' },
            { num: 'AV-46', title: 'Koska Reeves' },
            { num: 'AV-47', title: 'Elia Kane' },
            { num: 'AV-48', title: 'Axe Woves' },
            { num: 'AV-49', title: 'Paz Vizsla' },
            { num: 'AV-50', title: 'Toro Calican' },
            { num: 'AV-51', title: 'Ranzar Malk' },
            { num: 'AV-52', title: 'Commissioner Helgait' },
            { num: 'AV-53', title: 'The Duchess' },
            { num: 'AV-54', title: 'Captain Bombardier' },
            { num: 'AV-55', title: 'Colonel Tuttle' },
            { num: 'AV-56', title: 'Kelleran Beq' },
            { num: 'AV-57', title: 'Morgan Elsbeth' },
            { num: 'AV-58', title: 'Qin' },
            { num: 'AV-59', title: 'Xi\'an' },
            { num: 'AV-60', title: 'Burg' },
            { num: 'AV-61', title: 'Q9-0' },
            { num: 'AV-62', title: 'Gorian Shard' },
            { num: 'AV-63', title: 'Boba Fett\'s Rancor' },
            { num: 'AV-64', title: 'Rancor Keeper' },
            { num: 'AV-65', title: 'Tatooine Sand Beast' },
            { num: 'AV-66', title: 'Darth Vader' },
            { num: 'AV-67', title: 'Obi-Wan Kenobi' },
            { num: 'AV-68', title: 'Reva' },
            { num: 'AV-69', title: 'Princess Leia' },
            { num: 'AV-70', title: 'Luke Skywalker' },
            { num: 'AV-71', title: 'Uncle Owen' },
            { num: 'AV-72', title: 'Aunt Beru' },
            { num: 'AV-73', title: 'Breha Organa' },
            { num: 'AV-74', title: 'Bail Organa' },
            { num: 'AV-75', title: 'Vect Nokru' },
            { num: 'AV-76', title: 'L0LA' },
            { num: 'AV-77', title: 'Fifth Brother' },
            { num: 'AV-78', title: 'The Grand Inquisitor' },
            { num: 'AV-79', title: 'Haja Estree' },
            { num: 'AV-80', title: 'Fourth Sister' },
            { num: 'AV-81', title: 'Freck' },
            { num: 'AV-82', title: 'Purge Trooper' },
            { num: 'AV-83', title: 'Tala Durith' },
            { num: 'AV-84', title: 'NED-B' },
            { num: 'AV-85', title: 'Vane' },
            { num: 'AV-86', title: 'Praetorian Guard' },
            { num: 'AV-87', title: 'Pit Droid' },
            { num: 'AV-88', title: 'R5-D4' },
            { num: 'AV-89', title: 'Mudhorn' },
            { num: 'AV-90', title: 'Freedi Pamular' },
            { num: 'AV-91', title: 'Doctor Quadpaw' },
            { num: 'AV-92', title: 'Nurchi' },
            { num: 'AV-93', title: 'Salman Paak' },
            { num: 'AV-94', title: 'Steelpecker' },
            { num: 'AV-95', title: 'Corellian Hound' },
            { num: 'AV-96', title: 'Leida Mothma' },
            { num: 'AV-97', title: 'Perrin Fertha' },
            { num: 'AV-98', title: 'Melshi' },
            { num: 'AV-99', title: 'Captain Enoch' },
            { num: 'AV-100', title: 'Jacen Syndulla' },
            { num: 'AV-101', title: 'K-2SO' },
            { num: 'AV-102', title: 'Han Solo' },
            { num: 'AV-103', title: 'Leia Organa' },
            { num: 'AV-104', title: 'Luke Skywalker' },
            { num: 'AV-105', title: 'Wedge Antilles' },
            { num: 'AV-106', title: 'Lando Calrissian' },
            { num: 'AV-107', title: 'Chewbacca' },
            { num: 'AV-108', title: 'R2-D2' },
            { num: 'AV-109', title: 'C-3PO' },
            { num: 'AV-110', title: 'BB-8' },
            { num: 'AV-111', title: 'D-0' },
            { num: 'AV-112', title: 'Rey' },
            { num: 'AV-113', title: 'Finn' },
            { num: 'AV-114', title: 'Poe Dameron' },
            { num: 'AV-115', title: 'Kylo Ren' },
            { num: 'AV-116', title: 'General Hux' },
            { num: 'AV-117', title: 'Supreme Leader Snoke' },
            { num: 'AV-118', title: 'Jabba The Hutt' },
            { num: 'AV-119', title: 'Jyn Erso' },
            { num: 'AV-120', title: 'Director Krennic' },
            { num: 'AV-121', title: 'Admiral Ackbar' },
            { num: 'AV-122', title: 'Nien Nunb' },
            { num: 'AV-123', title: 'Wicket W. Warrick' },
            { num: 'AV-124', title: 'Kanan Jarrus' },
            { num: 'AV-125', title: 'Ezra Bridger' },
            { num: 'AV-126', title: 'Zeb Orrelios' },
            { num: 'AV-127', title: 'Jar Jar Binks' },
            { num: 'AV-128', title: 'Qui-Gon Jinn' },
            { num: 'AV-129', title: 'Count Dooku' },
            { num: 'AV-130', title: 'Padmé Amidala' },
            { num: 'AV-131', title: 'Emperor Palpatine' },
            { num: 'AV-132', title: 'Sebulba' },
            { num: 'AV-133', title: 'Captain Phasma' },
            { num: 'AV-134', title: 'Maz Kanata' },
            { num: 'AV-135', title: 'General Grievous' },
            { num: 'AV-136', title: 'Asajj Ventress' },
            { num: 'AV-137', title: 'Captain Rex' },
            { num: 'AV-138', title: 'Mace Windu' },
            { num: 'AV-139', title: 'Jango Fett' },
            { num: 'AV-140', title: 'Yoda' },
            { num: 'AV-141', title: 'Kit Fisto' },
            { num: 'AV-142', title: 'Dexter Jettster' },
            { num: 'AV-143', title: 'Aayla Secura' },
            { num: 'AV-144', title: 'Barriss Offee' },
            { num: 'AV-145', title: 'Luminara Unduli' },
            { num: 'AV-146', title: 'Saesee Tiin' },
            { num: 'AV-147', title: 'Plo Koon' },
            { num: 'AV-148', title: 'Aurra Sing' },
            { num: 'AV-149', title: 'Dryden Vos' },
            { num: 'AV-150', title: 'Qi\'ra' },
          ]
        },
        {
          count: 150,
          name: 'HOTH FROZENFRACTOR SSP',
          meta: 'Six 1/1 ice variants per base card',
          oneOfOne: true,
          parallels: 6,
          cards: [
            { num: 'HV-1', title: 'Ahsoka Tano' },
            { num: 'HV-2', title: 'Hera Syndulla' },
            { num: 'HV-3', title: 'Sabine Wren' },
            { num: 'HV-4', title: 'Grand Admiral Thrawn' },
            { num: 'HV-5', title: 'Baylan Skoll' },
            { num: 'HV-6', title: 'Shin Hati' },
            { num: 'HV-7', title: 'Cassian Andor' },
            { num: 'HV-8', title: 'Mon Mothma' },
            { num: 'HV-9', title: 'Luthen Rael' },
            { num: 'HV-10', title: 'Bix Caleen' },
            { num: 'HV-11', title: 'Kino Loy' },
            { num: 'HV-12', title: 'Syril Karn' },
            { num: 'HV-13', title: 'Maarva Andor' },
            { num: 'HV-14', title: 'Dedra Meero' },
            { num: 'HV-15', title: 'Vel Sartha' },
            { num: 'HV-16', title: 'Cinta Kaz' },
            { num: 'HV-17', title: 'Saw Gerrera' },
            { num: 'HV-18', title: 'B2EMO' },
            { num: 'HV-19', title: 'Boba Fett' },
            { num: 'HV-20', title: 'Fennec Shand' },
            { num: 'HV-21', title: 'The Mandalorian' },
            { num: 'HV-22', title: 'Grogu' },
            { num: 'HV-23', title: '8D8' },
            { num: 'HV-24', title: 'Twi\'lek Majordomo' },
            { num: 'HV-25', title: 'Garsa Fwip' },
            { num: 'HV-26', title: 'Krrsantan' },
            { num: 'HV-27', title: 'The Twins' },
            { num: 'HV-28', title: 'Drash' },
            { num: 'HV-29', title: 'Skad' },
            { num: 'HV-30', title: 'The Modifier' },
            { num: 'HV-31', title: 'Peli Motto' },
            { num: 'HV-32', title: 'Cobb Vanth' },
            { num: 'HV-33', title: 'Cad Bane' },
            { num: 'HV-34', title: 'Camie' },
            { num: 'HV-35', title: 'Fixer' },
            { num: 'HV-36', title: 'Carson Teva' },
            { num: 'HV-37', title: 'Moff Gideon' },
            { num: 'HV-38', title: 'Bo-Katan Kryze' },
            { num: 'HV-39', title: 'The Armorer' },
            { num: 'HV-40', title: 'IG-12' },
            { num: 'HV-41', title: 'IG-11' },
            { num: 'HV-42', title: 'Mayfeld' },
            { num: 'HV-43', title: 'Greef Karga' },
            { num: 'HV-44', title: 'The Client' },
            { num: 'HV-45', title: 'Kuiil' },
            { num: 'HV-46', title: 'Koska Reeves' },
            { num: 'HV-47', title: 'Elia Kane' },
            { num: 'HV-48', title: 'Axe Woves' },
            { num: 'HV-49', title: 'Paz Vizsla' },
            { num: 'HV-50', title: 'Toro Calican' },
            { num: 'HV-51', title: 'Ranzar Malk' },
            { num: 'HV-52', title: 'Commissioner Helgait' },
            { num: 'HV-53', title: 'The Duchess' },
            { num: 'HV-54', title: 'Captain Bombardier' },
            { num: 'HV-55', title: 'Colonel Tuttle' },
            { num: 'HV-56', title: 'Kelleran Beq' },
            { num: 'HV-57', title: 'Morgan Elsbeth' },
            { num: 'HV-58', title: 'Qin' },
            { num: 'HV-59', title: 'Xi\'an' },
            { num: 'HV-60', title: 'Burg' },
            { num: 'HV-61', title: 'Q9-0' },
            { num: 'HV-62', title: 'Gorian Shard' },
            { num: 'HV-63', title: 'Boba Fett\'s Rancor' },
            { num: 'HV-64', title: 'Rancor Keeper' },
            { num: 'HV-65', title: 'Tatooine Sand Beast' },
            { num: 'HV-66', title: 'Darth Vader' },
            { num: 'HV-67', title: 'Obi-Wan Kenobi' },
            { num: 'HV-68', title: 'Reva' },
            { num: 'HV-69', title: 'Princess Leia' },
            { num: 'HV-70', title: 'Luke Skywalker' },
            { num: 'HV-71', title: 'Uncle Owen' },
            { num: 'HV-72', title: 'Aunt Beru' },
            { num: 'HV-73', title: 'Breha Organa' },
            { num: 'HV-74', title: 'Bail Organa' },
            { num: 'HV-75', title: 'Vect Nokru' },
            { num: 'HV-76', title: 'L0LA' },
            { num: 'HV-77', title: 'Fifth Brother' },
            { num: 'HV-78', title: 'The Grand Inquisitor' },
            { num: 'HV-79', title: 'Haja Estree' },
            { num: 'HV-80', title: 'Fourth Sister' },
            { num: 'HV-81', title: 'Freck' },
            { num: 'HV-82', title: 'Purge Trooper' },
            { num: 'HV-83', title: 'Tala Durith' },
            { num: 'HV-84', title: 'NED-B' },
            { num: 'HV-85', title: 'Vane' },
            { num: 'HV-86', title: 'Praetorian Guard' },
            { num: 'HV-87', title: 'Pit Droid' },
            { num: 'HV-88', title: 'R5-D4' },
            { num: 'HV-89', title: 'Mudhorn' },
            { num: 'HV-90', title: 'Freedi Pamular' },
            { num: 'HV-91', title: 'Doctor Quadpaw' },
            { num: 'HV-92', title: 'Nurchi' },
            { num: 'HV-93', title: 'Salman Paak' },
            { num: 'HV-94', title: 'Steelpecker' },
            { num: 'HV-95', title: 'Corellian Hound' },
            { num: 'HV-96', title: 'Leida Mothma' },
            { num: 'HV-97', title: 'Perrin Fertha' },
            { num: 'HV-98', title: 'Melshi' },
            { num: 'HV-99', title: 'Captain Enoch' },
            { num: 'HV-100', title: 'Jacen Syndulla' },
            { num: 'HV-101', title: 'K-2SO' },
            { num: 'HV-102', title: 'Han Solo' },
            { num: 'HV-103', title: 'Leia Organa' },
            { num: 'HV-104', title: 'Luke Skywalker' },
            { num: 'HV-105', title: 'Wedge Antilles' },
            { num: 'HV-106', title: 'Lando Calrissian' },
            { num: 'HV-107', title: 'Chewbacca' },
            { num: 'HV-108', title: 'R2-D2' },
            { num: 'HV-109', title: 'C-3PO' },
            { num: 'HV-110', title: 'BB-8' },
            { num: 'HV-111', title: 'D-0' },
            { num: 'HV-112', title: 'Rey' },
            { num: 'HV-113', title: 'Finn' },
            { num: 'HV-114', title: 'Poe Dameron' },
            { num: 'HV-115', title: 'Kylo Ren' },
            { num: 'HV-116', title: 'General Hux' },
            { num: 'HV-117', title: 'Supreme Leader Snoke' },
            { num: 'HV-118', title: 'Jabba The Hutt' },
            { num: 'HV-119', title: 'Jyn Erso' },
            { num: 'HV-120', title: 'Director Krennic' },
            { num: 'HV-121', title: 'Admiral Ackbar' },
            { num: 'HV-122', title: 'Nien Nunb' },
            { num: 'HV-123', title: 'Wicket W. Warrick' },
            { num: 'HV-124', title: 'Kanan Jarrus' },
            { num: 'HV-125', title: 'Ezra Bridger' },
            { num: 'HV-126', title: 'Zeb Orrelios' },
            { num: 'HV-127', title: 'Jar Jar Binks' },
            { num: 'HV-128', title: 'Qui-Gon Jinn' },
            { num: 'HV-129', title: 'Count Dooku' },
            { num: 'HV-130', title: 'Padmé Amidala' },
            { num: 'HV-131', title: 'Emperor Palpatine' },
            { num: 'HV-132', title: 'Sebulba' },
            { num: 'HV-133', title: 'Captain Phasma' },
            { num: 'HV-134', title: 'Maz Kanata' },
            { num: 'HV-135', title: 'General Grievous' },
            { num: 'HV-136', title: 'Asajj Ventress' },
            { num: 'HV-137', title: 'Captain Rex' },
            { num: 'HV-138', title: 'Mace Windu' },
            { num: 'HV-139', title: 'Jango Fett' },
            { num: 'HV-140', title: 'Yoda' },
            { num: 'HV-141', title: 'Kit Fisto' },
            { num: 'HV-142', title: 'Dexter Jettster' },
            { num: 'HV-143', title: 'Aayla Secura' },
            { num: 'HV-144', title: 'Barriss Offee' },
            { num: 'HV-145', title: 'Luminara Unduli' },
            { num: 'HV-146', title: 'Saesee Tiin' },
            { num: 'HV-147', title: 'Plo Koon' },
            { num: 'HV-148', title: 'Aurra Sing' },
            { num: 'HV-149', title: 'Dryden Vos' },
            { num: 'HV-150', title: 'Qi\'ra' },
          ]
        }
      ],
      insert: [
        {
          count: 10,
          name: 'BONUS STAGE',
          meta: 'Retro arcade art · Superfractor parallel only',
          odds: 'Super limited',
          parallels: 1,
          cards: [
            { num: 'BS-AS', title: 'Anakin Skywalker' },
            { num: 'BS-AT', title: 'Ahsoka Tano' },
            { num: 'BS-C', title: 'Chewbacca' },
            { num: 'BS-EB', title: 'Ezra Bridger' },
            { num: 'BS-HO', title: 'Captain Rex' },
            { num: 'BS-KJ', title: 'Kanan Jarrus' },
            { num: 'BS-OK', title: 'Obi-Wan Kenobi' },
            { num: 'BS-R', title: 'Rey' },
            { num: 'BS-SW', title: 'Sabine Wren' },
            { num: 'BS-Y', title: 'Yoda' },
          ]
        },
        {
          count: 9,
          name: 'GALACTIC CIVIL WAR — EMPIRE',
          meta: 'The Imperial war machine',
          odds: '1:8 packs',
          parallels: 6,
          cards: [
            { num: 'GE-1', title: 'Darth Vader' },
            { num: 'GE-2', title: 'Emperor Palpatine' },
            { num: 'GE-3', title: 'Director Orson Krennic' },
            { num: 'GE-4', title: 'Grand Moff Tarkin' },
            { num: 'GE-5', title: 'Admiral Ozzel' },
            { num: 'GE-6', title: 'Admiral Piett' },
            { num: 'GE-7', title: 'Admiral Motti' },
            { num: 'GE-8', title: 'Imperial Royal Guards' },
            { num: 'GE-9', title: 'Stormtrooper' },
          ]
        },
        {
          count: 9,
          name: 'GALACTIC CIVIL WAR — REBELS',
          meta: 'Heroes of the Alliance',
          odds: '1:8 packs',
          parallels: 6,
          cards: [
            { num: 'RA-1', title: 'Leia Organa' },
            { num: 'RA-2', title: 'Luke Skywalker' },
            { num: 'RA-3', title: 'Han Solo' },
            { num: 'RA-4', title: 'Chewbacca' },
            { num: 'RA-5', title: 'Lando Calrissian' },
            { num: 'RA-6', title: 'C-3PO' },
            { num: 'RA-7', title: 'Cassian Andor' },
            { num: 'RA-8', title: 'R2-D2' },
            { num: 'RA-9', title: 'Jyn Erso' },
          ]
        },
        {
          count: 25,
          name: 'GALACTIC GEAR',
          meta: 'Signature gear & equipment',
          odds: '1:10 packs',
          parallels: 6,
          cards: [
            { num: 'GG-1', title: 'Lando Calrissian' },
            { num: 'GG-2', title: 'Lando Calrissian' },
            { num: 'GG-3', title: 'Han Solo' },
            { num: 'GG-4', title: 'Leia Organa' },
            { num: 'GG-5', title: 'Luke Skywalker' },
            { num: 'GG-6', title: 'Captain Phasma' },
            { num: 'GG-7', title: 'Darth Vader' },
            { num: 'GG-8', title: 'Darth Maul' },
            { num: 'GG-9', title: 'Kelleran Beq' },
            { num: 'GG-10', title: 'The Dutchess' },
            { num: 'GG-11', title: 'Queen Amidala' },
            { num: 'GG-12', title: 'Padmé Amidala' },
            { num: 'GG-13', title: 'Qi\'ra' },
            { num: 'GG-14', title: 'Han Solo' },
            { num: 'GG-15', title: 'Lando Calrissian' },
            { num: 'GG-16', title: 'Count Dooku' },
            { num: 'GG-17', title: 'Padmé Amidala' },
            { num: 'GG-18', title: 'Anakin Skywalker' },
            { num: 'GG-19', title: 'Leia Organa' },
            { num: 'GG-20', title: 'Fennec Shand' },
            { num: 'GG-21', title: 'Boba Fett' },
            { num: 'GG-22', title: 'Poe Dameron' },
            { num: 'GG-23', title: 'Finn' },
            { num: 'GG-24', title: 'Kylo Ren' },
            { num: 'GG-25', title: 'Ahsoka Tano' },
          ]
        },
        {
          count: 10,
          name: 'THE HEIRESS',
          meta: 'Bo-Katan\'s Mandalorian arc',
          odds: '1:6 packs',
          parallels: 6,
          cards: [
            { num: 'TH-1', title: 'Bo-Katan Reassures Grogu' },
            { num: 'TH-2', title: 'Bo-Katan Pursues the Raptor' },
            { num: 'TH-3', title: 'Bo-Katan Leads the Rescue Mission' },
            { num: 'TH-4', title: 'Bo-Katan Plans the Route' },
            { num: 'TH-5', title: 'Bo-Katan Wields the Darksaber' },
            { num: 'TH-6', title: 'Bo-Katan Rescues The Mandalorian' },
            { num: 'TH-7', title: 'Bo-Katan Fends Off Attackers' },
            { num: 'TH-8', title: 'The Team Arrives at the Secret Enclave' },
            { num: 'TH-9', title: 'Bo-Katan Begins the Search for Mando' },
            { num: 'TH-10', title: 'Bo-Katan Brings Grogu for the Ride' },
          ]
        },
        {
          count: 20,
          name: 'I LOVE YOU...I KNOW',
          meta: 'Han & Leia · A/B paired cards',
          parallels: 5,
          cards: [
            { num: 'ILY-1A', title: 'Rescuing The Princess' },
            { num: 'ILY-1B', title: 'Rescuing The Princess' },
            { num: 'ILY-2A', title: 'The Medal Ceremony' },
            { num: 'ILY-2B', title: 'The Medal Ceremony' },
            { num: 'ILY-3A', title: 'Evacuation on Hoth' },
            { num: 'ILY-3B', title: 'Evacuation on Hoth' },
            { num: 'ILY-4A', title: 'Asteroid Field' },
            { num: 'ILY-4B', title: 'Asteroid Field' },
            { num: 'ILY-5A', title: 'The Carbonite Chamber' },
            { num: 'ILY-5B', title: 'The Carbonite Chamber' },
            { num: 'ILY-6A', title: 'Rescuing the Scoundrel' },
            { num: 'ILY-6B', title: 'Rescuing the Scoundrel' },
            { num: 'ILY-7A', title: 'In the Ewok Village' },
            { num: 'ILY-7B', title: 'In the Ewok Village' },
            { num: 'ILY-8A', title: 'The Endor Bunker' },
            { num: 'ILY-8B', title: 'The Endor Bunker' },
            { num: 'ILY-9A', title: 'Reunion on Takodana' },
            { num: 'ILY-9B', title: 'Reunion on Takodana' },
            { num: 'ILY-10A', title: 'Rescuing Their Son' },
            { num: 'ILY-10B', title: 'Rescuing Their Son' },
          ]
        },
        {
          count: 5,
          name: 'REFLECTIONS',
          meta: 'R-1 to R-5 · Superfractor parallel only',
          odds: 'Extremely limited',
          parallels: 1,
          cards: [
            { num: 'R-1', title: 'Imperial Stormtrooper' },
            { num: 'R-2', title: 'R2-D2' },
            { num: 'R-3', title: 'Darth Vader' },
            { num: 'R-4', title: 'Greedo' },
            { num: 'R-5', title: 'Boba Fett' },
          ]
        },
        {
          count: 20,
          name: 'THE RISE OF PALPATINE',
          meta: 'Palpatine\'s path to power',
          odds: '1:5 packs',
          parallels: 6,
          cards: [
            { num: 'RP-1', title: 'The Secret Apprentice' },
            { num: 'RP-2', title: 'Advisor to Queen Amidala' },
            { num: 'RP-3', title: 'The New Supreme Chancellor' },
            { num: 'RP-4', title: 'Civil War with the Separatists' },
            { num: 'RP-5', title: 'Emergency Powers' },
            { num: 'RP-6', title: 'The Secret Geonosian Superweapon' },
            { num: 'RP-7', title: 'The Tale of Darth Plagueis' },
            { num: 'RP-8', title: 'The Jedi\'s Attempt to Seize Control' },
            { num: 'RP-9', title: 'Order 66' },
            { num: 'RP-10', title: 'The First Galactic Empire' },
            { num: 'RP-11', title: 'The Duel with Yoda' },
            { num: 'RP-12', title: 'Extracting Vader from Mustafar' },
            { num: 'RP-13', title: 'The Offspring of Anakin Skywalker' },
            { num: 'RP-14', title: 'Arrival at the Second Death Star' },
            { num: 'RP-15', title: 'Luring the Rebellion Into a Trap' },
            { num: 'RP-16', title: 'Tempting Luke Skywalker to the Dark Side' },
            { num: 'RP-17', title: 'Darth Vader\'s Betrayal' },
            { num: 'RP-18', title: 'Palpatine Resurrected' },
            { num: 'RP-19', title: 'The Secret Sith Fleet' },
            { num: 'RP-20', title: 'Final Battle with Rey & Kylo Ren' },
          ]
        },
        {
          count: 15,
          name: 'STARSHIP BLUEPRINTS',
          meta: 'Layered blueprint shadowboxes',
          odds: '1:192 packs',
          parallels: 5,
          cards: [
            { num: 'S-1', title: 'The Millennium Falcon' },
            { num: 'S-2', title: 'The Razor Crest' },
            { num: 'S-3', title: 'The Ghost' },
            { num: 'S-4', title: 'Boba Fett\'s Starship' },
            { num: 'S-5', title: 'Fondor Haulcraft' },
            { num: 'S-6', title: 'The Marauder' },
            { num: 'S-7', title: 'Gauntlet Fighter' },
            { num: 'S-8', title: 'Darth Vader\'s TIE Fighter' },
            { num: 'S-9', title: 'Star Destroyer' },
            { num: 'S-10', title: 'The Mandalorian\'s N-1 Starfighter' },
            { num: 'S-11', title: 'Jedi T-6 Shuttle' },
            { num: 'S-12', title: 'Poe Dameron\'s X-Wing Fighter' },
            { num: 'S-13', title: 'Kylo Ren\'s TIE Silencer' },
            { num: 'S-14', title: 'The Night Buzzard' },
            { num: 'S-15', title: 'Snowspeeder' },
          ]
        }
      ],
      auto: [
        {
          count: 95,
          name: 'AUTOGRAPH CARDS',
          meta: 'Single-signer · film & series stars',
          parallels: 8,
          cards: [
            { num: 'AU-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'AU-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'AU-AE', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'AU-AL', title: 'Alex Lawther', meta: 'Karis Nemik' },
            { num: 'AU-AM', title: 'Alastair Mackenzie', meta: 'Perrin Fertha' },
            { num: 'AU-AS', title: 'Andy Serkis', meta: 'Kino Loy' },
            { num: 'AU-B', title: 'Joplin Sibtain', meta: 'Brasso' },
            { num: 'AU-BC', title: 'Bronte Carmichael', meta: 'Leida Mothma' },
            { num: 'AU-BDT', title: 'Benicio Del Toro', meta: 'DJ' },
            { num: 'AU-BL', title: 'Billie Lourd', meta: 'Lieutenant Kaydel Ko Connix' },
            { num: 'AU-BM', title: 'Ben Mendelsohn', meta: 'Director Orson Krennic' },
            { num: 'AU-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'AU-CC', title: 'Crystal Clarke', meta: 'Pammich Nerro Goode' },
            { num: 'AU-CI', title: 'Dee Tails', meta: 'Cratinus' },
            { num: 'AU-CP', title: 'Chad Parker', meta: 'Worker Padu Cherd' },
            { num: 'AU-DG', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'AU-DGL', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'AU-DI', title: 'Diana Lee Inosanto', meta: 'Morgan Elsbeth' },
            { num: 'AU-DKO', title: 'Gabriel Fonseca', meta: 'Duke Kayo Organa' },
            { num: 'AU-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'AU-DP', title: 'David Pasquesi', meta: 'Twi\'lek Majordomo' },
            { num: 'AU-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'AU-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'AU-EMC', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'AU-EW', title: 'Evan Whitten', meta: 'Jacen Syndulla' },
            { num: 'AU-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'AU-FS', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'AU-FW', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'AU-G', title: 'Paul Blake', meta: 'Greedo' },
            { num: 'AU-GB', title: 'Gary Beadle', meta: 'Clem Andor' },
            { num: 'AU-GF', title: 'Grant Feely', meta: 'Luke Skywalker' },
            { num: 'AU-GH', title: 'Guy Henry', meta: 'Grand Moff Tarkin' },
            { num: 'AU-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'AU-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'AU-HD', title: 'Harrison Davis', meta: 'Pommet Warrick' },
            { num: 'AU-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'AU-HM', title: 'Heath McGough', meta: 'Groff Ditcher' },
            { num: 'AU-HQ', title: 'Hugh Quarshie', meta: 'Captain Panaka' },
            { num: 'AU-IF', title: 'Isla Farris', meta: 'Winta' },
            { num: 'AU-II', title: 'Ian Inigo', meta: 'Cousin Niano Organa' },
            { num: 'AU-IM', title: 'Ian McDiarmid', meta: 'The Emperor' },
            { num: 'AU-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'AU-JG', title: 'Julian Glover', meta: 'General Maximilian Veers' },
            { num: 'AU-JJ', title: 'Julia Jones', meta: 'Omera' },
            { num: 'AU-JN', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'AU-JO', title: 'Joanna Bennett', meta: 'Tusken Warrior' },
            { num: 'AU-JPG', title: 'Jeryl Prescott Gallien', meta: 'Aktropaw' },
            { num: 'AU-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'AU-KL', title: 'Nick Kellington', meta: 'Bistan' },
            { num: 'AU-KS', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'AU-KSA', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'AU-LAW', title: 'Anton Lesser', meta: 'Major Partagaz' },
            { num: 'AU-LB', title: 'Lee Boardman', meta: 'Kravas Drezzer' },
            { num: 'AU-LC', title: 'Lily Cole', meta: 'Lovey' },
            { num: 'AU-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'AU-LNY', title: 'Lupita Nyong\'o', meta: 'Maz Kanata' },
            { num: 'AU-LRB', title: 'Lynn Robertson Bruce', meta: 'D-0' },
            { num: 'AU-LS', title: 'Leilani Shiu', meta: 'Jawa' },
            { num: 'AU-MBO', title: 'Mark Boone Jr.', meta: 'Ranzar Malk' },
            { num: 'AU-ME', title: 'Maya Erskine', meta: 'Sully Stark' },
            { num: 'AU-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'AU-MK', title: 'Mandy Kowalski', meta: 'Camie' },
            { num: 'AU-MM', title: 'Molly Miller', meta: 'Handmaiden Agira' },
            { num: 'AU-MP', title: 'Michael Pennington', meta: 'Moff Jerjerrod' },
            { num: 'AU-MQ', title: 'Ming Qiu', meta: 'Jedi Master Minas Velti' },
            { num: 'AU-MR', title: 'Mark Rolston', meta: 'Captain Hayle' },
            { num: 'AU-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'AU-MWE', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'AU-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'AU-NK', title: 'Nalini Krishan', meta: 'Barriss Offee' },
            { num: 'AU-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'AU-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'AU-PD', title: 'Paul Darnell', meta: 'Marrok' },
            { num: 'AU-PJ', title: 'Peter Jacobson', meta: 'Myn Weaver' },
            { num: 'AU-PW', title: 'Paul Warren', meta: 'Doctor Quadpaw' },
            { num: 'AU-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'AU-RB', title: 'Ralph Brown', meta: 'Ric Olié' },
            { num: 'AU-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'AU-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'AU-RM', title: 'Ryder McLaughlin', meta: 'Wade Resselian' },
            { num: 'AU-SB', title: 'Skyler Bible', meta: 'Fixer' },
            { num: 'AU-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'AU-SKE', title: 'Simone Kessell', meta: 'Breha Organa' },
            { num: 'AU-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'AU-SW', title: 'Stephen Wight', meta: 'Verlo Skiff' },
            { num: 'AU-TF', title: 'Tait Fletcher', meta: 'Paz Vizsla' },
            { num: 'AU-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'AU-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'AU-TR', title: 'Tim Rose', meta: 'Admiral Ackbar' },
            { num: 'AU-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'AU-VB', title: 'Vivien Lyra Blair', meta: 'Princess Leia Organa' },
            { num: 'AU-WC', title: 'Wes Chatham', meta: 'Captain Enoch' },
            { num: 'AU-WH', title: 'Werner Herzog', meta: 'The Client' },
            { num: 'AU-XJ', title: 'Xavier Jimenez', meta: 'Tusken Chief' },
            { num: 'AU-YAT', title: 'Ariana Greenblatt', meta: 'Young Ahsoka Tano' },
          ]
        },
        {
          count: 13,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'DA-AO', title: 'Omid Abtahi / Katy O\'Brian', meta: 'Dr. Pershing / Elia Kane' },
            { num: 'DA-BI', title: 'Natasha Liu Bordizzo / Diana Lee Inosanto', meta: 'Sabine Wren / Morgan Elsbeth' },
            { num: 'DA-DB', title: 'Natasha Liu Bordizzo / Rosario Dawson', meta: 'Sabine Wren / Ahsoka Tano' },
            { num: 'DA-DG', title: 'Domhnall Gleeson / Adam Driver', meta: 'General Hux / Kylo Ren' },
            { num: 'DA-DM', title: 'Lars Mikkelsen / Rosario Dawson', meta: 'Grand Admiral Thrawn / Ahsoka Tano' },
            { num: 'DA-LA', title: 'Adria Arjona / Diego Luna', meta: 'Bix Caleen / Cassian Andor' },
            { num: 'DA-LC', title: 'Diego Luna / Dave Chapman', meta: 'Cassian Andor / B2EMO' },
            { num: 'DA-LO', title: 'Diego Luna / Genevieve O\'Reilly', meta: 'Cassian Andor / Mon Mothma' },
            { num: 'DA-MB', title: 'Zach Braff / Ewan McGregor', meta: 'Freck / Obi-Wan Kenobi' },
            { num: 'DA-MW', title: 'Temuera Morrison / Ming-Na Wen', meta: 'Boba Fett / Fennec Shand' },
            { num: 'DA-RD', title: 'Adam Driver / Daisy Ridley', meta: 'Kylo Ren / Rey' },
            { num: 'DA-SG', title: 'Kyle Soller / Denise Gough', meta: 'Syril Karn / Dedra Meero' },
            { num: 'DA-WO', title: 'Genevieve O\'Reilly / Mary Elizabeth Winstead', meta: 'Mon Mothma / Hera Syndulla' },
          ]
        },
        {
          count: 7,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer',
          parallels: 2,
          cards: [
            { num: 'TA-FRN', title: 'Harrison Ford / Lupita Nyong\'o / Daisy Ridley', meta: 'Han Solo / Maz Kanata / Rey' },
            { num: 'TA-HMC', title: 'Mark Hamill / Carrie Fisher / Harrison Ford', meta: 'Luke / Princess Leia / Han Solo' },
            { num: 'TA-JLW', title: 'Felicity Jones / Diego Luna / Forest Whitaker', meta: 'Jyn Erso / Cassian Andor / Saw Gerrera' },
            { num: 'TA-MBB', title: 'Zach Braff / Ewan McGregor / Vivien Lyra Blair', meta: 'Freck / Obi-Wan Kenobi / Princess Leia' },
            { num: 'TA-MBF', title: 'Vivien Lyra Blair / Grant Feely / Ewan McGregor', meta: 'Princess Leia / Luke Skywalker / Obi-Wan Kenobi' },
            { num: 'TA-MIC', title: 'Moses Ingram / Ewan McGregor / Hayden Christensen', meta: 'Reva / Obi-Wan Kenobi / Darth Vader' },
            { num: 'TA-SVM', title: 'Suzie McGrath / Myrna Valesco / Christopher Sean', meta: 'Tam Ryvora / Torra Doza / Kazuda Xiono' },
          ]
        }
      ],
      sketch: [
        {
          count: 82,
          name: 'SKETCH CARD ARTISTS',
          meta: 'One-of-one hand-drawn sketches · 82 artists',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Angel S Aviles' },
            { num: 'SK-2', title: 'Anthony Pietszak' },
            { num: 'SK-3', title: 'Basak Kahraman' },
            { num: 'SK-4', title: 'Bobby Blakey' },
            { num: 'SK-5', title: 'Brandon Klein' },
            { num: 'SK-6', title: 'Bryan Kaiser Tillman' },
            { num: 'SK-7', title: 'Cisco Rivera' },
            { num: 'SK-8', title: 'Clinton Yeager' },
            { num: 'SK-9', title: 'Dan Lawler' },
            { num: 'SK-10', title: 'Daniel M. Chavez' },
            { num: 'SK-11', title: 'Daniel P. Gorman' },
            { num: 'SK-12', title: 'Darrin Pepe' },
            { num: 'SK-13', title: 'David Sorensen' },
            { num: 'SK-14', title: 'David Willingham' },
            { num: 'SK-15', title: 'Debjit Kar' },
            { num: 'SK-16', title: 'Derek Johnson' },
            { num: 'SK-17', title: 'Derek Stevens' },
            { num: 'SK-18', title: 'Dirk Shearer' },
            { num: 'SK-19', title: 'Dove McHargue' },
            { num: 'SK-20', title: 'Dwayne Carpenter' },
            { num: 'SK-21', title: 'Emrah Cildir' },
            { num: 'SK-22', title: 'Emre Varlibas' },
            { num: 'SK-23', title: 'Eric Medina' },
            { num: 'SK-24', title: 'Gabe Farber' },
            { num: 'SK-25', title: 'Gregory Tilson' },
            { num: 'SK-26', title: 'Ian Mckesson' },
            { num: 'SK-27', title: 'Jackson Ong' },
            { num: 'SK-28', title: 'James Boyd' },
            { num: 'SK-29', title: 'Jason Saldajeno' },
            { num: 'SK-30', title: 'Jason Christner' },
            { num: 'SK-31', title: 'Jason Davies' },
            { num: 'SK-32', title: 'Jason Sobol' },
            { num: 'SK-33', title: 'Jay Manchand' },
            { num: 'SK-34', title: 'Jeffrey Benitez' },
            { num: 'SK-35', title: 'Jessica Hickman' },
            { num: 'SK-36', title: 'Joey Mason' },
            { num: 'SK-37', title: 'John Anthony Rodriguez' },
            { num: 'SK-38', title: 'Julie Hunt' },
            { num: 'SK-39', title: 'Kang Jing' },
            { num: 'SK-40', title: 'Karl Jones' },
            { num: 'SK-41', title: 'Keith Farnum' },
            { num: 'SK-42', title: 'Kevin Scott Jacobs' },
            { num: 'SK-43', title: 'Kirk Chavarria' },
            { num: 'SK-44', title: 'Krishna Sharma' },
            { num: 'SK-45', title: 'Limuel Pinzon' },
            { num: 'SK-46', title: 'Luke Seavers' },
            { num: 'SK-47', title: 'Marcia Dye' },
            { num: 'SK-48', title: 'Marlo Agunos' },
            { num: 'SK-49', title: 'Matt Stewart' },
            { num: 'SK-50', title: 'Matthew Maldonado' },
            { num: 'SK-51', title: 'Michael J Sealie' },
            { num: 'SK-52', title: 'Michael Mastermaker' },
            { num: 'SK-53', title: 'Mike Davidson' },
            { num: 'SK-54', title: 'Mike LaPeruta' },
            { num: 'SK-55', title: 'Mongola Das' },
            { num: 'SK-56', title: 'Neil Brady' },
            { num: 'SK-57', title: 'Neil Camera' },
            { num: 'SK-58', title: 'Nick Gribbon' },
            { num: 'SK-59', title: 'Phillip Trujillo' },
            { num: 'SK-60', title: 'Quinton Baker' },
            { num: 'SK-61', title: 'Rachel Jane' },
            { num: 'SK-62', title: 'Rebeca Louro' },
            { num: 'SK-63', title: 'Robert Demers' },
            { num: 'SK-64', title: 'Robert Garcia' },
            { num: 'SK-65', title: 'Rusty Gilligan' },
            { num: 'SK-66', title: 'Rutvig Vaid' },
            { num: 'SK-67', title: 'Ryan Harris' },
            { num: 'SK-68', title: 'Ryan Johnston' },
            { num: 'SK-69', title: 'Sam Barugh' },
            { num: 'SK-70', title: 'Sean Mathews' },
            { num: 'SK-71', title: 'Semra Bulut' },
            { num: 'SK-72', title: 'Shaow Siong' },
            { num: 'SK-73', title: 'Stephane Leonardi' },
            { num: 'SK-74', title: 'Steve Alce' },
            { num: 'SK-75', title: 'Todd Aaron Smith' },
            { num: 'SK-76', title: 'Traci Easterday' },
            { num: 'SK-77', title: 'Rico Dela Rosa' },
            { num: 'SK-78', title: 'Veronica Louro' },
            { num: 'SK-79', title: 'Veronica Smith' },
            { num: 'SK-80', title: 'Will Pleydon' },
            { num: 'SK-81', title: 'Yves Van Berlo' },
            { num: 'SK-82', title: 'Zach Woolsey' },
          ]
        }
      ],
    },
  },

  '2023-chrome-galaxy': {
    setId: '2023-chrome-galaxy',
    year: '2023',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '8 / 30 / 2023',
    lede: 'The third Chrome Galaxy, anchored by the 40th anniversary of Return of the Jedi. A 100-card chromium base set with a 10-deep rainbow — the Aqua /199 debuts here — four new insert lines, ultra-rare Kyber Crystal die-cuts, and the leanest autograph program of the run: five multi-signer cards, with three numbered refractors per box instead of a guaranteed auto.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Classic + new Galaxy art', color: 'gold' },
      { num: '5', label: 'Insert Sets', sub: '4 to 20 cards each', color: 'cyan' },
      { num: '5', label: 'Auto Cards', sub: 'Dual & triple only', color: 'green' },
      { num: '10', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '9', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4', l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '3', l: 'Numbered refractors / box' },
      { v: '0', l: 'Guaranteed autos — parallels instead' },
    ],
    pullRates: [
      { name: 'Galactic Visions', odds: '1 : 9', tier: 'normal' },
      { name: 'Darth Vader & the Bounty Hunters', odds: '1 : 9', tier: 'normal' },
      { name: 'ROTJ 40th Poster Art', odds: '1 : 9', tier: 'normal' },
      { name: 'Women of Star Wars', odds: '1 : 9', tier: 'normal' },
      { name: 'Sketch Cards', odds: '1 : 135', tier: 'rare' },
      { name: 'Kyber Crystal Die-Cuts', odds: '1 : 1,118', tier: 'mythic' },
      { name: 'Dual Autographs', odds: '1 : 10,922', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'AQUA', pr: '/199', gradient: 'linear-gradient(135deg, #40e8e0 0%, #00a0a0 60%, #80fff0 100%)', darkText: true },
      { name: 'ATOMIC', pr: '/150', gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'WAVE', pr: '/99', gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'PRISM', pr: '/75', gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO', pr: '/50', gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'X-FRACTOR', pr: '/10', gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Classic + new Galaxy artwork',
          parallels: 10,
          cards: [
            { num: '1', title: 'Luke in Peril!' },
            { num: '2', title: 'Wise Yoda' },
            { num: '3', title: 'Hoth from the Air' },
            { num: '4', title: 'Incoming Transmission' },
            { num: '5', title: 'The Princess & The Scoundrel' },
            { num: '6', title: 'Becoming Sith' },
            { num: '7', title: 'Han Solo Draws!' },
            { num: '8', title: 'The Bespin Administrator' },
            { num: '9', title: 'Wild Wampa' },
            { num: '10', title: 'The Emperor Up Close' },
            { num: '11', title: 'Holochess Contest' },
            { num: '12', title: 'Beggar\'s Canyon Run' },
            { num: '13', title: 'Gamorrean Charge!' },
            { num: '14', title: 'Skirmish Above the Sarlacc!' },
            { num: '15', title: 'Yoda\'s Hut' },
            { num: '16', title: 'Imperial Agents of Evil' },
            { num: '17', title: 'Showdown on Dagobah' },
            { num: '18', title: 'AT-STs on the Prowl' },
            { num: '19', title: 'Ravenous Rancor' },
            { num: '20', title: 'The Torture Droid' },
            { num: '21', title: 'Embattled Han & Chewie' },
            { num: '22', title: 'Carbonite Chamber Duel' },
            { num: '23', title: 'An Upset Wookiee' },
            { num: '24', title: 'Stormtrooper Overrun!' },
            { num: '25', title: 'Wading Through the Swamp' },
            { num: '26', title: 'On the Hunt' },
            { num: '27', title: 'A Plan in Action' },
            { num: '28', title: 'From the Eyes of the Admiral' },
            { num: '29', title: 'Salacious B. Crumb' },
            { num: '30', title: 'Weight of Destiny' },
            { num: '31', title: 'Kenobi\'s Visage' },
            { num: '32', title: 'Enlist!' },
            { num: '33', title: 'Masters of the Force' },
            { num: '34', title: 'Future of the Jedi' },
            { num: '35', title: 'Vader Redeemed' },
            { num: '36', title: 'Luke Stands Ready' },
            { num: '37', title: 'From the Depths' },
            { num: '38', title: 'Marching AT-STs' },
            { num: '39', title: 'Galaxy\'s Most Dangerous' },
            { num: '40', title: 'The Star Wars Saga' },
            { num: '41', title: 'Old Master Yoda' },
            { num: '42', title: 'Diabolic Duo' },
            { num: '43', title: 'Lando Calrissian' },
            { num: '44', title: 'Wing Man' },
            { num: '45', title: 'Take The Bait' },
            { num: '46', title: 'Sneaking Around Danger' },
            { num: '47', title: 'Remnants of Kenobi' },
            { num: '48', title: 'A Dyad in the Force' },
            { num: '49', title: 'Ambush from Above' },
            { num: '50', title: 'A Queen in Portrait' },
            { num: '51', title: 'The Captain Captured!' },
            { num: '52', title: 'A Young Jedi\'s Stance' },
            { num: '53', title: 'Tusken Under Twin Suns' },
            { num: '54', title: 'Flight of the Millennium Falcon' },
            { num: '55', title: 'Jango Draws His Pistols' },
            { num: '56', title: 'Maul\'s Rage' },
            { num: '57', title: 'The Empire\'s Forces' },
            { num: '58', title: 'A Squad of Bounty Hunters' },
            { num: '59', title: 'Attack on Takodana' },
            { num: '60', title: 'Face the Dark Side' },
            { num: '61', title: 'Projection' },
            { num: '62', title: 'Sunset' },
            { num: '63', title: 'The Sacred Tree' },
            { num: '64', title: 'Odd Couple' },
            { num: '65', title: 'Dark Order' },
            { num: '66', title: 'What a Piece of Junk' },
            { num: '67', title: 'Bucket of Bolts' },
            { num: '68', title: 'Just Like Back Home' },
            { num: '69', title: 'Patrolling the Endor Moon' },
            { num: '70', title: 'The Masters of Evil' },
            { num: '71', title: 'Master of Evil' },
            { num: '72', title: 'Bounty Acquired' },
            { num: '73', title: 'He\'s All Yours, Bounty Hunter' },
            { num: '74', title: 'The Reunion' },
            { num: '75', title: 'Battle of Yavin' },
            { num: '76', title: 'Predator & Prey' },
            { num: '77', title: 'Do. Or Do Not.' },
            { num: '78', title: 'The Pursuit' },
            { num: '79', title: 'Dune Sea Palace' },
            { num: '80', title: 'Shiny Return' },
            { num: '81', title: 'The Dark Side' },
            { num: '82', title: 'Princess Leia Organa' },
            { num: '83', title: 'Planetesimals' },
            { num: '84', title: 'Lobot' },
            { num: '85', title: 'Sandtroopers' },
            { num: '86', title: 'Battle of Endor' },
            { num: '87', title: 'Lifting the X-Wing' },
            { num: '88', title: 'Bespin Bounty Hunter' },
            { num: '89', title: 'X-Wings' },
            { num: '90', title: 'Daybreak on Hoth' },
            { num: '91', title: 'Tatooine Sunset' },
            { num: '92', title: 'Dark Side' },
            { num: '93', title: 'Dawn of the Rebellion' },
            { num: '94', title: 'Pinned Down' },
            { num: '95', title: 'Storming Rebels' },
            { num: '96', title: 'Vader\'s Shuttle' },
            { num: '97', title: 'Vengeful Pursuit' },
            { num: '98', title: '74-Z Speeder Bike' },
            { num: '99', title: 'Night Must Fall' },
            { num: '100', title: 'Forced in Darkness' },
          ]
        }
      ],
      insert: [
        {
          count: 20,
          name: 'GALACTIC VISIONS',
          meta: 'New Galaxy artwork',
          odds: '1:9 packs',
          parallels: 10,
          cards: [
            { num: 'GV-1', title: 'Galactic Visions 1' },
            { num: 'GV-2', title: 'Galactic Visions 2' },
            { num: 'GV-3', title: 'Galactic Visions 3' },
            { num: 'GV-4', title: 'Galactic Visions 4' },
            { num: 'GV-5', title: 'Galactic Visions 5' },
            { num: 'GV-6', title: 'Galactic Visions 6' },
            { num: 'GV-7', title: 'Galactic Visions 7' },
            { num: 'GV-8', title: 'Galactic Visions 8' },
            { num: 'GV-9', title: 'Galactic Visions 9' },
            { num: 'GV-10', title: 'Galactic Visions 10' },
            { num: 'GV-11', title: 'Galactic Visions 11' },
            { num: 'GV-12', title: 'Galactic Visions 12' },
            { num: 'GV-13', title: 'Galactic Visions 13' },
            { num: 'GV-14', title: 'Galactic Visions 14' },
            { num: 'GV-15', title: 'Galactic Visions 15' },
            { num: 'GV-16', title: 'Galactic Visions 16' },
            { num: 'GV-17', title: 'Galactic Visions 17' },
            { num: 'GV-18', title: 'Galactic Visions 18' },
            { num: 'GV-19', title: 'Galactic Visions 19' },
            { num: 'GV-20', title: 'Galactic Visions 20' },
          ]
        },
        {
          count: 10,
          name: 'DARTH VADER & THE BOUNTY HUNTERS',
          meta: 'The Empire’s hired guns',
          odds: '1:9 packs',
          parallels: 10,
          cards: [
            { num: 'DVBH-1', title: 'Boba Fett', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-2', title: 'Zuckuss', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-3', title: 'Stormtrooper', meta: 'A New Hope' },
            { num: 'DVBH-4', title: 'Dengar', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-5', title: '4-LOM', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-6', title: 'Bossk', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-7', title: 'Darth Vader Ignites His Lightsaber', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-8', title: 'Darth Vader', meta: 'A New Hope' },
            { num: 'DVBH-9', title: 'IG-88', meta: 'The Empire Strikes Back' },
            { num: 'DVBH-10', title: 'Darth Vader & His Stormtroopers', meta: 'A New Hope' },
          ]
        },
        {
          count: 5,
          name: 'RETURN OF THE JEDI 40TH POSTER ART',
          meta: 'Anniversary tribute',
          odds: '1:9 packs',
          parallels: 10,
          cards: [
            { num: 'ROTJ-1', title: 'ROTJ 40th Anniversary Poster 1' },
            { num: 'ROTJ-2', title: 'ROTJ 40th Anniversary Poster 2' },
            { num: 'ROTJ-3', title: 'ROTJ 40th Anniversary Poster 3' },
            { num: 'ROTJ-4', title: 'ROTJ 40th Anniversary Poster 4' },
            { num: 'ROTJ-5', title: 'ROTJ 40th Anniversary Poster 5' },
          ]
        },
        {
          count: 15,
          name: 'WOMEN OF STAR WARS',
          meta: 'Female heroes across the saga',
          odds: '1:9 packs',
          parallels: 10,
          cards: [
            { num: 'WSW-1', title: 'Hera Syndulla', meta: 'Star Wars Rebels' },
            { num: 'WSW-2', title: 'Padmé Amidala', meta: 'The Phantom Menace' },
            { num: 'WSW-3', title: 'Rey & Kylo Ren', meta: 'The Last Jedi' },
            { num: 'WSW-4', title: 'Asajj Ventress', meta: 'The Clone Wars' },
            { num: 'WSW-5', title: 'Princess Leia & Wicket', meta: 'Return of the Jedi' },
            { num: 'WSW-6', title: 'Sabine Wren', meta: 'Star Wars Rebels' },
            { num: 'WSW-7', title: 'Ahsoka Tano\'s New Path', meta: 'Star Wars Rebels' },
            { num: 'WSW-8', title: 'Queen Amidala', meta: 'The Phantom Menace' },
            { num: 'WSW-9', title: 'The Queen\'s Handmaidens', meta: 'The Phantom Menace' },
            { num: 'WSW-10', title: 'Qi\'ra', meta: 'Solo: A Star Wars Story' },
            { num: 'WSW-11', title: 'Rey Lifting Rocks', meta: 'The Last Jedi' },
            { num: 'WSW-12', title: 'Maz Kanata', meta: 'The Force Awakens' },
            { num: 'WSW-13', title: 'Mon Mothma', meta: 'Rogue One' },
            { num: 'WSW-14', title: 'Aayla Secura', meta: 'Attack of the Clones' },
            { num: 'WSW-15', title: 'Princess Leia', meta: 'A New Hope' },
          ]
        },
        {
          count: 4,
          name: 'KYBER CRYSTAL DIE-CUTS',
          meta: 'KCD-12 through KCD-15',
          noParallels: true,
          odds: '1:1,118 packs',
          cards: [
            { num: 'KCD-12', title: 'Kanan Jarrus' },
            { num: 'KCD-13', title: 'Count Dooku' },
            { num: 'KCD-14', title: 'Asajj Ventress' },
            { num: 'KCD-15', title: 'Yoda' },
          ]
        }
      ],
      auto: [
        {
          count: 4,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer · numbered /25',
          parallels: 3,
          cards: [
            { num: 'DA-FH', title: 'Mark Hamill / Harrison Ford', meta: 'Luke / Han' },
            { num: 'DA-MV', title: 'Ewan McGregor / Indira Varma', meta: 'Obi-Wan / Tala' },
            { num: 'DA-NF', title: 'Harrison Ford / Lupita Nyong\'o', meta: 'Han / Maz' },
            { num: 'DA-PG', title: 'Sarah Michelle Gellar / Freddie Prinze Jr.', meta: '7th Sister / Kanan' },
          ]
        },
        {
          count: 1,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer · numbered /5',
          parallels: 2,
          cards: [
            { num: 'TA-DSM', title: 'Ian McDiarmid / Andy Serkis / Adam Driver', meta: 'Palpatine / Snoke / Kylo' },
          ]
        }
      ],
      sketch: [
        {
          count: 1,
          name: 'SKETCH CARDS',
          meta: 'One-of-one hand-drawn sketches · artist roster not cataloged',
          oneOfOne: true,
          noParallels: true,
          odds: '1:135 packs',
          cards: [
            { num: 'SK-1', title: 'Sketch Card', meta: 'Various Artists' },
          ]
        }
      ],
    },
  },

  '2022-chrome-galaxy': {
    setId: '2022-chrome-galaxy',
    year: '2022',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '12 / 28 / 2022',
    lede: 'The second Chrome Galaxy leans into nostalgia: a 100-card chromium base set, sketch-variation chases on twenty base cards, Retro Rewind cards from the Droids and Ewoks cartoons, video-game cover art in Gameplay Galaxy, and a 71-card autograph program across three signature tiers.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Classic + new Galaxy art', color: 'gold' },
      { num: '5', label: 'Insert Sets', sub: '4 to 25 cards each', color: 'cyan' },
      { num: '71', label: 'Auto Cards', sub: '3 signature tiers', color: 'green' },
      { num: '9', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '10', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4', l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
      { v: '2', l: 'Sketch cards per case' },
    ],
    pullRates: [
      { name: 'Base Card Sketch Variations', odds: '1 : 9', tier: 'normal' },
      { name: 'Original Trilogy Concept Art', odds: '1 : 9', tier: 'normal' },
      { name: 'Retro Rewind', odds: '1 : 9', tier: 'normal' },
      { name: 'Gameplay Galaxy', odds: '1 : 9', tier: 'normal' },
      { name: 'Galaxy Autographs', odds: '1 : 43', tier: 'rare' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'ATOMIC', pr: '/150', gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'WAVE', pr: '/99', gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'PRISM', pr: '/75', gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO', pr: '/50', gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'PURPLE', pr: '/25', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 100%)' },
      { name: 'X-FRACTOR', pr: '/10', gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [
      { name: 'Derek Laufman', work: 'Base Card Sketch Variations — 7 cards' },
      { name: 'Darrin Pepe', work: 'Base Card Sketch Variations — 6 cards' },
      { name: 'Daniel Govar', work: 'Base Card Sketch Variations — 4 cards' },
      { name: 'Jason Crosby', work: 'Base Card Sketch Variations — 3 cards' },
    ],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Classic + new Galaxy artwork',
          parallels: 9,
          cards: [
            { num: '1', title: 'Luke Skywalker' },
            { num: '2', title: 'Darth Vader' },
            { num: '3', title: 'Obi-Wan Kenobi' },
            { num: '4', title: 'Han Solo' },
            { num: '5', title: 'Chewbacca' },
            { num: '6', title: 'Lando Calrissian' },
            { num: '7', title: 'Yoda' },
            { num: '8', title: 'C-3PO' },
            { num: '9', title: 'R2-D2' },
            { num: '10', title: 'Boba Fett' },
            { num: '11', title: 'Emperor Palpatine' },
            { num: '12', title: 'X-wing Starfighters' },
            { num: '13', title: 'Ben Kenobi' },
            { num: '14', title: 'Attack on Hoth!' },
            { num: '15', title: 'Battle with the Dianoga' },
            { num: '16', title: 'PATROLLING the Cantina' },
            { num: '17', title: 'Sandtrooper Atop a Dewback' },
            { num: '18', title: 'The Skywalkers' },
            { num: '19', title: 'Solo Investigates' },
            { num: '20', title: 'Grand Moff Tarkin' },
            { num: '21', title: 'Luke Skywalker in Action!' },
            { num: '22', title: 'The Smuggler, Han Solo' },
            { num: '23', title: 'Bounty Hunters' },
            { num: '24', title: 'Salacious B. Crumb' },
            { num: '25', title: 'A Card Game of Chance' },
            { num: '26', title: 'Tusken Raider at Sundown' },
            { num: '27', title: 'Medical Droid' },
            { num: '28', title: 'Bounty Hunters Answer the Empire\'s Call' },
            { num: '29', title: 'Wookiee War Dance' },
            { num: '30', title: 'Boushh Disguise' },
            { num: '31', title: 'Gamorrean Guard' },
            { num: '32', title: 'Yoda on Dagobah' },
            { num: '33', title: 'Life on Tatooine' },
            { num: '34', title: 'Duel on the Death Star!' },
            { num: '35', title: 'Princess Leia Organa' },
            { num: '36', title: 'Ewoks Under Attack!' },
            { num: '37', title: 'The Emperor\'s Power' },
            { num: '38', title: 'X-wings in Formation' },
            { num: '39', title: 'Yoda and Luke Skywalker' },
            { num: '40', title: 'Stormtrooper Surveying the Desert' },
            { num: '41', title: 'Aboard the Bridge' },
            { num: '42', title: 'Han Solo & Chewbacca in the Cockpit' },
            { num: '43', title: 'Snowtroopers Invade Hoth' },
            { num: '44', title: 'Darth Vader VS. Obi-Wan Kenobi' },
            { num: '45', title: 'Leia Organa in Her Boushh Disguise' },
            { num: '46', title: 'The Dark Lord and a New Hope' },
            { num: '47', title: 'Chewbacca\'s Anguish' },
            { num: '48', title: 'A Wookiee in the Wilderness' },
            { num: '49', title: 'A Galaxy Within Grasp' },
            { num: '50', title: 'Enter: Darth Vader' },
            { num: '51', title: 'The Skywalker Legacy' },
            { num: '52', title: 'The Shadow of the Dark Lord' },
            { num: '53', title: 'The Infamous Boba Fett' },
            { num: '54', title: 'General Grievous' },
            { num: '55', title: 'A Dark Turn for Anakin Skywalker' },
            { num: '56', title: 'Mace Windu\'s Barrage!' },
            { num: '57', title: 'Star Wars' },
            { num: '58', title: 'Stormtroopers Swarm Darth Vader' },
            { num: '59', title: 'Lord Vader & His Stormtroopers' },
            { num: '60', title: 'Luke Skywalker on Endor' },
            { num: '61', title: 'Boba Fett Ambushed!' },
            { num: '62', title: 'An Enemy of the Empire' },
            { num: '63', title: 'Stormtroopers Assess Their Gear' },
            { num: '64', title: 'A Wookiee\'s Wrath' },
            { num: '65', title: 'Luke Skywalker Assembles His Lightsaber' },
            { num: '66', title: 'Creatures of the Cantina' },
            { num: '67', title: 'The Jedi & The Princess' },
            { num: '68', title: 'Wicket W. Warrick' },
            { num: '69', title: 'The Boonta Eve Classic' },
            { num: '70', title: 'Lord Vader Readies His Ship' },
            { num: '71', title: 'Inside the Meditation Chamber' },
            { num: '72', title: 'Wedge Antilles in Battle' },
            { num: '73', title: 'Didn\'t Mean to Intrude' },
            { num: '74', title: 'Lack of Faith' },
            { num: '75', title: 'Tuskens & Their Bantha' },
            { num: '76', title: 'Aayla Secura' },
            { num: '77', title: 'Obi-Wan Kenobi & Boga' },
            { num: '78', title: 'Qui-Gon Jinn' },
            { num: '79', title: 'Galaxy\'s Greatest Scoundrels' },
            { num: '80', title: 'Boba Fett Battles the Sarlacc!' },
            { num: '81', title: 'Poe Dameron' },
            { num: '82', title: 'Trudgen' },
            { num: '83', title: 'Kylo Ren' },
            { num: '84', title: 'Sith Trooper' },
            { num: '85', title: 'Cobb Vanth' },
            { num: '86', title: 'Leia Organa' },
            { num: '87', title: 'Finn' },
            { num: '88', title: 'Hunter' },
            { num: '89', title: 'Echo' },
            { num: '90', title: 'Crosshair' },
            { num: '91', title: 'Wrecker' },
            { num: '92', title: 'Tech' },
            { num: '93', title: 'Omega' },
            { num: '94', title: 'Weequay' },
            { num: '95', title: 'Greedo' },
            { num: '96', title: 'Bossk' },
            { num: '97', title: 'Torra Doza' },
            { num: '98', title: 'Hera Syndulla' },
            { num: '99', title: 'Wedge Antilles' },
            { num: '100', title: 'Anakin Skywalker' },
          ]
        }
      ],
      insert: [
        {
          count: 4,
          name: 'PROMOTIONAL CARDS',
          meta: 'P1 through P4',
          parallels: 9,
          cards: [
            { num: 'P1', title: 'Vintage Vader' },
            { num: 'P2', title: 'Docking Bay 94' },
            { num: 'P3', title: 'Man with a Mission' },
            { num: 'P4', title: 'Vader, Unplugged' },
          ]
        },
        {
          count: 20,
          name: 'BASE CARD SKETCH VARIATIONS',
          meta: 'Four artists',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'BV-81', title: 'Poe Dameron', meta: 'Derek Laufman' },
            { num: 'BV-82', title: 'Trudgen', meta: 'Derek Laufman' },
            { num: 'BV-83', title: 'Kylo Ren', meta: 'Derek Laufman' },
            { num: 'BV-84', title: 'Sith Trooper', meta: 'Derek Laufman' },
            { num: 'BV-85', title: 'Cobb Vanth', meta: 'Derek Laufman' },
            { num: 'BV-86', title: 'Leia Organa', meta: 'Derek Laufman' },
            { num: 'BV-87', title: 'Finn', meta: 'Derek Laufman' },
            { num: 'BV-88', title: 'Hunter', meta: 'Darrin Pepe' },
            { num: 'BV-89', title: 'Echo', meta: 'Darrin Pepe' },
            { num: 'BV-90', title: 'Crosshair', meta: 'Darrin Pepe' },
            { num: 'BV-91', title: 'Wrecker', meta: 'Darrin Pepe' },
            { num: 'BV-92', title: 'Tech', meta: 'Darrin Pepe' },
            { num: 'BV-93', title: 'Omega', meta: 'Darrin Pepe' },
            { num: 'BV-94', title: 'Weequay', meta: 'Jason Crosby' },
            { num: 'BV-95', title: 'Greedo', meta: 'Jason Crosby' },
            { num: 'BV-96', title: 'Bossk', meta: 'Jason Crosby' },
            { num: 'BV-97', title: 'Torra Doza', meta: 'Daniel Govar' },
            { num: 'BV-98', title: 'Hera Syndulla', meta: 'Daniel Govar' },
            { num: 'BV-99', title: 'Wedge Antilles', meta: 'Daniel Govar' },
            { num: 'BV-100', title: 'Anakin Skywalker', meta: 'Daniel Govar' },
          ]
        },
        {
          count: 10,
          name: 'ORIGINAL TRILOGY CONCEPT ART',
          meta: 'Early concept renderings',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'OT-1', title: 'Original Trilogy Concept Art 1' },
            { num: 'OT-2', title: 'Original Trilogy Concept Art 2' },
            { num: 'OT-3', title: 'Original Trilogy Concept Art 3' },
            { num: 'OT-4', title: 'Original Trilogy Concept Art 4' },
            { num: 'OT-5', title: 'Original Trilogy Concept Art 5' },
            { num: 'OT-6', title: 'Original Trilogy Concept Art 6' },
            { num: 'OT-7', title: 'Original Trilogy Concept Art 7' },
            { num: 'OT-8', title: 'Original Trilogy Concept Art 8' },
            { num: 'OT-9', title: 'Original Trilogy Concept Art 9' },
            { num: 'OT-10', title: 'Original Trilogy Concept Art 10' },
          ]
        },
        {
          count: 15,
          name: 'RETRO REWIND',
          meta: 'Droids & Ewoks animation',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'V-1', title: 'Boba Fett', meta: 'Star Wars: Droids' },
            { num: 'V-2', title: 'A Close Call!', meta: 'Star Wars: Droids' },
            { num: 'V-3', title: 'On a Sand Skiff', meta: 'Star Wars: Droids' },
            { num: 'V-4', title: 'Jessica Meade & Max Rebo', meta: 'Star Wars: Droids' },
            { num: 'V-5', title: 'Admiral Screed', meta: 'Star Wars: Droids' },
            { num: 'V-6', title: 'In Jord\'s Garage', meta: 'Star Wars: Droids' },
            { num: 'V-7', title: 'The Fromm Gang', meta: 'Star Wars: Droids' },
            { num: 'V-8', title: 'Mungo Baobab', meta: 'Star Wars: Droids' },
            { num: 'V-9', title: 'Paploo', meta: 'Star Wars: Ewoks' },
            { num: 'V-10', title: 'Chief Chirpa', meta: 'Star Wars: Ewoks' },
            { num: 'V-11', title: 'Wicket W. Warrick', meta: 'Star Wars: Ewoks' },
            { num: 'V-12', title: 'Dulok Shaman', meta: 'Star Wars: Ewoks' },
            { num: 'V-13', title: 'Princess Kneesaa', meta: 'Star Wars: Ewoks' },
            { num: 'V-14', title: 'Through the Bog', meta: 'Star Wars: Ewoks' },
            { num: 'V-15', title: 'Wicket in Bright Tree Village', meta: 'Star Wars: Ewoks' },
          ]
        },
        {
          count: 25,
          name: 'GAMEPLAY GALAXY',
          meta: 'Video game cover art',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'GG-1', title: 'Star Wars: Empire at War' },
            { num: 'GG-2', title: 'Star Wars Jedi Knight II: Jedi Outcast' },
            { num: 'GG-3', title: 'Star Wars: Rebellion' },
            { num: 'GG-4', title: 'Star Wars: X-Wing vs. TIE Fighter' },
            { num: 'GG-5', title: 'Star Wars: X-Wing Tour of Duty: B-Wing' },
            { num: 'GG-6', title: 'Star Wars: Rebel Assault' },
            { num: 'GG-7', title: 'Star Wars: X-Wing' },
            { num: 'GG-8', title: 'Star Wars: The Empire Strikes Back' },
            { num: 'GG-9', title: 'Star Wars' },
            { num: 'GG-10', title: 'Star Wars: Battlefront II' },
            { num: 'GG-11', title: 'Star Wars: Republic Commando' },
            { num: 'GG-12', title: 'Star Wars: Battlefront' },
            { num: 'GG-13', title: 'Star Wars: Bounty Hunter' },
            { num: 'GG-14', title: 'Star Wars: Droidworks' },
            { num: 'GG-15', title: 'Star Wars Rogue Squadron III: Rebel Strike' },
            { num: 'GG-16', title: 'Star Wars: Starfighter' },
            { num: 'GG-17', title: 'Star Wars: Galactic Battlegrounds' },
            { num: 'GG-18', title: 'Star Wars: Demolition' },
            { num: 'GG-19', title: 'Star Wars: Force Commander' },
            { num: 'GG-20', title: 'Star Wars Jedi Knight: Mysteries of the Sith' },
            { num: 'GG-21', title: 'Star Wars: Shadows of the Empire' },
            { num: 'GG-22', title: 'Star Wars: Tie Fighter' },
            { num: 'GG-23', title: 'Star Wars: Super Bombad Racing' },
            { num: 'GG-24', title: 'Star Wars: Dark Forces' },
            { num: 'GG-25', title: 'Star Wars: Masters of Teräs Käsi' },
          ]
        }
      ],
      auto: [
        {
          count: 61,
          name: 'GALAXY AUTOGRAPHS',
          meta: 'Single-signer base auto tier',
          odds: '1:43 packs',
          parallels: 6,
          cards: [
            { num: 'GA-ABJ', title: 'Ahmed Best' },
            { num: 'GA-ABT', title: 'Andrea Bartlow' },
            { num: 'GA-AD', title: 'Adam Driver' },
            { num: 'GA-AGR', title: 'Allan Graf' },
            { num: 'GA-AK', title: 'Andrew Kishino' },
            { num: 'GA-BBU', title: 'Bernard Bullen' },
            { num: 'GA-BD', title: 'Ben Diskin' },
            { num: 'GA-BH', title: 'Brian Herring' },
            { num: 'GA-BL', title: 'Billie Lourd' },
            { num: 'GA-BM', title: 'Ben Mendelsohn' },
            { num: 'GA-CDW', title: 'Corey Dee Williams' },
            { num: 'GA-CH', title: 'Clint Howard' },
            { num: 'GA-CJ', title: 'Carey Jones' },
            { num: 'GA-CS', title: 'Christopher Sean' },
            { num: 'GA-DCB', title: 'Dave Chapman' },
            { num: 'GA-DMB', title: 'Dominic Monaghan' },
            { num: 'GA-DP', title: 'David Pasquesi' },
            { num: 'GA-DR', title: 'Daisy Ridley' },
            { num: 'GA-EW', title: 'Ewan McGregor' },
            { num: 'GA-GCP', title: 'Gwendoline Christie' },
            { num: 'GA-GE', title: 'Giancarlo Esposito' },
            { num: 'GA-GG', title: 'Greg Grunberg' },
            { num: 'GA-GTO', title: 'Gina Torres' },
            { num: 'GA-HC', title: 'Hayden Christensen' },
            { num: 'GA-HF', title: 'Harrison Ford' },
            { num: 'GA-IF', title: 'Isla Farris' },
            { num: 'GA-IM', title: 'Ian McDiarmid' },
            { num: 'GA-IS', title: 'Isaac Singleton Jr.' },
            { num: 'GA-JA', title: 'Josef Altin' },
            { num: 'GA-JBT', title: 'Joanna Bennet' },
            { num: 'GA-JC', title: 'Jake Cannavale' },
            { num: 'GA-JK', title: 'Jamie King' },
            { num: 'GA-JRO', title: 'John Rosengrant' },
            { num: 'GA-JS', title: 'Jason Spisak' },
            { num: 'GA-JT', title: 'John Tui' },
            { num: 'GA-KMT', title: 'Kelly Marie Tran' },
            { num: 'GA-KSN', title: 'Kiran Shah' },
            { num: 'GA-LD', title: 'Laura Dern' },
            { num: 'GA-LT', title: 'Lee Towersey' },
            { num: 'GA-MB', title: 'Matt Berry' },
            { num: 'GA-MBA', title: 'Michonne Bourriague' },
            { num: 'GA-ME', title: 'Mike Edmonds' },
            { num: 'GA-MM', title: 'Mads Mikkelsen' },
            { num: 'GA-MNW', title: 'Ming-Na Wen' },
            { num: 'GA-MR', title: 'Misty Rosas' },
            { num: 'GA-NA', title: 'Naomi Ackie' },
            { num: 'GA-NF', title: 'Nika Futterman' },
            { num: 'GA-NN', title: 'Nick Nolte' },
            { num: 'GA-OA', title: 'Omid Abtahi' },
            { num: 'GA-ODA', title: 'Olivia d\'Abo' },
            { num: 'GA-PAR', title: 'Philip Anthony-Rodriguez' },
            { num: 'GA-PL', title: 'Phil LaMarr' },
            { num: 'GA-RAD', title: 'Robin Atkin Downes' },
            { num: 'GA-RD', title: 'Rosario Dawson' },
            { num: 'GA-SB', title: 'Skyler Bible' },
            { num: 'GA-SBL', title: 'Steve Blum' },
            { num: 'GA-TS', title: 'Tiya Sircar' },
            { num: 'GA-VM', title: 'Vanessa Marshall' },
            { num: 'GA-WD', title: 'Warwick Davis' },
            { num: 'GA-WEB', title: 'W. Earl Brown' },
            { num: 'GA-WH', title: 'Werner Herzog' },
          ]
        },
        {
          count: 6,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'DA-BL', title: 'Brian Herring / Lynn Bruce Robertson' },
            { num: 'DA-CM', title: 'Ming-Na Wen / Carey Jones', meta: 'Fennec / Cobb' },
            { num: 'DA-DA', title: 'Adam Driver / Daisy Ridley', meta: 'Kylo / Rey' },
            { num: 'DA-HE', title: 'Hayden Christensen / Ewan McGregor', meta: 'Anakin / Obi-Wan' },
            { num: 'DA-MF', title: 'Felicity Jones / Mads Mikkelsen', meta: 'Jyn / Galen' },
            { num: 'DA-TF', title: 'Freddie Prinze Jr. / Tom Baker', meta: 'Kanan / Baker' },
          ]
        },
        {
          count: 4,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer',
          parallels: 1,
          cards: [
            { num: 'TA-DAJ', title: 'Daisy Ridley / Naomi Ackie / John Boyega', meta: 'Rey / Jannah / Finn' },
            { num: 'TA-EAW', title: 'Alden Ehrenreich / Warwick Davis / Erin Kellyman', meta: 'Han / Wicket / Enfys' },
            { num: 'TA-FVT', title: 'Taylor Gray / Vanessa Marshall / Freddie Prinze Jr.', meta: 'Ezra / Hera / Kanan' },
            { num: 'TA-HEI', title: 'Ewan McGregor / Ian McDiarmid / Hayden Christensen', meta: 'Obi-Wan / Palpatine / Anakin' },
          ]
        }
      ],
      sketch: [
        {
          count: 1,
          name: 'SKETCH CARDS',
          meta: 'One-of-one hand-drawn sketches · artist roster not cataloged',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Sketch Card', meta: 'Various Artists' },
          ]
        }
      ],
    },
  },

  '2021-chrome-galaxy': {
    setId: '2021-chrome-galaxy',
    year: '2021',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '8 / 25 / 2021',
    lede: 'The one that started the line — the first Star Wars Galaxy release on chromium stock. A 100-card base set of classic Galaxy paintings and new commissions, a 9-deep refractor rainbow, three poster-driven insert sets, and an 82-card autograph program crowned by ten triple signatures.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Classic + new Galaxy art', color: 'gold' },
      { num: '3', label: 'Insert Sets', sub: '10 to 20 cards each', color: 'cyan' },
      { num: '82', label: 'Auto Cards', sub: '3 signature tiers', color: 'green' },
      { num: '9', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '8', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4', l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '1', l: 'Autograph per box' },
      { v: '2', l: 'Sketch cards per case' },
    ],
    pullRates: [
      { name: 'Visions of Mandalore', odds: '1 : 9', tier: 'normal' },
      { name: 'Vintage Star Wars Posters', odds: '1 : 9', tier: 'normal' },
      { name: 'Star Wars Global Posters', odds: '1 : 9', tier: 'normal' },
      { name: 'Sketch Cards', odds: '2 : case', tier: 'rare' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'ATOMIC', pr: '/150', gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'WAVE', pr: '/99', gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'PRISM', pr: '/75', gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO', pr: '/50', gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'PURPLE', pr: '/25', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 100%)' },
      { name: 'X-FRACTOR', pr: '/10', gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [
      { name: 'Steve Chorney', work: 'Base set — 9 cards' },
      { name: 'Doug Cowan', work: 'Base set — 7 cards' },
      { name: 'Jerry Vanderstelt', work: 'Base set — 6 cards' },
      { name: 'Joe Corroney', work: 'Base set — 5 cards' },
      { name: 'Randy Martinez', work: 'Base set — 4 cards' },
      { name: 'Brian Rood', work: 'Base set — 3 cards' },
    ],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Classic + new Galaxy artwork',
          parallels: 9,
          cards: [
            { num: '1', title: 'Speeder Bike Chase', meta: 'June Brigman' },
            { num: '2', title: 'The Light of Padmé Amidala', meta: 'Marcia Dye' },
            { num: '3', title: 'The Droids', meta: 'Dave Dorman' },
            { num: '4', title: 'Frozen in Carbonite', meta: 'Dale Keown' },
            { num: '5', title: 'The Max Rebo Band', meta: 'Karl Kesel' },
            { num: '6', title: 'An Oversized Presence', meta: 'Jean Moebius Giraud' },
            { num: '7', title: 'The Emperor\'s Royal Guards', meta: 'Jerome Moore' },
            { num: '8', title: 'The Rancor', meta: 'Jason Palmer' },
            { num: '9', title: 'Darth Vader', meta: 'George Pratt' },
            { num: '10', title: 'T-16 Skyhopper', meta: 'Ken Steacy' },
            { num: '11', title: 'A Dangerous Boba Fett', meta: 'Brian Stelfreeze' },
            { num: '12', title: 'Warrior Ewok', meta: 'William Stout' },
            { num: '13', title: 'Jawas', meta: 'Greg Theakston' },
            { num: '14', title: 'Chewbacca', meta: 'Russell Walks' },
            { num: '15', title: 'Imperial Snowtroopers', meta: 'Al Williamson' },
            { num: '16', title: 'Mos Eisley Cantina', meta: 'Bruce Zick' },
            { num: '17', title: 'IG-88 on the Attack', meta: 'Karl Altstaetter' },
            { num: '18', title: 'Boba Fett\'s Starship', meta: 'Joe DeVito' },
            { num: '19', title: 'Aurra Sing on Tatooine', meta: 'Darrin Pepe' },
            { num: '20', title: 'Triple Threat', meta: 'Kyle Babbit' },
            { num: '21', title: '"I Love You"', meta: 'Rebecca Guay' },
            { num: '22', title: 'A Dark Presence', meta: 'Matt Haley' },
            { num: '23', title: 'Larger than Life', meta: 'Jack Kirby' },
            { num: '24', title: 'Crushing the Rebels', meta: 'Walter McDaniel' },
            { num: '25', title: 'Rule of Two', meta: 'Nelson' },
            { num: '26', title: 'Forsake the Dark Side', meta: 'Hoang Nguyen' },
            { num: '27', title: 'AT-ST', meta: 'Kevin O\'Neill' },
            { num: '28', title: 'Leap of Faith', meta: 'Zina Saunders' },
            { num: '29', title: 'The Four Jedi', meta: 'Greg and Tim Hildebrandt' },
            { num: '30', title: 'Galaxy\'s Edge', meta: 'Arthur Adams' },
            { num: '31', title: 'Escaping the AT-STs', meta: 'Dave Dorman' },
            { num: '32', title: 'Boba Fett', meta: 'Brett Booth' },
            { num: '33', title: 'New Friends', meta: 'Scott Neely' },
            { num: '34', title: 'Luke Skywalker', meta: 'Jerry Vanderstelt' },
            { num: '35', title: 'Leia Organa', meta: 'Jerry Vanderstelt' },
            { num: '36', title: 'Han Solo', meta: 'Jerry Vanderstelt' },
            { num: '37', title: 'Darth Sidious', meta: 'Steve Chorney' },
            { num: '38', title: 'Qui-Gon Jinn', meta: 'Steve Chorney' },
            { num: '39', title: 'Anakin Skywalker', meta: 'Steve Chorney' },
            { num: '40', title: 'Padmé Amidala', meta: 'Steve Chorney' },
            { num: '41', title: 'Jango Fett', meta: 'Steve Chorney' },
            { num: '42', title: 'Mace Windu', meta: 'Steve Chorney' },
            { num: '43', title: 'The Empire on Hoth', meta: 'Brian Rood' },
            { num: '44', title: 'Yoda on Dagobah', meta: 'Doug Cowan' },
            { num: '45', title: 'A Padawan\'s Challenge', meta: 'Grant Gould' },
            { num: '46', title: 'Teaching The Younglings', meta: 'Joe Corroney' },
            { num: '47', title: 'Call to Vengeance', meta: 'Ken Steacy' },
            { num: '48', title: 'Empire and Rebellion', meta: 'Jerry Vanderstelt' },
            { num: '49', title: 'Republic: Unite', meta: 'Joe Corroney' },
            { num: '50', title: 'Rebellion: Celebrate', meta: 'Joe Corroney' },
            { num: '51', title: 'New Republic: Together', meta: 'Joe Corroney' },
            { num: '52', title: 'Enlist Today', meta: 'Cliff Chiang' },
            { num: '53', title: 'Loose Lips', meta: 'Cliff Chiang' },
            { num: '54', title: 'Rebuild the Death Star', meta: 'Cliff Chiang' },
            { num: '55', title: 'Regrets', meta: 'Jerry Vanderstelt' },
            { num: '56', title: 'Palpatine Plays Possum', meta: 'Mark McHaley' },
            { num: '57', title: 'Rey The Scavenger', meta: 'Andrew Fry' },
            { num: '58', title: 'Luke\'s Ground Assault', meta: 'Doug Cowan' },
            { num: '59', title: 'Surveyed by the Dark Lord', meta: 'Doug Cowan' },
            { num: '60', title: 'The Battle of Hoth', meta: 'Matt Busch' },
            { num: '61', title: 'The Falcon Fires', meta: 'Brian Rood' },
            { num: '62', title: 'Endor Chase', meta: 'Steve McNiven' },
            { num: '63', title: 'A Sad Farewell', meta: 'Chris Trevas' },
            { num: '64', title: 'Reflections on Endor', meta: 'Doug Cowan' },
            { num: '65', title: 'The Dangers of Felucia', meta: 'Doug Cowan' },
            { num: '66', title: 'The Solitary Wicket', meta: 'Doug Cowan' },
            { num: '67', title: 'Gamorrean Guard', meta: 'Jason Edminston' },
            { num: '68', title: 'Offbeat Buddies', meta: 'Steve Chorney' },
            { num: '69', title: 'The Darkest Lord', meta: 'Ed Repka' },
            { num: '70', title: 'We are Bearing Gifts', meta: 'Nathan Hamill' },
            { num: '71', title: 'Curiosity Blasts Threepio', meta: 'Matt Busch' },
            { num: '72', title: 'Fall of a Jedi', meta: 'Matt Busch' },
            { num: '73', title: 'Focused And Fearless', meta: 'Allison Sohn' },
            { num: '74', title: 'Boba\'s Prize', meta: 'Leinel Yu' },
            { num: '75', title: 'Rancor Ranks Best of Beasts', meta: 'Rob Dobi' },
            { num: '76', title: 'Logray\'s Hunt', meta: 'Patrick Schoenmaker' },
            { num: '77', title: 'The Wrath of Maul', meta: 'Russ Walks' },
            { num: '78', title: 'The Finest on Naboo', meta: 'Jerry Vanderstelt' },
            { num: '79', title: 'The Rogue Years', meta: 'Steve Chorney' },
            { num: '80', title: 'Birth of a Hero', meta: 'Steve Chorney' },
            { num: '81', title: 'A Menace Named Maul', meta: 'Joe Corroney' },
            { num: '82', title: 'The Hopeful Princess', meta: 'Doug Cowan' },
            { num: '83', title: 'Vader\'s Revenge', meta: 'Brian Rood' },
            { num: '84', title: 'In the Court of the Evil Hutt', meta: 'Patrick Schoenmaker' },
            { num: '85', title: 'A Hutt Called Jabba', meta: 'Ed Repka' },
            { num: '86', title: 'Dueling with Dooku', meta: 'Paul Shipper' },
            { num: '87', title: 'Rites of Passage', meta: 'William Silvers' },
            { num: '88', title: 'Jedi a la Kurosawa', meta: 'Randy Martinez' },
            { num: '89', title: 'Dashing Derring-Do', meta: 'Randy Martinez' },
            { num: '90', title: 'The Karloff Connection', meta: 'Randy Martinez' },
            { num: '91', title: 'The Skywalker Saga: Luke', meta: 'Carlos Cabaleiro' },
            { num: '92', title: 'Student Becomes the Teacher', meta: 'Randy Martinez' },
            { num: '93', title: 'United behind General Grievous', meta: 'Ben Abu Saada' },
            { num: '94', title: 'Mos Eisley After Dark', meta: 'Eric Lehtonen' },
            { num: '95', title: 'Commander Poe Dameron', meta: 'Paul Andrews' },
            { num: '96', title: 'Light Rises to Meet Dark', meta: 'Bob Stevlic' },
            { num: '97', title: 'The Sand People', meta: 'Kris Pennix' },
            { num: '98', title: 'Thrawn\'s Private Quarters', meta: 'Rich Molinelli' },
            { num: '99', title: 'Stardust on Scarif', meta: 'Todd Aaron Smith' },
            { num: '100', title: 'The First Order\'s Enforcer', meta: 'Joe Coronney' },
          ]
        }
      ],
      insert: [
        {
          count: 10,
          name: 'VISIONS OF MANDALORE',
          meta: 'Mandalorian-era art',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'MN-1', title: 'Visions of Mandalore 1' },
            { num: 'MN-2', title: 'Visions of Mandalore 2' },
            { num: 'MN-3', title: 'Visions of Mandalore 3' },
            { num: 'MN-4', title: 'Visions of Mandalore 4' },
            { num: 'MN-5', title: 'Visions of Mandalore 5' },
            { num: 'MN-6', title: 'Visions of Mandalore 6' },
            { num: 'MN-7', title: 'Visions of Mandalore 7' },
            { num: 'MN-8', title: 'Visions of Mandalore 8' },
            { num: 'MN-9', title: 'Visions of Mandalore 9' },
            { num: 'MN-10', title: 'Visions of Mandalore 10' },
          ]
        },
        {
          count: 15,
          name: 'VINTAGE STAR WARS POSTERS',
          meta: '1970s–80s collectibles art',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'V-1', title: 'Millennium Falcon' },
            { num: 'V-2', title: 'Hero Action Figures' },
            { num: 'V-3', title: 'Star Destroyer' },
            { num: 'V-4', title: 'Action Figures' },
            { num: 'V-5', title: 'Scout Trooper with Speeder Bike' },
            { num: 'V-6', title: 'Millennium Falcon' },
            { num: 'V-7', title: 'Death Star Racing Set' },
            { num: 'V-8', title: 'Darth Vader Helmet' },
            { num: 'V-9', title: 'Remote Control R2-D2' },
            { num: 'V-10', title: 'Death Star II' },
            { num: 'V-11', title: 'Villain Action Figures' },
            { num: 'V-12', title: 'Action Figure Order Form' },
            { num: 'V-13', title: 'T-65 X-wing Starfighter' },
            { num: 'V-14', title: 'Jabba the Hutt Playset' },
            { num: 'V-15', title: 'Millennium Falcon Scale Model' },
          ]
        },
        {
          count: 20,
          name: 'STAR WARS GLOBAL POSTERS',
          meta: 'International theatrical posters',
          odds: '1:9 packs',
          parallels: 5,
          cards: [
            { num: 'GP-1', title: 'Star Wars: The Empire Strikes Back – Sweden' },
            { num: 'GP-2', title: 'Star Wars: The Empire Strikes Back – Spain' },
            { num: 'GP-3', title: 'Star Wars: The Empire Strikes Back – China' },
            { num: 'GP-4', title: 'Star Wars: The Empire Strikes Back – France' },
            { num: 'GP-5', title: 'Star Wars: The Empire Strikes Back – Argentina' },
            { num: 'GP-6', title: 'Star Wars: The Empire Strikes Back – Japan' },
            { num: 'GP-7', title: 'Star Wars: The Empire Strikes Back – Italy' },
            { num: 'GP-8', title: 'Star Wars: The Empire Strikes Back – Brazil' },
            { num: 'GP-9', title: 'Star Wars: The Empire Strikes Back – Sweden' },
            { num: 'GP-10', title: 'Star Wars: Return of the Jedi – Japan' },
            { num: 'GP-11', title: 'Star Wars: A New Hope – Thailand' },
            { num: 'GP-12', title: 'Star Wars: A New Hope – Spain' },
            { num: 'GP-13', title: 'Star Wars: A New Hope – France' },
            { num: 'GP-14', title: 'Star Wars: Return of the Jedi – Poland' },
            { num: 'GP-15', title: 'Star Wars: Return of the Jedi – Spain' },
            { num: 'GP-16', title: 'Star Wars: A New Hope – France' },
            { num: 'GP-17', title: 'Star Wars: A New Hope – Israel' },
            { num: 'GP-18', title: 'Star Wars: A New Hope – Italy' },
            { num: 'GP-19', title: 'Star Wars: A New Hope – Poland' },
            { num: 'GP-20', title: 'Star Wars: A New Hope – USA' },
          ]
        }
      ],
      auto: [
        {
          count: 59,
          name: 'GALAXY AUTOGRAPHS',
          meta: 'Single-signer base auto tier',
          parallels: 6,
          cards: [
            { num: 'GA-AB', title: 'Anna Brewster' },
            { num: 'GA-AD', title: 'Adam Driver' },
            { num: 'GA-AG', title: 'Anna Graves' },
            { num: 'GA-AND', title: 'Annabelle Davis' },
            { num: 'GA-AS', title: 'Andy Serkis' },
            { num: 'GA-ASG', title: 'Arti Shah' },
            { num: 'GA-AT', title: 'Alan Tudyk' },
            { num: 'GA-BB', title: 'Blair Bess' },
            { num: 'GA-BDW', title: 'Billy Dee Williams' },
            { num: 'GA-BL', title: 'Billie Lourd' },
            { num: 'GA-CDW', title: 'Corey Dee Williams' },
            { num: 'GA-CE', title: 'Chris Edgerly' },
            { num: 'GA-CF', title: 'Carrie Fisher' },
            { num: 'GA-CW', title: 'Carl Weathers' },
            { num: 'GA-DC', title: 'Dermot Crowley' },
            { num: 'GA-DMB', title: 'Dominic Monaghan' },
            { num: 'GA-DR', title: 'Daisy Ridley' },
            { num: 'GA-DT', title: 'Dee Tails' },
            { num: 'GA-DY', title: 'Donnie Yen' },
            { num: 'GA-EK', title: 'Erin Kellyman' },
            { num: 'GA-ES', title: 'Emily Swallow' },
            { num: 'GA-EW', title: 'Ewan McGregor' },
            { num: 'GA-FJ', title: 'Felicity Jones' },
            { num: 'GA-FW', title: 'Forest Whitaker' },
            { num: 'GA-GCP', title: 'Gwendoline Christie' },
            { num: 'GA-GE', title: 'Giancarlo Esposito' },
            { num: 'GA-GG', title: 'Greg Grunberg' },
            { num: 'GA-HC', title: 'Hayden Christensen' },
            { num: 'GA-HCT', title: 'Hermione Corfield' },
            { num: 'GA-HD', title: 'Harley Durst' },
            { num: 'GA-HF', title: 'Harrison Ford' },
            { num: 'GA-IK', title: 'Ian Kenny' },
            { num: 'GA-IR', title: 'Ian Ruskin' },
            { num: 'GA-JH', title: 'Jessica Henwick' },
            { num: 'GA-JK', title: 'Jaime King' },
            { num: 'GA-JR', title: 'John Ratzenberger' },
            { num: 'GA-JS', title: 'Jason Spisak' },
            { num: 'GA-JT', title: 'John Tui' },
            { num: 'GA-KB', title: 'Kenny Baker' },
            { num: 'GA-KMT', title: 'Kelly Marie Tran' },
            { num: 'GA-LD', title: 'Laura Dern' },
            { num: 'GA-MM', title: 'Mads Mikkelsen' },
            { num: 'GA-NA', title: 'Naomi Ackie' },
            { num: 'GA-NF', title: 'Nika Futterman' },
            { num: 'GA-NN', title: 'Nick Nolte' },
            { num: 'GA-OA', title: 'Omid Abtahi' },
            { num: 'GA-PAR', title: 'Philip Anthony-Rodriguez' },
            { num: 'GA-PM', title: 'Peter Mayhew' },
            { num: 'GA-PP', title: 'Pedro Pascal' },
            { num: 'GA-RA', title: 'Riz Ahmed' },
            { num: 'GA-RAD', title: 'Robin Atkin Downes' },
            { num: 'GA-RP', title: 'Ray Park' },
            { num: 'GA-SLJ', title: 'Samuel L. Jackson' },
            { num: 'GA-TD', title: 'Tim Dry' },
            { num: 'GA-TM', title: 'Temuera Morrison' },
            { num: 'GA-TW', title: 'Taika Waititi' },
            { num: 'GA-VK', title: 'Valene Kane' },
            { num: 'GA-WD', title: 'Warwick Davis' },
            { num: 'GA-WH', title: 'Werner Herzog' },
          ]
        },
        {
          count: 13,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'DA-CB', title: 'John Boyega / Gwendoline Christie', meta: 'Finn / Phasma' },
            { num: 'DA-CC', title: 'Hermione Corfield / Crystal Clarke' },
            { num: 'DA-EB', title: 'Paul Bettany / Alden Ehrenreich', meta: 'Dryden / Han' },
            { num: 'DA-FB', title: 'Brian Blessed / Oliver Ford Davies' },
            { num: 'DA-FM', title: 'Peter Mayhew / Harrison Ford', meta: 'Chewie / Han' },
            { num: 'DA-JM', title: 'Mads Mikkelsen / Felicity Jones', meta: 'Galen / Jyn' },
            { num: 'DA-KE', title: 'Ashley Eckstein / Jaime King' },
            { num: 'DA-MB', title: 'Ewan McGregor / Ahmed Best', meta: 'Obi-Wan / Jar Jar' },
            { num: 'DA-ML', title: 'Temuera Morrison / Daniel Logan', meta: 'Jango / Young Boba' },
            { num: 'DA-NE', title: 'Giancarlo Esposito / Werner Herzog', meta: 'Moff / Client' },
            { num: 'DA-RS', title: 'Joonas Suotamo / Daisy Ridley', meta: 'Chewie / Rey' },
            { num: 'DA-SL', title: 'Charlotte Louise / Sema-Tawi Smart' },
            { num: 'DA-TE', title: 'George Takei / Ashley Eckstein' },
          ]
        },
        {
          count: 10,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer',
          parallels: 1,
          cards: [
            { num: 'TA-DSC', title: 'Adam Driver / Andy Serkis / Gwendoline Christie', meta: 'Kylo / Snoke / Phasma' },
            { num: 'TA-EKD', title: 'Alden Ehrenreich / Warwick Davis / Erin Kellyman', meta: 'Solo Cast' },
            { num: 'TA-FET', title: 'Jeremy Bulloch / Temuera Morrison / Daniel Logan', meta: 'Boba Fetts' },
            { num: 'TA-FWM', title: 'Harrison Ford / Peter Mayhew / Billy Dee Williams', meta: 'Han / Chewie / Lando' },
            { num: 'TA-HFP', title: 'Amanda Hale / Simon Paisley Day / Geff Francis' },
            { num: 'TA-LHK', title: 'Denis Lawson / Jack Klaff / Garrick Hagon', meta: 'Wedge / Red Six / Red Three' },
            { num: 'TA-MAC', title: 'Tim Rose / Caroline Blakiston / Dermot Crowley', meta: 'Ackbar / Mon Mothma / Madine' },
            { num: 'TA-RBT', title: 'Daisy Ridley / John Boyega / Kelly Marie Tran', meta: 'Rey / Finn / Rose' },
            { num: 'TA-WRQ', title: 'Simon Williamson / Mike Quinn / Deep Roy' },
            { num: 'TA-YKK', title: 'Paul Kasey / Nick Kellington / Donnie Yen' },
          ]
        }
      ],
      sketch: [
        {
          count: 1,
          name: 'SKETCH CARDS',
          meta: 'One-of-one hand-drawn sketches · artist roster not cataloged',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Sketch Card', meta: 'Various Artists' },
          ]
        }
      ],
    },
  },

  '2026-galaxy': {
    setId: '2026-galaxy',
    year: '2026',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '8 / 12 / 2026',
    lede: 'The sixth Chrome Galaxy and the art showcase of the 2026 chrome calendar. A 100-card base set mixing newly commissioned art with classic Galaxy artwork, backed by a 17-deep parallel rainbow, nine insert sets from Duel on Cloud City to Knights of the Republic, four autograph tiers, and a 218-artist sketch program.',
    stats: [
      { num: '100', label: 'Base Cards',     sub: 'New art / archives',   color: 'gold' },
      { num: '9',   label: 'Insert Sets',    sub: '5 to 36 cards each',   color: 'cyan' },
      { num: '85',  label: 'Auto Cards',     sub: '4 signature tiers',    color: 'green' },
      { num: '17',  label: 'Base Parallels', sub: 'Refractor → 1/1',      color: 'purple' },
      { num: '15',  label: 'Sub-sets Total', sub: 'Tracked on CK',        color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4',  l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '4',  l: 'Numbered parallels / box' },
      { v: '1',  l: 'Autograph per case' },
    ],
    pullRates: [
      { name: 'Art inserts (5 sets)',       odds: 'TBD', tier: 'normal' },
      { name: 'Original Art Puzzle Cards',  odds: 'TBD', tier: 'normal' },
      { name: 'Force Energy',               odds: 'TBD', tier: 'rare' },
      { name: 'Chrome Layers (Chiang)',     odds: 'TBD', tier: 'rare' },
      { name: 'Comicfractor',               odds: 'TBD', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR',          pr: '∞',    gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'MINI DIAMOND',       pr: '∞',    gradient: 'repeating-linear-gradient(45deg, #b8c8d8 0 4px, #d8e8f0 4px 8px)', darkText: true },
      { name: 'MAGENTA LAVA',       pr: '/250', gradient: 'linear-gradient(135deg, #ff3088 0%, #c01070 60%, #ff60a8 100%)' },
      { name: 'GREEN SHIMMER',      pr: '/199', gradient: 'linear-gradient(135deg, #00e87a 0%, #00a050 60%, #40ffa0 100%)', darkText: true },
      { name: 'GREEN KALEIDOSCOPE', pr: '/199', gradient: 'conic-gradient(from 45deg, #40ff90, #00a050, #80ffc0, #008040, #40ff90)', darkText: true },
      { name: 'BLUE RAY WAVE',      pr: '/175', gradient: 'linear-gradient(135deg, #00aaff 0%, #0060c0 60%, #40ddff 100%)' },
      { name: 'ATOMIC',             pr: '/150', gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'PURPLE SPECKLE',     pr: '/125', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 100%)' },
      { name: 'WAVE',               pr: '/99',  gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'SW LOGOFRACTOR',     pr: '/77',  gradient: 'linear-gradient(135deg, #f0f0f0 0%, #c0c0c0 50%, #909090 100%)', darkText: true },
      { name: 'PRISM',              pr: '/75',  gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO',               pr: '/50',  gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'ORANGE',             pr: '/25',  gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'X-FRACTOR',          pr: '/10',  gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'SW RED LOGO',        pr: '/5',   gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'RED',                pr: '/5',   gradient: 'linear-gradient(135deg, #ff4040 0%, #c00000 100%)' },
      { name: 'SUPERFRACTOR',       pr: '1/1',  gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [
      { name: 'Christian Benavides', work: 'Duel on Cloud City' },
      { name: 'Traci Easterday',     work: 'Art of Rogue One' },
      { name: 'Taurin Clarke',       work: 'Art of the Dark Side' },
      { name: 'Danny Schlitz',       work: 'Galactic Anthology' },
      { name: 'Gal Or',              work: 'Art of Knights of the Republic' },
      { name: 'Doug Chiang',         work: 'Chrome Layers Original Art' },
    ],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'New art + classic Galaxy artwork',
          parallels: 17,
          cards: [
            { num: '1', title: 'The Mandalorian\'s Escape', meta: 'Claudio Aboy' },
            { num: '2', title: 'Padmé Amidala vs. the Nexu', meta: 'Kristen Plescow' },
            { num: '3', title: 'Anakin Skywalker\'s Sunset', meta: 'Uzuri Art' },
            { num: '4', title: 'General Grievous', meta: 'Annie Wu' },
            { num: '5', title: 'Battle of Endor', meta: 'BalanceSheet' },
            { num: '6', title: 'Carbonite', meta: 'Daniel Govar' },
            { num: '7', title: 'On Hoth', meta: 'Zoltan Boros/Gabor Szikszai' },
            { num: '8', title: 'C-3PO & Babu Frik', meta: 'Robert Jiménez' },
            { num: '9', title: 'Cassian Andor & K-2SO', meta: 'Uzuri Art' },
            { num: '10', title: 'Chewbacca On Hoth', meta: 'Daniel Horne' },
            { num: '11', title: 'The Knights Of Ren', meta: 'Anthony Feliciano' },
            { num: '12', title: 'The Dark Lord', meta: 'Jerry Vanderstelt' },
            { num: '13', title: 'The Emperor', meta: 'David Rabbitte' },
            { num: '14', title: 'The Chosen One', meta: 'Ignacio RC' },
            { num: '15', title: 'Tarkin', meta: 'Jerry Vanderstelt' },
            { num: '16', title: 'Only Hope', meta: 'Angelina Benedetti' },
            { num: '17', title: 'The Queen of Naboo', meta: 'Daniel Govar' },
            { num: '18', title: 'It\'s A Trap!', meta: 'JB Casacop' },
            { num: '19', title: 'Educating Luke', meta: 'Jerry Vanderstelt' },
            { num: '20', title: 'Jango Fett\'s Legacy', meta: 'Darrin Pepe' },
            { num: '21', title: 'Jawas\' Score', meta: 'Jason Thomas' },
            { num: '22', title: 'Maz Kanata', meta: 'BalanceSheet' },
            { num: '23', title: 'The Trinity of Evil', meta: 'Daniel Govar' },
            { num: '24', title: 'Cloud City Escape', meta: 'David Rabbitte' },
            { num: '25', title: 'Logray', meta: 'Daniel Govar' },
            { num: '26', title: '"Look Sir, Droids!"', meta: 'Doug Hills' },
            { num: '27', title: 'Peace Is A Lie', meta: 'Jenna McMullins' },
            { num: '28', title: 'FOR MANDALORE', meta: 'Jodie Rae Charity' },
            { num: '29', title: 'Poe Dameron & BB-8', meta: 'Kristen Plescow' },
            { num: '30', title: 'Qui-Gon Jinn', meta: 'Robert Jiménez' },
            { num: '31', title: 'Released From Carbonite', meta: 'Daz Tibbles' },
            { num: '32', title: 'The Rematch', meta: 'David Rabbitte' },
            { num: '33', title: 'Sol', meta: 'Candice Dailey' },
            { num: '34', title: 'Shin Hati', meta: 'Uzuri Art' },
            { num: '35', title: 'The Twins', meta: 'Kristen Plescow' },
            { num: '36', title: 'Three Bounty Hunters', meta: 'Jarreau Wimberly' },
            { num: '37', title: 'The Stranger', meta: 'Daniel Govar' },
            { num: '38', title: 'Darth Vader', meta: 'Camuncoli/Bonetti' },
            { num: '39', title: 'Luke Skywalker', meta: 'Camuncoli/Bonetti' },
            { num: '40', title: 'The Falcon Escapes', meta: 'Chris Sprouse' },
            { num: '41', title: 'Crait Showdown', meta: 'Rich Davies' },
            { num: '42', title: 'Pull To The Light', meta: 'Candice Dailey' },
            { num: '43', title: 'Ahsoka Tano\'s Path', meta: 'Seth Groves' },
            { num: '44', title: 'Trust the Force', meta: 'Claudio Aboy' },
            { num: '45', title: 'Darth Vader at Hoth', meta: 'Victor Garduno' },
            { num: '46', title: 'We Meet Again, At Last', meta: 'Jaime Carrillo' },
            { num: '47', title: 'Can You Speak Bocce?', meta: 'Alberto "Akirant" Quirantes' },
            { num: '48', title: 'Grand Master Yoda', meta: 'Tommy Lee Edwards' },
            { num: '49', title: 'Grogu', meta: 'Archives' },
            { num: '50', title: 'Save The Dream', meta: 'Colin Murdoch' },
            { num: '51', title: 'YAHOOO', meta: 'Rob Surette' },
            { num: '52', title: 'You Need A Teacher', meta: 'Candice Dailey' },
            { num: '53', title: 'Power of the Dark Side', meta: 'Rob Surette' },
            { num: '54', title: 'The Seeker', meta: 'Chris Dee' },
            { num: '55', title: 'What Lies Beneath!', meta: 'Peter Ferk' },
            { num: '56', title: 'You\'re Not Actually Going Into an Asteroid Field?', meta: 'Rob Surette' },
            { num: '57', title: 'Raider Ambush', meta: 'Jeremy Saliba' },
            { num: '58', title: 'Rebel Pilot', meta: 'Dave Dorman' },
            { num: '59', title: 'There Aren\'t Many Jedi Left', meta: 'Mark Englert' },
            { num: '60', title: 'The Savior', meta: 'Andy Fairhurst' },
            { num: '61', title: 'Last Look Back', meta: 'Raymond Swanland' },
            { num: '62', title: 'Vel Sartha', meta: 'Candice Dailey' },
            { num: '63', title: 'Bounty Hunters', meta: 'Chris Sprouse' },
            { num: '64', title: 'Machines of Dominion', meta: 'Raymond Swanland' },
            { num: '65', title: 'I Have You Now', meta: 'Rob Surette' },
            { num: '66', title: 'Through the Asteroid Field', meta: 'Archives' },
            { num: '67', title: 'Scarif Attack', meta: 'Alberto "Akirant" Quirantes' },
            { num: '68', title: 'Into the Storm', meta: 'PhaseRunner' },
            { num: '69', title: 'A Chilly Reception', meta: 'Terese Nielsen' },
            { num: '70', title: 'The Failed Execution', meta: 'Archives' },
            { num: '71', title: 'Unyielding', meta: 'Brent Woodside' },
            { num: '72', title: 'The Gift', meta: 'Al Abbazia' },
            { num: '73', title: 'Carbonite Captor', meta: 'Jenna McMullins' },
            { num: '74', title: 'Fighting Back', meta: 'Chris Trevas' },
            { num: '75', title: 'The Clones Advance', meta: 'Brent Woodside' },
            { num: '76', title: 'Solo Standoff', meta: 'Mark Chilcott' },
            { num: '77', title: 'Master And Apprentice', meta: 'Phil Noto' },
            { num: '78', title: 'Celebration On Endor', meta: 'Chris Sprouse' },
            { num: '79', title: 'Padmé Amidala In The Senate', meta: 'Candice Dailey' },
            { num: '80', title: 'Life On Hoth', meta: 'Archives' },
            { num: '81', title: 'Boba Fett', meta: 'Greg Lipton' },
            { num: '82', title: 'The Generals', meta: 'Dave Dorman' },
            { num: '83', title: 'Zorii Bliss', meta: 'Derek Laufman' },
            { num: '84', title: 'Rebel Base', meta: 'Ralph McQuarrie' },
            { num: '85', title: 'Death Star Duel', meta: 'Archives' },
            { num: '86', title: 'Battle In the Arena', meta: 'Chris Trevas' },
            { num: '87', title: 'Vulture Droids', meta: 'Archives' },
            { num: '88', title: 'Naboo Space Battle', meta: 'Archives' },
            { num: '89', title: 'Obi-Wan Kenobi On The Run', meta: 'Roberto Campos' },
            { num: '90', title: 'Lando Calrissian', meta: 'Archives' },
            { num: '91', title: 'Aurra Sing', meta: 'Chris Trevas' },
            { num: '92', title: 'Count Dooku', meta: 'Tony Hsu' },
            { num: '93', title: 'Life in Exile', meta: 'Jerry Vanderstelt' },
            { num: '94', title: 'Ahsoka Tano and Sabine Wren', meta: 'Giuseppe Camuncoli' },
            { num: '95', title: 'Smugglers', meta: 'Zoltan Boros/Gabor Szikszai' },
            { num: '96', title: 'The Royal Guard', meta: 'Tommy Lee Edwards' },
            { num: '97', title: 'A New Day for Luke Skywalker', meta: 'Dave Dorman' },
            { num: '98', title: 'Imminent Danger', meta: 'Liné Tutwiler' },
            { num: '99', title: 'No Squeezie!', meta: 'Jodie Rae Charity' },
            { num: '100', title: 'Grogu Reaches Out', meta: 'Brent Woodside' },
          ]
        }
      ],
      insert: [
        {
          count: 15,
          name: 'DUEL ON CLOUD CITY',
          meta: 'Christian Benavides',
          parallels: 10,
          cards: [
            { num: 'CLOUD-1', title: 'Confronting Darth Vader' },
            { num: 'CLOUD-2', title: '"You Are Not A Jedi, Yet"' },
            { num: 'CLOUD-3', title: 'Luke Skywalker Is Pushed Back' },
            { num: 'CLOUD-4', title: '"All Too Easy"' },
            { num: 'CLOUD-5', title: 'Reclaiming The Lightsaber' },
            { num: 'CLOUD-6', title: '"Release Your Anger"' },
            { num: 'CLOUD-7', title: 'Darth Vader\'s Fall' },
            { num: 'CLOUD-8', title: 'Following Darth Vader' },
            { num: 'CLOUD-9', title: 'The Duel Resumes' },
            { num: 'CLOUD-10', title: 'Luke Skywalker Flies Through The Window' },
            { num: 'CLOUD-11', title: '"You Are Beaten"' },
            { num: 'CLOUD-12', title: 'Luke Skywalker Strikes Back' },
            { num: 'CLOUD-13', title: 'Darth Vader Cuts Off Luke Skywalker\'s Arm' },
            { num: 'CLOUD-14', title: 'The Power Of The Dark Side' },
            { num: 'CLOUD-15', title: '"I Am Your Father"' },
          ]
        },
        {
          count: 15,
          name: 'ART OF ROGUE ONE',
          meta: 'Traci Easterday',
          parallels: 10,
          cards: [
            { num: 'ARO-1', title: 'Jyn Erso' },
            { num: 'ARO-2', title: 'Cassian Andor' },
            { num: 'ARO-3', title: 'K-2SO' },
            { num: 'ARO-4', title: 'Director Krennic' },
            { num: 'ARO-5', title: 'Saw Gerrera' },
            { num: 'ARO-6', title: 'Admiral Raddus' },
            { num: 'ARO-7', title: 'Galen Erso' },
            { num: 'ARO-8', title: 'Baze Malbus' },
            { num: 'ARO-9', title: 'Chirrut Îmwe' },
            { num: 'ARO-10', title: 'Bodhi Rook' },
            { num: 'ARO-11', title: 'Mon Mothma' },
            { num: 'ARO-12', title: 'Bail Organa' },
            { num: 'ARO-13', title: 'Darth Vader' },
            { num: 'ARO-14', title: 'Grand Moff Tarkin' },
            { num: 'ARO-15', title: 'Leia Organa' },
          ]
        },
        {
          count: 15,
          name: 'ART OF THE DARK SIDE',
          meta: 'Taurin Clarke',
          parallels: 10,
          cards: [
            { num: 'ADS-1', title: 'Anakin Skywalker' },
            { num: 'ADS-2', title: 'Moff Gideon' },
            { num: 'ADS-3', title: 'Maul' },
            { num: 'ADS-4', title: 'Darth Vader' },
            { num: 'ADS-5', title: 'Darth Sidious' },
            { num: 'ADS-6', title: 'The Stranger' },
            { num: 'ADS-7', title: 'Captain Phasma' },
            { num: 'ADS-8', title: 'Savage Opress' },
            { num: 'ADS-9', title: 'Fifth Brother' },
            { num: 'ADS-10', title: 'Kylo Ren' },
            { num: 'ADS-11', title: 'Mother Talzin' },
            { num: 'ADS-12', title: 'Grand Admiral Thrawn' },
            { num: 'ADS-13', title: 'Morgan Elsbeth' },
            { num: 'ADS-14', title: 'Cad Bane' },
            { num: 'ADS-15', title: 'Count Dooku' },
          ]
        },
        {
          count: 15,
          name: 'GALACTIC ANTHOLOGY',
          meta: 'Danny Schlitz',
          parallels: 10,
          cards: [
            { num: 'GA-1', title: 'Chewbacca and BB-8' },
            { num: 'GA-2', title: 'Qui-Gon Jinn' },
            { num: 'GA-3', title: 'Kanan Jarrus' },
            { num: 'GA-4', title: 'Jabba the Hutt' },
            { num: 'GA-5', title: 'Shin Hati' },
            { num: 'GA-6', title: 'Obi-Wan Kenobi' },
            { num: 'GA-7', title: 'Jar Jar Binks' },
            { num: 'GA-8', title: 'Dedra Meero' },
            { num: 'GA-9', title: 'Jango Fett' },
            { num: 'GA-10', title: 'Jod Na Nawood' },
            { num: 'GA-11', title: 'Lando Calrissian' },
            { num: 'GA-12', title: 'Luthen Rael' },
            { num: 'GA-13', title: 'General Grievous' },
            { num: 'GA-14', title: 'Wicket W. Warrick' },
            { num: 'GA-15', title: 'Asajj Ventress' },
          ]
        },
        {
          count: 15,
          name: 'ART OF KNIGHTS OF THE REPUBLIC',
          meta: 'Gal Or',
          parallels: 10,
          cards: [
            { num: 'KOTOR-1', title: 'Bastila Shan' },
            { num: 'KOTOR-2', title: 'Canderous Ordo' },
            { num: 'KOTOR-3', title: 'Carth Onasi' },
            { num: 'KOTOR-4', title: 'HK-47' },
            { num: 'KOTOR-5', title: 'Jolee Bindo' },
            { num: 'KOTOR-6', title: 'Juhani' },
            { num: 'KOTOR-7', title: 'T3-M4' },
            { num: 'KOTOR-8', title: 'Mission Vao' },
            { num: 'KOTOR-9', title: 'Sith Soldier' },
            { num: 'KOTOR-10', title: 'Visas Marr' },
            { num: 'KOTOR-11', title: 'Darth Malak' },
            { num: 'KOTOR-12', title: 'HK-47 & T3-M4' },
            { num: 'KOTOR-13', title: 'Darth Sion' },
            { num: 'KOTOR-14', title: 'Atton Rand' },
            { num: 'KOTOR-15', title: 'Darth Revan' },
          ]
        },
        {
          count: 11,
          name: 'CHROME LAYERS — DOUG CHIANG',
          meta: 'Original concept art',
          parallels: 4,
          cards: [
            { num: 'LAY-1', title: 'Opee Sea Killer Hunts the Gungan Submarine' },
            { num: 'LAY-2', title: 'The Krayt Dragon Targets A Bantha' },
            { num: 'LAY-3', title: 'Count Dooku\'s Hangar' },
            { num: 'LAY-4', title: 'The Podracer Advances' },
            { num: 'LAY-5', title: 'Ravinak' },
            { num: 'LAY-6', title: 'Battle Droids' },
            { num: 'LAY-7', title: 'Gungan Sacred Place' },
            { num: 'LAY-8', title: 'Republic Gunships' },
            { num: 'LAY-9', title: 'Naboo' },
            { num: 'LAY-10', title: 'Battle Droids Vs Gungans' },
            { num: 'LAY-11', title: 'The Mudhorn' },
          ]
        },
        {
          count: 5,
          name: 'COMICFRACTOR',
          meta: 'John Tyler Christopher',
          parallels: 4,
          cards: [
            { num: 'VC-16', title: 'Ben (Obi-Wan) Kenobi' },
            { num: 'VC-17', title: 'Ahsoka Tano' },
            { num: 'VC-18', title: 'Luke Skywalker' },
            { num: 'VC-19', title: 'Han Solo: Imperial Stormtrooper Outfit' },
            { num: 'VC-20', title: 'Imperial TIE Fighter Pilot' },
          ]
        },
        {
          count: 36,
          name: 'ORIGINAL ART PUZZLE CARDS',
          meta: 'Four 9-card puzzles',
          parallels: 4,
          cards: [
            { num: 'HCW-1', title: 'Anakin Skywalker', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-2', title: 'Mace Windu', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-3', title: 'Kit Fisto', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-4', title: 'Padmé Amidala', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-5', title: 'Obi-Wan Kenobi', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-6', title: 'Shaak Ti', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-7', title: 'Clone Troopers', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-8', title: 'Yoda', meta: 'Aurelio Lorenzo' },
            { num: 'HCW-9', title: 'Clone Commander Cody', meta: 'Aurelio Lorenzo' },
            { num: 'JC-1', title: 'Yaddle', meta: 'Erik Maell' },
            { num: 'JC-2', title: 'Saesee Tiin', meta: 'Erik Maell' },
            { num: 'JC-3', title: 'Even Piell', meta: 'Erik Maell' },
            { num: 'JC-4', title: 'Mace Windu', meta: 'Erik Maell' },
            { num: 'JC-5', title: 'Yoda', meta: 'Erik Maell' },
            { num: 'JC-6', title: 'Plo Koon', meta: 'Erik Maell' },
            { num: 'JC-7', title: 'Eeth Koth', meta: 'Erik Maell' },
            { num: 'JC-8', title: 'Ki-Adi-Mundi', meta: 'Erik Maell' },
            { num: 'JC-9', title: 'Adi Gallia', meta: 'Erik Maell' },
            { num: 'MIMA-1', title: 'The Armorer', meta: 'Joe Corroney' },
            { num: 'MIMA-2', title: 'The Mandalorian', meta: 'Joe Corroney' },
            { num: 'MIMA-3', title: 'Sabine Wren', meta: 'Joe Corroney' },
            { num: 'MIMA-4', title: 'Paz Vizsla', meta: 'Joe Corroney' },
            { num: 'MIMA-5', title: 'Grogu', meta: 'Joe Corroney' },
            { num: 'MIMA-6', title: 'Ragnar Vizsla', meta: 'Joe Corroney' },
            { num: 'MIMA-7', title: 'Axe Woves', meta: 'Joe Corroney' },
            { num: 'MIMA-8', title: 'Bo-Katan Kryze', meta: 'Joe Corroney' },
            { num: 'MIMA-9', title: 'Koska Reeves', meta: 'Joe Corroney' },
            { num: 'POWW-1', title: 'Bix Caleen', meta: 'Uzuri' },
            { num: 'POWW-2', title: 'Padmé Amidala', meta: 'Uzuri' },
            { num: 'POWW-3', title: 'Hera Syndulla', meta: 'Uzuri' },
            { num: 'POWW-4', title: 'Rey', meta: 'Uzuri' },
            { num: 'POWW-5', title: 'Leia Organa', meta: 'Uzuri' },
            { num: 'POWW-6', title: 'Zorii Bliss', meta: 'Uzuri' },
            { num: 'POWW-7', title: 'Ahsoka Tano', meta: 'Uzuri' },
            { num: 'POWW-8', title: 'Vice Admiral Holdo', meta: 'Uzuri' },
            { num: 'POWW-9', title: 'Kleya Marki', meta: 'Uzuri' },
          ]
        },
        {
          count: 10,
          name: 'FORCE ENERGY',
          meta: 'Shane Grammer',
          parallels: 4,
          cards: [
            { num: 'FE-1', title: 'Obi-Wan Kenobi' },
            { num: 'FE-2', title: 'Darth Maul' },
            { num: 'FE-3', title: 'Yoda' },
            { num: 'FE-4', title: 'Darth Sidious' },
            { num: 'FE-5', title: 'Luke Skywalker' },
            { num: 'FE-6', title: 'Darth Vader' },
            { num: 'FE-7', title: 'Rey' },
            { num: 'FE-8', title: 'Kylo Ren' },
            { num: 'FE-9', title: 'Mace Windu' },
            { num: 'FE-10', title: 'Ahsoka Tano' },
          ]
        }
      ],
      auto: [
        {
          count: 61,
          name: 'GALAXY AUTOGRAPHS',
          meta: 'Single-signer base auto tier',
          parallels: 7,
          cards: [
            { num: 'GA-33', title: 'Nick Frost', meta: 'SM-33' },
            { num: 'GA-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'GA-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'GA-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'GA-BOY', title: 'John Boyega', meta: 'Finn' },
            { num: 'GA-BRI', title: 'Alison Brie', meta: 'Am' },
            { num: 'GA-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'GA-C3', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'GA-CHEW', title: 'Joonas Suotamo', meta: 'Chewbacca' },
            { num: 'GA-CM', title: 'Carrie-Anne Moss', meta: 'Jedi Master Indara' },
            { num: 'GA-DG', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'GA-DK', title: 'Dafne Keen', meta: 'Jecki Lon' },
            { num: 'GA-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'GA-DO', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'GA-DOC', title: 'Christopher Lloyd', meta: 'Commissioner Helgait' },
            { num: 'GA-DON', title: 'Donald Faison', meta: 'Hype Fazon' },
            { num: 'GA-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'GA-DT', title: 'David Tennant', meta: 'Huyang' },
            { num: 'GA-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'GA-ECK', title: 'Ashley Eckstein', meta: 'Ahsoka Tano' },
            { num: 'GA-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'GA-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'GA-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'GA-FP', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'GA-GT', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'GA-HC', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'GA-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'GA-IM', title: 'Ian McDiarmid', meta: 'Darth Sidious' },
            { num: 'GA-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'GA-JI', title: 'Jason Isaacs', meta: 'The Grand Inquisitor' },
            { num: 'GA-JL', title: 'Jake Lloyd', meta: 'Anakin Skywalker' },
            { num: 'GA-K', title: 'Alan Tudyk', meta: 'K-2SO' },
            { num: 'GA-KAT', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'GA-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'GA-KM', title: 'Kelly Macdonald', meta: 'Pokkit' },
            { num: 'GA-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'GA-L', title: 'Lizzo', meta: 'The Duchess' },
            { num: 'GA-LAW', title: 'Jude Law', meta: 'Jod Na Nawood' },
            { num: 'GA-LD', title: 'Laura Dern', meta: 'Vice Admiral Holdo' },
            { num: 'GA-LJ', title: 'Lee Jung-jae', meta: 'Jedi Master Sol' },
            { num: 'GA-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'GA-MAY', title: 'Peter Mayhew', meta: 'Chewbacca' },
            { num: 'GA-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'GA-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'GA-MJ', title: 'Manny Jacinto', meta: 'The Stranger' },
            { num: 'GA-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'GA-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'GA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'GA-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'GA-RDAW', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'GA-RH', title: 'Ron Howard', meta: 'Director' },
            { num: 'GA-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'GA-SER', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'GA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'GA-SP', title: 'Simon Pegg', meta: 'Unkar Plutt' },
            { num: 'GA-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'GA-SW', title: 'Sam Witwer', meta: 'Darth Maul' },
            { num: 'GA-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'GA-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'GA-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'GA-WEN', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
          ]
        },
        {
          count: 10,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer',
          parallels: 2,
          cards: [
            { num: 'D-BOUNTY', title: 'Dorian Kingi / Temuera Morrison', meta: 'Cad Bane / Boba Fett' },
            { num: 'D-CDAWN', title: 'Paul Bettany / Ray Park', meta: 'Dryden Vos / Maul' },
            { num: 'D-DARK', title: 'Nika Futterman / Sam Witwer', meta: 'Asajj Ventress / Darth Maul' },
            { num: 'D-FO', title: 'Domhnall Gleeson / Richard E. Grant', meta: 'General Hux / General Pryde' },
            { num: 'D-NABOO', title: 'Keira Knightley / Ewan McGregor', meta: 'Sabé / Obi-Wan Kenobi' },
            { num: 'D-PIRATE', title: 'Jude Law / Jaleel White', meta: 'Jod Na Nawood / Gunter' },
            { num: 'D-REBEL', title: 'Genevieve O\'Reilly / Elizabeth Dulau', meta: 'Mon Mothma / Kleya Marki' },
            { num: 'D-ROTJ', title: 'David Barclay / Billy Dee Williams', meta: 'Jabba the Hutt / Lando Calrissian' },
            { num: 'D-RULE2', title: 'Ian McDiarmid / Hayden Christensen', meta: 'Darth Sidious / Darth Vader' },
            { num: 'D-TATOO', title: 'Pedro Pascal / Ming-Na Wen', meta: 'The Mandalorian / Fennec Shand' },
          ]
        },
        {
          count: 9,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer · 1/1 Superfractor only',
          parallels: 1,
          cards: [
            { num: 'T-AHS', title: 'David Tennant / Rosario Dawson / Natasha Liu Bordizzo', meta: 'Huyang / Ahsoka Tano / Sabine Wren' },
            { num: 'T-ANDOR', title: 'Denise Gough / Stellan Skarsgård / Diego Luna', meta: 'Dedra Meero / Luthen Rael / Cassian Andor' },
            { num: 'T-EP6', title: 'Peter Mayhew / Anthony Daniels / Harrison Ford', meta: 'Chewbacca / C-3PO / Han Solo' },
            { num: 'T-EP7', title: 'Lupita Nyong\'o / Joonas Suotamo / Daisy Ridley', meta: 'Maz Kanata / Chewbacca / Rey' },
            { num: 'T-GEO', title: 'Ian McDiarmid / Temuera Morrison / Samuel L. Jackson', meta: 'Chancellor Palpatine / Jango Fett / Mace Windu' },
            { num: 'T-HPATH', title: 'Maya Erskine / Ewan McGregor / O\'Shea Jackson Jr.', meta: 'Sully Stark / Obi-Wan Kenobi / Kawlan Roken' },
            { num: 'T-R1', title: 'Riz Ahmed / Mads Mikkelsen / Felicity Jones', meta: 'Bodhi Rook / Galen Erso / Jyn Erso' },
            { num: 'T-RESIST', title: 'Billie Lourd / Oscar Isaac / Kelly Marie Tran', meta: 'Kaydel Connix / Poe Dameron / Rose Tico' },
            { num: 'T-SOLO', title: 'Joonas Suotamo / Alden Ehrenreich / Paul Bettany', meta: 'Chewbacca / Han Solo / Dryden Vos' },
          ]
        },
        {
          count: 5,
          name: 'QUAD BOOKLET AUTOGRAPHS',
          meta: 'Four-signer booklet',
          parallels: 2,
          cards: [
            { num: 'Q-ANDOR', title: 'Diego Luna / Genevieve O\'Reilly / Stellan Skarsgård / Benjamin Bratt', meta: 'Cassian Andor / Mon Mothma / Luthen Rael / Bail Organa' },
            { num: 'Q-BESPIN', title: 'Jeremy Bulloch / David Prowse / Harrison Ford / Billy Dee Williams', meta: 'Boba Fett / Darth Vader / Han Solo / Lando Calrissian' },
            { num: 'Q-EP8', title: 'John Boyega / Gwendolie Christie / Benicio del Toro / Kelly Marie Tran', meta: 'Finn / Captain Phasma / DJ / Rose Tico' },
            { num: 'Q-JAKKU', title: 'Dave Chapman / John Boyega / Daisy Ridley / Simon Pegg', meta: 'BB-8 / Finn / Rey / Unkar Plutt' },
            { num: 'Q-P15', title: 'Lizzo / Christopher Lloyd / Pedro Pascal / Katee Sackhoff', meta: 'The Duchess / Commissioner Helgait / The Mandalorian / Bo-Katan Kryze' },
          ]
        }
      ],
      sketch: [
        {
          count: 218,
          name: 'SKETCH CARD ARTISTS',
          meta: 'One-of-one hand-drawn sketches',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Aaron Laurich' },
            { num: 'SK-2', title: 'Adam Beck' },
            { num: 'SK-3', title: 'Adam D. Perler' },
            { num: 'SK-4', title: 'Aldrich Serrano' },
            { num: 'SK-5', title: 'Aleksandr Gigov' },
            { num: 'SK-6', title: 'Alex Mines' },
            { num: 'SK-7', title: 'Alexander Diab' },
            { num: 'SK-8', title: 'Alexander McCormick' },
            { num: 'SK-9', title: 'Allen Geneta' },
            { num: 'SK-10', title: 'Allen Grimes' },
            { num: 'SK-11', title: 'Andrew Fernandes' },
            { num: 'SK-12', title: 'Andrew Fry' },
            { num: 'SK-13', title: 'ANDY TIU' },
            { num: 'SK-14', title: 'Angel Aviles' },
            { num: 'SK-15', title: 'Angelina Benedetti' },
            { num: 'SK-16', title: 'Anthony Pietszak' },
            { num: 'SK-17', title: 'Anthony Richichi' },
            { num: 'SK-18', title: 'Arlene' },
            { num: 'SK-19', title: 'ArtJay' },
            { num: 'SK-20', title: 'Ash' },
            { num: 'SK-21', title: 'Ashley Marsh' },
            { num: 'SK-22', title: 'AsylumArtz' },
            { num: 'SK-23', title: 'Barry Renshaw' },
            { num: 'SK-24', title: 'Basak Kahraman' },
            { num: 'SK-25', title: 'Bean' },
            { num: 'SK-26', title: 'Ben AbuSaada' },
            { num: 'SK-27', title: 'Bernardo Oliveira' },
            { num: 'SK-28', title: 'Bistek Javier' },
            { num: 'SK-29', title: 'Bobby Blakey' },
            { num: 'SK-30', title: 'Bradley Hudson' },
            { num: 'SK-31', title: 'Brandon Klein' },
            { num: 'SK-32', title: 'Bruce Gerlach' },
            { num: 'SK-33', title: 'Bryan Waytula' },
            { num: 'SK-34', title: 'C.Deakes' },
            { num: 'SK-35', title: 'Candice Dailey' },
            { num: 'SK-36', title: 'Carlo Allen Victoria' },
            { num: 'SK-37', title: 'Charlie Cody' },
            { num: 'SK-38', title: 'Chenduz' },
            { num: 'SK-39', title: 'Chris Colyer' },
            { num: 'SK-40', title: 'Chris Meeks' },
            { num: 'SK-41', title: 'Chris Quinn' },
            { num: 'SK-42', title: 'Chris Timola' },
            { num: 'SK-43', title: 'Christoffer Allen Victoria' },
            { num: 'SK-44', title: 'Cisco Rivera' },
            { num: 'SK-45', title: 'Court' },
            { num: 'SK-46', title: 'Cyrus Sherkat' },
            { num: 'SK-47', title: 'Dan Bergren' },
            { num: 'SK-48', title: 'Dan Cooney' },
            { num: 'SK-49', title: 'Dan Curto' },
            { num: 'SK-50', title: 'Dan Gorman' },
            { num: 'SK-51', title: 'Dan Lawler' },
            { num: 'SK-52', title: 'Dan Tearle' },
            { num: 'SK-53', title: 'Daniel Riveron' },
            { num: 'SK-54', title: 'Darrin Pepe' },
            { num: 'SK-55', title: 'Dave Wilson' },
            { num: 'SK-56', title: 'David Willingham' },
            { num: 'SK-57', title: 'Dawn Murphy' },
            { num: 'SK-58', title: 'Débora Centeio' },
            { num: 'SK-59', title: 'Don Nguyen' },
            { num: 'SK-60', title: 'Douglas Stromenger' },
            { num: 'SK-61', title: 'Dove McHargue' },
            { num: 'SK-62', title: 'Dwayne Carpenter' },
            { num: 'SK-63', title: 'DYJ' },
            { num: 'SK-64', title: 'Dylan Riley' },
            { num: 'SK-65', title: 'El Smetchö' },
            { num: 'SK-66', title: 'Elvin A Hernandez' },
            { num: 'SK-67', title: 'Eric Lehtonen' },
            { num: 'SK-68', title: 'Eric Medina' },
            { num: 'SK-69', title: 'Erik Maell' },
            { num: 'SK-70', title: 'Erik Muller' },
            { num: 'SK-71', title: 'Frank A. Kadar' },
            { num: 'SK-72', title: 'Frank Sansone' },
            { num: 'SK-73', title: 'Franklim Teixeira' },
            { num: 'SK-74', title: 'Gabe Farber' },
            { num: 'SK-75', title: 'Gary Rudisill' },
            { num: 'SK-76', title: 'Gary Shipman' },
            { num: 'SK-77', title: 'Gawanimayk' },
            { num: 'SK-78', title: 'Getatom' },
            { num: 'SK-79', title: 'Grace Riley' },
            { num: 'SK-80', title: 'Greg Treize' },
            { num: 'SK-81', title: 'Guilherme Rocha' },
            { num: 'SK-82', title: 'Henrique Pirote' },
            { num: 'SK-83', title: 'Ian McKesson' },
            { num: 'SK-84', title: 'Isiah Xavier Bradley' },
            { num: 'SK-85', title: 'Jaime Lopez' },
            { num: 'SK-86', title: 'James Boyd' },
            { num: 'SK-87', title: 'James Harris' },
            { num: 'SK-88', title: 'Jamie Richards' },
            { num: 'SK-89', title: 'Jamison Murdock' },
            { num: 'SK-90', title: 'Jane Rushton' },
            { num: 'SK-91', title: 'Jason Christner' },
            { num: 'SK-92', title: 'Jason Davies' },
            { num: 'SK-93', title: 'Jason Queen' },
            { num: 'SK-94', title: 'Jason Queen' },
            { num: 'SK-95', title: 'Jason Saldajeno' },
            { num: 'SK-96', title: 'Jason Sobol' },
            { num: 'SK-97', title: 'Jason Torres' },
            { num: 'SK-98', title: 'Jay Manchand' },
            { num: 'SK-99', title: 'Jeffrey' },
            { num: 'SK-100', title: 'Jeffrey C. Benitez' },
            { num: 'SK-101', title: 'Jenna McGrath' },
            { num: 'SK-102', title: 'Jenny Kim' },
            { num: 'SK-103', title: 'Jessica Hickman' },
            { num: 'SK-104', title: 'Jessica Van Dusen' },
            { num: 'SK-105', title: 'Jesus' },
            { num: 'SK-106', title: 'Jiaxin "YinShan" Sun' },
            { num: 'SK-107', title: 'Jim Dickson' },
            { num: 'SK-108', title: 'Jim O\'Riley' },
            { num: 'SK-109', title: 'Jodie Rae Charity' },
            { num: 'SK-110', title: 'John Boren' },
            { num: 'SK-111', title: 'John Bruce' },
            { num: 'SK-112', title: 'John Luchin' },
            { num: 'SK-113', title: 'John Pleak' },
            { num: 'SK-114', title: 'John Still' },
            { num: 'SK-115', title: 'Jojo Hilario' },
            { num: 'SK-116', title: 'Jon Mangini' },
            { num: 'SK-117', title: 'Jonathan Beistline' },
            { num: 'SK-118', title: 'Josh Rosland' },
            { num: 'SK-119', title: 'Joshua Whitten' },
            { num: 'SK-120', title: 'Julia McKenzie' },
            { num: 'SK-121', title: 'Julie-Anne' },
            { num: 'SK-122', title: 'JUN DIAZ' },
            { num: 'SK-123', title: 'Jungle' },
            { num: 'SK-124', title: 'Kang Jing' },
            { num: 'SK-125', title: 'Karl Jones' },
            { num: 'SK-126', title: 'Kevin P. West' },
            { num: 'SK-127', title: 'Kevin Scott Jacobs' },
            { num: 'SK-128', title: 'Khloe Delnick' },
            { num: 'SK-129', title: 'Kris Penix' },
            { num: 'SK-130', title: 'Kyle Babbitt' },
            { num: 'SK-131', title: 'Kyle Sweeney' },
            { num: 'SK-132', title: 'Layton Scarbrough' },
            { num: 'SK-133', title: 'Lee Lightfoot' },
            { num: 'SK-134', title: 'Leon Braojos' },
            { num: 'SK-135', title: 'LH (Lisa Hall)' },
            { num: 'SK-136', title: 'Limuel Pinzon' },
            { num: 'SK-137', title: 'Loc Nguyen' },
            { num: 'SK-138', title: 'Luke Rushton LR' },
            { num: 'SK-139', title: 'Marcia Dye' },
            { num: 'SK-140', title: 'Marlo Agunos' },
            { num: 'SK-141', title: 'Marlo Martos' },
            { num: 'SK-142', title: 'Matt Steffens' },
            { num: 'SK-143', title: 'Matt Stewart' },
            { num: 'SK-144', title: 'Matthew Maldonado' },
            { num: 'SK-145', title: 'Matthew Skillern' },
            { num: 'SK-146', title: 'Mayumi Seto' },
            { num: 'SK-147', title: 'Michael Foster' },
            { num: 'SK-148', title: 'Michael Mastermaker' },
            { num: 'SK-149', title: 'Michael W. Foreman II' },
            { num: 'SK-150', title: 'Michelle Rayner' },
            { num: 'SK-151', title: 'Mike Dalzell' },
            { num: 'SK-152', title: 'Mike J Sealie' },
            { num: 'SK-153', title: 'Mike James' },
            { num: 'SK-154', title: 'Mike Stephens' },
            { num: 'SK-155', title: 'Mohammad Jilani' },
            { num: 'SK-156', title: 'Nadz' },
            { num: 'SK-157', title: 'Nathaniel Howard' },
            { num: 'SK-158', title: 'Neil A Brady' },
            { num: 'SK-159', title: 'Neil Camera' },
            { num: 'SK-160', title: 'Nick Gribbon' },
            { num: 'SK-161', title: 'Niño John Benitez' },
            { num: 'SK-162', title: 'Oscar Chavez' },
            { num: 'SK-163', title: 'Patricio Carrasco' },
            { num: 'SK-164', title: 'Patrick Giles' },
            { num: 'SK-165', title: 'Paul Williams' },
            { num: 'SK-166', title: 'Peejay Catacutan' },
            { num: 'SK-167', title: 'Phil Hassewer' },
            { num: 'SK-168', title: 'Phillip Trujillo' },
            { num: 'SK-169', title: 'Rebeca Louro' },
            { num: 'SK-170', title: 'Rees Chua-Finlay' },
            { num: 'SK-171', title: 'Rich Hennemann' },
            { num: 'SK-172', title: 'Rico Dela Rosa' },
            { num: 'SK-173', title: 'Rob Demers' },
            { num: 'SK-174', title: 'Robert Hendrickson' },
            { num: 'SK-175', title: 'Ross' },
            { num: 'SK-176', title: 'Roy Cover' },
            { num: 'SK-177', title: 'Rustico Limosinero' },
            { num: 'SK-178', title: 'Rusty!' },
            { num: 'SK-179', title: 'Rutvig Vaid' },
            { num: 'SK-180', title: 'Ryan Crosby' },
            { num: 'SK-181', title: 'Ryan Finley' },
            { num: 'SK-182', title: 'Ryan Olsen' },
            { num: 'SK-183', title: 'Ryan Thompson' },
            { num: 'SK-184', title: 'Sammy Gomez' },
            { num: 'SK-185', title: 'Sandy Meeks' },
            { num: 'SK-186', title: 'Scott Hattox' },
            { num: 'SK-187', title: 'Scott Houseman' },
            { num: 'SK-188', title: 'Scott Rorie' },
            { num: 'SK-189', title: 'Scribbling Joe' },
            { num: 'SK-190', title: 'Sean Earey' },
            { num: 'SK-191', title: 'Sean Mathews' },
            { num: 'SK-192', title: 'Semra Bulut' },
            { num: 'SK-193', title: 'Shaow Siong' },
            { num: 'SK-194', title: 'Sir Edmund Duke' },
            { num: 'SK-195', title: 'Snorpixel' },
            { num: 'SK-196', title: 'Stephane Leonardi' },
            { num: 'SK-197', title: 'Steve Alce' },
            { num: 'SK-198', title: 'Steven Smith' },
            { num: 'SK-199', title: 'T Agar' },
            { num: 'SK-200', title: 'Ted Dastick Jr' },
            { num: 'SK-201', title: 'Tim Shinn' },
            { num: 'SK-202', title: 'Todd Aaron Smith' },
            { num: 'SK-203', title: 'Tom Amici' },
            { num: 'SK-204', title: 'TOMA' },
            { num: 'SK-205', title: 'Tomoko Taniguchi' },
            { num: 'SK-206', title: 'Tony Riley' },
            { num: 'SK-207', title: 'Traci Easterday' },
            { num: 'SK-208', title: 'Tyler Newcomb' },
            { num: 'SK-209', title: 'Veronica Louro' },
            { num: 'SK-210', title: 'Veronica Smith' },
            { num: 'SK-211', title: 'Vini Pirani' },
            { num: 'SK-212', title: 'W Green' },
            { num: 'SK-213', title: 'Ward Silverman' },
            { num: 'SK-214', title: 'William ROGER' },
            { num: 'SK-215', title: 'yungmilllz' },
            { num: 'SK-216', title: 'Yves Van Berlo' },
            { num: 'SK-217', title: 'Zach Woolsey' },
            { num: 'SK-218', title: 'ジェイソン (Jason)' },
          ]
        }
      ],
    },
  },

  '2025-chrome-galaxy': {
    setId: '2025-chrome-galaxy',
    year: '2025',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '12 / 10 / 2025',
    lede: 'The artistic flagship of the 2025 Star Wars chrome calendar. A 100-card base set built around original commissioned art and reimagined classics, anchored by a 15-deep parallel rainbow, five autograph tiers, and Ralph McQuarrie concept art across both Layers and Buyback inserts.',
    stats: [
      { num: '100', label: 'Base Cards',     sub: 'Mixed art / archives',  color: 'gold' },
      { num: '10',  label: 'Insert Sets',    sub: '5 to 20 cards each',     color: 'cyan' },
      { num: '70',  label: 'Auto Cards',     sub: '5 signature tiers',      color: 'green' },
      { num: '15',  label: 'Base Parallels', sub: 'Refractor → 1/1',        color: 'purple' },
      { num: '18',  label: 'Sub-sets Total', sub: 'Tracked on CK',          color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4',  l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '4',  l: 'Numbered parallels / box' },
      { v: '3',  l: 'Mini-Diamond refractors / box' },
      { v: '1',  l: 'Autograph per case' },
    ],
    pullRates: [
      { name: 'Galactic Inspirations',     odds: '1 : 18',    tier: 'normal' },
      { name: 'Duel on Mustafar',          odds: '1 : 18',    tier: 'normal' },
      { name: 'Power of the Force',        odds: '1 : 18',    tier: 'normal' },
      { name: 'Fear the Darkside',         odds: '1 : 18',    tier: 'normal' },
      { name: 'Original Art Puzzle',       odds: '1 : 216',   tier: 'normal' },
      { name: 'Chrome Layers (McQuarrie)', odds: '1 : 432',   tier: 'rare' },
      { name: 'Comicfractor',              odds: '1 : 1,080', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR',       pr: '∞',     gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'MINI DIAMOND',    pr: '∞',     gradient: 'repeating-linear-gradient(45deg, #b8c8d8 0 4px, #d8e8f0 4px 8px)', darkText: true },
      { name: 'MAGENTA LAVA',    pr: '/250',  gradient: 'linear-gradient(135deg, #ff3088 0%, #c01070 60%, #ff60a8 100%)' },
      { name: 'GREEN SHIMMER',   pr: '/199',  gradient: 'linear-gradient(135deg, #00e87a 0%, #00a050 60%, #40ffa0 100%)', darkText: true },
      { name: 'BLUE RAY WAVE',   pr: '/175',  gradient: 'linear-gradient(135deg, #00aaff 0%, #0060c0 60%, #40ddff 100%)' },
      { name: 'ATOMIC',          pr: '/150',  gradient: 'radial-gradient(circle at 30% 30%, #ffaa00 0%, #ff4400 60%, #cc2200 100%)' },
      { name: 'PURPLE SPECKLE',  pr: '/125',  gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 100%)' },
      { name: 'WAVE',            pr: '/99',   gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'SW LOGOFRACTOR',  pr: '/77',   gradient: 'linear-gradient(135deg, #f0f0f0 0%, #c0c0c0 50%, #909090 100%)', darkText: true },
      { name: 'PRISM',           pr: '/75',   gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO',            pr: '/50',   gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'ORANGE',          pr: '/25',   gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'X-FRACTOR',       pr: '/10',   gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'SW RED LOGO',     pr: '/5',    gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR',    pr: '1/1',   gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [
      { name: 'Ralph McQuarrie',     work: 'Chrome Layers + Buybacks' },
      { name: 'Christian Benavides', work: 'Duel on Mustafar' },
      { name: 'Joel Chaim Holtzman', work: 'Power of the Force' },
      { name: 'Danny Schlitz',       work: 'Fear the Darkside' },
      { name: 'Joe Corroney',        work: 'Galactic Inspirations + Skeleton Crew Puzzle' },
      { name: 'Aurelio Lorenzo',     work: 'Ahsoka Puzzle' },
    ],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Original art + reimagined classics',
          parallels: 15,
          cards: [
            { num: '1', title: 'What Remains', meta: 'Candice Dailey' },
            { num: '2', title: 'Luke Skywalker', meta: 'Dave Seely' },
            { num: '3', title: 'The Duel', meta: 'Ignacio RC' },
            { num: '4', title: 'Narrow Escape', meta: 'Claudio Aboy' },
            { num: '5', title: 'The Empire', meta: 'Davide Fabbri' },
            { num: '6', title: 'Gimmie', meta: 'Tricia Buchanan-Benson' },
            { num: '7', title: 'It\'s Not a Matter Of Luck', meta: 'Brent Woodside' },
            { num: '8', title: 'New Visions', meta: 'Steven Chorney' },
            { num: '9', title: 'Obi-Wan Kenobi', meta: 'Steve Chorney' },
            { num: '10', title: 'Protocol Droid', meta: 'Archives' },
            { num: '11', title: 'Protecting Hope', meta: 'Claudio Aboy' },
            { num: '12', title: 'General Grievous', meta: 'Terese Nielsen' },
            { num: '13', title: 'Loyalty Means Everything', meta: 'Kayla Woodside' },
            { num: '14', title: 'Awakening of A Jedi', meta: 'Ignacio RC' },
            { num: '15', title: 'Qui-Gon Jinn', meta: 'Archives' },
            { num: '16', title: 'Goin-In', meta: 'Archives' },
            { num: '17', title: 'Wedge Antilles', meta: 'Dave Dorman' },
            { num: '18', title: 'Joyride', meta: 'Cliff Cramp' },
            { num: '19', title: 'Royalty', meta: 'Brent Woodside' },
            { num: '20', title: 'Wizard', meta: 'Jenna McMullins' },
            { num: '21', title: 'The Confrontation', meta: 'Karl Fitzgerald' },
            { num: '22', title: 'You Were My Brother', meta: 'Meghan Gabriels' },
            { num: '23', title: 'Bounty Hunters', meta: 'Dave Dorman' },
            { num: '24', title: 'Confrontation', meta: 'Jaime Carillo' },
            { num: '25', title: 'Obsession #1', meta: 'Brian Chung' },
            { num: '26', title: 'The Resistance', meta: 'Archives' },
            { num: '27', title: 'The First Order', meta: 'Archives' },
            { num: '28', title: 'The Ewoks Join the Fight', meta: 'Bonnie Bogart' },
            { num: '29', title: 'Tatooine Cruise', meta: 'Mark Chilcott' },
            { num: '30', title: 'Learning the Force', meta: 'Akirant' },
            { num: '31', title: 'Mace Windu', meta: 'Archives' },
            { num: '32', title: 'Dooku', meta: 'Archives' },
            { num: '33', title: 'The Grand Admiral', meta: 'Brandon Kenney' },
            { num: '34', title: 'The Wampa', meta: 'Hugh Fleming' },
            { num: '35', title: 'Admiral Piett', meta: 'Christopher Moeller' },
            { num: '36', title: 'Podracing', meta: 'Hugh Fleming' },
            { num: '37', title: 'Smuggler\'s Moon', meta: 'Dave Dorman' },
            { num: '38', title: 'The Wanderer', meta: 'Brandon Kenney' },
            { num: '39', title: 'The Mandalorian', meta: 'Yusuke Osawa' },
            { num: '40', title: 'Across the Stars', meta: 'Kayla Woodside' },
            { num: '41', title: 'Masterhood', meta: 'Joe Hogan' },
            { num: '42', title: 'I\'ve Got This', meta: 'Brian Rood' },
            { num: '43', title: 'Plo Koon', meta: 'Jerry Vanderstelt' },
            { num: '44', title: 'Kit Fisto', meta: 'Terese Nielsen' },
            { num: '45', title: 'The Rancor', meta: 'RJ Palmer' },
            { num: '46', title: 'Eta-2 Actis class interceptor', meta: 'Tommy Lee Edwards' },
            { num: '47', title: 'I Don\'t Think They\'re Going To Let Us In', meta: 'Dave Dorman' },
            { num: '48', title: 'Carbonite Chamber', meta: 'Kevin Wilson' },
            { num: '49', title: 'Wicket and R2-D2', meta: 'Hugh Fleming' },
            { num: '50', title: 'Our Most Desperate Hour', meta: 'Natalia Sanabria' },
            { num: '51', title: 'Luke Skywalker and Obi-Wan Kenobi', meta: 'John Alvin' },
            { num: '52', title: 'Power in Numbers', meta: 'Raymond Swanland' },
            { num: '53', title: 'Shattered', meta: 'Jenna McMullins' },
            { num: '54', title: 'Rule With Respect', meta: 'Adam Schickling' },
            { num: '55', title: 'Making a Jedi', meta: 'Ignacio RC' },
            { num: '56', title: 'Rescue Mission', meta: 'Guy Vasilovich' },
            { num: '57', title: 'Darth Vader and the Speeders', meta: 'Christopher Moeller' },
            { num: '58', title: 'Alone I Stand', meta: 'Christophe Vacher' },
            { num: '59', title: 'The Clones', meta: 'Chris Valentine' },
            { num: '60', title: 'I Will Teach You to Protect Yourself', meta: 'Jeremy Saliba' },
            { num: '61', title: 'Dark Entrance', meta: 'Jeremy Saliba' },
            { num: '62', title: 'I\'ve Got Your Back', meta: 'Tricia Buchanan-Benson' },
            { num: '63', title: 'The Kyber Crystal', meta: 'Chris Trevas' },
            { num: '64', title: 'Hoth Mission', meta: 'Mark Chilcott' },
            { num: '65', title: 'Friendly Ambush', meta: 'Guy Vasilovich' },
            { num: '66', title: 'Road to Jabba\'s Palace', meta: 'Guy Vasilovich' },
            { num: '67', title: 'Chirrut Îmwe', meta: 'Gabz' },
            { num: '68', title: 'Fall of the Jedi', meta: 'Dave Dorman' },
            { num: '69', title: 'Jyn Erso', meta: 'Gabz' },
            { num: '70', title: 'The Emperor\'s Wrath', meta: 'Tommy Lee Edwards' },
            { num: '71', title: 'Anakin and Ahsoka', meta: 'Terese Nielsen' },
            { num: '72', title: 'Hoth Battle', meta: 'Claudio Aboy' },
            { num: '73', title: 'Docking Bay', meta: 'Pablo Olivera' },
            { num: '74', title: 'Marshal of Mos Pelgo', meta: 'Mark Englert' },
            { num: '75', title: 'Usurper', meta: 'Candice Dailey' },
            { num: '76', title: 'Dagobah', meta: 'PhaseRunner' },
            { num: '77', title: 'Tatooine', meta: 'PhaseRunner' },
            { num: '78', title: 'Mustafar', meta: 'PhaseRunner' },
            { num: '79', title: 'N-1 Starfighters', meta: 'Archives' },
            { num: '80', title: 'Avenge my Master', meta: 'Claudio Aboy' },
            { num: '81', title: 'Skywalker\'s Starfighter', meta: 'Tommy Lee Edwards' },
            { num: '82', title: 'Separated at Birth', meta: 'Hugh Fleming' },
            { num: '83', title: 'Trench Run', meta: 'Rob Kaz' },
            { num: '84', title: 'The Life of Luke Skywalker', meta: 'Ryder Windham' },
            { num: '85', title: 'Until Our Last Breath', meta: 'Christophe Vacher' },
            { num: '86', title: 'The Gunslinger', meta: 'Brian Rood' },
            { num: '87', title: 'Surprise Clankers!', meta: 'Brent Woodside' },
            { num: '88', title: 'Anakin Skywalker', meta: 'Tommy Lee Edwards' },
            { num: '89', title: 'Captain of the 501st', meta: 'Terese Nielsen' },
            { num: '90', title: 'Uninvited Guests', meta: 'Jack Gregory' },
            { num: '91', title: 'One Last Lesson', meta: 'Brent Woodside' },
            { num: '92', title: 'Lord Vader', meta: 'Kevin Wilson' },
            { num: '93', title: 'Checkpoint', meta: 'Akirant' },
            { num: '94', title: 'Han and Chewie', meta: 'Chris Trevas' },
            { num: '95', title: 'Shadow of Evil', meta: 'Tsuneo Sanda' },
            { num: '96', title: 'Boarding Party', meta: 'Jack Gregory' },
            { num: '97', title: 'The Falcon on Crait', meta: 'Derek Payne' },
            { num: '98', title: 'At Last We Will Have Revenge', meta: 'Devin Schoeffler' },
            { num: '99', title: 'B-wing Starfighters', meta: 'Tommy Lee Edwards' },
            { num: '100', title: 'Throughout the Ages', meta: 'Kayla Woodside' },
          ]
        }
      ],
      insert: [
        {
          count: 15,
          name: 'GALACTIC INSPIRATIONS',
          meta: 'Joe Corroney',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'SWIN-1', title: 'X-Wing And The Death Star', meta: 'Joe Corroney' },
            { num: 'SWIN-2', title: 'Luke In The Wampa\'s Den', meta: 'Joe Corroney' },
            { num: 'SWIN-3', title: 'Luke Vs The Scout Trooper', meta: 'Joe Corroney' },
            { num: 'SWIN-4', title: 'Darth Vader Observes', meta: 'Joe Corroney' },
            { num: 'SWIN-5', title: 'Battle Droid Down', meta: 'Joe Corroney' },
            { num: 'SWIN-6', title: 'Jar Jar Binks', meta: 'Joe Corroney' },
            { num: 'SWIN-7', title: 'The Queen Of Naboo', meta: 'Joe Corroney' },
            { num: 'SWIN-8', title: 'Obi-Wan Strikes Down Darth Maul', meta: 'Joe Corroney' },
            { num: 'SWIN-9', title: 'The Medal Ceremony', meta: 'Joe Corroney' },
            { num: 'SWIN-10', title: 'Into The Nebula', meta: 'Joe Corroney' },
            { num: 'SWIN-11', title: 'Luke\'s Recovery', meta: 'Joe Corroney' },
            { num: 'SWIN-12', title: 'Training With Yoda', meta: 'Joe Corroney' },
            { num: 'SWIN-13', title: 'AT-AT', meta: 'Joe Corroney' },
            { num: 'SWIN-14', title: 'Attack On The Death Star', meta: 'Joe Corroney' },
            { num: 'SWIN-15', title: 'Worrt On Tatooine', meta: 'Joe Corroney' },
          ]
        },
        {
          count: 15,
          name: 'DUEL ON MUSTAFAR',
          meta: 'Christian Benavides',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'DOM-1', title: 'The Duel Begins' },
            { num: 'DOM-2', title: 'Mustafar Control Room' },
            { num: 'DOM-3', title: 'Anakin\'s Chokehold' },
            { num: 'DOM-4', title: 'A Near-Fatal Strike' },
            { num: 'DOM-5', title: 'Equals In The Force' },
            { num: 'DOM-6', title: 'Taking The Duel Outside' },
            { num: 'DOM-7', title: 'A Narrow Battleground' },
            { num: 'DOM-8', title: 'A Heated Confrontation' },
            { num: 'DOM-9', title: 'Mustafar Rain' },
            { num: 'DOM-10', title: 'A Swinging Joust' },
            { num: 'DOM-11', title: 'Anakin Skywalker Closes In' },
            { num: 'DOM-12', title: 'Battle On The Lava River' },
            { num: 'DOM-13', title: '"I Have The High Ground"' },
            { num: 'DOM-14', title: '"You Underestimate My Power"' },
            { num: 'DOM-15', title: 'A Fiery Conclusion' },
          ]
        },
        {
          count: 15,
          name: 'POWER OF THE FORCE',
          meta: 'Joel Chaim Holtzman',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'POW-1', title: 'Captain Phasma' },
            { num: 'POW-2', title: 'Finn' },
            { num: 'POW-3', title: 'Unkar Plutt' },
            { num: 'POW-4', title: 'BB-8' },
            { num: 'POW-5', title: 'C-3PO' },
            { num: 'POW-6', title: 'R2-D2' },
            { num: 'POW-7', title: 'Chewbacca' },
            { num: 'POW-8', title: 'Han Solo' },
            { num: 'POW-9', title: 'Poe Dameron' },
            { num: 'POW-10', title: 'Kylo Ren' },
            { num: 'POW-11', title: 'General Hux' },
            { num: 'POW-12', title: 'Leia Organa' },
            { num: 'POW-13', title: 'Stormtrooper' },
            { num: 'POW-14', title: 'Rey' },
            { num: 'POW-15', title: 'Luke Skywalker' },
          ]
        },
        {
          count: 15,
          name: 'FEAR THE DARKSIDE',
          meta: 'Danny Schlitz',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'FTD-1', title: 'Kylo Ren' },
            { num: 'FTD-2', title: 'Darth Vader' },
            { num: 'FTD-3', title: 'The Stranger' },
            { num: 'FTD-4', title: 'Baylan Skoll' },
            { num: 'FTD-5', title: 'Shin Hati' },
            { num: 'FTD-6', title: 'General Grievous' },
            { num: 'FTD-7', title: 'Supreme Leader Snoke' },
            { num: 'FTD-8', title: 'Darth Plagueis' },
            { num: 'FTD-9', title: 'Count Dooku' },
            { num: 'FTD-10', title: 'Darth Maul' },
            { num: 'FTD-11', title: 'Darth Bane' },
            { num: 'FTD-12', title: 'Asajj Ventress' },
            { num: 'FTD-13', title: 'Emperor Palpatine' },
            { num: 'FTD-14', title: 'The Seventh Sister' },
            { num: 'FTD-15', title: 'The Grand Inquisitor' },
          ]
        },
        {
          count: 15,
          name: 'CHROME LAYERS — MCQUARRIE',
          meta: 'Original concept art',
          odds: '1:432 packs',
          parallels: 4,
          cards: [
            { num: 'LAY-1', title: 'Desert Skiff' },
            { num: 'LAY-2', title: 'Hoth Base' },
            { num: 'LAY-3', title: 'Jabba\'s Palace' },
            { num: 'LAY-4', title: 'Darth Vader Duel' },
            { num: 'LAY-5', title: 'Trench Run' },
            { num: 'LAY-6', title: 'Crashed Snowspeeder' },
            { num: 'LAY-7', title: 'Darth Vader vs Luke Skywalker' },
            { num: 'LAY-8', title: 'Jabba\'s Droids' },
            { num: 'LAY-9', title: 'The Death Star' },
            { num: 'LAY-10', title: 'Cloud City' },
            { num: 'LAY-11', title: 'Lando Calrissian greets Han Solo' },
            { num: 'LAY-12', title: 'Snowspeeder vs AT-AT' },
            { num: 'LAY-13', title: 'Chasing the Falcon' },
            { num: 'LAY-14', title: 'AT-ATs Attack!' },
            { num: 'LAY-15', title: 'Mon Mothma\'s Intel' },
          ]
        },
        {
          count: 5,
          name: 'COMICFRACTOR',
          meta: 'Comic-style art',
          odds: '1:1,080 packs',
          parallels: 4,
          cards: [
            { num: 'VC-11', title: 'Qui-Gon Jinn' },
            { num: 'VC-12', title: 'Darth Maul' },
            { num: 'VC-13', title: 'Stormtrooper' },
            { num: 'VC-14', title: 'Leia Organa' },
            { num: 'VC-15', title: 'AT-AT Driver' },
          ]
        },
        {
          count: 5,
          name: 'ONE WITH THE FORCE',
          meta: 'All 1/1 Superfractors only',
          oneOfOne: true,
          cards: [
            { num: 'OF-11', title: 'Ki-Adi-Mundi' },
            { num: 'OF-12', title: 'Jedi Master Sol' },
            { num: 'OF-13', title: 'Jedi Master Indara' },
            { num: 'OF-14', title: 'Supreme Leader Snoke' },
            { num: 'OF-15', title: 'Emperor Palpatine' },
          ]
        },
        {
          count: 9,
          name: 'PUZZLE — AHSOKA',
          meta: 'Aurelio Lorenzo',
          odds: '1:216 packs',
          parallels: 4,
          cards: [
            { num: 'AP-1', title: 'Ahsoka Tano' },
            { num: 'AP-2', title: 'Sabine Wren' },
            { num: 'AP-3', title: 'Ezra Bridger' },
            { num: 'AP-4', title: 'Baylan Skoll' },
            { num: 'AP-5', title: 'Shin Hati' },
            { num: 'AP-6', title: 'Hera Syndulla' },
            { num: 'AP-7', title: 'Grand Admiral Thrawn' },
            { num: 'AP-8', title: 'Captain Enoch' },
            { num: 'AP-9', title: 'Chopper' },
          ]
        },
        {
          count: 9,
          name: 'PUZZLE — SKELETON CREW',
          meta: 'Joe Corroney',
          odds: '1:216 packs',
          parallels: 4,
          cards: [
            { num: 'SCP-1', title: 'Jod' },
            { num: 'SCP-2', title: 'SM-33' },
            { num: 'SCP-3', title: 'Neel' },
            { num: 'SCP-4', title: 'Wim' },
            { num: 'SCP-5', title: 'Khy\'mm' },
            { num: 'SCP-6', title: 'Wendle' },
            { num: 'SCP-7', title: 'Fara' },
            { num: 'SCP-8', title: 'Fern' },
            { num: 'SCP-9', title: 'KB' },
          ]
        },
        {
          count: 20,
          name: 'MCQUARRIE BUYBACKS',
          meta: '1993–94 buyback cards',
          noParallels: true,
          cards: [
            { num: 'MCQ-1', title: '1993 Star Wars Galaxy Series 1 #15', meta: 'Vintage buyback' },
            { num: 'MCQ-2', title: '1993 Star Wars Galaxy Series 1 #42', meta: 'Vintage buyback' },
            { num: 'MCQ-3', title: '1993 Star Wars Galaxy Series 1 #43', meta: 'Vintage buyback' },
            { num: 'MCQ-4', title: '1993 Star Wars Galaxy Series 1 #44', meta: 'Vintage buyback' },
            { num: 'MCQ-5', title: '1993 Star Wars Galaxy Series 1 #45', meta: 'Vintage buyback' },
            { num: 'MCQ-6', title: '1993 Star Wars Galaxy Series 1 #46', meta: 'Vintage buyback' },
            { num: 'MCQ-7', title: '1993 Star Wars Galaxy Series 1 #47', meta: 'Vintage buyback' },
            { num: 'MCQ-8', title: '1993 Star Wars Galaxy Series 1 #57', meta: 'Vintage buyback' },
            { num: 'MCQ-9', title: '1993 Star Wars Galaxy Series 1 #59', meta: 'Vintage buyback' },
            { num: 'MCQ-10', title: '1993 Star Wars Galaxy Series 1 #60', meta: 'Vintage buyback' },
            { num: 'MCQ-11', title: '1993 Star Wars Galaxy Series 1 #68', meta: 'Vintage buyback' },
            { num: 'MCQ-12', title: '1993 Star Wars Galaxy Series 1 #75', meta: 'Vintage buyback' },
            { num: 'MCQ-13', title: '1993 Star Wars Galaxy Series 1 #77', meta: 'Vintage buyback' },
            { num: 'MCQ-14', title: '1994 Star Wars Galaxy Series 2 #142', meta: 'Vintage buyback' },
            { num: 'MCQ-15', title: '1994 Star Wars Galaxy Series 2 #143', meta: 'Vintage buyback' },
            { num: 'MCQ-16', title: '1994 Star Wars Galaxy Series 2 #144', meta: 'Vintage buyback' },
            { num: 'MCQ-17', title: '1994 Star Wars Galaxy Series 2 #145', meta: 'Vintage buyback' },
            { num: 'MCQ-18', title: '1994 Star Wars Galaxy Series 2 #146', meta: 'Vintage buyback' },
            { num: 'MCQ-19', title: '1994 Star Wars Galaxy Series 2 #147', meta: 'Vintage buyback' },
            { num: 'MCQ-20', title: '1994 Star Wars Galaxy Series 2 #148', meta: 'Vintage buyback' },
          ]
        }
      ],
      auto: [
        {
          count: 49,
          name: 'GALAXY AUTOGRAPHS',
          meta: 'Single-signer base auto tier',
          parallels: 7,
          cards: [
            { num: 'GA-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'GA-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'GA-BL', title: 'Billie Lourd', meta: 'Lieutenant Connix' },
            { num: 'GA-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'GA-C3', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'GA-CM', title: 'Carrie-Anne Moss', meta: 'Jedi Master Indara' },
            { num: 'GA-DG', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'GA-DK', title: 'Dafne Keen', meta: 'Jecki Lon' },
            { num: 'GA-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'GA-DO', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'GA-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'GA-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'GA-ECK', title: 'Ashley Eckstein', meta: 'Ahsoka Tano' },
            { num: 'GA-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'GA-EW', title: 'Elijah Wood', meta: 'Jace Rucklin' },
            { num: 'GA-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'GA-FW', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'GA-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'GA-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'GA-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'GA-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'GA-IM', title: 'Ian McDiarmid', meta: 'Darth Sidious' },
            { num: 'GA-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'GA-JAL', title: 'Jaleel White', meta: 'Gunter' },
            { num: 'GA-JB', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'GA-JOO', title: 'Joonas Suotamo', meta: 'Chewbacca' },
            { num: 'GA-JT', title: 'Justin Theroux', meta: 'Master Codebreaker' },
            { num: 'GA-LAW', title: 'Jude Law', meta: 'Jod Na Nawood' },
            { num: 'GA-LJ', title: 'Lee Jung-jae', meta: 'Jedi Master Sol' },
            { num: 'GA-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'GA-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'GA-MJ', title: 'Manny Jacinto', meta: 'The Stranger' },
            { num: 'GA-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'GA-NO', title: 'John Leguizamo', meta: 'Gor Koresh' },
            { num: 'GA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'GA-OJ', title: 'O\'Shea Jackson Jr.', meta: 'Kawlan Roken' },
            { num: 'GA-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'GA-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'GA-RH', title: 'Ron Howard', meta: 'Director' },
            { num: 'GA-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'GA-RS', title: 'Robert Timothy Smith', meta: 'Neel' },
            { num: 'GA-SG', title: 'Sarah Michelle Gellar', meta: 'Seventh Sister' },
            { num: 'GA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'GA-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'GA-SW', title: 'Sam Witwer', meta: 'Maul' },
            { num: 'GA-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'GA-TN', title: 'Thandiwe Newton', meta: 'Val' },
            { num: 'GA-WD', title: 'Warwick Davis', meta: 'Wicket W. Warrick' },
            { num: 'GA-ZB', title: 'Zach Braff', meta: 'Freck' },
          ]
        },
        {
          count: 10,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer · book card format',
          parallels: 2,
          cards: [
            { num: 'DA-AD', title: 'Adam Driver / Daisy Ridley', meta: 'Kylo Ren / Rey' },
            { num: 'DA-DR', title: 'Diana Lee Inosanto / Rosario Dawson', meta: 'Morgan / Ahsoka' },
            { num: 'DA-EP', title: 'Paul Bettany / Emilia Clarke', meta: 'Dryden / Qi\'ra' },
            { num: 'DA-FA', title: 'Freddie Prinze Jr. / Ashley Eckstein', meta: 'Kanan / Ahsoka' },
            { num: 'DA-KD', title: 'Denise Gough / Kyle Soller', meta: 'Dedra / Syril' },
            { num: 'DA-LI', title: 'Ivanna Sakhno / Lars Mikkelsen', meta: 'Shin / Thrawn' },
            { num: 'DA-OK', title: 'Oscar Isaac / Keri Russell', meta: 'Poe / Zorii' },
            { num: 'DA-PM', title: 'Mark Hamill / Pedro Pascal', meta: 'Luke / Mando' },
            { num: 'DA-RR', title: 'Robert Timothy Smith / Ravi Cabot-Conyers', meta: 'Neel / Wim' },
            { num: 'DA-SG', title: 'Genevieve O\'Reilly / Stellan Skarsgård', meta: 'Mon Mothma / Luthen' },
          ]
        },
        {
          count: 5,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer · Red /5 + Logo /5 + 1/1',
          parallels: 3,
          cards: [
            { num: 'TA-AFS', title: 'Sam Witwer / Freddie Prinze Jr. / Ashley Eckstein', meta: 'Rebels Cast' },
            { num: 'TA-DSG', title: 'Diego Luna / Genevieve O\'Reilly / Stellan Skarsgård', meta: 'Andor Cast' },
            { num: 'TA-H3M', title: 'Harrison Ford / Anthony Daniels / Mark Hamill', meta: 'OT Cast' },
            { num: 'TA-MHB', title: 'Harrison Ford / Billy Dee Williams / Mark Hamill', meta: 'OT Cast' },
            { num: 'TA-TKG', title: 'Katee Sackhoff / Giancarlo Esposito / Pedro Pascal', meta: 'Mando Cast' },
          ]
        },
        {
          count: 4,
          name: 'QUAD AUTOGRAPHS',
          meta: 'Four-signer · Red /5 + Logo /5 + 1/1',
          parallels: 3,
          cards: [
            { num: 'Q-ADSG', title: 'Genevieve O\'Reilly / Stellan Skarsgård / Adria Arjona / Diego Luna', meta: 'Andor Cast' },
            { num: 'Q-JNJF', title: 'Jaleel White / Fred Tatasciore / Nick Frost / Jude Law', meta: 'Skeleton Crew Cast' },
            { num: 'Q-RNME', title: 'Natasha Liu Bordizzo / Rosario Dawson / Eman Esfandi / Mary Elizabeth Winstead', meta: 'Ahsoka Cast' },
            { num: 'Q-SETH', title: 'Temuera Morrison / Ewan McGregor / Hayden Christensen / Samuel L. Jackson', meta: 'Prequel Cast' },
          ]
        },
        {
          count: 2,
          name: 'AUTOGRAPH BUYBACKS',
          meta: 'Vintage signed buybacks',
          parallels: 1,
          cards: [
            { num: 'AB-15', title: '1993 Star Wars Galaxy Series 1 #15', meta: 'Vintage signed buyback' },
            { num: 'AB-43', title: '1993 Star Wars Galaxy Series 1 #43', meta: 'Vintage signed buyback' },
          ]
        }
      ],
      sketch: [
        {
          count: 7,
          name: 'BLANK CANVAS SKETCH CARDS',
          meta: 'Original blank-canvas commissions',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'BCS-1', title: 'Aaron Soon' },
            { num: 'BCS-2', title: 'Tatyana Drewry Carvin' },
            { num: 'BCS-3', title: 'Tori Niu' },
            { num: 'BCS-4', title: 'Chris Madden' },
            { num: 'BCS-5', title: 'Taylor Chojecki' },
            { num: 'BCS-6', title: 'Scott Zenteno' },
            { num: 'BCS-7', title: 'Justin Bruce Lee' },
          ]
        },
        {
          count: 153,
          name: 'SKETCH CARD ARTISTS',
          meta: 'One-of-one hand-drawn sketches',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Adam Beck' },
            { num: 'SK-2', title: 'Adam Fields' },
            { num: 'SK-3', title: 'Aleksandr Gigov' },
            { num: 'SK-4', title: 'Alex Mines' },
            { num: 'SK-5', title: 'Allen Geneta' },
            { num: 'SK-6', title: 'Allen Grimes' },
            { num: 'SK-7', title: 'Andrew Fry' },
            { num: 'SK-8', title: 'Andy Hanks' },
            { num: 'SK-9', title: 'Angel Aviles' },
            { num: 'SK-10', title: 'Angelina Benedetti' },
            { num: 'SK-11', title: 'Anthony Pietszak' },
            { num: 'SK-12', title: 'Antni Ellison' },
            { num: 'SK-13', title: 'Ash Gonzales' },
            { num: 'SK-14', title: 'Ashley Marsh' },
            { num: 'SK-15', title: 'Basak Kahraman' },
            { num: 'SK-16', title: 'Bean' },
            { num: 'SK-17', title: 'Ben AbuSaada' },
            { num: 'SK-18', title: 'Bobby Blakey' },
            { num: 'SK-19', title: 'Brandon Klein' },
            { num: 'SK-20', title: 'C DUB' },
            { num: 'SK-21', title: 'Charlie Cody' },
            { num: 'SK-22', title: 'Chenduz' },
            { num: 'SK-23', title: 'Chris Colyer' },
            { num: 'SK-24', title: 'Chris Meeks' },
            { num: 'SK-25', title: 'Cory Payne CMP' },
            { num: 'SK-26', title: 'Court' },
            { num: 'SK-27', title: 'Cyrus Sherkat' },
            { num: 'SK-28', title: 'Dan Bergren' },
            { num: 'SK-29', title: 'Dan Cooney' },
            { num: 'SK-30', title: 'Dan Curto' },
            { num: 'SK-31', title: 'Dan Gorman' },
            { num: 'SK-32', title: 'Dan Lawler' },
            { num: 'SK-33', title: 'Dan Tearle' },
            { num: 'SK-34', title: 'Daniel Riveron' },
            { num: 'SK-35', title: 'Darrin Pepe' },
            { num: 'SK-36', title: 'David Willingham' },
            { num: 'SK-37', title: 'Dawn Murphy' },
            { num: 'SK-38', title: 'Dove McHargue' },
            { num: 'SK-39', title: 'Dwayne Carpenter' },
            { num: 'SK-40', title: 'DYJ' },
            { num: 'SK-41', title: 'Dylan Riley' },
            { num: 'SK-42', title: 'El Smetchö' },
            { num: 'SK-43', title: 'Elson Jr. Art' },
            { num: 'SK-44', title: 'Elvin A Hernandez' },
            { num: 'SK-45', title: 'Emma Douglas' },
            { num: 'SK-46', title: 'Emrah Cildir' },
            { num: 'SK-47', title: 'Emre Varlibas' },
            { num: 'SK-48', title: 'Enrica Martine Pitrolino' },
            { num: 'SK-49', title: 'Eric Lehtonen' },
            { num: 'SK-50', title: 'Erik Muller' },
            { num: 'SK-51', title: 'Evgheni REBL Batu' },
            { num: 'SK-52', title: 'Frank A. Kadar' },
            { num: 'SK-53', title: 'Frank Sansone' },
            { num: 'SK-54', title: 'Franklim Teixeira' },
            { num: 'SK-55', title: 'Guilherme Rocha' },
            { num: 'SK-56', title: 'Ian McKesson' },
            { num: 'SK-57', title: 'Jaime Lopez' },
            { num: 'SK-58', title: 'James Boyd' },
            { num: 'SK-59', title: 'James Harris' },
            { num: 'SK-60', title: 'Jamie Richards' },
            { num: 'SK-61', title: 'Jane Rushton' },
            { num: 'SK-62', title: 'Jason Christner' },
            { num: 'SK-63', title: 'Jason Pearce' },
            { num: 'SK-64', title: 'Jason Queen' },
            { num: 'SK-65', title: 'Jason Sobol' },
            { num: 'SK-66', title: 'Jay Manchand' },
            { num: 'SK-67', title: 'Jeffrey C. Benitez' },
            { num: 'SK-68', title: 'Jenny Kim' },
            { num: 'SK-69', title: 'Jessica Hickman' },
            { num: 'SK-70', title: 'Jessica Van Dusen' },
            { num: 'SK-71', title: 'Jiaxin YinShan Sun' },
            { num: 'SK-72', title: 'Jim O\'Riley' },
            { num: 'SK-73', title: 'Joe Ortiz' },
            { num: 'SK-74', title: 'John JAR Rodriguez' },
            { num: 'SK-75', title: 'John Boren' },
            { num: 'SK-76', title: 'John Bruce' },
            { num: 'SK-77', title: 'John Still' },
            { num: 'SK-78', title: 'Jojo Hilario' },
            { num: 'SK-79', title: 'Josh Trout' },
            { num: 'SK-80', title: 'Julia McKenzie' },
            { num: 'SK-81', title: 'Julie-Anne' },
            { num: 'SK-82', title: 'Kang Jing' },
            { num: 'SK-83', title: 'Karl Jones' },
            { num: 'SK-84', title: 'Kevin Cleveland' },
            { num: 'SK-85', title: 'Kevin P. West' },
            { num: 'SK-86', title: 'Kevin Scott Jacobs' },
            { num: 'SK-87', title: 'Khloe Delnick' },
            { num: 'SK-88', title: 'Khushi Mahajan' },
            { num: 'SK-89', title: 'Kris Penix' },
            { num: 'SK-90', title: 'Krishna Sharma' },
            { num: 'SK-91', title: 'Laura Inglis' },
            { num: 'SK-92', title: 'Lee Lightfoot' },
            { num: 'SK-93', title: 'Limuel Pinzon' },
            { num: 'SK-94', title: 'Lindsey Greyling' },
            { num: 'SK-95', title: 'Luke Rushton LR' },
            { num: 'SK-96', title: 'Marcia Dye' },
            { num: 'SK-97', title: 'Marlo Agunos' },
            { num: 'SK-98', title: 'Marlo Martos' },
            { num: 'SK-99', title: 'Matthew Maldonado' },
            { num: 'SK-100', title: 'Matthew Sutton' },
            { num: 'SK-101', title: 'Michael Mastermaker' },
            { num: 'SK-102', title: 'Mike Dalzell' },
            { num: 'SK-103', title: 'Mike LaPeruta' },
            { num: 'SK-104', title: 'Mohammad Jilani' },
            { num: 'SK-105', title: 'Neil A Brady' },
            { num: 'SK-106', title: 'Neil Camera' },
            { num: 'SK-107', title: 'Nick Gribbon' },
            { num: 'SK-108', title: 'Nick Sutphin' },
            { num: 'SK-109', title: 'Niño John Benitez' },
            { num: 'SK-110', title: 'Oscar Chavez' },
            { num: 'SK-111', title: 'Patricio Carrasco' },
            { num: 'SK-112', title: 'Patrick Giles' },
            { num: 'SK-113', title: 'Phillip Trujillo' },
            { num: 'SK-114', title: 'Randy Siplon' },
            { num: 'SK-115', title: 'Rees Chua-Finlay' },
            { num: 'SK-116', title: 'Rich RAM Molinelli' },
            { num: 'SK-117', title: 'Rich Hennemann' },
            { num: 'SK-118', title: 'Rico Dela Rosa' },
            { num: 'SK-119', title: 'Robert Hendrickson' },
            { num: 'SK-120', title: 'Roy Cover' },
            { num: 'SK-121', title: 'Rugved Bhuskute' },
            { num: 'SK-122', title: 'Rustico Limosinero' },
            { num: 'SK-123', title: 'Rutvig Vaid' },
            { num: 'SK-124', title: 'Ryan Edwards' },
            { num: 'SK-125', title: 'Ryan Finley' },
            { num: 'SK-126', title: 'Ryan Johnston' },
            { num: 'SK-127', title: 'Ryan Thompson' },
            { num: 'SK-128', title: 'Scott Anthony' },
            { num: 'SK-129', title: 'Scott Houseman' },
            { num: 'SK-130', title: 'Scott West' },
            { num: 'SK-131', title: 'Scribbling Joe' },
            { num: 'SK-132', title: 'Sean Mathews' },
            { num: 'SK-133', title: 'Semra Bulut' },
            { num: 'SK-134', title: 'Shaow Siong' },
            { num: 'SK-135', title: 'Shyla Lee' },
            { num: 'SK-136', title: 'Sir Edmund Duke' },
            { num: 'SK-137', title: 'Stephane Leonardi' },
            { num: 'SK-138', title: 'Stephanie Swanger' },
            { num: 'SK-139', title: 'Steve Alce' },
            { num: 'SK-140', title: 'Stirling Ford' },
            { num: 'SK-141', title: 'Ted Dastick Jr' },
            { num: 'SK-142', title: 'Tim Shinn' },
            { num: 'SK-143', title: 'Tom Amici' },
            { num: 'SK-144', title: 'TOMA' },
            { num: 'SK-145', title: 'Tomoko Taniguchi' },
            { num: 'SK-146', title: 'Traci Easterday' },
            { num: 'SK-147', title: 'Trent Westbrook' },
            { num: 'SK-148', title: 'Veronica Louro' },
            { num: 'SK-149', title: 'Vini Pirani' },
            { num: 'SK-150', title: 'Ward Silverman' },
            { num: 'SK-151', title: 'Will Pleydon' },
            { num: 'SK-152', title: 'Zach Woolsey' },
            { num: 'SK-153', title: 'Jason' },
          ]
        }
      ]
    },
  },

  '2024-chrome-galaxy': {
    setId: '2024-chrome-galaxy',
    year: '2024',
    brand: 'TOPPS CHROME',
    title: 'STAR WARS GALAXY',
    releaseDate: '11 / 01 / 2024',
    lede: 'Year of the Sith — anchored by the 25th anniversary of The Phantom Menace. Six artist-driven insert sets pair with new Armor Shadowbox helmets, John Tyler Christopher action-figure-cover variants, and a 13-deep parallel rainbow on the 100-card base set.',
    stats: [
      { num: '100', label: 'Base Cards',     sub: 'Galaxy archive + new art', color: 'gold' },
      { num: '9',   label: 'Insert Sets',    sub: '5 to 15 cards each',        color: 'cyan' },
      { num: '70',  label: 'Auto Cards',     sub: '4 signature tiers',         color: 'green' },
      { num: '13',  label: 'Base Parallels', sub: 'Refractor → 1/1',           color: 'purple' },
      { num: '15',  label: 'Sub-sets Total', sub: 'Tracked on CK',             color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4',  l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '4',  l: 'Numbered parallels / box' },
      { v: '3',  l: 'Mini-Diamond refractors / box' },
      { v: '1',  l: 'Armor Shadowbox per box' },
    ],
    pullRates: [
      { name: 'Phantom Menace 25th — Maul', odds: '1 : 9',     tier: 'normal' },
      { name: 'Art of the Sith',            odds: '1 : 18',    tier: 'normal' },
      { name: 'Art of Naboo',               odds: '1 : 18',    tier: 'normal' },
      { name: 'Power of the Darkside',      odds: '1 : 18',    tier: 'normal' },
      { name: 'Galactic Empire Art',        odds: '1 : 18',    tier: 'normal' },
      { name: 'Armor Shadowbox',            odds: '1 : 216',   tier: 'rare' },
      { name: 'Action Figure Variants',     odds: '1 : 1,080', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR',     pr: '∞',    gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'MINI DIAMOND',  pr: '∞',    gradient: 'repeating-linear-gradient(45deg, #b8c8d8 0 4px, #d8e8f0 4px 8px)', darkText: true },
      { name: 'AQUA',          pr: '/199', gradient: 'linear-gradient(135deg, #40e0d0 0%, #20a0a0 100%)' },
      { name: 'AQUA SONAR',    pr: '/199', gradient: 'linear-gradient(135deg, #00ffff 0%, #008888 100%)' },
      { name: 'AQUA LAVA',     pr: '/175', gradient: 'linear-gradient(135deg, #00d4ff 0%, #ff4400 100%)' },
      { name: 'BLUE',          pr: '/150', gradient: 'linear-gradient(135deg, #00aaff 0%, #0060c0 100%)' },
      { name: 'WAVE',          pr: '/99',  gradient: 'linear-gradient(135deg, #00d4ff 0%, #0080c0 100%)' },
      { name: 'PRISM',         pr: '/75',  gradient: 'linear-gradient(135deg, #ff60ff 0%, #6060ff 33%, #00d4ff 66%, #00ff80 100%)' },
      { name: 'MOJO',          pr: '/50',  gradient: 'linear-gradient(135deg, #ff0080 0%, #ff8000 50%, #ffd000 100%)' },
      { name: 'ORANGE',        pr: '/25',  gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'X-FRACTOR',     pr: '/10',  gradient: 'linear-gradient(135deg, #1a1a2a 0%, #0a0a16 100%)' },
      { name: 'RED',           pr: '/5',   gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR',  pr: '1/1',  gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [
      { name: 'Jason Thomas',           work: 'Art of the Sith' },
      { name: 'Balance Sheet',          work: 'Art of Naboo' },
      { name: 'Traci Easterday',        work: 'Power of the Darkside' },
      { name: 'Uzuri Art',              work: 'Galactic Empire Art' },
      { name: 'John Tyler Christopher', work: 'Action Figure Variants' },
    ],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Galaxy archive + new commissioned art',
          parallels: 13,
          cards: [
            { num: '1', title: 'Warriors of the Force', meta: 'Chris Trevas' },
            { num: '2', title: 'Darth Vader and Princess Leia', meta: 'Chris Trevas' },
            { num: '3', title: 'Not Part of the Bargain', meta: 'Chris Trevas' },
            { num: '4', title: 'Beyond the Cave', meta: 'Chris Trevas' },
            { num: '5', title: 'Luke Wields the Lightsaber', meta: 'Chris Trevas' },
            { num: '6', title: 'In the Heat of Battle', meta: 'Tommy Lee Edwards' },
            { num: '7', title: 'Anakin Skywalker\'s Revenge', meta: 'Tommy Lee Edwards' },
            { num: '8', title: 'Becoming Darth Vader', meta: 'Tommy Lee Edwards' },
            { num: '9', title: 'Battle of Kamino', meta: 'Saby Menyhei' },
            { num: '10', title: 'Jabba\'s Bounty Hunter', meta: 'Saby Menyhei' },
            { num: '11', title: 'There Is No Escape', meta: 'Saby Menyhei' },
            { num: '12', title: 'Imperial Shock Troopers', meta: 'Clark Mitchell' },
            { num: '13', title: 'Obi-Wan Kenobi', meta: 'Clark Mitchell' },
            { num: '14', title: 'Anakin Skywalker', meta: 'Clark Mitchell' },
            { num: '15', title: 'Battle-Ready', meta: 'Clark Mitchell' },
            { num: '16', title: 'Adventures of BB-8', meta: 'Archives' },
            { num: '17', title: 'The Force Awakens', meta: 'Archives' },
            { num: '18', title: 'Friends Forever', meta: 'Archives' },
            { num: '19', title: 'The Tatooine Gangster', meta: 'Archives' },
            { num: '20', title: 'Max Rebo Band', meta: 'Archives' },
            { num: '21', title: 'Starfighter in Battle', meta: 'Archives' },
            { num: '22', title: 'Han Solo in Carbonite', meta: 'Archives' },
            { num: '23', title: 'Kylo Ren', meta: 'Archives' },
            { num: '24', title: 'Boba Fett\'s Jetpack', meta: 'Archives' },
            { num: '25', title: 'Sith Lords', meta: 'Archives' },
            { num: '26', title: 'Defender of the Empire', meta: 'Archives' },
            { num: '27', title: 'Setting Suns', meta: 'Marko Manev' },
            { num: '28', title: 'The Dark Lord', meta: 'Marko Manev' },
            { num: '29', title: 'New Beginning', meta: 'Marko Manev' },
            { num: '30', title: 'A Look to the Past', meta: 'Marko Manev' },
            { num: '31', title: 'Mourning for Padmé', meta: 'Erik Maell' },
            { num: '32', title: 'Boba Fett\'s Prize', meta: 'Kyle Babbitt' },
            { num: '33', title: 'The Way of Mand\'alor', meta: 'Brent Woodside' },
            { num: '34', title: 'Red Five', meta: 'Brent Woodside' },
            { num: '35', title: 'Victory and Death', meta: 'Brent Woodside' },
            { num: '36', title: 'The Hunter', meta: 'Brent Woodside' },
            { num: '37', title: 'The Rebels and the Rancor', meta: 'Dave Dorman' },
            { num: '38', title: 'Biker Scout Down', meta: 'Dave Dorman' },
            { num: '39', title: 'Knights of the Republic Issue #4', meta: 'Dave Dorman' },
            { num: '40', title: 'The Crimson Crusader', meta: 'Dave Dorman' },
            { num: '41', title: 'Watto', meta: 'Matt Busch' },
            { num: '42', title: 'Where the Fun Begins', meta: 'Joshua Williams' },
            { num: '43', title: 'Braver Than Most', meta: 'Joshua Williams' },
            { num: '44', title: 'Cloud City Gambit', meta: 'Lee Kohse' },
            { num: '45', title: 'AT-AT Drivers', meta: 'Lee Kohse' },
            { num: '46', title: 'Dagobah', meta: 'Daniel Danger' },
            { num: '47', title: 'The Legacy', meta: 'Cliff Cramp' },
            { num: '48', title: 'Communion in the Force', meta: 'Dianne Vaznelis' },
            { num: '49', title: 'The Lost Jedi\'s Return', meta: 'Adam Schickling' },
            { num: '50', title: 'Luke Skywalker and R2-D2', meta: 'Greg & Tim Hildebrandt' },
            { num: '51', title: 'Passage to Alderaan', meta: 'Mike Kupka' },
            { num: '52', title: 'Return to Jabba\'s Palace', meta: 'Mike Kupka' },
            { num: '53', title: 'Calming Touch', meta: 'Mike Kupka' },
            { num: '54', title: 'On Mustafar', meta: 'Ryan Church' },
            { num: '55', title: 'Against the Dark Side', meta: 'Mark Chiarello' },
            { num: '56', title: 'Daring Deception', meta: 'Steven Chorney' },
            { num: '57', title: 'IG-11\'s Initiative', meta: 'David Rabbitte' },
            { num: '58', title: 'Victory and Defeat', meta: 'Danny Haas' },
            { num: '59', title: 'Too Strong for Blasters', meta: 'Jeremy Saliba' },
            { num: '60', title: 'Count Dooku', meta: 'Gabz' },
            { num: '61', title: 'Director Krennic', meta: 'Gabz' },
            { num: '62', title: 'Lando Calrissian', meta: 'Gabz' },
            { num: '63', title: 'From Hero to Villain', meta: 'Tsuneo Sanda' },
            { num: '64', title: 'Stormtroopers', meta: 'Tsuneo Sanda' },
            { num: '65', title: 'The Bounty Hunter\'s Prize', meta: 'Benjamin Carre' },
            { num: '66', title: 'Rescue of Geonosis', meta: 'Candice Dailey' },
            { num: '67', title: 'An Understanding', meta: 'Candice Dailey' },
            { num: '68', title: 'Dark Aspirations', meta: 'Candice Dailey' },
            { num: '69', title: 'The High Ground', meta: 'PhaseRunner' },
            { num: '70', title: 'The Destiny of a Jedi', meta: 'Ignacio RC' },
            { num: '71', title: 'The Duel: Kylo Ren', meta: 'Richard Luong' },
            { num: '72', title: 'The Duel: Rey', meta: 'Richard Luong' },
            { num: '73', title: 'One Last Lesson, Ahsoka Tano vs Darth Maul', meta: 'Ian Macdonald' },
            { num: '74', title: 'Ahsoka Tano', meta: 'Juan Carlos Ruiz Burgos' },
            { num: '75', title: 'Little Droidsmith', meta: 'Juan Carlos Ruiz Burgos' },
            { num: '76', title: 'Call the Jedi', meta: 'Akirant' },
            { num: '77', title: 'I Will Watch Over Him', meta: 'Kayla Woodside' },
            { num: '78', title: 'The Choice', meta: 'Kayla Woodside' },
            { num: '79', title: 'The Awakening', meta: 'Zoltan Simon' },
            { num: '80', title: 'Conquering Shadow', meta: 'Raymond Swanland' },
            { num: '81', title: 'A Clan of Two', meta: 'Jerry Vanderstelt' },
            { num: '82', title: 'Holding Hope', meta: 'Robert Hendrickson' },
            { num: '83', title: 'Luke Skywalker', meta: 'Alice X. Zhang' },
            { num: '84', title: 'Han Solo', meta: 'Alice X. Zhang' },
            { num: '85', title: 'Battle of Mos Espa', meta: 'Pablo Olivera' },
            { num: '86', title: 'Imperial Fleet', meta: 'Paul Youll' },
            { num: '87', title: 'Han Solo\'s Rescue', meta: 'Bryant Eastman' },
            { num: '88', title: 'Following Orders', meta: 'Chris Dee' },
            { num: '89', title: 'Hoth Evacuation', meta: 'Darren Tan' },
            { num: '90', title: 'You Are Our Only Hope', meta: 'Rodel Gonzalez' },
            { num: '91', title: 'Standoff', meta: 'Rodel Gonzalez' },
            { num: '92', title: 'Yoda', meta: 'Rodel Gonzalez' },
            { num: '93', title: 'Falcon Rising', meta: 'Mark Chilcott' },
            { num: '94', title: 'Mustafar Takeoff', meta: 'Mark Chilcott' },
            { num: '95', title: 'Disciples of the Empire', meta: 'Jaime Carrillo' },
            { num: '96', title: 'Trouble on Tatooine', meta: 'Hugh Fleming' },
            { num: '97', title: 'Ewok No Evil', meta: 'Craig Skaggs' },
            { num: '98', title: 'Goodbye for Now', meta: 'Al Abbazia' },
            { num: '99', title: 'Forged By Destiny', meta: 'Al Abbazia' },
            { num: '100', title: 'Ahsoka Returns', meta: 'Al Abbazia' },
          ]
        }
      ],
      insert: [
        {
          count: 10,
          name: 'ART OF THE SITH',
          meta: 'Jason Thomas',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'AS-1', title: 'Chancellor Palpatine', meta: 'Jason Thomas' },
            { num: 'AS-2', title: 'Darth Sidious', meta: 'Jason Thomas' },
            { num: 'AS-3', title: 'Darth Vader\'s Mask', meta: 'Jason Thomas' },
            { num: 'AS-4', title: 'Darth Vader', meta: 'Jason Thomas' },
            { num: 'AS-5', title: 'Count Dooku', meta: 'Jason Thomas' },
            { num: 'AS-6', title: 'Darth Nihilus', meta: 'Jason Thomas' },
            { num: 'AS-7', title: 'Darth Maul', meta: 'Jason Thomas' },
            { num: 'AS-8', title: 'Galactic Maul', meta: 'Jason Thomas' },
            { num: 'AS-9', title: 'Yoda meets Darth Bane', meta: 'Jason Thomas' },
            { num: 'AS-10', title: 'Darth Revan', meta: 'Jason Thomas' },
          ]
        },
        {
          count: 15,
          name: 'ART OF NABOO',
          meta: 'Balance Sheet',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'AN-1', title: 'Theed Power Generator', meta: 'Balance Sheet' },
            { num: 'AN-2', title: 'Great Grass Plains', meta: 'Balance Sheet' },
            { num: 'AN-3', title: 'Varykino Retreat', meta: 'Balance Sheet' },
            { num: 'AN-4', title: 'Theed Palace', meta: 'Balance Sheet' },
            { num: 'AN-5', title: 'Naboo Royal Starship', meta: 'Balance Sheet' },
            { num: 'AN-6', title: 'Theed Street', meta: 'Balance Sheet' },
            { num: 'AN-7', title: 'Gungan Sacred Place', meta: 'Balance Sheet' },
            { num: 'AN-8', title: 'Theed Plaza', meta: 'Balance Sheet' },
            { num: 'AN-9', title: 'Queen Amidala', meta: 'Balance Sheet' },
            { num: 'AN-10', title: 'N-1 Starfighter', meta: 'Balance Sheet' },
            { num: 'AN-11', title: 'Otoh Gunga', meta: 'Balance Sheet' },
            { num: 'AN-12', title: 'Lake Country', meta: 'Balance Sheet' },
            { num: 'AN-13', title: 'Padmé\'s Funeral Procession', meta: 'Balance Sheet' },
            { num: 'AN-14', title: 'Naboo Abyss', meta: 'Balance Sheet' },
            { num: 'AN-15', title: 'Padmé Amidala\'s Funeral', meta: 'Balance Sheet' },
          ]
        },
        {
          count: 15,
          name: 'PHANTOM MENACE 25TH — MAUL',
          meta: 'Multi-artist tribute',
          odds: '1:9 packs',
          parallels: 10,
          cards: [
            { num: 'AM-1', title: 'Phantom Menace #3 Comic Cover Art', meta: 'Hugh Fleming' },
            { num: 'AM-2', title: 'Sith Arrival', meta: 'Doug Cowan' },
            { num: 'AM-3', title: 'Jedi Slayer', meta: 'Brian Rood' },
            { num: 'AM-4', title: 'Darth Maul\'s Assets', meta: 'Archives' },
            { num: 'AM-5', title: 'A Mystery Named Maul', meta: 'Brian Rood' },
            { num: 'AM-6', title: 'Darth Maul Galaxy 7', meta: 'Mark Mchaley' },
            { num: 'AM-7', title: 'A Sith\'s Dark Vision', meta: 'Archives' },
            { num: 'AM-8', title: 'Battle Worn', meta: 'Archives' },
            { num: 'AM-9', title: 'Darth Maul', meta: 'Christian Alzmann' },
            { num: 'AM-10', title: 'Sinister Shadow', meta: 'Zoltan Simon' },
            { num: 'AM-11', title: 'Darth Maul', meta: 'Juan Burgos' },
            { num: 'AM-12', title: 'Crimson Blades', meta: 'Archives' },
            { num: 'AM-13', title: 'The Dark Duel', meta: 'Laz Marquez' },
            { num: 'AM-14', title: 'Double Bladed', meta: 'Tsuneo Sanda' },
            { num: 'AM-15', title: 'Infiltrator', meta: 'Doug Cowan' },
          ]
        },
        {
          count: 15,
          name: 'POWER OF THE DARKSIDE',
          meta: 'Traci Easterday',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'PD-1', title: 'Anakin Skywalker and His Mother', meta: 'Traci Easterday' },
            { num: 'PD-2', title: 'Mortis Vision', meta: 'Traci Easterday' },
            { num: 'PD-3', title: 'Obi-Wan Kenobi\'s Death', meta: 'Traci Easterday' },
            { num: 'PD-4', title: 'Anakin Skywalker Kills Dooku', meta: 'Traci Easterday' },
            { num: 'PD-5', title: 'Yoda Dismisses Anakin\'s Fears', meta: 'Traci Easterday' },
            { num: 'PD-6', title: 'Anakin Skywalker Stops Mace Windu', meta: 'Traci Easterday' },
            { num: 'PD-7', title: 'Lord Vader', meta: 'Traci Easterday' },
            { num: 'PD-8', title: 'Storming the Jedi Temple', meta: 'Traci Easterday' },
            { num: 'PD-9', title: 'Mustafar', meta: 'Traci Easterday' },
            { num: 'PD-10', title: 'Darth Vader Arrives on Malachor', meta: 'Traci Easterday' },
            { num: 'PD-11', title: 'Darth Vader vs Ahsoka Tano', meta: 'Traci Easterday' },
            { num: 'PD-12', title: 'Darth Vader vs Obi-Wan Kenobi', meta: 'Traci Easterday' },
            { num: 'PD-13', title: 'Tantive IV Hallway Massacre', meta: 'Traci Easterday' },
            { num: 'PD-14', title: 'Bespin', meta: 'Traci Easterday' },
            { num: 'PD-15', title: 'Darth Vader World Between Worlds', meta: 'Traci Easterday' },
          ]
        },
        {
          count: 15,
          name: 'GALACTIC EMPIRE ART',
          meta: 'Uzuri Art',
          odds: '1:18 packs',
          parallels: 10,
          cards: [
            { num: 'GE-1', title: 'Grand Admiral Thrawn', meta: 'Uzuri Art' },
            { num: 'GE-2', title: 'The Grand Inquisitor', meta: 'Uzuri Art' },
            { num: 'GE-3', title: 'Emperor\'s Royal Guard', meta: 'Uzuri Art' },
            { num: 'GE-4', title: 'Emperor Palpatine', meta: 'Uzuri Art' },
            { num: 'GE-5', title: 'Grand Moff Tarkin', meta: 'Uzuri Art' },
            { num: 'GE-6', title: 'Director Krennic', meta: 'Uzuri Art' },
            { num: 'GE-7', title: 'Captain Enoch', meta: 'Uzuri Art' },
            { num: 'GE-8', title: 'Second Sister', meta: 'Uzuri Art' },
            { num: 'GE-9', title: 'Night Trooper', meta: 'Uzuri Art' },
            { num: 'GE-10', title: 'Death Trooper', meta: 'Uzuri Art' },
            { num: 'GE-11', title: 'Dedra Meero', meta: 'Uzuri Art' },
            { num: 'GE-12', title: 'Iden Versio', meta: 'Uzuri Art' },
            { num: 'GE-13', title: 'Moff Gideon', meta: 'Uzuri Art' },
            { num: 'GE-14', title: 'Reva', meta: 'Uzuri Art' },
            { num: 'GE-15', title: 'Darth Vader', meta: 'Uzuri Art' },
          ]
        },
        {
          count: 15,
          name: 'ARMOR SHADOWBOX',
          meta: 'Layered helmet inserts',
          odds: '1:216 packs',
          parallels: 4,
          cards: [
            { num: 'ASB-1', title: 'Commander Cody Helmet' },
            { num: 'ASB-2', title: 'Captain Rex Helmet' },
            { num: 'ASB-3', title: 'Bo-Katan Kryze Helmet' },
            { num: 'ASB-4', title: 'The Mandalorian' },
            { num: 'ASB-5', title: 'Darth Vader Helmet' },
            { num: 'ASB-6', title: 'Boba Fett Helmet' },
            { num: 'ASB-7', title: 'Jess Pava\'s Resistance Pilot Helmet' },
            { num: 'ASB-8', title: 'Sabine Wren Helmet' },
            { num: 'ASB-9', title: 'Kylo Ren Helmet' },
            { num: 'ASB-10', title: 'Imperial Royal Guard Helmet' },
            { num: 'ASB-11', title: 'Death Trooper Helmet' },
            { num: 'ASB-12', title: 'Jango Fett Helmet' },
            { num: 'ASB-13', title: 'Captain Phasma Helmet' },
            { num: 'ASB-14', title: 'Captain Enoch Helmet' },
            { num: 'ASB-15', title: 'Darth Revan Helmet' },
          ]
        },
        {
          count: 5,
          name: 'ONE WITH THE FORCE',
          meta: 'All 1/1 Superfractors only',
          oneOfOne: true,
          cards: [
            { num: 'OF-1', title: 'Yoda' },
            { num: 'OF-2', title: 'Obi-Wan Kenobi' },
            { num: 'OF-3', title: 'Qui-Gon Jinn' },
            { num: 'OF-4', title: 'Count Dooku' },
            { num: 'OF-5', title: 'Darth Vader' },
          ]
        },
        {
          count: 5,
          name: 'ACTION FIGURE VARIANTS',
          meta: 'John Tyler Christopher',
          odds: '1:1,080 packs',
          parallels: 4,
          cards: [
            { num: 'VC-1', title: 'Luke Skywalker', meta: 'John Tyler Christopher' },
            { num: 'VC-2', title: 'Anakin Skywalker', meta: 'John Tyler Christopher' },
            { num: 'VC-3', title: 'Princess Leia Organa', meta: 'John Tyler Christopher' },
            { num: 'VC-4', title: 'Lando Calrissian', meta: 'John Tyler Christopher' },
            { num: 'VC-5', title: 'Grand Admiral Thrawn', meta: 'John Tyler Christopher' },
          ]
        },
        {
          count: 6,
          name: 'CANVAS ART CARDS',
          meta: 'Lucasfilm animator originals',
          noParallels: true,
          cards: [
            { num: 'CA-1', title: 'Justin Bruce Lee' },
            { num: 'CA-2', title: 'Chris Madden' },
            { num: 'CA-3', title: 'Scott Zenteno' },
            { num: 'CA-4', title: 'Ben Bryant' },
            { num: 'CA-5', title: 'Dawn Carlos' },
            { num: 'CA-6', title: 'Taylor Chojeck' },
          ]
        }
      ],
      auto: [
        {
          count: 56,
          name: 'GALAXY AUTOGRAPHS',
          meta: 'Single-signer base auto tier',
          parallels: 5,
          cards: [
            { num: 'A-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'A-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'A-AS', title: 'Andy Serkis', meta: 'Kino Loy' },
            { num: 'A-BD', title: 'Benicio Del Toro', meta: 'DJ' },
            { num: 'A-BL', title: 'Billie Lourd', meta: 'Lieutenant Connix' },
            { num: 'A-BM', title: 'Ben Mendelsohn', meta: 'Orson Krennic' },
            { num: 'A-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'A-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'A-DM', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'A-DR', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'A-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'A-EH', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'A-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'A-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'A-FP', title: 'Freddie Prinze Jr', meta: 'Kanan Jarrus' },
            { num: 'A-FS', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'A-GE', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'A-GL', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'A-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'A-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'A-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'A-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'A-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'A-JB', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'A-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'A-JL', title: 'John Leguizamo', meta: 'Gor Koresh' },
            { num: 'A-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'A-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'A-LD', title: 'Laura Dern', meta: 'Vice Admiral Holdo' },
            { num: 'A-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'A-ME', title: 'Maya Erskine', meta: 'Sully' },
            { num: 'A-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'A-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'A-MM', title: 'Mads Mikkelsen', meta: 'Galen Erso' },
            { num: 'A-MN', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'A-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'A-MZ', title: 'Lupita Nyong\'o', meta: 'Maz Kanata' },
            { num: 'A-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'A-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'A-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'A-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'A-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'A-RI', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'A-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'A-SG', title: 'Sarah Michelle Gellar', meta: 'Seventh Sister' },
            { num: 'A-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'A-SK', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'A-SO', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'A-SW', title: 'Sam Witwer', meta: 'Darth Maul' },
            { num: 'A-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'A-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'A-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'A-WD', title: 'Warwick Davis', meta: 'Wicket W. Warrick' },
            { num: 'A-WH', title: 'Werner Herzog', meta: 'The Client' },
            { num: 'A-ZB', title: 'Zach Braff', meta: 'Freck' },
          ]
        },
        {
          count: 6,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer · Red /5 + 1/1',
          parallels: 2,
          cards: [
            { num: 'DA-DO', title: 'Daisy Ridley / Oscar Isaac', meta: 'Rey / Poe Dameron' },
            { num: 'DA-DS', title: 'Diego Luna / Stellan Skarsgård', meta: 'Cassian / Luthen' },
            { num: 'DA-LO', title: 'Laura Dern / Oscar Isaac', meta: 'Holdo / Poe Dameron' },
            { num: 'DA-LW', title: 'Wes Chatham / Lars Mikkelsen', meta: 'Enoch / Thrawn' },
            { num: 'DA-RA', title: 'Rosario Dawson / Ariana Greenblatt', meta: 'Ahsoka Tano' },
            { num: 'DA-RM', title: 'Mary Elizabeth Winstead / Rosario Dawson', meta: 'Hera / Ahsoka' },
          ]
        },
        {
          count: 4,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer · Red /5 + 1/1',
          parallels: 2,
          cards: [
            { num: 'TA-DAS', title: 'Diego Luna / Stellan Skarsgård / Adria Arjona', meta: 'Andor Cast' },
            { num: 'TA-GFH', title: 'Gary Beadle / Fiona Shaw / Diego Luna', meta: 'Andor Cast' },
            { num: 'TA-HES', title: 'Ewan McGregor / Samuel L. Jackson / Hayden Christensen', meta: 'Prequel Cast' },
            { num: 'TA-RNM', title: 'Mary Elizabeth Winstead / Rosario Dawson / Natasha Liu Bordizzo', meta: 'Ahsoka Cast' },
          ]
        },
        {
          count: 4,
          name: 'QUAD AUTOGRAPHS',
          meta: 'Four-signer · Red /5 + 1/1',
          parallels: 2,
          cards: [
            { num: 'QA-DADK', title: 'Denise Gough / Adria Arjona / Kyle Soller / Diego Luna', meta: 'Andor Cast' },
            { num: 'QA-LWDI', title: 'Diana Lee Inosanto / Wes Chatham / Lars Mikkelsen / Ivanna Sakhno', meta: 'Ahsoka Cast' },
            { num: 'QA-NHES', title: 'Samuel L. Jackson / Ewan McGregor / Hayden Christensen / Natalie Portman', meta: 'Prequel Cast' },
            { num: 'QA-RNLW', title: 'Lars Mikkelsen / Natasha Liu Bordizzo / Wes Chatham / Rosario Dawson', meta: 'Ahsoka Cast' },
          ]
        }
      ],
      sketch: [
        {
          count: 120,
          name: 'SKETCH CARD ARTISTS',
          meta: 'One-of-one hand-drawn sketches',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Marlo Agunos' },
            { num: 'SK-2', title: 'Steve Alce' },
            { num: 'SK-3', title: 'Thomas Amici' },
            { num: 'SK-4', title: 'Angel S Aviles' },
            { num: 'SK-5', title: 'Adam Beck' },
            { num: 'SK-6', title: 'Jeffrey Benitez' },
            { num: 'SK-7', title: 'Dan Bergren' },
            { num: 'SK-8', title: 'Rugved Bhuskute' },
            { num: 'SK-9', title: 'James Boyd' },
            { num: 'SK-10', title: 'Isiah Xavier Bradley' },
            { num: 'SK-11', title: 'Neil A Brady' },
            { num: 'SK-12', title: 'John Bruce' },
            { num: 'SK-13', title: 'Neil Camera' },
            { num: 'SK-14', title: 'Patricio Carrasco' },
            { num: 'SK-15', title: 'Daniel Chavez' },
            { num: 'SK-16', title: 'Oscar Chavez' },
            { num: 'SK-17', title: 'Jason Christner' },
            { num: 'SK-18', title: 'Rees Chua-Finlay' },
            { num: 'SK-19', title: 'Emrah Cildir' },
            { num: 'SK-20', title: 'Candice Clemmons' },
            { num: 'SK-21', title: 'Dan Cooney' },
            { num: 'SK-22', title: 'Roy Cover' },
            { num: 'SK-23', title: 'Vincenzo Chenduz D\'Ippolito' },
            { num: 'SK-24', title: 'Candice Dailey' },
            { num: 'SK-25', title: 'Mike Dalzell' },
            { num: 'SK-26', title: 'Mongola Das' },
            { num: 'SK-27', title: 'Srijan Das' },
            { num: 'SK-28', title: 'Mike Davidson' },
            { num: 'SK-29', title: 'Jason Davies' },
            { num: 'SK-30', title: 'Rico Dela Rosa' },
            { num: 'SK-31', title: 'Robert Demers' },
            { num: 'SK-32', title: 'Marcia Dye' },
            { num: 'SK-33', title: 'Dyj' },
            { num: 'SK-34', title: 'Traci Easterday' },
            { num: 'SK-35', title: 'Antni Ellison' },
            { num: 'SK-36', title: 'Keith Farnum' },
            { num: 'SK-37', title: 'Brett Farr' },
            { num: 'SK-38', title: 'Ryan Finley' },
            { num: 'SK-39', title: 'Andrew Fry' },
            { num: 'SK-40', title: 'Robert El Smetcho Garcia' },
            { num: 'SK-41', title: 'Patrick Giles' },
            { num: 'SK-42', title: 'Rusty Gilligan' },
            { num: 'SK-43', title: 'Sammy Gomez' },
            { num: 'SK-44', title: 'Dan Gorman' },
            { num: 'SK-45', title: 'Lindsey Greyling' },
            { num: 'SK-46', title: 'Nick Gribbon' },
            { num: 'SK-47', title: 'Allen Grimes' },
            { num: 'SK-48', title: 'J. Hammond' },
            { num: 'SK-49', title: 'Andy Hanks' },
            { num: 'SK-50', title: 'Robert Hendrickson' },
            { num: 'SK-51', title: 'Elvin A Hernandez' },
            { num: 'SK-52', title: 'Jessica Hickman' },
            { num: 'SK-53', title: 'Nathaniel Howard' },
            { num: 'SK-54', title: 'Brad Hudson' },
            { num: 'SK-55', title: 'Kevin Scott Jacobs' },
            { num: 'SK-56', title: 'Rachel Jane' },
            { num: 'SK-57', title: 'Kang Jing' },
            { num: 'SK-58', title: 'Derek Johnson' },
            { num: 'SK-59', title: 'Ryan Johnston' },
            { num: 'SK-60', title: 'Karl Jones' },
            { num: 'SK-61', title: 'Basak Kahraman' },
            { num: 'SK-62', title: 'Debjit Kar' },
            { num: 'SK-63', title: 'Brandon Klein' },
            { num: 'SK-64', title: 'Michael LaPeruta' },
            { num: 'SK-65', title: 'Dan Lawler' },
            { num: 'SK-66', title: 'Eric Lehtonen' },
            { num: 'SK-67', title: 'Stephane Leonardi' },
            { num: 'SK-68', title: 'Rebeca Louro' },
            { num: 'SK-69', title: 'Veronica Louro' },
            { num: 'SK-70', title: 'Matt Maldonado' },
            { num: 'SK-71', title: 'Jay Manchand' },
            { num: 'SK-72', title: 'Joey Mason' },
            { num: 'SK-73', title: 'Michael Mastermaker' },
            { num: 'SK-74', title: 'Sean Mathews' },
            { num: 'SK-75', title: 'Lukas Maurer' },
            { num: 'SK-76', title: 'David Dove McHargue' },
            { num: 'SK-77', title: 'Julia McKenzie' },
            { num: 'SK-78', title: 'Ian McKesson' },
            { num: 'SK-79', title: 'Eric Medina' },
            { num: 'SK-80', title: 'Alex Mines' },
            { num: 'SK-81', title: 'Rich RAM Molinelli' },
            { num: 'SK-82', title: 'Jason Montoya' },
            { num: 'SK-83', title: 'Erik Muller' },
            { num: 'SK-84', title: 'Michael Munshaw' },
            { num: 'SK-85', title: 'Dawn Murphy' },
            { num: 'SK-86', title: 'Don Nguyen' },
            { num: 'SK-87', title: 'Jim O\'Riley' },
            { num: 'SK-88', title: 'Michael Ofiaza' },
            { num: 'SK-89', title: 'Jackson Ong' },
            { num: 'SK-90', title: 'Joe Ortiz' },
            { num: 'SK-91', title: 'Anthony Pietszak' },
            { num: 'SK-92', title: 'Limuel Pinzon' },
            { num: 'SK-93', title: 'Jason Queen' },
            { num: 'SK-94', title: 'Jamie Richards' },
            { num: 'SK-95', title: 'Cisco Rivera' },
            { num: 'SK-96', title: 'Daniel Riveron' },
            { num: 'SK-97', title: 'John Anthony Rodriguez' },
            { num: 'SK-98', title: 'Jason Saldajeno' },
            { num: 'SK-99', title: 'Frank Sansone' },
            { num: 'SK-100', title: 'Michael Sealie' },
            { num: 'SK-101', title: 'Luke Seavers' },
            { num: 'SK-102', title: 'Krishna Sharma' },
            { num: 'SK-103', title: 'Shaow Siong' },
            { num: 'SK-104', title: 'Todd Aaron Smith' },
            { num: 'SK-105', title: 'Veronica Smith' },
            { num: 'SK-106', title: 'Jason Sobol' },
            { num: 'SK-107', title: 'Matt Stewart' },
            { num: 'SK-108', title: 'John Still' },
            { num: 'SK-109', title: 'Nick Sutphin' },
            { num: 'SK-110', title: 'Matthew Sutton' },
            { num: 'SK-111', title: 'Ryan Thompson' },
            { num: 'SK-112', title: 'Bryan Kaiser Tillman' },
            { num: 'SK-113', title: 'RJ Tomascik' },
            { num: 'SK-114', title: 'Phillip Trujillo' },
            { num: 'SK-115', title: 'Rutvig Vaid' },
            { num: 'SK-116', title: 'Yves Van Berlo' },
            { num: 'SK-117', title: 'Emre Varlibas' },
            { num: 'SK-118', title: 'David Willingham' },
            { num: 'SK-119', title: 'Zach Woolsey' },
            { num: 'SK-120', title: 'Clinton Yeager' },
          ]
        }
      ]
    },
  },


  '2025-hyperspace': {
    setId: '2025-hyperspace',
    year: '2025',
    brand: 'TOPPS',
    title: 'STAR WARS HYPERSPACE',
    releaseDate: '12 / 30 / 2025',
    lede: 'The second Hyperspace voyage charts five planets — Alderaan, Corellia, Lothal, Mandalore and Tatooine — on all-Chrome stock: a 100-card base set with a full serial /99 Planetary Variations mirror, an 11-deep parallel rainbow from Refractor to Superfractor, nine insert lines from layered Shadowboxes to one-per-box Oversized Widevision sectors, a 37-signer on-card autograph program headlined by Mark Hamill and Harrison Ford, and a 144-artist sketch program topped by oversized planet panoramics.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Five planets, all Chrome', color: 'gold' },
      { num: '9', label: 'Insert Sets', sub: '5 to 25 cards each', color: 'cyan' },
      { num: '37', label: 'Auto Cards', sub: 'On-card variations', color: 'green' },
      { num: '11', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '12', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '8', l: 'Packs per box' },
      { v: '10', l: 'Cards per pack' },
      { v: '8', l: 'Boxes per case' },
      { v: '4', l: 'Numbered parallels / box' },
      { v: '2', l: 'Autographs per case' },
    ],
    pullRates: [
      { name: 'Galactic Eras', odds: '1 : 4', tier: 'normal' },
      { name: 'There\'s Always a Bigger Fish', odds: '1 : 4', tier: 'normal' },
      { name: 'Moon of Mandalore', odds: '1 : 8', tier: 'normal' },
      { name: 'Art of Tatooine', odds: '1 : 64', tier: 'rare' },
      { name: 'Autograph Variations', odds: '1 : 64', tier: 'rare' },
      { name: 'Hyperspace Shadowbox', odds: '1 : 128', tier: 'rare' },
      { name: 'Planetary Views', odds: '1 : 272', tier: 'rare' },
      { name: 'Galactic Origins', odds: '1 : 900', tier: 'mythic' },
      { name: 'Reflections', odds: '1 : 1,000', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'NEBULAE', pr: '∞', gradient: 'linear-gradient(135deg, #c9b6ff 0%, #7a5cd0 45%, #b88ce8 75%, #e8ddff 100%)', darkText: true },
      { name: 'AQUA SONAR', pr: '/199', gradient: 'linear-gradient(135deg, #40e8e0 0%, #00a0a0 60%, #80fff0 100%)', darkText: true },
      { name: 'BLUE LAZER', pr: '/150', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'PULSAR', pr: '/99', gradient: 'radial-gradient(circle at 50% 50%, #80b0ff 0%, #2050d0 70%)' },
      { name: 'GALACTIC DUST', pr: '/75', gradient: 'linear-gradient(135deg, #d4a855 0%, #9a7530 60%, #e8c880 100%)', darkText: true },
      { name: 'GOLD GALACTIC DUST', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'HYPERLANES', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'BLACK HYPERLANES', pr: '/10', gradient: 'linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)' },
      { name: 'RED HYPERLANES', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Five planets: Alderaan · Corellia · Lothal · Mandalore · Tatooine',
          parallels: 11,
          cards: [
            { num: '1', title: 'Ahsoka Tano', meta: 'Alderaan' },
            { num: '2', title: 'Alderaan Royal Guard', meta: 'Alderaan' },
            { num: '3', title: 'Aurra Sing', meta: 'Alderaan' },
            { num: '4', title: 'Bail Organa', meta: 'Alderaan' },
            { num: '5', title: 'Breha Organa', meta: 'Alderaan' },
            { num: '6', title: 'Captain Typho', meta: 'Alderaan' },
            { num: '7', title: 'Celly Organa', meta: 'Alderaan' },
            { num: '8', title: 'Kayo Organa', meta: 'Alderaan' },
            { num: '9', title: 'L0-LA59', meta: 'Alderaan' },
            { num: '10', title: 'Leia Organa', meta: 'Alderaan' },
            { num: '11', title: 'Mon Mothma', meta: 'Alderaan' },
            { num: '12', title: 'Naboo Royal Cruiser', meta: 'Alderaan' },
            { num: '13', title: 'Niano Organa', meta: 'Alderaan' },
            { num: '14', title: 'Tantive IV', meta: 'Alderaan' },
            { num: '15', title: 'Vect Nokru', meta: 'Alderaan' },
            { num: '16', title: 'Ahsoka Tano', meta: 'Corellia' },
            { num: '17', title: 'Chopper', meta: 'Corellia' },
            { num: '18', title: 'Han Solo', meta: 'Corellia' },
            { num: '19', title: 'Han Solo\'s landspeeder', meta: 'Corellia' },
            { num: '20', title: 'Hera Syndulla', meta: 'Corellia' },
            { num: '21', title: 'HK-87 Assassin Droid', meta: 'Corellia' },
            { num: '22', title: 'Marrok', meta: 'Corellia' },
            { num: '23', title: 'Qi\'ra', meta: 'Corellia' },
            { num: '24', title: 'Stormtrooper', meta: 'Corellia' },
            { num: '25', title: 'Agent Kallus', meta: 'Lothal' },
            { num: '26', title: 'Darth Vader', meta: 'Lothal' },
            { num: '27', title: 'Ezra Bridger', meta: 'Lothal' },
            { num: '28', title: 'Fifth Brother', meta: 'Lothal' },
            { num: '29', title: 'Garazeb Orrelios', meta: 'Lothal' },
            { num: '30', title: 'Governor Pryce', meta: 'Lothal' },
            { num: '31', title: 'Grand Admiral Thrawn', meta: 'Lothal' },
            { num: '32', title: 'Huyang', meta: 'Lothal' },
            { num: '33', title: 'Kanan Jarrus', meta: 'Lothal' },
            { num: '34', title: 'Loth-cat', meta: 'Lothal' },
            { num: '35', title: 'Loth-wolf', meta: 'Lothal' },
            { num: '36', title: 'Rukh', meta: 'Lothal' },
            { num: '37', title: 'Ryder Azadi', meta: 'Lothal' },
            { num: '38', title: 'Sabine Wren', meta: 'Lothal' },
            { num: '39', title: 'Seventh Sister', meta: 'Lothal' },
            { num: '40', title: 'Shin Hati', meta: 'Lothal' },
            { num: '41', title: 'The Grand Inquisitor', meta: 'Lothal' },
            { num: '42', title: 'Tie Fighter', meta: 'Lothal' },
            { num: '43', title: 'Almec', meta: 'Mandalore' },
            { num: '44', title: 'Amis', meta: 'Mandalore' },
            { num: '45', title: 'Anakin Skywalker', meta: 'Mandalore' },
            { num: '46', title: 'Bo-Katan Kryze', meta: 'Mandalore' },
            { num: '47', title: 'Bo-Katan Kryze\'s Gauntlet starfighter', meta: 'Mandalore' },
            { num: '48', title: 'Duchess Satine Kryze', meta: 'Mandalore' },
            { num: '49', title: 'Imperial Armored Commando', meta: 'Mandalore' },
            { num: '50', title: 'Korkie Kryze', meta: 'Mandalore' },
            { num: '51', title: 'Koska Reeves', meta: 'Mandalore' },
            { num: '52', title: 'Moff Gideon', meta: 'Mandalore' },
            { num: '53', title: 'Paz Vizsla', meta: 'Mandalore' },
            { num: '54', title: 'Pre Vizsla', meta: 'Mandalore' },
            { num: '55', title: 'R5-D4', meta: 'Mandalore' },
            { num: '56', title: 'Soniee', meta: 'Mandalore' },
            { num: '57', title: 'The Armorer', meta: 'Mandalore' },
            { num: '58', title: 'The Coronet', meta: 'Mandalore' },
            { num: '59', title: 'The Mandalorian', meta: 'Mandalore' },
            { num: '60', title: 'Ursa Wren', meta: 'Mandalore' },
            { num: '61', title: 'Anakin Skywalker\'s Podracer', meta: 'Tatooine' },
            { num: '62', title: 'Bib Fortuna', meta: 'Tatooine' },
            { num: '63', title: 'Boba Fett', meta: 'Tatooine' },
            { num: '64', title: 'Boba Fett\'s Starship', meta: 'Tatooine' },
            { num: '65', title: 'C-3PO', meta: 'Tatooine' },
            { num: '66', title: 'Cad Bane', meta: 'Tatooine' },
            { num: '67', title: 'Chef Droid', meta: 'Tatooine' },
            { num: '68', title: 'Cobb Vanth', meta: 'Tatooine' },
            { num: '69', title: 'Darth Maul', meta: 'Tatooine' },
            { num: '70', title: 'Desert Skiff', meta: 'Tatooine' },
            { num: '71', title: 'Fennec Shand', meta: 'Tatooine' },
            { num: '72', title: 'Figrin D\'an', meta: 'Tatooine' },
            { num: '73', title: 'Gamorrean Guard', meta: 'Tatooine' },
            { num: '74', title: 'Garsa Fwip', meta: 'Tatooine' },
            { num: '75', title: 'Grogu', meta: 'Tatooine' },
            { num: '76', title: 'Jabba The Hutt', meta: 'Tatooine' },
            { num: '77', title: 'Jar Jar Binks', meta: 'Tatooine' },
            { num: '78', title: 'Jawa', meta: 'Tatooine' },
            { num: '79', title: 'Krrsantan', meta: 'Tatooine' },
            { num: '80', title: 'Luke Skywalker', meta: 'Tatooine' },
            { num: '81', title: 'Max Rebo', meta: 'Tatooine' },
            { num: '82', title: 'Millennium Falcon', meta: 'Tatooine' },
            { num: '83', title: 'Naboo N-1 Starfighter', meta: 'Tatooine' },
            { num: '84', title: 'Obi-Wan Kenobi', meta: 'Tatooine' },
            { num: '85', title: 'Owen Lars', meta: 'Tatooine' },
            { num: '86', title: 'Padmé Amidala', meta: 'Tatooine' },
            { num: '87', title: 'Peli Motto', meta: 'Tatooine' },
            { num: '88', title: 'Qui-Gon Jinn', meta: 'Tatooine' },
            { num: '89', title: 'R2-D2', meta: 'Tatooine' },
            { num: '90', title: 'Rancor', meta: 'Tatooine' },
            { num: '91', title: 'Rancor Keeper', meta: 'Tatooine' },
            { num: '92', title: 'Razor Crest', meta: 'Tatooine' },
            { num: '93', title: 'Rey Skywalker', meta: 'Tatooine' },
            { num: '94', title: 'Salacious B. Crumb', meta: 'Tatooine' },
            { num: '95', title: 'Sandcrawler', meta: 'Tatooine' },
            { num: '96', title: 'Sebulba', meta: 'Tatooine' },
            { num: '97', title: 'Skad', meta: 'Tatooine' },
            { num: '98', title: 'Tusken Raider', meta: 'Tatooine' },
            { num: '99', title: 'Watto', meta: 'Tatooine' },
            { num: '100', title: 'X-34 Landspeeder', meta: 'Tatooine' },
          ]
        },
        {
          count: 100,
          name: 'BASE PLANETARY VARIATIONS',
          meta: 'Serial /99 photo variations of all 100 base cards',
          odds: '1:33–1:151 packs by planet',
          parallels: 1,
          cards: [
            { num: 'BPV-1', title: 'Ahsoka Tano', meta: 'Alderaan' },
            { num: 'BPV-2', title: 'Alderaan Royal Guard', meta: 'Alderaan' },
            { num: 'BPV-3', title: 'Aurra Sing', meta: 'Alderaan' },
            { num: 'BPV-4', title: 'Bail Organa', meta: 'Alderaan' },
            { num: 'BPV-5', title: 'Breha Organa', meta: 'Alderaan' },
            { num: 'BPV-6', title: 'Captain Typho', meta: 'Alderaan' },
            { num: 'BPV-7', title: 'Celly Organa', meta: 'Alderaan' },
            { num: 'BPV-8', title: 'Kayo Organa', meta: 'Alderaan' },
            { num: 'BPV-9', title: 'L0-LA59', meta: 'Alderaan' },
            { num: 'BPV-10', title: 'Leia Organa', meta: 'Alderaan' },
            { num: 'BPV-11', title: 'Mon Mothma', meta: 'Alderaan' },
            { num: 'BPV-12', title: 'Naboo Royal Cruiser', meta: 'Alderaan' },
            { num: 'BPV-13', title: 'Niano Organa', meta: 'Alderaan' },
            { num: 'BPV-14', title: 'Tantive IV', meta: 'Alderaan' },
            { num: 'BPV-15', title: 'Vect Nokru', meta: 'Alderaan' },
            { num: 'BPV-16', title: 'Ahsoka Tano', meta: 'Corellia' },
            { num: 'BPV-17', title: 'Chopper', meta: 'Corellia' },
            { num: 'BPV-18', title: 'Han Solo', meta: 'Corellia' },
            { num: 'BPV-19', title: 'Han Solo\'s landspeeder', meta: 'Corellia' },
            { num: 'BPV-20', title: 'Hera Syndulla', meta: 'Corellia' },
            { num: 'BPV-21', title: 'HK-87 Assassin Droid', meta: 'Corellia' },
            { num: 'BPV-22', title: 'Marrok', meta: 'Corellia' },
            { num: 'BPV-23', title: 'Qi\'ra', meta: 'Corellia' },
            { num: 'BPV-24', title: 'Stormtrooper', meta: 'Corellia' },
            { num: 'BPV-25', title: 'Agent Kallus', meta: 'Lothal' },
            { num: 'BPV-26', title: 'Darth Vader', meta: 'Lothal' },
            { num: 'BPV-27', title: 'Ezra Bridger', meta: 'Lothal' },
            { num: 'BPV-28', title: 'Fifth Brother', meta: 'Lothal' },
            { num: 'BPV-29', title: 'Garazeb Orrelios', meta: 'Lothal' },
            { num: 'BPV-30', title: 'Governor Pryce', meta: 'Lothal' },
            { num: 'BPV-31', title: 'Grand Admiral Thrawn', meta: 'Lothal' },
            { num: 'BPV-32', title: 'Huyang', meta: 'Lothal' },
            { num: 'BPV-33', title: 'Kanan Jarrus', meta: 'Lothal' },
            { num: 'BPV-34', title: 'Loth-cat', meta: 'Lothal' },
            { num: 'BPV-35', title: 'Loth-wolf', meta: 'Lothal' },
            { num: 'BPV-36', title: 'Rukh', meta: 'Lothal' },
            { num: 'BPV-37', title: 'Ryder Azadi', meta: 'Lothal' },
            { num: 'BPV-38', title: 'Sabine Wren', meta: 'Lothal' },
            { num: 'BPV-39', title: 'Seventh Sister', meta: 'Lothal' },
            { num: 'BPV-40', title: 'Shin Hati', meta: 'Lothal' },
            { num: 'BPV-41', title: 'The Grand Inquisitor', meta: 'Lothal' },
            { num: 'BPV-42', title: 'Tie Fighter', meta: 'Lothal' },
            { num: 'BPV-43', title: 'Almec', meta: 'Mandalore' },
            { num: 'BPV-44', title: 'Amis', meta: 'Mandalore' },
            { num: 'BPV-45', title: 'Anakin Skywalker', meta: 'Mandalore' },
            { num: 'BPV-46', title: 'Bo-Katan Kryze', meta: 'Mandalore' },
            { num: 'BPV-47', title: 'Bo-Katan Kryze\'s Gauntlet starfighter', meta: 'Mandalore' },
            { num: 'BPV-48', title: 'Duchess Satine Kryze', meta: 'Mandalore' },
            { num: 'BPV-49', title: 'Imperial Armored Commando', meta: 'Mandalore' },
            { num: 'BPV-50', title: 'Korkie Kryze', meta: 'Mandalore' },
            { num: 'BPV-51', title: 'Koska Reeves', meta: 'Mandalore' },
            { num: 'BPV-52', title: 'Moff Gideon', meta: 'Mandalore' },
            { num: 'BPV-53', title: 'Paz Vizsla', meta: 'Mandalore' },
            { num: 'BPV-54', title: 'Pre Vizsla', meta: 'Mandalore' },
            { num: 'BPV-55', title: 'R5-D4', meta: 'Mandalore' },
            { num: 'BPV-56', title: 'Soniee', meta: 'Mandalore' },
            { num: 'BPV-57', title: 'The Armorer', meta: 'Mandalore' },
            { num: 'BPV-58', title: 'The Coronet', meta: 'Mandalore' },
            { num: 'BPV-59', title: 'The Mandalorian', meta: 'Mandalore' },
            { num: 'BPV-60', title: 'Ursa Wren', meta: 'Mandalore' },
            { num: 'BPV-61', title: 'Anakin Skywalker\'s Podracer', meta: 'Tatooine' },
            { num: 'BPV-62', title: 'Bib Fortuna', meta: 'Tatooine' },
            { num: 'BPV-63', title: 'Boba Fett', meta: 'Tatooine' },
            { num: 'BPV-64', title: 'Boba Fett\'s Starship', meta: 'Tatooine' },
            { num: 'BPV-65', title: 'C-3PO', meta: 'Tatooine' },
            { num: 'BPV-66', title: 'Cad Bane', meta: 'Tatooine' },
            { num: 'BPV-67', title: 'Chef Droid', meta: 'Tatooine' },
            { num: 'BPV-68', title: 'Cobb Vanth', meta: 'Tatooine' },
            { num: 'BPV-69', title: 'Darth Maul', meta: 'Tatooine' },
            { num: 'BPV-70', title: 'Desert Skiff', meta: 'Tatooine' },
            { num: 'BPV-71', title: 'Fennec Shand', meta: 'Tatooine' },
            { num: 'BPV-72', title: 'Figrin D\'an', meta: 'Tatooine' },
            { num: 'BPV-73', title: 'Gamorrean Guard', meta: 'Tatooine' },
            { num: 'BPV-74', title: 'Garsa Fwip', meta: 'Tatooine' },
            { num: 'BPV-75', title: 'Grogu', meta: 'Tatooine' },
            { num: 'BPV-76', title: 'Jabba The Hutt', meta: 'Tatooine' },
            { num: 'BPV-77', title: 'Jar Jar Binks', meta: 'Tatooine' },
            { num: 'BPV-78', title: 'Jawa', meta: 'Tatooine' },
            { num: 'BPV-79', title: 'Krrsantan', meta: 'Tatooine' },
            { num: 'BPV-80', title: 'Luke Skywalker', meta: 'Tatooine' },
            { num: 'BPV-81', title: 'Max Rebo', meta: 'Tatooine' },
            { num: 'BPV-82', title: 'Millennium Falcon', meta: 'Tatooine' },
            { num: 'BPV-83', title: 'Naboo N-1 Starfighter', meta: 'Tatooine' },
            { num: 'BPV-84', title: 'Obi-Wan Kenobi', meta: 'Tatooine' },
            { num: 'BPV-85', title: 'Owen Lars', meta: 'Tatooine' },
            { num: 'BPV-86', title: 'Padmé Amidala', meta: 'Tatooine' },
            { num: 'BPV-87', title: 'Peli Motto', meta: 'Tatooine' },
            { num: 'BPV-88', title: 'Qui-Gon Jinn', meta: 'Tatooine' },
            { num: 'BPV-89', title: 'R2-D2', meta: 'Tatooine' },
            { num: 'BPV-90', title: 'Rancor', meta: 'Tatooine' },
            { num: 'BPV-91', title: 'Rancor Keeper', meta: 'Tatooine' },
            { num: 'BPV-92', title: 'Razor Crest', meta: 'Tatooine' },
            { num: 'BPV-93', title: 'Rey Skywalker', meta: 'Tatooine' },
            { num: 'BPV-94', title: 'Salacious B. Crumb', meta: 'Tatooine' },
            { num: 'BPV-95', title: 'Sandcrawler', meta: 'Tatooine' },
            { num: 'BPV-96', title: 'Sebulba', meta: 'Tatooine' },
            { num: 'BPV-97', title: 'Skad', meta: 'Tatooine' },
            { num: 'BPV-98', title: 'Tusken Raider', meta: 'Tatooine' },
            { num: 'BPV-99', title: 'Watto', meta: 'Tatooine' },
            { num: 'BPV-100', title: 'X-34 Landspeeder', meta: 'Tatooine' },
          ]
        },
      ],
      insert: [
        {
          count: 10,
          name: 'MOON OF MANDALORE',
          meta: 'The battle for Mandalore',
          odds: '1:8 packs',
          parallels: 7,
          cards: [
            { num: 'MOM-1', title: 'Obi-Wan Kenobi' },
            { num: 'MOM-2', title: 'Duchess Satine Kryze' },
            { num: 'MOM-3', title: 'Pre Vizsla' },
            { num: 'MOM-4', title: 'Mandalorian Guard' },
            { num: 'MOM-5', title: 'Death Watch Warrior' },
            { num: 'MOM-6', title: 'Gauntlet Fighter' },
            { num: 'MOM-7', title: 'Bo-Katan Kryze' },
            { num: 'MOM-8', title: 'Prime Minister Almec' },
            { num: 'MOM-9', title: 'Count Dooku' },
            { num: 'MOM-10', title: 'Obi-Wan\'s Delta-7 Jedi Starfighter' },
          ]
        },
        {
          count: 15,
          name: 'THERE\'S ALWAYS A BIGGER FISH',
          meta: 'Creatures of the five planets, small to colossal',
          odds: '1:4 packs',
          parallels: 7,
          cards: [
            { num: 'BIG-1', title: 'Loth-cat', meta: 'Lothal' },
            { num: 'BIG-2', title: 'Bantha', meta: 'Tatooine' },
            { num: 'BIG-3', title: 'Purrgil', meta: 'Lothal' },
            { num: 'BIG-4', title: 'Sarlacc', meta: 'Tatooine' },
            { num: 'BIG-5', title: 'Krayt Dragon', meta: 'Tatooine' },
            { num: 'BIG-6', title: 'Corellian hound', meta: 'Corellia' },
            { num: 'BIG-7', title: 'Mythosaur', meta: 'Mandalore' },
            { num: 'BIG-8', title: 'Rancor', meta: 'Tatooine' },
            { num: 'BIG-9', title: 'Puffer Pig', meta: 'Lothal' },
            { num: 'BIG-10', title: 'Loth-wolf', meta: 'Lothal' },
            { num: 'BIG-11', title: 'Dewback', meta: 'Tatooine' },
            { num: 'BIG-12', title: 'Alamite', meta: 'Mandalore' },
            { num: 'BIG-13', title: 'Sand Beast', meta: 'Tatooine' },
            { num: 'BIG-14', title: 'B\'omarr monk spider', meta: 'Tatooine' },
            { num: 'BIG-15', title: 'Worrt', meta: 'Tatooine' },
          ]
        },
        {
          count: 25,
          name: 'GALACTIC ERAS',
          meta: 'Pivotal moments in planetary history',
          odds: '1:4 packs',
          parallels: 7,
          cards: [
            { num: 'ERA-1', title: 'Leia Organa Is Kidnapped By Vect Nokru', meta: 'Alderaan' },
            { num: 'ERA-2', title: 'Han Solo Is Rescued', meta: 'Tatooine' },
            { num: 'ERA-3', title: 'A More Civilized Weapon', meta: 'Tatooine' },
            { num: 'ERA-4', title: '"These Aren\'t The Droids You\'re Looking For"', meta: 'Tatooine' },
            { num: 'ERA-5', title: 'The Purrgil Rescue Ezra Bridger', meta: 'Lothal' },
            { num: 'ERA-6', title: 'Bo-Katan Kryze Unites Mandalore', meta: 'Mandalore' },
            { num: 'ERA-7', title: 'Battle Over The Sarlacc Pit', meta: 'Tatooine' },
            { num: 'ERA-8', title: 'Boba Fett Rides His New Rancor', meta: 'Tatooine' },
            { num: 'ERA-9', title: 'The Mandalorian, The Marshal, and The Krayt Dragon', meta: 'Tatooine' },
            { num: 'ERA-10', title: 'Duchess Satine Kryze\'s Demise', meta: 'Mandalore' },
            { num: 'ERA-11', title: 'Ahsoka Duels Maul At The Siege Of Mandalore', meta: 'Mandalore' },
            { num: 'ERA-12', title: 'Ezra Bridger Rides The Loth-wolf', meta: 'Lothal' },
            { num: 'ERA-13', title: 'Sabine Wren Skips Ryder Azadi\'s Speech', meta: 'Lothal' },
            { num: 'ERA-14', title: 'Shin Hati Attacks Sabine Wren', meta: 'Lothal' },
            { num: 'ERA-15', title: 'Ahsoka Tano\'s Apprentice, Again', meta: 'Lothal' },
            { num: 'ERA-16', title: 'Ahsoka vs Marrok', meta: 'Corellia' },
            { num: 'ERA-17', title: 'Han Solo And Qi\'ra, Separated!', meta: 'Corellia' },
            { num: 'ERA-18', title: 'Qui-Gon Jinn vs Darth Maul', meta: 'Tatooine' },
            { num: 'ERA-19', title: 'The Chase For Han Solo', meta: 'Corellia' },
            { num: 'ERA-20', title: 'The Mandalorian vs Moff Gideon', meta: 'Mandalore' },
            { num: 'ERA-21', title: 'Destroyed By The Death Star!', meta: 'Alderaan' },
            { num: 'ERA-22', title: 'Obi-Wan Kenobi vs Maul', meta: 'Tatooine' },
            { num: 'ERA-23', title: 'Anakin Skywalker Wins the Boonta Eve Classic', meta: 'Tatooine' },
            { num: 'ERA-24', title: 'Obi-Wan Kenobi Brings Leia Organa Home', meta: 'Alderaan' },
            { num: 'ERA-25', title: 'The Great Purge of Mandalore', meta: 'Mandalore' },
          ]
        },
        {
          count: 15,
          name: 'ART OF TATOOINE',
          meta: 'Steve Hamilton\'s Tatooine landscapes · 1 per case',
          odds: '1:64 packs',
          parallels: 4,
          cards: [
            { num: 'AOT-1', title: 'Mos Eisley' },
            { num: 'AOT-2', title: 'Ben Kenobi\'s Hut' },
            { num: 'AOT-3', title: 'Dune Sea' },
            { num: 'AOT-4', title: 'Beggar\'s Canyon' },
            { num: 'AOT-5', title: 'Mos Espa' },
            { num: 'AOT-6', title: 'Mos Espa Grand Arena' },
            { num: 'AOT-7', title: 'Tibidon Carving Station' },
            { num: 'AOT-8', title: 'Freetown' },
            { num: 'AOT-9', title: 'The Jundland Wastes' },
            { num: 'AOT-10', title: 'Jabba\'s Palace' },
            { num: 'AOT-11', title: 'The Lars Homestead' },
            { num: 'AOT-12', title: 'Sarlacc Pit' },
            { num: 'AOT-13', title: 'Pyke Base' },
            { num: 'AOT-14', title: 'Garsa\'s Sanctuary' },
            { num: 'AOT-15', title: 'Mos Eisley Cantina' },
          ]
        },
        {
          count: 5,
          name: 'STAR WARS REFLECTIONS',
          meta: 'Christian Waggoner art · continues the numbering from 2025 Chrome',
          odds: '1:1,000 packs',
          parallels: 4,
          cards: [
            { num: 'R-16', title: 'The Empire' },
            { num: 'R-17', title: 'The Armorer\'s Guidance' },
            { num: 'R-18', title: 'Protecting Someone?' },
            { num: 'R-19', title: 'I Thought You Were Dead' },
            { num: 'R-20', title: 'Darth Vader' },
          ]
        },
        {
          count: 5,
          name: 'PLANETARY VIEWS',
          meta: 'Serial /99 · continues the numbering from 2025 Chrome',
          odds: '1:272 packs',
          parallels: 7,
          cards: [
            { num: 'PV-6', title: 'Alderaan' },
            { num: 'PV-7', title: 'Lothal' },
            { num: 'PV-8', title: 'Mandalore' },
            { num: 'PV-9', title: 'Corellia' },
            { num: 'PV-10', title: 'Tatooine' },
          ]
        },
        {
          count: 10,
          name: 'GALACTIC ORIGINS',
          meta: 'Traci Easterday character art',
          odds: '1:900 packs',
          parallels: 3,
          cards: [
            { num: 'GO-1', title: 'Leia Organa', meta: 'Alderaan' },
            { num: 'GO-2', title: 'Han Solo', meta: 'Corellia' },
            { num: 'GO-3', title: 'Ahsoka Tano', meta: 'Corellia' },
            { num: 'GO-4', title: 'Shin Hati', meta: 'Lothal' },
            { num: 'GO-5', title: 'Sabine Wren', meta: 'Lothal' },
            { num: 'GO-6', title: 'The Mandalorian', meta: 'Mandalore' },
            { num: 'GO-7', title: 'Moff Gideon', meta: 'Mandalore' },
            { num: 'GO-8', title: 'Qui-Gon Jinn', meta: 'Tatooine' },
            { num: 'GO-9', title: 'Luke Skywalker', meta: 'Tatooine' },
            { num: 'GO-10', title: 'Boba Fett', meta: 'Tatooine' },
          ]
        },
        {
          count: 20,
          name: 'HYPERSPACE SHADOWBOX',
          meta: 'Layered shadowbox chromium',
          odds: '1:128 packs',
          parallels: 3,
          cards: [
            { num: 'HYP-1', title: 'C-3PO', meta: 'Tatooine' },
            { num: 'HYP-2', title: 'R2-D2', meta: 'Tatooine' },
            { num: 'HYP-3', title: 'Boba Fett', meta: 'Tatooine' },
            { num: 'HYP-4', title: 'Cad Bane', meta: 'Tatooine' },
            { num: 'HYP-5', title: 'Bail Organa', meta: 'Alderaan' },
            { num: 'HYP-6', title: 'Grogu', meta: 'Mandalore' },
            { num: 'HYP-7', title: 'Ahsoka Tano', meta: 'Lothal' },
            { num: 'HYP-8', title: 'Qi\'ra', meta: 'Corellia' },
            { num: 'HYP-9', title: 'Salacious B. Crumb', meta: 'Tatooine' },
            { num: 'HYP-10', title: 'Stormtrooper', meta: 'Corellia' },
            { num: 'HYP-11', title: 'Lady Proxima', meta: 'Corellia' },
            { num: 'HYP-12', title: 'Bo-Katan Kryze', meta: 'Mandalore' },
            { num: 'HYP-13', title: 'Paz Vizsla', meta: 'Mandalore' },
            { num: 'HYP-14', title: 'The Armorer', meta: 'Mandalore' },
            { num: 'HYP-15', title: 'The Mandalorian', meta: 'Tatooine' },
            { num: 'HYP-16', title: 'Breha Organa', meta: 'Alderaan' },
            { num: 'HYP-17', title: 'Leia Organa', meta: 'Alderaan' },
            { num: 'HYP-18', title: 'Huyang', meta: 'Lothal' },
            { num: 'HYP-19', title: 'Luke Skywalker', meta: 'Tatooine' },
            { num: 'HYP-20', title: 'Darth Maul', meta: 'Tatooine' },
          ]
        },
        {
          count: 5,
          name: 'OVERSIZED WIDEVISION CHROME',
          meta: 'Planet-sector box loaders · one per hobby box',
          odds: '1:8 packs',
          noParallels: true,
          cards: [
            { num: 'WIDE-1', title: 'Alderaan Sector' },
            { num: 'WIDE-2', title: 'Lothal Sector' },
            { num: 'WIDE-3', title: 'Mandalore Sector' },
            { num: 'WIDE-4', title: 'Corellian Sector' },
            { num: 'WIDE-5', title: 'Arkanis Sector' },
          ]
        },
      ],
      auto: [
        {
          count: 37,
          name: 'AUTOGRAPH VARIATIONS',
          meta: 'On-card autograph variations of the base design',
          odds: '1:64 packs · 2 per case',
          parallels: 5,
          cards: [
            { num: 'AV-AHM', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'AV-ALD', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'AV-ANT', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'AV-ASH', title: 'Ashley Eckstein', meta: 'Ahsoka Tano' },
            { num: 'AV-BDEE', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'AV-CAM', title: 'Carrie-Anne Moss', meta: 'Jedi Master Indara' },
            { num: 'AV-DAI', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'AV-DAW', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'AV-EDG', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'AV-EMC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'AV-EMG', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'AV-EMS', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'AV-FOR', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'AV-GIA', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'AV-HAM', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'AV-HC', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'AV-IVA', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'AV-JEN', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'AV-KAT', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'AV-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'AV-KYK', title: 'Kyriana Kratter', meta: 'KB' },
            { num: 'AV-LAW', title: 'Jude Law', meta: 'Jod Na Nawood' },
            { num: 'AV-LIU', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'AV-LJJ', title: 'Lee Jung-jae', meta: 'Jedi Master Sol' },
            { num: 'AV-MEW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'AV-MIN', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'AV-MOS', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'AV-NAT', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'AV-OLY', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'AV-OSJ', title: 'O\'Shea Jackson Jr.', meta: 'Kawlan Roken' },
            { num: 'AV-PAS', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'AV-RAY', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'AV-RTS', title: 'Robert Timothy Smith', meta: 'Neel' },
            { num: 'AV-TEM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'AV-THU', title: 'Thundercat', meta: 'The Modifier' },
            { num: 'AV-WAI', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'AV-WIT', title: 'Sam Witwer', meta: 'Maul' },
          ]
        },
      ],
      sketch: [
        {
          count: 144,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches · Silver, Purple, Gold, Blue & Black Foil versions',
          odds: '3 per case',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: '1', title: 'Sketch Card', meta: 'Aleksandr Gigov' },
            { num: '2', title: 'Sketch Card', meta: 'Allen Geneta' },
            { num: '3', title: 'Sketch Card', meta: 'Andrew Fry' },
            { num: '4', title: 'Sketch Card', meta: 'Angel Aviles' },
            { num: '5', title: 'Sketch Card', meta: 'Angelina Benedetti' },
            { num: '6', title: 'Sketch Card', meta: 'Ash Gonzales' },
            { num: '7', title: 'Sketch Card', meta: 'Basak Kahraman' },
            { num: '8', title: 'Sketch Card', meta: 'Ben AbuSaada' },
            { num: '9', title: 'Sketch Card', meta: 'Bistek Javier' },
            { num: '10', title: 'Sketch Card', meta: 'Bobby Blakey' },
            { num: '11', title: 'Sketch Card', meta: 'Brandon Klein' },
            { num: '12', title: 'Sketch Card', meta: 'Candice Clemmons' },
            { num: '13', title: 'Sketch Card', meta: 'Charlie Cody' },
            { num: '14', title: 'Sketch Card', meta: 'Chenduz' },
            { num: '15', title: 'Sketch Card', meta: 'Court' },
            { num: '16', title: 'Sketch Card', meta: 'Cyrus Sherkat' },
            { num: '17', title: 'Sketch Card', meta: 'Dan Bergren' },
            { num: '18', title: 'Sketch Card', meta: 'Dan Cooney' },
            { num: '19', title: 'Sketch Card', meta: 'Dan Curto' },
            { num: '20', title: 'Sketch Card', meta: 'Dan Lawler' },
            { num: '21', title: 'Sketch Card', meta: 'Daniel M Chavez' },
            { num: '22', title: 'Sketch Card', meta: 'Daniel Riveron' },
            { num: '23', title: 'Sketch Card', meta: 'Darrin Pepe' },
            { num: '24', title: 'Sketch Card', meta: 'David Willingham' },
            { num: '25', title: 'Sketch Card', meta: 'Dawn Murphy' },
            { num: '26', title: 'Sketch Card', meta: 'Dove McHargue' },
            { num: '27', title: 'Sketch Card', meta: 'Dwayne Carpenter' },
            { num: '28', title: 'Sketch Card', meta: 'DYJ' },
            { num: '29', title: 'Sketch Card', meta: 'Dylan Riley' },
            { num: '30', title: 'Sketch Card', meta: 'El Smetchö' },
            { num: '31', title: 'Sketch Card', meta: 'Elson Jr. Art' },
            { num: '32', title: 'Sketch Card', meta: 'Elvin A Hernandez' },
            { num: '33', title: 'Sketch Card', meta: 'Emrah Cildir' },
            { num: '34', title: 'Sketch Card', meta: 'Emre Varlibas' },
            { num: '35', title: 'Sketch Card', meta: 'Eric Lehtonen' },
            { num: '36', title: 'Sketch Card', meta: 'Erik Muller' },
            { num: '37', title: 'Sketch Card', meta: 'Evgheni "REBL" Batu' },
            { num: '38', title: 'Sketch Card', meta: 'Frank A. Kadar' },
            { num: '39', title: 'Sketch Card', meta: 'Frank Sansone' },
            { num: '40', title: 'Sketch Card', meta: 'Franklim Teixeira' },
            { num: '41', title: 'Sketch Card', meta: 'Gabe Rogue' },
            { num: '42', title: 'Sketch Card', meta: 'Garrett Dix' },
            { num: '43', title: 'Sketch Card', meta: 'Gary Shipman' },
            { num: '44', title: 'Sketch Card', meta: 'Gerry Garcia Jr' },
            { num: '45', title: 'Sketch Card', meta: 'Getatom' },
            { num: '46', title: 'Sketch Card', meta: 'Greg Treize' },
            { num: '47', title: 'Sketch Card', meta: 'Guilherme Rocha' },
            { num: '48', title: 'Sketch Card', meta: 'Ian McKesson' },
            { num: '49', title: 'Sketch Card', meta: 'Ian Yoshio Roberts' },
            { num: '50', title: 'Sketch Card', meta: 'Ink Nerd' },
            { num: '51', title: 'Sketch Card', meta: 'Isiah Xavier Bradley' },
            { num: '52', title: 'Sketch Card', meta: 'Jackson "JackArts" Ong' },
            { num: '53', title: 'Sketch Card', meta: 'Jaime Lopez' },
            { num: '54', title: 'Sketch Card', meta: 'Jake Minor' },
            { num: '55', title: 'Sketch Card', meta: 'James Boyd' },
            { num: '56', title: 'Sketch Card', meta: 'James Harris' },
            { num: '57', title: 'Sketch Card', meta: 'Jane Rushton' },
            { num: '58', title: 'Sketch Card', meta: 'Jason Christner' },
            { num: '59', title: 'Sketch Card', meta: 'Jason Davies' },
            { num: '60', title: 'Sketch Card', meta: 'Jason Pearce' },
            { num: '61', title: 'Sketch Card', meta: 'Jason Queen' },
            { num: '62', title: 'Sketch Card', meta: 'Jason Sobol' },
            { num: '63', title: 'Sketch Card', meta: 'Jay Manchand' },
            { num: '64', title: 'Sketch Card', meta: 'Jeffrey C. Benitez' },
            { num: '65', title: 'Sketch Card', meta: 'Jenny Kim' },
            { num: '66', title: 'Sketch Card', meta: 'Jessica Hickman' },
            { num: '67', title: 'Sketch Card', meta: 'Jessica Van Dusen' },
            { num: '68', title: 'Sketch Card', meta: 'Jiaxin "YinShan" Sun' },
            { num: '69', title: 'Sketch Card', meta: 'Jim O\'Riley' },
            { num: '70', title: 'Sketch Card', meta: 'John "JAR" Rodriguez' },
            { num: '71', title: 'Sketch Card', meta: 'John Boren' },
            { num: '72', title: 'Sketch Card', meta: 'John Still' },
            { num: '73', title: 'Sketch Card', meta: 'Jojo Hilario' },
            { num: '74', title: 'Sketch Card', meta: 'Jonathan Beistline' },
            { num: '75', title: 'Sketch Card', meta: 'Josh Trout' },
            { num: '76', title: 'Sketch Card', meta: 'Julia McKenzie' },
            { num: '77', title: 'Sketch Card', meta: 'K Bass' },
            { num: '78', title: 'Sketch Card', meta: 'Kang Jing' },
            { num: '79', title: 'Sketch Card', meta: 'Karl Jones' },
            { num: '80', title: 'Sketch Card', meta: 'Kevin Cleveland' },
            { num: '81', title: 'Sketch Card', meta: 'Kevin Scott Jacobs' },
            { num: '82', title: 'Sketch Card', meta: 'Khloe Delnick' },
            { num: '83', title: 'Sketch Card', meta: 'Khushi Mahajan' },
            { num: '84', title: 'Sketch Card', meta: 'Kirk Chavarria' },
            { num: '85', title: 'Sketch Card', meta: 'Kris Penix' },
            { num: '86', title: 'Sketch Card', meta: 'Kyle Babbitt' },
            { num: '87', title: 'Sketch Card', meta: 'Laura Inglis' },
            { num: '88', title: 'Sketch Card', meta: 'Lee Lightfoot' },
            { num: '89', title: 'Sketch Card', meta: 'Lily Zapata Mercado' },
            { num: '90', title: 'Sketch Card', meta: 'Limuel Pinzon' },
            { num: '91', title: 'Sketch Card', meta: 'Lindsey Greyling' },
            { num: '92', title: 'Sketch Card', meta: 'Loc Nguyen' },
            { num: '93', title: 'Sketch Card', meta: 'Lowell Isaac' },
            { num: '94', title: 'Sketch Card', meta: 'Luke Rushton LR' },
            { num: '95', title: 'Sketch Card', meta: 'Marcia Dye' },
            { num: '96', title: 'Sketch Card', meta: 'Marlo Martos' },
            { num: '97', title: 'Sketch Card', meta: 'Matt Steffens' },
            { num: '98', title: 'Sketch Card', meta: 'Matthew Maldonado' },
            { num: '99', title: 'Sketch Card', meta: 'Matthew Skillern' },
            { num: '100', title: 'Sketch Card', meta: 'Michael Mastermaker' },
            { num: '101', title: 'Sketch Card', meta: 'Mike Dalzell' },
            { num: '102', title: 'Sketch Card', meta: 'Mike Davidson' },
            { num: '103', title: 'Sketch Card', meta: 'Mike J Sealie' },
            { num: '104', title: 'Sketch Card', meta: 'Neil Camera' },
            { num: '105', title: 'Sketch Card', meta: 'Nick Gribbon' },
            { num: '106', title: 'Sketch Card', meta: 'Niño John Benitez' },
            { num: '107', title: 'Sketch Card', meta: 'Oscar Chavez' },
            { num: '108', title: 'Sketch Card', meta: 'Patricio Carrasco' },
            { num: '109', title: 'Sketch Card', meta: 'Phillip Trujillo' },
            { num: '110', title: 'Sketch Card', meta: 'Quinton Baker' },
            { num: '111', title: 'Sketch Card', meta: 'Rachel Jane Art' },
            { num: '112', title: 'Sketch Card', meta: 'Rees Chua-Finlay' },
            { num: '113', title: 'Sketch Card', meta: 'Rich Hennemann' },
            { num: '114', title: 'Sketch Card', meta: 'Rico Dela Rosa' },
            { num: '115', title: 'Sketch Card', meta: 'Robert Hendrickson' },
            { num: '116', title: 'Sketch Card', meta: 'Rugved Bhuskute' },
            { num: '117', title: 'Sketch Card', meta: 'Rustico Limosinero' },
            { num: '118', title: 'Sketch Card', meta: 'Rusty!' },
            { num: '119', title: 'Sketch Card', meta: 'Rutvig Vaid' },
            { num: '120', title: 'Sketch Card', meta: 'Ryan Finley' },
            { num: '121', title: 'Sketch Card', meta: 'Ryan Johnston' },
            { num: '122', title: 'Sketch Card', meta: 'Ryan Olsen' },
            { num: '123', title: 'Sketch Card', meta: 'Ryan Thompson' },
            { num: '124', title: 'Sketch Card', meta: 'Scott Zambelli' },
            { num: '125', title: 'Sketch Card', meta: 'Scribbling Joe' },
            { num: '126', title: 'Sketch Card', meta: 'Semra Bulut' },
            { num: '127', title: 'Sketch Card', meta: 'Shaow Siong' },
            { num: '128', title: 'Sketch Card', meta: 'Sir Edmund Duke' },
            { num: '129', title: 'Sketch Card', meta: 'Snorpixel' },
            { num: '130', title: 'Sketch Card', meta: 'Stephane Leonardi' },
            { num: '131', title: 'Sketch Card', meta: 'Steve Alce' },
            { num: '132', title: 'Sketch Card', meta: 'Tim Shinn' },
            { num: '133', title: 'Sketch Card', meta: 'Tom Amici' },
            { num: '134', title: 'Sketch Card', meta: 'TOMA' },
            { num: '135', title: 'Sketch Card', meta: 'Tomoko Taniguchi' },
            { num: '136', title: 'Sketch Card', meta: 'Tony Riley' },
            { num: '137', title: 'Sketch Card', meta: 'Trent Westbrook' },
            { num: '138', title: 'Sketch Card', meta: 'Veronica Louro' },
            { num: '139', title: 'Sketch Card', meta: 'Vini Pirani' },
            { num: '140', title: 'Sketch Card', meta: 'Ward Silverman' },
            { num: '141', title: 'Sketch Card', meta: 'Will Pleydon' },
            { num: '142', title: 'Sketch Card', meta: 'Yves Van Berlo' },
            { num: '143', title: 'Sketch Card', meta: 'Zach Woolsey' },
            { num: '144', title: 'Sketch Card', meta: 'ジェイソン (Jason)' },
          ]
        },
        {
          count: 18,
          name: 'OVERSIZED PANORAMIC SKETCH CARDS',
          meta: 'Oversized one-of-one planet panoramas',
          odds: '1:2,990 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: '1', title: 'Panoramic Sketch Card', meta: 'Ash Gonzales' },
            { num: '2', title: 'Panoramic Sketch Card', meta: 'Charlie Cody' },
            { num: '3', title: 'Panoramic Sketch Card', meta: 'Cyrus Sherkat' },
            { num: '4', title: 'Panoramic Sketch Card', meta: 'Dan Bergren' },
            { num: '5', title: 'Panoramic Sketch Card', meta: 'Daniel Chavez' },
            { num: '6', title: 'Panoramic Sketch Card', meta: 'Dawn Murphy' },
            { num: '7', title: 'Panoramic Sketch Card', meta: 'Eric Lehtonen' },
            { num: '8', title: 'Panoramic Sketch Card', meta: 'Jason Davies' },
            { num: '9', title: 'Panoramic Sketch Card', meta: 'Jay Manchand' },
            { num: '10', title: 'Panoramic Sketch Card', meta: 'Lindsey Greyling' },
            { num: '11', title: 'Panoramic Sketch Card', meta: 'Marcia Dye' },
            { num: '12', title: 'Panoramic Sketch Card', meta: 'Marlo Martos' },
            { num: '13', title: 'Panoramic Sketch Card', meta: 'Michael Mastermaker' },
            { num: '14', title: 'Panoramic Sketch Card', meta: 'Nick Gribbon' },
            { num: '15', title: 'Panoramic Sketch Card', meta: 'Rich Hennemann' },
            { num: '16', title: 'Panoramic Sketch Card', meta: 'Semra Bulut' },
            { num: '17', title: 'Panoramic Sketch Card', meta: 'Steve Alce' },
            { num: '18', title: 'Panoramic Sketch Card', meta: 'Yves Van Berlo' },
          ]
        },
      ],
    },
  },


  '2024-hyperspace': {
    setId: '2024-hyperspace',
    year: '2024',
    brand: 'TOPPS',
    title: 'STAR WARS HYPERSPACE',
    releaseDate: '2 / 19 / 2025',
    lede: 'The voyage that launched the Hyperspace line charts five planets — Naboo, Kashyyyk, Hoth, Bespin and Mustafar — on all-Chrome stock: a 100-card base set with a full serial /99 Planetary Variations mirror, an 11-deep parallel rainbow running Refractor to Superfractor through twin Aqua /199s, seven insert lines from one-per-case Jump to Hyperspace starships to 1:1,000 Reflections, a 46-signer on-card autograph program headlined by Mark Hamill, Harrison Ford and Natalie Portman, and a 105-artist sketch program in five foil finishes.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Five planets, all Chrome', color: 'gold' },
      { num: '7', label: 'Insert Sets', sub: '5 to 25 cards each', color: 'cyan' },
      { num: '46', label: 'Auto Cards', sub: 'On-card variations', color: 'green' },
      { num: '11', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '10', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '8', l: 'Packs per box' },
      { v: '10', l: 'Cards per pack' },
      { v: '12', l: 'Boxes per case' },
      { v: '4', l: 'Numbered parallels / box' },
      { v: '2', l: 'Autographs per case' },
    ],
    pullRates: [
      { name: 'There’s Always a Bigger Fish', odds: '1 : 4', tier: 'normal' },
      { name: 'Galactic Eras', odds: '1 : 4', tier: 'normal' },
      { name: 'First Arrival', odds: '1 : 48', tier: 'rare' },
      { name: 'Autograph Variations', odds: '1 : 48', tier: 'rare' },
      { name: 'Jump to Hyperspace', odds: '1 : 96', tier: 'rare' },
      { name: 'Planetary Views', odds: '1 : 349', tier: 'rare' },
      { name: 'Galactic Origins', odds: '1 : 900', tier: 'mythic' },
      { name: 'Reflections', odds: '1 : 1,000', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'NEBULAE', pr: '∞', gradient: 'linear-gradient(135deg, #c9b6ff 0%, #7a5cd0 45%, #b88ce8 75%, #e8ddff 100%)', darkText: true },
      { name: 'AQUA', pr: '/199', gradient: 'linear-gradient(135deg, #7fe8f0 0%, #109cb0 55%, #b8f8ff 100%)', darkText: true },
      { name: 'AQUA SONAR', pr: '/199', gradient: 'linear-gradient(135deg, #40e8e0 0%, #00a0a0 60%, #80fff0 100%)', darkText: true },
      { name: 'PULSAR', pr: '/99', gradient: 'radial-gradient(circle at 50% 50%, #80b0ff 0%, #2050d0 70%)' },
      { name: 'GALACTIC DUST', pr: '/75', gradient: 'linear-gradient(135deg, #d4a855 0%, #9a7530 60%, #e8c880 100%)', darkText: true },
      { name: 'GOLD GALACTIC DUST', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'HYPERLANES', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'BLACK HYPERLANES', pr: '/10', gradient: 'linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)' },
      { name: 'RED HYPERLANES', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Five planets: Naboo · Kashyyyk · Hoth · Bespin · Mustafar',
          parallels: 11,
          cards: [
            { num: '1', title: 'Padmé Amidala', meta: 'Naboo' },
            { num: '2', title: 'Chief Tarfful', meta: 'Kashyyyk' },
            { num: '3', title: 'Opee Sea Killer', meta: 'Naboo' },
            { num: '4', title: 'HMP Droid Gunship', meta: 'Kashyyyk' },
            { num: '5', title: 'Republic Attack Gunship', meta: 'Kashyyyk' },
            { num: '6', title: 'Eirtaé', meta: 'Naboo' },
            { num: '7', title: 'Cloud Car', meta: 'Bespin' },
            { num: '8', title: 'Mylaya', meta: 'Kashyyyk' },
            { num: '9', title: 'Rep Teers', meta: 'Naboo' },
            { num: '10', title: 'Captain Panaka', meta: 'Naboo' },
            { num: '11', title: 'Theta-Class T-2c Shuttle', meta: 'Mustafar' },
            { num: '12', title: 'ISP Speeder', meta: 'Kashyyyk' },
            { num: '13', title: 'Queen Apailana', meta: 'Naboo' },
            { num: '14', title: 'Gungi', meta: 'Kashyyyk' },
            { num: '15', title: 'Wampa', meta: 'Hoth' },
            { num: '16', title: 'General Tarpals', meta: 'Naboo' },
            { num: '17', title: 'Naboo Royal Guard', meta: 'Naboo' },
            { num: '18', title: 'Northern Mustafarian', meta: 'Mustafar' },
            { num: '19', title: 'Wookiee Catamaran', meta: 'Kashyyyk' },
            { num: '20', title: 'Jar Jar Binks', meta: 'Naboo' },
            { num: '21', title: 'Corporate Alliance Tank Droid', meta: 'Kashyyyk' },
            { num: '22', title: 'R2-D2', meta: 'Hoth' },
            { num: '23', title: 'Droideka', meta: 'Naboo' },
            { num: '24', title: 'Captain Typho', meta: 'Naboo' },
            { num: '25', title: 'Krrsantan', meta: 'Kashyyyk' },
            { num: '26', title: 'X-Wings', meta: 'Hoth' },
            { num: '27', title: 'Dormé', meta: 'Naboo' },
            { num: '28', title: 'K-3PO', meta: 'Hoth' },
            { num: '29', title: 'STAP', meta: 'Naboo' },
            { num: '30', title: 'Queen Jamillia', meta: 'Naboo' },
            { num: '31', title: 'Snowspeeder', meta: 'Hoth' },
            { num: '32', title: 'Trade Federation Battleship', meta: 'Naboo' },
            { num: '33', title: 'Wookiee Gunship', meta: 'Kashyyyk' },
            { num: '34', title: 'Boss Nass', meta: 'Naboo' },
            { num: '35', title: 'Hoth Rebel Trooper', meta: 'Hoth' },
            { num: '36', title: 'Droid Starfighters', meta: 'Naboo' },
            { num: '37', title: 'Kybuck', meta: 'Kashyyyk' },
            { num: '38', title: 'Southern Mustafarian', meta: 'Mustafar' },
            { num: '39', title: 'Can-Cell', meta: 'Kashyyyk' },
            { num: '40', title: 'Sio Bibble', meta: 'Naboo' },
            { num: '41', title: 'Kaadu', meta: 'Naboo' },
            { num: '42', title: 'Millennium Falcon', meta: 'Hoth' },
            { num: '43', title: 'Alazmec', meta: 'Mustafar' },
            { num: '44', title: 'Naboo star skiff', meta: 'Mustafar' },
            { num: '45', title: 'Lobot', meta: 'Bespin' },
            { num: '46', title: 'Republic Frigate', meta: 'Naboo' },
            { num: '47', title: 'Mustafar Panning Droid', meta: 'Mustafar' },
            { num: '48', title: 'Multi-Troop Transport', meta: 'Naboo' },
            { num: '49', title: 'Rish Loo', meta: 'Naboo' },
            { num: '50', title: 'Darth Vader', meta: 'Mustafar' },
            { num: '51', title: 'Boss Lyonie', meta: 'Naboo' },
            { num: '52', title: 'Falumpaset', meta: 'Naboo' },
            { num: '53', title: 'Tauntauns', meta: 'Hoth' },
            { num: '54', title: 'Security S-5 blaster', meta: 'Kashyyyk' },
            { num: '55', title: 'Battle Droid', meta: 'Naboo' },
            { num: '56', title: 'Ugnaught', meta: 'Hoth' },
            { num: '57', title: 'Obi-Wan Kenobi', meta: 'Mustafar' },
            { num: '58', title: 'Gungan Bongo Submarine', meta: 'Naboo' },
            { num: '59', title: 'Han Solo', meta: 'Bespin' },
            { num: '60', title: 'AT-AT', meta: 'Hoth' },
            { num: '61', title: 'Roggwart', meta: 'Mustafar' },
            { num: '62', title: 'Wookiee Long-Gun', meta: 'Kashyyyk' },
            { num: '63', title: 'Kylo Ren', meta: 'Mustafar' },
            { num: '64', title: '2-1B', meta: 'Hoth' },
            { num: '65', title: 'Trandoshan', meta: 'Kashyyyk' },
            { num: '66', title: 'Gondola Speeder', meta: 'Naboo' },
            { num: '67', title: 'Sando Aqua Monster', meta: 'Naboo' },
            { num: '68', title: 'Boba Fett\'s Starship', meta: 'Bespin' },
            { num: '69', title: 'Helder Spinoza', meta: 'Bespin' },
            { num: '70', title: 'Senator Palpatine', meta: 'Naboo' },
            { num: '71', title: 'Nute Gunray', meta: 'Naboo' },
            { num: '72', title: 'Imperial Probe Droid', meta: 'Hoth' },
            { num: '73', title: 'Fambaas', meta: 'Naboo' },
            { num: '74', title: 'C-3PO', meta: 'Hoth' },
            { num: '75', title: 'Lando Calrissian', meta: 'Bespin' },
            { num: '76', title: 'AT-AT Driver', meta: 'Hoth' },
            { num: '77', title: 'Nuna', meta: 'Naboo' },
            { num: '78', title: 'Naboo Starfighter', meta: 'Naboo' },
            { num: '79', title: 'Mustafar Lava Flea', meta: 'Mustafar' },
            { num: '80', title: 'Ric Olié', meta: 'Naboo' },
            { num: '81', title: 'Booma', meta: 'Naboo' },
            { num: '82', title: 'Jedi Interceptor', meta: 'Mustafar' },
            { num: '83', title: 'Luke Skywalker', meta: 'Hoth' },
            { num: '84', title: 'Naboo Royal Starship', meta: 'Naboo' },
            { num: '85', title: 'San Hill', meta: 'Mustafar' },
            { num: '86', title: 'Maximilian Veers', meta: 'Hoth' },
            { num: '87', title: 'Colo Claw Fish', meta: 'Naboo' },
            { num: '88', title: 'Anti-Infantry Turret', meta: 'Hoth' },
            { num: '89', title: 'Pedar Solardo', meta: 'Bespin' },
            { num: '90', title: 'Sabé', meta: 'Naboo' },
            { num: '91', title: 'Leia Organa', meta: 'Hoth' },
            { num: '92', title: 'C-9979 Landing Ships', meta: 'Naboo' },
            { num: '93', title: 'Planetary Ion Cannon', meta: 'Hoth' },
            { num: '94', title: 'Wedge Antilles', meta: 'Hoth' },
            { num: '95', title: 'Chewbacca', meta: 'Kashyyyk' },
            { num: '96', title: 'AAT Battle Tank', meta: 'Naboo' },
            { num: '97', title: 'Boba Fett', meta: 'Bespin' },
            { num: '98', title: 'Rune Haako', meta: 'Naboo' },
            { num: '99', title: 'Yoda', meta: 'Kashyyyk' },
            { num: '100', title: 'Darth Sidious', meta: 'Mustafar' },
          ],
        },
        {
          count: 100,
          name: 'BASE PLANETARY VARIATIONS',
          meta: 'Serial /99 photo variations of all 100 base cards',
          odds: '1:43–1:218 packs by planet',
          parallels: 1,
          cards: [
            { num: 'BPV-1', title: 'Padmé Amidala', meta: 'Naboo' },
            { num: 'BPV-2', title: 'Chief Tarfful', meta: 'Kashyyyk' },
            { num: 'BPV-3', title: 'Opee Sea Killer', meta: 'Naboo' },
            { num: 'BPV-4', title: 'HMP Droid Gunship', meta: 'Kashyyyk' },
            { num: 'BPV-5', title: 'Republic Attack Gunship', meta: 'Kashyyyk' },
            { num: 'BPV-6', title: 'Eirtaé', meta: 'Naboo' },
            { num: 'BPV-7', title: 'Cloud Car', meta: 'Bespin' },
            { num: 'BPV-8', title: 'Mylaya', meta: 'Kashyyyk' },
            { num: 'BPV-9', title: 'Rep Teers', meta: 'Naboo' },
            { num: 'BPV-10', title: 'Captain Panaka', meta: 'Naboo' },
            { num: 'BPV-11', title: 'Theta-Class T-2c Shuttle', meta: 'Mustafar' },
            { num: 'BPV-12', title: 'ISP Speeder', meta: 'Kashyyyk' },
            { num: 'BPV-13', title: 'Queen Apailana', meta: 'Naboo' },
            { num: 'BPV-14', title: 'Gungi', meta: 'Kashyyyk' },
            { num: 'BPV-15', title: 'Wampa', meta: 'Hoth' },
            { num: 'BPV-16', title: 'General Tarpals', meta: 'Naboo' },
            { num: 'BPV-17', title: 'Naboo Royal Guard', meta: 'Naboo' },
            { num: 'BPV-18', title: 'Northern Mustafarian', meta: 'Mustafar' },
            { num: 'BPV-19', title: 'Wookiee Catamaran', meta: 'Kashyyyk' },
            { num: 'BPV-20', title: 'Jar Jar Binks', meta: 'Naboo' },
            { num: 'BPV-21', title: 'Corporate Alliance Tank Droid', meta: 'Kashyyyk' },
            { num: 'BPV-22', title: 'R2-D2', meta: 'Hoth' },
            { num: 'BPV-23', title: 'Droideka', meta: 'Naboo' },
            { num: 'BPV-24', title: 'Captain Typho', meta: 'Naboo' },
            { num: 'BPV-25', title: 'Krrsantan', meta: 'Kashyyyk' },
            { num: 'BPV-26', title: 'X-Wings', meta: 'Hoth' },
            { num: 'BPV-27', title: 'Dormé', meta: 'Naboo' },
            { num: 'BPV-28', title: 'K-3PO', meta: 'Hoth' },
            { num: 'BPV-29', title: 'STAP', meta: 'Naboo' },
            { num: 'BPV-30', title: 'Queen Jamillia', meta: 'Naboo' },
            { num: 'BPV-31', title: 'Snowspeeder', meta: 'Hoth' },
            { num: 'BPV-32', title: 'Trade Federation Battleship', meta: 'Naboo' },
            { num: 'BPV-33', title: 'Wookiee Gunship', meta: 'Kashyyyk' },
            { num: 'BPV-34', title: 'Boss Nass', meta: 'Naboo' },
            { num: 'BPV-35', title: 'Hoth Rebel Trooper', meta: 'Hoth' },
            { num: 'BPV-36', title: 'Droid Starfighters', meta: 'Naboo' },
            { num: 'BPV-37', title: 'Kybuck', meta: 'Kashyyyk' },
            { num: 'BPV-38', title: 'Southern Mustafarian', meta: 'Mustafar' },
            { num: 'BPV-39', title: 'Can-Cell', meta: 'Kashyyyk' },
            { num: 'BPV-40', title: 'Sio Bibble', meta: 'Naboo' },
            { num: 'BPV-41', title: 'Kaadu', meta: 'Naboo' },
            { num: 'BPV-42', title: 'Millennium Falcon', meta: 'Hoth' },
            { num: 'BPV-43', title: 'Alazmec', meta: 'Mustafar' },
            { num: 'BPV-44', title: 'Naboo star skiff', meta: 'Mustafar' },
            { num: 'BPV-45', title: 'Lobot', meta: 'Bespin' },
            { num: 'BPV-46', title: 'Republic Frigate', meta: 'Naboo' },
            { num: 'BPV-47', title: 'Mustafar Panning Droid', meta: 'Mustafar' },
            { num: 'BPV-48', title: 'Multi-Troop Transport', meta: 'Naboo' },
            { num: 'BPV-49', title: 'Rish Loo', meta: 'Naboo' },
            { num: 'BPV-50', title: 'Darth Vader', meta: 'Mustafar' },
            { num: 'BPV-51', title: 'Boss Lyonie', meta: 'Naboo' },
            { num: 'BPV-52', title: 'Falumpaset', meta: 'Naboo' },
            { num: 'BPV-53', title: 'Tauntauns', meta: 'Hoth' },
            { num: 'BPV-54', title: 'Security S-5 blaster', meta: 'Naboo' },
            { num: 'BPV-55', title: 'Battle Droid', meta: 'Naboo' },
            { num: 'BPV-56', title: 'Ugnaught', meta: 'Bespin' },
            { num: 'BPV-57', title: 'Obi-Wan Kenobi', meta: 'Mustafar' },
            { num: 'BPV-58', title: 'Gungan Bongo Submarine', meta: 'Naboo' },
            { num: 'BPV-59', title: 'Han Solo', meta: 'Bespin' },
            { num: 'BPV-60', title: 'AT-AT', meta: 'Hoth' },
            { num: 'BPV-61', title: 'Roggwart', meta: 'Mustafar' },
            { num: 'BPV-62', title: 'Wookiee Long-Gun', meta: 'Kashyyyk' },
            { num: 'BPV-63', title: 'Kylo Ren', meta: 'Mustafar' },
            { num: 'BPV-64', title: '2-1B', meta: 'Hoth' },
            { num: 'BPV-65', title: 'Trandoshan', meta: 'Kashyyyk' },
            { num: 'BPV-66', title: 'Gondola Speeder', meta: 'Naboo' },
            { num: 'BPV-67', title: 'Sando Aqua Monster', meta: 'Naboo' },
            { num: 'BPV-68', title: 'Boba Fett\'s Starship', meta: 'Bespin' },
            { num: 'BPV-69', title: 'Helder Spinoza', meta: 'Bespin' },
            { num: 'BPV-70', title: 'Senator Palpatine', meta: 'Naboo' },
            { num: 'BPV-71', title: 'Nute Gunray', meta: 'Naboo' },
            { num: 'BPV-72', title: 'Imperial Probe Droid', meta: 'Hoth' },
            { num: 'BPV-73', title: 'Fambaas', meta: 'Naboo' },
            { num: 'BPV-74', title: 'C-3PO', meta: 'Hoth' },
            { num: 'BPV-75', title: 'Lando Calrissian', meta: 'Bespin' },
            { num: 'BPV-76', title: 'AT-AT Driver', meta: 'Hoth' },
            { num: 'BPV-77', title: 'Nuna', meta: 'Naboo' },
            { num: 'BPV-78', title: 'Naboo Starfighter', meta: 'Naboo' },
            { num: 'BPV-79', title: 'Mustafar Lava Flea', meta: 'Mustafar' },
            { num: 'BPV-80', title: 'Ric Olié', meta: 'Naboo' },
            { num: 'BPV-81', title: 'Booma', meta: 'Naboo' },
            { num: 'BPV-82', title: 'Jedi Interceptor', meta: 'Mustafar' },
            { num: 'BPV-83', title: 'Luke Skywalker', meta: 'Hoth' },
            { num: 'BPV-84', title: 'Naboo Royal Starship', meta: 'Naboo' },
            { num: 'BPV-85', title: 'San Hill', meta: 'Mustafar' },
            { num: 'BPV-86', title: 'Maximilian Veers', meta: 'Hoth' },
            { num: 'BPV-87', title: 'Colo Claw Fish', meta: 'Naboo' },
            { num: 'BPV-88', title: 'Anti-Infantry Turret', meta: 'Hoth' },
            { num: 'BPV-89', title: 'Pedar Solardo', meta: 'Bespin' },
            { num: 'BPV-90', title: 'Sabé', meta: 'Naboo' },
            { num: 'BPV-91', title: 'Leia Organa', meta: 'Hoth' },
            { num: 'BPV-92', title: 'C-9979 Landing Ships', meta: 'Naboo' },
            { num: 'BPV-93', title: 'Planetary Ion Cannon', meta: 'Hoth' },
            { num: 'BPV-94', title: 'Wedge Antilles', meta: 'Hoth' },
            { num: 'BPV-95', title: 'Chewbacca', meta: 'Kashyyyk' },
            { num: 'BPV-96', title: 'AAT Battle Tank', meta: 'Naboo' },
            { num: 'BPV-97', title: 'Boba Fett', meta: 'Bespin' },
            { num: 'BPV-98', title: 'Rune Haako', meta: 'Naboo' },
            { num: 'BPV-99', title: 'Yoda', meta: 'Kashyyyk' },
            { num: 'BPV-100', title: 'Darth Sidious', meta: 'Mustafar' },
          ],
        },
      ],
      insert: [
        {
          count: 15,
          name: 'THERE’S ALWAYS A BIGGER FISH',
          meta: 'Creatures of the five planets, small to colossal',
          odds: '1:4 packs',
          parallels: 5,
          cards: [
            { num: 'BF-1', title: 'Tauntauns', meta: 'Hoth' },
            { num: 'BF-2', title: 'Wampa', meta: 'Hoth' },
            { num: 'BF-3', title: 'Fambaa', meta: 'Naboo' },
            { num: 'BF-4', title: 'Falumpaset', meta: 'Naboo' },
            { num: 'BF-5', title: 'Mylaya', meta: 'Kashyyyk' },
            { num: 'BF-6', title: 'Roggwart', meta: 'Mustafar' },
            { num: 'BF-7', title: 'Mustafar Lava Flea', meta: 'Mustafar' },
            { num: 'BF-8', title: 'Shaak', meta: 'Naboo' },
            { num: 'BF-9', title: 'Opee Sea Killer', meta: 'Naboo' },
            { num: 'BF-10', title: 'Sando Aqua Monster', meta: 'Naboo' },
            { num: 'BF-11', title: 'Kaadu', meta: 'Naboo' },
            { num: 'BF-12', title: 'Nuna', meta: 'Naboo' },
            { num: 'BF-13', title: 'Colo Claw Fish', meta: 'Naboo' },
            { num: 'BF-14', title: 'Can-Cell', meta: 'Kashyyyk' },
            { num: 'BF-15', title: 'Kybuck', meta: 'Kashyyyk' },
          ],
        },
        {
          count: 25,
          name: 'GALACTIC ERAS',
          meta: 'Pivotal moments in planetary history',
          odds: '1:4 packs',
          parallels: 5,
          cards: [
            { num: 'GE-1', title: 'Battle of Hoth', meta: 'Hoth' },
            { num: 'GE-2', title: 'Battle of Kachirho', meta: 'Kashyyyk' },
            { num: 'GE-3', title: 'Battle of Naboo', meta: 'Naboo' },
            { num: 'GE-4', title: 'Obi-Wan Kenobi vs Anakin Skywalker', meta: 'Mustafar' },
            { num: 'GE-5', title: 'Qui-Gon Jinn and Obi-Wan Kenobi vs Darth Maul', meta: 'Naboo' },
            { num: 'GE-6', title: 'Yoda, Chief Tarfful, and Chewbacca meet with Jedi Council', meta: 'Kashyyyk' },
            { num: 'GE-7', title: 'Padmé Amidala and Anakin Skywalker', meta: 'Mustafar' },
            { num: 'GE-8', title: 'Anakin Skywalker attacks SEPARATIST', meta: 'Mustafar' },
            { num: 'GE-9', title: 'Anakin Skywalker becomes Darth Vader', meta: 'Mustafar' },
            { num: 'GE-10', title: 'Han Solo, Chewbacca, and Princess Leia Organa seek refuge', meta: 'Bespin' },
            { num: 'GE-11', title: 'Wedge Antilles trips up an AT-AT', meta: 'Hoth' },
            { num: 'GE-12', title: 'Luke Skywalker plants an explosive in an AT-AT', meta: 'Hoth' },
            { num: 'GE-13', title: 'Lando Calrissian double crosses Han Solo', meta: 'Bespin' },
            { num: 'GE-14', title: 'Duel on Cloud City', meta: 'Bespin' },
            { num: 'GE-15', title: 'Leia, Chewbacca, and Lando Calrissian escaping Bespin', meta: 'Bespin' },
            { num: 'GE-16', title: 'Qui-Gon Jinn and Obi-Wan Kenobi Meet Jar Jar Binks', meta: 'Naboo' },
            { num: 'GE-17', title: 'Qui-Gon Jinn and Obi-Wan Kenobi meet with the Gungan Rep Council', meta: 'Naboo' },
            { num: 'GE-18', title: 'Naboo Celebration', meta: 'Naboo' },
            { num: 'GE-19', title: 'Anakin Skywalker and Padmé Amidala Kiss', meta: 'Naboo' },
            { num: 'GE-20', title: 'Anakin Skywalker and Padmé Amidala\'s Secret Wedding', meta: 'Naboo' },
            { num: 'GE-21', title: 'Yoda departs Kashyyyk', meta: 'Kashyyyk' },
            { num: 'GE-22', title: 'Kylo Ren finds Sith Wayfinder', meta: 'Mustafar' },
            { num: 'GE-23', title: 'Boba Fett captures Han Solo', meta: 'Bespin' },
            { num: 'GE-24', title: 'Nute Gunray and Rune Haako captured', meta: 'Naboo' },
            { num: 'GE-25', title: 'Han Solo rescues Luke Skywalker', meta: 'Hoth' },
          ],
        },
        {
          count: 15,
          name: 'FIRST ARRIVAL',
          meta: 'Die-cut · characters arriving on each planet',
          odds: '1:48 packs',
          parallels: 5,
          cards: [
            { num: 'FA-1', title: 'Padmé Amidala', meta: 'Naboo' },
            { num: 'FA-2', title: 'Chief Tarfful', meta: 'Kashyyyk' },
            { num: 'FA-3', title: 'Sabé', meta: 'Naboo' },
            { num: 'FA-4', title: 'Lobot', meta: 'Bespin' },
            { num: 'FA-5', title: 'Boss Nass', meta: 'Naboo' },
            { num: 'FA-6', title: 'Captain Panaka', meta: 'Naboo' },
            { num: 'FA-7', title: 'Senator Palpatine', meta: 'Naboo' },
            { num: 'FA-8', title: 'Sio Bibble', meta: 'Naboo' },
            { num: 'FA-9', title: 'Ric Olié', meta: 'Naboo' },
            { num: 'FA-10', title: 'Chewbacca', meta: 'Kashyyyk' },
            { num: 'FA-11', title: 'Boss Lyonie', meta: 'Naboo' },
            { num: 'FA-12', title: 'Jar Jar Binks', meta: 'Naboo' },
            { num: 'FA-13', title: 'Queen Jamillia', meta: 'Naboo' },
            { num: 'FA-14', title: 'General Tarpals', meta: 'Naboo' },
            { num: 'FA-15', title: 'Darth Vader', meta: 'Mustafar' },
          ],
        },
        {
          count: 5,
          name: 'JUMP TO HYPERSPACE',
          meta: 'Starships jumping to lightspeed · 1 per case',
          odds: '1:96 packs',
          parallels: 4,
          cards: [
            { num: 'JH-1', title: 'Millennium Falcon', meta: 'Hoth' },
            { num: 'JH-2', title: 'Naboo Starfighter', meta: 'Naboo' },
            { num: 'JH-3', title: 'Republic Frigate', meta: 'Naboo' },
            { num: 'JH-4', title: 'Boba Fett\'s Starship', meta: 'Bespin' },
            { num: 'JH-5', title: 'The Ghost', meta: 'Mustafar' },
          ],
        },
        {
          count: 5,
          name: 'PLANETARY VIEWS',
          meta: 'Serial /99 planet vistas',
          odds: '1:349 packs',
          parallels: 4,
          cards: [
            { num: 'PV-1', title: 'Naboo' },
            { num: 'PV-2', title: 'Kashyyyk' },
            { num: 'PV-3', title: 'Mustafar' },
            { num: 'PV-4', title: 'Bespin' },
            { num: 'PV-5', title: 'Hoth' },
          ],
        },
        {
          count: 10,
          name: 'GALACTIC ORIGINS',
          meta: 'Character origins across the five planets',
          odds: '1:900 packs',
          parallels: 3,
          cards: [
            { num: 'GO-1', title: 'Padmé Amidala', meta: 'Naboo' },
            { num: 'GO-2', title: 'Jar Jar Binks', meta: 'Naboo' },
            { num: 'GO-3', title: 'Chewbacca', meta: 'Kashyyyk' },
            { num: 'GO-4', title: 'Chief Tarfful', meta: 'Kashyyyk' },
            { num: 'GO-5', title: 'Senator Palpatine', meta: 'Naboo' },
            { num: 'GO-6', title: 'Darth Vader', meta: 'Mustafar' },
            { num: 'GO-7', title: 'Lando Calrissian', meta: 'Bespin' },
            { num: 'GO-8', title: 'Lobot', meta: 'Bespin' },
            { num: 'GO-9', title: 'K-3PO', meta: 'Hoth' },
            { num: 'GO-10', title: 'Captain Panaka', meta: 'Naboo' },
          ],
        },
        {
          count: 5,
          name: 'STAR WARS REFLECTIONS',
          meta: 'Continues the numbering from 2024 Chrome',
          odds: '1:1,000 packs',
          parallels: 2,
          cards: [
            { num: 'R-6', title: 'Lord Vader' },
            { num: 'R-7', title: 'Ahsoka\'s Remorse' },
            { num: 'R-8', title: 'Dangerous Negotiations' },
            { num: 'R-9', title: 'No Love for the Empire' },
            { num: 'R-10', title: 'AT-AT Driver' },
          ],
        },
      ],
      auto: [
        {
          count: 46,
          name: 'AUTOGRAPH VARIATIONS',
          meta: 'On-card autograph variations of the base design',
          odds: '1:48 packs · 2 per case',
          parallels: 5,
          cards: [
            { num: 'A-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'A-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'A-AS', title: 'Andy Serkis', meta: 'Kino Loy' },
            { num: 'A-BD', title: 'Benicio del Toro', meta: 'DJ' },
            { num: 'A-BL', title: 'Billie Lourd', meta: 'Lieutenant Connix' },
            { num: 'A-BM', title: 'Ben Mendelsohn', meta: 'Orson Krennic' },
            { num: 'A-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'A-DE', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'A-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'A-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'A-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'A-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'A-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'A-FS', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'A-FW', title: 'Forest Whitaker', meta: 'Saw Gerrera' },
            { num: 'A-GL', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'A-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'A-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'A-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'A-IM', title: 'Ian McDiarmid', meta: 'Darth Sidious' },
            { num: 'A-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'A-JB', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'A-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'A-JL', title: 'John Leguizamo', meta: 'Gor Koresh' },
            { num: 'A-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'A-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'A-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'A-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'A-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'A-MM', title: 'Mads Mikkelsen', meta: 'Galen Erso' },
            { num: 'A-MN', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'A-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'A-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Queen Amidala' },
            { num: 'A-NY', title: 'Lupita Nyong\'o', meta: 'Maz Kanata' },
            { num: 'A-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'A-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'A-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'A-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'A-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'A-SO', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'A-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'A-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'A-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'A-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'A-WH', title: 'Werner Herzog', meta: 'The Client' },
          ],
        },
      ],
      sketch: [
        {
          count: 105,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches · Silver, Purple, Gold, Blue & Black Foil versions',
          odds: '1:30 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: '1', title: 'Sketch Card', meta: 'Adam Beck' },
            { num: '2', title: 'Sketch Card', meta: 'Albino Ryno' },
            { num: '3', title: 'Sketch Card', meta: 'Alex Mines' },
            { num: '4', title: 'Sketch Card', meta: 'Allen Grimes' },
            { num: '5', title: 'Sketch Card', meta: 'Andrew Fry' },
            { num: '6', title: 'Sketch Card', meta: 'Andrew Perkins' },
            { num: '7', title: 'Sketch Card', meta: 'Anthony Pietszak' },
            { num: '8', title: 'Sketch Card', meta: 'Ashley Marsh' },
            { num: '9', title: 'Sketch Card', meta: 'Basak Kahraman' },
            { num: '10', title: 'Sketch Card', meta: 'Bobby Blakey' },
            { num: '11', title: 'Sketch Card', meta: 'Brandon Klein' },
            { num: '12', title: 'Sketch Card', meta: 'Brent Scotchmer' },
            { num: '13', title: 'Sketch Card', meta: 'Chris Thorne' },
            { num: '14', title: 'Sketch Card', meta: 'Chris Thornley' },
            { num: '15', title: 'Sketch Card', meta: 'Cisco Rivera' },
            { num: '16', title: 'Sketch Card', meta: 'Clinton Yeager' },
            { num: '17', title: 'Sketch Card', meta: 'Dan Cooney' },
            { num: '18', title: 'Sketch Card', meta: 'Dan Gorman' },
            { num: '19', title: 'Sketch Card', meta: 'Dan Lawler' },
            { num: '20', title: 'Sketch Card', meta: 'Daniel Chavez' },
            { num: '21', title: 'Sketch Card', meta: 'Darrin Pepe' },
            { num: '22', title: 'Sketch Card', meta: 'David "Dove" McHargue' },
            { num: '23', title: 'Sketch Card', meta: 'David Willingham' },
            { num: '24', title: 'Sketch Card', meta: 'Dawn Murphy' },
            { num: '25', title: 'Sketch Card', meta: 'El Smetchö' },
            { num: '26', title: 'Sketch Card', meta: 'Elvin A Hernandez' },
            { num: '27', title: 'Sketch Card', meta: 'Emma Douglas' },
            { num: '28', title: 'Sketch Card', meta: 'Emrah Cildir' },
            { num: '29', title: 'Sketch Card', meta: 'Emre VARLIBAŞ' },
            { num: '30', title: 'Sketch Card', meta: 'Eric Lehtonen' },
            { num: '31', title: 'Sketch Card', meta: 'Eric Medina' },
            { num: '32', title: 'Sketch Card', meta: 'Evgheni Batu' },
            { num: '33', title: 'Sketch Card', meta: 'Frank A. Kadar' },
            { num: '34', title: 'Sketch Card', meta: 'Frank Sansone' },
            { num: '35', title: 'Sketch Card', meta: 'Gabe Farber' },
            { num: '36', title: 'Sketch Card', meta: 'Gerry Garcia Jr' },
            { num: '37', title: 'Sketch Card', meta: 'Ian McKesson' },
            { num: '38', title: 'Sketch Card', meta: 'James Boyd' },
            { num: '39', title: 'Sketch Card', meta: 'James Harris' },
            { num: '40', title: 'Sketch Card', meta: 'Jamie Richards' },
            { num: '41', title: 'Sketch Card', meta: 'Jane Rushton' },
            { num: '42', title: 'Sketch Card', meta: 'Jason Christner' },
            { num: '43', title: 'Sketch Card', meta: 'Jason Montoya' },
            { num: '44', title: 'Sketch Card', meta: 'Jason Saldajeno' },
            { num: '45', title: 'Sketch Card', meta: 'Jason Sobol' },
            { num: '46', title: 'Sketch Card', meta: 'Jay Manchand' },
            { num: '47', title: 'Sketch Card', meta: 'Jeffrey C. Benitez' },
            { num: '48', title: 'Sketch Card', meta: 'Jessica Hickman' },
            { num: '49', title: 'Sketch Card', meta: 'Jim O\'Riley' },
            { num: '50', title: 'Sketch Card', meta: 'Joe Ortiz' },
            { num: '51', title: 'Sketch Card', meta: 'Joey Mason' },
            { num: '52', title: 'Sketch Card', meta: 'John Bruce' },
            { num: '53', title: 'Sketch Card', meta: 'John Pleak' },
            { num: '54', title: 'Sketch Card', meta: 'John Still' },
            { num: '55', title: 'Sketch Card', meta: 'Kang Jing' },
            { num: '56', title: 'Sketch Card', meta: 'Karl Jones' },
            { num: '57', title: 'Sketch Card', meta: 'Kevin P. West' },
            { num: '58', title: 'Sketch Card', meta: 'Kevin Scott Jacobs' },
            { num: '59', title: 'Sketch Card', meta: 'Kirk Chavarria' },
            { num: '60', title: 'Sketch Card', meta: 'Kris Penix' },
            { num: '61', title: 'Sketch Card', meta: 'Krishna Sharma' },
            { num: '62', title: 'Sketch Card', meta: 'Limuel Pinzon' },
            { num: '63', title: 'Sketch Card', meta: 'Lindsey Greyling' },
            { num: '64', title: 'Sketch Card', meta: 'Marcia Dye' },
            { num: '65', title: 'Sketch Card', meta: 'Matt Maldonado' },
            { num: '66', title: 'Sketch Card', meta: 'Matt Steffens' },
            { num: '67', title: 'Sketch Card', meta: 'Matt Stewart' },
            { num: '68', title: 'Sketch Card', meta: 'Michael Mastermaker' },
            { num: '69', title: 'Sketch Card', meta: 'Michael Munshaw' },
            { num: '70', title: 'Sketch Card', meta: 'Mike Dalzell' },
            { num: '71', title: 'Sketch Card', meta: 'Mike Davidson' },
            { num: '72', title: 'Sketch Card', meta: 'Mike LaPeruta' },
            { num: '73', title: 'Sketch Card', meta: 'Mongola Das' },
            { num: '74', title: 'Sketch Card', meta: 'Neil A Brady' },
            { num: '75', title: 'Sketch Card', meta: 'Neil Camera' },
            { num: '76', title: 'Sketch Card', meta: 'Nick Gribbon' },
            { num: '77', title: 'Sketch Card', meta: 'Oscar Chavez' },
            { num: '78', title: 'Sketch Card', meta: 'Patricio Carrasco' },
            { num: '79', title: 'Sketch Card', meta: 'Patrick Giles' },
            { num: '80', title: 'Sketch Card', meta: 'Phillip Trujillo' },
            { num: '81', title: 'Sketch Card', meta: 'Quinton Baker' },
            { num: '82', title: 'Sketch Card', meta: 'Rachel Jane Hetherington' },
            { num: '83', title: 'Sketch Card', meta: 'Rebeca Louro' },
            { num: '84', title: 'Sketch Card', meta: 'Rich "RAM" Molinelli' },
            { num: '85', title: 'Sketch Card', meta: 'Rich Hennemann' },
            { num: '86', title: 'Sketch Card', meta: 'Rico Dela Rosa' },
            { num: '87', title: 'Sketch Card', meta: 'Robert Hendrickson' },
            { num: '88', title: 'Sketch Card', meta: 'Robin Jeanes' },
            { num: '89', title: 'Sketch Card', meta: 'Roy Cover' },
            { num: '90', title: 'Sketch Card', meta: 'Rugved Bhuskute' },
            { num: '91', title: 'Sketch Card', meta: 'Ryan Johnston' },
            { num: '92', title: 'Sketch Card', meta: 'Ryan Thompson' },
            { num: '93', title: 'Sketch Card', meta: 'Sean Mathews' },
            { num: '94', title: 'Sketch Card', meta: 'Semra Bulut' },
            { num: '95', title: 'Sketch Card', meta: 'Shaow Siong' },
            { num: '96', title: 'Sketch Card', meta: 'Shyla Lee' },
            { num: '97', title: 'Sketch Card', meta: 'Stephane Leonardi' },
            { num: '98', title: 'Sketch Card', meta: 'Steve Alce' },
            { num: '99', title: 'Sketch Card', meta: 'Tim Shinn' },
            { num: '100', title: 'Sketch Card', meta: 'Tom Amici' },
            { num: '101', title: 'Sketch Card', meta: 'Veronica Louro' },
            { num: '102', title: 'Sketch Card', meta: 'Veronica Smith' },
            { num: '103', title: 'Sketch Card', meta: 'Vincenzo "Chenduz" D\'Ippolito' },
            { num: '104', title: 'Sketch Card', meta: 'Vini Pirani' },
            { num: '105', title: 'Sketch Card', meta: 'Yves Van Berlo' },
          ],
        },
      ],
    },
  },

  '2024-galactic-antiquities': {
    setId: '2024-galactic-antiquities',
    year: '2024',
    brand: 'TOPPS',
    title: 'STAR WARS GALACTIC ANTIQUITIES',
    releaseDate: '2 / 5 / 2025',
    lede: 'The tightest Star Wars product Topps has ever shipped: one case holds one box holding a single nine-card pack — five autographs, two base cards or parallels, a metal card and an oversized framed sketch. Behind that pack sits a 60-card base set with every card serial-numbered /25 beneath Red /10 and twin 1/1 parallels, a 30-card Metal Characters insert, a 75-card autograph program spanning on-card, framed, wood, Beskar metal and 1977 Series 1 Tribute tiers plus two seven-signature book cards, and 47 artists contributing one-of-one oversized art.',
    stats: [
      { num: '60', label: 'Base Cards', sub: 'Every card serial /25', color: 'gold' },
      { num: '30', label: 'Metal Cards', sub: 'Sole insert line', color: 'cyan' },
      { num: '75', label: 'Auto Cards', sub: '6 autograph tiers', color: 'green' },
      { num: '4', label: 'Base Parallels', sub: 'All serialized · /25 → 1/1', color: 'purple' },
      { num: '9', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '1', l: 'Pack per box · one box per case' },
      { v: '9', l: 'Cards per pack' },
      { v: '5', l: 'Autographs per box' },
      { v: '2', l: 'Base cards or parallels per box' },
      { v: '1', l: 'Metal card per box' },
      { v: '1', l: 'Oversized framed sketch per box' },
    ],
    pullRates: [
      { name: 'Red Parallels /10', odds: '1 : 2', tier: 'normal' },
      { name: 'Gold 1/1 Parallels', odds: '1 : 18', tier: 'rare' },
      { name: 'Hyperspace 1/1 Parallels', odds: '1 : 18', tier: 'rare' },
    ],
    parallelRainbow: [
      { name: 'BASE', pr: '/25', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'RED', pr: '/10', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'GOLD', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
      { name: 'HYPERSPACE', pr: '1/1', gradient: 'linear-gradient(135deg, #80d8ff 0%, #1878c8 55%, #b8ecff 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 60,
          name: 'BASE SET',
          meta: 'Characters across every era · every card serial /25',
          parallels: 4,
          cards: [
            { num: '1', title: 'Admiral Motti', meta: 'Star Wars: A New Hope' },
            { num: '2', title: 'Admiral Piett', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '3', title: 'Asajj Ventress', meta: 'Star Wars: The Clone Wars' },
            { num: '4', title: 'Darth Bane', meta: 'Star Wars: The Clone Wars' },
            { num: '5', title: 'Bail Organa', meta: 'Obi-Wan Kenobi' },
            { num: '6', title: 'Beru Lars', meta: 'Obi-Wan Kenobi' },
            { num: '7', title: 'Bib Fortuna', meta: 'The Mandalorian' },
            { num: '8', title: 'Bo-Katan Kryze', meta: 'The Mandalorian' },
            { num: '9', title: 'Bossk', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '10', title: 'Cad Bane', meta: 'The Book of Boba Fett' },
            { num: '11', title: 'Captain Rex', meta: 'Star Wars Rebels' },
            { num: '12', title: 'Chirrut Îmwe', meta: 'Rogue One: A Star Wars Story' },
            { num: '13', title: 'Cobb Vanth', meta: 'The Book of Boba Fett' },
            { num: '14', title: 'Inquisitor', meta: 'Tales of the Jedi' },
            { num: '15', title: 'Baylan Skoll', meta: 'Ahsoka' },
            { num: '16', title: 'Shin Hati', meta: 'Ahsoka' },
            { num: '17', title: 'Enfys Nest', meta: 'Solo: A Star Wars Story' },
            { num: '18', title: 'EV-9D9', meta: 'Star Wars: Return of the Jedi' },
            { num: '19', title: 'Fennec Shand', meta: 'The Book of Boba Fett' },
            { num: '20', title: 'Figrin D\'an', meta: 'Star Wars: A New Hope' },
            { num: '21', title: 'Galen Erso', meta: 'Rogue One: A Star Wars Story' },
            { num: '22', title: 'Grand Inquisitor', meta: 'Obi-Wan Kenobi' },
            { num: '23', title: 'Grand Moff Tarkin', meta: 'Rogue One: A Star Wars Story' },
            { num: '24', title: 'Greedo', meta: 'Star Wars: A New Hope' },
            { num: '25', title: 'IG-88', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '26', title: 'Jabba the Hutt', meta: 'Star Wars: Return of the Jedi' },
            { num: '27', title: 'Jango Fett', meta: 'Star Wars: Attack of the Clones' },
            { num: '28', title: 'Jar Jar Binks', meta: 'Star Wars: The Phantom Menace' },
            { num: '29', title: 'Jyn Erso', meta: 'Rogue One: A Star Wars Story' },
            { num: '30', title: 'K-2SO', meta: 'Rogue One: A Star Wars Story' },
            { num: '31', title: 'Kelleran Beq', meta: 'The Mandalorian' },
            { num: '32', title: 'Ki-Adi-Mundi', meta: 'Star Wars: Attack of the Clones' },
            { num: '33', title: 'Kit Fisto', meta: 'Star Wars: Attack of the Clones' },
            { num: '34', title: 'Krrsantan', meta: 'The Book of Boba Fett' },
            { num: '35', title: 'Kuiil', meta: 'The Mandalorian' },
            { num: '36', title: 'Lobot', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '37', title: 'Max Rebo', meta: 'Star Wars: Return of the Jedi' },
            { num: '38', title: 'Maz Kanata', meta: 'Star Wars: The Force Awakens' },
            { num: '39', title: 'Migs Mayfeld', meta: 'The Mandalorian' },
            { num: '40', title: 'Moff Gideon', meta: 'The Mandalorian' },
            { num: '41', title: 'Mon Mothma', meta: 'Andor' },
            { num: '42', title: 'Nien Nunb', meta: 'Star Wars: Return of the Jedi' },
            { num: '43', title: 'Shmi Skywalker', meta: 'Star Wars: The Phantom Menace' },
            { num: '44', title: 'Owen Lars', meta: 'Obi-Wan Kenobi' },
            { num: '45', title: 'Ponda Baba', meta: 'Star Wars: A New Hope' },
            { num: '46', title: 'Qi\'ra', meta: 'Solo: A Star Wars Story' },
            { num: '47', title: 'R5-D4', meta: 'The Mandalorian' },
            { num: '48', title: 'Rose Tico', meta: 'Star Wars: The Last Jedi' },
            { num: '49', title: 'Salacious B. Crumb', meta: 'Star Wars: Return of the Jedi' },
            { num: '50', title: 'Sebulba', meta: 'Star Wars: The Phantom Menace' },
            { num: '51', title: 'Shaak Ti', meta: 'Star Wars: Attack of the Clones' },
            { num: '52', title: 'Sith Trooper', meta: 'Star Wars: The Rise of Skywalker' },
            { num: '53', title: 'Stormtrooper', meta: 'Star Wars: Return of the Jedi' },
            { num: '54', title: 'Sy Snootles', meta: 'Star Wars: Return of the Jedi' },
            { num: '55', title: 'Vice Admiral Holdo', meta: 'Star Wars: The Last Jedi' },
            { num: '56', title: 'Wedge Antilles', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '57', title: 'Wicket W. Warrick', meta: 'Star Wars: Return of the Jedi' },
            { num: '58', title: 'Yaddle', meta: 'Tales of the Jedi' },
            { num: '59', title: 'Morgan Elsbeth', meta: 'Ahsoka' },
            { num: '60', title: 'Marrok', meta: 'Ahsoka' },
          ],
        },
      ],
      insert: [
        {
          count: 30,
          name: 'METAL CHARACTERS',
          meta: 'Saga icons on metal stock · one per box',
          parallels: 3,
          cards: [
            { num: 'M-1', title: 'Admiral Ackbar', meta: 'Star Wars: Return of the Jedi' },
            { num: 'M-2', title: 'Ahsoka Tano', meta: 'The Book of Boba Fett' },
            { num: 'M-3', title: 'Anakin Skywalker', meta: 'Star Wars: Revenge of the Sith' },
            { num: 'M-4', title: 'BB-8', meta: 'Star Wars: The Force Awakens' },
            { num: 'M-5', title: 'Boba Fett', meta: 'The Book of Boba Fett' },
            { num: 'M-6', title: 'C-3PO', meta: 'Star Wars: The Rise of Skywalker' },
            { num: 'M-7', title: 'Cassian Andor', meta: 'Andor' },
            { num: 'M-8', title: 'Chewbacca', meta: 'Star Wars: The Force Awakens' },
            { num: 'M-9', title: 'Darth Maul', meta: 'Star Wars: The Phantom Menace' },
            { num: 'M-10', title: 'Darth Sidious', meta: 'Star Wars: Revenge of the Sith' },
            { num: 'M-11', title: 'Count Dooku', meta: 'Star Wars: Attack of the Clones' },
            { num: 'M-12', title: 'Darth Vader', meta: 'Obi-Wan Kenobi' },
            { num: 'M-13', title: 'The Mandalorian', meta: 'The Mandalorian' },
            { num: 'M-14', title: 'Finn', meta: 'Star Wars: The Force Awakens' },
            { num: 'M-15', title: 'General Grievous', meta: 'Star Wars: Revenge of the Sith' },
            { num: 'M-16', title: 'Grogu', meta: 'The Mandalorian' },
            { num: 'M-17', title: 'Han Solo', meta: 'Star Wars: The Empire Strikes Back' },
            { num: 'M-18', title: 'Kylo Ren', meta: 'Star Wars: The Force Awakens' },
            { num: 'M-19', title: 'Lando Calrissian', meta: 'Star Wars: The Rise of Skywalker' },
            { num: 'M-20', title: 'Leia Organa', meta: 'Star Wars: A New Hope' },
            { num: 'M-21', title: 'Luke Skywalker', meta: 'Star Wars: The Last Jedi' },
            { num: 'M-22', title: 'Mace Windu', meta: 'Star Wars: The Phantom Menace' },
            { num: 'M-23', title: 'Obi-Wan Kenobi', meta: 'Obi-Wan Kenobi' },
            { num: 'M-24', title: 'Padmé Amidala', meta: 'Star Wars: Attack of the Clones' },
            { num: 'M-25', title: 'Poe Dameron', meta: 'Star Wars: The Rise of Skywalker' },
            { num: 'M-26', title: 'Qui-Gon Jinn', meta: 'Star Wars: The Phantom Menace' },
            { num: 'M-27', title: 'R2-D2', meta: 'Star Wars: The Last Jedi' },
            { num: 'M-28', title: 'Rey', meta: 'Star Wars: The Rise of Skywalker' },
            { num: 'M-29', title: 'Supreme Leader Snoke', meta: 'Star Wars: The Last Jedi' },
            { num: 'M-30', title: 'Yoda', meta: 'Star Wars: The Empire Strikes Back' },
          ],
        },
      ],
      auto: [
        {
          count: 26,
          name: 'AUTOGRAPHS',
          meta: 'On-card signers across every era',
          parallels: 5,
          cards: [
            { num: 'A-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'A-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'A-BDW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'A-C', title: 'Werner Herzog', meta: 'The Client' },
            { num: 'A-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'A-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'A-FP', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'A-GE', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'A-GF', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'A-GT', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'A-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'A-JR', title: 'John Ratzenberger', meta: 'Bren Derlin' },
            { num: 'A-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'A-KMT', title: 'Kelly Marie Tran', meta: 'Rose Tico' },
            { num: 'A-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'A-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'A-MNW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'A-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'A-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'A-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'A-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'A-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'A-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'A-TN', title: 'Thandiwe Newton', meta: 'Val' },
            { num: 'A-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
          ],
        },
        {
          count: 2,
          name: 'AUTOGRAPH BOOK CARD',
          meta: 'Seven-signature book cards',
          oneOfOne: true,
          cards: [
            { num: 'BC-O', title: 'Carrie Fisher / Mark Hamill / Billy Dee Williams / Peter Mayhew / David Prowse / Anthony Daniels / Harrison Ford', meta: 'Original Trilogy Cast' },
            { num: 'BC-X', title: 'Adam Driver / Daisy Ridley / Mark Hamill / Natalie Portman / Hayden Christensen / Harrison Ford / Carrie Fisher', meta: 'Skywalker Saga Cast' },
          ],
        },
        {
          count: 11,
          name: 'FRAMED AUTOGRAPHS',
          meta: 'Signed cards in presentation frames',
          parallels: 5,
          cards: [
            { num: 'FA-BC', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'FA-BDW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'FA-C', title: 'Werner Herzog', meta: 'The Client' },
            { num: 'FA-C3', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'FA-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'FA-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'FA-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'FA-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'FA-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'FA-SH', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'FA-SP', title: 'Simon Pegg', meta: 'Unkar Plutt' },
          ],
        },
        {
          count: 8,
          name: 'BESKAR METAL AUTOGRAPHS',
          meta: 'Signatures on Beskar metal stock',
          parallels: 4,
          cards: [
            { num: 'MA-FP', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'MA-GF', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'MA-GT', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'MA-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'MA-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'MA-SB', title: 'Stephen "Thundercat" Bruner', meta: 'The Modifier' },
            { num: 'MA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'MA-TN', title: 'Thandiwe Newton', meta: 'Val' },
          ],
        },
        {
          count: 17,
          name: '1977 STAR WARS SERIES 1 TRIBUTE AUTOGRAPHS',
          meta: '1977 Series 1 design · pulled from the box wax pack',
          parallels: 5,
          cards: [
            { num: 'TA-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'TA-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'TA-BDW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'TA-C', title: 'Werner Herzog', meta: 'The Client' },
            { num: 'TA-C3', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'TA-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'TA-GE', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'TA-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'TA-JR', title: 'John Ratzenberger', meta: 'Bren Derlin' },
            { num: 'TA-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'TA-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'TA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'TA-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'TA-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'TA-SB', title: 'Stephen "Thundercat" Bruner', meta: 'The Modifier' },
            { num: 'TA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'TA-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
          ],
        },
        {
          count: 11,
          name: 'WOOD AUTOGRAPHS',
          meta: 'Signatures on wood stock · no unnumbered version, Orange /25 down',
          parallels: 4,
          cards: [
            { num: 'WA-AB', title: 'Ahmed Best', meta: 'Jar Jar Binks' },
            { num: 'WA-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'WA-JR', title: 'John Ratzenberger', meta: 'Bren Derlin' },
            { num: 'WA-KMT', title: 'Kelly Marie Tran', meta: 'Rose Tico' },
            { num: 'WA-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'WA-MI', title: 'Moses Ingram', meta: 'Reva Sevander' },
            { num: 'WA-MNW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'WA-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'WA-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'WA-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'WA-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
          ],
        },
      ],
      sketch: [
        {
          count: 47,
          name: 'OVERSIZED ORIGINAL ART CARD',
          meta: 'Framed oversized 1/1 sketches · one per box',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'OOA-1', title: 'Alex Mines' },
            { num: 'OOA-2', title: 'Andrew Fry' },
            { num: 'OOA-3', title: 'Andy Hanks' },
            { num: 'OOA-4', title: 'Angel Aviles' },
            { num: 'OOA-5', title: 'Ari Arnaldsson' },
            { num: 'OOA-6', title: 'Ashley Marsh' },
            { num: 'OOA-7', title: 'Ben Jones' },
            { num: 'OOA-8', title: 'Brent Scotchmer' },
            { num: 'OOA-9', title: 'Candice Dailey' },
            { num: 'OOA-10', title: 'Carlos Cabaleiro' },
            { num: 'OOA-11', title: 'Chris Meeks' },
            { num: 'OOA-12', title: 'Cisco Rivera' },
            { num: 'OOA-13', title: 'Cyrus Sherkat' },
            { num: 'OOA-14', title: 'Dan Bergren' },
            { num: 'OOA-15', title: 'Dan Tearle' },
            { num: 'OOA-16', title: 'Daniel Chavez' },
            { num: 'OOA-17', title: 'Dave Gaskin' },
            { num: 'OOA-18', title: 'David "Dove" McHargue' },
            { num: 'OOA-19', title: 'Dawn Murphy' },
            { num: 'OOA-20', title: 'DYJ' },
            { num: 'OOA-21', title: 'Eric Lehtonen' },
            { num: 'OOA-22', title: 'Erik Maell' },
            { num: 'OOA-23', title: 'Gabe Farber' },
            { num: 'OOA-24', title: 'Jamison Murdock' },
            { num: 'OOA-25', title: 'Jason Davies' },
            { num: 'OOA-26', title: 'Jason Saldajeno' },
            { num: 'OOA-27', title: 'Jay Manchand' },
            { num: 'OOA-28', title: 'Jonathan Beistline' },
            { num: 'OOA-29', title: 'Josh Trout' },
            { num: 'OOA-30', title: 'Kang Jing' },
            { num: 'OOA-31', title: 'Kevin Graham' },
            { num: 'OOA-32', title: 'Kevin P. West' },
            { num: 'OOA-33', title: 'Kris Penix' },
            { num: 'OOA-34', title: 'Lindsey Greyling' },
            { num: 'OOA-35', title: 'Marcia Dye' },
            { num: 'OOA-36', title: 'Michael Mastermaker' },
            { num: 'OOA-37', title: 'Mike Stephens' },
            { num: 'OOA-38', title: 'Neil Camera' },
            { num: 'OOA-39', title: 'Nick Gribbon' },
            { num: 'OOA-40', title: 'Patricio Carrasco' },
            { num: 'OOA-41', title: 'Sam Barugh' },
            { num: 'OOA-42', title: 'Semra Bulut' },
            { num: 'OOA-43', title: 'Shyla Lee' },
            { num: 'OOA-44', title: 'Steve Alce' },
            { num: 'OOA-45', title: 'Vini Pirani' },
            { num: 'OOA-46', title: 'Will Pleydon' },
            { num: 'OOA-47', title: 'Yves Van Berlo' },
          ],
        },
      ],
    },
  },
  '2024-masterwork': {
    setId: '2024-masterwork',
    year: '2024',
    brand: 'TOPPS',
    title: 'STAR WARS MASTERWORK',
    releaseDate: '4 / 16 / 2025',
    lede: 'The ninth Masterwork in ten years — delayed into an April 2025 release — keeps the line\'s ultra-premium formula: 100 characters on 72-point stock behind an eight-step parallel ladder from Blue to Gold 1/1, seven insert lines including all-metal Artoo-Detoo and See-Threepio short prints and die-cut acetate Force Spirits, relics cut from a screen-used Force Awakens Stormtrooper costume and — a hobby first — the control panel of Disney\'s Rise of the Resistance ride, a six-tier autograph program with two autographs in every four-pack box, and a 182-artist sketch roster.',
    stats: [
      { num: '100', label: 'Base Cards', sub: '72-point stock', color: 'gold' },
      { num: '9', label: 'Insert Sets', sub: 'Incl. 2 relic lines', color: 'cyan' },
      { num: '99', label: 'Auto Cards', sub: '6 signature tiers', color: 'green' },
      { num: '8', label: 'Base Parallels', sub: 'Blue → Gold 1/1', color: 'purple' },
      { num: '17', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '4', l: 'Mini boxes per box' },
      { v: '5', l: 'Cards per mini box' },
      { v: '8', l: 'Boxes per case' },
      { v: '4', l: 'Hits per box' },
      { v: '2', l: 'Autographs per box' },
    ],
    pullRates: [
      { name: 'On Card Autographs', odds: '1 : 2', tier: 'normal' },
      { name: 'Marvel Comic Covers', odds: '1 : 4', tier: 'normal' },
      { name: 'Sketch Cards', odds: '1 : 4', tier: 'normal' },
      { name: 'Behind the New Scenes', odds: '1 : 5', tier: 'normal' },
      { name: 'Force Spirits', odds: '1 : 15', tier: 'rare' },
      { name: 'Rise of the Resistance Relics', odds: '1 : 22', tier: 'rare' },
      { name: 'Stormtrooper Armor Relics', odds: '1 : 39', tier: 'rare' },
      { name: 'Artoo-Detoo / See-Threepio', odds: '1 : 1,000', tier: 'mythic' },
      { name: 'Dual Autographs', odds: '1 : 1,030', tier: 'mythic' },
      { name: 'Quad Autograph Book', odds: '1 : 3,227', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'BLUE', pr: '∞', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'PURPLE', pr: '/50', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)' },
      { name: 'RED', pr: '/25', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'ORANGE', pr: '/10', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'BLACK', pr: '/5', gradient: 'linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)' },
      { name: 'PRINTING PLATES', pr: '1/1', gradient: 'linear-gradient(135deg, #b0b0b8 0%, #6a6a72 100%)' },
      { name: 'GOLD', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Characters across the saga · 72-point stock · parallel in every pack',
          parallels: 8,
          cards: [
            { num: '1', title: 'Han Solo' },
            { num: '2', title: 'Darth Maul' },
            { num: '3', title: 'Count Dooku' },
            { num: '4', title: 'General Grievous' },
            { num: '5', title: 'Baylan Skoll' },
            { num: '6', title: 'Shin Hati' },
            { num: '7', title: 'Marrok' },
            { num: '8', title: 'Asajj Ventress' },
            { num: '9', title: 'Jyn Erso' },
            { num: '10', title: 'Ahsoka Tano' },
            { num: '11', title: 'Lando Calrissian' },
            { num: '12', title: 'Nien Nunb' },
            { num: '13', title: 'Admiral Ackbar' },
            { num: '14', title: 'Carson Teva' },
            { num: '15', title: 'Captain Phasma' },
            { num: '16', title: 'Stormtrooper' },
            { num: '17', title: 'Bo-Katan Kryze' },
            { num: '18', title: 'Koska Reeves' },
            { num: '19', title: 'Boba Fett' },
            { num: '20', title: 'Darth Vader' },
            { num: '21', title: 'General Draven' },
            { num: '22', title: 'Baze Malbus' },
            { num: '23', title: 'Porg' },
            { num: '24', title: 'Figrin D\'an' },
            { num: '25', title: 'Krrsantan' },
            { num: '26', title: 'Greedo' },
            { num: '27', title: 'Enfys Nest' },
            { num: '28', title: 'Poe Dameron' },
            { num: '29', title: 'Rey' },
            { num: '30', title: 'Kylo Ren' },
            { num: '31', title: 'Tallie Lintra' },
            { num: '32', title: 'Salacious B. Crumb' },
            { num: '33', title: 'Bib Fortuna' },
            { num: '34', title: 'Beezer Fortuna' },
            { num: '35', title: 'Jabba the Hutt' },
            { num: '36', title: 'Garsa Fwip' },
            { num: '37', title: 'Droideka' },
            { num: '38', title: 'Jannah' },
            { num: '39', title: 'Max Rebo' },
            { num: '40', title: 'Chancellor Palpatine' },
            { num: '41', title: 'Mace Windu' },
            { num: '42', title: 'Jango Fett' },
            { num: '43', title: 'Lok Durd' },
            { num: '44', title: 'Vice Admiral Holdo' },
            { num: '45', title: 'The Modifier' },
            { num: '46', title: 'Ponda Baba' },
            { num: '47', title: 'Doctor Cornelius Evazan' },
            { num: '48', title: 'Ric Olié' },
            { num: '49', title: 'Chewbacca' },
            { num: '50', title: 'Luke Skywalker' },
            { num: '51', title: 'Ezra Bridger' },
            { num: '52', title: 'Sabine Wren' },
            { num: '53', title: 'Hera Syndulla' },
            { num: '54', title: 'Kanan Jarrus' },
            { num: '55', title: 'Chopper' },
            { num: '56', title: 'Garazeb Orrelios' },
            { num: '57', title: 'Jek Porkins' },
            { num: '58', title: 'Captain Panaka' },
            { num: '59', title: 'Oma Tres' },
            { num: '60', title: 'Obi-Wan Kenobi' },
            { num: '61', title: 'Nute Gunray' },
            { num: '62', title: 'Dedra Meero' },
            { num: '63', title: 'Syril Karn' },
            { num: '64', title: 'Admiral Motti' },
            { num: '65', title: 'Padmé Amidala' },
            { num: '66', title: 'Anakin Skywalker' },
            { num: '67', title: 'R5-D4' },
            { num: '68', title: 'Sy Snootles' },
            { num: '69', title: 'The Dutchess' },
            { num: '70', title: 'R2-D2' },
            { num: '71', title: 'C-3PO' },
            { num: '72', title: 'Supreme Leader Snoke' },
            { num: '73', title: 'Tala Durith' },
            { num: '74', title: 'Sebulba' },
            { num: '75', title: 'Reva' },
            { num: '76', title: 'Major Bren Derlin' },
            { num: '77', title: 'Huyang' },
            { num: '78', title: 'Luthen Rael' },
            { num: '79', title: 'Captain Bombardier' },
            { num: '80', title: 'Leia Organa' },
            { num: '81', title: 'Wicket W. Warrick' },
            { num: '82', title: 'Zorii Bliss' },
            { num: '83', title: 'Tobias Beckett' },
            { num: '84', title: 'Master Codebreaker' },
            { num: '85', title: 'The Rancor' },
            { num: '86', title: 'The Rancor Keeper' },
            { num: '87', title: 'Malakili' },
            { num: '88', title: 'Unkar Plutt' },
            { num: '89', title: 'Yaddle' },
            { num: '90', title: 'Yoda' },
            { num: '91', title: 'Grogu' },
            { num: '92', title: 'Even Piell' },
            { num: '93', title: 'Plo Koon' },
            { num: '94', title: 'Jacen Syndulla' },
            { num: '95', title: 'Kelleran Beq' },
            { num: '96', title: 'Tasu Leech' },
            { num: '97', title: 'Poggle the Lesser' },
            { num: '98', title: 'Admiral Piett' },
            { num: '99', title: 'The Mandalorian' },
            { num: '100', title: 'Grand Admiral Thrawn' },
          ]
        },
      ],
      insert: [
        {
          count: 23,
          name: 'BEHIND THE NEW SCENES',
          meta: 'Sequel Trilogy sets, behind the camera',
          odds: '1:5 packs',
          parallels: 6,
          cards: [
            { num: 'BTS-1', title: 'J.J. Abrams And Daisy Ridley' },
            { num: 'BTS-2', title: 'Stormtoopers Of The First Order' },
            { num: 'BTS-3', title: 'The Scavenger And The Droid' },
            { num: 'BTS-4', title: 'J.J. Abrams With John Boyega And Oscar Isaac' },
            { num: 'BTS-5', title: 'The Journey Begins' },
            { num: 'BTS-6', title: 'Rian Johnson and Mark Hamill in the Falcon' },
            { num: 'BTS-7', title: 'Rian Johnson With Oscar Isaac' },
            { num: 'BTS-8', title: 'At The Mirror Cave' },
            { num: 'BTS-9', title: 'Rian Johnson With Benicio Del Toro' },
            { num: 'BTS-10', title: 'Mark Hamill With The Droid' },
            { num: 'BTS-11', title: 'Rian Johnson Frames The Shot' },
            { num: 'BTS-12', title: 'Captain Phasma With Her Army' },
            { num: 'BTS-13', title: 'A Moment Of Joy For Mark Hamill' },
            { num: 'BTS-14', title: 'The Resistance Celebrates' },
            { num: 'BTS-15', title: 'The Droids On Kef Bir' },
            { num: 'BTS-16', title: 'R2-D2 Plus Two' },
            { num: 'BTS-17', title: 'J.J. Abrams And The Wookiee Collaborate' },
            { num: 'BTS-18', title: 'The Resistance At The Festival Of The Ancestors' },
            { num: 'BTS-19', title: 'J.J. Abrams And Adam Driver Discuss A Dark Moment' },
            { num: 'BTS-20', title: 'An Embrace On Pasaana' },
            { num: 'BTS-21', title: 'Daisy Ridley Channels The Force For The Camera' },
            { num: 'BTS-22', title: 'Chewbacca\'s Close-up' },
            { num: 'BTS-23', title: 'The Resistance Co-Generals Share A Laugh' },
          ]
        },
        {
          count: 20,
          name: 'JOURNEY OF AHSOKA TANO',
          meta: 'Padawan to Fulcrum and beyond',
          odds: '1:6 packs',
          parallels: 6,
          cards: [
            { num: 'JA-1', title: 'The Child & The Force' },
            { num: 'JA-2', title: 'Discovered By Plo Koon' },
            { num: 'JA-3', title: 'Enter "Snips"' },
            { num: 'JA-4', title: 'Infected' },
            { num: 'JA-5', title: 'Strange Occurrences On Mortis' },
            { num: 'JA-6', title: 'Wookiee Hunt' },
            { num: 'JA-7', title: 'A Jedi No More' },
            { num: 'JA-8', title: 'Under Siege' },
            { num: 'JA-9', title: 'Hunted By An Inquisitor' },
            { num: 'JA-10', title: 'Twilight of the Apprentice' },
            { num: 'JA-11', title: 'A Long Awaited Meeting' },
            { num: 'JA-12', title: 'The Search for Ezra And Thrawn' },
            { num: 'JA-13', title: 'A Mandalorian and A Former Jedi' },
            { num: 'JA-14', title: 'Defeating The Magistrate' },
            { num: 'JA-15', title: 'Clash In Corellia' },
            { num: 'JA-16', title: 'Space Duel' },
            { num: 'JA-17', title: 'Fallen Jedi' },
            { num: 'JA-18', title: 'Far, Far Away' },
            { num: 'JA-19', title: 'Heroes Move In' },
            { num: 'JA-20', title: 'Rematch with the Nightsister Witch' },
          ]
        },
        {
          count: 20,
          name: 'THE GRAND ADMIRAL',
          meta: 'The rise of Thrawn',
          odds: '1:6 packs',
          parallels: 4,
          cards: [
            { num: 'HG-1', title: 'Steps Into Shadows' },
            { num: 'HG-2', title: 'Appreciating The Kalikori' },
            { num: 'HG-3', title: 'Recruiting the Magistrate' },
            { num: 'HG-4', title: 'The Admiral And The Spy' },
            { num: 'HG-5', title: 'Narrowing The Search' },
            { num: 'HG-6', title: 'Sparring With Droids' },
            { num: 'HG-7', title: 'Ready For Anything' },
            { num: 'HG-8', title: 'The Pursuit Of Mon Mothma' },
            { num: 'HG-9', title: 'Fighting Kallus' },
            { num: 'HG-10', title: 'Sending The Fleet To Atollon' },
            { num: 'HG-11', title: 'Confronting Rebel Leaders' },
            { num: 'HG-12', title: 'Face To Face With Bendu' },
            { num: 'HG-13', title: 'A Perfect Oppurtinity' },
            { num: 'HG-14', title: 'Dispatching Agent Rukh' },
            { num: 'HG-15', title: 'Hera Syndulla Captured' },
            { num: 'HG-16', title: 'The Admiral And The Jedi' },
            { num: 'HG-17', title: 'Hijacked By Purrgil' },
            { num: 'HG-18', title: 'Reunion On Another Galaxy' },
            { num: 'HG-19', title: 'Ahsoka Lives, Prepare Accordingly' },
            { num: 'HG-20', title: 'Long Live The Empire' },
          ]
        },
        {
          count: 33,
          name: 'MARVEL COMIC COVERS',
          meta: 'Vintage Marvel issues, 1977–1986',
          odds: '1:4 packs',
          parallels: 6,
          cards: [
            { num: 'MC-1', title: 'Star Wars #1, July 1977' },
            { num: 'MC-2', title: 'Star Wars #7, January 1978' },
            { num: 'MC-3', title: 'Star Wars #11, May 1978' },
            { num: 'MC-4', title: 'Star Wars #18, December 1978' },
            { num: 'MC-5', title: 'Star Wars #13, July 1978' },
            { num: 'MC-6', title: 'Star Wars #21, March 1979' },
            { num: 'MC-7', title: 'Star Wars #24, June 1979' },
            { num: 'MC-8', title: 'Star Wars #30, December 1979' },
            { num: 'MC-9', title: 'Star Wars #31, January 1980' },
            { num: 'MC-10', title: 'Star Wars #35, May 1980' },
            { num: 'MC-11', title: 'Star Wars #38, August 1980' },
            { num: 'MC-12', title: 'Star Wars #39, September 1980' },
            { num: 'MC-13', title: 'Star Wars #52, October 1981' },
            { num: 'MC-14', title: 'Star Wars #63, September 1982' },
            { num: 'MC-15', title: 'Star Wars #64, October 1982' },
            { num: 'MC-16', title: 'Star Wars #65, November 1982' },
            { num: 'MC-17', title: 'Star Wars #68, February 1983' },
            { num: 'MC-18', title: 'Star Wars #69, March 1983' },
            { num: 'MC-19', title: 'Star Wars #70, April 1983' },
            { num: 'MC-20', title: 'Star Wars #71, May 1983' },
            { num: 'MC-21', title: 'Star Wars #73, July 1983' },
            { num: 'MC-22', title: 'Star Wars #80, February 1984' },
            { num: 'MC-23', title: 'Star Wars #81, March 1984' },
            { num: 'MC-24', title: 'Star Wars #86, August 1984' },
            { num: 'MC-25', title: 'Star Wars #90, December 1984' },
            { num: 'MC-26', title: 'Star Wars #91, January 1985' },
            { num: 'MC-27', title: 'Star Wars #92, February 1985' },
            { num: 'MC-28', title: 'Star Wars #94, April 1985' },
            { num: 'MC-29', title: 'Star Wars #95, May 1985' },
            { num: 'MC-30', title: 'Star Wars #98, August 1985' },
            { num: 'MC-31', title: 'Star Wars #100, October 1985' },
            { num: 'MC-32', title: 'Star Wars #101, November 1985' },
            { num: 'MC-33', title: 'Star Wars #107, September 1986' },
          ]
        },
        {
          count: 6,
          name: 'FORCE SPIRITS',
          meta: 'Die-cut acetate Force ghosts',
          odds: '1:15 packs',
          noParallels: true,
          cards: [
            { num: 'FS-1', title: 'Anakin Skywalker' },
            { num: 'FS-2', title: 'Obi-Wan Kenobi' },
            { num: 'FS-3', title: 'Yoda' },
            { num: 'FS-4', title: 'Qui-Gon Jinn' },
            { num: 'FS-5', title: 'Leia Organa' },
            { num: 'FS-6', title: 'Luke Skywalker' },
          ]
        },
        {
          count: 10,
          name: 'ARTOO-DETOO',
          meta: 'All-metal R2-D2 moments · short print',
          odds: '1:1,000 packs',
          noParallels: true,
          cards: [
            { num: 'AR-1', title: 'Protecting The Queen' },
            { num: 'AR-2', title: 'R2\'s Droid Factory Frolic' },
            { num: 'AR-3', title: 'Buzz Droid Zapped!' },
            { num: 'AR-4', title: 'Oil And Fire' },
            { num: 'AR-5', title: '"Help Me Obi-Wan Kenobi"' },
            { num: 'AR-6', title: 'R2-D2\'s Heroic Salvage' },
            { num: 'AR-7', title: 'Hit By Darth Vader' },
            { num: 'AR-8', title: 'Master Luke Lost' },
            { num: 'AR-9', title: 'Return Of The Jedi\'s Lightsaber' },
            { num: 'AR-10', title: 'R2\'s Bunker Breakdown' },
          ]
        },
        {
          count: 10,
          name: 'SEE-THREEPIO',
          meta: 'All-metal C-3PO moments · short print',
          odds: '1:1,000 packs',
          noParallels: true,
          cards: [
            { num: 'CP-1', title: 'Reunited' },
            { num: 'CP-2', title: 'Into The Clone Wars Head First' },
            { num: 'CP-3', title: 'Witness To A Secret Wedding' },
            { num: 'CP-4', title: 'Feeling So Helpless' },
            { num: 'CP-5', title: 'Organa Orders A Mind Wipe' },
            { num: 'CP-6', title: 'Lost On Tatooine' },
            { num: 'CP-7', title: 'Telling Han The Odds' },
            { num: 'CP-8', title: 'A Wookiee\'s Chatty Backpack' },
            { num: 'CP-9', title: 'Knock Knock Knocking On Jabba\'s door' },
            { num: 'CP-10', title: 'In Defense Of Hera Syndulla' },
          ]
        },
        {
          count: 8,
          name: 'RISE OF THE RESISTANCE RELICS',
          meta: 'Control-panel pieces from the Disney ride — the first theme-park relics',
          odds: '1:22 packs',
          parallels: 6,
          cards: [
            { num: 'RR-B', title: 'BB-8' },
            { num: 'RR-F', title: 'Finn' },
            { num: 'RR-G', title: 'General Hux' },
            { num: 'RR-K', title: 'Kylo Ren' },
            { num: 'RR-N', title: 'Nien Nunb' },
            { num: 'RR-P', title: 'Poe Dameron' },
            { num: 'RR-R', title: 'Rey' },
            { num: 'RR-S', title: 'Stormtrooper' },
          ]
        },
        {
          count: 8,
          name: 'STORMTROOPER ARMOR RELICS',
          meta: 'Screen-used Force Awakens Stormtrooper costume pieces',
          odds: '1:39 packs',
          parallels: 5,
          cards: [
            { num: 'S-1', title: 'Dante Briggins', meta: 'Stormtrooper' },
            { num: 'S-2', title: 'Dante Briggins', meta: 'Stormtrooper' },
            { num: 'S-3', title: 'Pip Andersen', meta: 'Stormtrooper' },
            { num: 'S-4', title: 'Pip Andersen', meta: 'Stormtrooper' },
            { num: 'S-5', title: 'Sam Witwer', meta: 'Stormtrooper' },
            { num: 'S-6', title: 'Sam Witwer', meta: 'Stormtrooper' },
            { num: 'S-7', title: 'Verona Blue', meta: 'Stormtrooper' },
            { num: 'S-8', title: 'Verona Blue', meta: 'Stormtrooper' },
          ]
        },
      ],
      auto: [
        {
          count: 50,
          name: 'ON CARD AUTOGRAPHS',
          meta: 'Hard-signed · one guaranteed per box',
          odds: '1:2 packs',
          parallels: 7,
          cards: [
            { num: 'A-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'A-AB', title: 'Ahmed Best', meta: 'Kelleran Beq' },
            { num: 'A-AD', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'A-AM', title: 'Amy Allen', meta: 'Aayla Secura' },
            { num: 'A-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'A-B', title: 'Brian Blessed', meta: 'Boss Nass' },
            { num: 'A-BDW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'A-CL', title: 'Christopher Lloyd', meta: 'Commissioner Helgait' },
            { num: 'A-DM', title: 'Dominic Monaghan', meta: 'Beaumont Kin' },
            { num: 'A-DN', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'A-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'A-EE', title: 'Eman Esfandi', meta: 'Ezra Bridger' },
            { num: 'A-EK', title: 'Erin Kellyman', meta: 'Enfys Nest' },
            { num: 'A-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'A-FPJ', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'A-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'A-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'A-GT', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'A-IM', title: 'Ian McDiarmid', meta: 'Darth Sidious' },
            { num: 'A-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'A-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'A-JN', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'A-JR', title: 'John Ratzenberger', meta: 'Major Bren Derlin' },
            { num: 'A-KCH', title: 'Keisha Castle-Hughes', meta: 'Queen Apailana' },
            { num: 'A-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'A-KMT', title: 'Kelly Marie Tran', meta: 'Rose Tico' },
            { num: 'A-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'A-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'A-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'A-MA', title: 'Michelle Ang', meta: 'Omega' },
            { num: 'A-ME', title: 'Maya Erskine', meta: 'Sully Stark' },
            { num: 'A-MEW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'A-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'A-MNW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'A-MW', title: 'Matthew Wood', meta: 'General Grievous' },
            { num: 'A-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'A-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'A-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'A-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'A-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'A-SL', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'A-SLJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'A-SP', title: 'Simon Pegg', meta: 'Unkar Plutt' },
            { num: 'A-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'A-T', title: 'Stephen Bruner', meta: 'The Modifier' },
            { num: 'A-TB', title: 'Tom Baker', meta: 'Bendu' },
            { num: 'A-TC', title: 'Tim Curry', meta: 'Chancellor Palpatine' },
            { num: 'A-TN', title: 'Thandiwe Newton', meta: 'Val' },
            { num: 'A-WH', title: 'Werner Herzog', meta: 'The Client' },
          ]
        },
        {
          count: 9,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two-signer pairings',
          odds: '1:1,030 packs',
          parallels: 3,
          cards: [
            { num: 'DA-CB', title: 'Carrie Fisher / Billy Dee Williams', meta: 'Leia Organa / Lando Calrissian' },
            { num: 'DA-DH', title: 'Rosario Dawson / Hayden Christensen', meta: 'Ahsoka Tano / Anakin Skywalker' },
            { num: 'DA-EG', title: 'Giancarlo Esposito / Katee Sackhoff', meta: 'Moff Gideon / Bo-Katan Kryze' },
            { num: 'DA-EN', title: 'Eman Esfandi / Natasha Liu Bordizzo', meta: 'Ezra Bridger / Sabine Wren' },
            { num: 'DA-JC', title: 'Felicity Jones / Diego Luna', meta: 'Jyn Erso / Cassian Andor' },
            { num: 'DA-PG', title: 'Freddie Prinze Jr. / Sarah Michelle Gellar', meta: 'Kanan Jarrus / Seventh Sister' },
            { num: 'DA-PM', title: 'Ray Park / Ewan McGregor', meta: 'Darth Maul / Obi-Wan Kenobi' },
            { num: 'DA-RA', title: 'Tom Wilton / Tim Rose', meta: 'Aftab Ackbar / Admiral Ackbar' },
            { num: 'DA-RM', title: 'Daisy Ridley / Ian McDiarmid', meta: 'Dark Rey / Emperor Palpatine' },
          ]
        },
        {
          count: 4,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three-signer combinations',
          odds: '1:2,017 packs',
          parallels: 3,
          cards: [
            { num: 'TA-AT', title: 'Rosario Dawson / Mary Elizabeth Winstead / Natasha Liu Bordizzo', meta: 'Ahsoka Tano / Hera Syndulla / Sabine Wren' },
            { num: 'TA-EMP', title: 'Billy Dee Williams / David Prowse / Jeremy Bulloch', meta: 'Lando Calrissian / Darth Vader / Boba Fett' },
            { num: 'TA-GP', title: 'Daisy Ridley / Natalie Portman / Carrie Fisher', meta: 'Rey / Queen Amidala / Princess Leia' },
            { num: 'TA-ROJ', title: 'Peter Mayhew / Mark Hamill / Harrison Ford', meta: 'Chewbacca / Luke Skywalker / Han Solo' },
          ]
        },
        {
          count: 3,
          name: 'QUAD AUTOGRAPH BOOK CARDS',
          meta: 'Four-signer book cards',
          odds: '1:3,227 packs',
          parallels: 1,
          cards: [
            { num: 'QAB-DSGG', title: 'Mark Hamill / Rosario Dawson / Temuera Morrison / Pedro Pascal', meta: 'Luke Skywalker / Ahsoka Tano / Boba Fett / The Mandalorian' },
            { num: 'QAB-DWBE', title: 'Mary Elizabeth Winstead / Natasha Liu Bordizzo / Eman Esfandi / Rosario Dawson', meta: 'Hera Syndulla / Sabine Wren / Ezra Bridger / Ahsoka Tano' },
            { num: 'QAB-MPPH', title: 'Domnall Gleeson / Andy Serkis / Adam Driver / Richard Grant', meta: 'General Hux / Supreme Leader Snoke / Supreme Leader Kylo Ren / General Pryde' },
          ]
        },
        {
          count: 31,
          name: 'PEN AUTOGRAPH RELICS',
          meta: 'A piece of the signing pen · one-of-one',
          odds: '1:1,669 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'AP-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'AP-AB', title: 'Ahmed Best', meta: 'Kelleran Beq' },
            { num: 'AP-AD', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'AP-AM', title: 'Amy Allen', meta: 'Aayla Secura' },
            { num: 'AP-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'AP-B', title: 'Brian Blessed', meta: 'Boss Nass' },
            { num: 'AP-DM', title: 'Dominic Monaghan', meta: 'Beaumont Kin' },
            { num: 'AP-DN', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'AP-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'AP-EK', title: 'Erin Kellyman', meta: 'Enfys Nest' },
            { num: 'AP-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'AP-FPJ', title: 'Freddie Prinze Jr.', meta: 'Kanan Jarrus' },
            { num: 'AP-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'AP-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'AP-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'AP-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'AP-JN', title: 'Jennifer Beals', meta: 'Garsa Fwip' },
            { num: 'AP-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'AP-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'AP-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'AP-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'AP-MEW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'AP-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'AP-MM', title: 'Mads Mikkelsen', meta: 'Galen Erso' },
            { num: 'AP-MNW', title: 'Ming-Na Wen', meta: 'Fennec Shand' },
            { num: 'AP-MW', title: 'Matthew Wood', meta: 'General Grievous' },
            { num: 'AP-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'AP-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'AP-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'AP-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'AP-T', title: 'Stephen Bruner', meta: 'The Modifier' },
          ]
        },
        {
          count: 2,
          name: 'STORMTROOPER ARMOR AUTOGRAPH VARIATION',
          meta: 'Signed armor relics · one-of-one',
          odds: '1:2,423 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SA-D', title: 'Dante Briggins', meta: 'Stormtrooper' },
            { num: 'SA-S', title: 'Sam Witwer', meta: 'Stormtrooper' },
          ]
        },
      ],
      sketch: [
        {
          count: 182,
          name: 'SKETCH CARDS',
          meta: 'One-of-one sketches · also pulled as Book (1:423), Triptych (1:385) & Panoramic (1:563) formats',
          odds: '1:4 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Sketch Card', meta: 'Angel Aviles' },
            { num: 'SK-2', title: 'Sketch Card', meta: 'Ashley Marsh' },
            { num: 'SK-3', title: 'Sketch Card', meta: 'Ben Jones' },
            { num: 'SK-4', title: 'Sketch Card', meta: 'Mayumi Seto' },
            { num: 'SK-5', title: 'Sketch Card', meta: 'Carlos Cabaleiro' },
            { num: 'SK-6', title: 'Sketch Card', meta: 'Cisco Rivera' },
            { num: 'SK-7', title: 'Sketch Card', meta: 'Dan Bergren' },
            { num: 'SK-8', title: 'Sketch Card', meta: 'Gabe Farber' },
            { num: 'SK-9', title: 'Sketch Card', meta: 'Jamison Murdock' },
            { num: 'SK-10', title: 'Sketch Card', meta: 'Jason Davies' },
            { num: 'SK-11', title: 'Sketch Card', meta: 'Josh Trout' },
            { num: 'SK-12', title: 'Sketch Card', meta: 'DYJ' },
            { num: 'SK-13', title: 'Sketch Card', meta: 'Kris Penix' },
            { num: 'SK-14', title: 'Sketch Card', meta: 'Shyla Lee' },
            { num: 'SK-15', title: 'Sketch Card', meta: 'Yves Van Berlo' },
            { num: 'SK-16', title: 'Sketch Card', meta: 'Aaron Lenahan' },
            { num: 'SK-17', title: 'Sketch Card', meta: 'Adam Beck' },
            { num: 'SK-18', title: 'Sketch Card', meta: 'Allen Grimes' },
            { num: 'SK-19', title: 'Sketch Card', meta: 'Andy Hanks' },
            { num: 'SK-20', title: 'Sketch Card', meta: 'Anthony Pietszak' },
            { num: 'SK-21', title: 'Sketch Card', meta: 'Basak Kahraman' },
            { num: 'SK-22', title: 'Sketch Card', meta: 'Bobby Blakey' },
            { num: 'SK-23', title: 'Sketch Card', meta: 'Brandon Klein' },
            { num: 'SK-24', title: 'Sketch Card', meta: 'Brandon "B.Done" Blevins' },
            { num: 'SK-25', title: 'Sketch Card', meta: 'Chris Thorne' },
            { num: 'SK-26', title: 'Sketch Card', meta: 'Christoffer Allen Victoria' },
            { num: 'SK-27', title: 'Sketch Card', meta: 'Clinton Yeager' },
            { num: 'SK-28', title: 'Sketch Card', meta: 'Cory Payne, CMP' },
            { num: 'SK-29', title: 'Sketch Card', meta: 'Dan Cooney' },
            { num: 'SK-30', title: 'Sketch Card', meta: 'Dan Lawler' },
            { num: 'SK-31', title: 'Sketch Card', meta: 'Dan Gorman' },
            { num: 'SK-32', title: 'Sketch Card', meta: 'Dave Wilson' },
            { num: 'SK-33', title: 'Sketch Card', meta: 'David Willingham' },
            { num: 'SK-34', title: 'Sketch Card', meta: 'Debjit Kar' },
            { num: 'SK-35', title: 'Sketch Card', meta: 'Derek A Johnson' },
            { num: 'SK-36', title: 'Sketch Card', meta: 'Dirk Shearer' },
            { num: 'SK-37', title: 'Sketch Card', meta: 'Emre VARLIBAŞ' },
            { num: 'SK-38', title: 'Sketch Card', meta: 'Ian McKesson' },
            { num: 'SK-39', title: 'Sketch Card', meta: 'J.Hammond' },
            { num: 'SK-40', title: 'Sketch Card', meta: 'Jackson "JackArts" Ong' },
            { num: 'SK-41', title: 'Sketch Card', meta: 'Jake Minor' },
            { num: 'SK-42', title: 'Sketch Card', meta: 'James Harris' },
            { num: 'SK-43', title: 'Sketch Card', meta: 'Jamie Richards' },
            { num: 'SK-44', title: 'Sketch Card', meta: 'Jane Rushton' },
            { num: 'SK-45', title: 'Sketch Card', meta: 'Jason Sobol' },
            { num: 'SK-46', title: 'Sketch Card', meta: 'Jeffrey C. Benitez' },
            { num: 'SK-47', title: 'Sketch Card', meta: 'Jessica Van Dusen' },
            { num: 'SK-48', title: 'Sketch Card', meta: 'Joey Mason' },
            { num: 'SK-49', title: 'Sketch Card', meta: 'John Still' },
            { num: 'SK-50', title: 'Sketch Card', meta: 'John Pleak' },
            { num: 'SK-51', title: 'Sketch Card', meta: 'Joe Ortiz' },
            { num: 'SK-52', title: 'Sketch Card', meta: 'Julia McKenzie' },
            { num: 'SK-53', title: 'Sketch Card', meta: 'Julie-Anne' },
            { num: 'SK-54', title: 'Sketch Card', meta: 'Karl Jones' },
            { num: 'SK-55', title: 'Sketch Card', meta: 'Keith Farnum' },
            { num: 'SK-56', title: 'Sketch Card', meta: 'Kevin Scott Jacobs' },
            { num: 'SK-57', title: 'Sketch Card', meta: 'Khloe Delnick' },
            { num: 'SK-58', title: 'Sketch Card', meta: 'Krishna Sharma' },
            { num: 'SK-59', title: 'Sketch Card', meta: 'Lukas Maurer' },
            { num: 'SK-60', title: 'Sketch Card', meta: 'Luke Seavers' },
            { num: 'SK-61', title: 'Sketch Card', meta: 'Marlo Agunos' },
            { num: 'SK-62', title: 'Sketch Card', meta: 'Matt Steffens' },
            { num: 'SK-63', title: 'Sketch Card', meta: 'Matt Stewart' },
            { num: 'SK-64', title: 'Sketch Card', meta: 'Michael Munshaw' },
            { num: 'SK-65', title: 'Sketch Card', meta: 'Mike J Sealie' },
            { num: 'SK-66', title: 'Sketch Card', meta: 'Mike LaPeruta' },
            { num: 'SK-67', title: 'Sketch Card', meta: 'Mike Dalzell' },
            { num: 'SK-68', title: 'Sketch Card', meta: 'Mongola Das' },
            { num: 'SK-69', title: 'Sketch Card', meta: 'Neil Camera' },
            { num: 'SK-70', title: 'Sketch Card', meta: 'Neil A Brady' },
            { num: 'SK-71', title: 'Sketch Card', meta: 'Nick Sutphin' },
            { num: 'SK-72', title: 'Sketch Card', meta: 'Oscar Chavez' },
            { num: 'SK-73', title: 'Sketch Card', meta: 'Patrick Giles' },
            { num: 'SK-74', title: 'Sketch Card', meta: 'Rich "RAM" Molinelli' },
            { num: 'SK-75', title: 'Sketch Card', meta: 'Rob Demers' },
            { num: 'SK-76', title: 'Sketch Card', meta: 'Rusty Gilligan' },
            { num: 'SK-77', title: 'Sketch Card', meta: 'Ryan Edwards' },
            { num: 'SK-78', title: 'Sketch Card', meta: 'Ryan Thompson' },
            { num: 'SK-79', title: 'Sketch Card', meta: 'Ryan Johnston' },
            { num: 'SK-80', title: 'Sketch Card', meta: 'Scott West' },
            { num: 'SK-81', title: 'Sketch Card', meta: 'Sean Mathews' },
            { num: 'SK-82', title: 'Sketch Card', meta: 'Srijan Das' },
            { num: 'SK-83', title: 'Sketch Card', meta: 'Rico Dela Rosa' },
            { num: 'SK-84', title: 'Sketch Card', meta: 'Vincenzo "Chenduz" D\'Ippolito' },
            { num: 'SK-85', title: 'Sketch Card', meta: 'Zach Woolsey' },
            { num: 'SK-86', title: 'Sketch Card', meta: 'Alex Mines' },
            { num: 'SK-87', title: 'Sketch Card', meta: 'Angelina Benedetti' },
            { num: 'SK-88', title: 'Sketch Card', meta: 'Brent Scotchmer' },
            { num: 'SK-89', title: 'Sketch Card', meta: 'Candice Dailey' },
            { num: 'SK-90', title: 'Sketch Card', meta: 'Cyrus Sherkat' },
            { num: 'SK-91', title: 'Sketch Card', meta: 'Daniel Chavez' },
            { num: 'SK-92', title: 'Sketch Card', meta: 'Dan Tearle' },
            { num: 'SK-93', title: 'Sketch Card', meta: 'Darrin Pepe' },
            { num: 'SK-94', title: 'Sketch Card', meta: 'Dave Gaskin' },
            { num: 'SK-95', title: 'Sketch Card', meta: 'Douglas Stromenger' },
            { num: 'SK-96', title: 'Sketch Card', meta: 'Eddie Rhodes III' },
            { num: 'SK-97', title: 'Sketch Card', meta: 'Eric Lehtonen' },
            { num: 'SK-98', title: 'Sketch Card', meta: 'Frank A. Kadar' },
            { num: 'SK-99', title: 'Sketch Card', meta: 'Gerry Garcia Jr' },
            { num: 'SK-100', title: 'Sketch Card', meta: 'Jason Christner' },
            { num: 'SK-101', title: 'Sketch Card', meta: 'Jason Saldajeno' },
            { num: 'SK-102', title: 'Sketch Card', meta: 'Jay Manchand' },
            { num: 'SK-103', title: 'Sketch Card', meta: 'Jonathan Beistline' },
            { num: 'SK-104', title: 'Sketch Card', meta: 'Kang Jing' },
            { num: 'SK-105', title: 'Sketch Card', meta: 'Kevin Graham' },
            { num: 'SK-106', title: 'Sketch Card', meta: 'Kyle Babbitt' },
            { num: 'SK-107', title: 'Sketch Card', meta: 'Lindsey Greyling' },
            { num: 'SK-108', title: 'Sketch Card', meta: 'Madison Emerick' },
            { num: 'SK-109', title: 'Sketch Card', meta: 'Marcia Dye' },
            { num: 'SK-110', title: 'Sketch Card', meta: 'Patricio Carrasco' },
            { num: 'SK-111', title: 'Sketch Card', meta: 'Rebeca Louro' },
            { num: 'SK-112', title: 'Sketch Card', meta: 'Rugved Bhuskute' },
            { num: 'SK-113', title: 'Sketch Card', meta: 'Sammy Gomez' },
            { num: 'SK-114', title: 'Sketch Card', meta: 'Semra Bulut' },
            { num: 'SK-115', title: 'Sketch Card', meta: 'Steve Alce' },
            { num: 'SK-116', title: 'Sketch Card', meta: 'Veronica Louro' },
            { num: 'SK-117', title: 'Sketch Card', meta: 'Will Pleydon' },
            { num: 'SK-118', title: 'Sketch Card', meta: 'Aleksandr Gigov' },
            { num: 'SK-119', title: 'Sketch Card', meta: 'Andrew Fry' },
            { num: 'SK-120', title: 'Sketch Card', meta: 'Antni Ellison' },
            { num: 'SK-121', title: 'Sketch Card', meta: 'Roy Cover' },
            { num: 'SK-122', title: 'Sketch Card', meta: 'Sir Edmund Duke' },
            { num: 'SK-123', title: 'Sketch Card', meta: 'Brent Ragland' },
            { num: 'SK-124', title: 'Sketch Card', meta: 'Candice Clemmons' },
            { num: 'SK-125', title: 'Sketch Card', meta: 'Charlie Cody' },
            { num: 'SK-126', title: 'Sketch Card', meta: 'Dan Curto' },
            { num: 'SK-127', title: 'Sketch Card', meta: 'Daniel Riveron' },
            { num: 'SK-128', title: 'Sketch Card', meta: 'Dawn Murphy' },
            { num: 'SK-129', title: 'Sketch Card', meta: 'Don Pedicini Jr' },
            { num: 'SK-130', title: 'Sketch Card', meta: 'David "Dove" McHargue' },
            { num: 'SK-131', title: 'Sketch Card', meta: 'Dwayne Carpenter' },
            { num: 'SK-132', title: 'Sketch Card', meta: 'Dylan Riley' },
            { num: 'SK-133', title: 'Sketch Card', meta: 'Elvin A Hernandez' },
            { num: 'SK-134', title: 'Sketch Card', meta: 'Emrah Cildir' },
            { num: 'SK-135', title: 'Sketch Card', meta: 'Eric Medina' },
            { num: 'SK-136', title: 'Sketch Card', meta: 'Erik Muller' },
            { num: 'SK-137', title: 'Sketch Card', meta: 'Evgheni Batu' },
            { num: 'SK-138', title: 'Sketch Card', meta: 'Frank Sansone' },
            { num: 'SK-139', title: 'Sketch Card', meta: 'Garrett Dix' },
            { num: 'SK-140', title: 'Sketch Card', meta: 'Isiah Xavier Bradley' },
            { num: 'SK-141', title: 'Sketch Card', meta: 'Jaime Lopez' },
            { num: 'SK-142', title: 'Sketch Card', meta: 'Jim O\'Riley' },
            { num: 'SK-143', title: 'Sketch Card', meta: 'James Boyd' },
            { num: 'SK-144', title: 'Sketch Card', meta: 'Jim Dickson' },
            { num: 'SK-145', title: 'Sketch Card', meta: 'Jason Queen' },
            { num: 'SK-146', title: 'Sketch Card', meta: 'Jason Montoya' },
            { num: 'SK-147', title: 'Sketch Card', meta: 'Jason Adams' },
            { num: 'SK-148', title: 'Sketch Card', meta: 'Jessica Hickman' },
            { num: 'SK-149', title: 'Sketch Card', meta: 'John "JAR" Rodriguez' },
            { num: 'SK-150', title: 'Sketch Card', meta: 'John Bruce' },
            { num: 'SK-151', title: 'Sketch Card', meta: 'Kevin Cleveland' },
            { num: 'SK-152', title: 'Sketch Card', meta: 'Limuel Pinzon' },
            { num: 'SK-153', title: 'Sketch Card', meta: 'Mathilde Machuel' },
            { num: 'SK-154', title: 'Sketch Card', meta: 'Matt Maldonado' },
            { num: 'SK-155', title: 'Sketch Card', meta: 'Matthew Sutton' },
            { num: 'SK-156', title: 'Sketch Card', meta: 'Michael Mastermaker' },
            { num: 'SK-157', title: 'Sketch Card', meta: 'Nathaniel Howard' },
            { num: 'SK-158', title: 'Sketch Card', meta: 'Nick Gribbon' },
            { num: 'SK-159', title: 'Sketch Card', meta: 'Patrick Richardson' },
            { num: 'SK-160', title: 'Sketch Card', meta: 'Phillip Trujillo' },
            { num: 'SK-161', title: 'Sketch Card', meta: 'Rachel Jane Hetherington' },
            { num: 'SK-162', title: 'Sketch Card', meta: 'Rees Chua-Finlay' },
            { num: 'SK-163', title: 'Sketch Card', meta: 'Rich Hennemann' },
            { num: 'SK-164', title: 'Sketch Card', meta: 'El Smetchö' },
            { num: 'SK-165', title: 'Sketch Card', meta: 'Robert Hendrickson' },
            { num: 'SK-166', title: 'Sketch Card', meta: 'Rutvig Vaid' },
            { num: 'SK-167', title: 'Sketch Card', meta: 'Ryan Crosby' },
            { num: 'SK-168', title: 'Sketch Card', meta: 'Ryan Finley' },
            { num: 'SK-169', title: 'Sketch Card', meta: 'Ryan Moffett' },
            { num: 'SK-170', title: 'Sketch Card', meta: 'Ryan Olsen' },
            { num: 'SK-171', title: 'Sketch Card', meta: 'Sam Barugh' },
            { num: 'SK-172', title: 'Sketch Card', meta: 'Sean Earey' },
            { num: 'SK-173', title: 'Sketch Card', meta: 'Shaow Siong' },
            { num: 'SK-174', title: 'Sketch Card', meta: 'Stephane Leonardi' },
            { num: 'SK-175', title: 'Sketch Card', meta: 'Ted Dastick Jr' },
            { num: 'SK-176', title: 'Sketch Card', meta: 'Tim Shinn' },
            { num: 'SK-177', title: 'Sketch Card', meta: 'Tom Amici' },
            { num: 'SK-178', title: 'Sketch Card', meta: 'Tony Riley' },
            { num: 'SK-179', title: 'Sketch Card', meta: 'Traci Easterday' },
            { num: 'SK-180', title: 'Sketch Card', meta: 'Vini Pirani' },
            { num: 'SK-181', title: 'Sketch Card', meta: 'Ward Silverman' },
            { num: 'SK-182', title: 'Sketch Card', meta: 'Mike Stephens' },
          ]
        },
      ],
    },
  },


  '2022-chrome-black': {
    setId: '2022-chrome-black',
    year: '2022',
    brand: 'TOPPS',
    title: 'STAR WARS CHROME BLACK',
    releaseDate: '11 / 2 / 2022',
    lede: 'The set that launched the Chrome Black line — a vault-format product of a single four-card pack per box, every box carrying an encased autograph and a serial-numbered base parallel. The 100-card base set prints the saga\'s most sought-after characters on black chromium under an eight-step refractor ladder from /199 to Superfractor, and behind it sits a 140-card, all-encased autograph program in four tiers: the 69-signer A design, the 45-card B design with its shorter rainbow, and the short-printed Dark Side and Galactic Black autographs at 1:16 and 1:58 boxes.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Black chromium stock', color: 'gold' },
      { num: '140', label: 'Auto Cards', sub: 'Encased · 1 per box', color: 'green' },
      { num: '8', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '4', label: 'Auto Tiers', sub: 'Incl. 2 short prints', color: 'cyan' },
      { num: '5', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '1', l: 'Encased autograph per box' },
      { v: '1', l: 'Numbered base parallel per box' },
      { v: '4', l: 'Cards per box · one pack' },
      { v: '12', l: 'Boxes per case' },
    ],
    pullRates: [
      { name: 'Refractors /199', odds: '1 : 2', tier: 'normal' },
      { name: 'Green Refractors /99', odds: '1 : 4', tier: 'normal' },
      { name: 'Blue Refractors /75', odds: '1 : 5', tier: 'normal' },
      { name: 'Gold Refractors /50', odds: '1 : 7', tier: 'normal' },
      { name: 'Orange Refractors /25', odds: '1 : 14', tier: 'normal' },
      { name: 'Dark Side Autographs', odds: '1 : 16', tier: 'rare' },
      { name: 'Magenta Refractors /10', odds: '1 : 34', tier: 'rare' },
      { name: 'Galactic Black Autographs', odds: '1 : 58', tier: 'rare' },
      { name: 'Red Refractors /5', odds: '1 : 68', tier: 'rare' },
      { name: 'A Design Superfractors 1/1', odds: '1 : 409', tier: 'mythic' },
      { name: 'B Design Superfractors 1/1', odds: '1 : 660', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '/199', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'GREEN', pr: '/99', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'BLUE', pr: '/75', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'MAGENTA', pr: '/10', gradient: 'linear-gradient(135deg, #ff40a0 0%, #c01070 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'The saga\'s most sought-after characters on black chromium',
          parallels: 8,
          cards: [
            { num: '1', title: 'Darth Vader', meta: 'Star Wars: A New Hope' },
            { num: '2', title: 'Obi-Wan Kenobi', meta: 'Star Wars: The Phantom Menace' },
            { num: '3', title: 'Yoda', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '4', title: 'Han Solo', meta: 'Star Wars: A New Hope' },
            { num: '5', title: 'Luke Skywalker', meta: 'Star Wars: A New Hope' },
            { num: '6', title: 'Chewbacca', meta: 'Star Wars: A New Hope' },
            { num: '7', title: 'R2-D2', meta: 'Star Wars: A New Hope' },
            { num: '8', title: 'Princess Leia Organa', meta: 'Star Wars: A New Hope' },
            { num: '9', title: 'Boba Fett', meta: 'Star Wars: Return of the Jedi' },
            { num: '10', title: 'Darth Maul', meta: 'Star Wars: The Phantom Menace' },
            { num: '11', title: 'Ahsoka Tano', meta: 'The Mandalorian' },
            { num: '12', title: 'The Mandalorian', meta: 'The Mandalorian' },
            { num: '13', title: 'Emperor Palpatine', meta: 'Star Wars: Revenge of the Sith' },
            { num: '14', title: 'C-3PO', meta: 'Star Wars: A New Hope' },
            { num: '15', title: 'Lando Calrissian', meta: 'Solo: A Star Wars Story' },
            { num: '16', title: 'Grogu', meta: 'The Mandalorian' },
            { num: '17', title: 'Jabba The Hutt', meta: 'Star Wars: The Phantom Menace' },
            { num: '18', title: 'Admiral Ackbar', meta: 'Star Wars: The Force Awakens' },
            { num: '19', title: 'Count Dooku', meta: 'Star Wars: Attack of the Clones' },
            { num: '20', title: 'Kylo Ren', meta: 'Star Wars: The Force Awakens' },
            { num: '21', title: 'Rey', meta: 'Star Wars: The Force Awakens' },
            { num: '22', title: 'BB-8', meta: 'Star Wars: The Force Awakens' },
            { num: '23', title: 'Poe Dameron', meta: 'Star Wars: The Force Awakens' },
            { num: '24', title: 'Finn', meta: 'Star Wars: The Force Awakens' },
            { num: '25', title: 'Greedo', meta: 'Star Wars: A New Hope' },
            { num: '26', title: 'K-2SO', meta: 'Rogue One: A Star Wars Story' },
            { num: '27', title: 'Captain Tarkin', meta: 'Star Wars: The Clone Wars' },
            { num: '28', title: 'Mace Windu', meta: 'Star Wars: Attack of the Clones' },
            { num: '29', title: 'Chirrut Îmwe', meta: 'Rogue One: A Star Wars Story' },
            { num: '30', title: 'Bib Fortuna', meta: 'Star Wars: The Phantom Menace' },
            { num: '31', title: 'Qui-Gon Jinn', meta: 'Star Wars: The Phantom Menace' },
            { num: '32', title: 'General Grievous', meta: 'Star Wars: Revenge of the Sith' },
            { num: '33', title: 'Wicket W. Warrick', meta: 'Star Wars: Return of the Jedi' },
            { num: '34', title: 'Enfys Nest', meta: 'Solo: A Star Wars Story' },
            { num: '35', title: 'Mon Mothma', meta: 'Star Wars: Return of the Jedi' },
            { num: '36', title: 'Vice Admiral Holdo', meta: 'Star Wars: The Last Jedi' },
            { num: '37', title: 'Wedge Antilles', meta: 'Star Wars: Return of the Jedi' },
            { num: '38', title: 'Qi\'ra', meta: 'Solo: A Star Wars Story' },
            { num: '39', title: 'Jar Jar Binks', meta: 'Star Wars: The Phantom Menace' },
            { num: '40', title: 'Sebulba', meta: 'Star Wars: The Phantom Menace' },
            { num: '41', title: 'Padmé Amidala', meta: 'Star Wars: The Phantom Menace' },
            { num: '42', title: 'Jango Fett', meta: 'Star Wars: Attack of the Clones' },
            { num: '43', title: 'Hunter', meta: 'Star Wars: The Bad Batch' },
            { num: '44', title: 'Wrecker', meta: 'Star Wars: The Bad Batch' },
            { num: '45', title: 'Tech', meta: 'Star Wars: The Bad Batch' },
            { num: '46', title: 'Crosshair', meta: 'Star Wars: The Bad Batch' },
            { num: '47', title: 'Echo', meta: 'Star Wars: The Bad Batch' },
            { num: '48', title: 'Omega', meta: 'Star Wars: The Bad Batch' },
            { num: '49', title: 'Captain Phasma', meta: 'Star Wars: The Force Awakens' },
            { num: '50', title: 'Grand Admiral Thrawn', meta: 'Star Wars Rebels' },
            { num: '51', title: 'Asajj Ventress', meta: 'Star Wars: The Clone Wars' },
            { num: '52', title: 'Moff Gideon', meta: 'The Mandalorian' },
            { num: '53', title: 'Fennec Shand', meta: 'The Mandalorian' },
            { num: '54', title: 'Koska Reeves', meta: 'The Mandalorian' },
            { num: '55', title: 'Kuiil', meta: 'The Mandalorian' },
            { num: '56', title: 'IG-11', meta: 'The Mandalorian' },
            { num: '57', title: 'Greef Karga', meta: 'The Mandalorian' },
            { num: '58', title: 'Mayfeld', meta: 'The Mandalorian' },
            { num: '59', title: 'Cobb Vanth', meta: 'The Mandalorian' },
            { num: '60', title: 'Peli Motto', meta: 'The Mandalorian' },
            { num: '61', title: 'Bo-Katan Kryze', meta: 'The Mandalorian' },
            { num: '62', title: 'Axe Woves', meta: 'The Mandalorian' },
            { num: '63', title: 'Ezra Bridger', meta: 'Star Wars Rebels' },
            { num: '64', title: 'Sabine Wren', meta: 'Star Wars Rebels' },
            { num: '65', title: 'Kanan Jarrus', meta: 'Star Wars Rebels' },
            { num: '66', title: 'Captain Rex', meta: 'Star Wars Rebels' },
            { num: '67', title: 'The Grand Inquisitor', meta: 'Star Wars Rebels' },
            { num: '68', title: 'Zeb Orrelios', meta: 'Star Wars Rebels' },
            { num: '69', title: 'Hera Syndulla', meta: 'Star Wars Rebels' },
            { num: '70', title: 'Saw Gerrera', meta: 'Rogue One: A Star Wars Story' },
            { num: '71', title: 'Jyn Erso', meta: 'Rogue One: A Star Wars Story' },
            { num: '72', title: 'Cassian Andor', meta: 'Rogue One: A Star Wars Story' },
            { num: '73', title: 'Galen Erso', meta: 'Rogue One: A Star Wars Story' },
            { num: '74', title: 'Bodhi Rook', meta: 'Rogue One: A Star Wars Story' },
            { num: '75', title: 'Director Krennic', meta: 'Rogue One: A Star Wars Story' },
            { num: '76', title: 'Kit Fisto', meta: 'Star Wars: Revenge of the Sith' },
            { num: '77', title: 'Boushh', meta: 'Star Wars: Return of the Jedi' },
            { num: '78', title: 'Biggs Darklighter', meta: 'Star Wars: A New Hope' },
            { num: '79', title: 'Zam Wesell', meta: 'Star Wars: Attack of the Clones' },
            { num: '80', title: 'Bolo', meta: 'Star Wars: The Bad Batch' },
            { num: '81', title: 'Commander Cody', meta: 'Star Wars: Revenge of the Sith' },
            { num: '82', title: 'IG-88', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '83', title: 'Anakin Skywalker', meta: 'Star Wars: Revenge of the Sith' },
            { num: '84', title: 'Supreme Leader Snoke', meta: 'Star Wars: The Last Jedi' },
            { num: '85', title: 'Rose Tico', meta: 'Star Wars: The Last Jedi' },
            { num: '86', title: 'Beaumont Kin', meta: 'Star Wars: The Rise of Skywalker' },
            { num: '87', title: 'Aurra Sing', meta: 'Star Wars: The Phantom Menace' },
            { num: '88', title: 'Cad Bane', meta: 'Star Wars: The Clone Wars' },
            { num: '89', title: 'Nala Se', meta: 'Star Wars: The Bad Batch' },
            { num: '90', title: 'Lama Su', meta: 'Star Wars: The Bad Batch' },
            { num: '91', title: 'Cut Lawquane', meta: 'Star Wars: The Bad Batch' },
            { num: '92', title: 'Vice Admiral Rampart', meta: 'Star Wars: The Bad Batch' },
            { num: '93', title: 'Quinlan Vos', meta: 'Star Wars: The Clone Wars' },
            { num: '94', title: 'Lobot', meta: 'Star Wars: The Empire Strikes Back' },
            { num: '95', title: 'Max Rebo', meta: 'Star Wars: Return of the Jedi' },
            { num: '96', title: 'Salacious B. Crumb', meta: 'Star Wars: Return of the Jedi' },
            { num: '97', title: 'Pao', meta: 'Rogue One: A Star Wars Story' },
            { num: '98', title: 'Sidon Ithano', meta: 'Star Wars: The Force Awakens' },
            { num: '99', title: 'Plo Koon', meta: 'Star Wars: Revenge of the Sith' },
            { num: '100', title: 'Cid', meta: 'Star Wars: The Bad Batch' },
          ]
        },
      ],
      auto: [
        {
          count: 69,
          name: 'AUTOGRAPHS A DESIGN',
          meta: 'Encased · Green /99 → Superfractor rainbow',
          parallels: 5,
          cards: [
            { num: 'A-AB', title: 'Anna Brewster' },
            { num: 'A-AD', title: 'Adam Driver' },
            { num: 'A-AEH', title: 'Alden Ehrenreich' },
            { num: 'A-AK', title: 'Andrew Kishino' },
            { num: 'A-AS', title: 'Andy Serkis' },
            { num: 'A-ASE', title: 'Amy Sedaris' },
            { num: 'A-BD', title: 'Ben Diskin', meta: 'The Bad Batch' },
            { num: 'A-BDW', title: 'Billy Dee Williams', meta: 'The Rise of Skywalker' },
            { num: 'A-BED', title: 'Ben Daniels' },
            { num: 'A-BL', title: 'Billie Lourd', meta: 'The Rise of Skywalker' },
            { num: 'A-CF', title: 'Carrie Fisher', meta: 'The Last Jedi' },
            { num: 'A-CM', title: 'Cameron Monaghan' },
            { num: 'A-CS', title: 'Christopher Sean' },
            { num: 'A-CW', title: 'Carl Weathers' },
            { num: 'A-DBB', title: 'Dee Bradley Baker', meta: 'The Bad Batch' },
            { num: 'A-DBC', title: 'Dee Bradley Baker' },
            { num: 'A-DBE', title: 'Dee Bradley Baker', meta: 'The Bad Batch' },
            { num: 'A-DBH', title: 'Dee Bradley Baker' },
            { num: 'A-DBT', title: 'Dee Bradley Baker' },
            { num: 'A-DBW', title: 'Dee Bradley Baker' },
            { num: 'A-DC', title: 'Dave Chapman' },
            { num: 'A-DLI', title: 'Diana Lee Inosanto' },
            { num: 'A-DR', title: 'Daisy Ridley' },
            { num: 'A-EC', title: 'Emilia Clarke' },
            { num: 'A-EK', title: 'Erin Kellyman' },
            { num: 'A-EM', title: 'Ewan McGregor' },
            { num: 'A-ES', title: 'Emily Swallow' },
            { num: 'A-FJ', title: 'Felicity Jones', meta: 'Rogue One' },
            { num: 'A-FPJ', title: 'Freddie Prinze Jr.' },
            { num: 'A-FW', title: 'Forest Whitaker', meta: 'Rogue One' },
            { num: 'A-GC', title: 'Gwendoline Christie' },
            { num: 'A-GE', title: 'Giancarlo Esposito' },
            { num: 'A-GG', title: 'Greg Grunberg', meta: 'The Rise of Skywalker' },
            { num: 'A-HC', title: 'Hayden Christensen' },
            { num: 'A-HF', title: 'Harrison Ford' },
            { num: 'A-HQ', title: 'Hugh Quarshie' },
            { num: 'A-IM', title: 'Ian McDiarmid' },
            { num: 'A-JB', title: 'John Boyega', meta: 'The Rise of Skywalker' },
            { num: 'A-JC', title: 'Jim Cummings', meta: 'Rebels' },
            { num: 'A-JD', title: 'Julie Dolan' },
            { num: 'A-JK', title: 'Jaime King' },
            { num: 'A-KMT', title: 'Kelly Marie Tran' },
            { num: 'A-KSH', title: 'Kiran Shah' },
            { num: 'A-MD', title: 'Mark Dodson' },
            { num: 'A-MIB', title: 'Michonne Bourriague' },
            { num: 'A-MNW', title: 'Ming-Na Wen', meta: 'The Mandalorian' },
            { num: 'A-MV', title: 'Mercedes Varnado' },
            { num: 'A-MW', title: 'Matthew Wood' },
            { num: 'A-NA', title: 'Naomi Ackie' },
            { num: 'A-NF', title: 'Nika Futterman' },
            { num: 'A-NN', title: 'Nick Nolte' },
            { num: 'A-NP', title: 'Natalie Portman', meta: 'Revenge of the Sith' },
            { num: 'A-PAR', title: 'Philip Anthony-Rodriguez' },
            { num: 'A-PK', title: 'Paul Kasey', meta: 'Rogue One' },
            { num: 'A-PL', title: 'Phil LaMarr', meta: 'The Bad Batch' },
            { num: 'A-PSL', title: 'Paul Sun-Hyung Lee' },
            { num: 'A-RAD', title: 'Robin Atkin Downes', meta: 'The Bad Batch' },
            { num: 'A-RD', title: 'Rosario Dawson' },
            { num: 'A-RZ', title: 'Riz Ahmed' },
            { num: 'A-SA', title: 'Stephen Stanton', meta: 'The Bad Batch' },
            { num: 'A-SB', title: 'Steve Blum' },
            { num: 'A-SL', title: 'Scott Lawrence' },
            { num: 'A-SLJ', title: 'Samuel L. Jackson', meta: 'Revenge of the Sith' },
            { num: 'A-TG', title: 'Taylor Gray' },
            { num: 'A-TR', title: 'Tim Rose' },
            { num: 'A-TS', title: 'Tiya Sircar', meta: 'Rebels' },
            { num: 'A-VM', title: 'Vanessa Marshall', meta: 'The Bad Batch' },
            { num: 'A-WD', title: 'Warwick Davis', meta: 'The Rise of Skywalker' },
            { num: 'A-WH', title: 'Werner Herzog' },
          ]
        },
        {
          count: 45,
          name: 'AUTOGRAPHS B DESIGN',
          meta: 'Encased · shorter rainbow from Gold /50',
          parallels: 4,
          cards: [
            { num: 'AB-AD', title: 'Adam Driver' },
            { num: 'AB-ADA', title: 'Annabelle Davis' },
            { num: 'AB-AL', title: 'Amanda Lawrence' },
            { num: 'AB-ASE', title: 'Amy Sedaris' },
            { num: 'AB-BD', title: 'Ben Diskin', meta: 'The Clone Wars' },
            { num: 'AB-BDW', title: 'Billy Dee Williams', meta: 'The Empire Strikes Back' },
            { num: 'AB-BH', title: 'Brian Herring' },
            { num: 'AB-BL', title: 'Billie Lourd', meta: 'The Last Jedi' },
            { num: 'AB-CF', title: 'Carrie Fisher', meta: 'The Empire Strikes Back' },
            { num: 'AB-CH', title: 'Clint Howard' },
            { num: 'AB-CS', title: 'Christopher Sean' },
            { num: 'AB-DBE', title: 'Dee Bradley Baker', meta: 'The Clone Wars' },
            { num: 'AB-DBR', title: 'Dee Bradley Baker', meta: 'The Clone Wars' },
            { num: 'AB-DR', title: 'Daisy Ridley' },
            { num: 'AB-EM', title: 'Ewan McGregor' },
            { num: 'AB-FJ', title: 'Felicity Jones', meta: 'Forces of Destiny' },
            { num: 'AB-FW', title: 'Forest Whitaker', meta: 'Rebels' },
            { num: 'AB-GC', title: 'Gwendoline Christie' },
            { num: 'AB-GG', title: 'Greg Grunberg', meta: 'The Force Awakens' },
            { num: 'AB-HC', title: 'Hayden Christensen' },
            { num: 'AB-HF', title: 'Harrison Ford' },
            { num: 'AB-IMC', title: 'Ian McDiarmid' },
            { num: 'AB-JB', title: 'John Boyega', meta: 'The Last Jedi' },
            { num: 'AB-JC', title: 'Jim Cummings', meta: 'The Clone Wars' },
            { num: 'AB-JI', title: 'Jason Isaacs' },
            { num: 'AB-KS', title: 'Kiran Shah' },
            { num: 'AB-KY', title: 'Keone Young' },
            { num: 'AB-LBR', title: 'Lynn Robertson Bruce' },
            { num: 'AB-LM', title: 'Lars Mikkelsen' },
            { num: 'AB-MBJ', title: 'Mark Boone Jr.' },
            { num: 'AB-MNW', title: 'Ming-Na Wen', meta: 'The Bad Batch' },
            { num: 'AB-MR', title: 'Misty Rosas' },
            { num: 'AB-MU', title: 'Megan Udall' },
            { num: 'AB-MW', title: 'Matthew Wood', meta: 'The Rise of Skywalker' },
            { num: 'AB-NF', title: 'Nika Futterman' },
            { num: 'AB-NP', title: 'Natalie Portman', meta: 'Attack of the Clones' },
            { num: 'AB-PK', title: 'Paul Kasey', meta: 'The Rise of Skywalker' },
            { num: 'AB-PL', title: 'Phil LaMarr', meta: 'Rebels' },
            { num: 'AB-RAD', title: 'Robin Atkin Downes', meta: 'Rebels' },
            { num: 'AB-RB', title: 'Ralph Brown' },
            { num: 'AB-SLJ', title: 'Samuel L. Jackson', meta: 'The Phantom Menace' },
            { num: 'AB-SS', title: 'Stephen Stanton', meta: 'Resistance' },
            { num: 'AB-SW', title: 'Sam Witwer', meta: 'Solo: A Star Wars Story' },
            { num: 'AB-TS', title: 'Tiya Sircar', meta: 'Forces of Destiny' },
            { num: 'AB-WD', title: 'Warwick Davis', meta: 'Solo: A Star Wars Story' },
          ]
        },
        {
          count: 15,
          name: 'DARK SIDE AUTOGRAPHS',
          meta: 'Villain signers · encased',
          odds: '1:16 boxes',
          parallels: 2,
          cards: [
            { num: 'DS-AB', title: 'Anna Brewster' },
            { num: 'DS-AD', title: 'Adam Driver' },
            { num: 'DS-AS', title: 'Andy Serkis' },
            { num: 'DS-DLI', title: 'Diana Lee Inosanto' },
            { num: 'DS-DR', title: 'Daisy Ridley' },
            { num: 'DS-GE', title: 'Giancarlo Esposito' },
            { num: 'DS-HC', title: 'Hayden Christensen' },
            { num: 'DS-IMC', title: 'Ian McDiarmid' },
            { num: 'DS-JI', title: 'Jason Isaacs' },
            { num: 'DS-PAR', title: 'Philip Anthony-Rodriguez' },
            { num: 'DS-PB', title: 'Paul Bettany' },
            { num: 'DS-RB', title: 'Richard Brake' },
            { num: 'DS-REG', title: 'Richard E. Grant' },
            { num: 'DS-SMG', title: 'Sarah Michelle Gellar' },
            { num: 'DS-SS', title: 'Stephen Stanton' },
          ]
        },
        {
          count: 11,
          name: 'GALACTIC BLACK AUTOGRAPHS',
          meta: 'Marquee signers · encased',
          odds: '1:58 boxes',
          parallels: 2,
          cards: [
            { num: 'GB-AD', title: 'Adam Driver' },
            { num: 'GB-AE', title: 'Alden Ehrenreich' },
            { num: 'GB-CF', title: 'Carrie Fisher' },
            { num: 'GB-CW', title: 'Carl Weathers' },
            { num: 'GB-DR', title: 'Daisy Ridley' },
            { num: 'GB-EC', title: 'Emilia Clarke' },
            { num: 'GB-EM', title: 'Ewan McGregor' },
            { num: 'GB-HC', title: 'Hayden Christensen' },
            { num: 'GB-HF', title: 'Harrison Ford' },
            { num: 'GB-JB', title: 'John Boyega' },
            { num: 'GB-NP', title: 'Natalie Portman' },
          ]
        },
      ],
    },
  },
  '2022-mandalorian-chrome': {
    setId: '2022-mandalorian-chrome',
    year: '2022',
    brand: 'TOPPS',
    title: 'THE MANDALORIAN CHROME BESKAR EDITION',
    releaseDate: '8 / 31 / 2022',
    lede: 'The Mandalorian\'s first two seasons get the full chromium treatment — Beskar Edition retells all sixteen chapters across a 100-card base set, with 25 all-new short-printed scenes behind it, under an eight-step refractor ladder from unnumbered Refractor to one-of-one SuperFractor. Four insert lines ride along — the Illustrated Characters art set, Chrome Comic Covers, Armored and Ready, and the case-hit Mandalorian Legends die-cuts — plus a 60-card autograph program led by Pedro Pascal with duals /25, triples /5, and signed die-cut Legends, and an autograph or sketch in every 18-pack box.',
    stats: [
      { num: '125', label: 'Base Cards', sub: '100 + 25 short prints', color: 'gold' },
      { num: '4', label: 'Insert Sets', sub: '5 to 25 cards each', color: 'cyan' },
      { num: '60', label: 'Auto Cards', sub: 'Singles · duals · triples', color: 'green' },
      { num: '8', label: 'Base Parallels', sub: 'Refractor → 1/1', color: 'purple' },
      { num: '11', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '18', l: 'Packs per box' },
      { v: '4', l: 'Cards per pack' },
      { v: '1', l: 'Autograph or sketch per box' },
      { v: '2', l: 'Sketch cards per case' },
      { v: '12', l: 'Boxes per case' },
    ],
    pullRates: [
      { name: 'Chrome Comic Covers', odds: '1 : 3', tier: 'normal' },
      { name: 'Illustrated Characters', odds: '1 : 6', tier: 'normal' },
      { name: 'Armored and Ready', odds: '1 : 6', tier: 'normal' },
      { name: 'Autographs', odds: '1 : 33', tier: 'rare' },
      { name: 'Short Printed Base', odds: '1 : 107', tier: 'rare' },
      { name: 'Sketch Cards', odds: '1 : 117', tier: 'rare' },
      { name: 'Legends Die-Cuts', odds: '1 : 217', tier: 'rare' },
      { name: 'Shaped Sketch Cards', odds: '1 : 1,173', tier: 'mythic' },
      { name: 'Dual Autographs /25', odds: '1 : 2,082', tier: 'mythic' },
      { name: 'Legends Die-Cut Autographs', odds: '1 : 12,751', tier: 'mythic' },
      { name: 'Triple Autographs /5', odds: '1 : 20,402', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'REFRACTOR', pr: '∞', gradient: 'linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)', darkText: true },
      { name: 'BLUE', pr: '/99', gradient: 'linear-gradient(135deg, #2979ff 0%, #0040a0 100%)' },
      { name: 'PURPLE', pr: '/75', gradient: 'linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)' },
      { name: 'GREEN', pr: '/50', gradient: 'linear-gradient(135deg, #00e87a 0%, #008048 100%)', darkText: true },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'BLACK', pr: '/10', gradient: 'linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'All 16 chapters of Seasons 1 & 2 on chromium',
          parallels: 8,
          cards: [
            { num: 'S1-1', title: 'Enter the Hunter', meta: 'Chapter 1, Season 1' },
            { num: 'S1-2', title: 'Checking in with Greef Karga', meta: 'Chapter 1, Season 1' },
            { num: 'S1-3', title: 'The Client', meta: 'Chapter 1, Season 1' },
            { num: 'S1-4', title: 'The Mandalorian Foundling', meta: 'Chapter 1, Season 1' },
            { num: 'S1-5', title: 'The Helpful Kuiil', meta: 'Chapter 1, Season 1' },
            { num: 'S1-6', title: 'IG-11', meta: 'Chapter 1, Season 1' },
            { num: 'S1-7', title: 'Crushing the Hunters', meta: 'Chapter 2, Season 1' },
            { num: 'S1-8', title: 'Defending the Razor Crest', meta: 'Chapter 2, Season 1' },
            { num: 'S1-9', title: 'Jawas on the Defensive', meta: 'Chapter 2, Season 1' },
            { num: 'S1-10', title: 'Riding the Sandcrawler', meta: 'Chapter 2, Season 1' },
            { num: 'S1-11', title: 'The Mudhorn Stopped!', meta: 'Chapter 2, Season 1' },
            { num: 'S1-12', title: 'Handing over the Egg', meta: 'Chapter 2, Season 1' },
            { num: 'S1-13', title: 'Delivering the "Asset"', meta: 'Chapter 3, Season 1' },
            { num: 'S1-14', title: 'Paid in Beskar Steel', meta: 'Chapter 3, Season 1' },
            { num: 'S1-15', title: 'Forging New Armor', meta: 'Chapter 3, Season 1' },
            { num: 'S1-16', title: 'A Messy Infiltration', meta: 'Chapter 3, Season 1' },
            { num: 'S1-17', title: 'Taking Grogu', meta: 'Chapter 3, Season 1' },
            { num: 'S1-18', title: 'The Fight is on', meta: 'Chapter 3, Season 1' },
            { num: 'S1-19', title: 'Reunited and Away!', meta: 'Chapter 3, Season 1' },
            { num: 'S1-20', title: 'Village Under Siege', meta: 'Chapter 4, Season 1' },
            { num: 'S1-21', title: 'Little Green Button Pusher', meta: 'Chapter 4, Season 1' },
            { num: 'S1-22', title: 'The Scary Cat', meta: 'Episode 4, Season 1' },
            { num: 'S1-23', title: 'The AT-ST has Awoken', meta: 'Chapter 4, Season 1' },
            { num: 'S1-24', title: 'The Village Fights Back', meta: 'Chapter 4, Season 1' },
            { num: 'S1-25', title: 'Grossing out the Kids', meta: 'Chapter 4, Season 1' },
            { num: 'S1-26', title: 'Peli\'s New Job', meta: 'Chapter 5, Season 1' },
            { num: 'S1-27', title: 'Tusken Raider Territory', meta: 'Chapter 5, Season 1' },
            { num: 'S1-28', title: 'Bounty Bait', meta: 'Chapter 5, Season 1' },
            { num: 'S1-29', title: 'The Plan For Fennec Shand', meta: 'Chapter 5, Season 1' },
            { num: 'S1-30', title: 'Fennec Shand Captured', meta: 'Chapter 5, Season 1' },
            { num: 'S1-31', title: 'Safe and Sound', meta: 'Chapter 5, Season 1' },
            { num: 'S1-32', title: 'The Crew Assembled', meta: 'Chapter 6, Season 1' },
            { num: 'S1-33', title: 'The Mandalorian\'s Secret Passenger', meta: 'Chapter 6, Season 1' },
            { num: 'S1-34', title: 'Pure Firepower', meta: 'Chapter 6, Season 1' },
            { num: 'S1-35', title: 'No Match for The Mandalorian', meta: 'Chapter 6, Season 1' },
            { num: 'S1-36', title: 'Evasion Tactics', meta: 'Chapter 6, Season 1' },
            { num: 'S1-37', title: 'The New Republic Closes in', meta: 'Chapter 6, Season 1' },
            { num: 'S1-38', title: 'Recruiting Kuiil', meta: 'Chapter 7, Season 1' },
            { num: 'S1-39', title: 'The Assassin Reborn', meta: 'Chapter 7, Season 1' },
            { num: 'S1-40', title: 'Remote Rendezvous', meta: 'Chapter 7, Season 1' },
            { num: 'S1-41', title: 'Greef Karga\'s Gift', meta: 'Chapter 7, Season 1' },
            { num: 'S1-42', title: 'Moff Gideon\'s Arrival', meta: 'Chapter 7, Season 1' },
            { num: 'S1-43', title: 'Kuiil and The Kid', meta: 'Chapter 7, Season 1' },
            { num: 'S1-44', title: 'IG-11\'s Rescue', meta: 'Chapter 8, Season 1' },
            { num: 'S1-45', title: 'An Uncertain Negotiation', meta: 'Chapter 8, Season 1' },
            { num: 'S1-46', title: 'Showdown in the Streets of Nevarro', meta: 'Chapter 8, Season 1' },
            { num: 'S1-47', title: 'Fate of the Mandalorians', meta: 'Chapter 8, Season 1' },
            { num: 'S1-48', title: 'The Armorer Unleashed', meta: 'Chapter 8, Season 1' },
            { num: 'S1-49', title: 'The Mandalorian Takes off', meta: 'Chapter 8, Season 1' },
            { num: 'S1-50', title: 'Successful and Reunited', meta: 'Chapter 8, Season 1' },
            { num: 'S2-1', title: 'The Meeting with Gor Koresh', meta: 'Chapter 9, Season 2' },
            { num: 'S2-2', title: 'Back on Tatooine', meta: 'Chapter 9, Season 2' },
            { num: 'S2-3', title: 'Cobb Vanth\'s Tale', meta: 'Chapter 9, Season 2' },
            { num: 'S2-4', title: 'Taking Back Mos Pelgo', meta: 'Chapter 9, Season 2' },
            { num: 'S2-5', title: 'Tension at the Tusken Camp', meta: 'Chapter 9, Season 2' },
            { num: 'S2-6', title: 'The Mandalorian\'s Bold Move', meta: 'Chapter 9, Season 2' },
            { num: 'S2-7', title: 'Return to Mos Eisley', meta: 'Chapter 10, Season 2' },
            { num: 'S2-8', title: 'Peli\'s Sketchy lead', meta: 'Chapter 10, Season 2' },
            { num: 'S2-9', title: 'Crashing Through the Ice', meta: 'Chapter 10, Season 2' },
            { num: 'S2-10', title: 'Waking up the Beast', meta: 'Chapter 10, Season 2' },
            { num: 'S2-11', title: 'The Ice Beast Returns', meta: 'Chapter 10, Season 2' },
            { num: 'S2-12', title: 'Saved by the New Republic', meta: 'Chapter 10, Season 2' },
            { num: 'S2-13', title: 'Dropping into Trask', meta: 'Chapter 11, Season 2' },
            { num: 'S2-14', title: 'Sailing into the Trap', meta: 'Chapter 11, Season 2' },
            { num: 'S2-15', title: 'An Unexpected Rescue', meta: 'Chapter 11, Season 2' },
            { num: 'S2-16', title: 'Bo-Katan Revealed', meta: 'Chapter 11, Season 2' },
            { num: 'S2-17', title: 'Storming the Imperial Cruiser', meta: 'Chapter 11, Season 2' },
            { num: 'S2-18', title: 'In Search of the Darksaber', meta: 'Chapter 11, Season 2' },
            { num: 'S2-19', title: 'The Child\'s New Friend', meta: 'Chapter 11, Season 2' },
            { num: 'S2-20', title: 'Return to Nevarro', meta: 'Chapter 12, Season 2' },
            { num: 'S2-21', title: 'A Daring Escape Plan', meta: 'Chapter 12, Season 2' },
            { num: 'S2-22', title: 'Speeder Bike Pursuit', meta: 'Chapter 12, Season 2' },
            { num: 'S2-23', title: 'TIE Fighter Assault', meta: 'Chapter 12, Season 2' },
            { num: 'S2-24', title: 'Mando\'s big Save', meta: 'Chapter 12, Season 2' },
            { num: 'S2-25', title: 'Good News for Moff Gideon', meta: 'Chapter 12, Season 2' },
            { num: 'S2-26', title: 'One with the Force', meta: 'Chapter 13, Season 2' },
            { num: 'S2-27', title: 'Ahsoka\'s Ultimatum', meta: 'Chapter 13, Season 2' },
            { num: 'S2-28', title: 'Meeting the Jedi', meta: 'Chapter 13, Season 2' },
            { num: 'S2-29', title: 'Trials in the Force', meta: 'Chapter 13, Season 2' },
            { num: 'S2-30', title: 'Battle Against Beskar', meta: 'Chapter 13, Season 2' },
            { num: 'S2-31', title: 'One Last Assault', meta: 'Chapter 13, Season 2' },
            { num: 'S2-32', title: 'Boba\'s Brutal Assault', meta: 'Chapter 14, Season 2' },
            { num: 'S2-33', title: 'Fennec Fires!', meta: 'Chapter 14, Season 2' },
            { num: 'S2-34', title: 'The Legend Returns', meta: 'Chapter 14, Season 2' },
            { num: 'S2-35', title: 'Enter the Dark Troopers', meta: 'Chapter 14, Season 2' },
            { num: 'S2-36', title: 'The New Marshal', meta: 'Chapter 14, Season 2' },
            { num: 'S2-37', title: 'Back with the Empire', meta: 'Chapter 14, Season 2' },
            { num: 'S2-38', title: 'Mayfeld\'s Surprise Visitor', meta: 'Chapter 15, Season 2' },
            { num: 'S2-39', title: 'AN UNLIKELY TEAM', meta: 'Chapter 15, Season 2' },
            { num: 'S2-40', title: 'Saved by the…Empire?!', meta: 'Chapter 15, Season 2' },
            { num: 'S2-41', title: 'Din Breaking in', meta: 'Chapter 15, Season 2' },
            { num: 'S2-42', title: 'Echoes of the Past', meta: 'Chapter 15, Season 2' },
            { num: 'S2-43', title: 'The Escape', meta: 'Chapter 15, Season 2' },
            { num: 'S2-44', title: 'Gideon\'s Prize Force', meta: 'Chapter 16, Season 2' },
            { num: 'S2-45', title: 'Threats of the Moff', meta: 'Chapter 16, Season 2' },
            { num: 'S2-46', title: 'Fight to the Finish', meta: 'Chapter 16, Season 2' },
            { num: 'S2-47', title: 'The Child\'s Connection', meta: 'Chapter 16, Season 2' },
            { num: 'S2-48', title: 'Coming Face to Face', meta: 'Chapter 16, Season 2' },
            { num: 'S2-49', title: 'The Jedi Revealed', meta: 'Chapter 16, Season 2' },
            { num: 'S2-50', title: 'The Child\'s New Journey', meta: 'Chapter 16, Season 2' },
          ]
        },
        {
          count: 25,
          name: 'SHORT PRINTED BASE CARDS',
          meta: '25 all-new scenes · no parallels',
          odds: '1:107 packs',
          noParallels: true,
          cards: [
            { num: 'SB-1', title: 'The Mandalorian Meets The Client', meta: 'Chapter 1, Season 1' },
            { num: 'SB-2', title: 'A Bounty Like No Other', meta: 'Chapter 1, Season 1' },
            { num: 'SB-3', title: 'Carson Teva Takes Aim', meta: 'Chapter 10, Season 2' },
            { num: 'SB-4', title: 'The Mandalorian and Clan Kryze', meta: 'Chapter 11, Season 2' },
            { num: 'SB-5', title: 'Class Participation', meta: 'Chapter 12, Season 2' },
            { num: 'SB-6', title: 'Nevarro Nummies for Grogu', meta: 'Chapter 12, Season 2' },
            { num: 'SB-7', title: 'Lang and Magistrate Morgan Elsbeth', meta: 'Chapter 13, Season 2' },
            { num: 'SB-8', title: 'Ahsoka Tano', meta: 'Chapter 13, Season 2' },
            { num: 'SB-9', title: 'The Return of Boba Fett', meta: 'Chapter 14, Season 2' },
            { num: 'SB-10', title: 'Fennec Shand and The Mandalorian Back-to-Back', meta: 'Chapter 14, Season 2' },
            { num: 'SB-11', title: 'Mando Unmasked!', meta: 'Chapter 15, Season 2' },
            { num: 'SB-12', title: 'Migs Mayfeld Serving His Sentence', meta: 'Chapter 15, Season 2' },
            { num: 'SB-13', title: 'A Mysterious Jedi Approaches', meta: 'Chapter 16, Season 2' },
            { num: 'SB-14', title: 'A Clan of Two', meta: 'Chapter 16, Season 2' },
            { num: 'SB-15', title: 'In the Mudhorn Pit', meta: 'Chapter 2, Season 1' },
            { num: 'SB-16', title: 'Grogu in His Pram', meta: 'Chapter 2, Season 1' },
            { num: 'SB-17', title: 'Greef Karga on Nevarro', meta: 'Chapter 3, Season 1' },
            { num: 'SB-18', title: 'Omera Tries to Unmask The Mandalorian', meta: 'Chapter 4, Season 1' },
            { num: 'SB-19', title: 'Peli Motto and Grogu', meta: 'Chapter 5, Season 1' },
            { num: 'SB-20', title: 'Toro Calican Conspires with The Mandalorian', meta: 'Chapter 5, Season 1' },
            { num: 'SB-21', title: 'Burg and Migs Mayfeld', meta: 'Chapter 6, Season 1' },
            { num: 'SB-22', title: 'Moff Gideon and His Death Troopers', meta: 'Chapter 7, Season 1' },
            { num: 'SB-23', title: 'Kuiil Discovers IG-11', meta: 'Chapter 7, Season 1' },
            { num: 'SB-24', title: 'Mando Hoists the E-WEB heavy blaster cannon', meta: 'Chapter 8, Season 1' },
            { num: 'SB-25', title: 'Cobb Vanth, the Marshal of Mos Pelgo', meta: 'Chapter 9, Season 2' },
          ]
        },
      ],
      insert: [
        {
          count: 5,
          name: 'CHROME COMIC COVERS',
          meta: 'Comic cover art on chrome',
          odds: '1:3 packs',
          parallels: 5,
          cards: [
            { num: 'CC-1', title: 'The Mandalorian' },
            { num: 'CC-2', title: 'The Nite Owls' },
            { num: 'CC-3', title: 'Boba Fett' },
            { num: 'CC-4', title: 'Ahsoka Tano' },
            { num: 'CC-5', title: 'Grogu' },
          ]
        },
        {
          count: 25,
          name: 'ILLUSTRATED CHARACTERS',
          meta: 'Illustrated character art · CC lists it as "Concept Art"',
          odds: '1:6 packs',
          parallels: 5,
          cards: [
            { num: 'IC-1', title: 'Cobb Vanth Helmet' },
            { num: 'IC-2', title: 'Cobb Vanth No helmet' },
            { num: 'IC-3', title: 'Fennec Shand' },
            { num: 'IC-4', title: 'Mando' },
            { num: 'IC-5', title: 'Boba Fett' },
            { num: 'IC-6', title: 'Ahsoka Tano' },
            { num: 'IC-7', title: 'Ahsoka Tano' },
            { num: 'IC-8', title: 'Ahsoka & Grogu' },
            { num: 'IC-9', title: 'Mando Carrying Gear' },
            { num: 'IC-10', title: 'Grogu Soup' },
            { num: 'IC-11', title: 'Grogu' },
            { num: 'IC-12', title: 'Bo-Katan and Crew' },
            { num: 'IC-13', title: 'Bo-Katan Kryze' },
            { num: 'IC-14', title: 'Koska Reeves' },
            { num: 'IC-15', title: 'Axe Woves' },
            { num: 'IC-16', title: 'Dark Troopers' },
            { num: 'IC-17', title: 'Mando Dark Saber' },
            { num: 'IC-18', title: 'Mando & Moff Gideon' },
            { num: 'IC-19', title: 'Luke Skywalker, Dark Tropper' },
            { num: 'IC-20', title: 'Mando, Dark Trooper' },
            { num: 'IC-21', title: 'Luke Skywalker, R2-D2, Grogu' },
            { num: 'IC-22', title: 'Luke Skywalker' },
            { num: 'IC-23', title: 'Fennec Shand, Boba Fett' },
            { num: 'IC-24', title: 'Grogu on Ship' },
            { num: 'IC-25', title: 'Grogu Meditating' },
          ]
        },
        {
          count: 10,
          name: 'ARMORED AND READY',
          meta: 'Armored-up character portraits',
          odds: '1:6 packs',
          parallels: 5,
          cards: [
            { num: 'AR-1', title: 'The Mandalorian' },
            { num: 'AR-2', title: 'Boba Fett' },
            { num: 'AR-3', title: 'The Armorer' },
            { num: 'AR-4', title: 'Clan Kryze' },
            { num: 'AR-5', title: 'Cobb Vanth' },
            { num: 'AR-6', title: 'Dark Trooper' },
            { num: 'AR-7', title: 'Paz Vizsla' },
            { num: 'AR-8', title: 'IG-11' },
            { num: 'AR-9', title: 'The Mandalorian' },
            { num: 'AR-10', title: 'Fennec Shand' },
          ]
        },
        {
          count: 10,
          name: 'THE MANDALORIAN LEGENDS DIECUT',
          meta: 'Die-cut case hits',
          odds: '1:217 packs',
          parallels: 3,
          cards: [
            { num: 'ML-1', title: 'Grogu' },
            { num: 'ML-2', title: 'The Mandalorian' },
            { num: 'ML-3', title: 'Kuiil' },
            { num: 'ML-4', title: 'IG-11' },
            { num: 'ML-5', title: 'Boba Fett' },
            { num: 'ML-6', title: 'Greef Karga' },
            { num: 'ML-7', title: 'Ahsoka Tano' },
            { num: 'ML-8', title: 'Fennec Shand' },
            { num: 'ML-9', title: 'Cobb Vanth' },
            { num: 'ML-10', title: 'Bo-Katan Kryze' },
          ]
        },
      ],
      auto: [
        {
          count: 39,
          name: 'MANDALORIAN AUTOGRAPHS',
          meta: '39 signers · Blue /150 → SuperFractor',
          odds: '1:33 packs',
          parallels: 6,
          cards: [
            { num: 'A-PP', title: 'Pedro Pascal' },
            { num: 'A-WH', title: 'Werner Herzog' },
            { num: 'A-CW', title: 'Carl Weathers' },
            { num: 'A-JL', title: 'John Leguizamo' },
            { num: 'A-RD', title: 'Rosario Dawson' },
            { num: 'A-NN', title: 'Nick Nolte' },
            { num: 'A-TAW', title: 'Taika Waititi' },
            { num: 'A-MNW', title: 'Ming-Na Wen' },
            { num: 'A-TM', title: 'Temuera Morrison' },
            { num: 'A-AS', title: 'Amy Sedaris' },
            { num: 'A-GE', title: 'Giancarlo Esposito' },
            { num: 'A-KS', title: 'Katee Sackhoff' },
            { num: 'A-ES', title: 'Emily Swallow' },
            { num: 'A-MW', title: 'Matthew Wood' },
            { num: 'A-JKC', title: 'Jake Cannavale' },
            { num: 'A-JJ', title: 'Julia Jones' },
            { num: 'A-OA', title: 'Omid Abtahi' },
            { num: 'A-MBJ', title: 'Mark Boone Jr.' },
            { num: 'A-RB', title: 'Richard Brake' },
            { num: 'A-MV', title: 'Mercedes Varnado' },
            { num: 'A-DB', title: 'Dmitrious Bistrevsky' },
            { num: 'A-KO', title: 'Katy O\'Brian' },
            { num: 'A-CB', title: 'Chris Bartlett' },
            { num: 'A-SK', title: 'Simon Kassianides' },
            { num: 'A-MR', title: 'Misty Rosas' },
            { num: 'A-LS', title: 'Leilani SHIU' },
            { num: 'A-PA', title: 'Philip Alexander' },
            { num: 'A-DLI', title: 'Diana Lee Inosanto' },
            { num: 'A-PL', title: 'Paul Sun-Hyung Lee' },
            { num: 'A-ISF', title: 'Isla Farris' },
            { num: 'A-CHB', title: 'Chris Bartlett' },
            { num: 'A-CBT', title: 'Chris Bartlett' },
            { num: 'A-WEB', title: 'W. Earl Brown' },
            { num: 'A-IS', title: 'Isaac Singleton Jr.' },
            { num: 'A-MRK', title: 'Misty Rosas' },
            { num: 'A-AW', title: 'Alexander Wraith' },
            { num: 'A-RW', title: 'Ryan Watson' },
            { num: 'A-BUL', title: 'Bernard Bullen' },
            { num: 'A-TF', title: 'Tait Fletcher' },
          ]
        },
        {
          count: 9,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two signers · serial /25',
          odds: '1:2,082 packs',
          parallels: 3,
          cards: [
            { num: 'DA-PG', title: 'Pedro Pascal / Giancarlo Esposito' },
            { num: 'DA-PW', title: 'Pedro Pascal / Carl Weathers' },
            { num: 'DA-SV', title: 'Katee Sackhoff / Mercedes Varnado' },
            { num: 'DA-MW', title: 'Temuera Morrison / Ming-Na Wen' },
            { num: 'DA-PD', title: 'Pedro Pascal / Rosario Dawson' },
            { num: 'DA-NW', title: 'Nick Nolte / Taika Waititi' },
            { num: 'DA-HA', title: 'Werner Herzog / Omid Abtahi' },
            { num: 'DA-EH', title: 'Giancarlo Esposito / Werner Herzog' },
            { num: 'DA-SP', title: 'Katee Sackhoff / Pedro Pascal' },
          ]
        },
        {
          count: 4,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three signers · serial /5',
          odds: '1:20,402 packs',
          parallels: 2,
          cards: [
            { num: 'TA-PWE', title: 'Pedro Pascal / Carl Weathers / Giancarlo Esposito' },
            { num: 'TA-SKV', title: 'Katee Sackhoff / Simon Kassianides / Mercedes Varnado' },
            { num: 'TA-PNW', title: 'Pedro Pascal / Nick Nolte / Taika Waititi' },
            { num: 'TA-MWW', title: 'Temuera Morrison / Ming-Na Wen / Matthew Wood' },
          ]
        },
        {
          count: 8,
          name: 'LEGENDS DIECUT AUTOGRAPHS',
          meta: 'Signed die-cuts · serial numbered, run not published',
          odds: '1:12,751 packs',
          noParallels: true,
          cards: [
            { num: 'MLA-1', title: 'Pedro Pascal' },
            { num: 'MLA-2', title: 'Carl Weathers' },
            { num: 'MLA-3', title: 'Rosario Dawson' },
            { num: 'MLA-4', title: 'Nick Nolte' },
            { num: 'MLA-5', title: 'Taika Waititi' },
            { num: 'MLA-6', title: 'Ming-Na Wen' },
            { num: 'MLA-7', title: 'Temuera Morrison' },
            { num: 'MLA-8', title: 'Katee Sackhoff' },
          ]
        },
      ],
      sketch: [
        {
          count: 2,
          name: 'SKETCH CARDS',
          meta: 'Standard & shaped · roster not published · 2 per case',
          odds: '1:117 packs',
          oneOfOne: true,
          noParallels: true,
          cards: [
            { num: 'SK-1', title: 'Sketch Card', meta: 'Various Artists' },
            { num: 'SK-2', title: 'Shaped Sketch Card', meta: 'Various Artists' },
          ]
        },
      ],
    },
  },
  '2024-chrome-black': {
    setId: '2024-chrome-black',
    year: '2024',
    brand: 'TOPPS',
    title: 'STAR WARS CHROME BLACK',
    releaseDate: '3 / 19 / 2025',
    lede: 'The third Chrome Black — delayed into a March 2025 release — doubles down on the line\'s vault-style formula: every box carries an encased autograph, an encased insert, and a serial-numbered refractor. Behind them sit a 100-card base set on black chromium with an eight-step ladder from Rainbow /199 to Superfractor, five insert lines from the shadowbox Depths of the Darkside to a 25-year Darth Maul retrospective, and a 229-card autograph program split into Light Side and Dark Side wings, crowned by dual /10 and triple /5 signatures.',
    stats: [
      { num: '100', label: 'Base Cards', sub: 'Black chromium stock', color: 'gold' },
      { num: '5', label: 'Insert Sets', sub: '15 to 20 cards each', color: 'cyan' },
      { num: '229', label: 'Auto Cards', sub: '5 signature tiers', color: 'green' },
      { num: '8', label: 'Base Parallels', sub: 'Rainbow → 1/1', color: 'purple' },
      { num: '11', label: 'Sub-sets Total', sub: 'Tracked on CK', color: 'red' },
    ],
    hobbyBox: [
      { v: '1', l: 'Encased autograph per box' },
      { v: '1', l: 'Encased insert per box' },
      { v: '1', l: 'Numbered refractor per box' },
      { v: '3', l: 'Chrome cards per box' },
      { v: '12', l: 'Boxes per case' },
    ],
    pullRates: [
      { name: '25 Years of Darth Maul', odds: '1 : 2', tier: 'normal' },
      { name: 'Embrace the Darkside', odds: '1 : 3', tier: 'normal' },
      { name: 'Autograph Dark Side', odds: '1 : 4', tier: 'normal' },
      { name: 'Autograph Light Side', odds: '1 : 5', tier: 'normal' },
      { name: 'Animated Short Prints', odds: '1 : 12', tier: 'rare' },
      { name: 'Depths of the Darkside', odds: '1 : 12', tier: 'rare' },
      { name: 'Duality of the Galaxy', odds: '1 : 26', tier: 'rare' },
      { name: 'Galactic Factions', odds: '/99', tier: 'rare' },
      { name: 'Dual Autographs', odds: '1 : 1,277', tier: 'mythic' },
      { name: 'Triple Autographs', odds: '1 : 2,171', tier: 'mythic' },
    ],
    parallelRainbow: [
      { name: 'RAINBOW', pr: '/199', gradient: 'linear-gradient(135deg, #ffb3ba 0%, #ffdfba 25%, #baffc9 50%, #bae1ff 75%, #e3baff 100%)', darkText: true },
      { name: 'BLUE/RED LAVA', pr: '/99', gradient: 'linear-gradient(135deg, #2979ff 0%, #7040c0 45%, #ff3030 100%)' },
      { name: 'YELLOW LAZER', pr: '/75', gradient: 'linear-gradient(135deg, #ffee58 0%, #d0b820 100%)', darkText: true },
      { name: 'GOLD', pr: '/50', gradient: 'linear-gradient(135deg, #f0c040 0%, #c89020 100%)', darkText: true },
      { name: 'ORANGE', pr: '/25', gradient: 'linear-gradient(135deg, #ff8800 0%, #ff4400 100%)' },
      { name: 'MAGENTA RAYWAVE', pr: '/10', gradient: 'linear-gradient(135deg, #ff40a0 0%, #c01070 100%)' },
      { name: 'RED', pr: '/5', gradient: 'linear-gradient(135deg, #ff2020 0%, #b00000 100%)' },
      { name: 'SUPERFRACTOR', pr: '1/1', gradient: 'linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)', darkText: true },
    ],
    artists: [],
    subsets: {
      base: [
        {
          count: 100,
          name: 'BASE SET',
          meta: 'Lightside & Darkside characters on black chromium',
          parallels: 8,
          cards: [
            { num: '1', title: 'Ahsoka Tano' },
            { num: '2', title: 'Rey' },
            { num: '3', title: 'Luke Skywalker' },
            { num: '4', title: 'Commissioner Helgait' },
            { num: '5', title: 'Grogu' },
            { num: '6', title: 'Obi-Wan Kenobi' },
            { num: '7', title: 'Padmé Amidala' },
            { num: '8', title: 'Sabine Wren' },
            { num: '9', title: 'Ezra Bridger' },
            { num: '10', title: 'Leia Organa' },
            { num: '11', title: 'Han Solo' },
            { num: '12', title: 'Hera Syndulla' },
            { num: '13', title: 'Chewbacca' },
            { num: '14', title: 'Cassian Andor' },
            { num: '15', title: 'Luthen Rael' },
            { num: '16', title: 'Mon Mothma' },
            { num: '17', title: 'Captain Rex' },
            { num: '18', title: 'Saw Gerrera' },
            { num: '19', title: 'Tarfful' },
            { num: '20', title: 'IG-11' },
            { num: '21', title: 'The Mandalorian' },
            { num: '22', title: 'Supreme Chancellor Palpatine' },
            { num: '23', title: 'The Armorer' },
            { num: '24', title: 'Carson Teva' },
            { num: '25', title: 'Bo-Katan Kryze' },
            { num: '26', title: 'Huyang' },
            { num: '27', title: 'K-2SO' },
            { num: '28', title: 'Owen Lars' },
            { num: '29', title: 'Anakin Skywalker' },
            { num: '30', title: 'BB-8' },
            { num: '31', title: 'Yoda' },
            { num: '32', title: 'Qui-Gon Jinn' },
            { num: '33', title: 'Cobb Vanth' },
            { num: '34', title: 'Kelleran Beq' },
            { num: '35', title: 'Poe Dameron' },
            { num: '36', title: 'Wedge Antilles' },
            { num: '37', title: 'Beru Lars' },
            { num: '38', title: 'Ki-Adi-Mundi' },
            { num: '39', title: 'C-3PO' },
            { num: '40', title: 'Kit Fisto' },
            { num: '41', title: 'Jar Jar Binks' },
            { num: '42', title: 'Minas Velti' },
            { num: '43', title: 'R2-D2' },
            { num: '44', title: 'Mace Windu' },
            { num: '45', title: 'Chirrut Îmwe' },
            { num: '46', title: 'Lando Calrissian' },
            { num: '47', title: 'Captain Enoch' },
            { num: '48', title: 'Maz Kanata' },
            { num: '49', title: 'Finn' },
            { num: '50', title: 'General Maximilian Veers' },
            { num: '51', title: 'Jyn Erso' },
            { num: '52', title: 'Kylo Ren' },
            { num: '53', title: 'Vel Sartha' },
            { num: '54', title: 'Darth Vader' },
            { num: '55', title: 'Count Dooku' },
            { num: '56', title: 'General Hux' },
            { num: '57', title: 'Moff Gideon' },
            { num: '58', title: 'Marrok' },
            { num: '59', title: 'Supreme Leader Snoke' },
            { num: '60', title: 'Grand Moff Tarkin' },
            { num: '61', title: 'Baylan Skoll' },
            { num: '62', title: 'Shin Hati' },
            { num: '63', title: 'Morgan Elsbeth' },
            { num: '64', title: 'General Grievous' },
            { num: '65', title: 'Jango Fett' },
            { num: '66', title: 'Dryden Vos' },
            { num: '67', title: 'Plo Koon' },
            { num: '68', title: 'Stormtrooper' },
            { num: '69', title: 'Director Krennic' },
            { num: '70', title: 'The Grand Inquisitor' },
            { num: '71', title: 'Dark Trooper' },
            { num: '72', title: 'Fifth Brother' },
            { num: '73', title: 'Young Ahsoka Tano' },
            { num: '74', title: 'First Order Stormtrooper' },
            { num: '75', title: 'B1 Battle Droid' },
            { num: '76', title: 'Super Battle Droid' },
            { num: '77', title: 'Maarva Andor' },
            { num: '78', title: 'Sith Trooper' },
            { num: '79', title: 'Moloch' },
            { num: '80', title: 'Reva' },
            { num: '81', title: 'Praetorian Guard' },
            { num: '82', title: 'Death Trooper' },
            { num: '83', title: 'Imperial Royal Guard' },
            { num: '84', title: 'Allegiant General Pryde' },
            { num: '85', title: 'Boba Fett' },
            { num: '86', title: 'Nute Gunray' },
            { num: '87', title: 'Cad Bane' },
            { num: '88', title: 'Captain Phasma' },
            { num: '89', title: 'Senator Bail Organa' },
            { num: '90', title: 'Elia Kane' },
            { num: '91', title: 'The Client' },
            { num: '92', title: 'Valin Hess' },
            { num: '93', title: 'Lang' },
            { num: '94', title: 'Dedra Meero' },
            { num: '95', title: 'Syril Karn' },
            { num: '96', title: 'Shoretrooper' },
            { num: '97', title: 'Droideka' },
            { num: '98', title: 'Darth Maul' },
            { num: '99', title: 'Poggle The Lesser' },
            { num: '100', title: 'Grand Admiral Thrawn' },
          ]
        },
      ],
      insert: [
        {
          count: 20,
          name: '25 YEARS OF DARTH MAUL',
          meta: 'A quarter century of Maul',
          odds: '1:2 boxes',
          parallels: 4,
          cards: [
            { num: 'DM-1', title: 'Darth Maul' },
            { num: 'DM-2', title: 'Darth Maul' },
            { num: 'DM-3', title: 'Darth Maul' },
            { num: 'DM-4', title: 'Darth Maul' },
            { num: 'DM-5', title: 'Maul' },
            { num: 'DM-6', title: 'Maul' },
            { num: 'DM-7', title: 'Maul' },
            { num: 'DM-8', title: 'Maul' },
            { num: 'DM-9', title: 'Darth Maul' },
            { num: 'DM-10', title: 'Darth Maul' },
            { num: 'DM-11', title: 'Darth Maul' },
            { num: 'DM-12', title: 'Darth Maul' },
            { num: 'DM-13', title: 'Darth Maul' },
            { num: 'DM-14', title: 'Darth Maul' },
            { num: 'DM-15', title: 'Darth Maul' },
            { num: 'DM-16', title: 'Darth Maul' },
            { num: 'DM-17', title: 'Maul' },
            { num: 'DM-18', title: 'Darth Maul' },
            { num: 'DM-19', title: 'Darth Maul' },
            { num: 'DM-20', title: 'Darth Maul' },
          ]
        },
        {
          count: 15,
          name: 'EMBRACE THE DARKSIDE',
          meta: 'The saga\'s villains of every era',
          odds: '1:3 boxes',
          parallels: 4,
          cards: [
            { num: 'ED-1', title: 'Darth Vader' },
            { num: 'ED-2', title: 'Grand Admiral Thrawn' },
            { num: 'ED-3', title: 'Captain Enoch' },
            { num: 'ED-4', title: 'Baylan Skoll' },
            { num: 'ED-5', title: 'Shin Hati' },
            { num: 'ED-6', title: 'Darth Maul' },
            { num: 'ED-7', title: 'Fifth Brother' },
            { num: 'ED-8', title: 'The Grand Inquisitor' },
            { num: 'ED-9', title: 'Count Dooku' },
            { num: 'ED-10', title: 'Kylo Ren' },
            { num: 'ED-11', title: 'Death Troopers' },
            { num: 'ED-12', title: 'Grand Moff Tarkin' },
            { num: 'ED-13', title: 'Moff Gideon' },
            { num: 'ED-14', title: 'General Grievous' },
            { num: 'ED-15', title: 'Darth Sidious' },
          ]
        },
        {
          count: 20,
          name: 'ANIMATED SHORT PRINTS',
          meta: 'Clone Wars & Rebels art · ~1 per case',
          odds: '1:12 boxes',
          parallels: 5,
          cards: [
            { num: 'SP-1', title: 'Ahsoka Tano' },
            { num: 'SP-2', title: 'Asajj Ventress' },
            { num: 'SP-3', title: 'Bo-Katan Kryze' },
            { num: 'SP-4', title: 'Hera Syndulla' },
            { num: 'SP-5', title: 'Kanan Jarrus' },
            { num: 'SP-6', title: 'The Grand Inquisitor' },
            { num: 'SP-7', title: 'Obi-Wan Kenobi' },
            { num: 'SP-8', title: 'Captain Rex' },
            { num: 'SP-9', title: 'Darth Maul' },
            { num: 'SP-10', title: 'Grand Admiral Thrawn' },
            { num: 'SP-11', title: 'Sabine Wren' },
            { num: 'SP-12', title: 'Savage Opress' },
            { num: 'SP-13', title: 'Fifth Brother' },
            { num: 'SP-14', title: 'Saw Gerrera' },
            { num: 'SP-15', title: 'Ezra Bridger' },
            { num: 'SP-16', title: 'Emperor Palpatine' },
            { num: 'SP-17', title: 'Yoda' },
            { num: 'SP-18', title: 'General Grievous' },
            { num: 'SP-19', title: 'Darth Bane' },
            { num: 'SP-20', title: 'Darth Vader' },
          ]
        },
        {
          count: 20,
          name: 'DEPTHS OF THE DARKSIDE',
          meta: 'Layered shadowbox · ~1 per case',
          odds: '1:12 boxes',
          parallels: 4,
          cards: [
            { num: 'DD-1', title: 'Grand Admiral Thrawn' },
            { num: 'DD-2', title: 'Darth Revan' },
            { num: 'DD-3', title: 'Emperor Palpatine' },
            { num: 'DD-4', title: 'Darth Maul' },
            { num: 'DD-5', title: 'Count Dooku' },
            { num: 'DD-6', title: 'Captain Enoch' },
            { num: 'DD-7', title: 'Death Trooper' },
            { num: 'DD-8', title: 'Darth Maul\'s Lightsaber' },
            { num: 'DD-9', title: 'Kylo Ren\'s Lightsaber' },
            { num: 'DD-10', title: 'Sith Wayfinder' },
            { num: 'DD-11', title: 'Sith Infiltrator' },
            { num: 'DD-12', title: 'Count Dooku\'s Lightsaber' },
            { num: 'DD-13', title: 'Blade of Ochi of Bestoon' },
            { num: 'DD-14', title: 'Sith Holocron' },
            { num: 'DD-15', title: 'Sith Speeder' },
            { num: 'DD-16', title: 'Darth Vader\'s TIE Fighter' },
            { num: 'DD-17', title: 'Darth Vader\'s Lightsaber' },
            { num: 'DD-18', title: 'The Grand Inquisitor' },
            { num: 'DD-19', title: 'Kylo Ren' },
            { num: 'DD-20', title: 'Darth Vader' },
          ]
        },
        {
          count: 20,
          name: 'GALACTIC FACTIONS',
          meta: 'Emblems of the galaxy\'s factions',
          odds: 'Serial /99',
          parallels: 4,
          cards: [
            { num: 'GL-1', title: 'Sith' },
            { num: 'GL-2', title: 'Bounty Hunters' },
            { num: 'GL-3', title: 'Rebel Alliance' },
            { num: 'GL-4', title: 'New Republic' },
            { num: 'GL-5', title: 'Jedi Order' },
            { num: 'GL-6', title: 'First Order' },
            { num: 'GL-7', title: 'Galactic Empire' },
            { num: 'GL-8', title: 'Galactic Republic' },
            { num: 'GL-9', title: 'Fulcrum' },
            { num: 'GL-10', title: 'Early Rebellion' },
            { num: 'GL-11', title: 'General Grievous' },
            { num: 'GL-12', title: 'Inquisitorius' },
            { num: 'GL-13', title: 'The Naboo' },
            { num: 'GL-14', title: 'Mudhorn' },
            { num: 'GL-15', title: 'Phoenix' },
            { num: 'GL-16', title: 'Gungan' },
            { num: 'GL-17', title: 'Rebel Fighters' },
            { num: 'GL-18', title: 'Galactic Senate' },
            { num: 'GL-19', title: 'Desilijic' },
            { num: 'GL-20', title: 'Confederacy of Independent Systems' },
          ]
        },
      ],
      auto: [
        {
          count: 77,
          name: 'AUTOGRAPH LIGHT SIDE',
          meta: 'Lightside signers · encased',
          odds: '1:5 boxes',
          parallels: 10,
          cards: [
            { num: 'ALS-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'ALS-AB', title: 'Ahmed Best', meta: 'Kelleran Beq' },
            { num: 'ALS-AD', title: 'Anthony Daniels', meta: 'C-3PO' },
            { num: 'ALS-AE', title: 'Ashley Eckstein', meta: 'Ahsoka Tano' },
            { num: 'ALS-AG', title: 'Ariana Greenblatt', meta: 'Young Ahsoka Tano' },
            { num: 'ALS-AM', title: 'Alastair McKenzie', meta: 'Perrin Fertha' },
            { num: 'ALS-AP', title: 'Angelique Perrin', meta: 'Adi Gallia' },
            { num: 'ALS-AV', title: 'Antonio Viña', meta: 'Kassa' },
            { num: 'ALS-BC', title: 'Bronte Carmichael', meta: 'Leida Mothma' },
            { num: 'ALS-BE', title: 'Blair Bess', meta: 'Even Piell' },
            { num: 'ALS-BL', title: 'Billie Lourd', meta: 'Kaydel Ko Connix' },
            { num: 'ALS-BM', title: 'Bobby Moynihan', meta: 'Orka' },
            { num: 'ALS-BR', title: 'Ralph Brown', meta: 'Ric Olié' },
            { num: 'ALS-BS', title: 'Brian Blessed', meta: 'Boss Nass' },
            { num: 'ALS-BW', title: 'Billy Dee Williams', meta: 'Lando Calrissian' },
            { num: 'ALS-CE', title: 'Chris Edgerly', meta: 'Eeth Koth' },
            { num: 'ALS-CH', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'ALS-DI', title: 'Ben Diskin', meta: 'AZI-3' },
            { num: 'ALS-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'ALS-DO', title: 'Robin Atkin Downes', meta: 'Cham Syndulla' },
            { num: 'ALS-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'ALS-DY', title: 'Donnie Yen', meta: 'Chirrut Îmwe' },
            { num: 'ALS-EE', title: 'Eman Esfandi', meta: 'Ezra Bridger' },
            { num: 'ALS-EH', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'ALS-EM', title: 'Ewan McGregor', meta: 'Obi-Wan Kenobi' },
            { num: 'ALS-ES', title: 'Emily Swallow', meta: 'The Armorer' },
            { num: 'ALS-EW', title: 'Evan Whitten', meta: 'Jacen Syndulla' },
            { num: 'ALS-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'ALS-FM', title: 'Faye Marsay', meta: 'Vel Sartha' },
            { num: 'ALS-FP', title: 'Freddie Prinze, Jr.', meta: 'Kanan Jarrus' },
            { num: 'ALS-FS', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'ALS-GB', title: 'Gary Beadle', meta: 'Clem Andor' },
            { num: 'ALS-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'ALS-HC', title: 'Hermione Corfield', meta: 'Tallie Lintra' },
            { num: 'ALS-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'ALS-HQ', title: 'Hugh Quarshie', meta: 'Captain Panaka' },
            { num: 'ALS-IV', title: 'Indira Varma', meta: 'Tala Durith' },
            { num: 'ALS-JD', title: 'Julie Dolan', meta: 'Princess Leia Organa' },
            { num: 'ALS-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'ALS-JG', title: 'Jason Spisak', meta: 'Lux Bonteri' },
            { num: 'ALS-JH', title: 'Jessica Henwick', meta: 'Jess Pava' },
            { num: 'ALS-KC', title: 'Keisha Castle-Hughes', meta: 'Queen Apailana' },
            { num: 'ALS-KF', title: 'Karen Fukuhara', meta: 'F' },
            { num: 'ALS-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'ALS-KK-2', title: 'Katy Kartwheel', meta: 'Rio Durant' },
            { num: 'ALS-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'ALS-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'ALS-LD', title: 'Laura Dern', meta: 'Vice Admiral Holdo' },
            { num: 'ALS-MA', title: 'Michelle Ang', meta: 'Omega' },
            { num: 'ALS-ME', title: 'Maya Erskine', meta: 'Sully Stark' },
            { num: 'ALS-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'ALS-MQ', title: 'Mike Quinn', meta: 'Nien Nunb' },
            { num: 'ALS-MS', title: 'Meredith Salenger', meta: 'Bariss Offee' },
            { num: 'ALS-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'ALS-NA', title: 'Naomi Ackie', meta: 'Jannah' },
            { num: 'ALS-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'ALS-NC', title: 'Nazneen Contractor', meta: 'Synara San' },
            { num: 'ALS-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'ALS-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'ALS-OF', title: 'Oliver Ford-Davies', meta: 'Sio Bibble' },
            { num: 'ALS-OI', title: 'Oscar Isaac', meta: 'Poe Dameron' },
            { num: 'ALS-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'ALS-PR', title: 'Paul Reubens', meta: 'RX-24' },
            { num: 'ALS-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'ALS-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'ALS-SD', title: 'Sharon Duncan-Brewster', meta: 'Senator Tynnra Pamlo' },
            { num: 'ALS-SE', title: 'Amy Sedaris', meta: 'Peli Motto' },
            { num: 'ALS-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'ALS-SK', title: 'Simone Kessell', meta: 'Breha Organa' },
            { num: 'ALS-SL', title: 'Scott Lawrence', meta: 'Jarek Yeager' },
            { num: 'ALS-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'ALS-TO', title: 'Timothy Olyphant', meta: 'Cobb Vanth' },
            { num: 'ALS-TR', title: 'Tim Rose', meta: 'Admiral Ackbar' },
            { num: 'ALS-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'ALS-VM', title: 'Vanessa Marshall', meta: 'Hera Syndulla' },
            { num: 'ALS-VS', title: 'Varada Sethu', meta: 'Cinta Kaz' },
            { num: 'ALS-WD', title: 'Warwick Davis', meta: 'Wicket W. Warrick' },
          ]
        },
        {
          count: 63,
          name: 'AUTOGRAPH DARK SIDE',
          meta: 'Darkside signers · encased',
          odds: '1:4 boxes',
          parallels: 10,
          cards: [
            { num: 'ADS-AB', title: 'Anna Brewster', meta: 'Bazine Netal' },
            { num: 'ADS-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'ADS-AF', title: 'Alex Ferns', meta: 'Sergeant Linus Mosk' },
            { num: 'ADS-AL', title: 'Anton Lesser', meta: 'Major Partagaz' },
            { num: 'ADS-AR', title: 'Alan Ruscoe', meta: 'Daultay Dofine' },
            { num: 'ADS-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'ADS-BD', title: 'Benicio Del Toro', meta: 'DJ' },
            { num: 'ADS-BG', title: 'Barbara Goodson', meta: 'Mother Talzin' },
            { num: 'ADS-BM', title: 'Ben Mendelsohn', meta: 'Director Krennic' },
            { num: 'ADS-CB', title: 'Claudia Black', meta: 'Klothow' },
            { num: 'ADS-CM', title: 'Cathy Munroe', meta: 'Zuckuss' },
            { num: 'ADS-CO', title: 'Liam Cook', meta: 'Ochi of Bestoon' },
            { num: 'ADS-DG', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'ADS-DI', title: 'Diana Lee Inosanto', meta: 'Morgan Elsbeth' },
            { num: 'ADS-DK', title: 'Dorian Kingi', meta: 'Cad Bane' },
            { num: 'ADS-DO', title: 'David Oyelowo', meta: 'Agent Kallus' },
            { num: 'ADS-DS', title: 'David Shaughnessy', meta: 'Myles Grint' },
            { num: 'ADS-EC', title: 'Emilia Clarke', meta: 'Qi\'ra' },
            { num: 'ADS-EK', title: 'Erin Kellyman', meta: 'Enfys Nest' },
            { num: 'ADS-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'ADS-GE', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'ADS-GH', title: 'Guy Henry', meta: 'Governor Tarkin' },
            { num: 'ADS-GL', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'ADS-GT', title: 'George Takei', meta: 'Lok Durd' },
            { num: 'ADS-GW', title: 'Gary Anthony Williams', meta: 'Kragan Gorr' },
            { num: 'ADS-HC', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'ADS-HD', title: 'Harley Durst', meta: 'Moloch' },
            { num: 'ADS-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'ADS-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'ADS-JC', title: 'Jake Cannavale', meta: 'Toro Calican' },
            { num: 'ADS-JG', title: 'Julian Glover', meta: 'General Veers' },
            { num: 'ADS-JI', title: 'Jason Isaacs', meta: 'The Grand Inquisitor' },
            { num: 'ADS-JK', title: 'Jamie King', meta: 'Aurra Sing' },
            { num: 'ADS-KO', title: 'Katy O\'Brian', meta: 'Elia Kane' },
            { num: 'ADS-KS', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'ADS-LC', title: 'Lily Cole', meta: 'Lovey' },
            { num: 'ADS-LE', title: 'Lewis Macleod', meta: 'Sebulba' },
            { num: 'ADS-LL', title: 'Lex Lang', meta: 'Major Vonreg' },
            { num: 'ADS-LM', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'ADS-MB', title: 'Mark Boone Jr.', meta: 'Ranzar Malk' },
            { num: 'ADS-MI', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'ADS-MM', title: 'Mary Elizabeth McGlynn', meta: 'Governor Pryce' },
            { num: 'ADS-MP', title: 'Michael Pennington', meta: 'Moff Jerjerrod' },
            { num: 'ADS-MV', title: 'Mario Vernazza', meta: 'Vult Skerris' },
            { num: 'ADS-MW', title: 'Matthew Wood', meta: 'General Grievous' },
            { num: 'ADS-NF', title: 'Nika Futterman', meta: 'Asajj Ventress' },
            { num: 'ADS-PA', title: 'Philip Anthony-Rodriguez', meta: 'Fifth Brother' },
            { num: 'ADS-PD', title: 'Paul Darnell', meta: 'Marrok' },
            { num: 'ADS-PJ', title: 'Peter Jacobson', meta: 'Myn Weaver' },
            { num: 'ADS-RA', title: 'Rajia Baroudi', meta: 'Queen Miraj Scintel' },
            { num: 'ADS-RB', title: 'Richard Brake', meta: 'Valin Hess' },
            { num: 'ADS-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'ADS-RG', title: 'Richard E. Grant', meta: 'Allegiant General Pryde' },
            { num: 'ADS-RK', title: 'Rya Kihlstedt', meta: 'Fourth Sister' },
            { num: 'ADS-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'ADS-SE', title: 'Andy Secombe', meta: 'Watto' },
            { num: 'ADS-SG', title: 'Sarah Michelle Gellar', meta: 'Seventh Sister' },
            { num: 'ADS-SW', title: 'Sam Witwer', meta: 'Maul' },
            { num: 'ADS-TB', title: 'Tom Baker', meta: 'Bendu' },
            { num: 'ADS-TC', title: 'Tim Curry', meta: 'Chancellor Palpatine' },
            { num: 'ADS-TM', title: 'Temuera Morrison', meta: 'Jango Fett' },
            { num: 'ADS-WC', title: 'Wes Chatham', meta: 'Captain Enoch' },
            { num: 'ADS-WH', title: 'Werner Herzog', meta: 'The Client' },
          ]
        },
        {
          count: 72,
          name: 'DUALITY OF THE GALAXY AUTOGRAPHS',
          meta: 'Signers caught between the light and the dark',
          odds: '1:26 boxes',
          parallels: 5,
          cards: [
            { num: 'BFA-AA', title: 'Adria Arjona', meta: 'Bix Caleen' },
            { num: 'BFA-AB', title: 'Ahmed Best', meta: 'Kelleran Beq' },
            { num: 'BFA-AD', title: 'Adam Driver', meta: 'Kylo Ren' },
            { num: 'BFA-AE', title: 'Alden Ehrenreich', meta: 'Han Solo' },
            { num: 'BFA-AF', title: 'Alex Ferns', meta: 'Sergeant Linus Mosk' },
            { num: 'BFA-AG', title: 'Ariana Greenblatt', meta: 'Young Ahsoka Tano' },
            { num: 'BFA-AL', title: 'Anton Lesser', meta: 'Major Partagaz' },
            { num: 'BFA-AM', title: 'Alastair McKenzie', meta: 'Perrin Fertha' },
            { num: 'BFA-AR', title: 'Alan Ruscoe', meta: 'Daultay Dofine' },
            { num: 'BFA-AS', title: 'Andy Serkis', meta: 'Supreme Leader Snoke' },
            { num: 'BFA-BD', title: 'Benicio Del Toro', meta: 'DJ' },
            { num: 'BFA-BE', title: 'Ben Mendelsohn', meta: 'Director Krennic' },
            { num: 'BFA-BL', title: 'Billie Lourd', meta: 'Kaydel Ko Connix' },
            { num: 'BFA-BM', title: 'Bobby Moynihan', meta: 'Orka' },
            { num: 'BFA-BS', title: 'Bruce Spence', meta: 'Tion Medon' },
            { num: 'BFA-CH', title: 'Hayden Christensen', meta: 'Darth Vader' },
            { num: 'BFA-DE', title: 'Denise Gough', meta: 'Dedra Meero' },
            { num: 'BFA-DI', title: 'Diana Lee Inosanto', meta: 'Morgan Elsbeth' },
            { num: 'BFA-DK', title: 'Dorian Kingi', meta: 'Cad Bane' },
            { num: 'BFA-DL', title: 'Diego Luna', meta: 'Cassian Andor' },
            { num: 'BFA-DP', title: 'David Pasquesi', meta: 'Twi\'lek Majordomo' },
            { num: 'BFA-DR', title: 'Daisy Ridley', meta: 'Rey' },
            { num: 'BFA-EE', title: 'Eman Esfandi', meta: 'Ezra Bridger' },
            { num: 'BFA-EW', title: 'Evan Whitten', meta: 'Jacen Syndulla' },
            { num: 'BFA-FJ', title: 'Felicity Jones', meta: 'Jyn Erso' },
            { num: 'BFA-FM', title: 'Faye Marsay', meta: 'Vel Sartha' },
            { num: 'BFA-FS', title: 'Fiona Shaw', meta: 'Maarva Andor' },
            { num: 'BFA-GB', title: 'Gary Beadle', meta: 'Clem Andor' },
            { num: 'BFA-GC', title: 'Gwendoline Christie', meta: 'Captain Phasma' },
            { num: 'BFA-GE', title: 'Giancarlo Esposito', meta: 'Moff Gideon' },
            { num: 'BFA-GL', title: 'Domhnall Gleeson', meta: 'General Hux' },
            { num: 'BFA-GO', title: 'Genevieve O\'Reilly', meta: 'Mon Mothma' },
            { num: 'BFA-HC', title: 'Hayden Christensen', meta: 'Anakin Skywalker' },
            { num: 'BFA-HF', title: 'Harrison Ford', meta: 'Han Solo' },
            { num: 'BFA-IM', title: 'Ian McDiarmid', meta: 'Emperor Palpatine' },
            { num: 'BFA-IS', title: 'Ivanna Sakhno', meta: 'Shin Hati' },
            { num: 'BFA-JC', title: 'Jake Cannavale', meta: 'Toro Calican' },
            { num: 'BFA-JE', title: 'Joel Edgerton', meta: 'Owen Lars' },
            { num: 'BFA-KK', title: 'Keira Knightley', meta: 'Sabé' },
            { num: 'BFA-KR', title: 'Keri Russell', meta: 'Zorii Bliss' },
            { num: 'BFA-KS', title: 'Katee Sackhoff', meta: 'Bo-Katan Kryze' },
            { num: 'BFA-KY', title: 'Kyle Soller', meta: 'Syril Karn' },
            { num: 'BFA-LA', title: 'Lars Mikkelsen', meta: 'Grand Admiral Thrawn' },
            { num: 'BFA-LC', title: 'Lily Cole', meta: 'Lovey' },
            { num: 'BFA-LD', title: 'Laura Dern', meta: 'Vice Admiral Holdo' },
            { num: 'BFA-LM', title: 'Lewis Macleod', meta: 'Sebulba' },
            { num: 'BFA-MB', title: 'Mark Boone Jr.', meta: 'Ranzar Malk' },
            { num: 'BFA-ME', title: 'Maya Erskine', meta: 'Sully Stark' },
            { num: 'BFA-MH', title: 'Mark Hamill', meta: 'Luke Skywalker' },
            { num: 'BFA-MM', title: 'Mary Elizabeth McGlynn', meta: 'Governor Pryce' },
            { num: 'BFA-MO', title: 'Moses Ingram', meta: 'Reva' },
            { num: 'BFA-MR', title: 'Mark Rolston', meta: 'Captain Hayle' },
            { num: 'BFA-MW', title: 'Mary Elizabeth Winstead', meta: 'Hera Syndulla' },
            { num: 'BFA-NB', title: 'Natasha Liu Bordizzo', meta: 'Sabine Wren' },
            { num: 'BFA-NN', title: 'Nick Nolte', meta: 'Kuiil' },
            { num: 'BFA-NP', title: 'Natalie Portman', meta: 'Padmé Amidala' },
            { num: 'BFA-PP', title: 'Pedro Pascal', meta: 'The Mandalorian' },
            { num: 'BFA-RA', title: 'Riz Ahmed', meta: 'Bodhi Rook' },
            { num: 'BFA-RB', title: 'Richard Brake', meta: 'Valin Hess' },
            { num: 'BFA-RD', title: 'Rosario Dawson', meta: 'Ahsoka Tano' },
            { num: 'BFA-RF', title: 'Rupert Friend', meta: 'The Grand Inquisitor' },
            { num: 'BFA-RG', title: 'Richard E. Grant', meta: 'Allegiant General Pryde' },
            { num: 'BFA-RP', title: 'Ray Park', meta: 'Darth Maul' },
            { num: 'BFA-SE', title: 'Andy Secombe', meta: 'Watto' },
            { num: 'BFA-SJ', title: 'Samuel L. Jackson', meta: 'Mace Windu' },
            { num: 'BFA-SS', title: 'Stellan Skarsgård', meta: 'Luthen Rael' },
            { num: 'BFA-TE', title: 'Temuera Morrison', meta: 'Jango Fett' },
            { num: 'BFA-TM', title: 'Temuera Morrison', meta: 'Boba Fett' },
            { num: 'BFA-TW', title: 'Taika Waititi', meta: 'IG-11' },
            { num: 'BFA-VS', title: 'Varada Sethu', meta: 'Cinta Kaz' },
            { num: 'BFA-WC', title: 'Wes Chatham', meta: 'Captain Enoch' },
            { num: 'BFA-WH', title: 'Werner Herzog', meta: 'The Client' },
          ]
        },
        {
          count: 11,
          name: 'DUAL AUTOGRAPHS',
          meta: 'Two signers · serial /10',
          odds: '1:1,277 boxes',
          parallels: 2,
          cards: [
            { num: 'DA-AE', title: 'Emilia Clarke / Alden Ehrenreich', meta: 'Qi\'ra / Han Solo' },
            { num: 'DA-DF', title: 'Diego Luna / Felicity Jones', meta: 'Cassian Andor / Jyn Erso' },
            { num: 'DA-DO', title: 'Daisy Ridley / Oscar Isaac', meta: 'Rey / Poe Dameron' },
            { num: 'DA-EH', title: 'Ewan McGregor / Hayden Christensen', meta: 'Obi-Wan Kenobi / Anakin Skywalker' },
            { num: 'DA-HB', title: 'Harrison Ford / Billy Dee Williams', meta: 'Han Solo / Lando Calrissian' },
            { num: 'DA-HI', title: 'Ian McDiarmid / Hayden Christensen', meta: 'Emperor Palpatine / Darth Vader' },
            { num: 'DA-HS', title: 'Samuel L. Jackson / Hayden Christensen', meta: 'Mace Windu / Darth Vader' },
            { num: 'DA-KG', title: 'Giancarlo Esposito / Katee Sackhoff', meta: 'Moff Gideon / Bo-Katan Kryze' },
            { num: 'DA-NI', title: 'Natasha Liu Bordizzo / Ivanna Sakhno', meta: 'Sabine Wren / Shin Hati' },
            { num: 'DA-RN', title: 'Natasha Liu Bordizzo / Rosario Dawson', meta: 'Sabine Wren / Ahsoka Tano' },
            { num: 'DA-TM', title: 'Temuera Morrison / Ming-Na Wen', meta: 'Boba Fett / Fennec Shand' },
          ]
        },
        {
          count: 6,
          name: 'TRIPLE AUTOGRAPHS',
          meta: 'Three signers · serial /5',
          odds: '1:2,171 boxes',
          parallels: 2,
          cards: [
            { num: 'TA-ADI', title: 'Daisy Ridley / Adam Driver / Ian McDiarmid', meta: 'Rey / Kylo Ren / Emperor Palpatine' },
            { num: 'TA-ADO', title: 'Adam Driver / Oscar Isaac / Daisy Ridley', meta: 'Kylo Ren / Poe Dameron / Rey' },
            { num: 'TA-DFD', title: 'Felicity Jones / Donnie Yen / Diego Luna', meta: 'Jyn Erso / Chirrut Îmwe / Cassian Andor' },
            { num: 'TA-LWD', title: 'Diana Lee Inosanto / Lars Mikkelsen / Wes Chatham', meta: 'Morgan Elsbeth / Grand Admiral Thrawn / Captain Enoch' },
            { num: 'TA-OKD', title: 'Daisy Ridley / Keri Russell / Oscar Isaac', meta: 'Rey / Zorii Bliss / Poe Dameron' },
            { num: 'TA-RNL', title: 'Natasha Liu Bordizzo / Lars Mikkelsen / Rosario Dawson', meta: 'Sabine Wren / Grand Admiral Thrawn / Ahsoka Tano' },
          ]
        },
      ],
    },
  },


  '2024-chrome-sapphire': {
    "setId": "2024-chrome-sapphire",
    "year": "2024",
    "brand": "TOPPS",
    "title": "STAR WARS CHROME SAPPHIRE EDITION",
    "releaseDate": "5 / 4 / 2024",
    "lede": "A Topps.com online exclusive for the 25th anniversary of The Phantom Menace — and the first Star Wars Sapphire built as its own product instead of a reprint of an earlier Chrome set. The 100-card base retells Episode I scene by scene beneath an eight-tier ladder from Purple /125 to the Padparadscha 1/1, four insert lines carry their own ladders — including a Jedi High Council serial-numbered /100 and two lines whose entry tier is Green /99 — and 13 original cast signers headline a pure-chase autograph program, from Ewan McGregor and Natalie Portman to Keira Knightley’s first certified Star Wars autograph.",
    "stats": [
      {
        "num": "100",
        "label": "Base Cards",
        "sub": "Episode I in story order",
        "color": "gold"
      },
      {
        "num": "4",
        "label": "Insert Sets",
        "sub": "10 to 20 cards each",
        "color": "cyan"
      },
      {
        "num": "25",
        "label": "Auto Cards",
        "sub": "13 signers · 3 tiers",
        "color": "green"
      },
      {
        "num": "8",
        "label": "Base Parallels",
        "sub": "Purple /125 → 1/1",
        "color": "purple"
      },
      {
        "num": "8",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "4",
        "l": "Packs per box"
      },
      {
        "v": "8",
        "l": "Cards per pack"
      },
      {
        "v": "4",
        "l": "Numbered parallels per box"
      },
      {
        "v": "1",
        "l": "Product · Topps.com online exclusive"
      }
    ],
    "pullRates": [
      {
        "name": "Sapphire Selections",
        "odds": "1 : 47",
        "tier": "normal"
      },
      {
        "name": "Duel of the Fates Green /99",
        "odds": "1 : 47",
        "tier": "normal"
      },
      {
        "name": "Jedi High Council /100",
        "odds": "1 : 77",
        "tier": "normal"
      },
      {
        "name": "Podracing Green /99",
        "odds": "1 : 94",
        "tier": "normal"
      },
      {
        "name": "Phantom Menace Cast Autographs",
        "odds": "1 : 112",
        "tier": "rare"
      },
      {
        "name": "Padparadscha Sapphire 1/1 (base)",
        "odds": "1 : 927",
        "tier": "rare"
      },
      {
        "name": "Sapphire Selections Autographs",
        "odds": "1 : 1,760",
        "tier": "mythic"
      },
      {
        "name": "Dual Autographs",
        "odds": "1 : 5,867",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "SAPPHIRE",
        "pr": "∞",
        "gradient": "linear-gradient(135deg, #7fb8ff 0%, #2d6fd0 55%, #b8dcff 100%)",
        "darkText": true
      },
      {
        "name": "PURPLE",
        "pr": "/125",
        "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/99",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "YELLOW",
        "pr": "/75",
        "gradient": "linear-gradient(135deg, #ffee58 0%, #d0b820 100%)",
        "darkText": true
      },
      {
        "name": "GOLD",
        "pr": "/50",
        "gradient": "linear-gradient(135deg, #f0c040 0%, #c89020 100%)",
        "darkText": true
      },
      {
        "name": "ORANGE",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      },
      {
        "name": "BLACK",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "RED",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      },
      {
        "name": "PADPARADSCHA",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #ffc4a8 0%, #ff9e80 45%, #ff7043 100%)",
        "darkText": true
      }
    ],
    "artists": [],
    "subsets": {
      "base": [
        {
          "count": 100,
          "name": "BASE SET",
          "meta": "The Phantom Menace retold in story order",
          "parallels": 8,
          "cards": [
            {
              "num": "1",
              "title": "The Chancellor's Ambassadors Arrive"
            },
            {
              "num": "2",
              "title": "The Trade Federation's Mysterious Conspirator"
            },
            {
              "num": "3",
              "title": "The Radiant VII is Obliterated!"
            },
            {
              "num": "4",
              "title": "Poisonous Gas Fills the Meeting Room"
            },
            {
              "num": "5",
              "title": "A Squad of Droids Arrive"
            },
            {
              "num": "6",
              "title": "The Jedi Make Their Way to the Command Deck"
            },
            {
              "num": "7",
              "title": "Breaking Down the Blast Doors"
            },
            {
              "num": "8",
              "title": "Stowaways"
            },
            {
              "num": "9",
              "title": "The Queen's Disapproval"
            },
            {
              "num": "10",
              "title": "Senator Sheev Palpatine"
            },
            {
              "num": "11",
              "title": "The Trade Federation Touches Down on Naboo"
            },
            {
              "num": "12",
              "title": "Hunt for the Jedi"
            },
            {
              "num": "13",
              "title": "On the Run in the Swamp!"
            },
            {
              "num": "14",
              "title": "Jar Jar Binks"
            },
            {
              "num": "15",
              "title": "Seeking Safety Among the Gungans"
            },
            {
              "num": "16",
              "title": "The Banished One"
            },
            {
              "num": "17",
              "title": "The Hidden Underwater City"
            },
            {
              "num": "18",
              "title": "An Unwelcome Return"
            },
            {
              "num": "19",
              "title": "Boss Nass"
            },
            {
              "num": "20",
              "title": "The Jedi & Their Navigator"
            },
            {
              "num": "21",
              "title": "Creatures of the Deep"
            },
            {
              "num": "22",
              "title": "The Dark Lord's Political Tactics"
            },
            {
              "num": "23",
              "title": "Theed Falls to the Trade Federation Army"
            },
            {
              "num": "24",
              "title": "The Royal Court Rescued!"
            },
            {
              "num": "25",
              "title": "Boarding the Queen's Starship"
            },
            {
              "num": "26",
              "title": "Blasting through the Blockade"
            },
            {
              "num": "27",
              "title": "The Heroic Astromech, R2-D2"
            },
            {
              "num": "28",
              "title": "Necessary Repairs on Tatooine"
            },
            {
              "num": "29",
              "title": "\"He will find your lost ship…\""
            },
            {
              "num": "30",
              "title": "The Queen's Handmaiden, Padmé Amidala"
            },
            {
              "num": "31",
              "title": "Watto's Junk Shop"
            },
            {
              "num": "32",
              "title": "Meeting Anakin Skywalker"
            },
            {
              "num": "33",
              "title": "Negotiating with Watto"
            },
            {
              "num": "34",
              "title": "Finding Trouble with the Locals"
            },
            {
              "num": "35",
              "title": "Sebulba & Anakin Skywalker"
            },
            {
              "num": "36",
              "title": "Shelter in the Skywalker Home"
            },
            {
              "num": "37",
              "title": "Anakin's Protocol Droid"
            },
            {
              "num": "38",
              "title": "Darth Maul is Sent to Tatooine"
            },
            {
              "num": "39",
              "title": "The Podracing Solution"
            },
            {
              "num": "40",
              "title": "Making the Deal with Watto"
            },
            {
              "num": "41",
              "title": "Anakin's Gifts"
            },
            {
              "num": "42",
              "title": "The Prophecy of the Chosen One"
            },
            {
              "num": "43",
              "title": "Repairs for Anakin's Podracer"
            },
            {
              "num": "44",
              "title": "Blood Sample Analysis"
            },
            {
              "num": "45",
              "title": "Dispatching the Seeker Droids"
            },
            {
              "num": "46",
              "title": "A New Bet with Watto"
            },
            {
              "num": "47",
              "title": "The Boonta Eve Classic"
            },
            {
              "num": "48",
              "title": "Qui-Gon Jinn's Advice"
            },
            {
              "num": "49",
              "title": "Protests from Padmé"
            },
            {
              "num": "50",
              "title": "Moving Through The Field of Racers"
            },
            {
              "num": "51",
              "title": "Clash with Sebulba"
            },
            {
              "num": "52",
              "title": "Victory!"
            },
            {
              "num": "53",
              "title": "\"Now you can make your dreams come true, Ani\""
            },
            {
              "num": "54",
              "title": "Our Heroes Encounter Darth Maul"
            },
            {
              "num": "55",
              "title": "A Narrow Escape"
            },
            {
              "num": "56",
              "title": "Arrival on Coruscant"
            },
            {
              "num": "57",
              "title": "Palpatine's Disdain for Republic Politics"
            },
            {
              "num": "58",
              "title": "Qui-Gon Jinn Reports to the Jedi Council"
            },
            {
              "num": "59",
              "title": "A Vergence in the Force"
            },
            {
              "num": "60",
              "title": "The Queen's Plea to the Senate"
            },
            {
              "num": "61",
              "title": "Chancellor Valorum's True Allegiance"
            },
            {
              "num": "62",
              "title": "Vote of No Confidence"
            },
            {
              "num": "63",
              "title": "The Rebellious Qui-Gon Jinn"
            },
            {
              "num": "64",
              "title": "\"Fear is the path to the dark side\""
            },
            {
              "num": "65",
              "title": "Palpatine's Rise to Supreme Chancellor"
            },
            {
              "num": "66",
              "title": "Return to Naboo"
            },
            {
              "num": "67",
              "title": "The Will of the Force"
            },
            {
              "num": "68",
              "title": "Otoh Gunga Deserted"
            },
            {
              "num": "69",
              "title": "Imploring the Gungans for Help"
            },
            {
              "num": "70",
              "title": "The True Queen Revealed"
            },
            {
              "num": "71",
              "title": "Jar Jar Binks' Promotion"
            },
            {
              "num": "72",
              "title": "The Plan to Capture the Viceroy"
            },
            {
              "num": "73",
              "title": "The Gungans Mobilize"
            },
            {
              "num": "74",
              "title": "The Trade Federation Opens Fire"
            },
            {
              "num": "75",
              "title": "The Queen's Army Mounts Their Attack!"
            },
            {
              "num": "76",
              "title": "Dispatching the Pilots"
            },
            {
              "num": "77",
              "title": "Anakin Skywalker's Hiding Spot"
            },
            {
              "num": "78",
              "title": "Engaging the Droid Control Ship"
            },
            {
              "num": "79",
              "title": "Droids Activated!"
            },
            {
              "num": "80",
              "title": "Jedi vs. Sith"
            },
            {
              "num": "81",
              "title": "R2-D2 & Anakin Skywalker Join the Battle"
            },
            {
              "num": "82",
              "title": "Duel Beneath the Palace"
            },
            {
              "num": "83",
              "title": "Swarms of Droid Starships"
            },
            {
              "num": "84",
              "title": "Ascending the Palace Walls"
            },
            {
              "num": "85",
              "title": "The Gungan Shields Fall"
            },
            {
              "num": "86",
              "title": "Crash Landing in the Droid Ship Hangar"
            },
            {
              "num": "87",
              "title": "The Queen Captured?"
            },
            {
              "num": "88",
              "title": "Obi-Wan Kenobi's Ferocious Fight"
            },
            {
              "num": "89",
              "title": "The Main Reactor Fails"
            },
            {
              "num": "90",
              "title": "The Droid Army Deactivated"
            },
            {
              "num": "91",
              "title": "The Sith Apprentice Defeated!"
            },
            {
              "num": "92",
              "title": "Viceroy Apprehended"
            },
            {
              "num": "93",
              "title": "\"Peace and prosperity to the Republic\""
            },
            {
              "num": "94",
              "title": "At Odds with Master Yoda"
            },
            {
              "num": "95",
              "title": "The Gungans are Surrounded"
            },
            {
              "num": "96",
              "title": "The Fate of Anakin Skywalker"
            },
            {
              "num": "97",
              "title": "\"Always two there are…\""
            },
            {
              "num": "98",
              "title": "The Gungans Arrive in Theed"
            },
            {
              "num": "99",
              "title": "Padawan Anakin Skywalker"
            },
            {
              "num": "100",
              "title": "Peace for Naboo"
            }
          ]
        }
      ],
      "insert": [
        {
          "count": 20,
          "name": "DUEL OF THE FATES",
          "meta": "Numbered only — Green /99 is the entry tier",
          "parallels": 7,
          "cards": [
            {
              "num": "DF-1",
              "title": "Storming the Palace Hangar"
            },
            {
              "num": "DF-2",
              "title": "Enter: Darth Maul!"
            },
            {
              "num": "DF-3",
              "title": "Two Jedi Versus One Sith"
            },
            {
              "num": "DF-4",
              "title": "Beneath the Palace"
            },
            {
              "num": "DF-5",
              "title": "Obi-Wan Kenobi Hangs for Dear Life!"
            },
            {
              "num": "DF-6",
              "title": "Qui-Gon Jinn Takes on Darth Maul Alone"
            },
            {
              "num": "DF-7",
              "title": "Struggling to Catch Up"
            },
            {
              "num": "DF-8",
              "title": "Separated by Laser Gates"
            },
            {
              "num": "DF-9",
              "title": "The Intimidating Darth Maul"
            },
            {
              "num": "DF-10",
              "title": "A Moment of Calm for Qui-Gon Jinn"
            },
            {
              "num": "DF-11",
              "title": "Darth Maul Gains the Upper Hand"
            },
            {
              "num": "DF-12",
              "title": "The Sith Waits for the Apprentice"
            },
            {
              "num": "DF-13",
              "title": "A Flurry of Attacks from Obi-Wan Kenobi"
            },
            {
              "num": "DF-14",
              "title": "Maul's Lightsaber is Cut in Half"
            },
            {
              "num": "DF-15",
              "title": "Sending His Oppenent into the Chasm!"
            },
            {
              "num": "DF-16",
              "title": "Darth Maul Taunts Obi-Wan Kenobi"
            },
            {
              "num": "DF-17",
              "title": "Obi-Wan Kenobi Reemerges!"
            },
            {
              "num": "DF-18",
              "title": "Qui-Gon Jinn's Final Request"
            },
            {
              "num": "DF-19",
              "title": "Qui-Gon Jinn Advances"
            },
            {
              "num": "DF-20",
              "title": "Darth Maul pulls out Dual Lightsaber"
            }
          ]
        },
        {
          "count": 12,
          "name": "JEDI HIGH COUNCIL",
          "meta": "Every card serial-numbered /100",
          "parallels": 5,
          "cards": [
            {
              "num": "JC-1",
              "title": "Yaddle"
            },
            {
              "num": "JC-2",
              "title": "Plo Koon"
            },
            {
              "num": "JC-3",
              "title": "Adi Gallia"
            },
            {
              "num": "JC-4",
              "title": "Depa Billaba"
            },
            {
              "num": "JC-5",
              "title": "Saesee Tiin"
            },
            {
              "num": "JC-6",
              "title": "Yarael Poof"
            },
            {
              "num": "JC-7",
              "title": "Eeth Koth"
            },
            {
              "num": "JC-8",
              "title": "Oppo Rancisis"
            },
            {
              "num": "JC-9",
              "title": "Even Piell"
            },
            {
              "num": "JC-10",
              "title": "Ki-Adi-Mundi"
            },
            {
              "num": "JC-11",
              "title": "Mace Windu"
            },
            {
              "num": "JC-12",
              "title": "Yoda"
            }
          ]
        },
        {
          "count": 10,
          "name": "PODRACING",
          "meta": "Numbered only — Green /99 is the entry tier",
          "parallels": 7,
          "cards": [
            {
              "num": "PR-1",
              "title": "Arriving at the Hangar"
            },
            {
              "num": "PR-2",
              "title": "Watto's Chance Cubes"
            },
            {
              "num": "PR-3",
              "title": "Sebulba's Interference"
            },
            {
              "num": "PR-4",
              "title": "A Tough Start for Anakin Skywalker"
            },
            {
              "num": "PR-5",
              "title": "Weaving Through the Other Racers"
            },
            {
              "num": "PR-6",
              "title": "Pushed off of the Track by Sebulba!"
            },
            {
              "num": "PR-7",
              "title": "Quick Thinking Recovery"
            },
            {
              "num": "PR-8",
              "title": "In the Final Stretch!"
            },
            {
              "num": "PR-9",
              "title": "Victory for Anakin Skywalker!"
            },
            {
              "num": "PR-10",
              "title": "Freed from Watto"
            }
          ]
        },
        {
          "count": 20,
          "name": "SAPPHIRE SELECTIONS",
          "meta": "The top 20 characters of Episode I",
          "parallels": 4,
          "cards": [
            {
              "num": "SS-1",
              "title": "Qui-Gon Jinn"
            },
            {
              "num": "SS-2",
              "title": "Queen Amidala"
            },
            {
              "num": "SS-3",
              "title": "R2-D2"
            },
            {
              "num": "SS-4",
              "title": "Sabé"
            },
            {
              "num": "SS-5",
              "title": "Anakin Skywalker"
            },
            {
              "num": "SS-6",
              "title": "Jar Jar Binks"
            },
            {
              "num": "SS-7",
              "title": "Mace Windu"
            },
            {
              "num": "SS-8",
              "title": "Yoda"
            },
            {
              "num": "SS-9",
              "title": "Captain Panaka"
            },
            {
              "num": "SS-10",
              "title": "Darth Maul"
            },
            {
              "num": "SS-11",
              "title": "Senator Palpatine"
            },
            {
              "num": "SS-12",
              "title": "Shmi Skywalker"
            },
            {
              "num": "SS-13",
              "title": "Ki-Adi-Mundi"
            },
            {
              "num": "SS-14",
              "title": "Sebulba"
            },
            {
              "num": "SS-15",
              "title": "Nute Gunray"
            },
            {
              "num": "SS-16",
              "title": "Boss Nass"
            },
            {
              "num": "SS-17",
              "title": "Sio Bibble"
            },
            {
              "num": "SS-18",
              "title": "Chancellor Valorum"
            },
            {
              "num": "SS-19",
              "title": "Ric Olié"
            },
            {
              "num": "SS-20",
              "title": "Obi-Wan Kenobi"
            }
          ]
        }
      ],
      "auto": [
        {
          "count": 13,
          "name": "PHANTOM MENACE CAST AUTOGRAPHS",
          "meta": "Original cast · no per-box guarantee",
          "parallels": 3,
          "cards": [
            {
              "num": "PA-AB",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "PA-BB",
              "title": "Brian Blessed",
              "meta": "Boss Nass"
            },
            {
              "num": "PA-EM",
              "title": "Ewan McGregor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "PA-IM",
              "title": "Ian McDiarmid",
              "meta": "Senator Palpatine"
            },
            {
              "num": "PA-KK",
              "title": "Keira Knightley",
              "meta": "Sabé"
            },
            {
              "num": "PA-LM",
              "title": "Lewis MacLeod",
              "meta": "Sebulba"
            },
            {
              "num": "PA-MC",
              "title": "Michaela Cottrell",
              "meta": "Even Piell"
            },
            {
              "num": "PA-NP",
              "title": "Natalie Portman",
              "meta": "Queen Amidala"
            },
            {
              "num": "PA-OD",
              "title": "Oliver Ford Davies",
              "meta": "Sio Bibble"
            },
            {
              "num": "PA-RB",
              "title": "Ralph Brown",
              "meta": "Ric Olié"
            },
            {
              "num": "PA-RP",
              "title": "Ray Park",
              "meta": "Darth Maul"
            },
            {
              "num": "PA-SJ",
              "title": "Samuel L. Jackson",
              "meta": "Mace Windu"
            },
            {
              "num": "PA-WD",
              "title": "Warwick Davis",
              "meta": "Weazel"
            }
          ]
        },
        {
          "count": 3,
          "name": "DUAL AUTOGRAPHS",
          "meta": "Two signers per card · all serial /5",
          "parallels": 2,
          "cards": [
            {
              "num": "PD-MB",
              "title": "Ewan McGregor / Ahmed Best",
              "meta": "Obi-Wan Kenobi / Jar Jar Binks"
            },
            {
              "num": "PD-PK",
              "title": "Keira Knightley / Natalie Portman",
              "meta": "Sabé / Queen Amidala"
            },
            {
              "num": "PD-PM",
              "title": "Ray Park / Ian McDiarmid",
              "meta": "Darth Maul / Darth Sidious"
            }
          ]
        },
        {
          "count": 9,
          "name": "SAPPHIRE SELECTIONS AUTOGRAPHS",
          "meta": "Signed Sapphire Selections designs",
          "parallels": 2,
          "cards": [
            {
              "num": "SSA-AB",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "SSA-BB",
              "title": "Brian Blessed",
              "meta": "Boss Nass"
            },
            {
              "num": "SSA-EM",
              "title": "Ewan McGregor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "SSA-IM",
              "title": "Ian McDiarmid",
              "meta": "Senator Palpatine"
            },
            {
              "num": "SSA-KK",
              "title": "Keira Knightley",
              "meta": "Sabé"
            },
            {
              "num": "SSA-NP",
              "title": "Natalie Portman",
              "meta": "Queen Amidala"
            },
            {
              "num": "SSA-OD",
              "title": "Oliver Ford Davies",
              "meta": "Sio Bibble"
            },
            {
              "num": "SSA-RP",
              "title": "Ray Park",
              "meta": "Darth Maul"
            },
            {
              "num": "SSA-SJ",
              "title": "Samuel L. Jackson",
              "meta": "Mace Windu"
            }
          ]
        }
      ]
    }
  },

  '2023-chrome-sapphire': {
      "setId": "2023-chrome-sapphire",
      "year": "2023",
      "brand": "TOPPS",
      "title": "STAR WARS SAPPHIRE RETURN OF THE JEDI 40TH ANNIVERSARY",
      "releaseDate": "7 / 12 / 2023",
      "lede": "A Topps.com online exclusive for the 40th anniversary of Return of the Jedi — the complete 1983 Topps set reborn on Sapphire stock. All 220 cards return across Series 1 and Series 2, right down to the three checklist cards, beneath a seven-tier ladder from Aqua /75 to the one-of-one Onyx. The 55 Chrome Sticker Reprints revive the 1983 sticker art with the four original colored puzzle backs, and for the first time in the Star Wars Sapphire line there are autographs to chase: eight Return of the Jedi cast signers, from Mark Hamill and Harrison Ford to Carrie Fisher.",
      "stats": [
          {
              "num": "220",
              "label": "Base Cards",
              "sub": "1983 Series 1 + Series 2",
              "color": "gold"
          },
          {
              "num": "55",
              "label": "Sticker Reprints",
              "sub": "Four 1983 puzzle backs",
              "color": "cyan"
          },
          {
              "num": "8",
              "label": "Auto Cards",
              "sub": "First Sapphire autographs",
              "color": "green"
          },
          {
              "num": "7",
              "label": "Base Parallels",
              "sub": "Aqua /75 → Onyx 1/1",
              "color": "purple"
          },
          {
              "num": "4",
              "label": "Sub-sets Total",
              "sub": "Tracked on CK",
              "color": "red"
          }
      ],
      "hobbyBox": [
          {
              "v": "8",
              "l": "Packs per box"
          },
          {
              "v": "4",
              "l": "Cards per pack"
          },
          {
              "v": "~2",
              "l": "Numbered parallels per box"
          },
          {
              "v": "1",
              "l": "Product · Topps.com online exclusive"
          }
      ],
      "pullRates": [
          {
              "name": "Aqua Sapphire /75 (base)",
              "odds": "1 : 11",
              "tier": "normal"
          },
          {
              "name": "Chrome Sticker Reprints",
              "odds": "1 : 31",
              "tier": "normal"
          },
          {
              "name": "Onyx Sapphire 1/1 (base)",
              "odds": "1 : 753",
              "tier": "rare"
          },
          {
              "name": "Sticker Reprints Superfractor 1/1",
              "odds": "1 : 2,974",
              "tier": "rare"
          },
          {
              "name": "ROTJ Cast Autograph Red /5",
              "odds": "1 : 4,014",
              "tier": "mythic"
          },
          {
              "name": "1983 Buyback Redemption",
              "odds": "1 : 4,117",
              "tier": "mythic"
          },
          {
              "name": "ROTJ Cast Autograph Purple /10",
              "odds": "1 : 8,028",
              "tier": "mythic"
          },
          {
              "name": "ROTJ Cast Autograph Superfractor 1/1",
              "odds": "1 : 20,070",
              "tier": "mythic"
          }
      ],
      "parallelRainbow": [
          {
              "name": "SAPPHIRE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #7fb8ff 0%, #2d6fd0 55%, #b8dcff 100%)",
              "darkText": true
          },
          {
              "name": "AQUA",
              "pr": "/75",
              "gradient": "linear-gradient(135deg, #00e5ff 0%, #0090b8 100%)",
              "darkText": true
          },
          {
              "name": "GREEN",
              "pr": "/60",
              "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
              "darkText": true
          },
          {
              "name": "ORANGE",
              "pr": "/25",
              "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
          },
          {
              "name": "GOLD",
              "pr": "/15",
              "gradient": "linear-gradient(135deg, #f0c040 0%, #c89020 100%)",
              "darkText": true
          },
          {
              "name": "PURPLE",
              "pr": "/10",
              "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
          },
          {
              "name": "RED",
              "pr": "/5",
              "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
          },
          {
              "name": "ONYX",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
          }
      ],
      "artists": [],
      "subsets": {
          "base": [
              {
                  "count": 132,
                  "name": "BASE SERIES 1",
                  "meta": "The 1983 Series 1 set — cards 1-132 incl. Checklists I & II",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "1",
                          "title": "132 Cards - 33 Stickers"
                      },
                      {
                          "num": "2",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "3",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "4",
                          "title": "Han Solo"
                      },
                      {
                          "num": "5",
                          "title": "Princess Leia Organa"
                      },
                      {
                          "num": "6",
                          "title": "Lando Calrissian"
                      },
                      {
                          "num": "7",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "8",
                          "title": "C-3PO and R2-D2"
                      },
                      {
                          "num": "9",
                          "title": "The New Death Star"
                      },
                      {
                          "num": "10",
                          "title": "The Inspection"
                      },
                      {
                          "num": "11",
                          "title": "Toward the Desert Palace"
                      },
                      {
                          "num": "12",
                          "title": "Bib Fortuna"
                      },
                      {
                          "num": "13",
                          "title": "Court of Evil"
                      },
                      {
                          "num": "14",
                          "title": "Jabba the Hutt"
                      },
                      {
                          "num": "15",
                          "title": "Intergalactic Gangster"
                      },
                      {
                          "num": "16",
                          "title": "Salacious Crumb"
                      },
                      {
                          "num": "17",
                          "title": "A Message for Jabba the Hutt"
                      },
                      {
                          "num": "18",
                          "title": "Dungeons of Jabba the Hutt"
                      },
                      {
                          "num": "19",
                          "title": "Beedo and a Jawa"
                      },
                      {
                          "num": "20",
                          "title": "Sy Snootles and the Rebo Band"
                      },
                      {
                          "num": "21",
                          "title": "Droopy McCool"
                      },
                      {
                          "num": "22",
                          "title": "Sy Snootles"
                      },
                      {
                          "num": "23",
                          "title": "Watched by Boba Fett"
                      },
                      {
                          "num": "24",
                          "title": "Boushh's Captive"
                      },
                      {
                          "num": "25",
                          "title": "The Bounty Hunter Boushh"
                      },
                      {
                          "num": "26",
                          "title": "The Villains Confer"
                      },
                      {
                          "num": "27",
                          "title": "Han Solo's Plight"
                      },
                      {
                          "num": "28",
                          "title": "The Rescuer"
                      },
                      {
                          "num": "29",
                          "title": "Decarbonized!"
                      },
                      {
                          "num": "30",
                          "title": "Princess Leia to the Rescue!"
                      },
                      {
                          "num": "31",
                          "title": "Heroes in Disguise"
                      },
                      {
                          "num": "32",
                          "title": "The Princess Apprehended"
                      },
                      {
                          "num": "33",
                          "title": "Luke Skywalker Arrives"
                      },
                      {
                          "num": "34",
                          "title": "The Young Jedi"
                      },
                      {
                          "num": "35",
                          "title": "The Court in Chaos!"
                      },
                      {
                          "num": "36",
                          "title": "The Rancor Pit"
                      },
                      {
                          "num": "37",
                          "title": "Facing Jabba the Hutt"
                      },
                      {
                          "num": "38",
                          "title": "The Sail Barge and the Desert Skiff"
                      },
                      {
                          "num": "39",
                          "title": "Jabba the Hutt's New Dancing Girl"
                      },
                      {
                          "num": "40",
                          "title": "On the Sail Barge"
                      },
                      {
                          "num": "41",
                          "title": "A Monstrous Fate!"
                      },
                      {
                          "num": "42",
                          "title": "The Battle Begins"
                      },
                      {
                          "num": "43",
                          "title": "Lando Calrissian's Fight for Life"
                      },
                      {
                          "num": "44",
                          "title": "Fury of the Jedi!"
                      },
                      {
                          "num": "45",
                          "title": "Princess Leia Strikes Back!"
                      },
                      {
                          "num": "46",
                          "title": "The Demise of Jabba the Hutt"
                      },
                      {
                          "num": "47",
                          "title": "Boba Fett's Last Stand"
                      },
                      {
                          "num": "48",
                          "title": "The Rescue"
                      },
                      {
                          "num": "49",
                          "title": "Gamorrean Guard"
                      },
                      {
                          "num": "50",
                          "title": "The Deadly Cannon"
                      },
                      {
                          "num": "51",
                          "title": "The Raging Battle"
                      },
                      {
                          "num": "52",
                          "title": "Princess Leia Swings into Action!"
                      },
                      {
                          "num": "53",
                          "title": "Swing to Safety"
                      },
                      {
                          "num": "54",
                          "title": "On the Death Star"
                      },
                      {
                          "num": "55",
                          "title": "Guards of the Emperor"
                      },
                      {
                          "num": "56",
                          "title": "The Deciders"
                      },
                      {
                          "num": "57",
                          "title": "The Emperor"
                      },
                      {
                          "num": "58",
                          "title": "Yoda, the Jedi Master"
                      },
                      {
                          "num": "59",
                          "title": "A Word with Ben (Obi-Wan) Kenobi"
                      },
                      {
                          "num": "60",
                          "title": "The Allies Meet"
                      },
                      {
                          "num": "61",
                          "title": "A New Challenge"
                      },
                      {
                          "num": "62",
                          "title": "Pondering the Raid"
                      },
                      {
                          "num": "63",
                          "title": "Mission: Destroy the Death Star!"
                      },
                      {
                          "num": "64",
                          "title": "Mon Mothma"
                      },
                      {
                          "num": "65",
                          "title": "The Friends Depart"
                      },
                      {
                          "num": "66",
                          "title": "Benevolent Creature"
                      },
                      {
                          "num": "67",
                          "title": "The Plan Begins"
                      },
                      {
                          "num": "68",
                          "title": "Forest of Endor"
                      },
                      {
                          "num": "69",
                          "title": "Droids on the Move"
                      },
                      {
                          "num": "70",
                          "title": "Blasting a Speeder Bike"
                      },
                      {
                          "num": "71",
                          "title": "Approaching the Princess"
                      },
                      {
                          "num": "72",
                          "title": "A New Found Friend"
                      },
                      {
                          "num": "73",
                          "title": "Princess Leia's Smile"
                      },
                      {
                          "num": "74",
                          "title": "Under Attack!"
                      },
                      {
                          "num": "75",
                          "title": "Imperial Scout Peril!"
                      },
                      {
                          "num": "76",
                          "title": "Entering the Throne Room"
                      },
                      {
                          "num": "77",
                          "title": "The Skywalker Factor"
                      },
                      {
                          "num": "78",
                          "title": "Captured by the Ewoks"
                      },
                      {
                          "num": "79",
                          "title": "The Netted Droid"
                      },
                      {
                          "num": "80",
                          "title": "All Hail See-Threepio!"
                      },
                      {
                          "num": "81",
                          "title": "Royal Treatment"
                      },
                      {
                          "num": "82",
                          "title": "Sitting with Royalty"
                      },
                      {
                          "num": "83",
                          "title": "Levitated by Luke"
                      },
                      {
                          "num": "84",
                          "title": "The Ewok Leaders"
                      },
                      {
                          "num": "85",
                          "title": "Logray and Chief Chirpa"
                      },
                      {
                          "num": "86",
                          "title": "Help from Princess Leia"
                      },
                      {
                          "num": "87",
                          "title": "Will Han Solo Be Dinner?"
                      },
                      {
                          "num": "88",
                          "title": "The Baby Ewok"
                      },
                      {
                          "num": "89",
                          "title": "The Forest Creatures"
                      },
                      {
                          "num": "90",
                          "title": "The Droid and the Ewok"
                      },
                      {
                          "num": "91",
                          "title": "R2-D2 Meets Wicket"
                      },
                      {
                          "num": "92",
                          "title": "Unexpected Allies"
                      },
                      {
                          "num": "93",
                          "title": "Serious Situation"
                      },
                      {
                          "num": "94",
                          "title": "Luke Skywalker's Destiny"
                      },
                      {
                          "num": "95",
                          "title": "Quiet, See-Threepio!"
                      },
                      {
                          "num": "96",
                          "title": "Imperial Biker Scout"
                      },
                      {
                          "num": "97",
                          "title": "Biker Scout and the Battlefield"
                      },
                      {
                          "num": "98",
                          "title": "Hans Solo's Approach"
                      },
                      {
                          "num": "99",
                          "title": "The Ultimate Mission"
                      },
                      {
                          "num": "100",
                          "title": "Ready for Action!"
                      },
                      {
                          "num": "101",
                          "title": "Ambushed by the Empire"
                      },
                      {
                          "num": "102",
                          "title": "Observed by the Ewoks"
                      },
                      {
                          "num": "103",
                          "title": "The Courageous Ewoks"
                      },
                      {
                          "num": "104",
                          "title": "Prisoners!"
                      },
                      {
                          "num": "105",
                          "title": "Revising Their Plan"
                      },
                      {
                          "num": "106",
                          "title": "AT-ST (All Terrain Scout Transport)"
                      },
                      {
                          "num": "107",
                          "title": "The Forest Fighters!"
                      },
                      {
                          "num": "108",
                          "title": "Break for Freedom!"
                      },
                      {
                          "num": "109",
                          "title": "Artoo-Detoo - Hit!"
                      },
                      {
                          "num": "110",
                          "title": "Chewbacca Triumphant!"
                      },
                      {
                          "num": "111",
                          "title": "Ewoks to the Rescue!"
                      },
                      {
                          "num": "112",
                          "title": "Battle in the Forest"
                      },
                      {
                          "num": "113",
                          "title": "Stormtrooper Attack!"
                      },
                      {
                          "num": "114",
                          "title": "The Victorious Rebels"
                      },
                      {
                          "num": "115",
                          "title": "Time Out for Love"
                      },
                      {
                          "num": "116",
                          "title": "Facing the Emperor"
                      },
                      {
                          "num": "117",
                          "title": "Master of Terror"
                      },
                      {
                          "num": "118",
                          "title": "The Emperor's Offer"
                      },
                      {
                          "num": "119",
                          "title": "Battle of the Jedi"
                      },
                      {
                          "num": "120",
                          "title": "Lightsaber Battle!"
                      },
                      {
                          "num": "121",
                          "title": "Darth Vader Is Down!"
                      },
                      {
                          "num": "122",
                          "title": "The Confrontation"
                      },
                      {
                          "num": "123",
                          "title": "The Death Star Raid"
                      },
                      {
                          "num": "124",
                          "title": "Military Leader Admiral Ackbar"
                      },
                      {
                          "num": "125",
                          "title": "Within the Death Star"
                      },
                      {
                          "num": "126",
                          "title": "Victory Celebration!"
                      },
                      {
                          "num": "127",
                          "title": "Congratulating Wedge"
                      },
                      {
                          "num": "128",
                          "title": "The Triumphant Trio"
                      },
                      {
                          "num": "129",
                          "title": "The Heroic Droids"
                      },
                      {
                          "num": "130",
                          "title": "Toward Brighter Tomorrows"
                      },
                      {
                          "num": "131",
                          "title": "Checklist I"
                      },
                      {
                          "num": "132",
                          "title": "Checklist II"
                      }
                  ]
              },
              {
                  "count": 88,
                  "name": "BASE SERIES 2",
                  "meta": "The 1983 Series 2 set — cards 133-220",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "133",
                          "title": "88 Cards - 22 Stickers"
                      },
                      {
                          "num": "134",
                          "title": "Path to Destiny"
                      },
                      {
                          "num": "135",
                          "title": "Captured!"
                      },
                      {
                          "num": "136",
                          "title": "The Courageous Jedi"
                      },
                      {
                          "num": "137",
                          "title": "The Victors"
                      },
                      {
                          "num": "138",
                          "title": "Wicket and Princess Leia"
                      },
                      {
                          "num": "139",
                          "title": "The Emperor's Arrival"
                      },
                      {
                          "num": "140",
                          "title": "Sail Barge Battle!"
                      },
                      {
                          "num": "141",
                          "title": "Luke Skywalker, the Jedi"
                      },
                      {
                          "num": "142",
                          "title": "The Approach of Wicket"
                      },
                      {
                          "num": "143",
                          "title": "A Close Call!"
                      },
                      {
                          "num": "144",
                          "title": "Above the Sarlacc Pit"
                      },
                      {
                          "num": "145",
                          "title": "Admiral Ackbar's Defenders"
                      },
                      {
                          "num": "146",
                          "title": "R2-D2 on Endor"
                      },
                      {
                          "num": "147",
                          "title": "Boba Fett Attacks!"
                      },
                      {
                          "num": "148",
                          "title": "Deadly Plunge!"
                      },
                      {
                          "num": "149",
                          "title": "Lando Calrissian's Disguise"
                      },
                      {
                          "num": "150",
                          "title": "Soldiers of the Empire"
                      },
                      {
                          "num": "151",
                          "title": "A Curious Ewok"
                      },
                      {
                          "num": "152",
                          "title": "A Pensive Luke Skywalker"
                      },
                      {
                          "num": "153",
                          "title": "The Captive Princess"
                      },
                      {
                          "num": "154",
                          "title": "Luke Skywalker Surrenders"
                      },
                      {
                          "num": "155",
                          "title": "Thoughts of a Jedi"
                      },
                      {
                          "num": "156",
                          "title": "The Jaws of Death"
                      },
                      {
                          "num": "157",
                          "title": "Princess Leia Has the Force!"
                      },
                      {
                          "num": "158",
                          "title": "Arrival of the Emperor"
                      },
                      {
                          "num": "159",
                          "title": "Reunion on Endor"
                      },
                      {
                          "num": "160",
                          "title": "Toward the Sarlacc Pit"
                      },
                      {
                          "num": "161",
                          "title": "Sail Barge Creatures"
                      },
                      {
                          "num": "162",
                          "title": "Friends of the Alliance!"
                      },
                      {
                          "num": "163",
                          "title": "The Dreaded Rancor"
                      },
                      {
                          "num": "164",
                          "title": "Face of Terror"
                      },
                      {
                          "num": "165",
                          "title": "Inside Jabba the Hutt's Palace"
                      },
                      {
                          "num": "166",
                          "title": "The Ewok Village"
                      },
                      {
                          "num": "167",
                          "title": "A Collection of Creatures"
                      },
                      {
                          "num": "168",
                          "title": "Alert to Danger!"
                      },
                      {
                          "num": "169",
                          "title": "Walking the Plank!"
                      },
                      {
                          "num": "170",
                          "title": "A Gamorrean Guard Emerges"
                      },
                      {
                          "num": "171",
                          "title": "The Imperial Fleet"
                      },
                      {
                          "num": "172",
                          "title": "Jabba the Hutt on the Sail Barge"
                      },
                      {
                          "num": "173",
                          "title": "Escorted to the Ewok Village"
                      },
                      {
                          "num": "174",
                          "title": "A Monstrous Guest!"
                      },
                      {
                          "num": "175",
                          "title": "Village of the Ewoks"
                      },
                      {
                          "num": "176",
                          "title": "Aboard the Sail Barge"
                      },
                      {
                          "num": "177",
                          "title": "Confronting Their Destiny"
                      },
                      {
                          "num": "178",
                          "title": "\"Where's Princess Leia?\""
                      },
                      {
                          "num": "179",
                          "title": "Horror from the Pit"
                      },
                      {
                          "num": "180",
                          "title": "\"Give in to Your Hate!\""
                      },
                      {
                          "num": "181",
                          "title": "Awaiting His Majesty"
                      },
                      {
                          "num": "182",
                          "title": "A Mother Ewok and Child"
                      },
                      {
                          "num": "183",
                          "title": "A Concerned Princess Leia"
                      },
                      {
                          "num": "184",
                          "title": "Lead Singer Sy Snootles"
                      },
                      {
                          "num": "185",
                          "title": "The Arrival of Boushh"
                      },
                      {
                          "num": "186",
                          "title": "Master of His Court"
                      },
                      {
                          "num": "187",
                          "title": "Star Lovers"
                      },
                      {
                          "num": "188",
                          "title": "Luke Skywalker…Now a Jedi!"
                      },
                      {
                          "num": "189",
                          "title": "Battle of the Bunker!"
                      },
                      {
                          "num": "190",
                          "title": "Portrait of Wicket"
                      },
                      {
                          "num": "191",
                          "title": "Trapped by the Empire"
                      },
                      {
                          "num": "192",
                          "title": "Their Secret Revealed"
                      },
                      {
                          "num": "193",
                          "title": "Rethinking the Plan"
                      },
                      {
                          "num": "194",
                          "title": "Snagged by the Ewoks"
                      },
                      {
                          "num": "195",
                          "title": "Han Solo's in Trouble!"
                      },
                      {
                          "num": "196",
                          "title": "Is Han Solo Giving Up?"
                      },
                      {
                          "num": "197",
                          "title": "The Royal Droid"
                      },
                      {
                          "num": "198",
                          "title": "Princess Leia Intercedes"
                      },
                      {
                          "num": "199",
                          "title": "Rescuing Han Solo"
                      },
                      {
                          "num": "200",
                          "title": "Father Versus Son"
                      },
                      {
                          "num": "201",
                          "title": "Luke Skywalker, Jedi Warrior"
                      },
                      {
                          "num": "202",
                          "title": "The Young Jedi Knight"
                      },
                      {
                          "num": "203",
                          "title": "Han Solo Is Alive!"
                      },
                      {
                          "num": "204",
                          "title": "Lando Calrissian Undercover"
                      },
                      {
                          "num": "205",
                          "title": "Horrendous Creature"
                      },
                      {
                          "num": "206",
                          "title": "Corridors of the Imperial Destroyer"
                      },
                      {
                          "num": "207",
                          "title": "Surrounded by Ewoks"
                      },
                      {
                          "num": "208",
                          "title": "Gamorrean Guard Profile"
                      },
                      {
                          "num": "209",
                          "title": "Hulking Gamorrean Guard"
                      },
                      {
                          "num": "210",
                          "title": "Guests of Jabba the Hutt"
                      },
                      {
                          "num": "211",
                          "title": "A Full-Fledged Jedi!"
                      },
                      {
                          "num": "212",
                          "title": "Bizarre Alien Creatures"
                      },
                      {
                          "num": "213",
                          "title": "Headquarters Frigate"
                      },
                      {
                          "num": "214",
                          "title": "TIE Interceptor (3/4 View)"
                      },
                      {
                          "num": "215",
                          "title": "The Nearly Completed Death Star"
                      },
                      {
                          "num": "216",
                          "title": "Rebel Cruiser"
                      },
                      {
                          "num": "217",
                          "title": "TIE Interceptor (Front View)"
                      },
                      {
                          "num": "218",
                          "title": "The Emperor's Shuttle"
                      },
                      {
                          "num": "219",
                          "title": "Portrait of Chewbacca"
                      },
                      {
                          "num": "220",
                          "title": "Checklist 133-172"
                      }
                  ]
              }
          ],
          "insert": [
              {
                  "count": 55,
                  "name": "CHROME STICKER REPRINTS",
                  "meta": "1983 sticker art · backs rebuild the four colored puzzles",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "1",
                          "title": "Yoda"
                      },
                      {
                          "num": "2",
                          "title": "Logray"
                      },
                      {
                          "num": "3",
                          "title": "Droopy McCool"
                      },
                      {
                          "num": "4",
                          "title": "Jabba the Hutt"
                      },
                      {
                          "num": "5",
                          "title": "Ree-Yees"
                      },
                      {
                          "num": "6",
                          "title": "Admiral Ackbar"
                      },
                      {
                          "num": "7",
                          "title": "Boushh"
                      },
                      {
                          "num": "8",
                          "title": "Han Solo"
                      },
                      {
                          "num": "9",
                          "title": "Princess Leia"
                      },
                      {
                          "num": "10",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "11",
                          "title": "Han Solo"
                      },
                      {
                          "num": "12",
                          "title": "C-3PO"
                      },
                      {
                          "num": "13",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "14",
                          "title": "Sy Snootles"
                      },
                      {
                          "num": "15",
                          "title": "Baby Ewok"
                      },
                      {
                          "num": "16",
                          "title": "Nien Nunb"
                      },
                      {
                          "num": "17",
                          "title": "Lando Calrission"
                      },
                      {
                          "num": "18",
                          "title": "R2-D2"
                      },
                      {
                          "num": "19",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "20",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "21",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "22",
                          "title": "Gamorrean Guard"
                      },
                      {
                          "num": "23",
                          "title": "Salacious B. Crumb"
                      },
                      {
                          "num": "24",
                          "title": "Ewok"
                      },
                      {
                          "num": "25",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "26",
                          "title": "Ewok"
                      },
                      {
                          "num": "27",
                          "title": "Jabba the Hutt"
                      },
                      {
                          "num": "28",
                          "title": "Lando in Disguise"
                      },
                      {
                          "num": "29",
                          "title": "Max Rebo"
                      },
                      {
                          "num": "30",
                          "title": "Leia"
                      },
                      {
                          "num": "31",
                          "title": "Leia"
                      },
                      {
                          "num": "32",
                          "title": "Han Solo"
                      },
                      {
                          "num": "33",
                          "title": "Biker Scout"
                      },
                      {
                          "num": "34",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "35",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "36",
                          "title": "Han Solo"
                      },
                      {
                          "num": "37",
                          "title": "Princess Leia"
                      },
                      {
                          "num": "38",
                          "title": "See-Threepio"
                      },
                      {
                          "num": "39",
                          "title": "Artoo-Detoo"
                      },
                      {
                          "num": "40",
                          "title": "Wicket"
                      },
                      {
                          "num": "41",
                          "title": "Admiral Ackbar"
                      },
                      {
                          "num": "42",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "43",
                          "title": "The Emperor"
                      },
                      {
                          "num": "44",
                          "title": "Millennium Falcon"
                      },
                      {
                          "num": "45",
                          "title": "R2-D2 and C-3PO"
                      },
                      {
                          "num": "46",
                          "title": "Han Solo"
                      },
                      {
                          "num": "47",
                          "title": "Desert Skiff"
                      },
                      {
                          "num": "48",
                          "title": "Nien Nunb and Lando Calrissian"
                      },
                      {
                          "num": "49",
                          "title": "Princess Leia and Jabba the Hutt"
                      },
                      {
                          "num": "50",
                          "title": "Cast Photo"
                      },
                      {
                          "num": "51",
                          "title": "Princess Leia, Chewbacca and C-3PO"
                      },
                      {
                          "num": "52",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "53",
                          "title": "R2-D2 and Wicket"
                      },
                      {
                          "num": "54",
                          "title": "Han Solo"
                      },
                      {
                          "num": "55",
                          "title": "Salacious B. Crumb"
                      }
                  ]
              }
          ],
          "auto": [
              {
                  "count": 8,
                  "name": "RETURN OF THE JEDI CAST AUTOGRAPHS",
                  "meta": "Original cast · numbered only · no per-box guarantee",
                  "parallels": 3,
                  "cards": [
                      {
                          "num": "ROTJ-CF",
                          "title": "Carrie Fisher",
                          "meta": "Princess Leia Organa"
                      },
                      {
                          "num": "ROTJ-HF",
                          "title": "Harrison Ford",
                          "meta": "Han Solo"
                      },
                      {
                          "num": "ROTJ-IM",
                          "title": "Ian McDiarmid",
                          "meta": "The Emperor"
                      },
                      {
                          "num": "ROTJ-JB",
                          "title": "Jeremy Bulloch",
                          "meta": "Boba Fett"
                      },
                      {
                          "num": "ROTJ-KB",
                          "title": "Kenny Baker",
                          "meta": "R2-D2"
                      },
                      {
                          "num": "ROTJ-MH",
                          "title": "Mark Hamill",
                          "meta": "Luke Skywalker"
                      },
                      {
                          "num": "ROTJ-PM",
                          "title": "Peter Mayhew",
                          "meta": "Chewbacca"
                      },
                      {
                          "num": "ROTJ-WD",
                          "title": "Warwick Davis",
                          "meta": "Wicket W. Warrick"
                      }
                  ]
              }
          ]
      }
  },

  '2023-obi-wan-kenobi': {
      "setId": "2023-obi-wan-kenobi",
      "year": "2023",
      "brand": "TOPPS",
      "title": "STAR WARS OBI-WAN KENOBI",
      "releaseDate": "5 / 31 / 2023",
      "lede": "The Disney+ series gets its dedicated set — a 100-card base that chronicles all six chapters, from the Inquisitors' arrival on Tatooine to the duel on the barren moon and Qui-Gon Jinn's return, under a nine-tier rainbow running from unnumbered Blue and Purple through the numbered ladder to one-of-one Black and Printing Plates. Five insert lines ride along — Heroes at 1:1 with its /5 Black Metal variation, Darth Vader & the Inquisitorius, Concept Art, Droids, and Creatures & Aliens — plus Original Art reprints in two sizes, sourced fabric relics, coin medallions, blaster-exclusive manufactured patches, and a 25-signer autograph program crowned by Ewan McGregor, Hayden Christensen, and Ian McDiarmid duals and triples.",
      "stats": [
          {
              "num": "100",
              "label": "Base Cards",
              "sub": "All six chapters",
              "color": "gold"
          },
          {
              "num": "9",
              "label": "Insert Sets",
              "sub": "Incl. /5 Black Metals",
              "color": "cyan"
          },
          {
              "num": "45",
              "label": "Auto Cards",
              "sub": "25 signers + duals & triples",
              "color": "green"
          },
          {
              "num": "24",
              "label": "Relic Cards",
              "sub": "Fabric · coins · patches",
              "color": "purple"
          },
          {
              "num": "17",
              "label": "Sub-sets Total",
              "sub": "Tracked on CK",
              "color": "red"
          }
      ],
      "hobbyBox": [
          {
              "v": "7",
              "l": "Packs per tin"
          },
          {
              "v": "8",
              "l": "Cards per pack"
          },
          {
              "v": "1",
              "l": "Autograph or sketch per tin"
          },
          {
              "v": "3",
              "l": "Formats · Hobby tin + Collector's 2-tin box + Blaster"
          }
      ],
      "pullRates": [
          {
              "name": "Heroes",
              "odds": "1 : 1",
              "tier": "normal"
          },
          {
              "name": "Concept Art · Creatures & Aliens · Original Art Reprints",
              "odds": "1 : 4",
              "tier": "normal"
          },
          {
              "name": "Darth Vader & the Inquisitorius · Droids",
              "odds": "1 : 7",
              "tier": "normal"
          },
          {
              "name": "Autographs",
              "odds": "1 : 12",
              "tier": "rare"
          },
          {
              "name": "Oversized Original Art Reprints (Collector's Hobby)",
              "odds": "1 : 14",
              "tier": "normal"
          },
          {
              "name": "Manufactured Patches (blaster packs)",
              "odds": "1 : 11",
              "tier": "normal"
          },
          {
              "name": "Dual Autographs /25",
              "odds": "1 : 759",
              "tier": "rare"
          },
          {
              "name": "Sourced Fabric Relics /99",
              "odds": "1 : 765",
              "tier": "rare"
          },
          {
              "name": "Coin Medallions /50",
              "odds": "1 : 2,349",
              "tier": "rare"
          },
          {
              "name": "Black Metal Variations /5",
              "odds": "1 : 3,654",
              "tier": "rare"
          },
          {
              "name": "Triple Autographs /5",
              "odds": "1 : 8,222",
              "tier": "mythic"
          },
          {
              "name": "Base Black 1/1",
              "odds": "1 : 5,481",
              "tier": "mythic"
          }
      ],
      "parallelRainbow": [
          {
              "name": "BASE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
              "darkText": true
          },
          {
              "name": "BLUE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
          },
          {
              "name": "PURPLE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
          },
          {
              "name": "RED",
              "pr": "/99",
              "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
          },
          {
              "name": "GREEN",
              "pr": "/75",
              "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
              "darkText": true
          },
          {
              "name": "ORANGE",
              "pr": "/50",
              "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
          },
          {
              "name": "SILVER",
              "pr": "/25",
              "gradient": "linear-gradient(135deg, #d4d4dc 0%, #9a9aa8 100%)",
              "darkText": true
          },
          {
              "name": "GOLD",
              "pr": "/10",
              "gradient": "linear-gradient(135deg, #f0c040 0%, #c89020 100%)",
              "darkText": true
          },
          {
              "name": "BLACK",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
          },
          {
              "name": "PLATES",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #c0c0c8 0%, #808088 100%)",
              "darkText": true
          }
      ],
      "artists": [],
      "subsets": {
          "base": [
              {
                  "count": 100,
                  "name": "BASE SET",
                  "meta": "All six chapters of the Disney+ series · nine-tier rainbow",
                  "parallels": 9,
                  "cards": [
                      {
                          "num": "1",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "2",
                          "title": "The Third Sister"
                      },
                      {
                          "num": "3",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "4",
                          "title": "An Ominous Ship Approaches"
                      },
                      {
                          "num": "5",
                          "title": "The Inquisitor's Arrival"
                      },
                      {
                          "num": "6",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "7",
                          "title": "A Hidden Jedi Among Them"
                      },
                      {
                          "num": "8",
                          "title": "Buying a Toy from Teeka"
                      },
                      {
                          "num": "9",
                          "title": "Leia Organa and L0LA"
                      },
                      {
                          "num": "10",
                          "title": "L0LA Among the Treetops"
                      },
                      {
                          "num": "11",
                          "title": "Owen Lars"
                      },
                      {
                          "num": "12",
                          "title": "Reva Confronts Owen Lars"
                      },
                      {
                          "num": "13",
                          "title": "The Fifth Brother"
                      },
                      {
                          "num": "14",
                          "title": "\"Stand down, Third Sister. Now!\""
                      },
                      {
                          "num": "15",
                          "title": "Obi-Wan Kenobi & Owen Lars"
                      },
                      {
                          "num": "16",
                          "title": "The Organa Family"
                      },
                      {
                          "num": "17",
                          "title": "\"There are many ways to lead. You just have to find yours.\""
                      },
                      {
                          "num": "18",
                          "title": "Bail Organa Visits an Old Ally"
                      },
                      {
                          "num": "19",
                          "title": "The Third Sister Orchestrates Leia's Kidnapping"
                      },
                      {
                          "num": "20",
                          "title": "A Clone Trooper Veteran"
                      },
                      {
                          "num": "21",
                          "title": "Obi-Wan Incognito"
                      },
                      {
                          "num": "22",
                          "title": "Haja Helps a Mother and Son off Daiyu"
                      },
                      {
                          "num": "23",
                          "title": "Haja Estree, Noble \"Jedi\""
                      },
                      {
                          "num": "24",
                          "title": "Obi-Wan Kenobi Focuses on the Investigation"
                      },
                      {
                          "num": "25",
                          "title": "Vect Nokru"
                      },
                      {
                          "num": "26",
                          "title": "The Princess Imprisoned!"
                      },
                      {
                          "num": "27",
                          "title": "The Imposing Third Sister"
                      },
                      {
                          "num": "28",
                          "title": "The Fourth Sister on Daiyu"
                      },
                      {
                          "num": "29",
                          "title": "The Fifth Brother on Daiyu"
                      },
                      {
                          "num": "30",
                          "title": "A Former Master in the Shadows"
                      },
                      {
                          "num": "31",
                          "title": "The Fifth Brother's Legion of Stormtroopers"
                      },
                      {
                          "num": "32",
                          "title": "Perched Above the Streets of Daiyu"
                      },
                      {
                          "num": "33",
                          "title": "A Con Artist with a Good Heart"
                      },
                      {
                          "num": "34",
                          "title": "\"You can't escape him, Obi-Wan!\""
                      },
                      {
                          "num": "35",
                          "title": "Darth Vader Awakens"
                      },
                      {
                          "num": "36",
                          "title": "A Quiet Moment for Obi-Wan"
                      },
                      {
                          "num": "37",
                          "title": "The Fearsome Helmet of Darth Vader"
                      },
                      {
                          "num": "38",
                          "title": "Fortress Vader"
                      },
                      {
                          "num": "39",
                          "title": "Walking across the Mapuzo Desert"
                      },
                      {
                          "num": "40",
                          "title": "Visions of Anakin"
                      },
                      {
                          "num": "41",
                          "title": "Freck"
                      },
                      {
                          "num": "42",
                          "title": "A Probe Droid Investigates"
                      },
                      {
                          "num": "43",
                          "title": "The Inquisitors Strategize"
                      },
                      {
                          "num": "44",
                          "title": "Illuminated by His Lightsaber"
                      },
                      {
                          "num": "45",
                          "title": "Tala Durith"
                      },
                      {
                          "num": "46",
                          "title": "Tala & Leia"
                      },
                      {
                          "num": "47",
                          "title": "Old Allies Clash!"
                      },
                      {
                          "num": "48",
                          "title": "Stand-off in the Quarry"
                      },
                      {
                          "num": "49",
                          "title": "Darth Vader Ignites the Battleground"
                      },
                      {
                          "num": "50",
                          "title": "Vader Amongst the Flames"
                      },
                      {
                          "num": "51",
                          "title": "Kenobi Defeated"
                      },
                      {
                          "num": "52",
                          "title": "A Shadowy Figure Approaches"
                      },
                      {
                          "num": "53",
                          "title": "Obi-Wan in the Bacta Tank"
                      },
                      {
                          "num": "54",
                          "title": "The Menacing Darth Vader"
                      },
                      {
                          "num": "55",
                          "title": "Obi-Wan Arrives on Jabiim"
                      },
                      {
                          "num": "56",
                          "title": "Kawlan Roken"
                      },
                      {
                          "num": "57",
                          "title": "Obi-Wan's New Allies Plan Their Attack"
                      },
                      {
                          "num": "58",
                          "title": "An Underwater Approach"
                      },
                      {
                          "num": "59",
                          "title": "L0LA Sneaks Aboard"
                      },
                      {
                          "num": "60",
                          "title": "Evading the Security Droids"
                      },
                      {
                          "num": "61",
                          "title": "Fortress Inquisitorius' Dark Secrets"
                      },
                      {
                          "num": "62",
                          "title": "Obi-Wan Discovers the Jedi Tomb"
                      },
                      {
                          "num": "63",
                          "title": "Kenobi on the Offensive!"
                      },
                      {
                          "num": "64",
                          "title": "Obi-Wan Holds the Ocean at Bay"
                      },
                      {
                          "num": "65",
                          "title": "The Inquisitors Approach"
                      },
                      {
                          "num": "66",
                          "title": "Leia Stays Hidden"
                      },
                      {
                          "num": "67",
                          "title": "The Third Sister and Her Purge Troopers"
                      },
                      {
                          "num": "68",
                          "title": "Inquisitors at Odds"
                      },
                      {
                          "num": "69",
                          "title": "Darth Vader Arrives on Nur"
                      },
                      {
                          "num": "70",
                          "title": "The Rebels Mourn Wade"
                      },
                      {
                          "num": "71",
                          "title": "Leia Rescued"
                      },
                      {
                          "num": "72",
                          "title": "Obi-Wan Stands Ready"
                      },
                      {
                          "num": "73",
                          "title": "Darth Vader Aboard His Star Destroyer"
                      },
                      {
                          "num": "74",
                          "title": "Reva Becomes Grand Inquisitor"
                      },
                      {
                          "num": "75",
                          "title": "Awaiting the Empire's Arrival"
                      },
                      {
                          "num": "76",
                          "title": "Master & Apprentice"
                      },
                      {
                          "num": "77",
                          "title": "The Imperial Siege"
                      },
                      {
                          "num": "78",
                          "title": "Padawan Reva's Terrifying Encounter"
                      },
                      {
                          "num": "79",
                          "title": "Obi-Wan Apprehended"
                      },
                      {
                          "num": "80",
                          "title": "Leia Removes L0LA's Restraining Bolt"
                      },
                      {
                          "num": "81",
                          "title": "Escape from Vader's Clutches!"
                      },
                      {
                          "num": "82",
                          "title": "Anakin Skywalker"
                      },
                      {
                          "num": "83",
                          "title": "Showdown with the Dark Lord!"
                      },
                      {
                          "num": "84",
                          "title": "The Return of the Grand Inquisitor"
                      },
                      {
                          "num": "85",
                          "title": "Leia & Obi-Wan Part Ways"
                      },
                      {
                          "num": "86",
                          "title": "Beru Lars in the Homestead"
                      },
                      {
                          "num": "87",
                          "title": "Owen & Beru Lars Prepare for Attack"
                      },
                      {
                          "num": "88",
                          "title": "The Devastator Tails Obi-Wan's Ship"
                      },
                      {
                          "num": "89",
                          "title": "Obi-Wan's Battle Stance"
                      },
                      {
                          "num": "90",
                          "title": "The Dark Lord, Ready to Duel!"
                      },
                      {
                          "num": "91",
                          "title": "Obi-Wan at Full Strength"
                      },
                      {
                          "num": "92",
                          "title": "The Scarred Visage of Darth Vader"
                      },
                      {
                          "num": "93",
                          "title": "The Emperor"
                      },
                      {
                          "num": "94",
                          "title": "Leia is Reunited with L0LA"
                      },
                      {
                          "num": "95",
                          "title": "Leia Embraces the Jedi Master"
                      },
                      {
                          "num": "96",
                          "title": "Visiting the Lars Homestead"
                      },
                      {
                          "num": "97",
                          "title": "Meeting Luke Skywalker"
                      },
                      {
                          "num": "98",
                          "title": "Obi-Wan Kenobi, Jedi Master"
                      },
                      {
                          "num": "99",
                          "title": "The Return of an Old Friend"
                      },
                      {
                          "num": "100",
                          "title": "Qui-Gon Jinn"
                      }
                  ]
              }
          ],
          "insert": [
              {
                  "count": 10,
                  "name": "HEROES",
                  "meta": "Obi-Wan's allies · 1:1 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "H-1",
                          "title": "Owen Lars"
                      },
                      {
                          "num": "H-2",
                          "title": "Princess Leia Organa"
                      },
                      {
                          "num": "H-3",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "H-4",
                          "title": "Bail Organa"
                      },
                      {
                          "num": "H-5",
                          "title": "Haja Estree"
                      },
                      {
                          "num": "H-6",
                          "title": "Tala Durith"
                      },
                      {
                          "num": "H-7",
                          "title": "Kawlan Roken"
                      },
                      {
                          "num": "H-8",
                          "title": "Sully Stark"
                      },
                      {
                          "num": "H-9",
                          "title": "Beru Lars"
                      },
                      {
                          "num": "H-10",
                          "title": "Luke Skywalker"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "DARTH VADER AND THE INQUISITORIUS",
                  "meta": "The villains of the series · 1:7 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "DVI-1",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "DVI-2",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "DVI-3",
                          "title": "Reva"
                      },
                      {
                          "num": "DVI-4",
                          "title": "Fifth Brother"
                      },
                      {
                          "num": "DVI-5",
                          "title": "Fourth Sister"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "CONCEPT ART",
                  "meta": "End-credit concept art by chapter · 1:4 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "CA-1",
                          "title": "Chapter 1"
                      },
                      {
                          "num": "CA-2",
                          "title": "Chapter 1"
                      },
                      {
                          "num": "CA-3",
                          "title": "Chapter 1"
                      },
                      {
                          "num": "CA-4",
                          "title": "Chapter 1"
                      },
                      {
                          "num": "CA-5",
                          "title": "Chapter 2"
                      },
                      {
                          "num": "CA-6",
                          "title": "Chapter 2"
                      },
                      {
                          "num": "CA-7",
                          "title": "Chapter 2"
                      },
                      {
                          "num": "CA-8",
                          "title": "Chapter 3"
                      },
                      {
                          "num": "CA-9",
                          "title": "Chapter 4"
                      },
                      {
                          "num": "CA-10",
                          "title": "Chapter 4"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "DROIDS",
                  "meta": "L0LA, NED-B and company · 1:7 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "D-1",
                          "title": "L0LA"
                      },
                      {
                          "num": "D-2",
                          "title": "1-JAC"
                      },
                      {
                          "num": "D-3",
                          "title": "NED-B"
                      },
                      {
                          "num": "D-4",
                          "title": "Probe Droid"
                      },
                      {
                          "num": "D-5",
                          "title": "ID-9 Seeker Droid"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "CREATURES AND ALIENS",
                  "meta": "Daiyu to Tatooine locals · 1:4 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "CAA-1",
                          "title": "Supply Store Clerk"
                      },
                      {
                          "num": "CAA-2",
                          "title": "Freck"
                      },
                      {
                          "num": "CAA-3",
                          "title": "Teeka"
                      },
                      {
                          "num": "CAA-4",
                          "title": "Eopie"
                      },
                      {
                          "num": "CAA-5",
                          "title": "The Butcher of Brix"
                      },
                      {
                          "num": "CAA-6",
                          "title": "Borrim Shub"
                      },
                      {
                          "num": "CAA-7",
                          "title": "Tredgar Volk"
                      },
                      {
                          "num": "CAA-8",
                          "title": "Sweebotta"
                      },
                      {
                          "num": "CAA-9",
                          "title": "Grelli Cryko"
                      },
                      {
                          "num": "CAA-10",
                          "title": "Agira"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "DVI BLACK METAL VARIATION",
                  "meta": "Serial /5 metal · hobby & Collector's only",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "DVMI-1",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "DVMI-2",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "DVMI-3",
                          "title": "Reva"
                      },
                      {
                          "num": "DVMI-4",
                          "title": "Fifth Brother"
                      },
                      {
                          "num": "DVMI-5",
                          "title": "Fourth Sister"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "HEROES BLACK METAL VARIATION",
                  "meta": "Serial /5 metal · hobby & Collector's only",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "HM-1",
                          "title": "Owen Lars"
                      },
                      {
                          "num": "HM-2",
                          "title": "Princess Leia Organa"
                      },
                      {
                          "num": "HM-3",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "HM-4",
                          "title": "Bail Organa"
                      },
                      {
                          "num": "HM-5",
                          "title": "Haja Estree"
                      },
                      {
                          "num": "HM-6",
                          "title": "Tala Durith"
                      },
                      {
                          "num": "HM-7",
                          "title": "Kawlan Roken"
                      },
                      {
                          "num": "HM-8",
                          "title": "Sully Stark"
                      },
                      {
                          "num": "HM-9",
                          "title": "Beru Lars"
                      },
                      {
                          "num": "HM-10",
                          "title": "Luke Skywalker"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "OVERSIZED ORIGINAL ART REPRINTS",
                  "meta": "Collector's Hobby box exclusive · 1:14 packs",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "OAR-1",
                          "title": "Kenobi on Tatooine"
                      },
                      {
                          "num": "OAR-2",
                          "title": "Reva"
                      },
                      {
                          "num": "OAR-3",
                          "title": "Fifth Brother"
                      },
                      {
                          "num": "OAR-4",
                          "title": "The Wrath of the Inquisitors"
                      },
                      {
                          "num": "OAR-5",
                          "title": "Fourth Sister"
                      },
                      {
                          "num": "OAR-6",
                          "title": "Darth Vader and his Inquisitors"
                      },
                      {
                          "num": "OAR-7",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "OAR-8",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "OAR-9",
                          "title": "Duel of former Master and Apprentice"
                      },
                      {
                          "num": "OAR-10",
                          "title": "Good vs Evil"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "ORIGINAL ART INSERT SIZED REPRINT",
                  "meta": "Insert-size reprints of the oversized art · 1:4 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "OAI-1",
                          "title": "Kenobi on Tatooine"
                      },
                      {
                          "num": "OAI-2",
                          "title": "Reva"
                      },
                      {
                          "num": "OAI-3",
                          "title": "Fifth Brother"
                      },
                      {
                          "num": "OAI-4",
                          "title": "The Wrath of the Inquisitors"
                      },
                      {
                          "num": "OAI-5",
                          "title": "Fourth Sister"
                      },
                      {
                          "num": "OAI-6",
                          "title": "Darth Vader and his Inquisitors"
                      },
                      {
                          "num": "OAI-7",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "OAI-8",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "OAI-9",
                          "title": "Duel of former Master and Apprentice"
                      },
                      {
                          "num": "OAI-10",
                          "title": "Good vs Evil"
                      }
                  ]
              },
              {
                  "count": 2,
                  "name": "SOURCED FABRIC RELICS",
                  "meta": "Screen-sourced fabric · serial /99 · SFR-4 & SFR-5 only",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "SFR-4",
                          "title": "Tala Durith"
                      },
                      {
                          "num": "SFR-5",
                          "title": "Reva"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "COMMEMORATIVE CHARACTER COIN MEDALLIONS",
                  "meta": "Character coin medallions · serial /50",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "CM-1",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "CM-2",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "CM-3",
                          "title": "Princess Leia Organa"
                      },
                      {
                          "num": "CM-4",
                          "title": "Reva"
                      },
                      {
                          "num": "CM-5",
                          "title": "The Grand Inquisitor"
                      }
                  ]
              },
              {
                  "count": 17,
                  "name": "MANUFACTURED PATCH CARDS",
                  "meta": "Blaster exclusive · 1:11 packs",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "MP-1",
                          "title": "NED-B"
                      },
                      {
                          "num": "MP-2",
                          "title": "Darth Vader & His Inquisitors"
                      },
                      {
                          "num": "MP-3",
                          "title": "Inquisitors & Purge Troopers"
                      },
                      {
                          "num": "MP-4",
                          "title": "Reva & Purge Troopers"
                      },
                      {
                          "num": "MP-5",
                          "title": "Old Allies Clash!"
                      },
                      {
                          "num": "MP-6",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "MP-7",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "MP-8",
                          "title": "Obi-Wan Kenobi Stands Guard"
                      },
                      {
                          "num": "MP-9",
                          "title": "The Dark Lord"
                      },
                      {
                          "num": "MP-10",
                          "title": "Kenobi Up Close"
                      },
                      {
                          "num": "MP-11",
                          "title": "Obi-Wan Vs Darth Vader"
                      },
                      {
                          "num": "MP-12",
                          "title": "Stormtrooper"
                      },
                      {
                          "num": "MP-13",
                          "title": "Grand Inquisitor"
                      },
                      {
                          "num": "MP-14",
                          "title": "Reva & Purge Troopers 2"
                      },
                      {
                          "num": "MP-15",
                          "title": "The Grand Inquisitor 2"
                      },
                      {
                          "num": "MP-16",
                          "title": "Reva"
                      },
                      {
                          "num": "MP-17",
                          "title": "The Inquisitorius"
                      }
                  ]
              }
          ],
          "auto": [
              {
                  "count": 25,
                  "name": "AUTOGRAPHS",
                  "meta": "25 signers · 1 autograph or sketch per tin",
                  "parallels": 8,
                  "cards": [
                      {
                          "num": "A-BP",
                          "title": "Bonnie Piesse",
                          "meta": "Beru Lars"
                      },
                      {
                          "num": "A-BS",
                          "title": "Benny Safdie",
                          "meta": "Nari"
                      },
                      {
                          "num": "A-CB",
                          "title": "Crispian Belfrage",
                          "meta": "Devastator Captain"
                      },
                      {
                          "num": "A-DC",
                          "title": "Dan Considine",
                          "meta": "Deck Officer Densin Clord"
                      },
                      {
                          "num": "A-DCE",
                          "title": "Dustin Ceithamer",
                          "meta": "Ned-B"
                      },
                      {
                          "num": "A-EW",
                          "title": "Ewan McGregor",
                          "meta": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "A-GF",
                          "title": "Gabe Fonseca",
                          "meta": "Duke Kayo Organa"
                      },
                      {
                          "num": "A-GFE",
                          "title": "Grant Feely",
                          "meta": "Luke Skywalker"
                      },
                      {
                          "num": "A-HC",
                          "title": "Hayden Christensen",
                          "meta": "Darth Vader"
                      },
                      {
                          "num": "A-HM",
                          "title": "Heath McGough",
                          "meta": "Foreman Groff Ditcher"
                      },
                      {
                          "num": "A-II",
                          "title": "Ian Inigo",
                          "meta": "Cousin Niano Organa"
                      },
                      {
                          "num": "A-IM",
                          "title": "Ian McDiarmid",
                          "meta": "Emperor Palpatine"
                      },
                      {
                          "num": "A-IV",
                          "title": "Indira Varma",
                          "meta": "Tala Durith"
                      },
                      {
                          "num": "A-JR",
                          "title": "John Rosengrant",
                          "meta": "Freck"
                      },
                      {
                          "num": "A-JS",
                          "title": "Jecobi Swain",
                          "meta": "Jayco"
                      },
                      {
                          "num": "A-MI",
                          "title": "Moses Ingram",
                          "meta": "Reva"
                      },
                      {
                          "num": "A-MM",
                          "title": "Molly Miller",
                          "meta": "Handmaiden Agira"
                      },
                      {
                          "num": "A-RK",
                          "title": "Rya Kihlstedt",
                          "meta": "Fourth Sister"
                      },
                      {
                          "num": "A-RM",
                          "title": "Ryder McLaughlin",
                          "meta": "Wade Resselian"
                      },
                      {
                          "num": "A-RP",
                          "title": "Rupert Friend",
                          "meta": "The Grand Inquisitor"
                      },
                      {
                          "num": "A-RS",
                          "title": "Roberta Sparta",
                          "meta": "Duchess Celly Organa"
                      },
                      {
                          "num": "A-SK",
                          "title": "Simone Kessell",
                          "meta": "Breha Organa"
                      },
                      {
                          "num": "A-TM",
                          "title": "Temuera Morrison",
                          "meta": "Veteran Clone Trooper"
                      },
                      {
                          "num": "A-VLB",
                          "title": "Vivien Lyra Blair",
                          "meta": "Princess Leia Organa"
                      },
                      {
                          "num": "A-ZB",
                          "title": "Zach Braff",
                          "meta": "Freck"
                      }
                  ]
              },
              {
                  "count": 14,
                  "name": "DUAL AUTOGRAPHS",
                  "meta": "Serial /25 · Gold /10 · Black 1/1",
                  "parallels": 3,
                  "cards": [
                      {
                          "num": "DA-BG",
                          "title": "Bonnie Piesse / Grant Feely",
                          "meta": "Beru Lars / Luke Skywalker"
                      },
                      {
                          "num": "DA-DI",
                          "title": "Dustin Ceithamer / Indira Varma",
                          "meta": "Ned-B / Tala Durith"
                      },
                      {
                          "num": "DA-DV",
                          "title": "Dustin Ceithamer / Vivien Lyra Blair",
                          "meta": "Ned-B / Princess Leia Organa"
                      },
                      {
                          "num": "DA-EH",
                          "title": "Hayden Christensen / Ewan McGregor",
                          "meta": "Darth Vader / Obi-Wan Kenobi"
                      },
                      {
                          "num": "DA-EI",
                          "title": "Ewan McGregor / Indira Varma",
                          "meta": "Obi-Wan Kenobi / Tala Durith"
                      },
                      {
                          "num": "DA-ET",
                          "title": "Ewan McGregor / Temuera Morrison",
                          "meta": "Obi-Wan Kenobi / Veteran Clone Trooper"
                      },
                      {
                          "num": "DA-EZ",
                          "title": "Zach Braff / Ewan McGregor",
                          "meta": "Freck / Obi-Wan Kenobi"
                      },
                      {
                          "num": "DA-GR",
                          "title": "Gabe Fonseca / Roberta Sparta",
                          "meta": "Duke Kayo Organa / Duchess Celly Organa"
                      },
                      {
                          "num": "DA-HR",
                          "title": "Hayden Christensen / Rupert Friend",
                          "meta": "Darth Vader / The Grand Inquisitor"
                      },
                      {
                          "num": "DA-KF",
                          "title": "Rya Kihlstedt / Rupert Friend",
                          "meta": "Fourth Sister / The Grand Inquisitor"
                      },
                      {
                          "num": "DA-MR",
                          "title": "Rya Kihlstedt / Moses Ingram",
                          "meta": "Fourth Sister / Reva"
                      },
                      {
                          "num": "DA-RM",
                          "title": "Rupert Friend / Moses Ingram",
                          "meta": "The Grand Inquisitor / Reva"
                      },
                      {
                          "num": "DA-VG",
                          "title": "Grant Feely / Vivien Lyra Blair",
                          "meta": "Luke Skywalker / Princess Leia Organa"
                      },
                      {
                          "num": "DA-VS",
                          "title": "Simone Kessell / Vivien Lyra Blair",
                          "meta": "Breha Organa / Princess Leia Organa"
                      }
                  ]
              },
              {
                  "count": 6,
                  "name": "TRIPLE AUTOGRAPHS",
                  "meta": "Serial /5 · Black 1/1",
                  "parallels": 2,
                  "cards": [
                      {
                          "num": "TA-EHI",
                          "title": "Hayden Christensen / Ewan McGregor / Ian McDiarmid",
                          "meta": "Darth Vader / Obi-Wan Kenobi / Emperor Palpatine"
                      },
                      {
                          "num": "TA-GRI",
                          "title": "Roberta Sparta / Gabe Fonseca / Ian Inigo",
                          "meta": "Duchess Celly Organa / Duke Kayo Organa / Cousin Niano Organa"
                      },
                      {
                          "num": "TA-HRC",
                          "title": "Hayden Christensen / Rupert Friend / Crispian Belfrage",
                          "meta": "Darth Vader / The Grand Inquisitor / Star Destroyer Captain"
                      },
                      {
                          "num": "TA-HRM",
                          "title": "Rupert Friend / Hayden Christensen / Moses Ingram",
                          "meta": "The Grand Inquisitor / Darth Vader / Reva"
                      },
                      {
                          "num": "TA-IVD",
                          "title": "Vivien Lyra Blair / Indira Varma / Dustin Ceithamer",
                          "meta": "Princess Leia Organa / Tala Durith / Ned-B"
                      },
                      {
                          "num": "TA-MIV",
                          "title": "Indira Varma / Vivien Lyra Blair / Moses Ingram",
                          "meta": "Tala Durith / Princess Leia Organa / Reva"
                      }
                  ]
              }
          ],
          "sketch": [
              {
                  "count": 2,
                  "name": "SKETCH CARDS",
                  "meta": "Standard + shaped sketches · artist roster not published",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "SK-1",
                          "title": "Sketch Card",
                          "meta": "Various Artists"
                      },
                      {
                          "num": "SK-2",
                          "title": "Shaped Sketch Card",
                          "meta": "Various Artists"
                      }
                  ]
              }
          ]
      }
  },
  '2023-star-wars': {
      "setId": "2023-star-wars",
      "year": "2023",
      "brand": "TOPPS",
      "title": "STAR WARS",
      "releaseDate": "8 / 4 / 2023",
      "lede": "The first-ever paper Star Wars flagship — a 100-card base that sweeps the whole galaxy, from Ahsoka, Andor, and The Book of Boba Fett to the original trilogy icons, under a twelve-tier rainbow running from Rainbow Foil through the numbered foilboards to twin one-of-ones in Hyperspace and Printing Plates. Nine insert lines ride along, from the 1:2 quartet of Comic Covers, Epic Clashes, Into the Galaxy, and the Lightsaber Stylings die-cuts to the ultra-rare Kyber Crystal Die-Cuts, plus oversized Widevision box toppers and an 18-signer autograph program that includes Felicity Jones, Ian McDiarmid, and Karen Fukuhara's Visions Jedi.",
      "stats": [
          {
              "num": "100",
              "label": "Base Cards",
              "sub": "First paper flagship",
              "color": "gold"
          },
          {
              "num": "9",
              "label": "Insert Sets",
              "sub": "Plus the SDCC promo",
              "color": "cyan"
          },
          {
              "num": "18",
              "label": "Auto Cards",
              "sub": "Confirmed signers",
              "color": "green"
          },
          {
              "num": "12",
              "label": "Base Parallels",
              "sub": "Rainbow Foil → twin 1/1s",
              "color": "purple"
          },
          {
              "num": "12",
              "label": "Sub-sets Total",
              "sub": "Tracked on CK",
              "color": "red"
          }
      ],
      "hobbyBox": [
          {
              "v": "24",
              "l": "Packs per Super Box"
          },
          {
              "v": "7",
              "l": "Cards per pack"
          },
          {
              "v": "1",
              "l": "Widevision topper per Super Box"
          },
          {
              "v": "2",
              "l": "Formats · Hobby Super Box + Value Blaster"
          }
      ],
      "pullRates": [
          {
              "name": "Comic Covers · Epic Clashes · Into the Galaxy · Lightsaber Stylings",
              "odds": "1 : 2",
              "tier": "normal"
          },
          {
              "name": "Widevision (Super Box topper)",
              "odds": "1 : 24",
              "tier": "normal"
          },
          {
              "name": "Character Image Short Prints",
              "odds": "1 : 66",
              "tier": "normal"
          },
          {
              "name": "AKA",
              "odds": "1 : 132",
              "tier": "normal"
          },
          {
              "name": "Holograms",
              "odds": "1 : 132",
              "tier": "normal"
          },
          {
              "name": "Autographs",
              "odds": "1 : 438",
              "tier": "rare"
          },
          {
              "name": "Kyber Crystal Die-Cuts",
              "odds": "1 : 2,636",
              "tier": "rare"
          },
          {
              "name": "Hyperspace 1/1 (base)",
              "odds": "1 : 13,245",
              "tier": "mythic"
          },
          {
              "name": "Autograph Hyperspace 1/1",
              "odds": "1 : 65,393",
              "tier": "mythic"
          }
      ],
      "parallelRainbow": [
          {
              "name": "BASE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
              "darkText": true
          },
          {
              "name": "RAINBOW FOIL",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 35%, #a1c4fd 70%, #c2e9fb 100%)",
              "darkText": true
          },
          {
              "name": "GOLD FOIL",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #f0c040 0%, #c89020 100%)",
              "darkText": true
          },
          {
              "name": "GREEN FOIL",
              "pr": "/499",
              "gradient": "linear-gradient(135deg, #8fdf8f 0%, #4a9e4a 100%)",
              "darkText": true
          },
          {
              "name": "ORANGE FOIL",
              "pr": "/299",
              "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
          },
          {
              "name": "RED FOIL",
              "pr": "/199",
              "gradient": "linear-gradient(135deg, #ff9d8a 0%, #d05540 100%)",
              "darkText": true
          },
          {
              "name": "PURPLE",
              "pr": "/99",
              "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
          },
          {
              "name": "BLACK",
              "pr": "/75",
              "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
          },
          {
              "name": "BLUE",
              "pr": "/50",
              "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
          },
          {
              "name": "GREEN",
              "pr": "/25",
              "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
              "darkText": true
          },
          {
              "name": "RED",
              "pr": "/10",
              "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
          },
          {
              "name": "HYPERSPACE",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #0b1a3a 0%, #274b8f 60%, #9fd8ff 100%)"
          },
          {
              "name": "PLATES",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #c0c0c8 0%, #808088 100%)",
              "darkText": true
          }
      ],
      "artists": [],
      "subsets": {
          "base": [
              {
                  "count": 100,
                  "name": "BASE SET",
                  "meta": "The first paper flagship — the whole galaxy in 100 cards",
                  "parallels": 12,
                  "cards": [
                      {
                          "num": "1",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "2",
                          "title": "Magistrate Morgan Elsbeth"
                      },
                      {
                          "num": "3",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "4",
                          "title": "Kuiil"
                      },
                      {
                          "num": "5",
                          "title": "8D8"
                      },
                      {
                          "num": "6",
                          "title": "EV-9D9"
                      },
                      {
                          "num": "7",
                          "title": "D-0"
                      },
                      {
                          "num": "8",
                          "title": "B2EMO"
                      },
                      {
                          "num": "9",
                          "title": "Moff Gideon"
                      },
                      {
                          "num": "10",
                          "title": "Dr. Pershing"
                      },
                      {
                          "num": "11",
                          "title": "Finn"
                      },
                      {
                          "num": "12",
                          "title": "Captain Carson Teva"
                      },
                      {
                          "num": "13",
                          "title": "Lieutenant Reed"
                      },
                      {
                          "num": "14",
                          "title": "Jib Dodger"
                      },
                      {
                          "num": "15",
                          "title": "Kleya Marki"
                      },
                      {
                          "num": "16",
                          "title": "Luthen Rael"
                      },
                      {
                          "num": "17",
                          "title": "Saw Gerrera"
                      },
                      {
                          "num": "18",
                          "title": "Bo-Katan Kryze"
                      },
                      {
                          "num": "19",
                          "title": "Koska Reeves"
                      },
                      {
                          "num": "20",
                          "title": "Axe Woves"
                      },
                      {
                          "num": "21",
                          "title": "Hondo Ohnaka"
                      },
                      {
                          "num": "22",
                          "title": "Hera Syndulla"
                      },
                      {
                          "num": "23",
                          "title": "Jarek Yeager"
                      },
                      {
                          "num": "24",
                          "title": "Tam Ryvora"
                      },
                      {
                          "num": "25",
                          "title": "Torra Doza"
                      },
                      {
                          "num": "26",
                          "title": "Synara San"
                      },
                      {
                          "num": "27",
                          "title": "Neeku Vozo"
                      },
                      {
                          "num": "28",
                          "title": "Ezra Bridger"
                      },
                      {
                          "num": "29",
                          "title": "Zeb Orrelios"
                      },
                      {
                          "num": "30",
                          "title": "Owen Lars"
                      },
                      {
                          "num": "31",
                          "title": "Beru Lars"
                      },
                      {
                          "num": "32",
                          "title": "The Armorer"
                      },
                      {
                          "num": "33",
                          "title": "Paz Vizsla"
                      },
                      {
                          "num": "34",
                          "title": "Bix Caleen"
                      },
                      {
                          "num": "35",
                          "title": "Brasso"
                      },
                      {
                          "num": "36",
                          "title": "Maarva Andor"
                      },
                      {
                          "num": "37",
                          "title": "Clem Andor"
                      },
                      {
                          "num": "38",
                          "title": "Toro Calican"
                      },
                      {
                          "num": "39",
                          "title": "Fennec Shand"
                      },
                      {
                          "num": "40",
                          "title": "Dokk Strassi"
                      },
                      {
                          "num": "41",
                          "title": "Tala Durith"
                      },
                      {
                          "num": "42",
                          "title": "Reva"
                      },
                      {
                          "num": "43",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "44",
                          "title": "Cal Kestis"
                      },
                      {
                          "num": "45",
                          "title": "Second Sister"
                      },
                      {
                          "num": "46",
                          "title": "Cere Junda"
                      },
                      {
                          "num": "47",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "48",
                          "title": "Minas Velti"
                      },
                      {
                          "num": "49",
                          "title": "Corran"
                      },
                      {
                          "num": "50",
                          "title": "Sully"
                      },
                      {
                          "num": "51",
                          "title": "Twi'lek Server"
                      },
                      {
                          "num": "52",
                          "title": "Garsa Fwip"
                      },
                      {
                          "num": "53",
                          "title": "Krrsantan"
                      },
                      {
                          "num": "54",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "55",
                          "title": "Tusken Chief"
                      },
                      {
                          "num": "56",
                          "title": "Tusken Warrior"
                      },
                      {
                          "num": "57",
                          "title": "Arvel Skeen"
                      },
                      {
                          "num": "58",
                          "title": "Taramyn Barcona"
                      },
                      {
                          "num": "59",
                          "title": "Karis Nemik"
                      },
                      {
                          "num": "60",
                          "title": "Cinta Kaz"
                      },
                      {
                          "num": "61",
                          "title": "Vel Sartha"
                      },
                      {
                          "num": "62",
                          "title": "Lieutenant Gorn"
                      },
                      {
                          "num": "63",
                          "title": "Qui-Gon Jinn"
                      },
                      {
                          "num": "64",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "65",
                          "title": "Tetha Grig"
                      },
                      {
                          "num": "66",
                          "title": "Vect Nokru"
                      },
                      {
                          "num": "67",
                          "title": "Princess Leia"
                      },
                      {
                          "num": "68",
                          "title": "Mon Mothma"
                      },
                      {
                          "num": "69",
                          "title": "Leida"
                      },
                      {
                          "num": "70",
                          "title": "Perrin Fertha"
                      },
                      {
                          "num": "71",
                          "title": "Babu Frik"
                      },
                      {
                          "num": "72",
                          "title": "Salacious B. Crumb"
                      },
                      {
                          "num": "73",
                          "title": "Sebulba"
                      },
                      {
                          "num": "74",
                          "title": "Zorii Bliss"
                      },
                      {
                          "num": "75",
                          "title": "Cassian Andor"
                      },
                      {
                          "num": "76",
                          "title": "Vetch"
                      },
                      {
                          "num": "77",
                          "title": "Major Partagaz"
                      },
                      {
                          "num": "78",
                          "title": "Lieutenant Supervisor Blevin"
                      },
                      {
                          "num": "79",
                          "title": "Dedra Meero"
                      },
                      {
                          "num": "80",
                          "title": "Syril Karn"
                      },
                      {
                          "num": "81",
                          "title": "Cad Bane"
                      },
                      {
                          "num": "82",
                          "title": "Kino Loy"
                      },
                      {
                          "num": "83",
                          "title": "Nien Nunb"
                      },
                      {
                          "num": "84",
                          "title": "Quinlan Vos"
                      },
                      {
                          "num": "85",
                          "title": "Jyn Erso"
                      },
                      {
                          "num": "86",
                          "title": "Han Solo"
                      },
                      {
                          "num": "87",
                          "title": "Princess Leia Organa"
                      },
                      {
                          "num": "88",
                          "title": "Grogu"
                      },
                      {
                          "num": "89",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "90",
                          "title": "Yoda"
                      },
                      {
                          "num": "91",
                          "title": "Rey"
                      },
                      {
                          "num": "92",
                          "title": "Padmé Amidala"
                      },
                      {
                          "num": "93",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "94",
                          "title": "C-3PO"
                      },
                      {
                          "num": "95",
                          "title": "R2-D2"
                      },
                      {
                          "num": "96",
                          "title": "BB-8"
                      },
                      {
                          "num": "97",
                          "title": "Darth Maul"
                      },
                      {
                          "num": "98",
                          "title": "Mace Windu"
                      },
                      {
                          "num": "99",
                          "title": "Lando Calrissian"
                      },
                      {
                          "num": "100",
                          "title": "Emperor Palpatine"
                      }
                  ]
              }
          ],
          "insert": [
              {
                  "count": 1,
                  "name": "SDCC PROMO",
                  "meta": "Card #0 Jabba the Hutt · exclusive to 2023 SDCC packs",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "0",
                          "title": "Jabba the Hutt"
                      }
                  ]
              },
              {
                  "count": 30,
                  "name": "COMIC COVERS",
                  "meta": "Marvel comic cover art · 1:2 packs",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "CC-1",
                          "title": "Captain Phasma #4"
                      },
                      {
                          "num": "CC-2",
                          "title": "Captain Phasma #1"
                      },
                      {
                          "num": "CC-3",
                          "title": "Chewbacca #2"
                      },
                      {
                          "num": "CC-4",
                          "title": "Darth Vader #13"
                      },
                      {
                          "num": "CC-5",
                          "title": "Darth Vader #17"
                      },
                      {
                          "num": "CC-6",
                          "title": "Darth Vader #22"
                      },
                      {
                          "num": "CC-7",
                          "title": "Darth Vader #2"
                      },
                      {
                          "num": "CC-8",
                          "title": "Darth Vader #5"
                      },
                      {
                          "num": "CC-9",
                          "title": "Darth Vader #10"
                      },
                      {
                          "num": "CC-10",
                          "title": "Darth Maul #2"
                      },
                      {
                          "num": "CC-11",
                          "title": "Darth Vader #6"
                      },
                      {
                          "num": "CC-12",
                          "title": "Han Solo #4"
                      },
                      {
                          "num": "CC-13",
                          "title": "Kanan #6"
                      },
                      {
                          "num": "CC-14",
                          "title": "Lando #3"
                      },
                      {
                          "num": "CC-15",
                          "title": "Lando #2"
                      },
                      {
                          "num": "CC-16",
                          "title": "Obi-Wan & Anakin #1"
                      },
                      {
                          "num": "CC-17",
                          "title": "Poe Dameron #22"
                      },
                      {
                          "num": "CC-18",
                          "title": "Poe Dameron #24"
                      },
                      {
                          "num": "CC-19",
                          "title": "Poe Dameron #2"
                      },
                      {
                          "num": "CC-20",
                          "title": "Poe Dameron #7"
                      },
                      {
                          "num": "CC-21",
                          "title": "Poe Dameron #17"
                      },
                      {
                          "num": "CC-22",
                          "title": "Star Wars #5"
                      },
                      {
                          "num": "CC-23",
                          "title": "Star Wars #8"
                      },
                      {
                          "num": "CC-24",
                          "title": "Star Wars #10"
                      },
                      {
                          "num": "CC-25",
                          "title": "Star Wars #11"
                      },
                      {
                          "num": "CC-26",
                          "title": "Star Wars #12"
                      },
                      {
                          "num": "CC-27",
                          "title": "Star Wars #15"
                      },
                      {
                          "num": "CC-28",
                          "title": "Star Wars #59"
                      },
                      {
                          "num": "CC-29",
                          "title": "Vader Down #1"
                      },
                      {
                          "num": "CC-30",
                          "title": "Star Wars #14"
                      }
                  ]
              },
              {
                  "count": 20,
                  "name": "EPIC CLASHES",
                  "meta": "Legendary duels · 1:2 packs",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "EC-1",
                          "title": "Obi-Wan Kenobi / Darth Maul"
                      },
                      {
                          "num": "EC-2",
                          "title": "Qui-Gon Jinn / Darth Maul"
                      },
                      {
                          "num": "EC-3",
                          "title": "Mace Windu / Jango Fett"
                      },
                      {
                          "num": "EC-4",
                          "title": "Yoda / Count Dooku"
                      },
                      {
                          "num": "EC-5",
                          "title": "Anakin Skywalker / Count Dooku"
                      },
                      {
                          "num": "EC-6",
                          "title": "Obi-Wan Kenobi / Count Dooku"
                      },
                      {
                          "num": "EC-7",
                          "title": "Obi-Wan Kenobi / General Grievous"
                      },
                      {
                          "num": "EC-8",
                          "title": "Mace Windu / Palpatine"
                      },
                      {
                          "num": "EC-9",
                          "title": "Obi-Wan Kenobi / Anakin Skywalker"
                      },
                      {
                          "num": "EC-10",
                          "title": "Yoda / Darth Sidious"
                      },
                      {
                          "num": "EC-11",
                          "title": "Obi-Wan Kenobi / Anakin Skywalker"
                      },
                      {
                          "num": "EC-12",
                          "title": "Obi-Wan Kenobi / Darth Vader"
                      },
                      {
                          "num": "EC-13",
                          "title": "Luke Skywalker / Darth Vader"
                      },
                      {
                          "num": "EC-14",
                          "title": "Luke Skywalker / Darth Vader"
                      },
                      {
                          "num": "EC-15",
                          "title": "Ahsoka Tano / Magistrate Morgan Elsbeth"
                      },
                      {
                          "num": "EC-16",
                          "title": "The Mandalorian / Moff Gideon"
                      },
                      {
                          "num": "EC-17",
                          "title": "Rey / Kylo Ren"
                      },
                      {
                          "num": "EC-18",
                          "title": "Rey / The Praetorian Guards"
                      },
                      {
                          "num": "EC-19",
                          "title": "Kylo Ren / The Praetorian Guards"
                      },
                      {
                          "num": "EC-20",
                          "title": "Luke Skywalker / Kylo Ren"
                      }
                  ]
              },
              {
                  "count": 30,
                  "name": "INTO THE GALAXY",
                  "meta": "30 planets and locations · 1:2 packs",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "IG-1",
                          "title": "Tatooine"
                      },
                      {
                          "num": "IG-2",
                          "title": "Coruscant"
                      },
                      {
                          "num": "IG-3",
                          "title": "Kashyyyk"
                      },
                      {
                          "num": "IG-4",
                          "title": "Bespin"
                      },
                      {
                          "num": "IG-5",
                          "title": "Naboo"
                      },
                      {
                          "num": "IG-6",
                          "title": "Hoth"
                      },
                      {
                          "num": "IG-7",
                          "title": "Mustafar"
                      },
                      {
                          "num": "IG-8",
                          "title": "Kamino"
                      },
                      {
                          "num": "IG-9",
                          "title": "Dagobah"
                      },
                      {
                          "num": "IG-10",
                          "title": "Mandalore"
                      },
                      {
                          "num": "IG-11",
                          "title": "Alderaan"
                      },
                      {
                          "num": "IG-12",
                          "title": "Yavin"
                      },
                      {
                          "num": "IG-13",
                          "title": "Geonosis"
                      },
                      {
                          "num": "IG-14",
                          "title": "Jakku"
                      },
                      {
                          "num": "IG-15",
                          "title": "Felucia"
                      },
                      {
                          "num": "IG-16",
                          "title": "Corellia"
                      },
                      {
                          "num": "IG-17",
                          "title": "Nal Hutta"
                      },
                      {
                          "num": "IG-18",
                          "title": "Mon Cala"
                      },
                      {
                          "num": "IG-19",
                          "title": "Starkiller Base"
                      },
                      {
                          "num": "IG-20",
                          "title": "Ryloth"
                      },
                      {
                          "num": "IG-21",
                          "title": "Serenno"
                      },
                      {
                          "num": "IG-22",
                          "title": "Lothal"
                      },
                      {
                          "num": "IG-23",
                          "title": "Crait"
                      },
                      {
                          "num": "IG-24",
                          "title": "Death Star"
                      },
                      {
                          "num": "IG-25",
                          "title": "Endor"
                      },
                      {
                          "num": "IG-26",
                          "title": "Scarif"
                      },
                      {
                          "num": "IG-27",
                          "title": "Jedha"
                      },
                      {
                          "num": "IG-28",
                          "title": "Takodana"
                      },
                      {
                          "num": "IG-29",
                          "title": "Ahch-To"
                      },
                      {
                          "num": "IG-30",
                          "title": "Nevarro"
                      }
                  ]
              },
              {
                  "count": 20,
                  "name": "LIGHTSABER STYLINGS DIE-CUTS",
                  "meta": "Die-cut saber showcases · 1:2 packs",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "LS-1",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "LS-2",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "LS-3",
                          "title": "Yoda"
                      },
                      {
                          "num": "LS-4",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "LS-5",
                          "title": "Rey"
                      },
                      {
                          "num": "LS-6",
                          "title": "Qui-Gon Jinn"
                      },
                      {
                          "num": "LS-7",
                          "title": "Mace Windu"
                      },
                      {
                          "num": "LS-8",
                          "title": "Ki-Adi-Mundi"
                      },
                      {
                          "num": "LS-9",
                          "title": "Kit Fisto"
                      },
                      {
                          "num": "LS-10",
                          "title": "Ezra Bridger"
                      },
                      {
                          "num": "LS-11",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "LS-12",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "LS-13",
                          "title": "Darth Maul"
                      },
                      {
                          "num": "LS-14",
                          "title": "Count Dooku"
                      },
                      {
                          "num": "LS-15",
                          "title": "Kanan Jarrus"
                      },
                      {
                          "num": "LS-16",
                          "title": "Darth Sidious"
                      },
                      {
                          "num": "LS-17",
                          "title": "Moff Gideon"
                      },
                      {
                          "num": "LS-18",
                          "title": "Asajj Ventress"
                      },
                      {
                          "num": "LS-19",
                          "title": "General Grievous"
                      },
                      {
                          "num": "LS-20",
                          "title": "The Grand Inquisitor"
                      }
                  ]
              },
              {
                  "count": 20,
                  "name": "CHARACTER IMAGE SHORT PRINTS",
                  "meta": "Short-printed variations · 1:66 packs",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "CI-1",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "CI-2",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "CI-3",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "CI-4",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "CI-5",
                          "title": "Han Solo"
                      },
                      {
                          "num": "CI-6",
                          "title": "General Leia Organa"
                      },
                      {
                          "num": "CI-7",
                          "title": "Grogu"
                      },
                      {
                          "num": "CI-8",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "CI-9",
                          "title": "Rey"
                      },
                      {
                          "num": "CI-10",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "CI-11",
                          "title": "C-3PO"
                      },
                      {
                          "num": "CI-12",
                          "title": "R2-D2"
                      },
                      {
                          "num": "CI-13",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "CI-14",
                          "title": "Maul"
                      },
                      {
                          "num": "CI-15",
                          "title": "Cassian Andor"
                      },
                      {
                          "num": "CI-16",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "CI-17",
                          "title": "Jabba the Hutt"
                      },
                      {
                          "num": "CI-18",
                          "title": "Yoda"
                      },
                      {
                          "num": "CI-19",
                          "title": "Poe Dameron"
                      },
                      {
                          "num": "CI-20",
                          "title": "Emperor Palpatine"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "AKA",
                  "meta": "Nicknames and aliases · 1:132 packs",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "AK-1",
                          "title": "Chewbacca - Chewie"
                      },
                      {
                          "num": "AK-2",
                          "title": "Anakin Skywalker - The Chosen One"
                      },
                      {
                          "num": "AK-3",
                          "title": "The Mandalorian - Mando"
                      },
                      {
                          "num": "AK-4",
                          "title": "Grogu - The Child"
                      },
                      {
                          "num": "AK-5",
                          "title": "Cassian Andor - Keef Girgo"
                      },
                      {
                          "num": "AK-6",
                          "title": "Black Krrsantan - Santo"
                      },
                      {
                          "num": "AK-7",
                          "title": "Luke Skywalker - Kid"
                      },
                      {
                          "num": "AK-8",
                          "title": "Ahsoka Tano - Fulcrum"
                      },
                      {
                          "num": "AK-9",
                          "title": "R2-D2 - Artoo"
                      },
                      {
                          "num": "AK-10",
                          "title": "C-3PO - Threepio"
                      }
                  ]
              },
              {
                  "count": 20,
                  "name": "HOLOGRAMS",
                  "meta": "Lenticular poster art · 1:132 packs",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "HC-1",
                          "title": "Rogue One"
                      },
                      {
                          "num": "HC-2",
                          "title": "A New Hope"
                      },
                      {
                          "num": "HC-3",
                          "title": "A New Hope"
                      },
                      {
                          "num": "HC-4",
                          "title": "Attack of the Clones"
                      },
                      {
                          "num": "HC-5",
                          "title": "A New Hope"
                      },
                      {
                          "num": "HC-6",
                          "title": "The Empire Strikes Back"
                      },
                      {
                          "num": "HC-7",
                          "title": "The Empire Strikes Back"
                      },
                      {
                          "num": "HC-8",
                          "title": "Rogue One"
                      },
                      {
                          "num": "HC-9",
                          "title": "The Force Awakens"
                      },
                      {
                          "num": "HC-10",
                          "title": "The Rise of Skywalker"
                      },
                      {
                          "num": "HC-11",
                          "title": "Solo"
                      },
                      {
                          "num": "HC-12",
                          "title": "Resistance"
                      },
                      {
                          "num": "HC-13",
                          "title": "Rebels"
                      },
                      {
                          "num": "HC-14",
                          "title": "The Bad Batch"
                      },
                      {
                          "num": "HC-15",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "HC-16",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "HC-17",
                          "title": "Andor"
                      },
                      {
                          "num": "HC-18",
                          "title": "The Clone Wars"
                      },
                      {
                          "num": "HC-19",
                          "title": "The Bad Batch"
                      },
                      {
                          "num": "HC-20",
                          "title": "The Clone Wars"
                      }
                  ]
              },
              {
                  "count": 40,
                  "name": "WIDEVISION",
                  "meta": "Oversized 2022 Disney+ scenes · one per Super Box",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "DW-1",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "DW-2",
                          "title": "Jabba's Palace"
                      },
                      {
                          "num": "DW-3",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "DW-4",
                          "title": "The Rancor"
                      },
                      {
                          "num": "DW-5",
                          "title": "Nikto Biker Gang"
                      },
                      {
                          "num": "DW-6",
                          "title": "Fennec Shand"
                      },
                      {
                          "num": "DW-7",
                          "title": "Sand Ape"
                      },
                      {
                          "num": "DW-8",
                          "title": "The Twins"
                      },
                      {
                          "num": "DW-9",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "DW-10",
                          "title": "Grogu"
                      },
                      {
                          "num": "DW-11",
                          "title": "Teeka"
                      },
                      {
                          "num": "DW-12",
                          "title": "Princess Leia"
                      },
                      {
                          "num": "DW-13",
                          "title": "The Inquisitors"
                      },
                      {
                          "num": "DW-14",
                          "title": "Reva"
                      },
                      {
                          "num": "DW-15",
                          "title": "Obi-Wan & Princess Leia"
                      },
                      {
                          "num": "DW-16",
                          "title": "Reva"
                      },
                      {
                          "num": "DW-17",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "DW-18",
                          "title": "No Escape"
                      },
                      {
                          "num": "DW-19",
                          "title": "Obi-Wan & Darth Vader"
                      },
                      {
                          "num": "DW-20",
                          "title": "Obi-Wan & Owen Lars"
                      },
                      {
                          "num": "DW-21",
                          "title": "Morlana One"
                      },
                      {
                          "num": "DW-22",
                          "title": "Luthen Rael"
                      },
                      {
                          "num": "DW-23",
                          "title": "Imperial Security Droid"
                      },
                      {
                          "num": "DW-24",
                          "title": "Cassian Andor"
                      },
                      {
                          "num": "DW-25",
                          "title": "Imperial Security Bureau Chambers"
                      },
                      {
                          "num": "DW-26",
                          "title": "Mon Mothma"
                      },
                      {
                          "num": "DW-27",
                          "title": "Kino Loy"
                      },
                      {
                          "num": "DW-28",
                          "title": "Arrestor Cruiser"
                      },
                      {
                          "num": "DW-29",
                          "title": "Debra Meero"
                      },
                      {
                          "num": "DW-30",
                          "title": "Marva Andor"
                      },
                      {
                          "num": "DW-31",
                          "title": "Count Dooku & Mace Windu"
                      },
                      {
                          "num": "DW-32",
                          "title": "Senator Dagonet's Forces Arrive"
                      },
                      {
                          "num": "DW-33",
                          "title": "Count Dooku & Qui-Gon Jinn"
                      },
                      {
                          "num": "DW-34",
                          "title": "The Raxshir"
                      },
                      {
                          "num": "DW-35",
                          "title": "Ahsoka's Training"
                      },
                      {
                          "num": "DW-36",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "DW-37",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "DW-38",
                          "title": "A Sinister Inquisitor"
                      },
                      {
                          "num": "DW-39",
                          "title": "Count Dooku"
                      },
                      {
                          "num": "DW-40",
                          "title": "Yaddle"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "KYBER CRYSTAL DIE-CUTS",
                  "meta": "KCD-6 to KCD-10 — numbering continues from 2023 Chrome",
                  "parallels": 0,
                  "cards": [
                      {
                          "num": "KCD-6",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "KCD-7",
                          "title": "Rey"
                      },
                      {
                          "num": "KCD-8",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "KCD-9",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "KCD-10",
                          "title": "Anakin Skywalker"
                      }
                  ]
              }
          ],
          "auto": [
              {
                  "count": 18,
                  "name": "AUTOGRAPHS",
                  "meta": "18 confirmed signers · no per-box guarantee",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "AU-AB",
                          "title": "Ahmed Best",
                          "meta": "Jar Jar Binks"
                      },
                      {
                          "num": "AU-AR",
                          "title": "Al Rodrigo",
                          "meta": "Quinlan Vos"
                      },
                      {
                          "num": "AU-BH",
                          "title": "Brian Herring",
                          "meta": "BB-8"
                      },
                      {
                          "num": "AU-CB",
                          "title": "Crispian Belfrage",
                          "meta": "Devastator Captain"
                      },
                      {
                          "num": "AU-DC",
                          "title": "Dan Considine",
                          "meta": "Densin Clord"
                      },
                      {
                          "num": "AU-FJ",
                          "title": "Felicity Jones",
                          "meta": "Jyn Erso"
                      },
                      {
                          "num": "AU-GE",
                          "title": "Giancarlo Esposito",
                          "meta": "Moff Gideon"
                      },
                      {
                          "num": "AU-GF",
                          "title": "Gabriel Fonseca",
                          "meta": "Duke Kayo Organa"
                      },
                      {
                          "num": "AU-ID",
                          "title": "Indie DesRoches",
                          "meta": "Corran"
                      },
                      {
                          "num": "AU-IM",
                          "title": "Ian McDiarmid",
                          "meta": "Emperor Palpatine"
                      },
                      {
                          "num": "AU-IV",
                          "title": "Indira Varma",
                          "meta": "Tala Durith"
                      },
                      {
                          "num": "AU-KF",
                          "title": "Karen Fukuhara",
                          "meta": "F"
                      },
                      {
                          "num": "AU-LC",
                          "title": "Lily Cole",
                          "meta": "Lovey"
                      },
                      {
                          "num": "AU-MQ",
                          "title": "Ming Qiu",
                          "meta": "Minas Velti"
                      },
                      {
                          "num": "AU-MW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "AU-OD",
                          "title": "Olivia D'Abo",
                          "meta": "Luminara Unduli"
                      },
                      {
                          "num": "AU-RS",
                          "title": "Roberta Sparta",
                          "meta": "Duchess Celly Organa"
                      },
                      {
                          "num": "AU-TM",
                          "title": "Temuera Morrison",
                          "meta": "Boba Fett"
                      }
                  ]
              }
          ]
      }
  },

  '2022-signature-series': {
    "setId": "2022-signature-series",
    "year": "2022",
    "brand": "TOPPS",
    "title": "STAR WARS SIGNATURE SERIES",
    "releaseDate": "2 / 16 / 2022",
    "lede": "The all-autograph line's second year — one box, one pack, one encased signed card. The 146-card A-design program spans two official blocks and more than 100 signers, from Harrison Ford, Emilia Clarke, Ewan McGregor, and Hayden Christensen to the deepest cast cuts, and the 56-card B-design puts its signatures on a 1980 Topps Empire Strikes Back-inspired variant design. The chase tops out with dual and triple autographs and the line's first quad autographs — every quad a one-of-one, led by the Harrison Ford / Carrie Fisher / Daisy Ridley / Adam Driver book. Every base autograph climbs a five-tier ladder from Blue /50 to the one-of-one Red.",
    "stats": [
      {
        "num": "211",
        "label": "Auto Cards",
        "sub": "Every card is signed",
        "color": "gold"
      },
      {
        "num": "146",
        "label": "A Design",
        "sub": "Two official blocks",
        "color": "cyan"
      },
      {
        "num": "56",
        "label": "B Design",
        "sub": "1980 ESB variant design",
        "color": "green"
      },
      {
        "num": "9",
        "label": "Multi-Signed",
        "sub": "Duals · triples · quads",
        "color": "purple"
      },
      {
        "num": "6",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "1",
        "l": "Encased autograph per box"
      },
      {
        "v": "1",
        "l": "Card per pack · 1 pack per box"
      },
      {
        "v": "20",
        "l": "Boxes per case"
      },
      {
        "v": "100+",
        "l": "Signers across both designs"
      }
    ],
    "pullRates": [
      {
        "name": "A-Design Blue /50",
        "odds": "1 : 8",
        "tier": "normal"
      },
      {
        "name": "B-Design Autograph",
        "odds": "1 : 9",
        "tier": "normal"
      },
      {
        "name": "A-Design Green /25",
        "odds": "1 : 13",
        "tier": "normal"
      },
      {
        "name": "A-Design Orange /10",
        "odds": "1 : 30",
        "tier": "normal"
      },
      {
        "name": "A-Design Black /5",
        "odds": "1 : 59",
        "tier": "rare"
      },
      {
        "name": "A-Design Red 1/1",
        "odds": "1 : 290",
        "tier": "rare"
      },
      {
        "name": "B-Design Red 1/1",
        "odds": "1 : 755",
        "tier": "rare"
      },
      {
        "name": "Dual Autographs",
        "odds": "1 : 2,816",
        "tier": "mythic"
      },
      {
        "name": "Triple Autographs",
        "odds": "1 : 2,816",
        "tier": "mythic"
      },
      {
        "name": "Quad Autographs 1/1",
        "odds": "1 : 14,070",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "AUTOGRAPH",
        "pr": "∞",
        "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
        "darkText": true
      },
      {
        "name": "BLUE",
        "pr": "/50",
        "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "ORANGE",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      },
      {
        "name": "BLACK",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "RED",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      }
    ],
    "artists": [],
    "subsets": {
      "auto": [
        {
          "count": 85,
          "name": "AUTOGRAPH CARDS A I",
          "meta": "The A-design flagship block · 85 cards · Blue /50 → Red 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "A-HF",
              "title": "Harrison Ford"
            },
            {
              "num": "A-EC",
              "title": "Emilia Clarke"
            },
            {
              "num": "A-DG",
              "title": "Domhnall Gleeson"
            },
            {
              "num": "A-AD",
              "title": "Adam Driver"
            },
            {
              "num": "A-HC",
              "title": "Hayden Christensen"
            },
            {
              "num": "A-FJ",
              "title": "Felicity Jones"
            },
            {
              "num": "A-SG",
              "title": "Sarah Michelle Gellar"
            },
            {
              "num": "A-AH",
              "title": "Alden Ehrenreich"
            },
            {
              "num": "A-WH",
              "title": "Werner Herzog"
            },
            {
              "num": "A-KB",
              "title": "Kenny Baker"
            },
            {
              "num": "A-LD",
              "title": "Laura Dern"
            },
            {
              "num": "A-TC",
              "title": "Tim Curry"
            },
            {
              "num": "A-PB",
              "title": "Paul Bettany"
            },
            {
              "num": "A-WD",
              "title": "Warwick Davis"
            },
            {
              "num": "A-RA",
              "title": "Riz Ahmed"
            },
            {
              "num": "A-TB",
              "title": "Tom Baker"
            },
            {
              "num": "A-BB",
              "title": "Ben Burtt"
            },
            {
              "num": "A-AB",
              "title": "Ahmed Best"
            },
            {
              "num": "A-JB",
              "title": "John Boyega"
            },
            {
              "num": "A-NA",
              "title": "Naomi Ackie"
            },
            {
              "num": "A-MC",
              "title": "Michael Carter"
            },
            {
              "num": "A-KCH",
              "title": "Keisha Castle-Hughes"
            },
            {
              "num": "A-GE",
              "title": "Giancarlo Esposito"
            },
            {
              "num": "A-GG",
              "title": "Greg Grunberg"
            },
            {
              "num": "A-JI",
              "title": "Jason Isaacs"
            },
            {
              "num": "A-AE",
              "title": "Ashley Eckstein"
            },
            {
              "num": "A-AB2",
              "title": "Anna Brewster"
            },
            {
              "num": "A-JB2",
              "title": "Jeremy Bulloch"
            },
            {
              "num": "A-AD1",
              "title": "Annabelle Davis"
            },
            {
              "num": "A-MD",
              "title": "Mark Dodson"
            },
            {
              "num": "A-KF",
              "title": "Kate Fleetwood"
            },
            {
              "num": "A-NF",
              "title": "Nika Futterman"
            },
            {
              "num": "A-JG",
              "title": "Janina Gavankar"
            },
            {
              "num": "A-AH1",
              "title": "Amanda Hale"
            },
            {
              "num": "A-BH",
              "title": "Brian Herring"
            },
            {
              "num": "A-CH",
              "title": "Clint Howard"
            },
            {
              "num": "A-SL",
              "title": "Scott Lawrence"
            },
            {
              "num": "A-SM",
              "title": "Suzie McGrath"
            },
            {
              "num": "A-CS",
              "title": "Christopher Sean"
            },
            {
              "num": "A-PB2",
              "title": "Paul Blake"
            },
            {
              "num": "A-AB1",
              "title": "Ariyon Bakare"
            },
            {
              "num": "A-HC1",
              "title": "Hermione Corfield"
            },
            {
              "num": "A-NF1",
              "title": "Nina Fallon"
            },
            {
              "num": "A-GH",
              "title": "Garrick Hagon"
            },
            {
              "num": "A-PK",
              "title": "Paul Kasey"
            },
            {
              "num": "A-SB",
              "title": "Steven Blum"
            },
            {
              "num": "A-RB",
              "title": "Ralph Brown"
            },
            {
              "num": "A-TG",
              "title": "Taylor Gray"
            },
            {
              "num": "A-OA",
              "title": "Omid Abtahi"
            },
            {
              "num": "A-HD",
              "title": "Harley Durst"
            },
            {
              "num": "A-ME",
              "title": "Mike Edmonds"
            },
            {
              "num": "A-MJ",
              "title": "Michael Jibson"
            },
            {
              "num": "A-DB",
              "title": "Dee Bradley Baker"
            },
            {
              "num": "A-MB",
              "title": "Mark Boone Jr."
            },
            {
              "num": "A-RB1",
              "title": "Richard Brake"
            },
            {
              "num": "A-DC",
              "title": "Dave Chapman"
            },
            {
              "num": "A-BD",
              "title": "Ben Daniels"
            },
            {
              "num": "A-TD",
              "title": "Tim Dry"
            },
            {
              "num": "A-DI",
              "title": "Diana Lee Inosanto"
            },
            {
              "num": "A-ZJ",
              "title": "Zac Jensen"
            },
            {
              "num": "A-PA",
              "title": "Philip Alexander"
            },
            {
              "num": "A-CA",
              "title": "Cas Anvar"
            },
            {
              "num": "A-MA",
              "title": "Mark Austin"
            },
            {
              "num": "A-CB",
              "title": "Chris Bartlett"
            },
            {
              "num": "A-DB1",
              "title": "Dmitrious Bistrevsky"
            },
            {
              "num": "A-PB1",
              "title": "Paul Brooke"
            },
            {
              "num": "A-SC",
              "title": "Scott Capurro"
            },
            {
              "num": "A-LC",
              "title": "Lily Cole"
            },
            {
              "num": "A-MC1",
              "title": "Michaela Cottrell"
            },
            {
              "num": "A-SC1",
              "title": "Sean Crawford"
            },
            {
              "num": "A-NC",
              "title": "Nathalie Cuzner"
            },
            {
              "num": "A-RA1",
              "title": "Robin Atkin Downes"
            },
            {
              "num": "A-RA2",
              "title": "Robin Atkin Downes"
            },
            {
              "num": "A-EE",
              "title": "Emun Elliott"
            },
            {
              "num": "A-AF",
              "title": "Anna Francolini"
            },
            {
              "num": "A-AG",
              "title": "Anna Graves"
            },
            {
              "num": "A-GH1",
              "title": "Gerald Home"
            },
            {
              "num": "A-SK",
              "title": "Simon Kassianides"
            },
            {
              "num": "A-MB1",
              "title": "Michonne Bourriague"
            },
            {
              "num": "A-OD",
              "title": "Oliver Ford Davies"
            },
            {
              "num": "A-VK",
              "title": "Valene Kane"
            },
            {
              "num": "A-BB1",
              "title": "Blair Bess"
            },
            {
              "num": "A-CE",
              "title": "Chris Edgerly"
            },
            {
              "num": "A-NK1",
              "title": "Nick Kellington"
            },
            {
              "num": "A-NK2",
              "title": "Nick Kellington"
            }
          ]
        },
        {
          "count": 61,
          "name": "AUTOGRAPH CARDS A II",
          "meta": "The A-design second block · 61 cards · Blue /50 → Red 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "A-EM",
              "title": "Ewan McGregor"
            },
            {
              "num": "A-GC",
              "title": "Gwendoline Christie"
            },
            {
              "num": "A-BW",
              "title": "Billy Dee Williams"
            },
            {
              "num": "A-FW",
              "title": "Forest Whitaker"
            },
            {
              "num": "A-CW",
              "title": "Carl Weathers"
            },
            {
              "num": "A-KMT",
              "title": "Kelly Marie Tran"
            },
            {
              "num": "A-JL",
              "title": "John Leguizamo"
            },
            {
              "num": "A-BL",
              "title": "Billie Lourd"
            },
            {
              "num": "A-NN",
              "title": "Nick Nolte"
            },
            {
              "num": "A-AS",
              "title": "Andy Serkis"
            },
            {
              "num": "A-TW",
              "title": "Taika Waititi"
            },
            {
              "num": "A-MM1",
              "title": "Mads Mikkelsen"
            },
            {
              "num": "A-DM",
              "title": "Dominic Monaghan"
            },
            {
              "num": "A-RP",
              "title": "Ray Park"
            },
            {
              "num": "A-RP1",
              "title": "Ron Perlman"
            },
            {
              "num": "A-FPJ",
              "title": "Freddie Prinze Jr."
            },
            {
              "num": "A-DY",
              "title": "Donnie Yen"
            },
            {
              "num": "A-SW",
              "title": "Sam Witwer"
            },
            {
              "num": "A-PR",
              "title": "Paul Reubens"
            },
            {
              "num": "A-GT",
              "title": "George Takei"
            },
            {
              "num": "A-MK",
              "title": "Mercedes Varnado"
            },
            {
              "num": "A-AT",
              "title": "Alan Tudyk"
            },
            {
              "num": "A-DL",
              "title": "Denis Lawson"
            },
            {
              "num": "A-SS1",
              "title": "Sema-Tawi Smart"
            },
            {
              "num": "A-TM",
              "title": "Temuera Morrison"
            },
            {
              "num": "A-PM",
              "title": "Peter Mayhew"
            },
            {
              "num": "A-ML",
              "title": "Matt Lanter"
            },
            {
              "num": "A-DT",
              "title": "David Tennant"
            },
            {
              "num": "A-AE2",
              "title": "Ashley Eckstein"
            },
            {
              "num": "A-KL",
              "title": "Ken Leung"
            },
            {
              "num": "A-LM",
              "title": "Lewis MacLeod"
            },
            {
              "num": "A-VM",
              "title": "Vanessa Marshall"
            },
            {
              "num": "A-KM",
              "title": "Cathy Munroe"
            },
            {
              "num": "A-ES",
              "title": "Emily Swallow"
            },
            {
              "num": "A-DT1",
              "title": "Dee Tails"
            },
            {
              "num": "A-MW",
              "title": "Matthew Wood"
            },
            {
              "num": "A-AW",
              "title": "Andrew Woodall"
            },
            {
              "num": "A-LM1",
              "title": "Lars Mikkelsen"
            },
            {
              "num": "A-AR",
              "title": "Alan Ruscoe"
            },
            {
              "num": "A-OS",
              "title": "Orli Shoshan"
            },
            {
              "num": "A-LW",
              "title": "Leeanna Walsman"
            },
            {
              "num": "A-AK",
              "title": "Andrew Kishino"
            },
            {
              "num": "A-RO",
              "title": "Rena Owen"
            },
            {
              "num": "A-MP",
              "title": "Michael Pennington"
            },
            {
              "num": "A-CR",
              "title": "Clive Revill"
            },
            {
              "num": "A-LT",
              "title": "Lee Towersey"
            },
            {
              "num": "A-DB2",
              "title": "Dee Bradley Baker"
            },
            {
              "num": "A-AG1",
              "title": "Anna Graves"
            },
            {
              "num": "A-JK",
              "title": "Jack Klaff"
            },
            {
              "num": "A-HQ",
              "title": "Hugh Quarshie"
            },
            {
              "num": "A-CO",
              "title": "Candice Orwell"
            },
            {
              "num": "A-SS",
              "title": "Stephanie Silva"
            },
            {
              "num": "A-BS",
              "title": "Bruce Spence"
            },
            {
              "num": "A-OW",
              "title": "Oliver Walpole"
            },
            {
              "num": "A-PL",
              "title": "Paul Sun-Hyung Lee"
            },
            {
              "num": "A-KO",
              "title": "Katy O'Brian"
            },
            {
              "num": "A-LS",
              "title": "Leilani Shiu"
            },
            {
              "num": "A-AW1",
              "title": "Alexander Wraith"
            },
            {
              "num": "A-IR",
              "title": "Ian Ruskin"
            },
            {
              "num": "A-KS1",
              "title": "Kath Soucie"
            },
            {
              "num": "A-BM1",
              "title": "Ben Mendelsohn"
            }
          ]
        },
        {
          "count": 56,
          "name": "AUTOGRAPH CARDS B",
          "meta": "ESB-inspired design variants · 56 cards · Blue /50 → Red 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "AV-HF",
              "title": "Harrison Ford"
            },
            {
              "num": "AV-EM",
              "title": "Ewan McGregor"
            },
            {
              "num": "AV-EC",
              "title": "Emilia Clarke"
            },
            {
              "num": "AV-DG",
              "title": "Domhnall Gleeson"
            },
            {
              "num": "AV-AD",
              "title": "Adam Driver"
            },
            {
              "num": "AV-HC",
              "title": "Hayden Christensen"
            },
            {
              "num": "AV-FJ",
              "title": "Felicity Jones"
            },
            {
              "num": "AV-FW",
              "title": "Forest Whitaker"
            },
            {
              "num": "AV-SG",
              "title": "Sarah Michelle Gellar"
            },
            {
              "num": "AV-AE",
              "title": "Alden Ehrenreich"
            },
            {
              "num": "AV-GC",
              "title": "Gwendoline Christie"
            },
            {
              "num": "AV-BW",
              "title": "Billy Dee Williams"
            },
            {
              "num": "AV-WH",
              "title": "Werner Herzog"
            },
            {
              "num": "AV-IM",
              "title": "Ian McDiarmid"
            },
            {
              "num": "AV-KB",
              "title": "Kenny Baker"
            },
            {
              "num": "AV-CW",
              "title": "Carl Weathers"
            },
            {
              "num": "AV-LD",
              "title": "Laura Dern"
            },
            {
              "num": "AV-NN",
              "title": "Nick Nolte"
            },
            {
              "num": "AV-AS",
              "title": "Andy Serkis"
            },
            {
              "num": "AV-TW",
              "title": "Taika Waititi"
            },
            {
              "num": "AV-PB",
              "title": "Paul Bettany"
            },
            {
              "num": "AV-WD",
              "title": "Warwick Davis"
            },
            {
              "num": "AV-RP",
              "title": "Ray Park"
            },
            {
              "num": "AV-FPJ",
              "title": "Freddie Prinze Jr."
            },
            {
              "num": "AV-DY",
              "title": "Donnie Yen"
            },
            {
              "num": "AV-MK",
              "title": "Mercedes Varnado"
            },
            {
              "num": "AV-AT",
              "title": "Alan Tudyk"
            },
            {
              "num": "AV-JB",
              "title": "John Boyega"
            },
            {
              "num": "AV-TM",
              "title": "Temuera Morrison"
            },
            {
              "num": "AV-MC",
              "title": "Michael Carter"
            },
            {
              "num": "AV-KC",
              "title": "Keisha Castle-Hughes"
            },
            {
              "num": "AV-GE",
              "title": "Giancarlo Esposito"
            },
            {
              "num": "AV-GG",
              "title": "Greg Grunberg"
            },
            {
              "num": "AV-ML",
              "title": "Matt Lanter"
            },
            {
              "num": "AV-AE1",
              "title": "Ashley Eckstein"
            },
            {
              "num": "AV-AE2",
              "title": "Ashley Eckstein"
            },
            {
              "num": "AV-JB1",
              "title": "Jeremy Bulloch"
            },
            {
              "num": "AV-AD1",
              "title": "Annabelle Davis"
            },
            {
              "num": "AV-NF",
              "title": "Nika Futterman"
            },
            {
              "num": "AV-JG",
              "title": "Janina Gavankar"
            },
            {
              "num": "AV-MW",
              "title": "Matthew Wood"
            },
            {
              "num": "AV-PB1",
              "title": "Paul Blake"
            },
            {
              "num": "AV-CR",
              "title": "Clive Revill"
            },
            {
              "num": "AV-SB",
              "title": "Steve Blum"
            },
            {
              "num": "AV-TG",
              "title": "Taylor Gray"
            },
            {
              "num": "AV-OA",
              "title": "Omid Abtahi"
            },
            {
              "num": "AV-DB",
              "title": "Dee Bradley Baker"
            },
            {
              "num": "AV-MB",
              "title": "Mark Boone Jr."
            },
            {
              "num": "AV-DC",
              "title": "Dave Chapman"
            },
            {
              "num": "AV-RB",
              "title": "Richard Brake"
            },
            {
              "num": "AV-PA",
              "title": "Philip Alexander"
            },
            {
              "num": "AV-CB",
              "title": "Chris Bartlett"
            },
            {
              "num": "AV-DB1",
              "title": "Dmitrious Bistrevsky"
            },
            {
              "num": "AV-RA",
              "title": "Robin Atkin Downes"
            },
            {
              "num": "AV-SK",
              "title": "Simon Kassianides"
            },
            {
              "num": "AV-NK",
              "title": "Nick Kellington"
            }
          ]
        },
        {
          "count": 3,
          "name": "DUAL AUTOGRAPHS",
          "meta": "3 pairings · Red 1/1",
          "parallels": 1,
          "cards": [
            {
              "num": "DA-MWT",
              "title": "Ray Park / Matthew Wood"
            },
            {
              "num": "DA-FJD",
              "title": "Felicity Jones / Donnie Yen"
            },
            {
              "num": "DA-JTA",
              "title": "James Arnold Taylor / Anna Graves"
            }
          ]
        },
        {
          "count": 3,
          "name": "TRIPLE AUTOGRAPHS",
          "meta": "3 trios · Red 1/1",
          "parallels": 1,
          "cards": [
            {
              "num": "TA-LJ",
              "title": "Daisy Ridley / John Boyega / Laura Dern"
            },
            {
              "num": "TA-RO",
              "title": "Felicity Jones / Alan Tudyk / Riz Ahmed"
            },
            {
              "num": "TA-FAW",
              "title": "Adam Driver / Domhnall Gleeson / Andy Serkis"
            }
          ]
        },
        {
          "count": 3,
          "name": "QUAD AUTOGRAPHS",
          "meta": "New for 2022 · every card a one-of-one",
          "parallels": 1,
          "cards": [
            {
              "num": "QA-CW",
              "title": "Ashley Eckstein / James Arnold Taylor / Matt Lanter / Dee Bradley Baker"
            },
            {
              "num": "QA-FA",
              "title": "Harrison Ford / Carrie Fisher / Daisy Ridley / Adam Driver"
            },
            {
              "num": "QA-SA",
              "title": "Ian McDiarmid / Ray Park / Hayden Christensen / Adam Driver"
            }
          ]
        }
      ]
    }
  },

  '2021-chrome-legacy': {
    "setId": "2021-chrome-legacy",
    "year": "2021",
    "brand": "TOPPS CHROME",
    "title": "STAR WARS LEGACY",
    "releaseDate": "10 / 20 / 2021",
    "lede": "The second Chrome Legacy puts the modern era’s stories on chromium — 200 base cards retelling The Rise of Skywalker, Rogue One, Solo, The Clone Wars, Rebels, and the first two seasons of The Mandalorian moment by moment, under a seven-tier rainbow from Refractor to the one-of-one SuperFractor. The chase runs through Mandalorian concept art, Wielders of the Lightsaber, and Star Wars: Visions concept art filed under the show’s working title, Project Kyoto — plus 40 ship medallions serial-numbered /99, a 53-signer autograph program split across Age of Republic, Rebellion, and Resistance designs with Harrison Ford, Carrie Fisher, Ewan McGregor, and Daisy Ridley, five dual autographs, and original sketch art from a 139-artist roster in standard and shaped formats.",
    "stats": [
      {
        "num": "200",
        "label": "Base Cards",
        "sub": "Six films & shows, story by story",
        "color": "gold"
      },
      {
        "num": "50",
        "label": "Insert Cards",
        "sub": "Concept art & lightsaber wielders",
        "color": "cyan"
      },
      {
        "num": "58",
        "label": "Auto Cards",
        "sub": "3 Age designs · 5 dual pairings",
        "color": "green"
      },
      {
        "num": "139",
        "label": "Sketch Artists",
        "sub": "Standard & shaped formats",
        "color": "purple"
      },
      {
        "num": "10",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "5",
        "l": "Cards per pack"
      },
      {
        "v": "12",
        "l": "Packs per box · two 6-pack mini boxes"
      },
      {
        "v": "8",
        "l": "Boxes per case"
      },
      {
        "v": "2",
        "l": "Hits per box · at least 1 autograph or sketch"
      },
      {
        "v": "4",
        "l": "Refractors per box"
      }
    ],
    "pullRates": [
      {
        "name": "Refractors",
        "odds": "1 : 3 packs",
        "tier": "normal"
      },
      {
        "name": "Autograph or Sketch",
        "odds": "1 per box",
        "tier": "normal"
      },
      {
        "name": "Auto, Sketch or Medallion",
        "odds": "1 more per box",
        "tier": "normal"
      },
      {
        "name": "Ship Medallions",
        "odds": "every card /99",
        "tier": "rare"
      },
      {
        "name": "Dual Autographs",
        "odds": "/25 or less",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "REFRACTOR",
        "pr": "∞",
        "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
        "darkText": true
      },
      {
        "name": "BLUE",
        "pr": "/99",
        "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/50",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "ORANGE",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      },
      {
        "name": "BLACK",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "RED",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      },
      {
        "name": "SUPERFRACTOR",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)",
        "darkText": true
      }
    ],
    "artists": [],
    "subsets": {
      "base": [
        {
          "count": 200,
          "name": "BASE CARDS",
          "meta": "The modern era, story by story · Refractor → SuperFractor 1/1",
          "parallels": 7,
          "cards": [
            {
              "num": "1",
              "title": "Kylo Ren Obtains The Sith Wayfinder"
            },
            {
              "num": "2",
              "title": "Kylo Ren Finds Palpatine On Exegol"
            },
            {
              "num": "3",
              "title": "Palpatine Reveals The Final Order"
            },
            {
              "num": "4",
              "title": "Rey In Training"
            },
            {
              "num": "5",
              "title": "Finn And Poe Deliver Intelligence"
            },
            {
              "num": "6",
              "title": "Lando Calrissian Helps The Resistance"
            },
            {
              "num": "7",
              "title": "Chewbacca Taken By The First Order"
            },
            {
              "num": "8",
              "title": "Rey And The Team Travel To Kijimi"
            },
            {
              "num": "9",
              "title": "C-3PO's Memory Reveals The Wayfinder"
            },
            {
              "num": "10",
              "title": "Rey Learns Who She Is"
            },
            {
              "num": "11",
              "title": "The Team Rescues Chewbacca"
            },
            {
              "num": "12",
              "title": "The Falcon Flies To Kef Bir"
            },
            {
              "num": "13",
              "title": "Rey & Kylo Ren Battle Amongst The Waves"
            },
            {
              "num": "14",
              "title": "Rey Heals Kylo Ren"
            },
            {
              "num": "15",
              "title": "Luke Skywalker Tells Rey To Face Palpatine"
            },
            {
              "num": "16",
              "title": "Ben Solo Sees A Memory Of Han Solo"
            },
            {
              "num": "17",
              "title": "The Resistance Prepares To Attack"
            },
            {
              "num": "18",
              "title": "Rey Confronts Her Grandfather"
            },
            {
              "num": "19",
              "title": "Lando Calrissian Brings Reinforcements"
            },
            {
              "num": "20",
              "title": "Ben Solo Destroys The Knights Of Ren"
            },
            {
              "num": "21",
              "title": "Ben Solo And Rey Take On Palpatine"
            },
            {
              "num": "22",
              "title": "Palpatine Drains Power From Rey And Ben Solo"
            },
            {
              "num": "23",
              "title": "The Fleet Attacked By Force Lightning"
            },
            {
              "num": "24",
              "title": "Rey Hears The Voices Of Past Jedi"
            },
            {
              "num": "25",
              "title": "Rey Deflects The Force Lightning"
            },
            {
              "num": "26",
              "title": "Palpatine Is Destroyed By Rey"
            },
            {
              "num": "27",
              "title": "Ben Solo Uses The Force To Revive Rey"
            },
            {
              "num": "28",
              "title": "The Resistance Defeats The Final Order"
            },
            {
              "num": "29",
              "title": "Rey Buries The Lightsabers On Tatooine"
            },
            {
              "num": "30",
              "title": "Rey States Her Name As \"Rey Skywalker\""
            },
            {
              "num": "31",
              "title": "Director Krennic Finds Galen Erso"
            },
            {
              "num": "32",
              "title": "Young Jyn Erso Escapes The Empire"
            },
            {
              "num": "33",
              "title": "Bodhi Rook Flees The Empire"
            },
            {
              "num": "34",
              "title": "Cassian Learns Of An Imperial Defector"
            },
            {
              "num": "35",
              "title": "Jyn Erso Meets Mon Mothma"
            },
            {
              "num": "36",
              "title": "Jyn & Cassian Team With K-2SO"
            },
            {
              "num": "37",
              "title": "Chirrut & Baze Battle The Stormtroopers"
            },
            {
              "num": "38",
              "title": "Saw Gerrera Reveals The Message From Galen Erso"
            },
            {
              "num": "39",
              "title": "Director Krennic Destroys Jedha City"
            },
            {
              "num": "40",
              "title": "Grand Moff Tarkin Meets With Director Krennic"
            },
            {
              "num": "41",
              "title": "Bodhi Rook Leads The Team To Eadu"
            },
            {
              "num": "42",
              "title": "Jyn Erso Is Too Late To Save Her Father"
            },
            {
              "num": "43",
              "title": "Director Krennic Talks With Darth Vader"
            },
            {
              "num": "44",
              "title": "The Mission To Steal The Death Star Plans"
            },
            {
              "num": "45",
              "title": "Rogue One Heads To Scarif"
            },
            {
              "num": "46",
              "title": "Cassian, Jyn & K-2SO Sneak Into The Base"
            },
            {
              "num": "47",
              "title": "Admiral Raddus Defeats The Star Destroyers"
            },
            {
              "num": "48",
              "title": "Cassian & Jyn Find The Schematics"
            },
            {
              "num": "49",
              "title": "Director Krennic Ambushes Jyn & Cassian"
            },
            {
              "num": "50",
              "title": "Jyn Transmits The Death Star Plans"
            },
            {
              "num": "51",
              "title": "Tarkin Destroys The Compromised Base"
            },
            {
              "num": "52",
              "title": "The Rebel Fleet Prepares For Hyperspace"
            },
            {
              "num": "53",
              "title": "Vader's Destroyer Intercepts Rebels"
            },
            {
              "num": "54",
              "title": "Vader Pursues The Stolen Plans"
            },
            {
              "num": "55",
              "title": "Darth Vader Attacks The Rebels"
            },
            {
              "num": "56",
              "title": "Rebels Fight To Hand Off The Stolen Plans"
            },
            {
              "num": "57",
              "title": "A Small Starship Evades Vader's Grasp"
            },
            {
              "num": "58",
              "title": "The Plans Are Delivered To Princess Leia"
            },
            {
              "num": "59",
              "title": "The Rebellion Now Has Hope"
            },
            {
              "num": "60",
              "title": "Han & Qi'ra Run From The White Worms"
            },
            {
              "num": "61",
              "title": "Qi'ra Is Captured During Escape Attempt"
            },
            {
              "num": "62",
              "title": "Han Escapes, But Vows To Return"
            },
            {
              "num": "63",
              "title": "Han Encounters Tobias Beckett"
            },
            {
              "num": "64",
              "title": "Solo Meets Chewbacca In The Pit"
            },
            {
              "num": "65",
              "title": "Beckett Teams With Solo & Chewie"
            },
            {
              "num": "66",
              "title": "Beckett & The Team Try To Steal Coaxium"
            },
            {
              "num": "67",
              "title": "Enfys Nest Ruins The Hijacking Plans"
            },
            {
              "num": "68",
              "title": "Beckett Loses Val & Rio Durant"
            },
            {
              "num": "69",
              "title": "Han & Chewie Vow To Help Beckett"
            },
            {
              "num": "70",
              "title": "Han Finds Qi'ra With Crimson Dawn"
            },
            {
              "num": "71",
              "title": "The Team Meets With Dryden Vos"
            },
            {
              "num": "72",
              "title": "Han Suggests Kessel Run To Obtain Coaxium"
            },
            {
              "num": "73",
              "title": "Qi'ra Brings The Team To Lando Calrissian"
            },
            {
              "num": "74",
              "title": "Han Challenges Lando To Sabacc"
            },
            {
              "num": "75",
              "title": "Lando Joins The Mission For A Share Of Profits"
            },
            {
              "num": "76",
              "title": "Han Solo Sees The Millennium Falcon"
            },
            {
              "num": "77",
              "title": "L3-37 Instigates Revolt On Kessel"
            },
            {
              "num": "78",
              "title": "The Team Steals The Coaxium & Flees The Empire"
            },
            {
              "num": "79",
              "title": "The Millennium Falcon Lands On Savareen"
            },
            {
              "num": "80",
              "title": "Enfys Nest Reveals Her Crew To Be Rebels"
            },
            {
              "num": "81",
              "title": "Han Attempts To Outsmart Dryden Vos"
            },
            {
              "num": "82",
              "title": "Beckett Betrays Dryden Vos, Takes Chewie"
            },
            {
              "num": "83",
              "title": "Qi'ra Defeats Dryden Vos"
            },
            {
              "num": "84",
              "title": "Han Goes After Beckett"
            },
            {
              "num": "85",
              "title": "Qi'ra Contacts Maul"
            },
            {
              "num": "86",
              "title": "Han Defeats Beckett"
            },
            {
              "num": "87",
              "title": "Han Gives The Coaxium To Enfys Nest"
            },
            {
              "num": "88",
              "title": "Han Wins The Millennium Falcon From Lando"
            },
            {
              "num": "89",
              "title": "Master Yoda Begins A Secret Mission"
            },
            {
              "num": "90",
              "title": "Yoda Takes On Ventress And Her Army"
            },
            {
              "num": "91",
              "title": "The Toydarian People Learn About The Jedi"
            },
            {
              "num": "92",
              "title": "The Malevolence Wreaks Havoc On The Jedi"
            },
            {
              "num": "93",
              "title": "The Jedi Take Down The Malevolence"
            },
            {
              "num": "94",
              "title": "Cad Bane & Aurra Sing Attack Senate Building"
            },
            {
              "num": "95",
              "title": "Darth Sidious Hires Cad Bane"
            },
            {
              "num": "96",
              "title": "Cad Bane Goes For The Jedi Holocron"
            },
            {
              "num": "97",
              "title": "Obi-Wan Kenobi Meets With Duchess Satine"
            },
            {
              "num": "98",
              "title": "Ahsoka Tano Stops Aurra Sing On Florrum"
            },
            {
              "num": "99",
              "title": "Boba Fett & Bossk Are Arrested"
            },
            {
              "num": "100",
              "title": "Ahsoka Tano Protects Senator Amidala"
            },
            {
              "num": "101",
              "title": "Cad Bane Breaks Ziro From Prison"
            },
            {
              "num": "102",
              "title": "Darth Sidious Meets With Count Dooku"
            },
            {
              "num": "103",
              "title": "The Jedi Descend On Mortis"
            },
            {
              "num": "104",
              "title": "Chewbacca Helps Ahsoka Escape"
            },
            {
              "num": "105",
              "title": "Krell And Dooku Become Allies"
            },
            {
              "num": "106",
              "title": "Lux & Ahsoka Tano Escape From Vizsla"
            },
            {
              "num": "107",
              "title": "Obi-Wan Kenobi Battles Maul & Savage Opress"
            },
            {
              "num": "108",
              "title": "Anakin Skywalker Contacts Hondo Ohnaka"
            },
            {
              "num": "109",
              "title": "Yoda Teaches Younglings On Ilum"
            },
            {
              "num": "110",
              "title": "Mandalore Under Attack"
            },
            {
              "num": "111",
              "title": "Order 66 Is Activated"
            },
            {
              "num": "112",
              "title": "Ahsoka Tano & Captain Rex Try To Stop Maul"
            },
            {
              "num": "113",
              "title": "Darth Vader Finds Ahsoka Tano's Lightsaber"
            },
            {
              "num": "114",
              "title": "Ezra Bridger Joins Ghost Crew In Their Getaway"
            },
            {
              "num": "115",
              "title": "Zeb Orrelios Hijacks A Tie Fighter"
            },
            {
              "num": "116",
              "title": "Ezra Bridger Starts His Jedi Training"
            },
            {
              "num": "117",
              "title": "Kanan Jarrus Struggles As A Mentor"
            },
            {
              "num": "118",
              "title": "Grand Moff Tarkin Visits Lothal"
            },
            {
              "num": "119",
              "title": "Agent Kallus Meets Darth Vader"
            },
            {
              "num": "120",
              "title": "Darth Vader Attacks Lothal"
            },
            {
              "num": "121",
              "title": "The Ghost Crew Locates Captain Rex"
            },
            {
              "num": "122",
              "title": "Ezra Bridger & Chopper Find Ketsu Onyo"
            },
            {
              "num": "123",
              "title": "Ahsoka Tano Meets With Kanan"
            },
            {
              "num": "124",
              "title": "Ezra Learns About His Parents"
            },
            {
              "num": "125",
              "title": "Leia Talks With Ezra & Kanan"
            },
            {
              "num": "126",
              "title": "Chava Reveals The True Force Names"
            },
            {
              "num": "127",
              "title": "Ezra Bridger Opens The Sith Holocron"
            },
            {
              "num": "128",
              "title": "Kanan Jarrus Rescues The Ghost Crew"
            },
            {
              "num": "129",
              "title": "Obi-Wan Kenobi Watches A Young Luke Skywalker"
            },
            {
              "num": "130",
              "title": "Ezra & Sabine Destroy Interdictor-Class Cruisers"
            },
            {
              "num": "131",
              "title": "Kanan Jarrus Uses The Force To Control The Blast"
            },
            {
              "num": "132",
              "title": "Sabine Wren & Zeb Orrelios Take On Rukh"
            },
            {
              "num": "133",
              "title": "Ahsoka Tano's Final Battle With Darth Vader"
            },
            {
              "num": "134",
              "title": "The Plan To Liberate Lothal"
            },
            {
              "num": "135",
              "title": "The Imperials Are Defeated"
            },
            {
              "num": "136",
              "title": "The Command Center Is Destroyed"
            },
            {
              "num": "137",
              "title": "The People Of Lothal Celebrate"
            },
            {
              "num": "138",
              "title": "The Ghost Crew Go Their Separate Ways"
            },
            {
              "num": "139",
              "title": "Hera & Rex Remain With The Rebels"
            },
            {
              "num": "140",
              "title": "The Mural Of The Ghost Crew On Lothal"
            },
            {
              "num": "141",
              "title": "Mando Meets With Greef Karga"
            },
            {
              "num": "142",
              "title": "Mando Accepts A New Mission"
            },
            {
              "num": "143",
              "title": "Grogu Is Discovered By Mando"
            },
            {
              "num": "144",
              "title": "Kuiil Helps Mando Negotiate"
            },
            {
              "num": "145",
              "title": "Grogu Uses The Force"
            },
            {
              "num": "146",
              "title": "Mando Hands Over Grogu"
            },
            {
              "num": "147",
              "title": "Mando Rescues Grogu From The Lab"
            },
            {
              "num": "148",
              "title": "Mando & Grogu Land On Tatooine"
            },
            {
              "num": "149",
              "title": "Mando Takes A Job From Ranzar Malk"
            },
            {
              "num": "150",
              "title": "The Team Tries To Capture Mando"
            },
            {
              "num": "151",
              "title": "X-Wings Attack Ranzar Malk's Station"
            },
            {
              "num": "152",
              "title": "Grogu Force Heals Greef Karga"
            },
            {
              "num": "153",
              "title": "Moff Gideon Arrives On Nevarro"
            },
            {
              "num": "154",
              "title": "Troops Fire On Mando's Crew"
            },
            {
              "num": "155",
              "title": "Moff Gideon Demands Grogu"
            },
            {
              "num": "156",
              "title": "Troopers Take Grogu From Kuiil"
            },
            {
              "num": "157",
              "title": "IG-11 Rescues Grogu"
            },
            {
              "num": "158",
              "title": "Mando Is Injured In Battle"
            },
            {
              "num": "159",
              "title": "IG-11 Removes Mando's Helmet"
            },
            {
              "num": "160",
              "title": "The Armorer Is The Only One Left"
            },
            {
              "num": "161",
              "title": "Mando Is Told To Bring Grogu To The Jedi"
            },
            {
              "num": "162",
              "title": "The Team Escapes On A Lava River Ferry"
            },
            {
              "num": "163",
              "title": "Troopers Ambush The Tunnel Exit"
            },
            {
              "num": "164",
              "title": "IG-11 Saves The Team By Self-Destructing"
            },
            {
              "num": "165",
              "title": "Moff Gideon Attacks In A Tie Fighter"
            },
            {
              "num": "166",
              "title": "Mando Takes Down The Tie Fighter"
            },
            {
              "num": "167",
              "title": "Mando Embarks On A New Mission"
            },
            {
              "num": "168",
              "title": "Moff Gideon Survives The Crash"
            },
            {
              "num": "169",
              "title": "Moff Gideon Ignites The Darksaber"
            },
            {
              "num": "170",
              "title": "Mando And Grogu Fly Away"
            },
            {
              "num": "171",
              "title": "Mando Meets The Marshal"
            },
            {
              "num": "172",
              "title": "The Krayt Dragon Attacks"
            },
            {
              "num": "173",
              "title": "The Krayt Dragon Slain By Mando"
            },
            {
              "num": "174",
              "title": "The Frog Lady Meets Grogu"
            },
            {
              "num": "175",
              "title": "The Razor Crest Is Attacked By Spiders"
            },
            {
              "num": "176",
              "title": "The New Republic Saves The Razor Crest"
            },
            {
              "num": "177",
              "title": "Mando Meets Other Mandalorians"
            },
            {
              "num": "178",
              "title": "Bo-Katan Kryze Offers Mando A Job"
            },
            {
              "num": "179",
              "title": "Mando Lands On Nevarro"
            },
            {
              "num": "180",
              "title": "The Imperial Base Is Destroyed"
            },
            {
              "num": "181",
              "title": "Ahsoka Tano Meets Grogu"
            },
            {
              "num": "182",
              "title": "Ahsoka & Mando Defeat Morgan Elsbeth"
            },
            {
              "num": "183",
              "title": "Grogu's Bond With Mando"
            },
            {
              "num": "184",
              "title": "Ahsoka Gives The Spear To Mando"
            },
            {
              "num": "185",
              "title": "Mando Brings Grogu To Tython"
            },
            {
              "num": "186",
              "title": "Grogu On The Seeing Stone"
            },
            {
              "num": "187",
              "title": "Boba Fett & Fennec Shand Arrive"
            },
            {
              "num": "188",
              "title": "Mando, Fett & Shand Battle Troopers"
            },
            {
              "num": "189",
              "title": "Dark Troopers Take Grogu"
            },
            {
              "num": "190",
              "title": "Mayfeld & Mando Work Together"
            },
            {
              "num": "191",
              "title": "Pirates Attack The Rhydonium"
            },
            {
              "num": "192",
              "title": "Mando Takes Off His Helmet For The Code"
            },
            {
              "num": "193",
              "title": "Dr. Pershing Is Captured"
            },
            {
              "num": "194",
              "title": "Mando Asks For Help On His Mission"
            },
            {
              "num": "195",
              "title": "Crash Landing On Moff Gideon's Cruiser"
            },
            {
              "num": "196",
              "title": "Stormtrooper Battle On The Bridge"
            },
            {
              "num": "197",
              "title": "Mando Beats Gideon & The Darksaber"
            },
            {
              "num": "198",
              "title": "Luke Skywalker Destroys The Dark Troopers"
            },
            {
              "num": "199",
              "title": "Grogu Meets Luke Skywalker & R2-D2"
            },
            {
              "num": "200",
              "title": "Mando Says Good-Bye To Grogu"
            }
          ]
        }
      ],
      "insert": [
        {
          "count": 15,
          "name": "MANDALORIAN CONCEPT ART",
          "meta": "ILM concept art from seasons 1–2 · Green /50 → SuperFractor 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "MCA-1",
              "title": "Doug Chiang, John Park",
              "meta": "Season 1, Episode 1"
            },
            {
              "num": "MCA-2",
              "title": "Doug Chiang",
              "meta": "Season 1, Episode 2"
            },
            {
              "num": "MCA-3",
              "title": "Brian Matyas",
              "meta": "Season 1, Episode 3"
            },
            {
              "num": "MCA-4",
              "title": "Christian Alzmann",
              "meta": "Season 1, Episode 4"
            },
            {
              "num": "MCA-5",
              "title": "Christian Alzmann",
              "meta": "Season 1, Episode 5"
            },
            {
              "num": "MCA-6",
              "title": "Doug Chiang",
              "meta": "Season 2, Episode 1"
            },
            {
              "num": "MCA-7",
              "title": "Brian Matyas",
              "meta": "Season 2, Episode 1"
            },
            {
              "num": "MCA-8",
              "title": "Christian Alzmann",
              "meta": "Season 2, Episode 2"
            },
            {
              "num": "MCA-9",
              "title": "Brian Matyas",
              "meta": "Season 2, Episode 3"
            },
            {
              "num": "MCA-10",
              "title": "Ryan Church",
              "meta": "Season 2, Episode 4"
            },
            {
              "num": "MCA-11",
              "title": "Christian Alzmann",
              "meta": "Season 2, Episode 5"
            },
            {
              "num": "MCA-12",
              "title": "Christian Alzmann",
              "meta": "Season 2, Episode 5"
            },
            {
              "num": "MCA-13",
              "title": "Ryan Church",
              "meta": "Season 2, Episode 6"
            },
            {
              "num": "MCA-14",
              "title": "Christian Alzmann",
              "meta": "Season 2, Episode 6"
            },
            {
              "num": "MCA-15",
              "title": "Brian Matyas",
              "meta": "Season 2, Episode 7"
            }
          ]
        },
        {
          "count": 20,
          "name": "WIELDERS OF THE LIGHTSABER",
          "meta": "Saber hands from Luke to the Seventh Sister · Green /50 → SuperFractor 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "WL-1",
              "title": "Luke Skywalker"
            },
            {
              "num": "WL-2",
              "title": "Anakin Skywalker"
            },
            {
              "num": "WL-3",
              "title": "Darth Vader"
            },
            {
              "num": "WL-4",
              "title": "Darth Sidious"
            },
            {
              "num": "WL-5",
              "title": "Darth Maul"
            },
            {
              "num": "WL-6",
              "title": "Count Dooku"
            },
            {
              "num": "WL-7",
              "title": "Kylo Ren"
            },
            {
              "num": "WL-8",
              "title": "Rey"
            },
            {
              "num": "WL-9",
              "title": "Finn"
            },
            {
              "num": "WL-10",
              "title": "Ahsoka Tano"
            },
            {
              "num": "WL-11",
              "title": "Kanan Jarrus"
            },
            {
              "num": "WL-12",
              "title": "Ezra Bridger"
            },
            {
              "num": "WL-13",
              "title": "Yoda"
            },
            {
              "num": "WL-14",
              "title": "Mace Windu"
            },
            {
              "num": "WL-15",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "WL-16",
              "title": "Qui-Gon Jinn"
            },
            {
              "num": "WL-17",
              "title": "General Grievous"
            },
            {
              "num": "WL-18",
              "title": "Kit Fisto"
            },
            {
              "num": "WL-19",
              "title": "The Grand Inquisitor"
            },
            {
              "num": "WL-20",
              "title": "Seventh Sister"
            }
          ]
        },
        {
          "count": 15,
          "name": "PROJECT KYOTO CONCEPT ART",
          "meta": "Star Wars: Visions under its working title · Green /50 → SuperFractor 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "SWV-1",
              "title": "The Duel"
            },
            {
              "num": "SWV-2",
              "title": "Lop & Ochō"
            },
            {
              "num": "SWV-3",
              "title": "Lop & Ochō"
            },
            {
              "num": "SWV-4",
              "title": "The Duel"
            },
            {
              "num": "SWV-5",
              "title": "The Duel"
            },
            {
              "num": "SWV-6",
              "title": "The Duel"
            },
            {
              "num": "SWV-7",
              "title": "Tatooine Rhapsody"
            },
            {
              "num": "SWV-8",
              "title": "Tatooine Rhapsody"
            },
            {
              "num": "SWV-9",
              "title": "The Ninth Jedi"
            },
            {
              "num": "SWV-10",
              "title": "Tatooine Rhapsody"
            },
            {
              "num": "SWV-11",
              "title": "Tatooine Rhapsody"
            },
            {
              "num": "SWV-12",
              "title": "The Ninth Jedi"
            },
            {
              "num": "SWV-13",
              "title": "Lop & Ochō"
            },
            {
              "num": "SWV-14",
              "title": "Tatooine Rhapsody"
            },
            {
              "num": "SWV-15",
              "title": "T0-B1"
            }
          ]
        },
        {
          "count": 40,
          "name": "COMMEMORATIVE SHIP MEDALLION CARDS",
          "meta": "Ship medallions · every card serial /99 → SuperFractor 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "SM-GE",
              "title": "Galen Erso"
            },
            {
              "num": "SM-DK",
              "title": "Director Krennic"
            },
            {
              "num": "SM-JE",
              "title": "Jyn Erso"
            },
            {
              "num": "SM-BR",
              "title": "Bodhi Rook"
            },
            {
              "num": "SM-SG",
              "title": "Saw Gerrera"
            },
            {
              "num": "SM-CA",
              "title": "Captain Cassian Andor"
            },
            {
              "num": "SM-K2",
              "title": "K-2SO"
            },
            {
              "num": "SM-CI",
              "title": "Chirrut Îmwe"
            },
            {
              "num": "SM-BM",
              "title": "Baze Malbus"
            },
            {
              "num": "SM-MT",
              "title": "Grand Moff Tarkin"
            },
            {
              "num": "SM-DV",
              "title": "Darth Vader"
            },
            {
              "num": "SM-HS",
              "title": "Han Solo"
            },
            {
              "num": "SM-LS",
              "title": "Luke Skywalker"
            },
            {
              "num": "SM-LO",
              "title": "Princess Leia Organa"
            },
            {
              "num": "SM-C3",
              "title": "C-3PO"
            },
            {
              "num": "SM-C",
              "title": "Chewbacca"
            },
            {
              "num": "SM-R2",
              "title": "R2-D2"
            },
            {
              "num": "SM-LC",
              "title": "Lando Calrissian"
            },
            {
              "num": "SM-DVD",
              "title": "Darth Vader"
            },
            {
              "num": "SM-SD",
              "title": "Stormtrooper"
            },
            {
              "num": "SM-GVD",
              "title": "General Veers"
            },
            {
              "num": "SM-DVT",
              "title": "Darth Vader"
            },
            {
              "num": "SM-JVT",
              "title": "Jon \"Dutch\" Vander"
            },
            {
              "num": "SM-LST",
              "title": "Luke Skywalker"
            },
            {
              "num": "SM-BKT",
              "title": "Biggs Darklighter"
            },
            {
              "num": "SM-WAT",
              "title": "Wedge Antilles"
            },
            {
              "num": "SM-TIE",
              "title": "TIE Fighter Pilot"
            },
            {
              "num": "SM-KRT",
              "title": "Kylo Ren"
            },
            {
              "num": "SM-PDT",
              "title": "Poe Dameron"
            },
            {
              "num": "SM-FT",
              "title": "Finn"
            },
            {
              "num": "SM-RT",
              "title": "Rey"
            },
            {
              "num": "SM-BBT",
              "title": "BB-8"
            },
            {
              "num": "SM-LSX",
              "title": "Luke Skywalker"
            },
            {
              "num": "SM-PDX",
              "title": "Poe Dameron"
            },
            {
              "num": "SM-WAX",
              "title": "Wedge Antilles"
            },
            {
              "num": "SM-JPX",
              "title": "Jess \"Testor\" Pava"
            },
            {
              "num": "SM-SWX",
              "title": "Snap Wexley"
            },
            {
              "num": "SM-NNX",
              "title": "Nien Nunb"
            },
            {
              "num": "SM-EAX",
              "title": "Ello Asty"
            },
            {
              "num": "SM-TLX",
              "title": "Tallie Lintra"
            }
          ]
        }
      ],
      "auto": [
        {
          "count": 10,
          "name": "AGE OF REPUBLIC AUTOGRAPHS",
          "meta": "Prequel-era signers · Blue /99 → SuperFractor 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "ARP-AB",
              "title": "Ahmed Best"
            },
            {
              "num": "ARP-AE",
              "title": "Ashley Eckstein"
            },
            {
              "num": "ARP-DL",
              "title": "Daniel Logan"
            },
            {
              "num": "ARP-DT",
              "title": "David Tennant"
            },
            {
              "num": "ARP-EM",
              "title": "Ewan McGregor"
            },
            {
              "num": "ARP-HC",
              "title": "Hayden Christensen"
            },
            {
              "num": "ARP-JAT",
              "title": "James Arnold Taylor"
            },
            {
              "num": "ARP-LM",
              "title": "Lewis Macleod"
            },
            {
              "num": "ARP-RP",
              "title": "Ron Perlman"
            },
            {
              "num": "ARP-SLJ",
              "title": "Samuel L. Jackson"
            }
          ]
        },
        {
          "count": 25,
          "name": "AGE OF REBELLION AUTOGRAPHS",
          "meta": "Original-trilogy era signers · Blue /99 → SuperFractor 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "ARB-JM",
              "title": "John Morton"
            },
            {
              "num": "ARB-PR",
              "title": "Pam Rose"
            },
            {
              "num": "ARB-MB",
              "title": "Mark Boone Jr."
            },
            {
              "num": "ARB-MP",
              "title": "Michael Pennington"
            },
            {
              "num": "ARB-DC",
              "title": "Dermot Crowley"
            },
            {
              "num": "ARB-MQ",
              "title": "Mike Quinn"
            },
            {
              "num": "ARB-JB",
              "title": "Jeremy Bulloch"
            },
            {
              "num": "ARB-GE",
              "title": "Giancarlo Esposito"
            },
            {
              "num": "ARB-MC",
              "title": "Michael Carter"
            },
            {
              "num": "ARB-PM",
              "title": "Peter Mayhew"
            },
            {
              "num": "ARB-AT",
              "title": "Alan Tudyk"
            },
            {
              "num": "ARB-KB",
              "title": "Ben Burtt"
            },
            {
              "num": "ARB-BM",
              "title": "Ben Mendelsohn"
            },
            {
              "num": "ARB-DY",
              "title": "Donnie Yen"
            },
            {
              "num": "ARB-RA",
              "title": "Riz Ahmed"
            },
            {
              "num": "ARB-MM",
              "title": "Mads Mikkelsen"
            },
            {
              "num": "ARB-NN",
              "title": "Nick Nolte"
            },
            {
              "num": "ARB-RD",
              "title": "Rosario Dawson"
            },
            {
              "num": "ARB-TW",
              "title": "Taika Waititi"
            },
            {
              "num": "ARB-IM",
              "title": "Ian McDiarmid"
            },
            {
              "num": "ARB-FW",
              "title": "Forest Whitaker"
            },
            {
              "num": "ARB-WH",
              "title": "Werner Herzog"
            },
            {
              "num": "ARB-BDW",
              "title": "Billy Dee Williams"
            },
            {
              "num": "ARB-FJ",
              "title": "Felicity Jones"
            },
            {
              "num": "ARB-HF",
              "title": "Harrison Ford"
            }
          ]
        },
        {
          "count": 18,
          "name": "AGE OF RESISTANCE AUTOGRAPHS",
          "meta": "Sequel-era signers · Blue /99 → SuperFractor 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "ARS-EE",
              "title": "Emun Elliott"
            },
            {
              "num": "ARS-DC",
              "title": "Dave Chapman"
            },
            {
              "num": "ARS-TW",
              "title": "Tom Wilton"
            },
            {
              "num": "ARS-MQ",
              "title": "Mike Quinn"
            },
            {
              "num": "ARS-KL",
              "title": "Ken Leung"
            },
            {
              "num": "ARS-GG",
              "title": "Greg Grunberg"
            },
            {
              "num": "ARS-JB",
              "title": "John Boyega"
            },
            {
              "num": "ARS-NA",
              "title": "Naomi Ackie"
            },
            {
              "num": "ARS-DM",
              "title": "Dominic Monaghan"
            },
            {
              "num": "ARS-AS",
              "title": "Andy Serkis"
            },
            {
              "num": "ARS-KB",
              "title": "Kenny Baker"
            },
            {
              "num": "ARS-BDW",
              "title": "Billy Dee Williams"
            },
            {
              "num": "ARS-GC",
              "title": "Gwendoline Christie"
            },
            {
              "num": "ARS-CF",
              "title": "Carrie Fisher"
            },
            {
              "num": "ARS-AD",
              "title": "Adam Driver"
            },
            {
              "num": "ARS-DG",
              "title": "Domhnall Gleeson"
            },
            {
              "num": "ARS-DR",
              "title": "Daisy Ridley"
            },
            {
              "num": "ARS-HF",
              "title": "Harrison Ford"
            }
          ]
        },
        {
          "count": 5,
          "name": "DUAL AUTOGRAPHS",
          "meta": "5 pairings · serial numbered /25 or less",
          "noParallels": true,
          "cards": [
            {
              "num": "DA-BA",
              "title": "John Boyega / Naomi Ackie"
            },
            {
              "num": "DA-FR",
              "title": "Carrie Fisher / Daisy Ridley"
            },
            {
              "num": "DA-FM",
              "title": "Harrison Ford / Peter Mayhew"
            },
            {
              "num": "DA-MJ",
              "title": "Ewan McGregor / Samuel L. Jackson"
            },
            {
              "num": "DA-RQ",
              "title": "Deep Roy / Mike Quinn"
            }
          ]
        }
      ],
      "sketch": [
        {
          "count": 139,
          "name": "SKETCH CARDS",
          "meta": "139-artist roster · standard & shaped formats · every card a 1/1",
          "oneOfOne": true,
          "noParallels": true,
          "cards": [
            {
              "num": "1",
              "title": "Sketch Card",
              "meta": "Adam Beck"
            },
            {
              "num": "2",
              "title": "Sketch Card",
              "meta": "Adam Worton"
            },
            {
              "num": "3",
              "title": "Sketch Card",
              "meta": "Alex Mines"
            },
            {
              "num": "4",
              "title": "Sketch Card",
              "meta": "Alexander Connell"
            },
            {
              "num": "5",
              "title": "Sketch Card",
              "meta": "Allen Grimes"
            },
            {
              "num": "6",
              "title": "Sketch Card",
              "meta": "Andrew Fry"
            },
            {
              "num": "7",
              "title": "Sketch Card",
              "meta": "Andrew Perkins"
            },
            {
              "num": "8",
              "title": "Sketch Card",
              "meta": "Andrew Sanchez"
            },
            {
              "num": "9",
              "title": "Sketch Card",
              "meta": "Angel Aviles"
            },
            {
              "num": "10",
              "title": "Sketch Card",
              "meta": "Angelina Benedetti"
            },
            {
              "num": "11",
              "title": "Sketch Card",
              "meta": "Anil Sharma"
            },
            {
              "num": "12",
              "title": "Sketch Card",
              "meta": "Antni Ellison"
            },
            {
              "num": "13",
              "title": "Sketch Card",
              "meta": "Ashlee Brienzo"
            },
            {
              "num": "14",
              "title": "Sketch Card",
              "meta": "Ashley Marsh"
            },
            {
              "num": "15",
              "title": "Sketch Card",
              "meta": "Barry Renshaw"
            },
            {
              "num": "16",
              "title": "Sketch Card",
              "meta": "Başak Çetinkaya"
            },
            {
              "num": "17",
              "title": "Sketch Card",
              "meta": "Benjamin Lombart"
            },
            {
              "num": "18",
              "title": "Sketch Card",
              "meta": "Bob Stevlic"
            },
            {
              "num": "19",
              "title": "Sketch Card",
              "meta": "Bobby Blakey"
            },
            {
              "num": "20",
              "title": "Sketch Card",
              "meta": "Brad Hudson"
            },
            {
              "num": "21",
              "title": "Sketch Card",
              "meta": "Brandon Blevins"
            },
            {
              "num": "22",
              "title": "Sketch Card",
              "meta": "Brent Ragland"
            },
            {
              "num": "23",
              "title": "Sketch Card",
              "meta": "Brent Scotchmer"
            },
            {
              "num": "24",
              "title": "Sketch Card",
              "meta": "Brett Farr"
            },
            {
              "num": "25",
              "title": "Sketch Card",
              "meta": "Candice Dailey"
            },
            {
              "num": "26",
              "title": "Sketch Card",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "27",
              "title": "Sketch Card",
              "meta": "Carolyn Craggs"
            },
            {
              "num": "28",
              "title": "Sketch Card",
              "meta": "Chris Colyer"
            },
            {
              "num": "29",
              "title": "Sketch Card",
              "meta": "Chris Kay"
            },
            {
              "num": "30",
              "title": "Sketch Card",
              "meta": "Cyrus Sherkat"
            },
            {
              "num": "31",
              "title": "Sketch Card",
              "meta": "Dan Gorman"
            },
            {
              "num": "32",
              "title": "Sketch Card",
              "meta": "Dan Lawler"
            },
            {
              "num": "33",
              "title": "Sketch Card",
              "meta": "Dan Tearle"
            },
            {
              "num": "34",
              "title": "Sketch Card",
              "meta": "Daniel Riveron"
            },
            {
              "num": "35",
              "title": "Sketch Card",
              "meta": "Darren James"
            },
            {
              "num": "36",
              "title": "Sketch Card",
              "meta": "Darrin Pepe"
            },
            {
              "num": "37",
              "title": "Sketch Card",
              "meta": "Dave Fowler"
            },
            {
              "num": "38",
              "title": "Sketch Card",
              "meta": "Dawn Murphy"
            },
            {
              "num": "39",
              "title": "Sketch Card",
              "meta": "Dean Drummond"
            },
            {
              "num": "40",
              "title": "Sketch Card",
              "meta": "Don Pedicini Jr."
            },
            {
              "num": "41",
              "title": "Sketch Card",
              "meta": "Dwayne Carpenter"
            },
            {
              "num": "42",
              "title": "Sketch Card",
              "meta": "Eric Lehtonen"
            },
            {
              "num": "43",
              "title": "Sketch Card",
              "meta": "Erik Maell"
            },
            {
              "num": "44",
              "title": "Sketch Card",
              "meta": "Francisco Rivera"
            },
            {
              "num": "45",
              "title": "Sketch Card",
              "meta": "Frank Kader"
            },
            {
              "num": "46",
              "title": "Sketch Card",
              "meta": "Frank Sansone"
            },
            {
              "num": "47",
              "title": "Sketch Card",
              "meta": "Gabe Farber"
            },
            {
              "num": "48",
              "title": "Sketch Card",
              "meta": "Garrett Dix"
            },
            {
              "num": "49",
              "title": "Sketch Card",
              "meta": "Gavin Williams"
            },
            {
              "num": "50",
              "title": "Sketch Card",
              "meta": "Gerard Garcia Jr."
            },
            {
              "num": "51",
              "title": "Sketch Card",
              "meta": "Gorkem Demir"
            },
            {
              "num": "52",
              "title": "Sketch Card",
              "meta": "Huy Truong"
            },
            {
              "num": "53",
              "title": "Sketch Card",
              "meta": "Ingrid Hardy"
            },
            {
              "num": "54",
              "title": "Sketch Card",
              "meta": "Jake Minor"
            },
            {
              "num": "55",
              "title": "Sketch Card",
              "meta": "Jamie Cosley"
            },
            {
              "num": "56",
              "title": "Sketch Card",
              "meta": "Jamie Murdock"
            },
            {
              "num": "57",
              "title": "Sketch Card",
              "meta": "Jamie Richards"
            },
            {
              "num": "58",
              "title": "Sketch Card",
              "meta": "Jason Adams"
            },
            {
              "num": "59",
              "title": "Sketch Card",
              "meta": "Jason Davies"
            },
            {
              "num": "60",
              "title": "Sketch Card",
              "meta": "Jason Montoya"
            },
            {
              "num": "61",
              "title": "Sketch Card",
              "meta": "Jason Queen"
            },
            {
              "num": "62",
              "title": "Sketch Card",
              "meta": "Jason Sobol"
            },
            {
              "num": "63",
              "title": "Sketch Card",
              "meta": "Jay Manchand"
            },
            {
              "num": "64",
              "title": "Sketch Card",
              "meta": "Jeff Abar"
            },
            {
              "num": "65",
              "title": "Sketch Card",
              "meta": "Jerold Bahr"
            },
            {
              "num": "66",
              "title": "Sketch Card",
              "meta": "Jessica Hickman"
            },
            {
              "num": "67",
              "title": "Sketch Card",
              "meta": "Jim Dickson"
            },
            {
              "num": "68",
              "title": "Sketch Card",
              "meta": "Jim Mehsling"
            },
            {
              "num": "69",
              "title": "Sketch Card",
              "meta": "JM Smith"
            },
            {
              "num": "70",
              "title": "Sketch Card",
              "meta": "Joe Corroney"
            },
            {
              "num": "71",
              "title": "Sketch Card",
              "meta": "John Bruce"
            },
            {
              "num": "72",
              "title": "Sketch Card",
              "meta": "John Pleak"
            },
            {
              "num": "73",
              "title": "Sketch Card",
              "meta": "Jonathan Beistline"
            },
            {
              "num": "74",
              "title": "Sketch Card",
              "meta": "Jonty Gates"
            },
            {
              "num": "75",
              "title": "Sketch Card",
              "meta": "Joshua Caleb King"
            },
            {
              "num": "76",
              "title": "Sketch Card",
              "meta": "Jude Gallagher"
            },
            {
              "num": "77",
              "title": "Sketch Card",
              "meta": "Karl Jones"
            },
            {
              "num": "78",
              "title": "Sketch Card",
              "meta": "Keith Farnum"
            },
            {
              "num": "79",
              "title": "Sketch Card",
              "meta": "Kelly Baber"
            },
            {
              "num": "80",
              "title": "Sketch Card",
              "meta": "Kevin Cleveland"
            },
            {
              "num": "81",
              "title": "Sketch Card",
              "meta": "Kevin Graham"
            },
            {
              "num": "82",
              "title": "Sketch Card",
              "meta": "Kevin P. West"
            },
            {
              "num": "83",
              "title": "Sketch Card",
              "meta": "Kursat Cetiner"
            },
            {
              "num": "84",
              "title": "Sketch Card",
              "meta": "Lindsey Greyling"
            },
            {
              "num": "85",
              "title": "Sketch Card",
              "meta": "Logan Monette"
            },
            {
              "num": "86",
              "title": "Sketch Card",
              "meta": "Lucas Peverill"
            },
            {
              "num": "87",
              "title": "Sketch Card",
              "meta": "Madison Emerick"
            },
            {
              "num": "88",
              "title": "Sketch Card",
              "meta": "Maggie Ransom"
            },
            {
              "num": "89",
              "title": "Sketch Card",
              "meta": "Marcia Dye"
            },
            {
              "num": "90",
              "title": "Sketch Card",
              "meta": "Mark Necchi"
            },
            {
              "num": "91",
              "title": "Sketch Card",
              "meta": "Marlo Agunos"
            },
            {
              "num": "92",
              "title": "Sketch Card",
              "meta": "Marsha Parkins"
            },
            {
              "num": "93",
              "title": "Sketch Card",
              "meta": "Matt Stewart"
            },
            {
              "num": "94",
              "title": "Sketch Card",
              "meta": "Matthew Hirons"
            },
            {
              "num": "95",
              "title": "Sketch Card",
              "meta": "Matthew Sutton"
            },
            {
              "num": "96",
              "title": "Sketch Card",
              "meta": "Mayumi Seto"
            },
            {
              "num": "97",
              "title": "Sketch Card",
              "meta": "Michael Mastermaker"
            },
            {
              "num": "98",
              "title": "Sketch Card",
              "meta": "Michael Munshaw"
            },
            {
              "num": "99",
              "title": "Sketch Card",
              "meta": "Michelle Rayner"
            },
            {
              "num": "100",
              "title": "Sketch Card",
              "meta": "Mick and Matt Glebe"
            },
            {
              "num": "101",
              "title": "Sketch Card",
              "meta": "Mike Stephens"
            },
            {
              "num": "102",
              "title": "Sketch Card",
              "meta": "Mohammad Jilani"
            },
            {
              "num": "103",
              "title": "Sketch Card",
              "meta": "Neil Camera"
            },
            {
              "num": "104",
              "title": "Sketch Card",
              "meta": "Nick Allsopp"
            },
            {
              "num": "105",
              "title": "Sketch Card",
              "meta": "Nick Gribbon"
            },
            {
              "num": "106",
              "title": "Sketch Card",
              "meta": "Norviento Basio"
            },
            {
              "num": "107",
              "title": "Sketch Card",
              "meta": "Oscar Chavez"
            },
            {
              "num": "108",
              "title": "Sketch Card",
              "meta": "Patricio Carrasco"
            },
            {
              "num": "109",
              "title": "Sketch Card",
              "meta": "Patrick Giles"
            },
            {
              "num": "110",
              "title": "Sketch Card",
              "meta": "Paul Maitland"
            },
            {
              "num": "111",
              "title": "Sketch Card",
              "meta": "Paul Shiers"
            },
            {
              "num": "112",
              "title": "Sketch Card",
              "meta": "Phillip Trujillo"
            },
            {
              "num": "113",
              "title": "Sketch Card",
              "meta": "Rees Finlay"
            },
            {
              "num": "114",
              "title": "Sketch Card",
              "meta": "Rich Hennemann"
            },
            {
              "num": "115",
              "title": "Sketch Card",
              "meta": "Rich Molinelli"
            },
            {
              "num": "116",
              "title": "Sketch Card",
              "meta": "RJ Tomascik"
            },
            {
              "num": "117",
              "title": "Sketch Card",
              "meta": "Rob Teranishi"
            },
            {
              "num": "118",
              "title": "Sketch Card",
              "meta": "Robert Garcia"
            },
            {
              "num": "119",
              "title": "Sketch Card",
              "meta": "Robert Hendrickson"
            },
            {
              "num": "120",
              "title": "Sketch Card",
              "meta": "Rodney Roberts"
            },
            {
              "num": "121",
              "title": "Sketch Card",
              "meta": "Rutvig Vaid"
            },
            {
              "num": "122",
              "title": "Sketch Card",
              "meta": "Ryan Finley"
            },
            {
              "num": "123",
              "title": "Sketch Card",
              "meta": "Ryan Santos"
            },
            {
              "num": "124",
              "title": "Sketch Card",
              "meta": "Sammy Gomez"
            },
            {
              "num": "125",
              "title": "Sketch Card",
              "meta": "Scott Robinson"
            },
            {
              "num": "126",
              "title": "Sketch Card",
              "meta": "Semra Bulut"
            },
            {
              "num": "127",
              "title": "Sketch Card",
              "meta": "Seth Groves"
            },
            {
              "num": "128",
              "title": "Sketch Card",
              "meta": "Shaow Siong"
            },
            {
              "num": "129",
              "title": "Sketch Card",
              "meta": "Solly Mohamed"
            },
            {
              "num": "130",
              "title": "Sketch Card",
              "meta": "Steve Alce"
            },
            {
              "num": "131",
              "title": "Sketch Card",
              "meta": "Thomas Amici"
            },
            {
              "num": "132",
              "title": "Sketch Card",
              "meta": "Tim Shinn"
            },
            {
              "num": "133",
              "title": "Sketch Card",
              "meta": "Tina Berardi"
            },
            {
              "num": "134",
              "title": "Sketch Card",
              "meta": "Trent Westbrook"
            },
            {
              "num": "135",
              "title": "Sketch Card",
              "meta": "Veronica Smith"
            },
            {
              "num": "136",
              "title": "Sketch Card",
              "meta": "Vincenzo D'Ippolito"
            },
            {
              "num": "137",
              "title": "Sketch Card",
              "meta": "Ward Silverman"
            },
            {
              "num": "138",
              "title": "Sketch Card",
              "meta": "Wayne Tully"
            },
            {
              "num": "139",
              "title": "Sketch Card",
              "meta": "Zach Woolsey"
            }
          ]
        }
      ]
    }
  },
  '2021-masterwork': {
    "setId": "2021-masterwork",
    "year": "2021",
    "brand": "TOPPS",
    "title": "STAR WARS MASTERWORK",
    "releaseDate": "4 / 8 / 2022",
    "lede": "The Masterwork that marked Lucasfilm’s 50th anniversary — delayed a full year into April 2022 — keeps the line’s ultra-premium formula: 100 characters on 72-point stock under an eight-step Blue-to-Gold ladder, and three insert lines — the anniversary retrospective, Out of the Box, and Welcome to the Dark Side’s villain quotes — each carrying Metal /5 and one-of-one Gold Metal variations. The hits run deep: character medallions, jumbo sourced costume relics, postage-stamp cards, a 52-signer on-card autograph program, fifteen dual autographs /50, six triples /25, and four quad autograph books with two copies each — plus one-of-one pen relic autographs from 43 signers and the single 20-signer Galactic Autograph Book, with Harrison Ford, Carrie Fisher, David Prowse, Ewan McGregor, and Adam Driver in one binding.",
    "stats": [
      {
        "num": "100",
        "label": "Base Cards",
        "sub": "72-point stock",
        "color": "gold"
      },
      {
        "num": "12",
        "label": "Insert Sets",
        "sub": "Incl. relics, medallions & stamps",
        "color": "cyan"
      },
      {
        "num": "121",
        "label": "Auto Cards",
        "sub": "6 autograph sub-sets",
        "color": "green"
      },
      {
        "num": "8",
        "label": "Base Parallels",
        "sub": "Blue → Gold 1/1",
        "color": "purple"
      },
      {
        "num": "19",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "4",
        "l": "Mini boxes per box"
      },
      {
        "v": "5",
        "l": "Cards per mini box"
      },
      {
        "v": "8",
        "l": "Boxes per case"
      },
      {
        "v": "4",
        "l": "Hits per box"
      },
      {
        "v": "2",
        "l": "Autographs per box · 1 on-card guaranteed"
      }
    ],
    "pullRates": [
      {
        "name": "Autographs",
        "odds": "2 per box",
        "tier": "normal"
      },
      {
        "name": "Premium Hits",
        "odds": "2 per box",
        "tier": "normal"
      },
      {
        "name": "Base Parallels · Inserts",
        "odds": "1 each per mini-box",
        "tier": "normal"
      },
      {
        "name": "Quad Autograph Books",
        "odds": "2 copies each",
        "tier": "mythic"
      },
      {
        "name": "Galactic Autograph Book · 20 signers",
        "odds": "1 of 1",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "BLUE",
        "pr": "∞",
        "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/99",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "PURPLE",
        "pr": "/50",
        "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
      },
      {
        "name": "RED",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      },
      {
        "name": "ORANGE",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      },
      {
        "name": "BLACK",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "PRINTING PLATES",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #c0c0c8 0%, #707078 100%)",
        "darkText": true
      },
      {
        "name": "GOLD",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)",
        "darkText": true
      }
    ],
    "artists": [],
    "subsets": {
      "base": [
        {
          "count": 100,
          "name": "BASE CARDS",
          "meta": "Characters from every era on 72-point stock · Blue → Gold 1/1",
          "parallels": 8,
          "cards": [
            {
              "num": "1",
              "title": "Aayla Secura"
            },
            {
              "num": "2",
              "title": "Admiral Ackbar"
            },
            {
              "num": "3",
              "title": "Admiral Holdo"
            },
            {
              "num": "4",
              "title": "Ahsoka Tano"
            },
            {
              "num": "5",
              "title": "Allegiant General Pryde"
            },
            {
              "num": "6",
              "title": "Anakin Skywalker"
            },
            {
              "num": "7",
              "title": "Asajj Ventress"
            },
            {
              "num": "8",
              "title": "Aurra Sing"
            },
            {
              "num": "9",
              "title": "Bantha"
            },
            {
              "num": "10",
              "title": "Baze Malbus"
            },
            {
              "num": "11",
              "title": "BB-8"
            },
            {
              "num": "12",
              "title": "Beckett"
            },
            {
              "num": "13",
              "title": "Bib Fortuna"
            },
            {
              "num": "14",
              "title": "Burg"
            },
            {
              "num": "15",
              "title": "Boba Fett"
            },
            {
              "num": "16",
              "title": "Bodhi Rook"
            },
            {
              "num": "17",
              "title": "Bo-Katan Kryze"
            },
            {
              "num": "18",
              "title": "Boss Nass"
            },
            {
              "num": "19",
              "title": "Bossk"
            },
            {
              "num": "20",
              "title": "C-3PO"
            },
            {
              "num": "21",
              "title": "Cad Bane"
            },
            {
              "num": "22",
              "title": "Captain Phasma"
            },
            {
              "num": "23",
              "title": "Captain Cassian Andor"
            },
            {
              "num": "24",
              "title": "Chewbacca"
            },
            {
              "num": "25",
              "title": "Chirrut Imwe"
            },
            {
              "num": "26",
              "title": "Cobb Vanth"
            },
            {
              "num": "27",
              "title": "Count Dooku"
            },
            {
              "num": "28",
              "title": "Darth Maul"
            },
            {
              "num": "29",
              "title": "Darth Vader"
            },
            {
              "num": "30",
              "title": "Dewback"
            },
            {
              "num": "31",
              "title": "Dryden Vos"
            },
            {
              "num": "32",
              "title": "Emperor Palpatine"
            },
            {
              "num": "33",
              "title": "Enfys Nest"
            },
            {
              "num": "34",
              "title": "Ezra Bridger"
            },
            {
              "num": "35",
              "title": "Fennec Shand"
            },
            {
              "num": "36",
              "title": "Finn"
            },
            {
              "num": "37",
              "title": "Frog Lady"
            },
            {
              "num": "38",
              "title": "Galen Erso"
            },
            {
              "num": "39",
              "title": "General Grievous"
            },
            {
              "num": "40",
              "title": "General Hux"
            },
            {
              "num": "41",
              "title": "Grand Admiral Thrawn"
            },
            {
              "num": "42",
              "title": "Grand Moff Tarkin"
            },
            {
              "num": "43",
              "title": "Greedo"
            },
            {
              "num": "44",
              "title": "Greef Karga"
            },
            {
              "num": "45",
              "title": "Grogu"
            },
            {
              "num": "46",
              "title": "Han Solo"
            },
            {
              "num": "47",
              "title": "Hera Syndulla"
            },
            {
              "num": "48",
              "title": "IG-11"
            },
            {
              "num": "49",
              "title": "IG-88"
            },
            {
              "num": "50",
              "title": "Jabba The Hutt"
            },
            {
              "num": "51",
              "title": "Jango Fett"
            },
            {
              "num": "52",
              "title": "Jannah"
            },
            {
              "num": "53",
              "title": "Jar Jar Binks"
            },
            {
              "num": "54",
              "title": "Jedi Master Mace Windu"
            },
            {
              "num": "55",
              "title": "Jedi Master Yoda"
            },
            {
              "num": "56",
              "title": "Jyn Erso"
            },
            {
              "num": "57",
              "title": "K-2SO"
            },
            {
              "num": "58",
              "title": "Kaadu"
            },
            {
              "num": "59",
              "title": "Kanan Jarrus"
            },
            {
              "num": "60",
              "title": "Kit Fisto"
            },
            {
              "num": "61",
              "title": "Trudgen"
            },
            {
              "num": "62",
              "title": "Krayt Dragon"
            },
            {
              "num": "63",
              "title": "Kuiil"
            },
            {
              "num": "64",
              "title": "Kylo Ren"
            },
            {
              "num": "65",
              "title": "L3-37"
            },
            {
              "num": "66",
              "title": "Lady Proxima"
            },
            {
              "num": "67",
              "title": "Lando Calrissian"
            },
            {
              "num": "68",
              "title": "Lieutenant Connix"
            },
            {
              "num": "69",
              "title": "Luke Skywalker"
            },
            {
              "num": "70",
              "title": "Mandalorian"
            },
            {
              "num": "71",
              "title": "Maz Kanata"
            },
            {
              "num": "72",
              "title": "Moff Gideon"
            },
            {
              "num": "73",
              "title": "Mon Mothma"
            },
            {
              "num": "74",
              "title": "Koska Reeves"
            },
            {
              "num": "75",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "76",
              "title": "Orson Krennic"
            },
            {
              "num": "77",
              "title": "Padmé Amidala"
            },
            {
              "num": "78",
              "title": "Poe Dameron"
            },
            {
              "num": "79",
              "title": "Princess Leia Organa"
            },
            {
              "num": "80",
              "title": "Mayfeld"
            },
            {
              "num": "81",
              "title": "Qi'ra"
            },
            {
              "num": "82",
              "title": "Qui-Gon Jinn"
            },
            {
              "num": "83",
              "title": "R2-D2"
            },
            {
              "num": "84",
              "title": "Rey"
            },
            {
              "num": "85",
              "title": "Rose Tico"
            },
            {
              "num": "86",
              "title": "Sabine Wren"
            },
            {
              "num": "87",
              "title": "Gor Koresh"
            },
            {
              "num": "88",
              "title": "Satine Kryze"
            },
            {
              "num": "89",
              "title": "Saw Guerrera"
            },
            {
              "num": "90",
              "title": "Sebulba"
            },
            {
              "num": "91",
              "title": "Senator Bail Organa"
            },
            {
              "num": "92",
              "title": "Shmi Skywalker"
            },
            {
              "num": "93",
              "title": "Supreme Leader Snoke"
            },
            {
              "num": "94",
              "title": "Tauntaun"
            },
            {
              "num": "95",
              "title": "The Rancor"
            },
            {
              "num": "96",
              "title": "Varactyl"
            },
            {
              "num": "97",
              "title": "Watto"
            },
            {
              "num": "98",
              "title": "Wedge Antilles"
            },
            {
              "num": "99",
              "title": "Zam Wesell"
            },
            {
              "num": "100",
              "title": "Zorii Bliss"
            }
          ]
        }
      ],
      "insert": [
        {
          "count": 20,
          "name": "MANUFACTURED CHARACTER MEDALLION CARDS",
          "meta": "Character medallions · Green /99 → Gold 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "CM-C3C",
              "title": "C-3PO"
            },
            {
              "num": "CM-C3R",
              "title": "C-3PO"
            },
            {
              "num": "CM-CC",
              "title": "Chewbacca"
            },
            {
              "num": "CM-CR",
              "title": "Chewbacca"
            },
            {
              "num": "CM-JR",
              "title": "Jawa"
            },
            {
              "num": "CM-LC",
              "title": "Luke Skywalker"
            },
            {
              "num": "CM-LOR",
              "title": "Princess Leia Organa"
            },
            {
              "num": "CM-LR",
              "title": "Luke Skywalker"
            },
            {
              "num": "CM-LS",
              "title": "Luke Skywalker"
            },
            {
              "num": "CM-LV",
              "title": "Luke Skywalker"
            },
            {
              "num": "CM-OV",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "CM-PLC",
              "title": "Princess Leia Organa"
            },
            {
              "num": "CM-PLV",
              "title": "Princess Leia Organa"
            },
            {
              "num": "CM-RC",
              "title": "R2-D2"
            },
            {
              "num": "CM-RR",
              "title": "R2-D2"
            },
            {
              "num": "CM-SS",
              "title": "Stormtrooper"
            },
            {
              "num": "CM-SV",
              "title": "Stormtrooper"
            },
            {
              "num": "CM-VS",
              "title": "Darth Vader"
            },
            {
              "num": "CM-VV",
              "title": "Darth Vader"
            },
            {
              "num": "CM-WC",
              "title": "Wicket W. Warrick"
            }
          ]
        },
        {
          "count": 17,
          "name": "JUMBO COSTUME RELICS",
          "meta": "Jumbo sourced costume swatches · Purple /25 → Gold 1/1",
          "parallels": 4,
          "cards": [
            {
              "num": "JCR-AT",
              "title": "Ahsoka Tano Shirt Lining"
            },
            {
              "num": "JCR-BE",
              "title": "Tobias Beckett Trench Coat"
            },
            {
              "num": "JCR-BF",
              "title": "Boba Fett Pants"
            },
            {
              "num": "JCR-BR",
              "title": "Bodhi Rook Imperial Jumpsuit"
            },
            {
              "num": "JCR-FN",
              "title": "Finn Imperial Disguise Tunic"
            },
            {
              "num": "JCR-GE",
              "title": "Galen Erso Farmer Disguise Jacket"
            },
            {
              "num": "JCR-GG",
              "title": "Gamorrean Fighter Leather Shirt"
            },
            {
              "num": "JCR-GM",
              "title": "General Merrick Mae West Jacket"
            },
            {
              "num": "JCR-JE",
              "title": "Jyn Erso Poncho"
            },
            {
              "num": "JCR-LS",
              "title": "Luke Skywalker Battle Tunic"
            },
            {
              "num": "JCR-LU",
              "title": "Luke Skywalker Pants"
            },
            {
              "num": "JCR-MC",
              "title": "The Mandalorian Cloak"
            },
            {
              "num": "JCR-PD",
              "title": "Poe Dameron Jacket"
            },
            {
              "num": "JCR-PO",
              "title": "Poe Dameron Shirt"
            },
            {
              "num": "JCR-QI",
              "title": "Qi'ra Leggings"
            },
            {
              "num": "JCR-RE",
              "title": "Rey Jacket"
            },
            {
              "num": "JCR-TMA",
              "title": "The Mandalorian Vest"
            }
          ]
        },
        {
          "count": 14,
          "name": "LUCASFILM 50TH ANNIVERSARY",
          "meta": "50 years of Lucasfilm, card by card · Rainbow Foil /299 → Printing Plates 1/1",
          "parallels": 4,
          "cards": [
            {
              "num": "LFA-1",
              "title": "George Lucas creates Lucasfilm"
            },
            {
              "num": "LFA-2",
              "title": "Star Wars: A New Hope"
            },
            {
              "num": "LFA-3",
              "title": "Star Wars: The Empire Strikes Back"
            },
            {
              "num": "LFA-4",
              "title": "Star Wars: Return of the Jedi"
            },
            {
              "num": "LFA-5",
              "title": "Star Wars: The Phantom Menace"
            },
            {
              "num": "LFA-6",
              "title": "Star Wars: Attack of the Clones"
            },
            {
              "num": "LFA-7",
              "title": "Star Wars: Revenge of the Sith"
            },
            {
              "num": "LFA-8",
              "title": "Star Wars: The Force Awakens"
            },
            {
              "num": "LFA-9",
              "title": "Star Wars: The Last Jedi"
            },
            {
              "num": "LFA-10",
              "title": "Star Wars: The Rise of Skywalker"
            },
            {
              "num": "LFA-11",
              "title": "Spin-Offs and Animated Series"
            },
            {
              "num": "LFA-12",
              "title": "Star Wars: Galaxy's Edge"
            },
            {
              "num": "LFA-13",
              "title": "Disney+ launches with Star Wars films and The Mandalorian"
            },
            {
              "num": "LFA-14",
              "title": "The Book of Boba Fett announced"
            }
          ]
        },
        {
          "count": 14,
          "name": "LUCASFILM 50TH GOLD METAL VARIATION",
          "meta": "Gold Metal variations · every card a one-of-one",
          "parallels": 1,
          "oneOfOne": true,
          "cards": [
            {
              "num": "LFA-1GM",
              "title": "George Lucas creates Lucasfilm"
            },
            {
              "num": "LFA-2GM",
              "title": "Star Wars: A New Hope"
            },
            {
              "num": "LFA-3GM",
              "title": "Star Wars: The Empire Strikes Back"
            },
            {
              "num": "LFA-4GM",
              "title": "Star Wars: Return of the Jedi"
            },
            {
              "num": "LFA-5GM",
              "title": "Star Wars: The Phantom Menace"
            },
            {
              "num": "LFA-6GM",
              "title": "Star Wars: Attack of the Clones"
            },
            {
              "num": "LFA-7GM",
              "title": "Star Wars: Revenge of the Sith"
            },
            {
              "num": "LFA-8GM",
              "title": "Star Wars: The Force Awakens"
            },
            {
              "num": "LFA-9GM",
              "title": "Star Wars: The Last Jedi"
            },
            {
              "num": "LFA-10GM",
              "title": "Star Wars: The Rise of Skywalker"
            },
            {
              "num": "LFA-11GM",
              "title": "Spin-Offs and Animated Series"
            },
            {
              "num": "LFA-12GM",
              "title": "Star Wars: Galaxy's Edge"
            },
            {
              "num": "LFA-13GM",
              "title": "Disney+ launches with Star Wars films and The Mandalorian"
            },
            {
              "num": "LFA-14GM",
              "title": "The Book of Boba Fett announced"
            }
          ]
        },
        {
          "count": 14,
          "name": "LUCASFILM 50TH METAL VARIATION",
          "meta": "Metal variations · every card /5",
          "parallels": 1,
          "cards": [
            {
              "num": "LFA-1M",
              "title": "George Lucas creates Lucasfilm"
            },
            {
              "num": "LFA-2M",
              "title": "Star Wars: A New Hope"
            },
            {
              "num": "LFA-3M",
              "title": "Star Wars: The Empire Strikes Back"
            },
            {
              "num": "LFA-4M",
              "title": "Star Wars: Return of the Jedi"
            },
            {
              "num": "LFA-5M",
              "title": "Star Wars: The Phantom Menace"
            },
            {
              "num": "LFA-6M",
              "title": "Star Wars: Attack of the Clones"
            },
            {
              "num": "LFA-7M",
              "title": "Star Wars: Revenge of the Sith"
            },
            {
              "num": "LFA-8M",
              "title": "Star Wars: The Force Awakens"
            },
            {
              "num": "LFA-9M",
              "title": "Star Wars: The Last Jedi"
            },
            {
              "num": "LFA-10M",
              "title": "Star Wars: The Rise of Skywalker"
            },
            {
              "num": "LFA-11M",
              "title": "Spin-Offs and Animated Series"
            },
            {
              "num": "LFA-12M",
              "title": "Star Wars: Galaxy's Edge"
            },
            {
              "num": "LFA-13M",
              "title": "Disney+ launches with Star Wars films and The Mandalorian"
            },
            {
              "num": "LFA-14M",
              "title": "The Book of Boba Fett announced"
            }
          ]
        },
        {
          "count": 25,
          "name": "OUT OF THE BOX",
          "meta": "Classic characters in artistic renderings · Rainbow Foil /299 → Printing Plates 1/1",
          "parallels": 4,
          "cards": [
            {
              "num": "OTB-1",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "OTB-2",
              "title": "Han Solo"
            },
            {
              "num": "OTB-3",
              "title": "Luke Skywalker"
            },
            {
              "num": "OTB-4",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-5",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-6",
              "title": "Han Solo"
            },
            {
              "num": "OTB-7",
              "title": "C-3PO"
            },
            {
              "num": "OTB-8",
              "title": "R2-D2"
            },
            {
              "num": "OTB-9",
              "title": "Chewbacca"
            },
            {
              "num": "OTB-10",
              "title": "Greedo"
            },
            {
              "num": "OTB-11",
              "title": "Darth Vader"
            },
            {
              "num": "OTB-12",
              "title": "Boba Fett"
            },
            {
              "num": "OTB-13",
              "title": "Lando Calrissian"
            },
            {
              "num": "OTB-14",
              "title": "Tusken Raider"
            },
            {
              "num": "OTB-15",
              "title": "Rancor"
            },
            {
              "num": "OTB-16",
              "title": "Ewok"
            },
            {
              "num": "OTB-17",
              "title": "Stormtrooper"
            },
            {
              "num": "OTB-18",
              "title": "Biker Scout"
            },
            {
              "num": "OTB-19",
              "title": "Snowtrooper"
            },
            {
              "num": "OTB-20",
              "title": "Admiral Ackbar"
            },
            {
              "num": "OTB-21",
              "title": "Gamorrean Guard"
            },
            {
              "num": "OTB-22",
              "title": "Jawa"
            },
            {
              "num": "OTB-23",
              "title": "R2-D2"
            },
            {
              "num": "OTB-24",
              "title": "Tie Fighter Pilot"
            },
            {
              "num": "OTB-25",
              "title": "Emperor's Royal Guard"
            }
          ]
        },
        {
          "count": 25,
          "name": "OUT OF THE BOX GOLD METAL VARIATION",
          "meta": "Gold Metal variations · every card a one-of-one",
          "parallels": 1,
          "oneOfOne": true,
          "cards": [
            {
              "num": "OTB-1GM",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "OTB-2GM",
              "title": "Han Solo"
            },
            {
              "num": "OTB-3GM",
              "title": "Luke Skywalker"
            },
            {
              "num": "OTB-4GM",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-5GM",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-6GM",
              "title": "Han Solo"
            },
            {
              "num": "OTB-7GM",
              "title": "C-3PO"
            },
            {
              "num": "OTB-8GM",
              "title": "R2-D2"
            },
            {
              "num": "OTB-9GM",
              "title": "Chewbacca"
            },
            {
              "num": "OTB-10GM",
              "title": "Greedo"
            },
            {
              "num": "OTB-11GM",
              "title": "Darth Vader"
            },
            {
              "num": "OTB-12GM",
              "title": "Boba Fett"
            },
            {
              "num": "OTB-13GM",
              "title": "Lando Calrissian"
            },
            {
              "num": "OTB-14GM",
              "title": "Tusken Raider"
            },
            {
              "num": "OTB-15GM",
              "title": "Rancor"
            },
            {
              "num": "OTB-16GM",
              "title": "Ewok"
            },
            {
              "num": "OTB-17GM",
              "title": "Stormtrooper"
            },
            {
              "num": "OTB-18GM",
              "title": "Biker Scout"
            },
            {
              "num": "OTB-19GM",
              "title": "Snowtrooper"
            },
            {
              "num": "OTB-20GM",
              "title": "Admiral Ackbar"
            },
            {
              "num": "OTB-21GM",
              "title": "Gamorrean Guard"
            },
            {
              "num": "OTB-22GM",
              "title": "Jawa"
            },
            {
              "num": "OTB-23GM",
              "title": "R2-D2"
            },
            {
              "num": "OTB-24GM",
              "title": "Tie Fighter Pilot"
            },
            {
              "num": "OTB-25GM",
              "title": "Emperor's Royal Guard"
            }
          ]
        },
        {
          "count": 25,
          "name": "OUT OF THE BOX METAL VARIATION",
          "meta": "Metal variations · every card /5",
          "parallels": 1,
          "cards": [
            {
              "num": "OTB-1M",
              "title": "Obi-Wan Kenobi"
            },
            {
              "num": "OTB-2M",
              "title": "Han Solo"
            },
            {
              "num": "OTB-3M",
              "title": "Luke Skywalker"
            },
            {
              "num": "OTB-4M",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-5M",
              "title": "Princess Leia Organa"
            },
            {
              "num": "OTB-6M",
              "title": "Han Solo"
            },
            {
              "num": "OTB-7M",
              "title": "C-3PO"
            },
            {
              "num": "OTB-8M",
              "title": "R2-D2"
            },
            {
              "num": "OTB-9M",
              "title": "Chewbacca"
            },
            {
              "num": "OTB-10M",
              "title": "Greedo"
            },
            {
              "num": "OTB-11M",
              "title": "Darth Vader"
            },
            {
              "num": "OTB-12M",
              "title": "Boba Fett"
            },
            {
              "num": "OTB-13M",
              "title": "Lando Calrissian"
            },
            {
              "num": "OTB-14M",
              "title": "Tusken Raider"
            },
            {
              "num": "OTB-15M",
              "title": "Rancor"
            },
            {
              "num": "OTB-16M",
              "title": "Ewok"
            },
            {
              "num": "OTB-17M",
              "title": "Stormtrooper"
            },
            {
              "num": "OTB-18M",
              "title": "Biker Scout"
            },
            {
              "num": "OTB-19M",
              "title": "Snowtrooper"
            },
            {
              "num": "OTB-20M",
              "title": "Admiral Ackbar"
            },
            {
              "num": "OTB-21M",
              "title": "Gamorrean Guard"
            },
            {
              "num": "OTB-22M",
              "title": "Jawa"
            },
            {
              "num": "OTB-23M",
              "title": "R2-D2"
            },
            {
              "num": "OTB-24M",
              "title": "Tie Fighter Pilot"
            },
            {
              "num": "OTB-25M",
              "title": "Emperor's Royal Guard"
            }
          ]
        },
        {
          "count": 24,
          "name": "STAMP CARDS",
          "meta": "Character postage-stamp cards · Green /99 → Gold 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "SC-AG",
              "title": "Adi Gallia"
            },
            {
              "num": "SC-AN",
              "title": "Anakin Skywalker"
            },
            {
              "num": "SC-AS",
              "title": "Anakin Skywalker"
            },
            {
              "num": "SC-BB",
              "title": "BB-8"
            },
            {
              "num": "SC-CHW",
              "title": "Chewbacca"
            },
            {
              "num": "SC-FB",
              "title": "Fode and Beed"
            },
            {
              "num": "SC-FN",
              "title": "Finn"
            },
            {
              "num": "SC-JA",
              "title": "Jannah"
            },
            {
              "num": "SC-KF",
              "title": "Kit Fisto"
            },
            {
              "num": "SC-KR",
              "title": "Kylo Ren"
            },
            {
              "num": "SC-LO",
              "title": "Leia Organa"
            },
            {
              "num": "SC-LS",
              "title": "Luke Skywalker"
            },
            {
              "num": "SC-PD",
              "title": "Poe Dameron"
            },
            {
              "num": "SC-PDA",
              "title": "Poe Dameron"
            },
            {
              "num": "SC-QG",
              "title": "Qui Gon Jin"
            },
            {
              "num": "SC-R2",
              "title": "R2-D2"
            },
            {
              "num": "SC-SE",
              "title": "Sebulba"
            },
            {
              "num": "SC-ST",
              "title": "Stormtrooper"
            },
            {
              "num": "SC-STI",
              "title": "Saesee Tiin"
            },
            {
              "num": "SC-STP",
              "title": "Scout Trooper"
            },
            {
              "num": "SC-SW",
              "title": "Snap Wexley"
            },
            {
              "num": "SC-TA",
              "title": "Tallie Lintra"
            },
            {
              "num": "SC-WA",
              "title": "Watto"
            },
            {
              "num": "SC-WW",
              "title": "Wicket W Warrick"
            }
          ]
        },
        {
          "count": 10,
          "name": "WELCOME TO THE DARK SIDE",
          "meta": "The dark side’s most chilling lines · Rainbow Foil /299 → Printing Plates 1/1",
          "parallels": 4,
          "cards": [
            {
              "num": "WDS-1",
              "title": "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-2",
              "title": "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-3",
              "title": "\"I am your father.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-4",
              "title": "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-5",
              "title": "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-6",
              "title": "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)"
            },
            {
              "num": "WDS-7",
              "title": "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-8",
              "title": "\"The Force is strong in this one.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-9",
              "title": "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-10",
              "title": "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)"
            }
          ]
        },
        {
          "count": 10,
          "name": "WELCOME TO THE DARK SIDE GOLD METAL VARIATION",
          "meta": "Gold Metal variations · every card a one-of-one",
          "parallels": 1,
          "oneOfOne": true,
          "cards": [
            {
              "num": "WDS-1GM",
              "title": "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-2GM",
              "title": "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-3GM",
              "title": "\"I am your father.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-4GM",
              "title": "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-5GM",
              "title": "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-6GM",
              "title": "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)"
            },
            {
              "num": "WDS-7GM",
              "title": "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-8GM",
              "title": "\"The Force is strong in this one.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-9GM",
              "title": "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-10GM",
              "title": "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)"
            }
          ]
        },
        {
          "count": 10,
          "name": "WELCOME TO THE DARK SIDE METAL VARIATION",
          "meta": "Metal variations · every card /5",
          "parallels": 1,
          "cards": [
            {
              "num": "WDS-1M",
              "title": "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-2M",
              "title": "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-3M",
              "title": "\"I am your father.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-4M",
              "title": "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-5M",
              "title": "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)"
            },
            {
              "num": "WDS-6M",
              "title": "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)"
            },
            {
              "num": "WDS-7M",
              "title": "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-8M",
              "title": "\"The Force is strong in this one.\" (Star Wars: A New Hope)"
            },
            {
              "num": "WDS-9M",
              "title": "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)"
            },
            {
              "num": "WDS-10M",
              "title": "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)"
            }
          ]
        }
      ],
      "auto": [
        {
          "count": 52,
          "name": "ON CARD AUTOGRAPHS",
          "meta": "Hard-signed from every era · Blue Foil /99 → Gold Frame 1/1",
          "parallels": 7,
          "cards": [
            {
              "num": "MWA-AB",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "MWA-ABR",
              "title": "Anna Brewster",
              "meta": "Bazine Netal"
            },
            {
              "num": "MWA-AD",
              "title": "Adam Driver",
              "meta": "Kylo Ren"
            },
            {
              "num": "MWA-ADA",
              "title": "Annabelle Davis",
              "meta": "Thromba"
            },
            {
              "num": "MWA-AE",
              "title": "Ashley Eckstein",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "MWA-AL",
              "title": "Amanda Lawrence",
              "meta": "Commander D'Acy"
            },
            {
              "num": "MWA-AS",
              "title": "Amy Sedaris",
              "meta": "Peli Motto"
            },
            {
              "num": "MWA-AW",
              "title": "Alexander Wraith",
              "meta": "Imperial Freighter Pilot"
            },
            {
              "num": "MWA-BH",
              "title": "Brian Herring",
              "meta": "BB-8"
            },
            {
              "num": "MWA-CB",
              "title": "Chris Bartlett",
              "meta": "Teacher Droid"
            },
            {
              "num": "MWA-CE",
              "title": "Chris Edgerly",
              "meta": "Eeth Koth"
            },
            {
              "num": "MWA-CG",
              "title": "Clare Grant",
              "meta": "Latts Razzi"
            },
            {
              "num": "MWA-DBC",
              "title": "Dee Bradley Baker",
              "meta": "Crosshair"
            },
            {
              "num": "MWA-DBE",
              "title": "Dee Bradley Baker",
              "meta": "Echo"
            },
            {
              "num": "MWA-DBH",
              "title": "Dee Bradley Baker",
              "meta": "Hunter"
            },
            {
              "num": "MWA-DBR",
              "title": "Dee Bradley Baker",
              "meta": "Captain Rex"
            },
            {
              "num": "MWA-DBT",
              "title": "Dee Bradley Baker",
              "meta": "Tech"
            },
            {
              "num": "MWA-DBW",
              "title": "Dee Bradley Baker",
              "meta": "Wrecker"
            },
            {
              "num": "MWA-DI",
              "title": "Diana Lee Inosanto",
              "meta": "Magistrate Morgan Elsbeth"
            },
            {
              "num": "MWA-DR",
              "title": "Daisy Ridley",
              "meta": "Rey"
            },
            {
              "num": "MWA-EC",
              "title": "Emilia Clarke",
              "meta": "Qi'ra"
            },
            {
              "num": "MWA-ES",
              "title": "Emily Swallow",
              "meta": "The Armorer"
            },
            {
              "num": "MWA-GE",
              "title": "Giancarlo Esposito",
              "meta": "Moff Gideon"
            },
            {
              "num": "MWA-GG",
              "title": "Greg Grunberg",
              "meta": "Snap Wexley"
            },
            {
              "num": "MWA-HC",
              "title": "Hayden Christensen",
              "meta": "Anakin Skywalker"
            },
            {
              "num": "MWA-IM",
              "title": "Ian McDiarmid",
              "meta": "Emperor Palpatine"
            },
            {
              "num": "MWA-JG",
              "title": "Janina Gavankar",
              "meta": "Iden Versio"
            },
            {
              "num": "MWA-JL",
              "title": "John Leguizamo",
              "meta": "Gor Koresh"
            },
            {
              "num": "MWA-KO",
              "title": "Katy O'Brian",
              "meta": "Imperial Comms Officer"
            },
            {
              "num": "MWA-LM",
              "title": "Lars Mikkelsen",
              "meta": "Grand Admiral Thrawn"
            },
            {
              "num": "MWA-LS",
              "title": "Leilani Shiu",
              "meta": "Jawa"
            },
            {
              "num": "MWA-MBO",
              "title": "Mark Boone Junior",
              "meta": "Ranzar Malk"
            },
            {
              "num": "MWA-MIB",
              "title": "Michonne Bourriague",
              "meta": "Aurra Sing"
            },
            {
              "num": "MWA-MM",
              "title": "Mary Elizabeth McGlynn",
              "meta": "Governor Arihnda Pryce"
            },
            {
              "num": "MWA-MV",
              "title": "Mercedes Varnado",
              "meta": "Koska Reeves"
            },
            {
              "num": "MWA-MW",
              "title": "Matthew Wood",
              "meta": "General Grievous"
            },
            {
              "num": "MWA-NF",
              "title": "Nika Futterman",
              "meta": "Asajj Ventress"
            },
            {
              "num": "MWA-NP",
              "title": "Natalie Portman",
              "meta": "Queen Amidala"
            },
            {
              "num": "MWA-OA",
              "title": "Omid Abtahi",
              "meta": "Dr. Pershing"
            },
            {
              "num": "MWA-PA",
              "title": "Philip Anthony-Rodriguez",
              "meta": "Fifth Brother"
            },
            {
              "num": "MWA-PAL",
              "title": "Philip Alexander",
              "meta": "Imperial Security Officer"
            },
            {
              "num": "MWA-PK",
              "title": "Paul Kasey",
              "meta": "C'ai Threnalli"
            },
            {
              "num": "MWA-PL",
              "title": "Paul Sun-Hyung Lee",
              "meta": "Captain Carson Teva"
            },
            {
              "num": "MWA-RB",
              "title": "Richard Brake",
              "meta": "Valin Hess"
            },
            {
              "num": "MWA-RD",
              "title": "Rosario Dawson",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "MWA-RG",
              "title": "Richard Grant",
              "meta": "Allegiant General Pryde"
            },
            {
              "num": "MWA-RO",
              "title": "Rena Owen",
              "meta": "Taun We"
            },
            {
              "num": "MWA-SK",
              "title": "Simon Kassianides",
              "meta": "Axe Woves"
            },
            {
              "num": "MWA-SS",
              "title": "Stephen Stanton",
              "meta": "Admiral Tarkin"
            },
            {
              "num": "MWA-SW",
              "title": "Sam Witwer",
              "meta": "Darth Maul"
            },
            {
              "num": "MWA-TG",
              "title": "Taylor Gray",
              "meta": "Ezra Bridger"
            },
            {
              "num": "MWA-TR",
              "title": "Tim Rose",
              "meta": "Admiral Ackbar"
            }
          ]
        },
        {
          "count": 15,
          "name": "DUAL AUTOGRAPH CARDS",
          "meta": "15 pairings · every card /50 → Gold 1/1",
          "parallels": 5,
          "cards": [
            {
              "num": "MWD-BM",
              "title": "Mary Elizabeth McGlynn / Steve Blum",
              "meta": "Governor Arihnda Pryce / Zeb Orrelios"
            },
            {
              "num": "MWD-CE",
              "title": "Alden Ehrenreich / Emilia Clarke",
              "meta": "Han Solo / Qi'ra"
            },
            {
              "num": "MWD-CP",
              "title": "Natalie Portman / Hayden Christensen",
              "meta": "Padmé Amidala / Anakin Skywalker"
            },
            {
              "num": "MWD-DC",
              "title": "Adam Driver / Gwendoline Christie",
              "meta": "Kylo Ren / Captain Phasma"
            },
            {
              "num": "MWD-DI",
              "title": "Diana Lee Inosanto / Rosario Dawson",
              "meta": "Magistrate Morgan Elsbeth / Ahsoka Tano"
            },
            {
              "num": "MWD-HA",
              "title": "Werner Herzog / Omid Abtahi",
              "meta": "The Client / Dr. Pershing"
            },
            {
              "num": "MWD-HR",
              "title": "Ralph Brown / Hugh Quarshie",
              "meta": "Ric Olié / Captain Panaka"
            },
            {
              "num": "MWD-JM",
              "title": "Ben Mendelsohn / Felicity Jones",
              "meta": "Director Krennic / Jyn Erso"
            },
            {
              "num": "MWD-MB",
              "title": "Temuera Morrison / Jeremy Bulloch",
              "meta": "Jango Fett / Boba Fett"
            },
            {
              "num": "MWD-MC",
              "title": "Ewan McGregor / Hayden Christensen",
              "meta": "Obi-Wan Kenobi / Anakin Skywalker"
            },
            {
              "num": "MWD-MG",
              "title": "Taylor Gray / Lars Mikkelsen",
              "meta": "Ezra Bridger / Grand Admiral Thrawn"
            },
            {
              "num": "MWD-RM",
              "title": "Daisy Ridley / Ian McDiarmid",
              "meta": "Rey / Emperor Palpatine"
            },
            {
              "num": "MWD-SW",
              "title": "Nick Nolte / Carl Weathers",
              "meta": "Kuiil / Greef Karga"
            },
            {
              "num": "MWD-WB",
              "title": "Dickey Beer / Corey Dee Williams",
              "meta": "Barada / Klaatu"
            },
            {
              "num": "MWD-WG",
              "title": "Matthew Wood / Kathleen Gati",
              "meta": "General Grievous / Old Daka"
            }
          ]
        },
        {
          "count": 6,
          "name": "TRIPLE AUTOGRAPH CARDS",
          "meta": "6 trios · every card /25 → Gold 1/1",
          "parallels": 4,
          "cards": [
            {
              "num": "MWT-BMT",
              "title": "John Boyega / Kelly Marie Tran / Dominic Monaghan",
              "meta": "Finn / Rose Tico / Beaumont Kin"
            },
            {
              "num": "MWT-CFD",
              "title": "Harrison Ford / Adam Driver / Andy Serkis",
              "meta": "Han Solo / Kylo Ren / Supreme Leader Snoke"
            },
            {
              "num": "MWT-CPF",
              "title": "Natalie Portman / Hayden Christensen / Ian McDiarmid",
              "meta": "Padmé Amidala / Anakin Skywalker / Supreme Chancellor Palpatine"
            },
            {
              "num": "MWT-EBC",
              "title": "Emilia Clarke / Paul Bettany / Alden Ehrenreich",
              "meta": "Qi'ra / Dryden Vos / Han Solo"
            },
            {
              "num": "MWT-GBS",
              "title": "Steve Blum / Taylor Gray / Tiya Sircar",
              "meta": "Zeb Orrelios / Ezra Bridger / Sabine Wren"
            },
            {
              "num": "MWT-MPC",
              "title": "Ray Park / Ian McDiarmid / Hayden Christensen",
              "meta": "Darth Maul / Emperor Palpatine / Darth Vader"
            }
          ]
        },
        {
          "count": 4,
          "name": "QUAD AUTOGRAPH BOOK CARDS",
          "meta": "Signed book cards · two copies each",
          "parallels": 1,
          "cards": [
            {
              "num": "MWQ-MBSP",
              "title": "Riz Ahmed / Donnie Yen / Alan Tudyk / Felicity Jones",
              "meta": "Bodhi Rook / Chirrut Îmwe / K-2SO / Jyn Erso"
            },
            {
              "num": "MWQ-MPCD",
              "title": "Hayden Christensen / Ray Park / Ian McDiarmid / Adam Driver",
              "meta": "Darth Vader / Darth Maul / Emperor Palpatine / Kylo Ren"
            },
            {
              "num": "MWQ-MWWN",
              "title": "David Barclay / Michael Carter / Mark Dodson / Jeremy Bulloch",
              "meta": "Jabba The Hutt / Bib Fortuna / Salacious B. Crumb / Boba Fett"
            },
            {
              "num": "MWQ-PJFR",
              "title": "Natalie Portman / Felicity Jones / Carrie Fisher / Daisy Ridley",
              "meta": "Queen Amidala / Jyn Erso / Princess Leia Organa / Rey"
            }
          ]
        },
        {
          "count": 1,
          "name": "GALACTIC AUTOGRAPH BOOK",
          "meta": "20 signers in one book · 1 of 1",
          "parallels": 1,
          "oneOfOne": true,
          "cards": [
            {
              "num": "GAB-2021",
              "title": "Andy Serkis / Carl Weathers / Pedro Pascal / Billy Dee Williams / Gwendoline Christie / John Boyega / Ian McDiarmid / Adam Driver / Daisy Ridley / Harrison Ford / David Prowse / Ewan McGregor / Samuel L. Jackson / Hayden Christensen / Mads Mikkelsen / Felicity Jones / Carrie Fisher / Alden Ehrenreich / Emilia Clarke / Natalie Portman",
              "meta": "Supreme Leader Snoke / Greef Karga / The Mandalorian / Lando Calrissian / Captain Phasma / Finn / Emperor Palpatine / Kylo Ren / Rey / Han Solo / Darth Vader / Obi-Wan Kenobi / Mace Windu / Anakin Skywalker / Galen Erso / Jyn Erso / Princess Leia Organa / Han Solo / Qi'ra / Queen Amidala"
            }
          ]
        },
        {
          "count": 43,
          "name": "PEN RELIC AUTOGRAPHS",
          "meta": "A piece of the signing pen in every card · all 1/1",
          "parallels": 1,
          "oneOfOne": true,
          "cards": [
            {
              "num": "PRA-AB",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "PRA-ABR",
              "title": "Anna Brewster",
              "meta": "Bazine Netal"
            },
            {
              "num": "PRA-AD",
              "title": "Adam Driver",
              "meta": "Kylo Ren"
            },
            {
              "num": "PRA-ADA",
              "title": "Annabelle Davis",
              "meta": "Thromba"
            },
            {
              "num": "PRA-AE",
              "title": "Ashley Eckstein",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "PRA-AL",
              "title": "Amanda Lawrence",
              "meta": "Commander D'Acy"
            },
            {
              "num": "PRA-BD",
              "title": "Ben Daniels",
              "meta": "General Merrick"
            },
            {
              "num": "PRA-BH",
              "title": "Brian Herring",
              "meta": "BB-8"
            },
            {
              "num": "PRA-BL",
              "title": "Billie Lourd",
              "meta": "Kaydel Ko Connix"
            },
            {
              "num": "PRA-CW",
              "title": "Carl Weathers",
              "meta": "Greef Karga"
            },
            {
              "num": "PRA-DBC",
              "title": "Dee Bradley Baker",
              "meta": "Crosshair"
            },
            {
              "num": "PRA-DBE",
              "title": "Dee Bradley Baker",
              "meta": "Echo"
            },
            {
              "num": "PRA-DBH",
              "title": "Dee Bradley Baker",
              "meta": "Hunter"
            },
            {
              "num": "PRA-DBR",
              "title": "Dee Bradley Baker",
              "meta": "Captain Rex"
            },
            {
              "num": "PRA-DBT",
              "title": "Dee Bradley Baker",
              "meta": "Tech"
            },
            {
              "num": "PRA-DBW",
              "title": "Dee Bradley Baker",
              "meta": "Wrecker"
            },
            {
              "num": "PRA-DI",
              "title": "Diana Lee Inosanto",
              "meta": "Magistrate Morgan Elsbeth"
            },
            {
              "num": "PRA-DL",
              "title": "Daniel Logan",
              "meta": "Boba Fett"
            },
            {
              "num": "PRA-DR",
              "title": "Daisy Ridley",
              "meta": "Rey"
            },
            {
              "num": "PRA-EC",
              "title": "Emilia Clarke",
              "meta": "Qi'ra"
            },
            {
              "num": "PRA-ES",
              "title": "Emily Swallow",
              "meta": "The Armorer"
            },
            {
              "num": "PRA-GE",
              "title": "Giancarlo Esposito",
              "meta": "Moff Gideon"
            },
            {
              "num": "PRA-GG",
              "title": "Greg Grunberg",
              "meta": "Snap Wexley"
            },
            {
              "num": "PRA-HC",
              "title": "Hayden Christensen",
              "meta": "Anakin Skywalker"
            },
            {
              "num": "PRA-IM",
              "title": "Ian McDiarmid",
              "meta": "Emperor Palpatine"
            },
            {
              "num": "PRA-JL",
              "title": "John Leguizamo",
              "meta": "Gor Koresh"
            },
            {
              "num": "PRA-JT",
              "title": "James Arnold Taylor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "PRA-KO",
              "title": "Katy O'Brian",
              "meta": "Comms Officer"
            },
            {
              "num": "PRA-LM",
              "title": "Lars Mikkelsen",
              "meta": "Grand Admiral Thrawn"
            },
            {
              "num": "PRA-MBO",
              "title": "Mark Boone Junior",
              "meta": "Ranzar Malk"
            },
            {
              "num": "PRA-MM",
              "title": "Mary Elizabeth McGlynn",
              "meta": "Governor Arihnda Pryce"
            },
            {
              "num": "PRA-MW",
              "title": "Matthew Wood",
              "meta": "General Grievous"
            },
            {
              "num": "PRA-NP",
              "title": "Natalie Portman",
              "meta": "Queen Amidala"
            },
            {
              "num": "PRA-OA",
              "title": "Omid Abtahi",
              "meta": "Dr. Pershing"
            },
            {
              "num": "PRA-PK",
              "title": "Paul Kasey",
              "meta": "Ello Asty"
            },
            {
              "num": "PRA-PL",
              "title": "Paul Sun-Hyung Lee",
              "meta": "Captain Carson Teva"
            },
            {
              "num": "PRA-RB",
              "title": "Richard Brake",
              "meta": "Valin Hess"
            },
            {
              "num": "PRA-RD",
              "title": "Rosario Dawson",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "PRA-RO",
              "title": "Rena Owen",
              "meta": "Taun We"
            },
            {
              "num": "PRA-SK",
              "title": "Simon Kassianides",
              "meta": "Axe Woves"
            },
            {
              "num": "PRA-SS",
              "title": "Stephen Stanton",
              "meta": "Admiral Tarkin"
            },
            {
              "num": "PRA-TG",
              "title": "Taylor Gray",
              "meta": "Ezra Bridger"
            },
            {
              "num": "PRA-TM",
              "title": "Temuera Morrison",
              "meta": "Boba Fett"
            }
          ]
        }
      ]
    }
  },
  '2021-stellar-signatures': {
    "setId": "2021-stellar-signatures",
    "year": "2021",
    "brand": "TOPPS",
    "title": "STAR WARS STELLAR SIGNATURES",
    "releaseDate": "12 / 22 / 2021",
    "lede": "Topps’ ultra-premium Star Wars box set — a production run of just 100 boxes, each packing 141 cards: 40 encased on-card autographs (36 singles, 3 duals, and a quad), the complete 100-card sketch reproduction set, and a framed 5\" × 7\" original sketch that exists nowhere else. Every signed card is numbered to 40 copies or fewer, from a 36-signer roster that runs Harrison Ford, Natalie Portman, Daisy Ridley, Adam Driver, Emilia Clarke, and Hayden Christensen deep, and every autograph climbs a refractor ladder that ends in three different one-of-ones — Imperial Red, Galactic Black, and Rebel Orange.",
    "stats": [
      {
        "num": "100",
        "label": "Boxes Made",
        "sub": "The entire production run",
        "color": "gold"
      },
      {
        "num": "45",
        "label": "Auto Cards",
        "sub": "36 singles · 8 duals · 1 quad",
        "color": "cyan"
      },
      {
        "num": "40",
        "label": "Autos Per Box",
        "sub": "Encased · /40 or fewer",
        "color": "green"
      },
      {
        "num": "200",
        "label": "Sketch Cards",
        "sub": "100 repros /100 · 100 originals 1/1",
        "color": "purple"
      },
      {
        "num": "5",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "141",
        "l": "Cards per box"
      },
      {
        "v": "40",
        "l": "Autographs per box · 36 singles, 3 duals, 1 quad"
      },
      {
        "v": "100",
        "l": "Sketch reproductions · the complete /100 set in every box"
      },
      {
        "v": "1",
        "l": "Framed 5\" × 7\" oversized sketch 1/1 per box"
      }
    ],
    "pullRates": [
      {
        "name": "On-Card Autographs",
        "odds": "36 per box",
        "tier": "normal"
      },
      {
        "name": "Dual Autographs",
        "odds": "3 per box",
        "tier": "normal"
      },
      {
        "name": "Quad Autograph",
        "odds": "1 per box",
        "tier": "rare"
      },
      {
        "name": "Oversized Sketch 1/1",
        "odds": "1 per box",
        "tier": "rare"
      },
      {
        "name": "Autograph 1/1 Versions",
        "odds": "135 across the run",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "AUTOGRAPH",
        "pr": "/40",
        "gradient": "linear-gradient(135deg, #c8d8e8 0%, #8aa0b8 50%, #c8d8e8 100%)",
        "darkText": true
      },
      {
        "name": "BLUE",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/20",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "PURPLE",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
      },
      {
        "name": "GOLD",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)",
        "darkText": true
      },
      {
        "name": "IMPERIAL RED",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      },
      {
        "name": "GALACTIC BLACK",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "REBEL ORANGE",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      }
    ],
    "artists": [
      {
        "name": "Candice Dailey",
        "work": "21 subjects across the reproduction and oversized sketch sets"
      },
      {
        "name": "Dan Tearle",
        "work": "21 subjects across the reproduction and oversized sketch sets"
      },
      {
        "name": "Dan Bergren",
        "work": "20 subjects across the reproduction and oversized sketch sets"
      },
      {
        "name": "Jason Davies",
        "work": "20 subjects across the reproduction and oversized sketch sets"
      },
      {
        "name": "Carlos Cabaleiro",
        "work": "18 subjects across the reproduction and oversized sketch sets"
      }
    ],
    "subsets": {
      "insert": [
        {
          "count": 100,
          "name": "SKETCH CARD REPRODUCTIONS",
          "meta": "The complete 100-card set in every box · every card serial /100",
          "parallels": 1,
          "cards": [
            {
              "num": "1",
              "title": "Kuiil",
              "meta": "Dan Bergren"
            },
            {
              "num": "2",
              "title": "Hunter",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "3",
              "title": "Omega",
              "meta": "Candice Dailey"
            },
            {
              "num": "4",
              "title": "Baze Malbus",
              "meta": "Jason Davies"
            },
            {
              "num": "5",
              "title": "Ben Solo",
              "meta": "Dan Tearle"
            },
            {
              "num": "6",
              "title": "Han Solo",
              "meta": "Dan Bergren"
            },
            {
              "num": "7",
              "title": "Wrecker",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "8",
              "title": "Caleb Dume",
              "meta": "Candice Dailey"
            },
            {
              "num": "9",
              "title": "Bodhi Rook",
              "meta": "Jason Davies"
            },
            {
              "num": "10",
              "title": "Flame Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "11",
              "title": "Qi'ra",
              "meta": "Dan Bergren"
            },
            {
              "num": "12",
              "title": "Tech",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "13",
              "title": "Wilhuff Tarkin",
              "meta": "Candice Dailey"
            },
            {
              "num": "14",
              "title": "Captain Cassian Andor",
              "meta": "Jason Davies"
            },
            {
              "num": "15",
              "title": "Rey's Speeder",
              "meta": "Dan Tearle"
            },
            {
              "num": "16",
              "title": "Tobias Beckett",
              "meta": "Dan Bergren"
            },
            {
              "num": "17",
              "title": "Crosshair",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "18",
              "title": "Saw Gerrera",
              "meta": "Candice Dailey"
            },
            {
              "num": "19",
              "title": "Chirrut Îmwe",
              "meta": "Jason Davies"
            },
            {
              "num": "20",
              "title": "Supreme Leader Snoke",
              "meta": "Dan Tearle"
            },
            {
              "num": "21",
              "title": "Poe Dameron",
              "meta": "Dan Bergren"
            },
            {
              "num": "22",
              "title": "Echo",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "23",
              "title": "Dark Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "24",
              "title": "Galen Erso",
              "meta": "Jason Davies"
            },
            {
              "num": "25",
              "title": "BB-8",
              "meta": "Dan Tearle"
            },
            {
              "num": "26",
              "title": "Finn",
              "meta": "Dan Bergren"
            },
            {
              "num": "27",
              "title": "Cad Bane",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "28",
              "title": "General Leia Organa",
              "meta": "Candice Dailey"
            },
            {
              "num": "29",
              "title": "Jyn Erso",
              "meta": "Jason Davies"
            },
            {
              "num": "30",
              "title": "AT-ST Walker",
              "meta": "Dan Tearle"
            },
            {
              "num": "31",
              "title": "Obi-Wan Kenobi",
              "meta": "Dan Bergren"
            },
            {
              "num": "32",
              "title": "Captain Rex",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "33",
              "title": "Rose Tico",
              "meta": "Candice Dailey"
            },
            {
              "num": "34",
              "title": "K-2SO",
              "meta": "Jason Davies"
            },
            {
              "num": "35",
              "title": "C-3PO",
              "meta": "Dan Tearle"
            },
            {
              "num": "36",
              "title": "Jango Fett",
              "meta": "Dan Bergren"
            },
            {
              "num": "37",
              "title": "Jesse",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "38",
              "title": "Padmé Amidala",
              "meta": "Candice Dailey"
            },
            {
              "num": "39",
              "title": "Jabba the Hutt",
              "meta": "Jason Davies"
            },
            {
              "num": "40",
              "title": "R2-D2",
              "meta": "Dan Tearle"
            },
            {
              "num": "41",
              "title": "Anakin Skywalker",
              "meta": "Dan Bergren"
            },
            {
              "num": "42",
              "title": "Cobb Vanth",
              "meta": "Candice Dailey"
            },
            {
              "num": "43",
              "title": "Zam Wesell",
              "meta": "Candice Dailey"
            },
            {
              "num": "44",
              "title": "Greedo",
              "meta": "Jason Davies"
            },
            {
              "num": "45",
              "title": "Darth Vader",
              "meta": "Dan Tearle"
            },
            {
              "num": "46",
              "title": "Qui-Gon Jinn",
              "meta": "Dan Bergren"
            },
            {
              "num": "47",
              "title": "Ahsoka Tano",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "48",
              "title": "Hera Syndulla",
              "meta": "Candice Dailey"
            },
            {
              "num": "49",
              "title": "Saw Gerrera",
              "meta": "Jason Davies"
            },
            {
              "num": "50",
              "title": "Han Solo",
              "meta": "Dan Tearle"
            },
            {
              "num": "51",
              "title": "Lando Calrissian",
              "meta": "Dan Bergren"
            },
            {
              "num": "52",
              "title": "Captain Phasma",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "53",
              "title": "Kanan Jarrus",
              "meta": "Candice Dailey"
            },
            {
              "num": "54",
              "title": "Zorii Bliss",
              "meta": "Jason Davies"
            },
            {
              "num": "55",
              "title": "Scout Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "56",
              "title": "Ben Kenobi",
              "meta": "Dan Bergren"
            },
            {
              "num": "57",
              "title": "Nien Nunb",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "58",
              "title": "The Grand Inquisitor",
              "meta": "Candice Dailey"
            },
            {
              "num": "59",
              "title": "Chewbacca",
              "meta": "Jason Davies"
            },
            {
              "num": "60",
              "title": "Snow Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "61",
              "title": "Yoda",
              "meta": "Dan Bergren"
            },
            {
              "num": "62",
              "title": "Luke Skywalker",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "63",
              "title": "Zeb Orrelios",
              "meta": "Candice Dailey"
            },
            {
              "num": "64",
              "title": "Darth Maul",
              "meta": "Jason Davies"
            },
            {
              "num": "65",
              "title": "AT-AT Walkers",
              "meta": "Dan Tearle"
            },
            {
              "num": "66",
              "title": "Princess Leia",
              "meta": "Dan Bergren"
            },
            {
              "num": "67",
              "title": "Ezra Bridger",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "68",
              "title": "The Mandalorian",
              "meta": "Candice Dailey"
            },
            {
              "num": "69",
              "title": "Darth Sidious",
              "meta": "Jason Davies"
            },
            {
              "num": "70",
              "title": "The Armorer",
              "meta": "Dan Tearle"
            },
            {
              "num": "71",
              "title": "Wicket W. Warrick",
              "meta": "Dan Bergren"
            },
            {
              "num": "72",
              "title": "Grand Admiral Thrawn",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "73",
              "title": "Greef Karga",
              "meta": "Candice Dailey"
            },
            {
              "num": "74",
              "title": "General Grievous",
              "meta": "Jason Davies"
            },
            {
              "num": "75",
              "title": "TIE Fighter",
              "meta": "Dan Tearle"
            },
            {
              "num": "76",
              "title": "Wedge Antilles",
              "meta": "Dan Bergren"
            },
            {
              "num": "77",
              "title": "Emperor Palpatine",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "78",
              "title": "The Client",
              "meta": "Candice Dailey"
            },
            {
              "num": "79",
              "title": "Jar Jar Binks",
              "meta": "Jason Davies"
            },
            {
              "num": "80",
              "title": "X-Wing Fighter",
              "meta": "Dan Tearle"
            },
            {
              "num": "81",
              "title": "Maz Kanata",
              "meta": "Dan Bergren"
            },
            {
              "num": "82",
              "title": "Rey",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "83",
              "title": "Moff Gideon",
              "meta": "Candice Dailey"
            },
            {
              "num": "84",
              "title": "Mace Windu",
              "meta": "Jason Davies"
            },
            {
              "num": "85",
              "title": "Boba Fett's Ship",
              "meta": "Dan Tearle"
            },
            {
              "num": "86",
              "title": "Snap Wexley",
              "meta": "Dan Bergren"
            },
            {
              "num": "87",
              "title": "Jawa",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "88",
              "title": "Bo-Katan Kryze",
              "meta": "Candice Dailey"
            },
            {
              "num": "89",
              "title": "Queen Amidala",
              "meta": "Jason Davies"
            },
            {
              "num": "90",
              "title": "Imperial Star Destroyer",
              "meta": "Dan Tearle"
            },
            {
              "num": "91",
              "title": "Grogu",
              "meta": "Dan Bergren"
            },
            {
              "num": "92",
              "title": "Ahsoka Tano",
              "meta": "Candice Dailey"
            },
            {
              "num": "93",
              "title": "Frog Lady",
              "meta": "Candice Dailey"
            },
            {
              "num": "94",
              "title": "Admiral Ackbar",
              "meta": "Jason Davies"
            },
            {
              "num": "95",
              "title": "The Razor Crest",
              "meta": "Dan Tearle"
            },
            {
              "num": "96",
              "title": "Kylo Ren",
              "meta": "Dan Bergren"
            },
            {
              "num": "97",
              "title": "Boba Fett",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "98",
              "title": "Fennec Shand",
              "meta": "Candice Dailey"
            },
            {
              "num": "99",
              "title": "Boba Fett",
              "meta": "Jason Davies"
            },
            {
              "num": "100",
              "title": "Imperial Guard",
              "meta": "Dan Tearle"
            }
          ]
        }
      ],
      "auto": [
        {
          "count": 36,
          "name": "ON-CARD AUTOGRAPHS",
          "meta": "Encased singles · /40 base → Gold /5 and three 1/1 versions",
          "parallels": 8,
          "cards": [
            {
              "num": "A-AB",
              "title": "Ahmed Best"
            },
            {
              "num": "A-AD",
              "title": "Adam Driver"
            },
            {
              "num": "A-AE",
              "title": "Ashley Eckstein"
            },
            {
              "num": "A-AS",
              "title": "Andy Serkis"
            },
            {
              "num": "A-ASP",
              "title": "Amy Sedaris"
            },
            {
              "num": "A-BDW",
              "title": "Billy Dee Williams"
            },
            {
              "num": "A-BL",
              "title": "Billie Lourd"
            },
            {
              "num": "A-CB",
              "title": "Caroline Blakiston"
            },
            {
              "num": "A-CH",
              "title": "Clint Howard"
            },
            {
              "num": "A-CW",
              "title": "Carl Weathers"
            },
            {
              "num": "A-DLI",
              "title": "Diana Lee Inosanto"
            },
            {
              "num": "A-DR",
              "title": "Daisy Ridley"
            },
            {
              "num": "A-EC",
              "title": "Emilia Clarke"
            },
            {
              "num": "A-EK",
              "title": "Erin Kellyman"
            },
            {
              "num": "A-ES",
              "title": "Emily Swallow"
            },
            {
              "num": "A-FJ",
              "title": "Felicity Jones"
            },
            {
              "num": "A-GE",
              "title": "Giancarlo Esposito"
            },
            {
              "num": "A-HC",
              "title": "Hayden Christensen"
            },
            {
              "num": "A-HF",
              "title": "Harrison Ford"
            },
            {
              "num": "A-HQ",
              "title": "Hugh Quarshie"
            },
            {
              "num": "A-JAT",
              "title": "James Arnold Taylor"
            },
            {
              "num": "A-KB",
              "title": "Kenny Baker"
            },
            {
              "num": "A-KMT",
              "title": "Kelly Marie Tran"
            },
            {
              "num": "A-LM",
              "title": "Lars Mikkelsen"
            },
            {
              "num": "A-ML",
              "title": "Matt Lanter"
            },
            {
              "num": "A-MP",
              "title": "Michael Pennington"
            },
            {
              "num": "A-MV",
              "title": "Mercedes Varnado"
            },
            {
              "num": "A-MW",
              "title": "Matthew Wood"
            },
            {
              "num": "A-NA",
              "title": "Naomi Ackie"
            },
            {
              "num": "A-NP",
              "title": "Natalie Portman"
            },
            {
              "num": "A-OA",
              "title": "Omid Abtahi"
            },
            {
              "num": "A-RD",
              "title": "Rosario Dawson"
            },
            {
              "num": "A-SK",
              "title": "Simon Kassianides"
            },
            {
              "num": "A-TG",
              "title": "Taylor Gray"
            },
            {
              "num": "A-TW",
              "title": "Taika Waititi"
            },
            {
              "num": "A-WD",
              "title": "Warwick Davis"
            }
          ]
        },
        {
          "count": 8,
          "name": "ON-CARD DUAL AUTOGRAPHS",
          "meta": "8 pairings · /25 base → Gold /5 and three 1/1 versions",
          "parallels": 6,
          "cards": [
            {
              "num": "DA-BG",
              "title": "Taylor Gray / Dee Bradley Baker"
            },
            {
              "num": "DA-DD",
              "title": "Harrison Davis / Warwick Davis"
            },
            {
              "num": "DA-EB",
              "title": "Dee Bradley Baker / Ashley Eckstein"
            },
            {
              "num": "DA-FD",
              "title": "Adam Driver / Harrison Ford"
            },
            {
              "num": "DA-LE",
              "title": "Matt Lanter / Ashley Eckstein"
            },
            {
              "num": "DA-RD",
              "title": "Daisy Ridley / Adam Driver"
            },
            {
              "num": "DA-RW",
              "title": "Billy Dee Williams / Daisy Ridley"
            },
            {
              "num": "DA-VK",
              "title": "Simon Kassianides / Mercedes Varnado"
            }
          ]
        },
        {
          "count": 1,
          "name": "ON-CARD QUAD AUTOGRAPH",
          "meta": "The Clone Wars voice cast · /40 base → three 1/1 versions",
          "parallels": 9,
          "cards": [
            {
              "num": "QD-CW",
              "title": "Dee Bradley Baker / Matt Lanter / James Arnold Taylor / Ashley Eckstein"
            }
          ]
        }
      ],
      "sketch": [
        {
          "count": 100,
          "name": "OVERSIZED SKETCH CARDS",
          "meta": "Framed 5\" × 7\" originals · one per box · every card a 1/1",
          "oneOfOne": true,
          "noParallels": true,
          "cards": [
            {
              "num": "1",
              "title": "Kuiil",
              "meta": "Dan Bergren"
            },
            {
              "num": "2",
              "title": "Hunter",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "3",
              "title": "Omega",
              "meta": "Candice Dailey"
            },
            {
              "num": "4",
              "title": "Baze Malbus",
              "meta": "Jason Davies"
            },
            {
              "num": "5",
              "title": "Ben Solo",
              "meta": "Dan Tearle"
            },
            {
              "num": "6",
              "title": "Han Solo",
              "meta": "Dan Bergren"
            },
            {
              "num": "7",
              "title": "Wrecker",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "8",
              "title": "Caleb Dume",
              "meta": "Candice Dailey"
            },
            {
              "num": "9",
              "title": "Bodhi Rook",
              "meta": "Jason Davies"
            },
            {
              "num": "10",
              "title": "Flame Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "11",
              "title": "Qi'ra",
              "meta": "Dan Bergren"
            },
            {
              "num": "12",
              "title": "Tech",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "13",
              "title": "Wilhuff Tarkin",
              "meta": "Candice Dailey"
            },
            {
              "num": "14",
              "title": "Captain Cassian Andor",
              "meta": "Jason Davies"
            },
            {
              "num": "15",
              "title": "Rey's Speeder",
              "meta": "Dan Tearle"
            },
            {
              "num": "16",
              "title": "Tobias Beckett",
              "meta": "Dan Bergren"
            },
            {
              "num": "17",
              "title": "Crosshair",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "18",
              "title": "Saw Gerrera",
              "meta": "Candice Dailey"
            },
            {
              "num": "19",
              "title": "Chirrut Îmwe",
              "meta": "Jason Davies"
            },
            {
              "num": "20",
              "title": "Supreme Leader Snoke",
              "meta": "Dan Tearle"
            },
            {
              "num": "21",
              "title": "Poe Dameron",
              "meta": "Dan Bergren"
            },
            {
              "num": "22",
              "title": "Echo",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "23",
              "title": "Dark Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "24",
              "title": "Galen Erso",
              "meta": "Jason Davies"
            },
            {
              "num": "25",
              "title": "BB-8",
              "meta": "Dan Tearle"
            },
            {
              "num": "26",
              "title": "Finn",
              "meta": "Dan Bergren"
            },
            {
              "num": "27",
              "title": "Cad Bane",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "28",
              "title": "General Leia Organa",
              "meta": "Candice Dailey"
            },
            {
              "num": "29",
              "title": "Jyn Erso",
              "meta": "Jason Davies"
            },
            {
              "num": "30",
              "title": "AT-ST Walker",
              "meta": "Dan Tearle"
            },
            {
              "num": "31",
              "title": "Obi-Wan Kenobi",
              "meta": "Dan Bergren"
            },
            {
              "num": "32",
              "title": "Captain Rex",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "33",
              "title": "Rose Tico",
              "meta": "Candice Dailey"
            },
            {
              "num": "34",
              "title": "K-2SO",
              "meta": "Jason Davies"
            },
            {
              "num": "35",
              "title": "C-3PO",
              "meta": "Dan Tearle"
            },
            {
              "num": "36",
              "title": "Jango Fett",
              "meta": "Dan Bergren"
            },
            {
              "num": "37",
              "title": "Jesse",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "38",
              "title": "Padmé Amidala",
              "meta": "Candice Dailey"
            },
            {
              "num": "39",
              "title": "Jabba the Hutt",
              "meta": "Jason Davies"
            },
            {
              "num": "40",
              "title": "R2-D2",
              "meta": "Dan Tearle"
            },
            {
              "num": "41",
              "title": "Anakin Skywalker",
              "meta": "Dan Bergren"
            },
            {
              "num": "42",
              "title": "Cobb Vanth",
              "meta": "Candice Dailey"
            },
            {
              "num": "43",
              "title": "Zam Wesell",
              "meta": "Candice Dailey"
            },
            {
              "num": "44",
              "title": "Greedo",
              "meta": "Jason Davies"
            },
            {
              "num": "45",
              "title": "Darth Vader",
              "meta": "Dan Tearle"
            },
            {
              "num": "46",
              "title": "Qui-Gon Jinn",
              "meta": "Dan Bergren"
            },
            {
              "num": "47",
              "title": "Ahsoka Tano",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "48",
              "title": "Hera Syndulla",
              "meta": "Candice Dailey"
            },
            {
              "num": "49",
              "title": "Saw Gerrera",
              "meta": "Jason Davies"
            },
            {
              "num": "50",
              "title": "Han Solo",
              "meta": "Dan Tearle"
            },
            {
              "num": "51",
              "title": "Lando Calrissian",
              "meta": "Dan Bergren"
            },
            {
              "num": "52",
              "title": "Captain Phasma",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "53",
              "title": "Kanan Jarrus",
              "meta": "Candice Dailey"
            },
            {
              "num": "54",
              "title": "Zorii Bliss",
              "meta": "Jason Davies"
            },
            {
              "num": "55",
              "title": "Scout Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "56",
              "title": "Ben Kenobi",
              "meta": "Dan Bergren"
            },
            {
              "num": "57",
              "title": "Nien Nunb",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "58",
              "title": "The Grand Inquisitor",
              "meta": "Candice Dailey"
            },
            {
              "num": "59",
              "title": "Chewbacca",
              "meta": "Jason Davies"
            },
            {
              "num": "60",
              "title": "Snow Trooper",
              "meta": "Dan Tearle"
            },
            {
              "num": "61",
              "title": "Yoda",
              "meta": "Dan Bergren"
            },
            {
              "num": "62",
              "title": "Luke Skywalker",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "63",
              "title": "Zeb Orrelios",
              "meta": "Candice Dailey"
            },
            {
              "num": "64",
              "title": "Darth Maul",
              "meta": "Jason Davies"
            },
            {
              "num": "65",
              "title": "AT-AT Walkers",
              "meta": "Dan Tearle"
            },
            {
              "num": "66",
              "title": "Princess Leia",
              "meta": "Dan Bergren"
            },
            {
              "num": "67",
              "title": "Ezra Bridger",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "68",
              "title": "The Mandalorian",
              "meta": "Candice Dailey"
            },
            {
              "num": "69",
              "title": "Darth Sidious",
              "meta": "Jason Davies"
            },
            {
              "num": "70",
              "title": "The Armorer",
              "meta": "Dan Tearle"
            },
            {
              "num": "71",
              "title": "Wicket W. Warrick",
              "meta": "Dan Bergren"
            },
            {
              "num": "72",
              "title": "Grand Admiral Thrawn",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "73",
              "title": "Greef Karga",
              "meta": "Candice Dailey"
            },
            {
              "num": "74",
              "title": "General Grievous",
              "meta": "Jason Davies"
            },
            {
              "num": "75",
              "title": "TIE Fighter",
              "meta": "Dan Tearle"
            },
            {
              "num": "76",
              "title": "Wedge Antilles",
              "meta": "Dan Bergren"
            },
            {
              "num": "77",
              "title": "Emperor Palpatine",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "78",
              "title": "The Client",
              "meta": "Candice Dailey"
            },
            {
              "num": "79",
              "title": "Jar Jar Binks",
              "meta": "Jason Davies"
            },
            {
              "num": "80",
              "title": "X-Wing Fighter",
              "meta": "Dan Tearle"
            },
            {
              "num": "81",
              "title": "Maz Kanata",
              "meta": "Dan Bergren"
            },
            {
              "num": "82",
              "title": "Rey",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "83",
              "title": "Moff Gideon",
              "meta": "Candice Dailey"
            },
            {
              "num": "84",
              "title": "Mace Windu",
              "meta": "Jason Davies"
            },
            {
              "num": "85",
              "title": "Boba Fett's Ship",
              "meta": "Dan Tearle"
            },
            {
              "num": "86",
              "title": "Snap Wexley",
              "meta": "Dan Bergren"
            },
            {
              "num": "87",
              "title": "Jawa",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "88",
              "title": "Bo-Katan Kryze",
              "meta": "Candice Dailey"
            },
            {
              "num": "89",
              "title": "Queen Amidala",
              "meta": "Jason Davies"
            },
            {
              "num": "90",
              "title": "Imperial Star Destroyer",
              "meta": "Dan Tearle"
            },
            {
              "num": "91",
              "title": "Grogu",
              "meta": "Dan Bergren"
            },
            {
              "num": "92",
              "title": "Ahsoka Tano",
              "meta": "Candice Dailey"
            },
            {
              "num": "93",
              "title": "Frog Lady",
              "meta": "Candice Dailey"
            },
            {
              "num": "94",
              "title": "Admiral Ackbar",
              "meta": "Jason Davies"
            },
            {
              "num": "95",
              "title": "The Razor Crest",
              "meta": "Dan Tearle"
            },
            {
              "num": "96",
              "title": "Kylo Ren",
              "meta": "Dan Bergren"
            },
            {
              "num": "97",
              "title": "Boba Fett",
              "meta": "Carlos Cabaleiro"
            },
            {
              "num": "98",
              "title": "Fennec Shand",
              "meta": "Candice Dailey"
            },
            {
              "num": "99",
              "title": "Boba Fett",
              "meta": "Jason Davies"
            },
            {
              "num": "100",
              "title": "Imperial Guard",
              "meta": "Dan Tearle"
            }
          ]
        }
      ]
    }
  },
  '2021-signature-series': {
    "setId": "2021-signature-series",
    "year": "2021",
    "brand": "TOPPS",
    "title": "STAR WARS SIGNATURE SERIES",
    "releaseDate": "2 / 17 / 2021",
    "lede": "The set that launched the all-autograph Signature Series line — one box, one pack, one encased signed card. The 163-card autograph run across the Cards I and Cards II blocks covers more than 100 signers with up to three image variations each, from Harrison Ford, Carrie Fisher, Ewan McGregor, and Adam Driver to the deepest cast cuts, and the chase tops out with eight dual and eight triple autographs. Every base autograph climbs a six-tier ladder from Purple /99 to the one-of-one Red.",
    "stats": [
      {
        "num": "179",
        "label": "Auto Cards",
        "sub": "Every card is signed",
        "color": "gold"
      },
      {
        "num": "98",
        "label": "Cards I",
        "sub": "The flagship signer block",
        "color": "cyan"
      },
      {
        "num": "65",
        "label": "Cards II",
        "sub": "The second signer block",
        "color": "green"
      },
      {
        "num": "16",
        "label": "Multi-Signed",
        "sub": "8 duals · 8 triples",
        "color": "purple"
      },
      {
        "num": "4",
        "label": "Sub-sets Total",
        "sub": "Tracked on CK",
        "color": "red"
      }
    ],
    "hobbyBox": [
      {
        "v": "1",
        "l": "Encased autograph per box"
      },
      {
        "v": "1",
        "l": "Card per pack · 1 pack per box"
      },
      {
        "v": "20",
        "l": "Boxes per case"
      },
      {
        "v": "100+",
        "l": "Signers across Cards I + II"
      }
    ],
    "pullRates": [
      {
        "name": "Blue /50",
        "odds": "1 : 6",
        "tier": "normal"
      },
      {
        "name": "Green /25",
        "odds": "1 : 9",
        "tier": "normal"
      },
      {
        "name": "Orange /10",
        "odds": "1 : 19",
        "tier": "normal"
      },
      {
        "name": "Black /5",
        "odds": "1 : 32",
        "tier": "rare"
      },
      {
        "name": "Red 1/1",
        "odds": "1 : 143",
        "tier": "rare"
      },
      {
        "name": "Dual Autographs",
        "odds": "1 : 761",
        "tier": "mythic"
      },
      {
        "name": "Triple Autographs",
        "odds": "1 : 1,522",
        "tier": "mythic"
      },
      {
        "name": "Dual / Triple Red 1/1",
        "odds": "1 : 2,853",
        "tier": "mythic"
      }
    ],
    "parallelRainbow": [
      {
        "name": "AUTOGRAPH",
        "pr": "∞",
        "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
        "darkText": true
      },
      {
        "name": "PURPLE",
        "pr": "/99",
        "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
      },
      {
        "name": "BLUE",
        "pr": "/50",
        "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
      },
      {
        "name": "GREEN",
        "pr": "/25",
        "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
        "darkText": true
      },
      {
        "name": "ORANGE",
        "pr": "/10",
        "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
      },
      {
        "name": "BLACK",
        "pr": "/5",
        "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
      },
      {
        "name": "RED",
        "pr": "1/1",
        "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
      }
    ],
    "artists": [],
    "subsets": {
      "auto": [
        {
          "count": 98,
          "name": "AUTOGRAPH CARDS I",
          "meta": "The flagship signer block · 98 cards · Purple /99 → Red 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "A-AB",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "A-AB2",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "A-AB3",
              "title": "Ahmed Best",
              "meta": "Jar Jar Binks"
            },
            {
              "num": "A-AD",
              "title": "Adam Driver",
              "meta": "Kylo Ren"
            },
            {
              "num": "A-AD2",
              "title": "Adam Driver",
              "meta": "Kylo Ren"
            },
            {
              "num": "A-AD3",
              "title": "Adam Driver",
              "meta": "Ben Solo"
            },
            {
              "num": "A-AE",
              "title": "Ashley Eckstein",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "A-AE2",
              "title": "Ashley Eckstein",
              "meta": "Ahsoka Tano"
            },
            {
              "num": "A-AE3",
              "title": "Ashley Eckstein",
              "meta": "Aleena"
            },
            {
              "num": "A-AF",
              "title": "Anthony Forrest",
              "meta": "Fixer"
            },
            {
              "num": "A-AF2",
              "title": "Anthony Forrest",
              "meta": "Sandtrooper"
            },
            {
              "num": "A-AH",
              "title": "Alden Ehrenreich",
              "meta": "Han Solo"
            },
            {
              "num": "A-AH2",
              "title": "Alden Ehrenreich",
              "meta": "Han Solo"
            },
            {
              "num": "A-AS",
              "title": "Andy Serkis",
              "meta": "Supreme Leader Snoke"
            },
            {
              "num": "A-AS2",
              "title": "Andy Serkis",
              "meta": "Supreme Leader Snoke"
            },
            {
              "num": "A-BB",
              "title": "Ben Burtt",
              "meta": "Colonel Dyer"
            },
            {
              "num": "A-BB2",
              "title": "Ben Burtt",
              "meta": "BD-1"
            },
            {
              "num": "A-BL",
              "title": "Billie Lourd",
              "meta": "Kaydel Ko Connix"
            },
            {
              "num": "A-BL2",
              "title": "Billie Lourd",
              "meta": "Kaydel Ko Connix"
            },
            {
              "num": "A-BL3",
              "title": "Billie Lourd",
              "meta": "Kaydel Ko Connix"
            },
            {
              "num": "A-BW",
              "title": "Billy Dee Williams",
              "meta": "Lando Calrissian"
            },
            {
              "num": "A-BW2",
              "title": "Billy Dee Williams",
              "meta": "Lando Calrissian"
            },
            {
              "num": "A-BW3",
              "title": "Billy Dee Williams",
              "meta": "Lando Calrissian"
            },
            {
              "num": "A-CC",
              "title": "Cavin Cornwall",
              "meta": "Pemmin Brunce"
            },
            {
              "num": "A-CF",
              "title": "Carrie Fisher",
              "meta": "Princess Leia Organa"
            },
            {
              "num": "A-CF2",
              "title": "Carrie Fisher",
              "meta": "General Leia Organa"
            },
            {
              "num": "A-DB",
              "title": "DEE Bradley Baker",
              "meta": "Commander Cody"
            },
            {
              "num": "A-DB2",
              "title": "DEE Bradley Baker",
              "meta": "Kassius Konstantine"
            },
            {
              "num": "A-DB3",
              "title": "DEE Bradley Baker",
              "meta": "Bossk"
            },
            {
              "num": "A-DG",
              "title": "Domhnall Gleeson",
              "meta": "General Hux"
            },
            {
              "num": "A-DG2",
              "title": "Domhnall Gleeson",
              "meta": "General Hux"
            },
            {
              "num": "A-DG3",
              "title": "Domhnall Gleeson",
              "meta": "General Hux"
            },
            {
              "num": "A-DL",
              "title": "Daniel Logan",
              "meta": "Boba Fett"
            },
            {
              "num": "A-DL2",
              "title": "Daniel Logan",
              "meta": "Boba Fett"
            },
            {
              "num": "A-DR",
              "title": "Daisy Ridley",
              "meta": "Rey"
            },
            {
              "num": "A-DR2",
              "title": "Daisy Ridley",
              "meta": "Rey"
            },
            {
              "num": "A-DR3",
              "title": "Daisy Ridley",
              "meta": "Dark Rey"
            },
            {
              "num": "A-EW",
              "title": "Ewan McGregor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "A-EW2",
              "title": "Ewan McGregor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "A-EW3",
              "title": "Ewan McGregor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "A-FJ",
              "title": "Felicity Jones",
              "meta": "Jyn Erso"
            },
            {
              "num": "A-FJ2",
              "title": "Felicity Jones",
              "meta": "Jyn Erso"
            },
            {
              "num": "A-FJ3",
              "title": "Felicity Jones",
              "meta": "Jyn Erso"
            },
            {
              "num": "A-FP",
              "title": "Freddie Prinze Jr.",
              "meta": "Kanan Jarrus"
            },
            {
              "num": "A-FP2",
              "title": "Freddie Prinze Jr.",
              "meta": "Kanan Jarrus"
            },
            {
              "num": "A-GC",
              "title": "Gwendoline Christie",
              "meta": "Captain Phasma"
            },
            {
              "num": "A-GC2",
              "title": "Gwendoline Christie",
              "meta": "Captain Phasma"
            },
            {
              "num": "A-GG",
              "title": "Greg Grunberg",
              "meta": "Snap Wexley"
            },
            {
              "num": "A-GG2",
              "title": "Greg Grunberg",
              "meta": "Snap Wexley"
            },
            {
              "num": "A-GO",
              "title": "Genevieve O'Reilly",
              "meta": "Mon Mothma"
            },
            {
              "num": "A-HC",
              "title": "Hayden Christensen",
              "meta": "Anakin Skywalker"
            },
            {
              "num": "A-HC2",
              "title": "Hayden Christensen",
              "meta": "Anakin Skywalker"
            },
            {
              "num": "A-HC3",
              "title": "Hayden Christensen",
              "meta": "Darth Vader"
            },
            {
              "num": "A-IM",
              "title": "Ian McDiarmid",
              "meta": "Senator Palpatine"
            },
            {
              "num": "A-IM2",
              "title": "Ian McDiarmid",
              "meta": "Darth Sidious"
            },
            {
              "num": "A-IM3",
              "title": "Ian McDiarmid",
              "meta": "Emperor Palpatine"
            },
            {
              "num": "A-IW",
              "title": "Ian Whyte",
              "meta": "Moroff"
            },
            {
              "num": "A-IW2",
              "title": "Ian Whyte",
              "meta": "Bollie Prindel"
            },
            {
              "num": "A-JB",
              "title": "John Boyega",
              "meta": "Finn"
            },
            {
              "num": "A-JB2",
              "title": "John Boyega",
              "meta": "Finn"
            },
            {
              "num": "A-JB3",
              "title": "John Boyega",
              "meta": "Finn"
            },
            {
              "num": "A-JS",
              "title": "Joonas Suotamo",
              "meta": "Chewbacca"
            },
            {
              "num": "A-JS2",
              "title": "Joonas Suotamo",
              "meta": "Chewbacca"
            },
            {
              "num": "A-JT",
              "title": "James Arnold Taylor",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "A-JT2",
              "title": "James Arnold Taylor",
              "meta": "Plo Koon"
            },
            {
              "num": "A-JT3",
              "title": "James Arnold Taylor",
              "meta": "Rako Hardeen"
            },
            {
              "num": "A-KB",
              "title": "Kenny Baker",
              "meta": "R2-D2"
            },
            {
              "num": "A-KB2",
              "title": "Kenny Baker",
              "meta": "R2-D2"
            },
            {
              "num": "A-KB3",
              "title": "Kenny Baker",
              "meta": "R2-D2"
            },
            {
              "num": "A-KT",
              "title": "Kelly Marie Tran",
              "meta": "Rose Tico"
            },
            {
              "num": "A-KT2",
              "title": "Kelly Marie Tran",
              "meta": "Rose Tico"
            },
            {
              "num": "A-PM",
              "title": "Peter Mayhew",
              "meta": "Chewbacca"
            },
            {
              "num": "A-PM2",
              "title": "Peter Mayhew",
              "meta": "Chewbacca"
            },
            {
              "num": "A-PM3",
              "title": "Peter Mayhew",
              "meta": "Chewbacca"
            },
            {
              "num": "A-RD",
              "title": "Robin Atkin Downes",
              "meta": "Cham Syndulla"
            },
            {
              "num": "A-RD2",
              "title": "Robin Atkin Downes",
              "meta": "Rush Clovis"
            },
            {
              "num": "A-RP",
              "title": "Ray Park",
              "meta": "Darth Maul"
            },
            {
              "num": "A-RP2",
              "title": "Ray Park",
              "meta": "Darth Maul"
            },
            {
              "num": "A-RP3",
              "title": "Ray Park",
              "meta": "Maul"
            },
            {
              "num": "A-S",
              "title": "Stephen Stanton",
              "meta": "Obi-Wan Kenobi"
            },
            {
              "num": "A-S2",
              "title": "Stephen Stanton",
              "meta": "Mas Amedda"
            },
            {
              "num": "A-S3",
              "title": "Stephen Stanton",
              "meta": "Moralo Eval"
            },
            {
              "num": "A-SJ",
              "title": "Samuel L. Jackson",
              "meta": "Mace Windu"
            },
            {
              "num": "A-SJ2",
              "title": "Samuel L. Jackson",
              "meta": "Mace Windu"
            },
            {
              "num": "A-SJ3",
              "title": "Samuel L. Jackson",
              "meta": "Mace Windu"
            },
            {
              "num": "A-SW",
              "title": "Sam Witwer",
              "meta": "Mortis Son"
            },
            {
              "num": "A-SW2",
              "title": "Sam Witwer",
              "meta": "Maul"
            },
            {
              "num": "A-SW3",
              "title": "Sam Witwer",
              "meta": "Emperor Palpatine"
            },
            {
              "num": "A-TG",
              "title": "Taylor Gray",
              "meta": "Ezra Bridger"
            },
            {
              "num": "A-TG2",
              "title": "Taylor Gray",
              "meta": "Ezra Bridger"
            },
            {
              "num": "A-TM",
              "title": "Temuera Morrison",
              "meta": "Jango Fett"
            },
            {
              "num": "A-TM2",
              "title": "Temuera Morrison",
              "meta": "Boba Fett"
            },
            {
              "num": "A-TR",
              "title": "Tim Rose",
              "meta": "Admiral Ackbar"
            },
            {
              "num": "A-TR2",
              "title": "Tim Rose",
              "meta": "Admiral Ackbar"
            },
            {
              "num": "A-TR3",
              "title": "Tim Rose",
              "meta": "Admiral Ackbar"
            },
            {
              "num": "A-WD",
              "title": "Warwick Davis",
              "meta": "Wicket W. Warrick"
            },
            {
              "num": "A-WD2",
              "title": "Warwick Davis",
              "meta": "Weazel"
            },
            {
              "num": "A-WD3",
              "title": "Warwick Davis",
              "meta": "Rukh"
            }
          ]
        },
        {
          "count": 65,
          "name": "AUTOGRAPH CARDS II",
          "meta": "The second signer block · 65 cards · Purple /99 → Red 1/1",
          "parallels": 6,
          "cards": [
            {
              "num": "A-A",
              "title": "Annabelle Davis",
              "meta": "Thromba"
            },
            {
              "num": "A-A2",
              "title": "Annabelle Davis",
              "meta": "WG-22"
            },
            {
              "num": "A-AG",
              "title": "Anna Graves",
              "meta": "Sugi"
            },
            {
              "num": "A-AG2",
              "title": "Anna Graves",
              "meta": "Satine Kryze"
            },
            {
              "num": "A-ASG",
              "title": "Arti Shah",
              "meta": "Gwellis Bagnoro"
            },
            {
              "num": "A-BBE",
              "title": "Blair Bess",
              "meta": "Even Piell"
            },
            {
              "num": "A-BM",
              "title": "Ben Mendelsohn",
              "meta": "Director Krennic"
            },
            {
              "num": "A-BMR",
              "title": "Bobby Moynihan",
              "meta": "Orka"
            },
            {
              "num": "A-CC2",
              "title": "Cavin Cornwall",
              "meta": "Sidon Ithano"
            },
            {
              "num": "A-CDW",
              "title": "Corey Dee Williams",
              "meta": "Klaatu"
            },
            {
              "num": "A-CH",
              "title": "Clint Howard",
              "meta": "Ralakili"
            },
            {
              "num": "A-CM",
              "title": "Cameron Monaghan",
              "meta": "Cal Kestis"
            },
            {
              "num": "A-CW",
              "title": "Carl Weathers",
              "meta": "Greef Karga"
            },
            {
              "num": "A-DA",
              "title": "Derek Arnold",
              "meta": "Chancellor Villecham"
            },
            {
              "num": "A-DA2",
              "title": "Derek Arnold",
              "meta": "Pao"
            },
            {
              "num": "A-DA3",
              "title": "Derek Arnold",
              "meta": "Bor Gullet"
            },
            {
              "num": "A-DC",
              "title": "Dave Chapman",
              "meta": "SE-2 \"Essie\" Worker Droid"
            },
            {
              "num": "A-DC2",
              "title": "Dave Chapman",
              "meta": "BB-8"
            },
            {
              "num": "A-DF",
              "title": "Donald Faison",
              "meta": "Hype Fazon"
            },
            {
              "num": "A-DM",
              "title": "Dominic Monaghan",
              "meta": "Beaumont Kin"
            },
            {
              "num": "A-DT",
              "title": "Dee Tails",
              "meta": "K-0HN"
            },
            {
              "num": "A-DT2",
              "title": "Dee Tails",
              "meta": "Quay Tolsite"
            },
            {
              "num": "A-DT3",
              "title": "Dee Tails",
              "meta": "Cratinus"
            },
            {
              "num": "A-DW",
              "title": "Debra Wilson",
              "meta": "Cere Junda"
            },
            {
              "num": "A-DY",
              "title": "Donnie Yen",
              "meta": "Chirrut Îmwe"
            },
            {
              "num": "A-ES",
              "title": "Emily Swallow",
              "meta": "The Armorer"
            },
            {
              "num": "A-FW",
              "title": "Forest Whitaker",
              "meta": "Saw Gerrera"
            },
            {
              "num": "A-GCM",
              "title": "Gina Carano",
              "meta": "Cara Dune"
            },
            {
              "num": "A-GE",
              "title": "Giancarlo Esposito",
              "meta": "Moff Gideon"
            },
            {
              "num": "A-GP",
              "title": "Greg Proops",
              "meta": "Fode"
            },
            {
              "num": "A-HD",
              "title": "Harley Durst",
              "meta": "Moloch"
            },
            {
              "num": "A-HF",
              "title": "Harrison Ford",
              "meta": "Han Solo"
            },
            {
              "num": "A-HF2",
              "title": "Harrison Ford",
              "meta": "Han Solo"
            },
            {
              "num": "A-HF3",
              "title": "Harrison Ford",
              "meta": "Han Solo"
            },
            {
              "num": "A-HS",
              "title": "Horatio Sanz",
              "meta": "Mythrol"
            },
            {
              "num": "A-IR",
              "title": "Ian Ruskin",
              "meta": "Chancellor Valorum"
            },
            {
              "num": "A-JK",
              "title": "Jaime King",
              "meta": "Aurra Sing"
            },
            {
              "num": "A-JR",
              "title": "Jerome Blake",
              "meta": "Mas Amedda"
            },
            {
              "num": "A-JR2",
              "title": "Jerome Blake",
              "meta": "Rune Haako"
            },
            {
              "num": "A-JTS",
              "title": "John Tui",
              "meta": "Korso"
            },
            {
              "num": "A-LT",
              "title": "Lee Towersey",
              "meta": "R2-D2"
            },
            {
              "num": "A-MD",
              "title": "Matt Doran",
              "meta": "Elan Sleazebaggano"
            },
            {
              "num": "A-MM",
              "title": "Mads Mikkelsen",
              "meta": "Galen Erso"
            },
            {
              "num": "A-NF",
              "title": "Nika Futterman",
              "meta": "Asajj Ventress"
            },
            {
              "num": "A-NF2",
              "title": "Nika Futterman",
              "meta": "Sy Snootles"
            },
            {
              "num": "A-NF3",
              "title": "Nika Futterman",
              "meta": "TC-70"
            },
            {
              "num": "A-NK",
              "title": "Nick Kellington",
              "meta": "Bistan"
            },
            {
              "num": "A-NK2",
              "title": "Nick Kellington",
              "meta": "Klaud"
            },
            {
              "num": "A-NN",
              "title": "Nick Nolte",
              "meta": "Kuiil"
            },
            {
              "num": "A-PA",
              "title": "Philip Anthony-Rodriguez",
              "meta": "Fifth Brother"
            },
            {
              "num": "A-PB",
              "title": "Paul Bettany",
              "meta": "Dryden Vos"
            },
            {
              "num": "A-PP",
              "title": "Pedro Pascal",
              "meta": "The Mandalorian"
            },
            {
              "num": "A-RA",
              "title": "Riz Ahmed",
              "meta": "Bodhi Rook"
            },
            {
              "num": "A-RPC",
              "title": "Ron Perlman",
              "meta": "Gha Nachkt"
            },
            {
              "num": "A-TBS",
              "title": "Thomas Brodie-Sangster",
              "meta": "Petty Officer Thanisson"
            },
            {
              "num": "A-TD",
              "title": "Tim Dry",
              "meta": "J'Quille"
            },
            {
              "num": "A-TF",
              "title": "Tovah Feldshuh",
              "meta": "Aunt Z"
            },
            {
              "num": "A-TK",
              "title": "Tom Kenny",
              "meta": "Nute Gunray"
            },
            {
              "num": "A-TK2",
              "title": "Tom Kenny",
              "meta": "Greedo"
            },
            {
              "num": "A-TK3",
              "title": "Tom Kenny",
              "meta": "Silood"
            },
            {
              "num": "A-TW",
              "title": "Taika Waititi",
              "meta": "IG-11"
            },
            {
              "num": "A-WA",
              "title": "Denis Lawson",
              "meta": "Wedge Antilles"
            },
            {
              "num": "A-WA2",
              "title": "Denis Lawson",
              "meta": "Wedge Antilles"
            },
            {
              "num": "A-WA3",
              "title": "Denis Lawson",
              "meta": "Wedge Antilles"
            },
            {
              "num": "A-WH",
              "title": "Werner Herzog",
              "meta": "The Client"
            }
          ]
        },
        {
          "count": 8,
          "name": "DUAL AUTOGRAPHS",
          "meta": "8 pairings · serial numbered, run unpublished · Red 1/1",
          "parallels": 1,
          "cards": [
            {
              "num": "DA-BC",
              "title": "Gwendoline Christie / John Boyega",
              "meta": "Captain Phasma / Finn"
            },
            {
              "num": "DA-CM",
              "title": "Ian McDiarmid / Hayden Christensen",
              "meta": "Emperor Palpatine / Darth Vader"
            },
            {
              "num": "DA-EB",
              "title": "Alden Ehrenreich / Paul Bettany",
              "meta": "Han Solo / Dryden Vos"
            },
            {
              "num": "DA-JM",
              "title": "Ben Mendelsohn / Felicity Jones",
              "meta": "Director Krennic / Jyn Erso"
            },
            {
              "num": "DA-LE",
              "title": "Ashley Eckstein / Matt Lanter",
              "meta": "Ahsoka Tano / Anakin Skywalker"
            },
            {
              "num": "DA-PE",
              "title": "Giancarlo Esposito / Pedro Pascal",
              "meta": "Moff Gideon / The Mandalorian"
            },
            {
              "num": "DA-RD",
              "title": "Daisy Ridley / Adam Driver",
              "meta": "Kylo Ren / Dark Rey"
            },
            {
              "num": "DA-WM",
              "title": "Peter Mayhew / Billy Dee Williams",
              "meta": "Lando Calrissian / Chewbacca"
            }
          ]
        },
        {
          "count": 8,
          "name": "TRIPLE AUTOGRAPHS",
          "meta": "8 trios · serial numbered, run unpublished · Red 1/1",
          "parallels": 1,
          "cards": [
            {
              "num": "TA-DCG",
              "title": "Adam Driver / Gwendoline Christie / Domhnall Gleeson",
              "meta": "Kylo Ren / Captain Phasma / General Hux"
            },
            {
              "num": "TA-EFS",
              "title": "Nika Futterman / Ashley Eckstein / Meredith Salenger",
              "meta": "Ahsoka Tano / Asajj Ventress / Barriss Offee"
            },
            {
              "num": "TA-ESK",
              "title": "Alden Ehrenreich / Joonas Suotamo / Erin Kellyman",
              "meta": "Han Solo / Chewbacca / Enfys Nest"
            },
            {
              "num": "TA-JWA",
              "title": "Felicity Jones / Forest Whitaker / Riz Ahmed",
              "meta": "Jyn Erso / Saw Gerrera / Bodhi Rook"
            },
            {
              "num": "TA-PGM",
              "title": "Freddie Prinze Jr. / Taylor Gray / Vanessa Marshall",
              "meta": "Kanan Jarrus / Ezra Bridger / Hera Syndulla"
            },
            {
              "num": "TA-PWN",
              "title": "Pedro Pascal / Taika Waititi / Nick Nolte",
              "meta": "The Mandalorian / IG-11 / Kuiil"
            },
            {
              "num": "TA-RDB",
              "title": "Daisy Ridley / Adam Driver / John Boyega",
              "meta": "Rey / Kylo Ren / Finn"
            },
            {
              "num": "TA-RTL",
              "title": "Daisy Ridley / Kelly Marie Tran / Billie Lourd",
              "meta": "Rey / Rose Tico / Kaydel Ko Connix"
            }
          ]
        }
      ]
    }
  },

  '2023-signature-series': {
      "setId": "2023-signature-series",
      "year": "2023",
      "brand": "TOPPS",
      "title": "STAR WARS SIGNATURE SERIES",
      "releaseDate": "3 / 31 / 2023",
      "lede": "The all-autograph product — one box, one pack, one encased signed card. The 134-signer Design A line runs from Harrison Ford, Ewan McGregor, Natalie Portman, and Werner Herzog to the deepest cast cuts, the 67-card Design B line puts its signatures on the 1983 Topps Return of the Jedi design for the 40th anniversary, and the chase tops out with dual and triple autographs and two one-of-one Light Side / Dark Side quad autographs carrying four signatures each. Every design climbs the same five-tier ladder from Blue /50 to the one-of-one Red.",
      "stats": [
          {
              "num": "209",
              "label": "Auto Cards",
              "sub": "Every card is signed",
              "color": "gold"
          },
          {
              "num": "134",
              "label": "Design A",
              "sub": "The main autograph line",
              "color": "cyan"
          },
          {
              "num": "67",
              "label": "Design B",
              "sub": "1983 ROTJ 40th design",
              "color": "green"
          },
          {
              "num": "8",
              "label": "Multi-Signed",
              "sub": "Duals · triples · quads",
              "color": "purple"
          },
          {
              "num": "5",
              "label": "Sub-sets Total",
              "sub": "Tracked on CK",
              "color": "red"
          }
      ],
      "hobbyBox": [
          {
              "v": "1",
              "l": "Encased autograph per box"
          },
          {
              "v": "1",
              "l": "Card per pack · 1 pack per box"
          },
          {
              "v": "20",
              "l": "Boxes per case"
          },
          {
              "v": "2",
              "l": "Designs · A + the 1983 ROTJ 40th B"
          }
      ],
      "pullRates": [
          {
              "name": "Design A Blue /50",
              "odds": "1 : 7",
              "tier": "normal"
          },
          {
              "name": "Design B Autograph",
              "odds": "1 : 9",
              "tier": "normal"
          },
          {
              "name": "Design A Red 1/1",
              "odds": "1 : 295",
              "tier": "rare"
          },
          {
              "name": "Design B Red 1/1",
              "odds": "1 : 768",
              "tier": "rare"
          },
          {
              "name": "Dual Autographs",
              "odds": "1 : 2,816",
              "tier": "mythic"
          },
          {
              "name": "Triple Autographs",
              "odds": "1 : 2,816",
              "tier": "mythic"
          },
          {
              "name": "Light Side / Dark Side Quad 1/1",
              "odds": "1 : 14,080",
              "tier": "mythic"
          }
      ],
      "parallelRainbow": [
          {
              "name": "AUTOGRAPH",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #e8e8f0 0%, #b0b0c0 100%)",
              "darkText": true
          },
          {
              "name": "BLUE",
              "pr": "/50",
              "gradient": "linear-gradient(135deg, #4d9fff 0%, #1a5fd0 100%)"
          },
          {
              "name": "GREEN",
              "pr": "/25",
              "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
              "darkText": true
          },
          {
              "name": "ORANGE",
              "pr": "/10",
              "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
          },
          {
              "name": "BLACK",
              "pr": "/5",
              "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
          },
          {
              "name": "RED",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
          }
      ],
      "artists": [],
      "subsets": {
          "auto": [
              {
                  "count": 134,
                  "name": "AUTOGRAPHS DESIGN A",
                  "meta": "The main line · 134 signers · Blue /50 → Red 1/1",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "A-AB",
                          "title": "Ahmed Best",
                          "meta": "Jar Jar Binks"
                      },
                      {
                          "num": "A-ABA",
                          "title": "Andrea Bartlow",
                          "meta": "Twi'lek Server"
                      },
                      {
                          "num": "A-AC",
                          "title": "Aidan Cook",
                          "meta": "Strono \"Cookie\" Tuggs"
                      },
                      {
                          "num": "A-AD",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "A-AE",
                          "title": "Alden Ehrenreich",
                          "meta": "Han Solo"
                      },
                      {
                          "num": "A-AEC",
                          "title": "Ashley Eckstein",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "A-AG",
                          "title": "Allan Graf",
                          "meta": "Bartender"
                      },
                      {
                          "num": "A-AH",
                          "title": "Alfred Hsing",
                          "meta": "Pyke Traveler"
                      },
                      {
                          "num": "A-AK",
                          "title": "Andrew Kishino",
                          "meta": "Izuma"
                      },
                      {
                          "num": "A-AP",
                          "title": "Alistair Petrie",
                          "meta": "General Draven"
                      },
                      {
                          "num": "A-APE",
                          "title": "Angelique Perrin",
                          "meta": "Adi Gallia"
                      },
                      {
                          "num": "A-AS",
                          "title": "Andy Serkis",
                          "meta": "Supreme Leader Snoke"
                      },
                      {
                          "num": "A-ASE",
                          "title": "Amy Sedaris",
                          "meta": "Peli Motto"
                      },
                      {
                          "num": "A-AT",
                          "title": "Alan Tudyk",
                          "meta": "K-2SO"
                      },
                      {
                          "num": "A-AW",
                          "title": "Alexander Wraith",
                          "meta": "Imperial Freighter Pilot"
                      },
                      {
                          "num": "A-BB",
                          "title": "Bernard Bullen",
                          "meta": "Father of the Mandalorian"
                      },
                      {
                          "num": "A-BD",
                          "title": "Ben Diskin",
                          "meta": "AZI-3"
                      },
                      {
                          "num": "A-BH",
                          "title": "Brian Herring",
                          "meta": "BB-8"
                      },
                      {
                          "num": "A-BL",
                          "title": "Billie Lourd",
                          "meta": "Kaydel Ko Connix"
                      },
                      {
                          "num": "A-BLO",
                          "title": "Barry Lowin",
                          "meta": "Garfalaquox"
                      },
                      {
                          "num": "A-BM",
                          "title": "Ben Mendelsohn",
                          "meta": "Director Krennic"
                      },
                      {
                          "num": "A-BP",
                          "title": "Bonnie Piesse",
                          "meta": "Beru Lars"
                      },
                      {
                          "num": "A-CB",
                          "title": "Chris Bartlett",
                          "meta": "Zero"
                      },
                      {
                          "num": "A-CBL",
                          "title": "Caroline Blakiston",
                          "meta": "Mon Mothma"
                      },
                      {
                          "num": "A-CC",
                          "title": "Crystal Clarke",
                          "meta": "Pammich Nerro Goode"
                      },
                      {
                          "num": "A-CE",
                          "title": "Chris Edgerly",
                          "meta": "Eeth Koth"
                      },
                      {
                          "num": "A-CH",
                          "title": "Clint Howard",
                          "meta": "Ralakili"
                      },
                      {
                          "num": "A-CJ",
                          "title": "Carey Jones",
                          "meta": "Krrsantan"
                      },
                      {
                          "num": "A-CL",
                          "title": "Charlotte Louise",
                          "meta": "Margo"
                      },
                      {
                          "num": "A-CP",
                          "title": "Chris Parsons",
                          "meta": "4-LOM"
                      },
                      {
                          "num": "A-CS",
                          "title": "Christopher Sean",
                          "meta": "Kazuda Xiono"
                      },
                      {
                          "num": "A-CW",
                          "title": "Carl Weathers",
                          "meta": "Greef Karga"
                      },
                      {
                          "num": "A-CWI",
                          "title": "Corey Dee Williams",
                          "meta": "Klaatu"
                      },
                      {
                          "num": "A-DA",
                          "title": "David Acord",
                          "meta": "Edrio Two Tubes"
                      },
                      {
                          "num": "A-DBI",
                          "title": "Dmitrious Bistrevsky",
                          "meta": "Quarren Trawler"
                      },
                      {
                          "num": "A-DC",
                          "title": "Dave Chapman",
                          "meta": "BB-8"
                      },
                      {
                          "num": "A-DG",
                          "title": "Domhnall Gleeson",
                          "meta": "General Hux"
                      },
                      {
                          "num": "A-DK",
                          "title": "Dorian Kingi",
                          "meta": "Cad Bane"
                      },
                      {
                          "num": "A-DLU",
                          "title": "Diego Luna",
                          "meta": "Cassian Andor"
                      },
                      {
                          "num": "A-DM",
                          "title": "Dominic Monaghan",
                          "meta": "Beaumont Kin"
                      },
                      {
                          "num": "A-DP",
                          "title": "David Pasquesi",
                          "meta": "Twi'lek Majordomo"
                      },
                      {
                          "num": "A-DY",
                          "title": "Donnie Yen",
                          "meta": "Chirrut Îmwe"
                      },
                      {
                          "num": "A-EC",
                          "title": "Emilia Clarke",
                          "meta": "Qi'ra"
                      },
                      {
                          "num": "A-EK",
                          "title": "Erin Kellyman",
                          "meta": "Enfys Nest"
                      },
                      {
                          "num": "A-EM",
                          "title": "Ewan McGregor",
                          "meta": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "A-FJ",
                          "title": "Felicity Jones",
                          "meta": "Jyn Erso"
                      },
                      {
                          "num": "A-FP",
                          "title": "Freddie Prinze Jr.",
                          "meta": "Kanan Jarrus"
                      },
                      {
                          "num": "A-GE",
                          "title": "Giancarlo Esposito",
                          "meta": "Moff Gideon"
                      },
                      {
                          "num": "A-GH",
                          "title": "Guy Henry",
                          "meta": "Grand Moff Tarkin"
                      },
                      {
                          "num": "A-GT",
                          "title": "Gina Torres",
                          "meta": "Ketsu Onyo"
                      },
                      {
                          "num": "A-GTA",
                          "title": "George Takei",
                          "meta": "Lok Durd"
                      },
                      {
                          "num": "A-HCO",
                          "title": "Hermione Corfield",
                          "meta": "Tallie Lintra"
                      },
                      {
                          "num": "A-HD",
                          "title": "Harrison Davis",
                          "meta": "Pommet Warrick"
                      },
                      {
                          "num": "A-HF",
                          "title": "Harrison Ford",
                          "meta": "Han Solo"
                      },
                      {
                          "num": "A-HQ",
                          "title": "Hugh Quarshie",
                          "meta": "Captain Panaka"
                      },
                      {
                          "num": "A-JA",
                          "title": "Josef Altin",
                          "meta": "Seftin Vanik"
                      },
                      {
                          "num": "A-JB",
                          "title": "John Boyega",
                          "meta": "Finn"
                      },
                      {
                          "num": "A-JBE",
                          "title": "Joanna Bennett",
                          "meta": "Tusken Warrior"
                      },
                      {
                          "num": "A-JC",
                          "title": "Jim Cummings",
                          "meta": "Hondo Ohnaka"
                      },
                      {
                          "num": "A-JD",
                          "title": "Julie Dolan",
                          "meta": "Princess Leia Organa"
                      },
                      {
                          "num": "A-JG",
                          "title": "Julian Glover",
                          "meta": "General Veers"
                      },
                      {
                          "num": "A-JK",
                          "title": "Jaime King",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "A-JL",
                          "title": "John Leguizamo",
                          "meta": "Gor Koresh"
                      },
                      {
                          "num": "A-JR",
                          "title": "John Rosengrant",
                          "meta": "Mayor Mok Shaiz"
                      },
                      {
                          "num": "A-JS",
                          "title": "Jason Spisak",
                          "meta": "Lux Bonteri"
                      },
                      {
                          "num": "A-JW",
                          "title": "Jaden Waldman",
                          "meta": "T0-B1"
                      },
                      {
                          "num": "A-KB",
                          "title": "Kenny Baker",
                          "meta": "R2-D2"
                      },
                      {
                          "num": "A-KF",
                          "title": "Karen Fukuhara",
                          "meta": "F"
                      },
                      {
                          "num": "A-KG",
                          "title": "Kathleen Gati",
                          "meta": "Old Daka"
                      },
                      {
                          "num": "A-KK",
                          "title": "Katy Kartwheel",
                          "meta": "Rio Durant"
                      },
                      {
                          "num": "A-KO",
                          "title": "Katy O'Brian",
                          "meta": "Imperial Comms Officer"
                      },
                      {
                          "num": "A-KS",
                          "title": "Kiran Shah",
                          "meta": "Nambi Ghima"
                      },
                      {
                          "num": "A-KT",
                          "title": "Kelly Marie Tran",
                          "meta": "Rose Tico"
                      },
                      {
                          "num": "A-LC",
                          "title": "Lily Cole",
                          "meta": "Lovey"
                      },
                      {
                          "num": "A-LD",
                          "title": "Laura Dern",
                          "meta": "Vice Admiral Holdo"
                      },
                      {
                          "num": "A-LM",
                          "title": "Lars Mikkelsen",
                          "meta": "Grand Admiral Thrawn"
                      },
                      {
                          "num": "A-LN",
                          "title": "Lupita Nyong'o",
                          "meta": "Maz Kanata"
                      },
                      {
                          "num": "A-LT",
                          "title": "Lee Towersey",
                          "meta": "R2-D2"
                      },
                      {
                          "num": "A-LW",
                          "title": "Leeanna Walsman",
                          "meta": "Zam Wesell"
                      },
                      {
                          "num": "A-MB",
                          "title": "Matt Berry",
                          "meta": "8D8"
                      },
                      {
                          "num": "A-MBO",
                          "title": "Michonne Bourriague",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "A-MC",
                          "title": "Michaela Cottrell",
                          "meta": "Even Piell"
                      },
                      {
                          "num": "A-MCU",
                          "title": "Michael Culver",
                          "meta": "Captain Needa"
                      },
                      {
                          "num": "A-ME",
                          "title": "Mike Edmonds",
                          "meta": "Logray"
                      },
                      {
                          "num": "A-ML",
                          "title": "Matt Lanter",
                          "meta": "Anakin Skywalker"
                      },
                      {
                          "num": "A-MM",
                          "title": "Mads Mikkelsen",
                          "meta": "Galen Erso"
                      },
                      {
                          "num": "A-MMC",
                          "title": "Mary Elizabeth McGlynn",
                          "meta": "Governor Arihnda Pryce"
                      },
                      {
                          "num": "A-MQ",
                          "title": "Mike Quinn",
                          "meta": "Nien Nunb"
                      },
                      {
                          "num": "A-MV",
                          "title": "Mercedes Varnado",
                          "meta": "Koska Reeves"
                      },
                      {
                          "num": "A-MW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "A-MWO",
                          "title": "Matthew Wood",
                          "meta": "General Grievous"
                      },
                      {
                          "num": "A-NA",
                          "title": "Naomi Ackie",
                          "meta": "Jannah"
                      },
                      {
                          "num": "A-NF",
                          "title": "Nika Futterman",
                          "meta": "Asajj Ventress"
                      },
                      {
                          "num": "A-NN",
                          "title": "Nick Nolte",
                          "meta": "Kuiil"
                      },
                      {
                          "num": "A-NP",
                          "title": "Natalie Portman",
                          "meta": "Padmé Amidala"
                      },
                      {
                          "num": "A-OA",
                          "title": "Omid Abtahi",
                          "meta": "Dr. Pershing"
                      },
                      {
                          "num": "A-OD",
                          "title": "Olivia d'Abo",
                          "meta": "Luminara Unduli"
                      },
                      {
                          "num": "A-ODA",
                          "title": "Oliver Ford Davies",
                          "meta": "Governor Sio Bibble"
                      },
                      {
                          "num": "A-PA",
                          "title": "Philip Alexander",
                          "meta": "Imperial Security Officer"
                      },
                      {
                          "num": "A-PAN",
                          "title": "Philip Anthony-Rodriguez",
                          "meta": "Fifth Brother"
                      },
                      {
                          "num": "A-PD",
                          "title": "Paul Darnell",
                          "meta": "Night Wind Assassin"
                      },
                      {
                          "num": "A-PK",
                          "title": "Paul Kasey",
                          "meta": "C'ai Threnalli"
                      },
                      {
                          "num": "A-PLE",
                          "title": "Paul Sun-Hyung Lee",
                          "meta": "Carson Teva"
                      },
                      {
                          "num": "A-PRE",
                          "title": "Paul Reubens",
                          "meta": "RX-24"
                      },
                      {
                          "num": "A-PW",
                          "title": "Paul Warren",
                          "meta": "Hassk Triplet"
                      },
                      {
                          "num": "A-RA",
                          "title": "Riz Ahmed",
                          "meta": "Bodhi Rook"
                      },
                      {
                          "num": "A-RB",
                          "title": "Ralph Brown",
                          "meta": "Ric Olié"
                      },
                      {
                          "num": "A-RBR",
                          "title": "Richard Brake",
                          "meta": "Valin Hess"
                      },
                      {
                          "num": "A-RD",
                          "title": "Rosario Dawson",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "A-RDO",
                          "title": "Robin Atkin Downes",
                          "meta": "Cham Syndulla"
                      },
                      {
                          "num": "A-RG",
                          "title": "Richard E. Grant",
                          "meta": "Allegiant General Pryde"
                      },
                      {
                          "num": "A-RO",
                          "title": "Rena Owen",
                          "meta": "Taun We"
                      },
                      {
                          "num": "A-RP",
                          "title": "Ray Park",
                          "meta": "Darth Maul"
                      },
                      {
                          "num": "A-RPE",
                          "title": "Ron Perlman",
                          "meta": "Gha Nachkt"
                      },
                      {
                          "num": "A-RW",
                          "title": "Ryan Watson",
                          "meta": "Beta Trawler"
                      },
                      {
                          "num": "A-SB",
                          "title": "Steve Blum",
                          "meta": "Zeb Orrelios"
                      },
                      {
                          "num": "A-SBI",
                          "title": "Skyler Bible",
                          "meta": "Fixer"
                      },
                      {
                          "num": "A-SC",
                          "title": "Scott Capurro",
                          "meta": "Beed"
                      },
                      {
                          "num": "A-SGE",
                          "title": "Sarah Michelle Gellar",
                          "meta": "Seventh Sister"
                      },
                      {
                          "num": "A-SK",
                          "title": "Simon Kassianides",
                          "meta": "Axe Woves"
                      },
                      {
                          "num": "A-SL",
                          "title": "Scott Lawrence",
                          "meta": "Jarek Yeager"
                      },
                      {
                          "num": "A-SS",
                          "title": "Stephen Stanton",
                          "meta": "Ben Kenobi"
                      },
                      {
                          "num": "A-SW",
                          "title": "Sam Witwer",
                          "meta": "Maul"
                      },
                      {
                          "num": "A-TB",
                          "title": "Tom Baker",
                          "meta": "Bendu"
                      },
                      {
                          "num": "A-TC",
                          "title": "Tim Curry",
                          "meta": "Chancellor Palpatine"
                      },
                      {
                          "num": "A-TG",
                          "title": "Taylor Gray",
                          "meta": "Ezra Bridger"
                      },
                      {
                          "num": "A-TM",
                          "title": "Temuera Morrison",
                          "meta": "Boba Fett"
                      },
                      {
                          "num": "A-TR",
                          "title": "Tim Rose",
                          "meta": "Admiral Ackbar"
                      },
                      {
                          "num": "A-TW",
                          "title": "Taika Waititi",
                          "meta": "IG-11"
                      },
                      {
                          "num": "A-VK",
                          "title": "Valene Kane",
                          "meta": "Lyra Erso"
                      },
                      {
                          "num": "A-VM",
                          "title": "Vanessa Marshall",
                          "meta": "Hera Syndulla"
                      },
                      {
                          "num": "A-WB",
                          "title": "W. Earl Brown",
                          "meta": "Taanti"
                      },
                      {
                          "num": "A-WD",
                          "title": "Warwick Davis",
                          "meta": "Wicket W. Warrick"
                      },
                      {
                          "num": "A-WH",
                          "title": "Werner Herzog",
                          "meta": "The Client"
                      }
                  ]
              },
              {
                  "count": 67,
                  "name": "AUTOGRAPHS DESIGN B",
                  "meta": "On the 1983 ROTJ design for the 40th anniversary",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "AB-AB",
                          "title": "Ahmed Best",
                          "meta": "Jar Jar Binks"
                      },
                      {
                          "num": "AB-AD",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "AB-AE",
                          "title": "Ashley Eckstein",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "AB-AG",
                          "title": "Allan Graf",
                          "meta": "Bartender"
                      },
                      {
                          "num": "AB-AH",
                          "title": "Alfred Hsing",
                          "meta": "Pyke Traveler"
                      },
                      {
                          "num": "AB-AS",
                          "title": "Andy Serkis",
                          "meta": "Supreme Leader Snoke"
                      },
                      {
                          "num": "AB-BH",
                          "title": "Brian Herring",
                          "meta": "BB-8"
                      },
                      {
                          "num": "AB-BL",
                          "title": "Billie Lourd",
                          "meta": "Kaydel Ko Connix"
                      },
                      {
                          "num": "AB-BM",
                          "title": "Ben Mendelsohn",
                          "meta": "Director Krennic"
                      },
                      {
                          "num": "AB-BP",
                          "title": "Bonnie Piesse",
                          "meta": "Beru Lars"
                      },
                      {
                          "num": "AB-CH",
                          "title": "Clint Howard",
                          "meta": "Ralakili"
                      },
                      {
                          "num": "AB-CW",
                          "title": "Carl Weathers",
                          "meta": "Greef Karga"
                      },
                      {
                          "num": "AB-DA",
                          "title": "David Acord",
                          "meta": "Edrio Two Tubes"
                      },
                      {
                          "num": "AB-DG",
                          "title": "Domhnall Gleeson",
                          "meta": "General Hux"
                      },
                      {
                          "num": "AB-DL",
                          "title": "Daniel Logan",
                          "meta": "Boba Fett"
                      },
                      {
                          "num": "AB-DY",
                          "title": "Donnie Yen",
                          "meta": "Chirrut Îmwe"
                      },
                      {
                          "num": "AB-EC",
                          "title": "Emilia Clarke",
                          "meta": "Qi'ra"
                      },
                      {
                          "num": "AB-EK",
                          "title": "Erin Kellyman",
                          "meta": "Enfys Nest"
                      },
                      {
                          "num": "AB-EM",
                          "title": "Ewan McGregor",
                          "meta": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "AB-ES",
                          "title": "Emily Swallow",
                          "meta": "The Armorer"
                      },
                      {
                          "num": "AB-FJ",
                          "title": "Felicity Jones",
                          "meta": "Jyn Erso"
                      },
                      {
                          "num": "AB-GH",
                          "title": "Guy Henry",
                          "meta": "Grand Moff Tarkin"
                      },
                      {
                          "num": "AB-GT",
                          "title": "Gina Torres",
                          "meta": "Ketsu Onyo"
                      },
                      {
                          "num": "AB-HC",
                          "title": "Hayden Christensen",
                          "meta": "Darth Vader"
                      },
                      {
                          "num": "AB-HD",
                          "title": "Harrison Davis",
                          "meta": "Pommet Warrick"
                      },
                      {
                          "num": "AB-HE",
                          "title": "Hermione Corfield",
                          "meta": "Tallie Lintra"
                      },
                      {
                          "num": "AB-HF",
                          "title": "Harrison Ford",
                          "meta": "Han Solo"
                      },
                      {
                          "num": "AB-JA",
                          "title": "Josef Altin",
                          "meta": "Seftin Vanik"
                      },
                      {
                          "num": "AB-JB",
                          "title": "John Boyega",
                          "meta": "Finn"
                      },
                      {
                          "num": "AB-JC",
                          "title": "Jim Cummings",
                          "meta": "Hondo Ohnaka"
                      },
                      {
                          "num": "AB-JS",
                          "title": "Jason Spisak",
                          "meta": "Lux Bonteri"
                      },
                      {
                          "num": "AB-KB",
                          "title": "Kenny Baker",
                          "meta": "R2-D2"
                      },
                      {
                          "num": "AB-KF",
                          "title": "Karen Fukuhara",
                          "meta": "F"
                      },
                      {
                          "num": "AB-KK",
                          "title": "Katy Kartwheel",
                          "meta": "Rio Durant"
                      },
                      {
                          "num": "AB-KS",
                          "title": "Kiran Shah",
                          "meta": "Nambi Ghima"
                      },
                      {
                          "num": "AB-KT",
                          "title": "Kelly Marie Tran",
                          "meta": "Rose Tico"
                      },
                      {
                          "num": "AB-LC",
                          "title": "Lily Cole",
                          "meta": "Lovey"
                      },
                      {
                          "num": "AB-LD",
                          "title": "Laura Dern",
                          "meta": "Vice Admiral Holdo"
                      },
                      {
                          "num": "AB-LN",
                          "title": "Lupita Nyong'o",
                          "meta": "Maz Kanata"
                      },
                      {
                          "num": "AB-MA",
                          "title": "Matthew Wood",
                          "meta": "General Grievous"
                      },
                      {
                          "num": "AB-MB",
                          "title": "Matt Berry",
                          "meta": "8D8"
                      },
                      {
                          "num": "AB-ML",
                          "title": "Matt Lanter",
                          "meta": "Anakin Skywalker"
                      },
                      {
                          "num": "AB-MM",
                          "title": "Mads Mikkelsen",
                          "meta": "Galen Erso"
                      },
                      {
                          "num": "AB-MV",
                          "title": "Mercedes Varnado",
                          "meta": "Koska Reeves"
                      },
                      {
                          "num": "AB-MW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "AB-NF",
                          "title": "Nika Futterman",
                          "meta": "Asajj Ventress"
                      },
                      {
                          "num": "AB-NN",
                          "title": "Nick Nolte",
                          "meta": "Kuiil"
                      },
                      {
                          "num": "AB-NP",
                          "title": "Natalie Portman",
                          "meta": "Padmé Amidala"
                      },
                      {
                          "num": "AB-PA",
                          "title": "Philip Alexander",
                          "meta": "Imperial Security Officer"
                      },
                      {
                          "num": "AB-PD",
                          "title": "Paul Darnell",
                          "meta": "Night Wind Assassin"
                      },
                      {
                          "num": "AB-PW",
                          "title": "Paul Warren",
                          "meta": "Hassk Triplet"
                      },
                      {
                          "num": "AB-RA",
                          "title": "Riz Ahmed",
                          "meta": "Bodhi Rook"
                      },
                      {
                          "num": "AB-RB",
                          "title": "Richard Brake",
                          "meta": "Valin Hess"
                      },
                      {
                          "num": "AB-RD",
                          "title": "Rosario Dawson",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "AB-RDO",
                          "title": "Robin Atkin Downes",
                          "meta": "Cham Syndulla"
                      },
                      {
                          "num": "AB-RO",
                          "title": "Ron Perlman",
                          "meta": "Gha Nachkt"
                      },
                      {
                          "num": "AB-SC",
                          "title": "Scott Capurro",
                          "meta": "Beed"
                      },
                      {
                          "num": "AB-SG",
                          "title": "Sarah Michelle Gellar",
                          "meta": "Seventh Sister"
                      },
                      {
                          "num": "AB-SW",
                          "title": "Sam Witwer",
                          "meta": "Maul"
                      },
                      {
                          "num": "AB-TB",
                          "title": "Tom Baker",
                          "meta": "Bendu"
                      },
                      {
                          "num": "AB-TC",
                          "title": "Tim Curry",
                          "meta": "Chancellor Palpatine"
                      },
                      {
                          "num": "AB-TM",
                          "title": "Temuera Morrison",
                          "meta": "Boba Fett"
                      },
                      {
                          "num": "AB-TR",
                          "title": "Tim Rose",
                          "meta": "Admiral Ackbar"
                      },
                      {
                          "num": "AB-TW",
                          "title": "Taika Waititi",
                          "meta": "IG-11"
                      },
                      {
                          "num": "AB-VK",
                          "title": "Valene Kane",
                          "meta": "Lyra Erso"
                      },
                      {
                          "num": "AB-VM",
                          "title": "Vanessa Marshall",
                          "meta": "Hera Syndulla"
                      },
                      {
                          "num": "AB-WD",
                          "title": "Warwick Davis",
                          "meta": "Wicket W. Warrick"
                      }
                  ]
              },
              {
                  "count": 3,
                  "name": "DUAL AUTOGRAPHS",
                  "meta": "Two signers per card · Red 1/1 parallel",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "DA-JW",
                          "title": "Carey Jones / Ming-Na Wen",
                          "meta": "Krrsantan / Fennec Shand"
                      },
                      {
                          "num": "DA-MW",
                          "title": "Ming-Na Wen / Temuera Morrison",
                          "meta": "Fennec Shand / Boba Fett"
                      },
                      {
                          "num": "DA-RD",
                          "title": "Adam Driver / Daisy Ridley",
                          "meta": "Kylo Ren / Rey"
                      }
                  ]
              },
              {
                  "count": 3,
                  "name": "TRIPLE AUTOGRAPHS",
                  "meta": "Three signers per card · Red 1/1 parallel",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "TA-JWM",
                          "title": "Carey Jones / Temuera Morrison / Ming-Na Wen",
                          "meta": "Krrsantan / Boba Fett / Fennec Shand"
                      },
                      {
                          "num": "TA-PWM",
                          "title": "Ewan McGregor / Ian McDiarmid / Ray Park",
                          "meta": "Obi-Wan Kenobi / Darth Sidious / Darth Maul"
                      },
                      {
                          "num": "TA-RDB",
                          "title": "Adam Driver / Daisy Ridley / John Boyega",
                          "meta": "Kylo Ren / Rey / Finn"
                      }
                  ]
              },
              {
                  "count": 2,
                  "name": "LIGHT SIDE / DARK SIDE QUAD AUTOGRAPHS",
                  "meta": "Four signers, split good and evil · every card 1/1",
                  "parallels": 1,
                  "cards": [
                      {
                          "num": "LDA-PMWM",
                          "title": "Ewan McGregor / Matthew Wood / Ian McDiarmid / Natalie Portman",
                          "meta": "Obi-Wan Kenobi / General Grievous / Darth Sidious / Padmé Amidala"
                      },
                      {
                          "num": "LDA-RFDS",
                          "title": "Andy Serkis / Harrison Ford / Adam Driver / Daisy Ridley",
                          "meta": "Supreme Leader Snoke / Han Solo / Kylo Ren / Rey"
                      }
                  ]
              }
          ]
      }
  },

  '2022-masterwork': {
      "setId": "2022-masterwork",
      "year": "2022",
      "brand": "TOPPS",
      "title": "STAR WARS MASTERWORK",
      "releaseDate": "12 / 8 / 2023",
      "lede": "The eighth Masterwork — so delayed it shipped December 2023, over a year past its title date — keeps the line's ultra-premium formula: 100 characters on 72-point stock under an eight-step Blue-to-Gold ladder, three insert lines with one-of-one Gold Metal variations, and, a Masterwork first, autographed relics — four relic lines from sourced costumes to screen-used Rogue One props, each with a three-copy signed parallel, crowned by stamp autographs from Harrison Ford and Carrie Fisher. A 63-signer on-card program with two autographs in every four-pack box, quad autograph books with just two copies each, and a sketch program in four formats from a 94-artist roster round it out.",
      "stats": [
          {
              "num": "100",
              "label": "Base Cards",
              "sub": "72-point stock",
              "color": "gold"
          },
          {
              "num": "10",
              "label": "Insert Sets",
              "sub": "Incl. 4 relic lines",
              "color": "cyan"
          },
          {
              "num": "133",
              "label": "Auto Cards",
              "sub": "9 autograph sub-sets",
              "color": "green"
          },
          {
              "num": "8",
              "label": "Base Parallels",
              "sub": "Blue → Gold 1/1",
              "color": "purple"
          },
          {
              "num": "24",
              "label": "Sub-sets Total",
              "sub": "Tracked on CK",
              "color": "red"
          }
      ],
      "hobbyBox": [
          {
              "v": "4",
              "l": "Mini boxes per box"
          },
          {
              "v": "5",
              "l": "Cards per mini box"
          },
          {
              "v": "8",
              "l": "Boxes per case"
          },
          {
              "v": "4",
              "l": "Hits per box"
          },
          {
              "v": "2",
              "l": "Autographs per box"
          }
      ],
      "pullRates": [
          {
              "name": "Original Trilogy Poster Cards",
              "odds": "1 : 2",
              "tier": "normal"
          },
          {
              "name": "On Card Autographs",
              "odds": "1 : 3",
              "tier": "normal"
          },
          {
              "name": "Bounty Hunting · Obi-Wan Quotes",
              "odds": "1 : 4",
              "tier": "normal"
          },
          {
              "name": "Sketch Cards",
              "odds": "1 : 10",
              "tier": "normal"
          },
          {
              "name": "Costume Relics",
              "odds": "1 : 13",
              "tier": "rare"
          },
          {
              "name": "On-Screen Prop Relics",
              "odds": "1 : 24",
              "tier": "rare"
          },
          {
              "name": "Commemorative Stamps",
              "odds": "1 : 27",
              "tier": "rare"
          },
          {
              "name": "Tools & Technology Medallions",
              "odds": "1 : 32",
              "tier": "rare"
          },
          {
              "name": "Dual Autographs /50",
              "odds": "1 : 205",
              "tier": "rare"
          },
          {
              "name": "Pen Relic Autographs 1/1",
              "odds": "1 : 2,005",
              "tier": "mythic"
          },
          {
              "name": "Quad Autograph Books /2",
              "odds": "1 : 12,528",
              "tier": "mythic"
          },
          {
              "name": "Triple Autographs /25",
              "odds": "1 : 50,112",
              "tier": "mythic"
          }
      ],
      "parallelRainbow": [
          {
              "name": "BLUE",
              "pr": "∞",
              "gradient": "linear-gradient(135deg, #2979ff 0%, #0040a0 100%)"
          },
          {
              "name": "GREEN",
              "pr": "/99",
              "gradient": "linear-gradient(135deg, #00e87a 0%, #008048 100%)",
              "darkText": true
          },
          {
              "name": "PURPLE",
              "pr": "/50",
              "gradient": "linear-gradient(135deg, #b060ff 0%, #6020a0 50%, #d0a0ff 100%)"
          },
          {
              "name": "RED",
              "pr": "/25",
              "gradient": "linear-gradient(135deg, #ff2020 0%, #b00000 100%)"
          },
          {
              "name": "ORANGE",
              "pr": "/10",
              "gradient": "linear-gradient(135deg, #ff8800 0%, #ff4400 100%)"
          },
          {
              "name": "BLACK",
              "pr": "/5",
              "gradient": "linear-gradient(135deg, #3a3a4a 0%, #101018 60%, #5a5a6a 100%)"
          },
          {
              "name": "PRINTING PLATES",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #b0b0b8 0%, #6a6a72 100%)"
          },
          {
              "name": "GOLD",
              "pr": "1/1",
              "gradient": "linear-gradient(135deg, #fff080 0%, #f0c040 30%, #c89020 70%, #fff0a0 100%)",
              "darkText": true
          }
      ],
      "artists": [],
      "subsets": {
          "base": [
              {
                  "count": 100,
                  "name": "BASE SET",
                  "meta": "Films, Disney+ series, animation & Jedi: Fallen Order · 72-point stock",
                  "parallels": 8,
                  "cards": [
                      {
                          "num": "1",
                          "title": "Bo-Katan Kryze"
                      },
                      {
                          "num": "2",
                          "title": "Valin Hess"
                      },
                      {
                          "num": "3",
                          "title": "Migs Mayfeld"
                      },
                      {
                          "num": "4",
                          "title": "Greef Karga"
                      },
                      {
                          "num": "5",
                          "title": "Moff Gideon"
                      },
                      {
                          "num": "6",
                          "title": "Kuiil"
                      },
                      {
                          "num": "7",
                          "title": "IG-11"
                      },
                      {
                          "num": "8",
                          "title": "Zero"
                      },
                      {
                          "num": "9",
                          "title": "Koska Reeves"
                      },
                      {
                          "num": "10",
                          "title": "Carson Teva"
                      },
                      {
                          "num": "11",
                          "title": "Magistrate Morgan Elsbeth"
                      },
                      {
                          "num": "12",
                          "title": "R2-D2"
                      },
                      {
                          "num": "13",
                          "title": "C-3PO"
                      },
                      {
                          "num": "14",
                          "title": "Babu Frik"
                      },
                      {
                          "num": "15",
                          "title": "Zorii Bliss"
                      },
                      {
                          "num": "16",
                          "title": "Rey"
                      },
                      {
                          "num": "17",
                          "title": "Poe Dameron"
                      },
                      {
                          "num": "18",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "19",
                          "title": "Finn"
                      },
                      {
                          "num": "20",
                          "title": "Lando Calrissian"
                      },
                      {
                          "num": "21",
                          "title": "Chewbacca"
                      },
                      {
                          "num": "22",
                          "title": "Padmé Amidala"
                      },
                      {
                          "num": "23",
                          "title": "Kaydel Ko Connix"
                      },
                      {
                          "num": "24",
                          "title": "Jannah"
                      },
                      {
                          "num": "25",
                          "title": "BB-8"
                      },
                      {
                          "num": "26",
                          "title": "Qui-Gon Jinn"
                      },
                      {
                          "num": "27",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "28",
                          "title": "General Leia Organa"
                      },
                      {
                          "num": "29",
                          "title": "Han Solo"
                      },
                      {
                          "num": "30",
                          "title": "Quinlan Vos"
                      },
                      {
                          "num": "31",
                          "title": "Asajj Ventress"
                      },
                      {
                          "num": "32",
                          "title": "Jar Jar Binks"
                      },
                      {
                          "num": "33",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "34",
                          "title": "Grogu"
                      },
                      {
                          "num": "35",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "36",
                          "title": "Boba Fett"
                      },
                      {
                          "num": "37",
                          "title": "Fennec Shand"
                      },
                      {
                          "num": "38",
                          "title": "Garsa Fwip"
                      },
                      {
                          "num": "39",
                          "title": "Twi'lek Majordomo"
                      },
                      {
                          "num": "40",
                          "title": "Krrsantan"
                      },
                      {
                          "num": "41",
                          "title": "The Twins"
                      },
                      {
                          "num": "42",
                          "title": "Drash"
                      },
                      {
                          "num": "43",
                          "title": "Skad"
                      },
                      {
                          "num": "44",
                          "title": "Tatooine Sand Ape"
                      },
                      {
                          "num": "45",
                          "title": "Cad Bane"
                      },
                      {
                          "num": "46",
                          "title": "Cobb Vanth"
                      },
                      {
                          "num": "47",
                          "title": "The Armorer"
                      },
                      {
                          "num": "48",
                          "title": "Axe Woves"
                      },
                      {
                          "num": "49",
                          "title": "Peli Motto"
                      },
                      {
                          "num": "50",
                          "title": "Omega"
                      },
                      {
                          "num": "51",
                          "title": "Hunter"
                      },
                      {
                          "num": "52",
                          "title": "Tech"
                      },
                      {
                          "num": "53",
                          "title": "Wrecker"
                      },
                      {
                          "num": "54",
                          "title": "Cid"
                      },
                      {
                          "num": "55",
                          "title": "Crosshair"
                      },
                      {
                          "num": "56",
                          "title": "Echo"
                      },
                      {
                          "num": "57",
                          "title": "Captain Rex"
                      },
                      {
                          "num": "58",
                          "title": "Darth Sidious"
                      },
                      {
                          "num": "59",
                          "title": "General Grievous"
                      },
                      {
                          "num": "60",
                          "title": "Mace Windu"
                      },
                      {
                          "num": "61",
                          "title": "Obi-Wan Kenobi"
                      },
                      {
                          "num": "62",
                          "title": "The Grand Inquisitor"
                      },
                      {
                          "num": "63",
                          "title": "Fifth Brother"
                      },
                      {
                          "num": "64",
                          "title": "Owen Lars"
                      },
                      {
                          "num": "65",
                          "title": "Beru Lars"
                      },
                      {
                          "num": "66",
                          "title": "Third Sister"
                      },
                      {
                          "num": "67",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "68",
                          "title": "Jango Fett"
                      },
                      {
                          "num": "69",
                          "title": "Count Dooku"
                      },
                      {
                          "num": "70",
                          "title": "Cassian Andor"
                      },
                      {
                          "num": "71",
                          "title": "Mon Mothma"
                      },
                      {
                          "num": "72",
                          "title": "Kazuda Xiono"
                      },
                      {
                          "num": "73",
                          "title": "Tam Ryvora"
                      },
                      {
                          "num": "74",
                          "title": "Major Vonreg"
                      },
                      {
                          "num": "75",
                          "title": "Jarek Yeager"
                      },
                      {
                          "num": "76",
                          "title": "Commander Pyre"
                      },
                      {
                          "num": "77",
                          "title": "Agent Tierny"
                      },
                      {
                          "num": "78",
                          "title": "Torra Doza"
                      },
                      {
                          "num": "79",
                          "title": "Kanan Jarrus"
                      },
                      {
                          "num": "80",
                          "title": "Hera Syndulla"
                      },
                      {
                          "num": "81",
                          "title": "Ezra Bridger"
                      },
                      {
                          "num": "82",
                          "title": "Zeb Orrelios"
                      },
                      {
                          "num": "83",
                          "title": "Sabine Wren"
                      },
                      {
                          "num": "84",
                          "title": "Cal Kestis"
                      },
                      {
                          "num": "85",
                          "title": "BD-1"
                      },
                      {
                          "num": "86",
                          "title": "Second Sister"
                      },
                      {
                          "num": "87",
                          "title": "Ninth Sister"
                      },
                      {
                          "num": "88",
                          "title": "Cere Junda"
                      },
                      {
                          "num": "89",
                          "title": "Merrin"
                      },
                      {
                          "num": "90",
                          "title": "L3-37"
                      },
                      {
                          "num": "91",
                          "title": "Maul"
                      },
                      {
                          "num": "92",
                          "title": "Qi'ra"
                      },
                      {
                          "num": "93",
                          "title": "Bail Organa"
                      },
                      {
                          "num": "94",
                          "title": "K-2SO"
                      },
                      {
                          "num": "95",
                          "title": "Chirrut Îmwe"
                      },
                      {
                          "num": "96",
                          "title": "Baze Malbus"
                      },
                      {
                          "num": "97",
                          "title": "Bodhi Rook"
                      },
                      {
                          "num": "98",
                          "title": "Jyn Erso"
                      },
                      {
                          "num": "99",
                          "title": "Galen Erso"
                      },
                      {
                          "num": "100",
                          "title": "Director Krennic"
                      }
                  ]
              }
          ],
          "insert": [
              {
                  "count": 15,
                  "name": "BOUNTY HUNTING: A COMPLICATED PROFESSION",
                  "meta": "Bounty hunters across the saga",
                  "odds": "1:4 packs",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "BH-1",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BH-2",
                          "title": "Boba Fett",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BH-3",
                          "title": "The Mandalorian",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BH-4",
                          "title": "IG-11",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BH-5",
                          "title": "Krrsantan",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BH-6",
                          "title": "Cad Bane",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BH-7",
                          "title": "Fennec Shand",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BH-8",
                          "title": "IG-88",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BH-9",
                          "title": "Dengar",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BH-10",
                          "title": "Bossk",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BH-11",
                          "title": "Jango Fett",
                          "meta": "Star Wars: Attack of the Clones"
                      },
                      {
                          "num": "BH-12",
                          "title": "Greedo",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "BH-13",
                          "title": "Aurra Sing",
                          "meta": "Star Wars: The Phantom Menace"
                      },
                      {
                          "num": "BH-14",
                          "title": "Asajj Ventress",
                          "meta": "Star Wars: The Clone Wars"
                      },
                      {
                          "num": "BH-15",
                          "title": "Toro Calican",
                          "meta": "The Mandalorian"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "HELLO THERE: THE QUOTES OF OBI-WAN KENOBI",
                  "meta": "Kenobi's most quotable moments",
                  "odds": "1:4 packs",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "OB1-1",
                          "title": "\"Use the Force, Luke.\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1-2",
                          "title": "\"Only a Sith deals in absolutes.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1-3",
                          "title": "\"Hello, there.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1-4",
                          "title": "\"I have the high ground.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1-5",
                          "title": "\"Luke, you're going to find that many of the truths we cling to depend greatly on our own point of view.\"",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OB1-6",
                          "title": "\"Who is more foolish? The fool or the fool who follows him?\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1-7",
                          "title": "\"Be mindful of your thoughts, Anakin, they betray you.\"",
                          "meta": "Star Wars: Attack of the Clones"
                      },
                      {
                          "num": "OB1-8",
                          "title": "\"If you strike me down, I shall become more powerful than you can possibly imagine.\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1-9",
                          "title": "\"So uncivilized.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1-10",
                          "title": "\"If you define yourself by the power to take life, the desire to dominate, to possess...then you have nothing.\"",
                          "meta": "Star Wars Rebels"
                      }
                  ]
              },
              {
                  "count": 25,
                  "name": "ORIGINAL TRILOGY POSTER CARDS",
                  "meta": "Vintage original trilogy one-sheets",
                  "odds": "1:2 packs",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "OT-1",
                          "title": "Obi-Wan Kenobi",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-2",
                          "title": "Lando Calrissian",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-3",
                          "title": "Tusken Raider",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-4",
                          "title": "Jabba The Hutt",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OT-5",
                          "title": "Imperial Royal Guard",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OT-6",
                          "title": "Grand Moff Tarkin",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-7",
                          "title": "Jawas",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-8",
                          "title": "Wicket W. Warrick",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OT-9",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-10",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-11",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-12",
                          "title": "C-3PO & R2-D2",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-13",
                          "title": "Chewbacca",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-14",
                          "title": "Yoda",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-15",
                          "title": "Chewbacca",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-16",
                          "title": "Stormtrooper",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-17",
                          "title": "Stormtrooper",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OT-18",
                          "title": "Emperor Palpatine",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OT-19",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-20",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-21",
                          "title": "Han Solo",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-22",
                          "title": "Luke Skywalker",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-23",
                          "title": "Luke Skywalker",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OT-24",
                          "title": "Darth Vader",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OT-25",
                          "title": "Darth Vader",
                          "meta": "Star Wars: The Empire Strikes Back"
                      }
                  ]
              },
              {
                  "count": 15,
                  "name": "BOUNTY HUNTING GOLD METAL VARIATION",
                  "meta": "All-metal one-of-one variation",
                  "odds": "1:3,341 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "BHG-1",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BHG-2",
                          "title": "Boba Fett",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BHG-3",
                          "title": "The Mandalorian",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BHG-4",
                          "title": "IG-11",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BHG-5",
                          "title": "Krrsantan",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BHG-6",
                          "title": "Cad Bane",
                          "meta": "The Book of Boba Fett"
                      },
                      {
                          "num": "BHG-7",
                          "title": "Fennec Shand",
                          "meta": "The Mandalorian"
                      },
                      {
                          "num": "BHG-8",
                          "title": "IG-88",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BHG-9",
                          "title": "Dengar",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BHG-10",
                          "title": "Bossk",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "BHG-11",
                          "title": "Jango Fett",
                          "meta": "Star Wars: Attack of the Clones"
                      },
                      {
                          "num": "BHG-12",
                          "title": "Greedo",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "BHG-13",
                          "title": "Aurra Sing",
                          "meta": "Star Wars: The Phantom Menace"
                      },
                      {
                          "num": "BHG-14",
                          "title": "Asajj Ventress",
                          "meta": "Star Wars: The Clone Wars"
                      },
                      {
                          "num": "BHG-15",
                          "title": "Toro Calican",
                          "meta": "The Mandalorian"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "OBI-WAN QUOTES GOLD METAL VARIATION",
                  "meta": "All-metal one-of-one variation",
                  "odds": "1:5,012 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "OB1G-1",
                          "title": "\"Use the Force, Luke.\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1G-2",
                          "title": "\"Only a Sith deals in absolutes.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1G-3",
                          "title": "\"Hello, there.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1G-4",
                          "title": "\"I have the high ground.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1G-5",
                          "title": "\"Luke, you're going to find that many of the truths we cling to depend greatly on our own point of view.\"",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OB1G-6",
                          "title": "\"Who is more foolish? The fool or the fool who follows him?\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1G-7",
                          "title": "\"Be mindful of your thoughts, Anakin, they betray you.\"",
                          "meta": "Star Wars: Attack of the Clones"
                      },
                      {
                          "num": "OB1G-8",
                          "title": "\"If you strike me down, I shall become more powerful than you can possibly imagine.\"",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OB1G-9",
                          "title": "\"So uncivilized.\"",
                          "meta": "Star Wars: Revenge of the Sith"
                      },
                      {
                          "num": "OB1G-10",
                          "title": "\"If you define yourself by the power to take life, the desire to dominate, to possess...then you have nothing.\"",
                          "meta": "Star Wars Rebels"
                      }
                  ]
              },
              {
                  "count": 25,
                  "name": "OT POSTER GOLD METAL VARIATION",
                  "meta": "All-metal one-of-one variation",
                  "odds": "1:2,005 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "OTG-1",
                          "title": "Obi-Wan Kenobi",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-2",
                          "title": "Lando Calrissian",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-3",
                          "title": "Tusken Raider",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-4",
                          "title": "Jabba The Hutt",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OTG-5",
                          "title": "Imperial Royal Guard",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OTG-6",
                          "title": "Grand Moff Tarkin",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-7",
                          "title": "Jawas",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-8",
                          "title": "Wicket W. Warrick",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OTG-9",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-10",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-11",
                          "title": "Princess Leia Organa",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-12",
                          "title": "C-3PO & R2-D2",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-13",
                          "title": "Chewbacca",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-14",
                          "title": "Yoda",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-15",
                          "title": "Chewbacca",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-16",
                          "title": "Stormtrooper",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-17",
                          "title": "Stormtrooper",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OTG-18",
                          "title": "Emperor Palpatine",
                          "meta": "Star Wars: Return of the Jedi"
                      },
                      {
                          "num": "OTG-19",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-20",
                          "title": "Boba Fett",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-21",
                          "title": "Han Solo",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-22",
                          "title": "Luke Skywalker",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-23",
                          "title": "Luke Skywalker",
                          "meta": "Star Wars: The Empire Strikes Back"
                      },
                      {
                          "num": "OTG-24",
                          "title": "Darth Vader",
                          "meta": "Star Wars: A New Hope"
                      },
                      {
                          "num": "OTG-25",
                          "title": "Darth Vader",
                          "meta": "Star Wars: The Empire Strikes Back"
                      }
                  ]
              },
              {
                  "count": 11,
                  "name": "COSTUME RELIC CARDS",
                  "meta": "Sourced fabric swatches",
                  "odds": "1:13 packs",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "CR-AT",
                          "title": "Ahsoka Tano"
                      },
                      {
                          "num": "CR-DV",
                          "title": "Dryden Vos"
                      },
                      {
                          "num": "CR-FS",
                          "title": "Fennec Shand"
                      },
                      {
                          "num": "CR-JE",
                          "title": "Jyn Erso"
                      },
                      {
                          "num": "CR-LU",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "CR-ME",
                          "title": "Magistrate Morgan Elsbeth"
                      },
                      {
                          "num": "CR-PD",
                          "title": "Poe Dameron"
                      },
                      {
                          "num": "CR-R",
                          "title": "Rey"
                      },
                      {
                          "num": "CR-RE",
                          "title": "Rey"
                      },
                      {
                          "num": "CR-TA",
                          "title": "The Armorer"
                      },
                      {
                          "num": "CR-TM",
                          "title": "The Mandalorian"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "ON-SCREEN PROP RELICS",
                  "meta": "Screen-used Rogue One props",
                  "odds": "1:24 packs",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "OSPR-BM",
                          "title": "Baze Malbus"
                      },
                      {
                          "num": "OSPR-BO",
                          "title": "Bail Organa"
                      },
                      {
                          "num": "OSPR-BR",
                          "title": "Bodhi Rook"
                      },
                      {
                          "num": "OSPR-CA",
                          "title": "Cassian Andor"
                      },
                      {
                          "num": "OSPR-CI",
                          "title": "Chirrut Îmwe"
                      },
                      {
                          "num": "OSPR-GM",
                          "title": "General Merrick"
                      },
                      {
                          "num": "OSPR-JD",
                          "title": "Jan Dodonna"
                      },
                      {
                          "num": "OSPR-JE",
                          "title": "Jyn Erso"
                      },
                      {
                          "num": "OSPR-K2",
                          "title": "K-2SO"
                      },
                      {
                          "num": "OSPR-MM",
                          "title": "Mon Mothma"
                      }
                  ]
              },
              {
                  "count": 9,
                  "name": "COMMEMORATIVE STAMP CARDS",
                  "meta": "Manufactured stamp cards",
                  "odds": "1:27 packs",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "SC-DM",
                          "title": "Darth Maul"
                      },
                      {
                          "num": "SC-DV",
                          "title": "Darth Vader"
                      },
                      {
                          "num": "SC-HS",
                          "title": "Han Solo"
                      },
                      {
                          "num": "SC-KR",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "SC-LO",
                          "title": "General Leia Organa"
                      },
                      {
                          "num": "SC-LS",
                          "title": "Luke Skywalker"
                      },
                      {
                          "num": "SC-MD",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "SC-R",
                          "title": "Reva"
                      },
                      {
                          "num": "SC-RS",
                          "title": "Rey"
                      }
                  ]
              },
              {
                  "count": 9,
                  "name": "TOOLS & TECHNOLOGY MEDALLIONS",
                  "meta": "Manufactured medallion cards",
                  "odds": "1:32 packs",
                  "parallels": 6,
                  "cards": [
                      {
                          "num": "TTM-K",
                          "title": "Krrsantan"
                      },
                      {
                          "num": "TTM-KR",
                          "title": "Kylo Ren"
                      },
                      {
                          "num": "TTM-MG",
                          "title": "Moff Gideon"
                      },
                      {
                          "num": "TTM-P",
                          "title": "Palpatine"
                      },
                      {
                          "num": "TTM-Q",
                          "title": "Qi'ra"
                      },
                      {
                          "num": "TTM-R",
                          "title": "Rey"
                      },
                      {
                          "num": "TTM-TC",
                          "title": "The Client"
                      },
                      {
                          "num": "TTM-TM",
                          "title": "The Mandalorian"
                      },
                      {
                          "num": "TTM-TM2",
                          "title": "The Mandalorian"
                      }
                  ]
              }
          ],
          "auto": [
              {
                  "count": 63,
                  "name": "ON CARD AUTOGRAPHS",
                  "meta": "Hard-signed · Blue Foil /99 → Gold Framed 1/1",
                  "odds": "1:3 packs",
                  "parallels": 7,
                  "cards": [
                      {
                          "num": "MWA-ABA",
                          "title": "Andrea Bartlow",
                          "meta": "Twi'lek Server"
                      },
                      {
                          "num": "MWA-ABE",
                          "title": "Ahmed Best",
                          "meta": "Jar Jar Binks"
                      },
                      {
                          "num": "MWA-AG",
                          "title": "Allan Graf",
                          "meta": "Bartender"
                      },
                      {
                          "num": "MWA-AH",
                          "title": "Alfred Hsing",
                          "meta": "Pyke Traveler"
                      },
                      {
                          "num": "MWA-AK",
                          "title": "Andrew Kishino",
                          "meta": "Saw Gerrera"
                      },
                      {
                          "num": "MWA-AW",
                          "title": "Alexander Wraith",
                          "meta": "Imperial Freighter Pilot"
                      },
                      {
                          "num": "MWA-BH",
                          "title": "Brian Herring",
                          "meta": "BB-8"
                      },
                      {
                          "num": "MWA-BP",
                          "title": "Bonnie Piesse",
                          "meta": "Beru Lars"
                      },
                      {
                          "num": "MWA-CB",
                          "title": "Chris Bartlett",
                          "meta": "Teacher Droid"
                      },
                      {
                          "num": "MWA-CG",
                          "title": "Clare Grant",
                          "meta": "Latts Razzi"
                      },
                      {
                          "num": "MWA-CJ",
                          "title": "Carey Jones",
                          "meta": "Krrsantan"
                      },
                      {
                          "num": "MWA-DA",
                          "title": "David Acord",
                          "meta": "FN-2199"
                      },
                      {
                          "num": "MWA-DB1",
                          "title": "Dee Bradley Baker",
                          "meta": "Captain Rex"
                      },
                      {
                          "num": "MWA-DB2",
                          "title": "Dee Bradley Baker",
                          "meta": "Hunter"
                      },
                      {
                          "num": "MWA-DB3",
                          "title": "Dee Bradley Baker",
                          "meta": "Wrecker"
                      },
                      {
                          "num": "MWA-DB4",
                          "title": "Dee Bradley Baker",
                          "meta": "Echo"
                      },
                      {
                          "num": "MWA-DB5",
                          "title": "Dee Bradley Baker",
                          "meta": "Crosshair"
                      },
                      {
                          "num": "MWA-DB6",
                          "title": "Dee Bradley Baker",
                          "meta": "Tech"
                      },
                      {
                          "num": "MWA-DK",
                          "title": "Dorian Kingi",
                          "meta": "Cad Bane"
                      },
                      {
                          "num": "MWA-DLI",
                          "title": "Diana Lee Inosanto",
                          "meta": "Magistrate Morgan Elsbeth"
                      },
                      {
                          "num": "MWA-DR",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      },
                      {
                          "num": "MWA-EC",
                          "title": "Emilia Clarke",
                          "meta": "Qi'ra"
                      },
                      {
                          "num": "MWA-ES",
                          "title": "Emily Swallow",
                          "meta": "The Armorer"
                      },
                      {
                          "num": "MWA-GE",
                          "title": "Giancarlo Esposito",
                          "meta": "Moff Gideon"
                      },
                      {
                          "num": "MWA-JCU",
                          "title": "Jim Cummings",
                          "meta": "Hondo Ohnaka"
                      },
                      {
                          "num": "MWA-JD",
                          "title": "Julie Dolan",
                          "meta": "Princess Leia Organa"
                      },
                      {
                          "num": "MWA-JK",
                          "title": "Jaime King",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "MWA-JL",
                          "title": "John Leguizamo",
                          "meta": "Gor Koresh"
                      },
                      {
                          "num": "MWA-JS",
                          "title": "Jason Spisak",
                          "meta": "Lux Bonteri"
                      },
                      {
                          "num": "MWA-KO",
                          "title": "Katy O'Brian",
                          "meta": "Imperial Comms Officer"
                      },
                      {
                          "num": "MWA-KS",
                          "title": "Katee Sackhoff",
                          "meta": "Bo-Katan Kryze"
                      },
                      {
                          "num": "MWA-KSH",
                          "title": "Kiran Shah",
                          "meta": "Nambi Ghima"
                      },
                      {
                          "num": "MWA-LS",
                          "title": "Leilani Shiu",
                          "meta": "Jawa"
                      },
                      {
                          "num": "MWA-MBJ",
                          "title": "Mark Boone Junior",
                          "meta": "Ranzar Malk"
                      },
                      {
                          "num": "MWA-MBO",
                          "title": "Michonne Bourriague",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "MWA-MH",
                          "title": "Mark Hamill",
                          "meta": "Luke Skywalker"
                      },
                      {
                          "num": "MWA-MI",
                          "title": "Moses Ingram",
                          "meta": "Reva"
                      },
                      {
                          "num": "MWA-MNW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "MWA-MPM",
                          "title": "Murphy Patrick Martin",
                          "meta": "Drummer"
                      },
                      {
                          "num": "MWA-MR",
                          "title": "Misty Rosas",
                          "meta": "Frog Lady"
                      },
                      {
                          "num": "MWA-MV",
                          "title": "Mercedes Varnado",
                          "meta": "Koska Reeves"
                      },
                      {
                          "num": "MWA-MW",
                          "title": "Matthew Wood",
                          "meta": "General Grievous"
                      },
                      {
                          "num": "MWA-NF",
                          "title": "Nika Futterman",
                          "meta": "Asajj Ventress"
                      },
                      {
                          "num": "MWA-OA",
                          "title": "Omid Abtahi",
                          "meta": "Dr. Pershing"
                      },
                      {
                          "num": "MWA-OD",
                          "title": "Olivia d'ABO",
                          "meta": "Luminara Unduli"
                      },
                      {
                          "num": "MWA-PA",
                          "title": "Philip Alexander",
                          "meta": "Fifth Brother"
                      },
                      {
                          "num": "MWA-PAR",
                          "title": "Philip Anthony-Rodriguez",
                          "meta": "Imperial Security Officer"
                      },
                      {
                          "num": "MWA-PD",
                          "title": "Paul Darnell",
                          "meta": "C'ai Threnalli"
                      },
                      {
                          "num": "MWA-PK",
                          "title": "Paul Kasey",
                          "meta": "Night Wind Assassin"
                      },
                      {
                          "num": "MWA-PSL",
                          "title": "Paul Sun-Hyung Lee",
                          "meta": "Captain Carson Teva"
                      },
                      {
                          "num": "MWA-RB",
                          "title": "Richard Brake",
                          "meta": "Valin Hess"
                      },
                      {
                          "num": "MWA-RD",
                          "title": "Rosario Dawson",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "MWA-RO",
                          "title": "Rena Owen",
                          "meta": "Taun We"
                      },
                      {
                          "num": "MWA-SB",
                          "title": "Skyler Bible",
                          "meta": "Fixer"
                      },
                      {
                          "num": "MWA-SK",
                          "title": "Simon Kassianides",
                          "meta": "Axe Woves"
                      },
                      {
                          "num": "MWA-SS",
                          "title": "Stephen Stanton",
                          "meta": "Admiral Tarkin"
                      },
                      {
                          "num": "MWA-SW",
                          "title": "Sam Witwer",
                          "meta": "Maul"
                      },
                      {
                          "num": "MWA-TF",
                          "title": "Tait Fletcher",
                          "meta": "Alpha Trawler"
                      },
                      {
                          "num": "MWA-TG",
                          "title": "Taylor Gray",
                          "meta": "Ezra Bridger"
                      },
                      {
                          "num": "MWA-TM",
                          "title": "Temuera Morrison",
                          "meta": "Boba Fett"
                      },
                      {
                          "num": "MWA-TO",
                          "title": "Timothy Olyphant",
                          "meta": "Cobb Vanth"
                      },
                      {
                          "num": "MWA-TR",
                          "title": "Tim Rose",
                          "meta": "Admiral Ackbar"
                      },
                      {
                          "num": "MWA-TS",
                          "title": "Tiya Sircar",
                          "meta": "Sabine Wren"
                      }
                  ]
              },
              {
                  "count": 10,
                  "name": "DUAL AUTOGRAPHS",
                  "meta": "Two-signer pairings · base serial /50",
                  "odds": "1:205 packs",
                  "parallels": 5,
                  "cards": [
                      {
                          "num": "MWD-BQ",
                          "title": "Ralph Brown / Hugh Quarshie",
                          "meta": "Ric Olié / Captain Panaka"
                      },
                      {
                          "num": "MWD-CE",
                          "title": "Alden Ehrenreich / Emilia Clarke",
                          "meta": "Han Solo / Qi'ra"
                      },
                      {
                          "num": "MWD-GB",
                          "title": "Steve Blum / Taylor Gray",
                          "meta": "Zeb Orrelios / Ezra Bridger"
                      },
                      {
                          "num": "MWD-GC",
                          "title": "Taylor Gray / Jim Cummings",
                          "meta": "Ezra Bridger / Hondo Ohnaka"
                      },
                      {
                          "num": "MWD-HM",
                          "title": "Guy Henry / Ben Mendelsohn",
                          "meta": "Governor Tarkin / Director Krennic"
                      },
                      {
                          "num": "MWD-JW",
                          "title": "Forest Whitaker / Felicity Jones",
                          "meta": "Saw Gerrera / Jyn Erso"
                      },
                      {
                          "num": "MWD-MC",
                          "title": "Ewan McGregor / Hayden Christensen",
                          "meta": "Obi-Wan Kenobi / Darth Vader"
                      },
                      {
                          "num": "MWD-PM",
                          "title": "Natalie Portman / Ian McDiarmid",
                          "meta": "Padmé Amidala / Chancellor Palpatine"
                      },
                      {
                          "num": "MWD-TL",
                          "title": "Kelly Marie Tran / Billie Lourd",
                          "meta": "Rose Tico / Kaydel Ko Connix"
                      },
                      {
                          "num": "MWD-WJ",
                          "title": "Ming-Na Wen / Carey Jones",
                          "meta": "Fennec Shand / Krrsantan"
                      }
                  ]
              },
              {
                  "count": 3,
                  "name": "TRIPLE AUTOGRAPHS",
                  "meta": "Three-signer combinations · base serial /25",
                  "odds": "1:50,112 packs",
                  "parallels": 4,
                  "cards": [
                      {
                          "num": "MWT-CPM",
                          "title": "Ian McDiarmid / Hayden Christensen / Natalie Portman",
                          "meta": "Emperor Palpatine / Anakin Skywalker / Padmé Amidala"
                      },
                      {
                          "num": "MWT-EKC",
                          "title": "Erin Kellyman / Emilia Clarke / Alden Ehrenreich",
                          "meta": "Enfys Nest / Qi'ra / Han Solo"
                      },
                      {
                          "num": "MWT-MPC",
                          "title": "Matthew Wood / Ian McDiarmid / Hayden Christensen",
                          "meta": "General Grievous / Darth Sidious / Darth Vader"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "QUAD AUTOGRAPH BOOK CARDS",
                  "meta": "Four-signer books · serial /2 — two copies each",
                  "odds": "1:12,528 packs",
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "MWQ-CMEP",
                          "title": "Ewan McGregor / Hayden Christensen / Bonnie Piesse / Joel Edgerton",
                          "meta": "Obi-Wan Kenobi / Anakin Skywalker / Beru Lars / Owen Lars"
                      },
                      {
                          "num": "MWQ-JMMK",
                          "title": "Valene Kane / Mads Mikkelsen / Ben Mendelsohn / Felicity Jones",
                          "meta": "Lyra Erso / Galen Erso / Director Krennic / Jyn Erso"
                      },
                      {
                          "num": "MWQ-MWJP",
                          "title": "Carey Jones / Ming-Na Wen / Temuera Morrison / David Pasquesi",
                          "meta": "Krrsantan / Fennec Shand / Boba Fett / Twi'lek Majordomo"
                      },
                      {
                          "num": "MWQ-PDWE",
                          "title": "Taika Waititi / Giancarlo Esposito / Rosario Dawson / Pedro Pascal",
                          "meta": "IG-11 / Moff Gideon / Ahsoka Tano / The Mandalorian"
                      },
                      {
                          "num": "MWQ-PJFR",
                          "title": "Carrie Fisher / Natalie Portman / Daisy Ridley / Felicity Jones",
                          "meta": "General Leia Organa / Queen Amidala / Rey / Jyn Erso"
                      }
                  ]
              },
              {
                  "count": 7,
                  "name": "COSTUME RELIC AUTOGRAPHS",
                  "meta": "Signed costume relics · serial /3 · first Masterwork auto relics",
                  "odds": "1:2,387 packs",
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "CRA-AD",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "CRA-AD2",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "CRA-DR",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      },
                      {
                          "num": "CRA-DR2",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      },
                      {
                          "num": "CRA-FJ",
                          "title": "Felicity Jones",
                          "meta": "Jyn Erso"
                      },
                      {
                          "num": "CRA-MW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "CRA-RD",
                          "title": "Rosario Dawson",
                          "meta": "Ahsoka Tano"
                      }
                  ]
              },
              {
                  "count": 8,
                  "name": "ON-SCREEN PROP RELIC AUTOGRAPHS",
                  "meta": "Signed Rogue One prop relics · serial /3",
                  "odds": "1:2,278 packs",
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "OSPRA-BR",
                          "title": "Riz Ahmed",
                          "meta": "Bodhi Rook"
                      },
                      {
                          "num": "OSPRA-CA",
                          "title": "Diego Luna",
                          "meta": "Cassian Andor"
                      },
                      {
                          "num": "OSPRA-CI",
                          "title": "Donnie Yen",
                          "meta": "Chirrut Îmwe"
                      },
                      {
                          "num": "OSPRA-GM",
                          "title": "Ben Daniels",
                          "meta": "General Merrick"
                      },
                      {
                          "num": "OSPRA-JD",
                          "title": "Ian McElhinney",
                          "meta": "Jan Dodonna"
                      },
                      {
                          "num": "OSPRA-JE",
                          "title": "Felicity Jones",
                          "meta": "Jyn Erso"
                      },
                      {
                          "num": "OSPRA-K2",
                          "title": "Alan Tudyk",
                          "meta": "K-2SO"
                      },
                      {
                          "num": "OSPRA-MM",
                          "title": "Genevieve O'Reilly",
                          "meta": "Mon Mothma"
                      }
                  ]
              },
              {
                  "count": 5,
                  "name": "STAMP CARD AUTOGRAPHS",
                  "meta": "Ford · Fisher · Christensen · Driver · Ridley · serial /3",
                  "odds": "1:3,341 packs",
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "SC-DV",
                          "title": "Hayden Christensen",
                          "meta": "Darth Vader"
                      },
                      {
                          "num": "SC-HS",
                          "title": "Harrison Ford",
                          "meta": "Han Solo"
                      },
                      {
                          "num": "SC-KR",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "SC-LO",
                          "title": "Carrie Fisher",
                          "meta": "General Leia Organa"
                      },
                      {
                          "num": "SC-RS",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      }
                  ]
              },
              {
                  "count": 7,
                  "name": "TOOLS & TECHNOLOGY MEDALLION AUTOGRAPHS",
                  "meta": "Signed medallion relics · serial /3",
                  "odds": "1:2,387 packs",
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "TTMA-K",
                          "title": "Carey Jones",
                          "meta": "Krrsantan"
                      },
                      {
                          "num": "TTMA-KR",
                          "title": "Adam Driver",
                          "meta": "Kylo Ren"
                      },
                      {
                          "num": "TTMA-MG",
                          "title": "Giancarlo Esposito",
                          "meta": "Moff Gideon"
                      },
                      {
                          "num": "TTMA-P",
                          "title": "Ian McDiarmid",
                          "meta": "Palpatine"
                      },
                      {
                          "num": "TTMA-Q",
                          "title": "Emilia Clarke",
                          "meta": "Qi'ra"
                      },
                      {
                          "num": "TTMA-R",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      },
                      {
                          "num": "TTMA-TC",
                          "title": "Werner Herzog",
                          "meta": "The Client"
                      }
                  ]
              },
              {
                  "count": 25,
                  "name": "PEN RELIC AUTOGRAPHS",
                  "meta": "A piece of the signing pen · one-of-one",
                  "odds": "1:2,005 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "PRA-AB",
                          "title": "Ahmed Best",
                          "meta": "Jar Jar Binks"
                      },
                      {
                          "num": "PRA-AK",
                          "title": "Andrew Kishino",
                          "meta": "Saw Gerrera"
                      },
                      {
                          "num": "PRA-AW",
                          "title": "Alexander Wraith",
                          "meta": "Imperial Freighter Pilot"
                      },
                      {
                          "num": "PRA-CB",
                          "title": "Chris Bartlett",
                          "meta": "Zero"
                      },
                      {
                          "num": "PRA-CJ",
                          "title": "Carey Jones",
                          "meta": "Krrsantan"
                      },
                      {
                          "num": "PRA-DA",
                          "title": "David Acord",
                          "meta": "FN-2199"
                      },
                      {
                          "num": "PRA-DK",
                          "title": "Dorian Kingi",
                          "meta": "Cad Bane"
                      },
                      {
                          "num": "PRA-DR",
                          "title": "Daisy Ridley",
                          "meta": "Rey"
                      },
                      {
                          "num": "PRA-GE",
                          "title": "Giancarlo Esposito",
                          "meta": "Moff Gideon"
                      },
                      {
                          "num": "PRA-GT",
                          "title": "Gina Torres",
                          "meta": "Ketsu Onyo"
                      },
                      {
                          "num": "PRA-JC",
                          "title": "Jim Cummings",
                          "meta": "Hondo Ohnaka"
                      },
                      {
                          "num": "PRA-JK",
                          "title": "Jaime King",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "PRA-JL",
                          "title": "John Leguizamo",
                          "meta": "Gor Koresh"
                      },
                      {
                          "num": "PRA-JS",
                          "title": "Jason Spisak",
                          "meta": "Lux Bonteri"
                      },
                      {
                          "num": "PRA-KS",
                          "title": "Kiran Shah",
                          "meta": "Nambi Ghima"
                      },
                      {
                          "num": "PRA-MI",
                          "title": "Michonne Bourriague",
                          "meta": "Aurra Sing"
                      },
                      {
                          "num": "PRA-MW",
                          "title": "Ming-Na Wen",
                          "meta": "Fennec Shand"
                      },
                      {
                          "num": "PRA-OA",
                          "title": "Omid Abtahi",
                          "meta": "Dr. Pershing"
                      },
                      {
                          "num": "PRA-Od",
                          "title": "Olivia d'Abo",
                          "meta": "Luminara Unduli"
                      },
                      {
                          "num": "PRA-PD",
                          "title": "Paul Darnell",
                          "meta": "Night Wind Assassin"
                      },
                      {
                          "num": "PRA-RB",
                          "title": "Richard Brake",
                          "meta": "Valin Hess"
                      },
                      {
                          "num": "PRA-RD",
                          "title": "Rosario Dawson",
                          "meta": "Ahsoka Tano"
                      },
                      {
                          "num": "PRA-SK",
                          "title": "Skyler Bible",
                          "meta": "Fixer"
                      },
                      {
                          "num": "PRA-TF",
                          "title": "Tait Fletcher",
                          "meta": "Alpha Trawler"
                      },
                      {
                          "num": "PRA-TM",
                          "title": "Temuera Morrison",
                          "meta": "Boba Fett"
                      }
                  ]
              }
          ],
          "sketch": [
              {
                  "count": 94,
                  "name": "SKETCH CARDS",
                  "meta": "One-of-one sketches · 94 artists",
                  "odds": "1:10 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "SK-1",
                          "title": "Sketch Card",
                          "meta": "Dan Tearle"
                      },
                      {
                          "num": "SK-2",
                          "title": "Sketch Card",
                          "meta": "Benjamin Lombart"
                      },
                      {
                          "num": "SK-3",
                          "title": "Sketch Card",
                          "meta": "Basak Kahraman"
                      },
                      {
                          "num": "SK-4",
                          "title": "Sketch Card",
                          "meta": "Gerry Garcia Jr"
                      },
                      {
                          "num": "SK-5",
                          "title": "Sketch Card",
                          "meta": "Ryan Finley"
                      },
                      {
                          "num": "SK-6",
                          "title": "Sketch Card",
                          "meta": "Oscar Chavez"
                      },
                      {
                          "num": "SK-7",
                          "title": "Sketch Card",
                          "meta": "Jason Montoya"
                      },
                      {
                          "num": "SK-8",
                          "title": "Sketch Card",
                          "meta": "Andrew Fry"
                      },
                      {
                          "num": "SK-9",
                          "title": "Sketch Card",
                          "meta": "Patricio Carrasco"
                      },
                      {
                          "num": "SK-10",
                          "title": "Sketch Card",
                          "meta": "Dan Lawler"
                      },
                      {
                          "num": "SK-11",
                          "title": "Sketch Card",
                          "meta": "Eric Lehtonen"
                      },
                      {
                          "num": "SK-12",
                          "title": "Sketch Card",
                          "meta": "Francisco Rivera"
                      },
                      {
                          "num": "SK-13",
                          "title": "Sketch Card",
                          "meta": "Jamison Murdock"
                      },
                      {
                          "num": "SK-14",
                          "title": "Sketch Card",
                          "meta": "Jenn DePaola"
                      },
                      {
                          "num": "SK-15",
                          "title": "Sketch Card",
                          "meta": "Jessica Hickman"
                      },
                      {
                          "num": "SK-16",
                          "title": "Sketch Card",
                          "meta": "Josh Trout"
                      },
                      {
                          "num": "SK-17",
                          "title": "Sketch Card",
                          "meta": "Kevin Nelson"
                      },
                      {
                          "num": "SK-18",
                          "title": "Sketch Card",
                          "meta": "Krishna Sharma"
                      },
                      {
                          "num": "SK-19",
                          "title": "Sketch Card",
                          "meta": "Kyle Babbitt"
                      },
                      {
                          "num": "SK-20",
                          "title": "Sketch Card",
                          "meta": "Marcia Dye"
                      },
                      {
                          "num": "SK-21",
                          "title": "Sketch Card",
                          "meta": "Patrick Davis"
                      },
                      {
                          "num": "SK-22",
                          "title": "Sketch Card",
                          "meta": "Robert Hendrickson"
                      },
                      {
                          "num": "SK-23",
                          "title": "Sketch Card",
                          "meta": "Veronica Smith"
                      },
                      {
                          "num": "SK-24",
                          "title": "Sketch Card",
                          "meta": "Brent Scotchmer"
                      },
                      {
                          "num": "SK-25",
                          "title": "Sketch Card",
                          "meta": "Bobby Blakey"
                      },
                      {
                          "num": "SK-26",
                          "title": "Sketch Card",
                          "meta": "Neil Camera"
                      },
                      {
                          "num": "SK-27",
                          "title": "Sketch Card",
                          "meta": "Veronica Louro"
                      },
                      {
                          "num": "SK-28",
                          "title": "Sketch Card",
                          "meta": "Zach Woolsey"
                      },
                      {
                          "num": "SK-29",
                          "title": "Sketch Card",
                          "meta": "Tim Shinn"
                      },
                      {
                          "num": "SK-30",
                          "title": "Sketch Card",
                          "meta": "Tom Amici"
                      },
                      {
                          "num": "SK-31",
                          "title": "Sketch Card",
                          "meta": "Michael Munshaw"
                      },
                      {
                          "num": "SK-32",
                          "title": "Sketch Card",
                          "meta": "Angel Aviles"
                      },
                      {
                          "num": "SK-33",
                          "title": "Sketch Card",
                          "meta": "Emre Varlibas"
                      },
                      {
                          "num": "SK-34",
                          "title": "Sketch Card",
                          "meta": "Brett Farr"
                      },
                      {
                          "num": "SK-35",
                          "title": "Sketch Card",
                          "meta": "Chris Thorne"
                      },
                      {
                          "num": "SK-36",
                          "title": "Sketch Card",
                          "meta": "Jonathan Beistline"
                      },
                      {
                          "num": "SK-37",
                          "title": "Sketch Card",
                          "meta": "Matt Stewart"
                      },
                      {
                          "num": "SK-38",
                          "title": "Sketch Card",
                          "meta": "Richard Molinelli"
                      },
                      {
                          "num": "SK-39",
                          "title": "Sketch Card",
                          "meta": "Quinton Baker"
                      },
                      {
                          "num": "SK-40",
                          "title": "Sketch Card",
                          "meta": "John Bruce"
                      },
                      {
                          "num": "SK-41",
                          "title": "Sketch Card",
                          "meta": "Adam Everett Beck"
                      },
                      {
                          "num": "SK-42",
                          "title": "Sketch Card",
                          "meta": "Ian McKesson"
                      },
                      {
                          "num": "SK-43",
                          "title": "Sketch Card",
                          "meta": "Jane Rushton"
                      },
                      {
                          "num": "SK-44",
                          "title": "Sketch Card",
                          "meta": "Jason Sobol"
                      },
                      {
                          "num": "SK-45",
                          "title": "Sketch Card",
                          "meta": "Marlo Agunos"
                      },
                      {
                          "num": "SK-46",
                          "title": "Sketch Card",
                          "meta": "CJ Jones"
                      },
                      {
                          "num": "SK-47",
                          "title": "Sketch Card",
                          "meta": "Michael Mastermaker"
                      },
                      {
                          "num": "SK-48",
                          "title": "Sketch Card",
                          "meta": "Yves Van Berlo"
                      },
                      {
                          "num": "SK-49",
                          "title": "Sketch Card",
                          "meta": "Jay Manchand"
                      },
                      {
                          "num": "SK-50",
                          "title": "Sketch Card",
                          "meta": "Brad Hudson"
                      },
                      {
                          "num": "SK-51",
                          "title": "Sketch Card",
                          "meta": "Cory Payne"
                      },
                      {
                          "num": "SK-52",
                          "title": "Sketch Card",
                          "meta": "Darrin Pepe"
                      },
                      {
                          "num": "SK-53",
                          "title": "Sketch Card",
                          "meta": "Dwayne Carpenter"
                      },
                      {
                          "num": "SK-54",
                          "title": "Sketch Card",
                          "meta": "Gabe Farber"
                      },
                      {
                          "num": "SK-55",
                          "title": "Sketch Card",
                          "meta": "Jamie Richards"
                      },
                      {
                          "num": "SK-56",
                          "title": "Sketch Card",
                          "meta": "Joey Mason"
                      },
                      {
                          "num": "SK-57",
                          "title": "Sketch Card",
                          "meta": "Kevin B Cleveland"
                      },
                      {
                          "num": "SK-58",
                          "title": "Sketch Card",
                          "meta": "Logan Monette"
                      },
                      {
                          "num": "SK-59",
                          "title": "Sketch Card",
                          "meta": "Mike Sealie"
                      },
                      {
                          "num": "SK-60",
                          "title": "Sketch Card",
                          "meta": "Rugved Bhuskute"
                      },
                      {
                          "num": "SK-61",
                          "title": "Sketch Card",
                          "meta": "Semra Bulut"
                      },
                      {
                          "num": "SK-62",
                          "title": "Sketch Card",
                          "meta": "Shyla Lee"
                      },
                      {
                          "num": "SK-63",
                          "title": "Sketch Card",
                          "meta": "Nick Gribbon"
                      },
                      {
                          "num": "SK-64",
                          "title": "Sketch Card",
                          "meta": "Karl Jones"
                      },
                      {
                          "num": "SK-65",
                          "title": "Sketch Card",
                          "meta": "Stephane Leonardi"
                      },
                      {
                          "num": "SK-66",
                          "title": "Sketch Card",
                          "meta": "Rebeca Louro"
                      },
                      {
                          "num": "SK-67",
                          "title": "Sketch Card",
                          "meta": "Dawn Murphy"
                      },
                      {
                          "num": "SK-68",
                          "title": "Sketch Card",
                          "meta": "Julia Mckenzie"
                      },
                      {
                          "num": "SK-69",
                          "title": "Sketch Card",
                          "meta": "Robert Garcia"
                      },
                      {
                          "num": "SK-70",
                          "title": "Sketch Card",
                          "meta": "Rusty Gilligan"
                      },
                      {
                          "num": "SK-71",
                          "title": "Sketch Card",
                          "meta": "Robert Stewart IV"
                      },
                      {
                          "num": "SK-72",
                          "title": "Sketch Card",
                          "meta": "Brandon Klein"
                      },
                      {
                          "num": "SK-73",
                          "title": "Sketch Card",
                          "meta": "Cyrus Sherkat"
                      },
                      {
                          "num": "SK-74",
                          "title": "Sketch Card",
                          "meta": "Jenna McGrath"
                      },
                      {
                          "num": "SK-75",
                          "title": "Sketch Card",
                          "meta": "Ryan Thompson"
                      },
                      {
                          "num": "SK-76",
                          "title": "Sketch Card",
                          "meta": "Neil Anthony Brady"
                      },
                      {
                          "num": "SK-77",
                          "title": "Sketch Card",
                          "meta": "Limuel Pinzon"
                      },
                      {
                          "num": "SK-78",
                          "title": "Sketch Card",
                          "meta": "Alex Mines"
                      },
                      {
                          "num": "SK-79",
                          "title": "Sketch Card",
                          "meta": "Anthony Pietszak"
                      },
                      {
                          "num": "SK-80",
                          "title": "Sketch Card",
                          "meta": "Jason Davies"
                      },
                      {
                          "num": "SK-81",
                          "title": "Sketch Card",
                          "meta": "Luke Seavers"
                      },
                      {
                          "num": "SK-82",
                          "title": "Sketch Card",
                          "meta": "Mike Dalzell"
                      },
                      {
                          "num": "SK-83",
                          "title": "Sketch Card",
                          "meta": "Scott Anthony"
                      },
                      {
                          "num": "SK-84",
                          "title": "Sketch Card",
                          "meta": "Dove McHargue"
                      },
                      {
                          "num": "SK-85",
                          "title": "Sketch Card",
                          "meta": "Eric Medina"
                      },
                      {
                          "num": "SK-86",
                          "title": "Sketch Card",
                          "meta": "Matthew Maldonado"
                      },
                      {
                          "num": "SK-87",
                          "title": "Sketch Card",
                          "meta": "Vincenzo D'lppolito aka Chenduz"
                      },
                      {
                          "num": "SK-88",
                          "title": "Sketch Card",
                          "meta": "Michael Davidson"
                      },
                      {
                          "num": "SK-89",
                          "title": "Sketch Card",
                          "meta": "Chad Thomas"
                      },
                      {
                          "num": "SK-90",
                          "title": "Sketch Card",
                          "meta": "Jackson Ong"
                      },
                      {
                          "num": "SK-91",
                          "title": "Sketch Card",
                          "meta": "Rachel Jane Hetherington"
                      },
                      {
                          "num": "SK-92",
                          "title": "Sketch Card",
                          "meta": "Steve Alce"
                      },
                      {
                          "num": "SK-93",
                          "title": "Sketch Card",
                          "meta": "Candice Dailey"
                      },
                      {
                          "num": "SK-94",
                          "title": "Sketch Card",
                          "meta": "Tim Parsons"
                      }
                  ]
              },
              {
                  "count": 48,
                  "name": "SKETCH BOOK CARDS",
                  "meta": "Two-panel sketch books · 48 artists",
                  "odds": "1:583 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "SBK-1",
                          "title": "Sketch Book Card",
                          "meta": "Benjamin Lombert"
                      },
                      {
                          "num": "SBK-2",
                          "title": "Sketch Book Card",
                          "meta": "Andrew Fry"
                      },
                      {
                          "num": "SBK-3",
                          "title": "Sketch Book Card",
                          "meta": "Dan Lawler"
                      },
                      {
                          "num": "SBK-4",
                          "title": "Sketch Book Card",
                          "meta": "Bradley Hudson"
                      },
                      {
                          "num": "SBK-5",
                          "title": "Sketch Book Card",
                          "meta": "Dan Tearle"
                      },
                      {
                          "num": "SBK-6",
                          "title": "Sketch Book Card",
                          "meta": "Darrin Pepe"
                      },
                      {
                          "num": "SBK-7",
                          "title": "Sketch Book Card",
                          "meta": "Debjit Kar"
                      },
                      {
                          "num": "SBK-8",
                          "title": "Sketch Book Card",
                          "meta": "Emre Varlibas"
                      },
                      {
                          "num": "SBK-9",
                          "title": "Sketch Book Card",
                          "meta": "Francisco Rivera"
                      },
                      {
                          "num": "SBK-10",
                          "title": "Sketch Book Card",
                          "meta": "Ian Mckesson"
                      },
                      {
                          "num": "SBK-11",
                          "title": "Sketch Book Card",
                          "meta": "Jamie Richards"
                      },
                      {
                          "num": "SBK-12",
                          "title": "Sketch Book Card",
                          "meta": "Jamison Murdock"
                      },
                      {
                          "num": "SBK-13",
                          "title": "Sketch Book Card",
                          "meta": "Jane Rushton"
                      },
                      {
                          "num": "SBK-14",
                          "title": "Sketch Book Card",
                          "meta": "Jason Sobol"
                      },
                      {
                          "num": "SBK-15",
                          "title": "Sketch Book Card",
                          "meta": "Jay Manchand"
                      },
                      {
                          "num": "SBK-16",
                          "title": "Sketch Book Card",
                          "meta": "Jenn DePaola"
                      },
                      {
                          "num": "SBK-17",
                          "title": "Sketch Book Card",
                          "meta": "Jenn McGrath"
                      },
                      {
                          "num": "SBK-18",
                          "title": "Sketch Book Card",
                          "meta": "Joey Mason"
                      },
                      {
                          "num": "SBK-19",
                          "title": "Sketch Book Card",
                          "meta": "John Pleak"
                      },
                      {
                          "num": "SBK-20",
                          "title": "Sketch Book Card",
                          "meta": "Jonathan Beistline"
                      },
                      {
                          "num": "SBK-21",
                          "title": "Sketch Book Card",
                          "meta": "Kevin B Cleveland"
                      },
                      {
                          "num": "SBK-22",
                          "title": "Sketch Book Card",
                          "meta": "Krishna Sharma"
                      },
                      {
                          "num": "SBK-23",
                          "title": "Sketch Book Card",
                          "meta": "Logan Monette"
                      },
                      {
                          "num": "SBK-24",
                          "title": "Sketch Book Card",
                          "meta": "Marlo Agunos"
                      },
                      {
                          "num": "SBK-25",
                          "title": "Sketch Book Card",
                          "meta": "Matt Stewart"
                      },
                      {
                          "num": "SBK-26",
                          "title": "Sketch Book Card",
                          "meta": "Michael Mastermaker"
                      },
                      {
                          "num": "SBK-27",
                          "title": "Sketch Book Card",
                          "meta": "Michael Munshaw"
                      },
                      {
                          "num": "SBK-28",
                          "title": "Sketch Book Card",
                          "meta": "Mike Sealie"
                      },
                      {
                          "num": "SBK-29",
                          "title": "Sketch Book Card",
                          "meta": "Neil Camera"
                      },
                      {
                          "num": "SBK-30",
                          "title": "Sketch Book Card",
                          "meta": "Nick Gribbon"
                      },
                      {
                          "num": "SBK-31",
                          "title": "Sketch Book Card",
                          "meta": "Patrick Davis"
                      },
                      {
                          "num": "SBK-32",
                          "title": "Sketch Book Card",
                          "meta": "Patricio Carrasco"
                      },
                      {
                          "num": "SBK-33",
                          "title": "Sketch Book Card",
                          "meta": "Quinton Baker"
                      },
                      {
                          "num": "SBK-34",
                          "title": "Sketch Book Card",
                          "meta": "Robert Stewart"
                      },
                      {
                          "num": "SBK-35",
                          "title": "Sketch Book Card",
                          "meta": "Rugved Bhuskute"
                      },
                      {
                          "num": "SBK-36",
                          "title": "Sketch Book Card",
                          "meta": "Ryan Finley"
                      },
                      {
                          "num": "SBK-37",
                          "title": "Sketch Book Card",
                          "meta": "Semra Bulut"
                      },
                      {
                          "num": "SBK-38",
                          "title": "Sketch Book Card",
                          "meta": "CJ Jones"
                      },
                      {
                          "num": "SBK-39",
                          "title": "Sketch Book Card",
                          "meta": "Veronica Louro"
                      },
                      {
                          "num": "SBK-40",
                          "title": "Sketch Book Card",
                          "meta": "Rebeca Louro"
                      },
                      {
                          "num": "SBK-41",
                          "title": "Sketch Book Card",
                          "meta": "Yves Van Berlo"
                      },
                      {
                          "num": "SBK-42",
                          "title": "Sketch Book Card",
                          "meta": "Zach Woolsey"
                      },
                      {
                          "num": "SBK-43",
                          "title": "Sketch Book Card",
                          "meta": "Brett Farr"
                      },
                      {
                          "num": "SBK-44",
                          "title": "Sketch Book Card",
                          "meta": "Dean Drummond"
                      },
                      {
                          "num": "SBK-45",
                          "title": "Sketch Book Card",
                          "meta": "Cory Payne"
                      },
                      {
                          "num": "SBK-46",
                          "title": "Sketch Book Card",
                          "meta": "Bobby Blakey"
                      },
                      {
                          "num": "SBK-47",
                          "title": "Sketch Book Card",
                          "meta": "Basak Kahraman"
                      },
                      {
                          "num": "SBK-48",
                          "title": "Sketch Book Card",
                          "meta": "Adam Everett Beck"
                      }
                  ]
              },
              {
                  "count": 45,
                  "name": "PANORAMIC SKETCH CARDS",
                  "meta": "Wide-format sketches · 45 artists",
                  "odds": "1:583 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "PSK-1",
                          "title": "Panoramic Sketch Card",
                          "meta": "Benjamin Lombert"
                      },
                      {
                          "num": "PSK-2",
                          "title": "Panoramic Sketch Card",
                          "meta": "Adam Everett Beck"
                      },
                      {
                          "num": "PSK-3",
                          "title": "Panoramic Sketch Card",
                          "meta": "Basak Kahraman"
                      },
                      {
                          "num": "PSK-4",
                          "title": "Panoramic Sketch Card",
                          "meta": "Bobby Blakey"
                      },
                      {
                          "num": "PSK-5",
                          "title": "Panoramic Sketch Card",
                          "meta": "Bradley Hudson"
                      },
                      {
                          "num": "PSK-6",
                          "title": "Panoramic Sketch Card",
                          "meta": "Brett Farr"
                      },
                      {
                          "num": "PSK-7",
                          "title": "Panoramic Sketch Card",
                          "meta": "Cory Payne"
                      },
                      {
                          "num": "PSK-8",
                          "title": "Panoramic Sketch Card",
                          "meta": "Dan Lawler"
                      },
                      {
                          "num": "PSK-9",
                          "title": "Panoramic Sketch Card",
                          "meta": "Dan Tearle"
                      },
                      {
                          "num": "PSK-10",
                          "title": "Panoramic Sketch Card",
                          "meta": "Darrin Pepe"
                      },
                      {
                          "num": "PSK-11",
                          "title": "Panoramic Sketch Card",
                          "meta": "Dean Drummond"
                      },
                      {
                          "num": "PSK-12",
                          "title": "Panoramic Sketch Card",
                          "meta": "Debjit Kar"
                      },
                      {
                          "num": "PSK-13",
                          "title": "Panoramic Sketch Card",
                          "meta": "Dwayne Carpenter"
                      },
                      {
                          "num": "PSK-14",
                          "title": "Panoramic Sketch Card",
                          "meta": "Emre Varlibas"
                      },
                      {
                          "num": "PSK-15",
                          "title": "Panoramic Sketch Card",
                          "meta": "Francisco Rivera"
                      },
                      {
                          "num": "PSK-16",
                          "title": "Panoramic Sketch Card",
                          "meta": "Ian Mckesson"
                      },
                      {
                          "num": "PSK-17",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jamie Richards"
                      },
                      {
                          "num": "PSK-18",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jamison Murdock"
                      },
                      {
                          "num": "PSK-19",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jane Rushton"
                      },
                      {
                          "num": "PSK-20",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jason Sobol"
                      },
                      {
                          "num": "PSK-21",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jenna McGrath"
                      },
                      {
                          "num": "PSK-22",
                          "title": "Panoramic Sketch Card",
                          "meta": "Joey Mason"
                      },
                      {
                          "num": "PSK-23",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jessica Hickman"
                      },
                      {
                          "num": "PSK-24",
                          "title": "Panoramic Sketch Card",
                          "meta": "John Pleak"
                      },
                      {
                          "num": "PSK-25",
                          "title": "Panoramic Sketch Card",
                          "meta": "Jonathan Beistline"
                      },
                      {
                          "num": "PSK-26",
                          "title": "Panoramic Sketch Card",
                          "meta": "Kevin B Cleveland"
                      },
                      {
                          "num": "PSK-27",
                          "title": "Panoramic Sketch Card",
                          "meta": "Krishna Sharma"
                      },
                      {
                          "num": "PSK-28",
                          "title": "Panoramic Sketch Card",
                          "meta": "Logan Monette"
                      },
                      {
                          "num": "PSK-29",
                          "title": "Panoramic Sketch Card",
                          "meta": "Marlo Agunos"
                      },
                      {
                          "num": "PSK-30",
                          "title": "Panoramic Sketch Card",
                          "meta": "Matt Stewart"
                      },
                      {
                          "num": "PSK-31",
                          "title": "Panoramic Sketch Card",
                          "meta": "Michael Mastermaker"
                      },
                      {
                          "num": "PSK-32",
                          "title": "Panoramic Sketch Card",
                          "meta": "Michael Munshaw"
                      },
                      {
                          "num": "PSK-33",
                          "title": "Panoramic Sketch Card",
                          "meta": "Mike Sealie"
                      },
                      {
                          "num": "PSK-34",
                          "title": "Panoramic Sketch Card",
                          "meta": "Neil Camera"
                      },
                      {
                          "num": "PSK-35",
                          "title": "Panoramic Sketch Card",
                          "meta": "Nick Gribbon"
                      },
                      {
                          "num": "PSK-36",
                          "title": "Panoramic Sketch Card",
                          "meta": "Patricio Carrasco"
                      },
                      {
                          "num": "PSK-37",
                          "title": "Panoramic Sketch Card",
                          "meta": "Patrick Davis"
                      },
                      {
                          "num": "PSK-38",
                          "title": "Panoramic Sketch Card",
                          "meta": "Quinton Baker"
                      },
                      {
                          "num": "PSK-39",
                          "title": "Panoramic Sketch Card",
                          "meta": "Robert Garcia"
                      },
                      {
                          "num": "PSK-40",
                          "title": "Panoramic Sketch Card",
                          "meta": "Robert Stewart"
                      },
                      {
                          "num": "PSK-41",
                          "title": "Panoramic Sketch Card",
                          "meta": "CJ Jones"
                      },
                      {
                          "num": "PSK-42",
                          "title": "Panoramic Sketch Card",
                          "meta": "Shyla Lee"
                      },
                      {
                          "num": "PSK-43",
                          "title": "Panoramic Sketch Card",
                          "meta": "Veronica Louro"
                      },
                      {
                          "num": "PSK-44",
                          "title": "Panoramic Sketch Card",
                          "meta": "Rebeca Louro"
                      },
                      {
                          "num": "PSK-45",
                          "title": "Panoramic Sketch Card",
                          "meta": "Zach Woolsey"
                      }
                  ]
              },
              {
                  "count": 46,
                  "name": "TRIPTYCH SKETCH CARDS",
                  "meta": "Three-panel sketches · 46 artists",
                  "odds": "1:395 packs",
                  "oneOfOne": true,
                  "noParallels": true,
                  "cards": [
                      {
                          "num": "TSK-1",
                          "title": "Triptych Sketch Card",
                          "meta": "Benjamin Lombert"
                      },
                      {
                          "num": "TSK-2",
                          "title": "Triptych Sketch Card",
                          "meta": "Adam Everett Beck"
                      },
                      {
                          "num": "TSK-3",
                          "title": "Triptych Sketch Card",
                          "meta": "Basak Kahraman"
                      },
                      {
                          "num": "TSK-4",
                          "title": "Triptych Sketch Card",
                          "meta": "Bobby Blakey"
                      },
                      {
                          "num": "TSK-5",
                          "title": "Triptych Sketch Card",
                          "meta": "Bradley Hudson"
                      },
                      {
                          "num": "TSK-6",
                          "title": "Triptych Sketch Card",
                          "meta": "Brett Farr"
                      },
                      {
                          "num": "TSK-7",
                          "title": "Triptych Sketch Card",
                          "meta": "Cory Payne"
                      },
                      {
                          "num": "TSK-8",
                          "title": "Triptych Sketch Card",
                          "meta": "Dan Lawler"
                      },
                      {
                          "num": "TSK-9",
                          "title": "Triptych Sketch Card",
                          "meta": "Dan Tearle"
                      },
                      {
                          "num": "TSK-10",
                          "title": "Triptych Sketch Card",
                          "meta": "Darrin Pepe"
                      },
                      {
                          "num": "TSK-11",
                          "title": "Triptych Sketch Card",
                          "meta": "Dean Drummond"
                      },
                      {
                          "num": "TSK-12",
                          "title": "Triptych Sketch Card",
                          "meta": "Debjit Kar"
                      },
                      {
                          "num": "TSK-13",
                          "title": "Triptych Sketch Card",
                          "meta": "Dwayne Carpenter"
                      },
                      {
                          "num": "TSK-14",
                          "title": "Triptych Sketch Card",
                          "meta": "Emre Varlibas"
                      },
                      {
                          "num": "TSK-15",
                          "title": "Triptych Sketch Card",
                          "meta": "Francisco Rivera"
                      },
                      {
                          "num": "TSK-16",
                          "title": "Triptych Sketch Card",
                          "meta": "Ian Mckesson"
                      },
                      {
                          "num": "TSK-17",
                          "title": "Triptych Sketch Card",
                          "meta": "Jamison Murdock"
                      },
                      {
                          "num": "TSK-18",
                          "title": "Triptych Sketch Card",
                          "meta": "Jane Rushton"
                      },
                      {
                          "num": "TSK-19",
                          "title": "Triptych Sketch Card",
                          "meta": "Jason Sobol"
                      },
                      {
                          "num": "TSK-20",
                          "title": "Triptych Sketch Card",
                          "meta": "Jenna McGrath"
                      },
                      {
                          "num": "TSK-21",
                          "title": "Triptych Sketch Card",
                          "meta": "Joey Mason"
                      },
                      {
                          "num": "TSK-22",
                          "title": "Triptych Sketch Card",
                          "meta": "John Pleak"
                      },
                      {
                          "num": "TSK-23",
                          "title": "Triptych Sketch Card",
                          "meta": "Jonathan Beistline"
                      },
                      {
                          "num": "TSK-24",
                          "title": "Triptych Sketch Card",
                          "meta": "Kevin B Cleveland"
                      },
                      {
                          "num": "TSK-25",
                          "title": "Triptych Sketch Card",
                          "meta": "Krishna Sharma"
                      },
                      {
                          "num": "TSK-26",
                          "title": "Triptych Sketch Card",
                          "meta": "Logan Monette"
                      },
                      {
                          "num": "TSK-27",
                          "title": "Triptych Sketch Card",
                          "meta": "Marlo Agunos"
                      },
                      {
                          "num": "TSK-28",
                          "title": "Triptych Sketch Card",
                          "meta": "Matt Stewart"
                      },
                      {
                          "num": "TSK-29",
                          "title": "Triptych Sketch Card",
                          "meta": "Michael Mastermaker"
                      },
                      {
                          "num": "TSK-30",
                          "title": "Triptych Sketch Card",
                          "meta": "Michael Munshaw"
                      },
                      {
                          "num": "TSK-31",
                          "title": "Triptych Sketch Card",
                          "meta": "Mike Sealie"
                      },
                      {
                          "num": "TSK-32",
                          "title": "Triptych Sketch Card",
                          "meta": "Neil Camera"
                      },
                      {
                          "num": "TSK-33",
                          "title": "Triptych Sketch Card",
                          "meta": "Nick Gribbon"
                      },
                      {
                          "num": "TSK-34",
                          "title": "Triptych Sketch Card",
                          "meta": "Patricio Carrasco"
                      },
                      {
                          "num": "TSK-35",
                          "title": "Triptych Sketch Card",
                          "meta": "Patrick Davis"
                      },
                      {
                          "num": "TSK-36",
                          "title": "Triptych Sketch Card",
                          "meta": "Quinton Baker"
                      },
                      {
                          "num": "TSK-37",
                          "title": "Triptych Sketch Card",
                          "meta": "Robert Garcia"
                      },
                      {
                          "num": "TSK-38",
                          "title": "Triptych Sketch Card",
                          "meta": "Robert Stewart"
                      },
                      {
                          "num": "TSK-39",
                          "title": "Triptych Sketch Card",
                          "meta": "Rutvid Vaid"
                      },
                      {
                          "num": "TSK-40",
                          "title": "Triptych Sketch Card",
                          "meta": "CJ Jones"
                      },
                      {
                          "num": "TSK-41",
                          "title": "Triptych Sketch Card",
                          "meta": "Shyla Lee"
                      },
                      {
                          "num": "TSK-42",
                          "title": "Triptych Sketch Card",
                          "meta": "Veronica Louro"
                      },
                      {
                          "num": "TSK-43",
                          "title": "Triptych Sketch Card",
                          "meta": "Rebeca Louro"
                      },
                      {
                          "num": "TSK-44",
                          "title": "Triptych Sketch Card",
                          "meta": "Yves Van Berlo"
                      },
                      {
                          "num": "TSK-45",
                          "title": "Triptych Sketch Card",
                          "meta": "Zach Woolsey"
                      },
                      {
                          "num": "TSK-46",
                          "title": "Triptych Sketch Card",
                          "meta": "Neil Anthony Brady"
                      }
                  ]
              }
          ]
      }
  },

};
